var Ik = Object.defineProperty;
var Mk = (e, t, n) => t in e ? Ik(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var qe = (e, t, n) => Mk(e, typeof t != "symbol" ? t + "" : t, n);
import * as w from "react";
import Ne, { forwardRef as Hl, useContext as cs, isValidElement as xl, cloneElement as Ou, Children as xC, useState as Kt, useMemo as Ln, useEffect as nn, useCallback as At, useRef as Yr, useReducer as Vg, useImperativeHandle as zg, Fragment as Ak, PureComponent as Nk, createRef as qb, useLayoutEffect as Wg, useId as jk, Component as Fk } from "react";
import * as Lk from "react-dom";
import ru, { createPortal as Bk } from "react-dom";
var ji = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Cs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ou = { exports: {} }, Ks = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ub;
function Vk() {
  if (Ub) return Ks;
  Ub = 1;
  var e = Ne, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, d, p) {
    var f, m = {}, g = null, y = null;
    p !== void 0 && (g = "" + p), d.key !== void 0 && (g = "" + d.key), d.ref !== void 0 && (y = d.ref);
    for (f in d) r.call(d, f) && !a.hasOwnProperty(f) && (m[f] = d[f]);
    if (c && c.defaultProps) for (f in d = c.defaultProps, d) m[f] === void 0 && (m[f] = d[f]);
    return { $$typeof: t, type: c, key: g, ref: y, props: m, _owner: o.current };
  }
  return Ks.Fragment = n, Ks.jsx = l, Ks.jsxs = l, Ks;
}
var Xs = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hb;
function zk() {
  return Hb || (Hb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ne, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), c = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), b = Symbol.iterator, v = "@@iterator";
    function $(U) {
      if (U === null || typeof U != "object")
        return null;
      var Ce = b && U[b] || U[v];
      return typeof Ce == "function" ? Ce : null;
    }
    var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(U) {
      {
        for (var Ce = arguments.length, De = new Array(Ce > 1 ? Ce - 1 : 0), Ze = 1; Ze < Ce; Ze++)
          De[Ze - 1] = arguments[Ze];
        P("error", U, De);
      }
    }
    function P(U, Ce, De) {
      {
        var Ze = S.ReactDebugCurrentFrame, St = Ze.getStackAddendum();
        St !== "" && (Ce += "%s", De = De.concat([St]));
        var pe = De.map(function(ce) {
          return String(ce);
        });
        pe.unshift("Warning: " + Ce), Function.prototype.apply.call(console[U], console, pe);
      }
    }
    var T = !1, O = !1, k = !1, I = !1, D = !1, j;
    j = Symbol.for("react.module.reference");
    function E(U) {
      return !!(typeof U == "string" || typeof U == "function" || U === r || U === a || D || U === o || U === p || U === f || I || U === y || T || O || k || typeof U == "object" && U !== null && (U.$$typeof === g || U.$$typeof === m || U.$$typeof === l || U.$$typeof === c || U.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      U.$$typeof === j || U.getModuleId !== void 0));
    }
    function M(U, Ce, De) {
      var Ze = U.displayName;
      if (Ze)
        return Ze;
      var St = Ce.displayName || Ce.name || "";
      return St !== "" ? De + "(" + St + ")" : De;
    }
    function F(U) {
      return U.displayName || "Context";
    }
    function B(U) {
      if (U == null)
        return null;
      if (typeof U.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof U == "function")
        return U.displayName || U.name || null;
      if (typeof U == "string")
        return U;
      switch (U) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case p:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof U == "object")
        switch (U.$$typeof) {
          case c:
            var Ce = U;
            return F(Ce) + ".Consumer";
          case l:
            var De = U;
            return F(De._context) + ".Provider";
          case d:
            return M(U, U.render, "ForwardRef");
          case m:
            var Ze = U.displayName || null;
            return Ze !== null ? Ze : B(U.type) || "Memo";
          case g: {
            var St = U, pe = St._payload, ce = St._init;
            try {
              return B(ce(pe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var V = Object.assign, z = 0, L, G, se, ne, K, Q, ye;
    function we() {
    }
    we.__reactDisabledLog = !0;
    function fe() {
      {
        if (z === 0) {
          L = console.log, G = console.info, se = console.warn, ne = console.error, K = console.group, Q = console.groupCollapsed, ye = console.groupEnd;
          var U = {
            configurable: !0,
            enumerable: !0,
            value: we,
            writable: !0
          };
          Object.defineProperties(console, {
            info: U,
            log: U,
            warn: U,
            error: U,
            group: U,
            groupCollapsed: U,
            groupEnd: U
          });
        }
        z++;
      }
    }
    function X() {
      {
        if (z--, z === 0) {
          var U = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: V({}, U, {
              value: L
            }),
            info: V({}, U, {
              value: G
            }),
            warn: V({}, U, {
              value: se
            }),
            error: V({}, U, {
              value: ne
            }),
            group: V({}, U, {
              value: K
            }),
            groupCollapsed: V({}, U, {
              value: Q
            }),
            groupEnd: V({}, U, {
              value: ye
            })
          });
        }
        z < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var re = S.ReactCurrentDispatcher, ie;
    function Y(U, Ce, De) {
      {
        if (ie === void 0)
          try {
            throw Error();
          } catch (St) {
            var Ze = St.stack.trim().match(/\n( *(at )?)/);
            ie = Ze && Ze[1] || "";
          }
        return `
` + ie + U;
      }
    }
    var Z = !1, ue;
    {
      var ge = typeof WeakMap == "function" ? WeakMap : Map;
      ue = new ge();
    }
    function W(U, Ce) {
      if (!U || Z)
        return "";
      {
        var De = ue.get(U);
        if (De !== void 0)
          return De;
      }
      var Ze;
      Z = !0;
      var St = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var pe;
      pe = re.current, re.current = null, fe();
      try {
        if (Ce) {
          var ce = function() {
            throw Error();
          };
          if (Object.defineProperty(ce.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ce, []);
            } catch (Pn) {
              Ze = Pn;
            }
            Reflect.construct(U, [], ce);
          } else {
            try {
              ce.call();
            } catch (Pn) {
              Ze = Pn;
            }
            U.call(ce.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Pn) {
            Ze = Pn;
          }
          U();
        }
      } catch (Pn) {
        if (Pn && Ze && typeof Pn.stack == "string") {
          for (var Te = Pn.stack.split(`
`), Ke = Ze.stack.split(`
`), Ge = Te.length - 1, nt = Ke.length - 1; Ge >= 1 && nt >= 0 && Te[Ge] !== Ke[nt]; )
            nt--;
          for (; Ge >= 1 && nt >= 0; Ge--, nt--)
            if (Te[Ge] !== Ke[nt]) {
              if (Ge !== 1 || nt !== 1)
                do
                  if (Ge--, nt--, nt < 0 || Te[Ge] !== Ke[nt]) {
                    var _t = `
` + Te[Ge].replace(" at new ", " at ");
                    return U.displayName && _t.includes("<anonymous>") && (_t = _t.replace("<anonymous>", U.displayName)), typeof U == "function" && ue.set(U, _t), _t;
                  }
                while (Ge >= 1 && nt >= 0);
              break;
            }
        }
      } finally {
        Z = !1, re.current = pe, X(), Error.prepareStackTrace = St;
      }
      var rn = U ? U.displayName || U.name : "", rr = rn ? Y(rn) : "";
      return typeof U == "function" && ue.set(U, rr), rr;
    }
    function J(U, Ce, De) {
      return W(U, !1);
    }
    function le(U) {
      var Ce = U.prototype;
      return !!(Ce && Ce.isReactComponent);
    }
    function me(U, Ce, De) {
      if (U == null)
        return "";
      if (typeof U == "function")
        return W(U, le(U));
      if (typeof U == "string")
        return Y(U);
      switch (U) {
        case p:
          return Y("Suspense");
        case f:
          return Y("SuspenseList");
      }
      if (typeof U == "object")
        switch (U.$$typeof) {
          case d:
            return J(U.render);
          case m:
            return me(U.type, Ce, De);
          case g: {
            var Ze = U, St = Ze._payload, pe = Ze._init;
            try {
              return me(pe(St), Ce, De);
            } catch {
            }
          }
        }
      return "";
    }
    var be = Object.prototype.hasOwnProperty, de = {}, Oe = S.ReactDebugCurrentFrame;
    function Re(U) {
      if (U) {
        var Ce = U._owner, De = me(U.type, U._source, Ce ? Ce.type : null);
        Oe.setExtraStackFrame(De);
      } else
        Oe.setExtraStackFrame(null);
    }
    function We(U, Ce, De, Ze, St) {
      {
        var pe = Function.call.bind(be);
        for (var ce in U)
          if (pe(U, ce)) {
            var Te = void 0;
            try {
              if (typeof U[ce] != "function") {
                var Ke = Error((Ze || "React class") + ": " + De + " type `" + ce + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof U[ce] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ke.name = "Invariant Violation", Ke;
              }
              Te = U[ce](Ce, ce, Ze, De, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ge) {
              Te = Ge;
            }
            Te && !(Te instanceof Error) && (Re(St), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ze || "React class", De, ce, typeof Te), Re(null)), Te instanceof Error && !(Te.message in de) && (de[Te.message] = !0, Re(St), R("Failed %s type: %s", De, Te.message), Re(null));
          }
      }
    }
    var Ye = Array.isArray;
    function Ie(U) {
      return Ye(U);
    }
    function kt(U) {
      {
        var Ce = typeof Symbol == "function" && Symbol.toStringTag, De = Ce && U[Symbol.toStringTag] || U.constructor.name || "Object";
        return De;
      }
    }
    function Ee(U) {
      try {
        return Ae(U), !1;
      } catch {
        return !0;
      }
    }
    function Ae(U) {
      return "" + U;
    }
    function pt(U) {
      if (Ee(U))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", kt(U)), Ae(U);
    }
    var Ue = S.ReactCurrentOwner, et = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Je, rt;
    function je(U) {
      if (be.call(U, "ref")) {
        var Ce = Object.getOwnPropertyDescriptor(U, "ref").get;
        if (Ce && Ce.isReactWarning)
          return !1;
      }
      return U.ref !== void 0;
    }
    function $t(U) {
      if (be.call(U, "key")) {
        var Ce = Object.getOwnPropertyDescriptor(U, "key").get;
        if (Ce && Ce.isReactWarning)
          return !1;
      }
      return U.key !== void 0;
    }
    function Pt(U, Ce) {
      typeof U.ref == "string" && Ue.current;
    }
    function Ft(U, Ce) {
      {
        var De = function() {
          Je || (Je = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ce));
        };
        De.isReactWarning = !0, Object.defineProperty(U, "key", {
          get: De,
          configurable: !0
        });
      }
    }
    function Jt(U, Ce) {
      {
        var De = function() {
          rt || (rt = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ce));
        };
        De.isReactWarning = !0, Object.defineProperty(U, "ref", {
          get: De,
          configurable: !0
        });
      }
    }
    var Me = function(U, Ce, De, Ze, St, pe, ce) {
      var Te = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: U,
        key: Ce,
        ref: De,
        props: ce,
        // Record the component responsible for creating this element.
        _owner: pe
      };
      return Te._store = {}, Object.defineProperty(Te._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Te, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ze
      }), Object.defineProperty(Te, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: St
      }), Object.freeze && (Object.freeze(Te.props), Object.freeze(Te)), Te;
    };
    function it(U, Ce, De, Ze, St) {
      {
        var pe, ce = {}, Te = null, Ke = null;
        De !== void 0 && (pt(De), Te = "" + De), $t(Ce) && (pt(Ce.key), Te = "" + Ce.key), je(Ce) && (Ke = Ce.ref, Pt(Ce, St));
        for (pe in Ce)
          be.call(Ce, pe) && !et.hasOwnProperty(pe) && (ce[pe] = Ce[pe]);
        if (U && U.defaultProps) {
          var Ge = U.defaultProps;
          for (pe in Ge)
            ce[pe] === void 0 && (ce[pe] = Ge[pe]);
        }
        if (Te || Ke) {
          var nt = typeof U == "function" ? U.displayName || U.name || "Unknown" : U;
          Te && Ft(ce, nt), Ke && Jt(ce, nt);
        }
        return Me(U, Te, Ke, St, Ze, Ue.current, ce);
      }
    }
    var bt = S.ReactCurrentOwner, gt = S.ReactDebugCurrentFrame;
    function Et(U) {
      if (U) {
        var Ce = U._owner, De = me(U.type, U._source, Ce ? Ce.type : null);
        gt.setExtraStackFrame(De);
      } else
        gt.setExtraStackFrame(null);
    }
    var xn;
    xn = !1;
    function ln(U) {
      return typeof U == "object" && U !== null && U.$$typeof === t;
    }
    function wr() {
      {
        if (bt.current) {
          var U = B(bt.current.type);
          if (U)
            return `

Check the render method of \`` + U + "`.";
        }
        return "";
      }
    }
    function Yn(U) {
      return "";
    }
    var oo = {};
    function vo(U) {
      {
        var Ce = wr();
        if (!Ce) {
          var De = typeof U == "string" ? U : U.displayName || U.name;
          De && (Ce = `

Check the top-level render call using <` + De + ">.");
        }
        return Ce;
      }
    }
    function tt(U, Ce) {
      {
        if (!U._store || U._store.validated || U.key != null)
          return;
        U._store.validated = !0;
        var De = vo(Ce);
        if (oo[De])
          return;
        oo[De] = !0;
        var Ze = "";
        U && U._owner && U._owner !== bt.current && (Ze = " It was passed a child from " + B(U._owner.type) + "."), Et(U), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', De, Ze), Et(null);
      }
    }
    function In(U, Ce) {
      {
        if (typeof U != "object")
          return;
        if (Ie(U))
          for (var De = 0; De < U.length; De++) {
            var Ze = U[De];
            ln(Ze) && tt(Ze, Ce);
          }
        else if (ln(U))
          U._store && (U._store.validated = !0);
        else if (U) {
          var St = $(U);
          if (typeof St == "function" && St !== U.entries)
            for (var pe = St.call(U), ce; !(ce = pe.next()).done; )
              ln(ce.value) && tt(ce.value, Ce);
        }
      }
    }
    function bo(U) {
      {
        var Ce = U.type;
        if (Ce == null || typeof Ce == "string")
          return;
        var De;
        if (typeof Ce == "function")
          De = Ce.propTypes;
        else if (typeof Ce == "object" && (Ce.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ce.$$typeof === m))
          De = Ce.propTypes;
        else
          return;
        if (De) {
          var Ze = B(Ce);
          We(De, U.props, "prop", Ze, U);
        } else if (Ce.PropTypes !== void 0 && !xn) {
          xn = !0;
          var St = B(Ce);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", St || "Unknown");
        }
        typeof Ce.getDefaultProps == "function" && !Ce.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function io(U) {
      {
        for (var Ce = Object.keys(U.props), De = 0; De < Ce.length; De++) {
          var Ze = Ce[De];
          if (Ze !== "children" && Ze !== "key") {
            Et(U), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ze), Et(null);
            break;
          }
        }
        U.ref !== null && (Et(U), R("Invalid attribute `ref` supplied to `React.Fragment`."), Et(null));
      }
    }
    var Ar = {};
    function xo(U, Ce, De, Ze, St, pe) {
      {
        var ce = E(U);
        if (!ce) {
          var Te = "";
          (U === void 0 || typeof U == "object" && U !== null && Object.keys(U).length === 0) && (Te += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ke = Yn();
          Ke ? Te += Ke : Te += wr();
          var Ge;
          U === null ? Ge = "null" : Ie(U) ? Ge = "array" : U !== void 0 && U.$$typeof === t ? (Ge = "<" + (B(U.type) || "Unknown") + " />", Te = " Did you accidentally export a JSX literal instead of a component?") : Ge = typeof U, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ge, Te);
        }
        var nt = it(U, Ce, De, St, pe);
        if (nt == null)
          return nt;
        if (ce) {
          var _t = Ce.children;
          if (_t !== void 0)
            if (Ze)
              if (Ie(_t)) {
                for (var rn = 0; rn < _t.length; rn++)
                  In(_t[rn], U);
                Object.freeze && Object.freeze(_t);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              In(_t, U);
        }
        if (be.call(Ce, "key")) {
          var rr = B(U), Pn = Object.keys(Ce).filter(function($i) {
            return $i !== "key";
          }), xi = Pn.length > 0 ? "{key: someKey, " + Pn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ar[rr + xi]) {
            var wi = Pn.length > 0 ? "{" + Pn.join(": ..., ") + ": ...}" : "{}";
            R(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, xi, rr, wi, rr), Ar[rr + xi] = !0;
          }
        }
        return U === r ? io(nt) : bo(nt), nt;
      }
    }
    function zo(U, Ce, De) {
      return xo(U, Ce, De, !0);
    }
    function Hi(U, Ce, De) {
      return xo(U, Ce, De, !1);
    }
    var Gi = Hi, Yi = zo;
    Xs.Fragment = r, Xs.jsx = Gi, Xs.jsxs = Yi;
  }()), Xs;
}
var Gb;
function Wk() {
  return Gb || (Gb = 1, process.env.NODE_ENV === "production" ? ou.exports = Vk() : ou.exports = zk()), ou.exports;
}
var x = Wk();
function No(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
const Kr = "$$material";
function ee() {
  return ee = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ee.apply(null, arguments);
}
function qk(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function Uk(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Hk = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(o) {
      var a;
      r.tags.length === 0 ? r.insertionPoint ? a = r.insertionPoint.nextSibling : r.prepend ? a = r.container.firstChild : a = r.before : a = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(o, a), r.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Uk(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = qk(o);
      try {
        a.insertRule(r, a.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var o;
      return (o = r.parentNode) == null ? void 0 : o.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Zn = "-ms-", Vu = "-moz-", Vt = "-webkit-", wC = "comm", qg = "rule", Ug = "decl", Gk = "@import", $C = "@keyframes", Yk = "@layer", Kk = Math.abs, yd = String.fromCharCode, Xk = Object.assign;
function Zk(e, t) {
  return Un(e, 0) ^ 45 ? (((t << 2 ^ Un(e, 0)) << 2 ^ Un(e, 1)) << 2 ^ Un(e, 2)) << 2 ^ Un(e, 3) : 0;
}
function CC(e) {
  return e.trim();
}
function Qk(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function zt(e, t, n) {
  return e.replace(t, n);
}
function ig(e, t) {
  return e.indexOf(t);
}
function Un(e, t) {
  return e.charCodeAt(t) | 0;
}
function El(e, t, n) {
  return e.slice(t, n);
}
function Po(e) {
  return e.length;
}
function Hg(e) {
  return e.length;
}
function iu(e, t) {
  return t.push(e), e;
}
function Jk(e, t) {
  return e.map(t).join("");
}
var vd = 1, us = 1, SC = 0, xr = 0, Mn = 0, Ss = "";
function bd(e, t, n, r, o, a, l) {
  return { value: e, root: t, parent: n, type: r, props: o, children: a, line: vd, column: us, length: l, return: "" };
}
function Zs(e, t) {
  return Xk(bd("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function e6() {
  return Mn;
}
function t6() {
  return Mn = xr > 0 ? Un(Ss, --xr) : 0, us--, Mn === 10 && (us = 1, vd--), Mn;
}
function Dr() {
  return Mn = xr < SC ? Un(Ss, xr++) : 0, us++, Mn === 10 && (us = 1, vd++), Mn;
}
function Io() {
  return Un(Ss, xr);
}
function Pu() {
  return xr;
}
function Gl(e, t) {
  return El(Ss, e, t);
}
function Rl(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function TC(e) {
  return vd = us = 1, SC = Po(Ss = e), xr = 0, [];
}
function OC(e) {
  return Ss = "", e;
}
function Eu(e) {
  return CC(Gl(xr - 1, ag(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function n6(e) {
  for (; (Mn = Io()) && Mn < 33; )
    Dr();
  return Rl(e) > 2 || Rl(Mn) > 3 ? "" : " ";
}
function r6(e, t) {
  for (; --t && Dr() && !(Mn < 48 || Mn > 102 || Mn > 57 && Mn < 65 || Mn > 70 && Mn < 97); )
    ;
  return Gl(e, Pu() + (t < 6 && Io() == 32 && Dr() == 32));
}
function ag(e) {
  for (; Dr(); )
    switch (Mn) {
      // ] ) " '
      case e:
        return xr;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && ag(Mn);
        break;
      // (
      case 40:
        e === 41 && ag(e);
        break;
      // \
      case 92:
        Dr();
        break;
    }
  return xr;
}
function o6(e, t) {
  for (; Dr() && e + Mn !== 57; )
    if (e + Mn === 84 && Io() === 47)
      break;
  return "/*" + Gl(t, xr - 1) + "*" + yd(e === 47 ? e : Dr());
}
function i6(e) {
  for (; !Rl(Io()); )
    Dr();
  return Gl(e, xr);
}
function a6(e) {
  return OC(Ru("", null, null, null, [""], e = TC(e), 0, [0], e));
}
function Ru(e, t, n, r, o, a, l, c, d) {
  for (var p = 0, f = 0, m = l, g = 0, y = 0, b = 0, v = 1, $ = 1, S = 1, R = 0, P = "", T = o, O = a, k = r, I = P; $; )
    switch (b = R, R = Dr()) {
      // (
      case 40:
        if (b != 108 && Un(I, m - 1) == 58) {
          ig(I += zt(Eu(R), "&", "&\f"), "&\f") != -1 && (S = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        I += Eu(R);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        I += n6(b);
        break;
      // \
      case 92:
        I += r6(Pu() - 1, 7);
        continue;
      // /
      case 47:
        switch (Io()) {
          case 42:
          case 47:
            iu(s6(o6(Dr(), Pu()), t, n), d);
            break;
          default:
            I += "/";
        }
        break;
      // {
      case 123 * v:
        c[p++] = Po(I) * S;
      // } ; \0
      case 125 * v:
      case 59:
      case 0:
        switch (R) {
          // \0 }
          case 0:
          case 125:
            $ = 0;
          // ;
          case 59 + f:
            S == -1 && (I = zt(I, /\f/g, "")), y > 0 && Po(I) - m && iu(y > 32 ? Kb(I + ";", r, n, m - 1) : Kb(zt(I, " ", "") + ";", r, n, m - 2), d);
            break;
          // @ ;
          case 59:
            I += ";";
          // { rule/at-rule
          default:
            if (iu(k = Yb(I, t, n, p, f, o, c, P, T = [], O = [], m), a), R === 123)
              if (f === 0)
                Ru(I, t, k, k, T, a, m, c, O);
              else
                switch (g === 99 && Un(I, 3) === 110 ? 100 : g) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ru(e, k, k, r && iu(Yb(e, k, k, 0, 0, o, c, P, o, T = [], m), O), o, O, m, c, r ? T : O);
                    break;
                  default:
                    Ru(I, k, k, k, [""], O, 0, c, O);
                }
        }
        p = f = y = 0, v = S = 1, P = I = "", m = l;
        break;
      // :
      case 58:
        m = 1 + Po(I), y = b;
      default:
        if (v < 1) {
          if (R == 123)
            --v;
          else if (R == 125 && v++ == 0 && t6() == 125)
            continue;
        }
        switch (I += yd(R), R * v) {
          // &
          case 38:
            S = f > 0 ? 1 : (I += "\f", -1);
            break;
          // ,
          case 44:
            c[p++] = (Po(I) - 1) * S, S = 1;
            break;
          // @
          case 64:
            Io() === 45 && (I += Eu(Dr())), g = Io(), f = m = Po(P = I += i6(Pu())), R++;
            break;
          // -
          case 45:
            b === 45 && Po(I) == 2 && (v = 0);
        }
    }
  return a;
}
function Yb(e, t, n, r, o, a, l, c, d, p, f) {
  for (var m = o - 1, g = o === 0 ? a : [""], y = Hg(g), b = 0, v = 0, $ = 0; b < r; ++b)
    for (var S = 0, R = El(e, m + 1, m = Kk(v = l[b])), P = e; S < y; ++S)
      (P = CC(v > 0 ? g[S] + " " + R : zt(R, /&\f/g, g[S]))) && (d[$++] = P);
  return bd(e, t, n, o === 0 ? qg : c, d, p, f);
}
function s6(e, t, n) {
  return bd(e, t, n, wC, yd(e6()), El(e, 2, -2), 0);
}
function Kb(e, t, n, r) {
  return bd(e, t, n, Ug, El(e, 0, r), El(e, r + 1, -1), r);
}
function ns(e, t) {
  for (var n = "", r = Hg(e), o = 0; o < r; o++)
    n += t(e[o], o, e, t) || "";
  return n;
}
function l6(e, t, n, r) {
  switch (e.type) {
    case Yk:
      if (e.children.length) break;
    case Gk:
    case Ug:
      return e.return = e.return || e.value;
    case wC:
      return "";
    case $C:
      return e.return = e.value + "{" + ns(e.children, r) + "}";
    case qg:
      e.value = e.props.join(",");
  }
  return Po(n = ns(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function c6(e) {
  var t = Hg(e);
  return function(n, r, o, a) {
    for (var l = "", c = 0; c < t; c++)
      l += e[c](n, r, o, a) || "";
    return l;
  };
}
function u6(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function PC(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var d6 = function(t, n, r) {
  for (var o = 0, a = 0; o = a, a = Io(), o === 38 && a === 12 && (n[r] = 1), !Rl(a); )
    Dr();
  return Gl(t, xr);
}, p6 = function(t, n) {
  var r = -1, o = 44;
  do
    switch (Rl(o)) {
      case 0:
        o === 38 && Io() === 12 && (n[r] = 1), t[r] += d6(xr - 1, n, r);
        break;
      case 2:
        t[r] += Eu(o);
        break;
      case 4:
        if (o === 44) {
          t[++r] = Io() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      // fallthrough
      default:
        t[r] += yd(o);
    }
  while (o = Dr());
  return t;
}, f6 = function(t, n) {
  return OC(p6(TC(t), n));
}, Xb = /* @__PURE__ */ new WeakMap(), h6 = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, o = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !Xb.get(r)) && !o) {
      Xb.set(t, !0);
      for (var a = [], l = f6(n, a), c = r.props, d = 0, p = 0; d < l.length; d++)
        for (var f = 0; f < c.length; f++, p++)
          t.props[p] = a[d] ? l[d].replace(/&\f/g, c[f]) : c[f] + " " + l[d];
    }
  }
}, m6 = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function EC(e, t) {
  switch (Zk(e, t)) {
    // color-adjust
    case 5103:
      return Vt + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Vt + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Vt + e + Vu + e + Zn + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return Vt + e + Zn + e + e;
    // order
    case 6165:
      return Vt + e + Zn + "flex-" + e + e;
    // align-items
    case 5187:
      return Vt + e + zt(e, /(\w+).+(:[^]+)/, Vt + "box-$1$2" + Zn + "flex-$1$2") + e;
    // align-self
    case 5443:
      return Vt + e + Zn + "flex-item-" + zt(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return Vt + e + Zn + "flex-line-pack" + zt(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return Vt + e + Zn + zt(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return Vt + e + Zn + zt(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return Vt + "box-" + zt(e, "-grow", "") + Vt + e + Zn + zt(e, "grow", "positive") + e;
    // transition
    case 4554:
      return Vt + zt(e, /([^-])(transform)/g, "$1" + Vt + "$2") + e;
    // cursor
    case 6187:
      return zt(zt(zt(e, /(zoom-|grab)/, Vt + "$1"), /(image-set)/, Vt + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return zt(e, /(image-set\([^]*)/, Vt + "$1$`$1");
    // justify-content
    case 4968:
      return zt(zt(e, /(.+:)(flex-)?(.*)/, Vt + "box-pack:$3" + Zn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Vt + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return zt(e, /(.+)-inline(.+)/, Vt + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Po(e) - 1 - t > 6) switch (Un(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (Un(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return zt(e, /(.+:)(.+)-([^]+)/, "$1" + Vt + "$2-$3$1" + Vu + (Un(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~ig(e, "stretch") ? EC(zt(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (Un(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (Un(e, Po(e) - 3 - (~ig(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return zt(e, ":", ":" + Vt) + e;
        // (inline-)?fl(e)x
        case 101:
          return zt(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Vt + (Un(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Vt + "$2$3$1" + Zn + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (Un(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return Vt + e + Zn + zt(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return Vt + e + Zn + zt(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return Vt + e + Zn + zt(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Vt + e + Zn + e + e;
  }
  return e;
}
var g6 = function(t, n, r, o) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case Ug:
      t.return = EC(t.value, t.length);
      break;
    case $C:
      return ns([Zs(t, {
        value: zt(t.value, "@", "@" + Vt)
      })], o);
    case qg:
      if (t.length) return Jk(t.props, function(a) {
        switch (Qk(a, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return ns([Zs(t, {
              props: [zt(a, /:(read-\w+)/, ":" + Vu + "$1")]
            })], o);
          // :placeholder
          case "::placeholder":
            return ns([Zs(t, {
              props: [zt(a, /:(plac\w+)/, ":" + Vt + "input-$1")]
            }), Zs(t, {
              props: [zt(a, /:(plac\w+)/, ":" + Vu + "$1")]
            }), Zs(t, {
              props: [zt(a, /:(plac\w+)/, Zn + "input-$1")]
            })], o);
        }
        return "";
      });
  }
}, y6 = [g6], v6 = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(v) {
      var $ = v.getAttribute("data-emotion");
      $.indexOf(" ") !== -1 && (document.head.appendChild(v), v.setAttribute("data-s", ""));
    });
  }
  var o = t.stylisPlugins || y6, a = {}, l, c = [];
  l = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(v) {
      for (var $ = v.getAttribute("data-emotion").split(" "), S = 1; S < $.length; S++)
        a[$[S]] = !0;
      c.push(v);
    }
  );
  var d, p = [h6, m6];
  {
    var f, m = [l6, u6(function(v) {
      f.insert(v);
    })], g = c6(p.concat(o, m)), y = function($) {
      return ns(a6($), g);
    };
    d = function($, S, R, P) {
      f = R, y($ ? $ + "{" + S.styles + "}" : S.styles), P && (b.inserted[S.name] = !0);
    };
  }
  var b = {
    key: n,
    sheet: new Hk({
      key: n,
      container: l,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: d
  };
  return b.sheet.hydrate(c), b;
}, au = { exports: {} }, Ut = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zb;
function b6() {
  if (Zb) return Ut;
  Zb = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, $ = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, R = e ? Symbol.for("react.scope") : 60119;
  function P(O) {
    if (typeof O == "object" && O !== null) {
      var k = O.$$typeof;
      switch (k) {
        case t:
          switch (O = O.type, O) {
            case d:
            case p:
            case r:
            case a:
            case o:
            case m:
              return O;
            default:
              switch (O = O && O.$$typeof, O) {
                case c:
                case f:
                case b:
                case y:
                case l:
                  return O;
                default:
                  return k;
              }
          }
        case n:
          return k;
      }
    }
  }
  function T(O) {
    return P(O) === p;
  }
  return Ut.AsyncMode = d, Ut.ConcurrentMode = p, Ut.ContextConsumer = c, Ut.ContextProvider = l, Ut.Element = t, Ut.ForwardRef = f, Ut.Fragment = r, Ut.Lazy = b, Ut.Memo = y, Ut.Portal = n, Ut.Profiler = a, Ut.StrictMode = o, Ut.Suspense = m, Ut.isAsyncMode = function(O) {
    return T(O) || P(O) === d;
  }, Ut.isConcurrentMode = T, Ut.isContextConsumer = function(O) {
    return P(O) === c;
  }, Ut.isContextProvider = function(O) {
    return P(O) === l;
  }, Ut.isElement = function(O) {
    return typeof O == "object" && O !== null && O.$$typeof === t;
  }, Ut.isForwardRef = function(O) {
    return P(O) === f;
  }, Ut.isFragment = function(O) {
    return P(O) === r;
  }, Ut.isLazy = function(O) {
    return P(O) === b;
  }, Ut.isMemo = function(O) {
    return P(O) === y;
  }, Ut.isPortal = function(O) {
    return P(O) === n;
  }, Ut.isProfiler = function(O) {
    return P(O) === a;
  }, Ut.isStrictMode = function(O) {
    return P(O) === o;
  }, Ut.isSuspense = function(O) {
    return P(O) === m;
  }, Ut.isValidElementType = function(O) {
    return typeof O == "string" || typeof O == "function" || O === r || O === p || O === a || O === o || O === m || O === g || typeof O == "object" && O !== null && (O.$$typeof === b || O.$$typeof === y || O.$$typeof === l || O.$$typeof === c || O.$$typeof === f || O.$$typeof === $ || O.$$typeof === S || O.$$typeof === R || O.$$typeof === v);
  }, Ut.typeOf = P, Ut;
}
var Ht = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qb;
function x6() {
  return Qb || (Qb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, $ = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, R = e ? Symbol.for("react.scope") : 60119;
    function P(W) {
      return typeof W == "string" || typeof W == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      W === r || W === p || W === a || W === o || W === m || W === g || typeof W == "object" && W !== null && (W.$$typeof === b || W.$$typeof === y || W.$$typeof === l || W.$$typeof === c || W.$$typeof === f || W.$$typeof === $ || W.$$typeof === S || W.$$typeof === R || W.$$typeof === v);
    }
    function T(W) {
      if (typeof W == "object" && W !== null) {
        var J = W.$$typeof;
        switch (J) {
          case t:
            var le = W.type;
            switch (le) {
              case d:
              case p:
              case r:
              case a:
              case o:
              case m:
                return le;
              default:
                var me = le && le.$$typeof;
                switch (me) {
                  case c:
                  case f:
                  case b:
                  case y:
                  case l:
                    return me;
                  default:
                    return J;
                }
            }
          case n:
            return J;
        }
      }
    }
    var O = d, k = p, I = c, D = l, j = t, E = f, M = r, F = b, B = y, V = n, z = a, L = o, G = m, se = !1;
    function ne(W) {
      return se || (se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), K(W) || T(W) === d;
    }
    function K(W) {
      return T(W) === p;
    }
    function Q(W) {
      return T(W) === c;
    }
    function ye(W) {
      return T(W) === l;
    }
    function we(W) {
      return typeof W == "object" && W !== null && W.$$typeof === t;
    }
    function fe(W) {
      return T(W) === f;
    }
    function X(W) {
      return T(W) === r;
    }
    function re(W) {
      return T(W) === b;
    }
    function ie(W) {
      return T(W) === y;
    }
    function Y(W) {
      return T(W) === n;
    }
    function Z(W) {
      return T(W) === a;
    }
    function ue(W) {
      return T(W) === o;
    }
    function ge(W) {
      return T(W) === m;
    }
    Ht.AsyncMode = O, Ht.ConcurrentMode = k, Ht.ContextConsumer = I, Ht.ContextProvider = D, Ht.Element = j, Ht.ForwardRef = E, Ht.Fragment = M, Ht.Lazy = F, Ht.Memo = B, Ht.Portal = V, Ht.Profiler = z, Ht.StrictMode = L, Ht.Suspense = G, Ht.isAsyncMode = ne, Ht.isConcurrentMode = K, Ht.isContextConsumer = Q, Ht.isContextProvider = ye, Ht.isElement = we, Ht.isForwardRef = fe, Ht.isFragment = X, Ht.isLazy = re, Ht.isMemo = ie, Ht.isPortal = Y, Ht.isProfiler = Z, Ht.isStrictMode = ue, Ht.isSuspense = ge, Ht.isValidElementType = P, Ht.typeOf = T;
  }()), Ht;
}
var Jb;
function w6() {
  return Jb || (Jb = 1, process.env.NODE_ENV === "production" ? au.exports = b6() : au.exports = x6()), au.exports;
}
var Mf, e1;
function $6() {
  if (e1) return Mf;
  e1 = 1;
  var e = w6(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, o = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, a = {};
  a[e.ForwardRef] = r, a[e.Memo] = o;
  function l(b) {
    return e.isMemo(b) ? o : a[b.$$typeof] || t;
  }
  var c = Object.defineProperty, d = Object.getOwnPropertyNames, p = Object.getOwnPropertySymbols, f = Object.getOwnPropertyDescriptor, m = Object.getPrototypeOf, g = Object.prototype;
  function y(b, v, $) {
    if (typeof v != "string") {
      if (g) {
        var S = m(v);
        S && S !== g && y(b, S, $);
      }
      var R = d(v);
      p && (R = R.concat(p(v)));
      for (var P = l(b), T = l(v), O = 0; O < R.length; ++O) {
        var k = R[O];
        if (!n[k] && !($ && $[k]) && !(T && T[k]) && !(P && P[k])) {
          var I = f(v, k);
          try {
            c(b, k, I);
          } catch {
          }
        }
      }
    }
    return b;
  }
  return Mf = y, Mf;
}
$6();
var C6 = !0;
function RC(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? t.push(e[o] + ";") : o && (r += o + " ");
  }), r;
}
var Gg = function(t, n, r) {
  var o = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  C6 === !1) && t.registered[o] === void 0 && (t.registered[o] = n.styles);
}, Yg = function(t, n, r) {
  Gg(t, n, r);
  var o = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var a = n;
    do
      t.insert(n === a ? "." + o : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function S6(e) {
  for (var t = 0, n, r = 0, o = e.length; o >= 4; ++r, o -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var T6 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, O6 = /[A-Z]|^ms/g, P6 = /_EMO_([^_]+?)_([^]*?)_EMO_/g, kC = function(t) {
  return t.charCodeAt(1) === 45;
}, t1 = function(t) {
  return t != null && typeof t != "boolean";
}, Af = /* @__PURE__ */ PC(function(e) {
  return kC(e) ? e : e.replace(O6, "-$&").toLowerCase();
}), n1 = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(P6, function(r, o, a) {
          return Eo = {
            name: o,
            styles: a,
            next: Eo
          }, o;
        });
  }
  return T6[t] !== 1 && !kC(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function kl(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var o = n;
      if (o.anim === 1)
        return Eo = {
          name: o.name,
          styles: o.styles,
          next: Eo
        }, o.name;
      var a = n;
      if (a.styles !== void 0) {
        var l = a.next;
        if (l !== void 0)
          for (; l !== void 0; )
            Eo = {
              name: l.name,
              styles: l.styles,
              next: Eo
            }, l = l.next;
        var c = a.styles + ";";
        return c;
      }
      return E6(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var d = Eo, p = n(e);
        return Eo = d, kl(e, t, p);
      }
      break;
    }
  }
  var f = n;
  if (t == null)
    return f;
  var m = t[f];
  return m !== void 0 ? m : f;
}
function E6(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      r += kl(e, t, n[o]) + ";";
  else
    for (var a in n) {
      var l = n[a];
      if (typeof l != "object") {
        var c = l;
        t != null && t[c] !== void 0 ? r += a + "{" + t[c] + "}" : t1(c) && (r += Af(a) + ":" + n1(a, c) + ";");
      } else if (Array.isArray(l) && typeof l[0] == "string" && (t == null || t[l[0]] === void 0))
        for (var d = 0; d < l.length; d++)
          t1(l[d]) && (r += Af(a) + ":" + n1(a, l[d]) + ";");
      else {
        var p = kl(e, t, l);
        switch (a) {
          case "animation":
          case "animationName": {
            r += Af(a) + ":" + p + ";";
            break;
          }
          default:
            r += a + "{" + p + "}";
        }
      }
    }
  return r;
}
var r1 = /label:\s*([^\s;{]+)\s*(;|$)/g, Eo;
function Yl(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, o = "";
  Eo = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    r = !1, o += kl(n, t, a);
  else {
    var l = a;
    o += l[0];
  }
  for (var c = 1; c < e.length; c++)
    if (o += kl(n, t, e[c]), r) {
      var d = a;
      o += d[c];
    }
  r1.lastIndex = 0;
  for (var p = "", f; (f = r1.exec(o)) !== null; )
    p += "-" + f[1];
  var m = S6(o) + p;
  return {
    name: m,
    styles: o,
    next: Eo
  };
}
var R6 = function(t) {
  return t();
}, _C = w.useInsertionEffect ? w.useInsertionEffect : !1, DC = _C || R6, o1 = _C || w.useLayoutEffect, IC = /* @__PURE__ */ w.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ v6({
    key: "css"
  }) : null
);
IC.Provider;
var Kg = function(t) {
  return /* @__PURE__ */ Hl(function(n, r) {
    var o = cs(IC);
    return t(n, o, r);
  });
}, Kl = /* @__PURE__ */ w.createContext({}), Xg = {}.hasOwnProperty, sg = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", k6 = function(t, n) {
  var r = {};
  for (var o in n)
    Xg.call(n, o) && (r[o] = n[o]);
  return r[sg] = t, r;
}, _6 = function(t) {
  var n = t.cache, r = t.serialized, o = t.isStringTag;
  return Gg(n, r, o), DC(function() {
    return Yg(n, r, o);
  }), null;
}, D6 = /* @__PURE__ */ Kg(function(e, t, n) {
  var r = e.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var o = e[sg], a = [r], l = "";
  typeof e.className == "string" ? l = RC(t.registered, a, e.className) : e.className != null && (l = e.className + " ");
  var c = Yl(a, void 0, w.useContext(Kl));
  l += t.key + "-" + c.name;
  var d = {};
  for (var p in e)
    Xg.call(e, p) && p !== "css" && p !== sg && (d[p] = e[p]);
  return d.className = l, n && (d.ref = n), /* @__PURE__ */ w.createElement(w.Fragment, null, /* @__PURE__ */ w.createElement(_6, {
    cache: t,
    serialized: c,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ w.createElement(o, d));
}), I6 = D6, i1 = function(t, n) {
  var r = arguments;
  if (n == null || !Xg.call(n, "css"))
    return w.createElement.apply(void 0, r);
  var o = r.length, a = new Array(o);
  a[0] = I6, a[1] = k6(t, n);
  for (var l = 2; l < o; l++)
    a[l] = r[l];
  return w.createElement.apply(null, a);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(i1 || (i1 = {}));
var M6 = /* @__PURE__ */ Kg(function(e, t) {
  var n = e.styles, r = Yl([n], void 0, w.useContext(Kl)), o = w.useRef();
  return o1(function() {
    var a = t.key + "-global", l = new t.sheet.constructor({
      key: a,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), c = !1, d = document.querySelector('style[data-emotion="' + a + " " + r.name + '"]');
    return t.sheet.tags.length && (l.before = t.sheet.tags[0]), d !== null && (c = !0, d.setAttribute("data-emotion", a), l.hydrate([d])), o.current = [l, c], function() {
      l.flush();
    };
  }, [t]), o1(function() {
    var a = o.current, l = a[0], c = a[1];
    if (c) {
      a[1] = !1;
      return;
    }
    if (r.next !== void 0 && Yg(t, r.next, !0), l.tags.length) {
      var d = l.tags[l.tags.length - 1].nextElementSibling;
      l.before = d, l.flush();
    }
    t.insert("", r, l, !1);
  }, [t, r.name]), null;
});
function Zg() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Yl(t);
}
function Xl() {
  var e = Zg.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var A6 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, N6 = /* @__PURE__ */ PC(
  function(e) {
    return A6.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), j6 = N6, F6 = function(t) {
  return t !== "theme";
}, a1 = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? j6 : F6;
}, s1 = function(t, n, r) {
  var o;
  if (n) {
    var a = n.shouldForwardProp;
    o = t.__emotion_forwardProp && a ? function(l) {
      return t.__emotion_forwardProp(l) && a(l);
    } : a;
  }
  return typeof o != "function" && r && (o = t.__emotion_forwardProp), o;
}, L6 = function(t) {
  var n = t.cache, r = t.serialized, o = t.isStringTag;
  return Gg(n, r, o), DC(function() {
    return Yg(n, r, o);
  }), null;
}, B6 = function e(t, n) {
  var r = t.__emotion_real === t, o = r && t.__emotion_base || t, a, l;
  n !== void 0 && (a = n.label, l = n.target);
  var c = s1(t, n, r), d = c || a1(o), p = !d("as");
  return function() {
    var f = arguments, m = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (a !== void 0 && m.push("label:" + a + ";"), f[0] == null || f[0].raw === void 0)
      m.push.apply(m, f);
    else {
      var g = f[0];
      m.push(g[0]);
      for (var y = f.length, b = 1; b < y; b++)
        m.push(f[b], g[b]);
    }
    var v = Kg(function($, S, R) {
      var P = p && $.as || o, T = "", O = [], k = $;
      if ($.theme == null) {
        k = {};
        for (var I in $)
          k[I] = $[I];
        k.theme = w.useContext(Kl);
      }
      typeof $.className == "string" ? T = RC(S.registered, O, $.className) : $.className != null && (T = $.className + " ");
      var D = Yl(m.concat(O), S.registered, k);
      T += S.key + "-" + D.name, l !== void 0 && (T += " " + l);
      var j = p && c === void 0 ? a1(P) : d, E = {};
      for (var M in $)
        p && M === "as" || j(M) && (E[M] = $[M]);
      return E.className = T, R && (E.ref = R), /* @__PURE__ */ w.createElement(w.Fragment, null, /* @__PURE__ */ w.createElement(L6, {
        cache: S,
        serialized: D,
        isStringTag: typeof P == "string"
      }), /* @__PURE__ */ w.createElement(P, E));
    });
    return v.displayName = a !== void 0 ? a : "Styled(" + (typeof o == "string" ? o : o.displayName || o.name || "Component") + ")", v.defaultProps = t.defaultProps, v.__emotion_real = v, v.__emotion_base = o, v.__emotion_styles = m, v.__emotion_forwardProp = c, Object.defineProperty(v, "toString", {
      value: function() {
        return "." + l;
      }
    }), v.withComponent = function($, S) {
      var R = e($, ee({}, n, S, {
        shouldForwardProp: s1(v, S, !0)
      }));
      return R.apply(void 0, m);
    }, v;
  };
}, V6 = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], lg = B6.bind(null);
V6.forEach(function(e) {
  lg[e] = lg(e);
});
var su = { exports: {} }, lu = { exports: {} }, Gt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l1;
function z6() {
  if (l1) return Gt;
  l1 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, $ = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, R = e ? Symbol.for("react.scope") : 60119;
  function P(O) {
    if (typeof O == "object" && O !== null) {
      var k = O.$$typeof;
      switch (k) {
        case t:
          switch (O = O.type, O) {
            case d:
            case p:
            case r:
            case a:
            case o:
            case m:
              return O;
            default:
              switch (O = O && O.$$typeof, O) {
                case c:
                case f:
                case b:
                case y:
                case l:
                  return O;
                default:
                  return k;
              }
          }
        case n:
          return k;
      }
    }
  }
  function T(O) {
    return P(O) === p;
  }
  return Gt.AsyncMode = d, Gt.ConcurrentMode = p, Gt.ContextConsumer = c, Gt.ContextProvider = l, Gt.Element = t, Gt.ForwardRef = f, Gt.Fragment = r, Gt.Lazy = b, Gt.Memo = y, Gt.Portal = n, Gt.Profiler = a, Gt.StrictMode = o, Gt.Suspense = m, Gt.isAsyncMode = function(O) {
    return T(O) || P(O) === d;
  }, Gt.isConcurrentMode = T, Gt.isContextConsumer = function(O) {
    return P(O) === c;
  }, Gt.isContextProvider = function(O) {
    return P(O) === l;
  }, Gt.isElement = function(O) {
    return typeof O == "object" && O !== null && O.$$typeof === t;
  }, Gt.isForwardRef = function(O) {
    return P(O) === f;
  }, Gt.isFragment = function(O) {
    return P(O) === r;
  }, Gt.isLazy = function(O) {
    return P(O) === b;
  }, Gt.isMemo = function(O) {
    return P(O) === y;
  }, Gt.isPortal = function(O) {
    return P(O) === n;
  }, Gt.isProfiler = function(O) {
    return P(O) === a;
  }, Gt.isStrictMode = function(O) {
    return P(O) === o;
  }, Gt.isSuspense = function(O) {
    return P(O) === m;
  }, Gt.isValidElementType = function(O) {
    return typeof O == "string" || typeof O == "function" || O === r || O === p || O === a || O === o || O === m || O === g || typeof O == "object" && O !== null && (O.$$typeof === b || O.$$typeof === y || O.$$typeof === l || O.$$typeof === c || O.$$typeof === f || O.$$typeof === $ || O.$$typeof === S || O.$$typeof === R || O.$$typeof === v);
  }, Gt.typeOf = P, Gt;
}
var Yt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c1;
function W6() {
  return c1 || (c1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, $ = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, R = e ? Symbol.for("react.scope") : 60119;
    function P(W) {
      return typeof W == "string" || typeof W == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      W === r || W === p || W === a || W === o || W === m || W === g || typeof W == "object" && W !== null && (W.$$typeof === b || W.$$typeof === y || W.$$typeof === l || W.$$typeof === c || W.$$typeof === f || W.$$typeof === $ || W.$$typeof === S || W.$$typeof === R || W.$$typeof === v);
    }
    function T(W) {
      if (typeof W == "object" && W !== null) {
        var J = W.$$typeof;
        switch (J) {
          case t:
            var le = W.type;
            switch (le) {
              case d:
              case p:
              case r:
              case a:
              case o:
              case m:
                return le;
              default:
                var me = le && le.$$typeof;
                switch (me) {
                  case c:
                  case f:
                  case b:
                  case y:
                  case l:
                    return me;
                  default:
                    return J;
                }
            }
          case n:
            return J;
        }
      }
    }
    var O = d, k = p, I = c, D = l, j = t, E = f, M = r, F = b, B = y, V = n, z = a, L = o, G = m, se = !1;
    function ne(W) {
      return se || (se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), K(W) || T(W) === d;
    }
    function K(W) {
      return T(W) === p;
    }
    function Q(W) {
      return T(W) === c;
    }
    function ye(W) {
      return T(W) === l;
    }
    function we(W) {
      return typeof W == "object" && W !== null && W.$$typeof === t;
    }
    function fe(W) {
      return T(W) === f;
    }
    function X(W) {
      return T(W) === r;
    }
    function re(W) {
      return T(W) === b;
    }
    function ie(W) {
      return T(W) === y;
    }
    function Y(W) {
      return T(W) === n;
    }
    function Z(W) {
      return T(W) === a;
    }
    function ue(W) {
      return T(W) === o;
    }
    function ge(W) {
      return T(W) === m;
    }
    Yt.AsyncMode = O, Yt.ConcurrentMode = k, Yt.ContextConsumer = I, Yt.ContextProvider = D, Yt.Element = j, Yt.ForwardRef = E, Yt.Fragment = M, Yt.Lazy = F, Yt.Memo = B, Yt.Portal = V, Yt.Profiler = z, Yt.StrictMode = L, Yt.Suspense = G, Yt.isAsyncMode = ne, Yt.isConcurrentMode = K, Yt.isContextConsumer = Q, Yt.isContextProvider = ye, Yt.isElement = we, Yt.isForwardRef = fe, Yt.isFragment = X, Yt.isLazy = re, Yt.isMemo = ie, Yt.isPortal = Y, Yt.isProfiler = Z, Yt.isStrictMode = ue, Yt.isSuspense = ge, Yt.isValidElementType = P, Yt.typeOf = T;
  }()), Yt;
}
var u1;
function MC() {
  return u1 || (u1 = 1, process.env.NODE_ENV === "production" ? lu.exports = z6() : lu.exports = W6()), lu.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Nf, d1;
function q6() {
  if (d1) return Nf;
  d1 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var d = Object.getOwnPropertyNames(l).map(function(f) {
        return l[f];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        p[f] = f;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Nf = o() ? Object.assign : function(a, l) {
    for (var c, d = r(a), p, f = 1; f < arguments.length; f++) {
      c = Object(arguments[f]);
      for (var m in c)
        t.call(c, m) && (d[m] = c[m]);
      if (e) {
        p = e(c);
        for (var g = 0; g < p.length; g++)
          n.call(c, p[g]) && (d[p[g]] = c[p[g]]);
      }
    }
    return d;
  }, Nf;
}
var jf, p1;
function Qg() {
  if (p1) return jf;
  p1 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return jf = e, jf;
}
var Ff, f1;
function AC() {
  return f1 || (f1 = 1, Ff = Function.call.bind(Object.prototype.hasOwnProperty)), Ff;
}
var Lf, h1;
function U6() {
  if (h1) return Lf;
  h1 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ Qg(), n = {}, r = /* @__PURE__ */ AC();
    e = function(a) {
      var l = "Warning: " + a;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function o(a, l, c, d, p) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in a)
        if (r(a, f)) {
          var m;
          try {
            if (typeof a[f] != "function") {
              var g = Error(
                (d || "React class") + ": " + c + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            m = a[f](l, f, d, c, null, t);
          } catch (b) {
            m = b;
          }
          if (m && !(m instanceof Error) && e(
            (d || "React class") + ": type specification of " + c + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof m + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), m instanceof Error && !(m.message in n)) {
            n[m.message] = !0;
            var y = p ? p() : "";
            e(
              "Failed " + c + " type: " + m.message + (y ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Lf = o, Lf;
}
var Bf, m1;
function H6() {
  if (m1) return Bf;
  m1 = 1;
  var e = MC(), t = q6(), n = /* @__PURE__ */ Qg(), r = /* @__PURE__ */ AC(), o = /* @__PURE__ */ U6(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(c) {
    var d = "Warning: " + c;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return Bf = function(c, d) {
    var p = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function m(K) {
      var Q = K && (p && K[p] || K[f]);
      if (typeof Q == "function")
        return Q;
    }
    var g = "<<anonymous>>", y = {
      array: S("array"),
      bigint: S("bigint"),
      bool: S("boolean"),
      func: S("function"),
      number: S("number"),
      object: S("object"),
      string: S("string"),
      symbol: S("symbol"),
      any: R(),
      arrayOf: P,
      element: T(),
      elementType: O(),
      instanceOf: k,
      node: E(),
      objectOf: D,
      oneOf: I,
      oneOfType: j,
      shape: F,
      exact: B
    };
    function b(K, Q) {
      return K === Q ? K !== 0 || 1 / K === 1 / Q : K !== K && Q !== Q;
    }
    function v(K, Q) {
      this.message = K, this.data = Q && typeof Q == "object" ? Q : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function $(K) {
      if (process.env.NODE_ENV !== "production")
        var Q = {}, ye = 0;
      function we(X, re, ie, Y, Z, ue, ge) {
        if (Y = Y || g, ue = ue || ie, ge !== n) {
          if (d) {
            var W = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw W.name = "Invariant Violation", W;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var J = Y + ":" + ie;
            !Q[J] && // Avoid spamming the console because they are often not actionable except for lib authors
            ye < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + ue + "` prop on `" + Y + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Q[J] = !0, ye++);
          }
        }
        return re[ie] == null ? X ? re[ie] === null ? new v("The " + Z + " `" + ue + "` is marked as required " + ("in `" + Y + "`, but its value is `null`.")) : new v("The " + Z + " `" + ue + "` is marked as required in " + ("`" + Y + "`, but its value is `undefined`.")) : null : K(re, ie, Y, Z, ue);
      }
      var fe = we.bind(null, !1);
      return fe.isRequired = we.bind(null, !0), fe;
    }
    function S(K) {
      function Q(ye, we, fe, X, re, ie) {
        var Y = ye[we], Z = L(Y);
        if (Z !== K) {
          var ue = G(Y);
          return new v(
            "Invalid " + X + " `" + re + "` of type " + ("`" + ue + "` supplied to `" + fe + "`, expected ") + ("`" + K + "`."),
            { expectedType: K }
          );
        }
        return null;
      }
      return $(Q);
    }
    function R() {
      return $(l);
    }
    function P(K) {
      function Q(ye, we, fe, X, re) {
        if (typeof K != "function")
          return new v("Property `" + re + "` of component `" + fe + "` has invalid PropType notation inside arrayOf.");
        var ie = ye[we];
        if (!Array.isArray(ie)) {
          var Y = L(ie);
          return new v("Invalid " + X + " `" + re + "` of type " + ("`" + Y + "` supplied to `" + fe + "`, expected an array."));
        }
        for (var Z = 0; Z < ie.length; Z++) {
          var ue = K(ie, Z, fe, X, re + "[" + Z + "]", n);
          if (ue instanceof Error)
            return ue;
        }
        return null;
      }
      return $(Q);
    }
    function T() {
      function K(Q, ye, we, fe, X) {
        var re = Q[ye];
        if (!c(re)) {
          var ie = L(re);
          return new v("Invalid " + fe + " `" + X + "` of type " + ("`" + ie + "` supplied to `" + we + "`, expected a single ReactElement."));
        }
        return null;
      }
      return $(K);
    }
    function O() {
      function K(Q, ye, we, fe, X) {
        var re = Q[ye];
        if (!e.isValidElementType(re)) {
          var ie = L(re);
          return new v("Invalid " + fe + " `" + X + "` of type " + ("`" + ie + "` supplied to `" + we + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return $(K);
    }
    function k(K) {
      function Q(ye, we, fe, X, re) {
        if (!(ye[we] instanceof K)) {
          var ie = K.name || g, Y = ne(ye[we]);
          return new v("Invalid " + X + " `" + re + "` of type " + ("`" + Y + "` supplied to `" + fe + "`, expected ") + ("instance of `" + ie + "`."));
        }
        return null;
      }
      return $(Q);
    }
    function I(K) {
      if (!Array.isArray(K))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), l;
      function Q(ye, we, fe, X, re) {
        for (var ie = ye[we], Y = 0; Y < K.length; Y++)
          if (b(ie, K[Y]))
            return null;
        var Z = JSON.stringify(K, function(ge, W) {
          var J = G(W);
          return J === "symbol" ? String(W) : W;
        });
        return new v("Invalid " + X + " `" + re + "` of value `" + String(ie) + "` " + ("supplied to `" + fe + "`, expected one of " + Z + "."));
      }
      return $(Q);
    }
    function D(K) {
      function Q(ye, we, fe, X, re) {
        if (typeof K != "function")
          return new v("Property `" + re + "` of component `" + fe + "` has invalid PropType notation inside objectOf.");
        var ie = ye[we], Y = L(ie);
        if (Y !== "object")
          return new v("Invalid " + X + " `" + re + "` of type " + ("`" + Y + "` supplied to `" + fe + "`, expected an object."));
        for (var Z in ie)
          if (r(ie, Z)) {
            var ue = K(ie, Z, fe, X, re + "." + Z, n);
            if (ue instanceof Error)
              return ue;
          }
        return null;
      }
      return $(Q);
    }
    function j(K) {
      if (!Array.isArray(K))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var Q = 0; Q < K.length; Q++) {
        var ye = K[Q];
        if (typeof ye != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + se(ye) + " at index " + Q + "."
          ), l;
      }
      function we(fe, X, re, ie, Y) {
        for (var Z = [], ue = 0; ue < K.length; ue++) {
          var ge = K[ue], W = ge(fe, X, re, ie, Y, n);
          if (W == null)
            return null;
          W.data && r(W.data, "expectedType") && Z.push(W.data.expectedType);
        }
        var J = Z.length > 0 ? ", expected one of type [" + Z.join(", ") + "]" : "";
        return new v("Invalid " + ie + " `" + Y + "` supplied to " + ("`" + re + "`" + J + "."));
      }
      return $(we);
    }
    function E() {
      function K(Q, ye, we, fe, X) {
        return V(Q[ye]) ? null : new v("Invalid " + fe + " `" + X + "` supplied to " + ("`" + we + "`, expected a ReactNode."));
      }
      return $(K);
    }
    function M(K, Q, ye, we, fe) {
      return new v(
        (K || "React class") + ": " + Q + " type `" + ye + "." + we + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + fe + "`."
      );
    }
    function F(K) {
      function Q(ye, we, fe, X, re) {
        var ie = ye[we], Y = L(ie);
        if (Y !== "object")
          return new v("Invalid " + X + " `" + re + "` of type `" + Y + "` " + ("supplied to `" + fe + "`, expected `object`."));
        for (var Z in K) {
          var ue = K[Z];
          if (typeof ue != "function")
            return M(fe, X, re, Z, G(ue));
          var ge = ue(ie, Z, fe, X, re + "." + Z, n);
          if (ge)
            return ge;
        }
        return null;
      }
      return $(Q);
    }
    function B(K) {
      function Q(ye, we, fe, X, re) {
        var ie = ye[we], Y = L(ie);
        if (Y !== "object")
          return new v("Invalid " + X + " `" + re + "` of type `" + Y + "` " + ("supplied to `" + fe + "`, expected `object`."));
        var Z = t({}, ye[we], K);
        for (var ue in Z) {
          var ge = K[ue];
          if (r(K, ue) && typeof ge != "function")
            return M(fe, X, re, ue, G(ge));
          if (!ge)
            return new v(
              "Invalid " + X + " `" + re + "` key `" + ue + "` supplied to `" + fe + "`.\nBad object: " + JSON.stringify(ye[we], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(K), null, "  ")
            );
          var W = ge(ie, ue, fe, X, re + "." + ue, n);
          if (W)
            return W;
        }
        return null;
      }
      return $(Q);
    }
    function V(K) {
      switch (typeof K) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !K;
        case "object":
          if (Array.isArray(K))
            return K.every(V);
          if (K === null || c(K))
            return !0;
          var Q = m(K);
          if (Q) {
            var ye = Q.call(K), we;
            if (Q !== K.entries) {
              for (; !(we = ye.next()).done; )
                if (!V(we.value))
                  return !1;
            } else
              for (; !(we = ye.next()).done; ) {
                var fe = we.value;
                if (fe && !V(fe[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function z(K, Q) {
      return K === "symbol" ? !0 : Q ? Q["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Q instanceof Symbol : !1;
    }
    function L(K) {
      var Q = typeof K;
      return Array.isArray(K) ? "array" : K instanceof RegExp ? "object" : z(Q, K) ? "symbol" : Q;
    }
    function G(K) {
      if (typeof K > "u" || K === null)
        return "" + K;
      var Q = L(K);
      if (Q === "object") {
        if (K instanceof Date)
          return "date";
        if (K instanceof RegExp)
          return "regexp";
      }
      return Q;
    }
    function se(K) {
      var Q = G(K);
      switch (Q) {
        case "array":
        case "object":
          return "an " + Q;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Q;
        default:
          return Q;
      }
    }
    function ne(K) {
      return !K.constructor || !K.constructor.name ? g : K.constructor.name;
    }
    return y.checkPropTypes = o, y.resetWarningCache = o.resetWarningCache, y.PropTypes = y, y;
  }, Bf;
}
var Vf, g1;
function G6() {
  if (g1) return Vf;
  g1 = 1;
  var e = /* @__PURE__ */ Qg();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Vf = function() {
    function r(l, c, d, p, f, m) {
      if (m !== e) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Vf;
}
var y1;
function Y6() {
  if (y1) return su.exports;
  if (y1 = 1, process.env.NODE_ENV !== "production") {
    var e = MC(), t = !0;
    su.exports = /* @__PURE__ */ H6()(e.isElement, t);
  } else
    su.exports = /* @__PURE__ */ G6()();
  return su.exports;
}
var K6 = /* @__PURE__ */ Y6();
const i = /* @__PURE__ */ Cs(K6);
function X6(e) {
  return e == null || Object.keys(e).length === 0;
}
function Jg(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e, r = typeof t == "function" ? (o) => t(X6(o) ? n : o) : t;
  return /* @__PURE__ */ x.jsx(M6, {
    styles: r
  });
}
process.env.NODE_ENV !== "production" && (Jg.propTypes = {
  defaultTheme: i.object,
  styles: i.oneOfType([i.array, i.string, i.object, i.func])
});
/**
 * @mui/styled-engine v6.4.3
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function NC(e, t) {
  const n = lg(e, t);
  return process.env.NODE_ENV !== "production" ? (...r) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((a) => a === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
function Z6(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const v1 = [];
function b1(e) {
  return v1[0] = e, Yl(v1);
}
var cu = { exports: {} }, en = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var x1;
function Q6() {
  if (x1) return en;
  x1 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), y = Symbol.for("react.client.reference");
  function b(v) {
    if (typeof v == "object" && v !== null) {
      var $ = v.$$typeof;
      switch ($) {
        case e:
          switch (v = v.type, v) {
            case n:
            case o:
            case r:
            case d:
            case p:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case l:
                case c:
                case m:
                case f:
                  return v;
                case a:
                  return v;
                default:
                  return $;
              }
          }
        case t:
          return $;
      }
    }
  }
  return en.ContextConsumer = a, en.ContextProvider = l, en.Element = e, en.ForwardRef = c, en.Fragment = n, en.Lazy = m, en.Memo = f, en.Portal = t, en.Profiler = o, en.StrictMode = r, en.Suspense = d, en.SuspenseList = p, en.isContextConsumer = function(v) {
    return b(v) === a;
  }, en.isContextProvider = function(v) {
    return b(v) === l;
  }, en.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, en.isForwardRef = function(v) {
    return b(v) === c;
  }, en.isFragment = function(v) {
    return b(v) === n;
  }, en.isLazy = function(v) {
    return b(v) === m;
  }, en.isMemo = function(v) {
    return b(v) === f;
  }, en.isPortal = function(v) {
    return b(v) === t;
  }, en.isProfiler = function(v) {
    return b(v) === o;
  }, en.isStrictMode = function(v) {
    return b(v) === r;
  }, en.isSuspense = function(v) {
    return b(v) === d;
  }, en.isSuspenseList = function(v) {
    return b(v) === p;
  }, en.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === n || v === o || v === r || v === d || v === p || v === g || typeof v == "object" && v !== null && (v.$$typeof === m || v.$$typeof === f || v.$$typeof === l || v.$$typeof === a || v.$$typeof === c || v.$$typeof === y || v.getModuleId !== void 0);
  }, en.typeOf = b, en;
}
var tn = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var w1;
function J6() {
  return w1 || (w1 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(v) {
      if (typeof v == "object" && v !== null) {
        var $ = v.$$typeof;
        switch ($) {
          case t:
            switch (v = v.type, v) {
              case r:
              case a:
              case o:
              case p:
              case f:
                return v;
              default:
                switch (v = v && v.$$typeof, v) {
                  case c:
                  case d:
                  case g:
                  case m:
                    return v;
                  case l:
                    return v;
                  default:
                    return $;
                }
            }
          case n:
            return $;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), l = Symbol.for("react.consumer"), c = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), b = Symbol.for("react.client.reference");
    tn.ContextConsumer = l, tn.ContextProvider = c, tn.Element = t, tn.ForwardRef = d, tn.Fragment = r, tn.Lazy = g, tn.Memo = m, tn.Portal = n, tn.Profiler = a, tn.StrictMode = o, tn.Suspense = p, tn.SuspenseList = f, tn.isContextConsumer = function(v) {
      return e(v) === l;
    }, tn.isContextProvider = function(v) {
      return e(v) === c;
    }, tn.isElement = function(v) {
      return typeof v == "object" && v !== null && v.$$typeof === t;
    }, tn.isForwardRef = function(v) {
      return e(v) === d;
    }, tn.isFragment = function(v) {
      return e(v) === r;
    }, tn.isLazy = function(v) {
      return e(v) === g;
    }, tn.isMemo = function(v) {
      return e(v) === m;
    }, tn.isPortal = function(v) {
      return e(v) === n;
    }, tn.isProfiler = function(v) {
      return e(v) === a;
    }, tn.isStrictMode = function(v) {
      return e(v) === o;
    }, tn.isSuspense = function(v) {
      return e(v) === p;
    }, tn.isSuspenseList = function(v) {
      return e(v) === f;
    }, tn.isValidElementType = function(v) {
      return typeof v == "string" || typeof v == "function" || v === r || v === a || v === o || v === p || v === f || v === y || typeof v == "object" && v !== null && (v.$$typeof === g || v.$$typeof === m || v.$$typeof === c || v.$$typeof === l || v.$$typeof === d || v.$$typeof === b || v.getModuleId !== void 0);
    }, tn.typeOf = e;
  }()), tn;
}
var $1;
function e8() {
  return $1 || ($1 = 1, process.env.NODE_ENV === "production" ? cu.exports = /* @__PURE__ */ Q6() : cu.exports = /* @__PURE__ */ J6()), cu.exports;
}
var va = /* @__PURE__ */ e8();
function ko(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function jC(e) {
  if (/* @__PURE__ */ w.isValidElement(e) || va.isValidElementType(e) || !ko(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = jC(e[n]);
  }), t;
}
function Vn(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? {
    ...e
  } : e;
  return ko(e) && ko(t) && Object.keys(t).forEach((o) => {
    /* @__PURE__ */ w.isValidElement(t[o]) || va.isValidElementType(t[o]) ? r[o] = t[o] : ko(t[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && ko(e[o]) ? r[o] = Vn(e[o], t[o], n) : n.clone ? r[o] = ko(t[o]) ? jC(t[o]) : t[o] : r[o] = t[o];
  }), r;
}
const t8 = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => ({
    ...n,
    [r.key]: r.val
  }), {});
};
function n8(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5,
    ...o
  } = e, a = t8(t), l = Object.keys(a);
  function c(g) {
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${n})`;
  }
  function d(g) {
    return `@media (max-width:${(typeof t[g] == "number" ? t[g] : g) - r / 100}${n})`;
  }
  function p(g, y) {
    const b = l.indexOf(y);
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${n}) and (max-width:${(b !== -1 && typeof t[l[b]] == "number" ? t[l[b]] : y) - r / 100}${n})`;
  }
  function f(g) {
    return l.indexOf(g) + 1 < l.length ? p(g, l[l.indexOf(g) + 1]) : c(g);
  }
  function m(g) {
    const y = l.indexOf(g);
    return y === 0 ? c(l[1]) : y === l.length - 1 ? d(l[y]) : p(g, l[l.indexOf(g) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: l,
    values: a,
    up: c,
    down: d,
    between: p,
    only: f,
    not: m,
    unit: n,
    ...o
  };
}
function r8(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((r) => r.startsWith("@container")).sort((r, o) => {
    var l, c;
    const a = /min-width:\s*([0-9.]+)/;
    return +(((l = r.match(a)) == null ? void 0 : l[1]) || 0) - +(((c = o.match(a)) == null ? void 0 : c[1]) || 0);
  });
  return n.length ? n.reduce((r, o) => {
    const a = t[o];
    return delete r[o], r[o] = a, r;
  }, {
    ...t
  }) : t;
}
function o8(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function i8(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : No(18, `(${t})`));
    return null;
  }
  const [, r, o] = n, a = Number.isNaN(+r) ? r || 0 : +r;
  return e.containerQueries(o).up(a);
}
function a8(e) {
  const t = (a, l) => a.replace("@media", l ? `@container ${l}` : "@container");
  function n(a, l) {
    a.up = (...c) => t(e.breakpoints.up(...c), l), a.down = (...c) => t(e.breakpoints.down(...c), l), a.between = (...c) => t(e.breakpoints.between(...c), l), a.only = (...c) => t(e.breakpoints.only(...c), l), a.not = (...c) => {
      const d = t(e.breakpoints.not(...c), l);
      return d.includes("not all and") ? d.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : d;
    };
  }
  const r = {}, o = (a) => (n(r, a), r);
  return n(o), {
    ...e,
    containerQueries: o
  };
}
const s8 = {
  borderRadius: 4
}, Wi = process.env.NODE_ENV !== "production" ? i.oneOfType([i.number, i.string, i.object, i.array]) : {};
function wl(e, t) {
  return t ? Vn(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const xd = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, C1 = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${xd[e]}px)`
}, l8 = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : xd[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function go(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const a = r.breakpoints || C1;
    return t.reduce((l, c, d) => (l[a.up(a.keys[d])] = n(t[d]), l), {});
  }
  if (typeof t == "object") {
    const a = r.breakpoints || C1;
    return Object.keys(t).reduce((l, c) => {
      if (o8(a.keys, c)) {
        const d = i8(r.containerQueries ? r : l8, c);
        d && (l[d] = n(t[c], c));
      } else if (Object.keys(a.values || xd).includes(c)) {
        const d = a.up(c);
        l[d] = n(t[c], c);
      } else {
        const d = c;
        l[d] = t[d];
      }
      return l;
    }, {});
  }
  return n(t);
}
function FC(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((r, o) => {
    const a = e.up(o);
    return r[a] = {}, r;
  }, {})) || {};
}
function LC(e, t) {
  return e.reduce((n, r) => {
    const o = n[r];
    return (!o || Object.keys(o).length === 0) && delete n[r], n;
  }, t);
}
function c8(e, ...t) {
  const n = FC(e), r = [n, ...t].reduce((o, a) => Vn(o, a), {});
  return LC(Object.keys(n), r);
}
function u8(e, t) {
  if (typeof e != "object")
    return {};
  const n = {}, r = Object.keys(t);
  return Array.isArray(e) ? r.forEach((o, a) => {
    a < e.length && (n[o] = !0);
  }) : r.forEach((o) => {
    e[o] != null && (n[o] = !0);
  }), n;
}
function zf({
  values: e,
  breakpoints: t,
  base: n
}) {
  const r = n || u8(e, t), o = Object.keys(r);
  if (o.length === 0)
    return e;
  let a;
  return o.reduce((l, c, d) => (Array.isArray(e) ? (l[c] = e[d] != null ? e[d] : e[a], a = d) : typeof e == "object" ? (l[c] = e[c] != null ? e[c] : e[a], a = c) : l[c] = e, l), {});
}
function Pe(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : No(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function wd(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((o, a) => o && o[a] ? o[a] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, o) => r && r[o] != null ? r[o] : null, e);
}
function zu(e, t, n, r = n) {
  let o;
  return typeof e == "function" ? o = e(n) : Array.isArray(e) ? o = e[n] || r : o = wd(e, n) || r, t && (o = t(o, r, e)), o;
}
function Dn(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: o
  } = e, a = (l) => {
    if (l[t] == null)
      return null;
    const c = l[t], d = l.theme, p = wd(d, r) || {};
    return go(l, c, (m) => {
      let g = zu(p, o, m);
      return m === g && typeof m == "string" && (g = zu(p, o, `${t}${m === "default" ? "" : Pe(m)}`, m)), n === !1 ? g : {
        [n]: g
      };
    });
  };
  return a.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: Wi
  } : {}, a.filterProps = [t], a;
}
function d8(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const p8 = {
  m: "margin",
  p: "padding"
}, f8 = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, S1 = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, h8 = d8((e) => {
  if (e.length > 2)
    if (S1[e])
      e = S1[e];
    else
      return [e];
  const [t, n] = e.split(""), r = p8[t], o = f8[n] || "";
  return Array.isArray(o) ? o.map((a) => r + a) : [r + o];
}), $d = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Cd = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], m8 = [...$d, ...Cd];
function Zl(e, t, n, r) {
  const o = wd(e, t, !0) ?? n;
  return typeof o == "number" || typeof o == "string" ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && typeof a != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${a}.`), typeof o == "string" ? `calc(${a} * ${o})` : o * a) : Array.isArray(o) ? (a) => {
    if (typeof a == "string")
      return a;
    const l = Math.abs(a);
    process.env.NODE_ENV !== "production" && (Number.isInteger(l) ? l > o.length - 1 && console.error([`MUI: The value provided (${l}) overflows.`, `The supported values are: ${JSON.stringify(o)}.`, `${l} > ${o.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const c = o[l];
    return a >= 0 ? c : typeof c == "number" ? -c : `-${c}`;
  } : typeof o == "function" ? o : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${o}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function Sd(e) {
  return Zl(e, "spacing", 8, "spacing");
}
function ba(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function g8(e, t) {
  return (n) => e.reduce((r, o) => (r[o] = ba(t, n), r), {});
}
function y8(e, t, n, r) {
  if (!t.includes(n))
    return null;
  const o = h8(n), a = g8(o, r), l = e[n];
  return go(e, l, a);
}
function BC(e, t) {
  const n = Sd(e.theme);
  return Object.keys(e).map((r) => y8(e, t, r, n)).reduce(wl, {});
}
function $n(e) {
  return BC(e, $d);
}
$n.propTypes = process.env.NODE_ENV !== "production" ? $d.reduce((e, t) => (e[t] = Wi, e), {}) : {};
$n.filterProps = $d;
function Cn(e) {
  return BC(e, Cd);
}
Cn.propTypes = process.env.NODE_ENV !== "production" ? Cd.reduce((e, t) => (e[t] = Wi, e), {}) : {};
Cn.filterProps = Cd;
process.env.NODE_ENV !== "production" && m8.reduce((e, t) => (e[t] = Wi, e), {});
function VC(e = 8, t = Sd({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...r) => (process.env.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((a) => {
    const l = t(a);
    return typeof l == "number" ? `${l}px` : l;
  }).join(" "));
  return n.mui = !0, n;
}
function Td(...e) {
  const t = e.reduce((r, o) => (o.filterProps.forEach((a) => {
    r[a] = o;
  }), r), {}), n = (r) => Object.keys(r).reduce((o, a) => t[a] ? wl(o, t[a](r)) : o, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((r, o) => Object.assign(r, o.propTypes), {}) : {}, n.filterProps = e.reduce((r, o) => r.concat(o.filterProps), []), n;
}
function Gr(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function to(e, t) {
  return Dn({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const v8 = to("border", Gr), b8 = to("borderTop", Gr), x8 = to("borderRight", Gr), w8 = to("borderBottom", Gr), $8 = to("borderLeft", Gr), C8 = to("borderColor"), S8 = to("borderTopColor"), T8 = to("borderRightColor"), O8 = to("borderBottomColor"), P8 = to("borderLeftColor"), E8 = to("outline", Gr), R8 = to("outlineColor"), Od = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = Zl(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: ba(t, r)
    });
    return go(e, e.borderRadius, n);
  }
  return null;
};
Od.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Wi
} : {};
Od.filterProps = ["borderRadius"];
Td(v8, b8, x8, w8, $8, C8, S8, T8, O8, P8, Od, E8, R8);
const Pd = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = Zl(e.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: ba(t, r)
    });
    return go(e, e.gap, n);
  }
  return null;
};
Pd.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Wi
} : {};
Pd.filterProps = ["gap"];
const Ed = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = Zl(e.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: ba(t, r)
    });
    return go(e, e.columnGap, n);
  }
  return null;
};
Ed.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Wi
} : {};
Ed.filterProps = ["columnGap"];
const Rd = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = Zl(e.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: ba(t, r)
    });
    return go(e, e.rowGap, n);
  }
  return null;
};
Rd.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Wi
} : {};
Rd.filterProps = ["rowGap"];
const k8 = Dn({
  prop: "gridColumn"
}), _8 = Dn({
  prop: "gridRow"
}), D8 = Dn({
  prop: "gridAutoFlow"
}), I8 = Dn({
  prop: "gridAutoColumns"
}), M8 = Dn({
  prop: "gridAutoRows"
}), A8 = Dn({
  prop: "gridTemplateColumns"
}), N8 = Dn({
  prop: "gridTemplateRows"
}), j8 = Dn({
  prop: "gridTemplateAreas"
}), F8 = Dn({
  prop: "gridArea"
});
Td(Pd, Ed, Rd, k8, _8, D8, I8, M8, A8, N8, j8, F8);
function rs(e, t) {
  return t === "grey" ? t : e;
}
const L8 = Dn({
  prop: "color",
  themeKey: "palette",
  transform: rs
}), B8 = Dn({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: rs
}), V8 = Dn({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: rs
});
Td(L8, B8, V8);
function _r(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const z8 = Dn({
  prop: "width",
  transform: _r
}), e0 = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var o, a, l, c, d;
      const r = ((l = (a = (o = e.theme) == null ? void 0 : o.breakpoints) == null ? void 0 : a.values) == null ? void 0 : l[n]) || xd[n];
      return r ? ((d = (c = e.theme) == null ? void 0 : c.breakpoints) == null ? void 0 : d.unit) !== "px" ? {
        maxWidth: `${r}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: r
      } : {
        maxWidth: _r(n)
      };
    };
    return go(e, e.maxWidth, t);
  }
  return null;
};
e0.filterProps = ["maxWidth"];
const W8 = Dn({
  prop: "minWidth",
  transform: _r
}), q8 = Dn({
  prop: "height",
  transform: _r
}), U8 = Dn({
  prop: "maxHeight",
  transform: _r
}), H8 = Dn({
  prop: "minHeight",
  transform: _r
});
Dn({
  prop: "size",
  cssProperty: "width",
  transform: _r
});
Dn({
  prop: "size",
  cssProperty: "height",
  transform: _r
});
const G8 = Dn({
  prop: "boxSizing"
});
Td(z8, e0, W8, q8, U8, H8, G8);
const Ql = {
  // borders
  border: {
    themeKey: "borders",
    transform: Gr
  },
  borderTop: {
    themeKey: "borders",
    transform: Gr
  },
  borderRight: {
    themeKey: "borders",
    transform: Gr
  },
  borderBottom: {
    themeKey: "borders",
    transform: Gr
  },
  borderLeft: {
    themeKey: "borders",
    transform: Gr
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Gr
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Od
  },
  // palette
  color: {
    themeKey: "palette",
    transform: rs
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: rs
  },
  backgroundColor: {
    themeKey: "palette",
    transform: rs
  },
  // spacing
  p: {
    style: Cn
  },
  pt: {
    style: Cn
  },
  pr: {
    style: Cn
  },
  pb: {
    style: Cn
  },
  pl: {
    style: Cn
  },
  px: {
    style: Cn
  },
  py: {
    style: Cn
  },
  padding: {
    style: Cn
  },
  paddingTop: {
    style: Cn
  },
  paddingRight: {
    style: Cn
  },
  paddingBottom: {
    style: Cn
  },
  paddingLeft: {
    style: Cn
  },
  paddingX: {
    style: Cn
  },
  paddingY: {
    style: Cn
  },
  paddingInline: {
    style: Cn
  },
  paddingInlineStart: {
    style: Cn
  },
  paddingInlineEnd: {
    style: Cn
  },
  paddingBlock: {
    style: Cn
  },
  paddingBlockStart: {
    style: Cn
  },
  paddingBlockEnd: {
    style: Cn
  },
  m: {
    style: $n
  },
  mt: {
    style: $n
  },
  mr: {
    style: $n
  },
  mb: {
    style: $n
  },
  ml: {
    style: $n
  },
  mx: {
    style: $n
  },
  my: {
    style: $n
  },
  margin: {
    style: $n
  },
  marginTop: {
    style: $n
  },
  marginRight: {
    style: $n
  },
  marginBottom: {
    style: $n
  },
  marginLeft: {
    style: $n
  },
  marginX: {
    style: $n
  },
  marginY: {
    style: $n
  },
  marginInline: {
    style: $n
  },
  marginInlineStart: {
    style: $n
  },
  marginInlineEnd: {
    style: $n
  },
  marginBlock: {
    style: $n
  },
  marginBlockStart: {
    style: $n
  },
  marginBlockEnd: {
    style: $n
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Pd
  },
  rowGap: {
    style: Rd
  },
  columnGap: {
    style: Ed
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: _r
  },
  maxWidth: {
    style: e0
  },
  minWidth: {
    transform: _r
  },
  height: {
    transform: _r
  },
  maxHeight: {
    transform: _r
  },
  minHeight: {
    transform: _r
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function Y8(...e) {
  const t = e.reduce((r, o) => r.concat(Object.keys(o)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function K8(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function X8() {
  function e(n, r, o, a) {
    const l = {
      [n]: r,
      theme: o
    }, c = a[n];
    if (!c)
      return {
        [n]: r
      };
    const {
      cssProperty: d = n,
      themeKey: p,
      transform: f,
      style: m
    } = c;
    if (r == null)
      return null;
    if (p === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const g = wd(o, p) || {};
    return m ? m(l) : go(l, r, (b) => {
      let v = zu(g, f, b);
      return b === v && typeof b == "string" && (v = zu(g, f, `${n}${b === "default" ? "" : Pe(b)}`, b)), d === !1 ? v : {
        [d]: v
      };
    });
  }
  function t(n) {
    const {
      sx: r,
      theme: o = {}
    } = n || {};
    if (!r)
      return null;
    const a = o.unstable_sxConfig ?? Ql;
    function l(c) {
      let d = c;
      if (typeof c == "function")
        d = c(o);
      else if (typeof c != "object")
        return c;
      if (!d)
        return null;
      const p = FC(o.breakpoints), f = Object.keys(p);
      let m = p;
      return Object.keys(d).forEach((g) => {
        const y = K8(d[g], o);
        if (y != null)
          if (typeof y == "object")
            if (a[g])
              m = wl(m, e(g, y, o, a));
            else {
              const b = go({
                theme: o
              }, y, (v) => ({
                [g]: v
              }));
              Y8(b, y) ? m[g] = t({
                sx: y,
                theme: o
              }) : m = wl(m, b);
            }
          else
            m = wl(m, e(g, y, o, a));
      }), r8(o, LC(f, m));
    }
    return Array.isArray(r) ? r.map(l) : l(r);
  }
  return t;
}
const Li = X8();
Li.filterProps = ["sx"];
function Z8(e, t) {
  var r;
  const n = this;
  if (n.vars) {
    if (!((r = n.colorSchemes) != null && r[e]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let o = n.getColorSchemeSelector(e);
    return o === "&" ? t : ((o.includes("data-") || o.includes(".")) && (o = `*:where(${o.replace(/\s*&$/, "")}) &`), {
      [o]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function Jl(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: o,
    shape: a = {},
    ...l
  } = e, c = n8(n), d = VC(o);
  let p = Vn({
    breakpoints: c,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...r
    },
    spacing: d,
    shape: {
      ...s8,
      ...a
    }
  }, l);
  return p = a8(p), p.applyStyles = Z8, p = t.reduce((f, m) => Vn(f, m), p), p.unstable_sxConfig = {
    ...Ql,
    ...l == null ? void 0 : l.unstable_sxConfig
  }, p.unstable_sx = function(m) {
    return Li({
      sx: m,
      theme: this
    });
  }, p;
}
function Q8(e) {
  return Object.keys(e).length === 0;
}
function t0(e = null) {
  const t = w.useContext(Kl);
  return !t || Q8(t) ? e : t;
}
const J8 = Jl();
function ec(e = J8) {
  return t0(e);
}
function zC({
  styles: e,
  themeId: t,
  defaultTheme: n = {}
}) {
  const r = ec(n), o = typeof e == "function" ? e(t && r[t] || r) : e;
  return /* @__PURE__ */ x.jsx(Jg, {
    styles: o
  });
}
process.env.NODE_ENV !== "production" && (zC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: i.object,
  /**
   * @ignore
   */
  styles: i.oneOfType([i.array, i.func, i.number, i.object, i.string, i.bool]),
  /**
   * @ignore
   */
  themeId: i.string
});
const e_ = (e) => {
  var r;
  const t = {
    systemProps: {},
    otherProps: {}
  }, n = ((r = e == null ? void 0 : e.theme) == null ? void 0 : r.unstable_sxConfig) ?? Ql;
  return Object.keys(e).forEach((o) => {
    n[o] ? t.systemProps[o] = e[o] : t.otherProps[o] = e[o];
  }), t;
};
function kd(e) {
  const {
    sx: t,
    ...n
  } = e, {
    systemProps: r,
    otherProps: o
  } = e_(n);
  let a;
  return Array.isArray(t) ? a = [r, ...t] : typeof t == "function" ? a = (...l) => {
    const c = t(...l);
    return ko(c) ? {
      ...r,
      ...c
    } : r;
  } : a = {
    ...r,
    ...t
  }, {
    ...o,
    sx: a
  };
}
const T1 = (e) => e, t_ = () => {
  let e = T1;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = T1;
    }
  };
}, WC = t_();
function qC(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = qC(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function _e() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = qC(e)) && (r && (r += " "), r += t);
  return r;
}
function n_(e = {}) {
  const {
    themeId: t,
    defaultTheme: n,
    defaultClassName: r = "MuiBox-root",
    generateClassName: o
  } = e, a = NC("div", {
    shouldForwardProp: (c) => c !== "theme" && c !== "sx" && c !== "as"
  })(Li);
  return /* @__PURE__ */ w.forwardRef(function(d, p) {
    const f = ec(n), {
      className: m,
      component: g = "div",
      ...y
    } = kd(d);
    return /* @__PURE__ */ x.jsx(a, {
      as: g,
      ref: p,
      className: _e(m, o ? o(r) : r),
      theme: t && f[t] || f,
      ...y
    });
  });
}
const r_ = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Fe(e, t, n = "Mui") {
  const r = r_[t];
  return r ? `${n}-${r}` : `${WC.generate(e)}-${t}`;
}
function Le(e, t, n = "Mui") {
  const r = {};
  return t.forEach((o) => {
    r[o] = Fe(e, o, n);
  }), r;
}
function UC(e, t = "") {
  return e.displayName || e.name || t;
}
function O1(e, t, n) {
  const r = UC(t);
  return e.displayName || (r !== "" ? `${n}(${r})` : n);
}
function o_(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return UC(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case va.ForwardRef:
          return O1(e, e.render, "ForwardRef");
        case va.Memo:
          return O1(e, e.type, "memo");
        default:
          return;
      }
  }
}
function HC(e) {
  const {
    variants: t,
    ...n
  } = e, r = {
    variants: t,
    style: b1(n),
    isProcessed: !0
  };
  return r.style === n || t && t.forEach((o) => {
    typeof o.style != "function" && (o.style = b1(o.style));
  }), r;
}
const i_ = Jl();
function ku(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function a_(e) {
  return e ? (t, n) => n[e] : null;
}
function s_(e, t, n) {
  e.theme = u_(e.theme) ? n : e.theme[t] || e.theme;
}
function _u(e, t) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((r) => _u(e, r));
  if (Array.isArray(n == null ? void 0 : n.variants)) {
    let r;
    if (n.isProcessed)
      r = n.style;
    else {
      const {
        variants: o,
        ...a
      } = n;
      r = a;
    }
    return GC(e, n.variants, [r]);
  }
  return n != null && n.isProcessed ? n.style : n;
}
function GC(e, t, n = []) {
  var o;
  let r;
  e: for (let a = 0; a < t.length; a += 1) {
    const l = t[a];
    if (typeof l.props == "function") {
      if (r ?? (r = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !l.props(r))
        continue;
    } else
      for (const c in l.props)
        if (e[c] !== l.props[c] && ((o = e.ownerState) == null ? void 0 : o[c]) !== l.props[c])
          continue e;
    typeof l.style == "function" ? (r ?? (r = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), n.push(l.style(r))) : n.push(l.style);
  }
  return n;
}
function YC(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = i_,
    rootShouldForwardProp: r = ku,
    slotShouldForwardProp: o = ku
  } = e;
  function a(c) {
    s_(c, t, n);
  }
  return (c, d = {}) => {
    Z6(c, (O) => O.filter((k) => k !== Li));
    const {
      name: p,
      slot: f,
      skipVariantsResolver: m,
      skipSx: g,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: y = a_(KC(f)),
      ...b
    } = d, v = m !== void 0 ? m : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      f && f !== "Root" && f !== "root" || !1
    ), $ = g || !1;
    let S = ku;
    f === "Root" || f === "root" ? S = r : f ? S = o : d_(c) && (S = void 0);
    const R = NC(c, {
      shouldForwardProp: S,
      label: c_(p, f),
      ...b
    }), P = (O) => {
      if (typeof O == "function" && O.__emotion_real !== O)
        return function(I) {
          return _u(I, O);
        };
      if (ko(O)) {
        const k = HC(O);
        return k.variants ? function(D) {
          return _u(D, k);
        } : k.style;
      }
      return O;
    }, T = (...O) => {
      const k = [], I = O.map(P), D = [];
      if (k.push(a), p && y && D.push(function(F) {
        var L, G;
        const V = (G = (L = F.theme.components) == null ? void 0 : L[p]) == null ? void 0 : G.styleOverrides;
        if (!V)
          return null;
        const z = {};
        for (const se in V)
          z[se] = _u(F, V[se]);
        return y(F, z);
      }), p && !v && D.push(function(F) {
        var z, L;
        const B = F.theme, V = (L = (z = B == null ? void 0 : B.components) == null ? void 0 : z[p]) == null ? void 0 : L.variants;
        return V ? GC(F, V) : null;
      }), $ || D.push(Li), Array.isArray(I[0])) {
        const M = I.shift(), F = new Array(k.length).fill(""), B = new Array(D.length).fill("");
        let V;
        V = [...F, ...M, ...B], V.raw = [...F, ...M.raw, ...B], k.unshift(V);
      }
      const j = [...k, ...I, ...D], E = R(...j);
      return c.muiName && (E.muiName = c.muiName), process.env.NODE_ENV !== "production" && (E.displayName = l_(p, f, c)), E;
    };
    return R.withConfig && (T.withConfig = R.withConfig), T;
  };
}
function l_(e, t, n) {
  return e ? `${e}${Pe(t || "")}` : `Styled(${o_(n)})`;
}
function c_(e, t) {
  let n;
  return process.env.NODE_ENV !== "production" && e && (n = `${e}-${KC(t || "Root")}`), n;
}
function u_(e) {
  for (const t in e)
    return !1;
  return !0;
}
function d_(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function KC(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
const XC = YC();
function _l(e, t) {
  const n = {
    ...t
  };
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      const o = r;
      if (o === "components" || o === "slots")
        n[o] = {
          ...e[o],
          ...n[o]
        };
      else if (o === "componentsProps" || o === "slotProps") {
        const a = e[o], l = t[o];
        if (!l)
          n[o] = a || {};
        else if (!a)
          n[o] = l;
        else {
          n[o] = {
            ...l
          };
          for (const c in a)
            if (Object.prototype.hasOwnProperty.call(a, c)) {
              const d = c;
              n[o][d] = _l(a[d], l[d]);
            }
        }
      } else n[o] === void 0 && (n[o] = e[o]);
    }
  return n;
}
function ZC(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? r : _l(t.components[n].defaultProps, r);
}
function n0({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: r
}) {
  let o = ec(n);
  return r && (o = o[r] || o), ZC({
    theme: o,
    name: t,
    props: e
  });
}
const Nn = typeof window < "u" ? w.useLayoutEffect : w.useEffect;
function p_(e, t, n, r, o) {
  const [a, l] = w.useState(() => o && n ? n(e).matches : r ? r(e).matches : t);
  return Nn(() => {
    if (!n)
      return;
    const c = n(e), d = () => {
      l(c.matches);
    };
    return d(), c.addEventListener("change", d), () => {
      c.removeEventListener("change", d);
    };
  }, [e, n]), a;
}
const f_ = {
  ...w
}, QC = f_.useSyncExternalStore;
function h_(e, t, n, r, o) {
  const a = w.useCallback(() => t, [t]), l = w.useMemo(() => {
    if (o && n)
      return () => n(e).matches;
    if (r !== null) {
      const {
        matches: f
      } = r(e);
      return () => f;
    }
    return a;
  }, [a, e, r, o, n]), [c, d] = w.useMemo(() => {
    if (n === null)
      return [a, () => () => {
      }];
    const f = n(e);
    return [() => f.matches, (m) => (f.addEventListener("change", m), () => {
      f.removeEventListener("change", m);
    })];
  }, [a, n, e]);
  return QC(d, c, l);
}
function JC(e = {}) {
  const {
    themeId: t
  } = e;
  return function(r, o = {}) {
    let a = t0();
    a && t && (a = a[t] || a);
    const l = typeof window < "u" && typeof window.matchMedia < "u", {
      defaultMatches: c = !1,
      matchMedia: d = l ? window.matchMedia : null,
      ssrMatchMedia: p = null,
      noSsr: f = !1
    } = ZC({
      name: "MuiUseMediaQuery",
      props: o,
      theme: a
    });
    process.env.NODE_ENV !== "production" && typeof r == "function" && a === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
    let m = typeof r == "function" ? r(a) : r;
    m = m.replace(/^@media( ?)/m, "");
    const y = (QC !== void 0 ? h_ : p_)(m, c, d, p, f);
    return process.env.NODE_ENV !== "production" && w.useDebugValue({
      query: m,
      match: y
    }), y;
  };
}
JC();
function m_(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function r0(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), m_(e, t, n);
}
function g_(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, o) => o < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Bi(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Bi(g_(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : No(9, e));
  let r = e.substring(t + 1, e.length - 1), o;
  if (n === "color") {
    if (r = r.split(" "), o = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(o))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : No(10, o));
  } else
    r = r.split(",");
  return r = r.map((a) => parseFloat(a)), {
    type: n,
    values: r,
    colorSpace: o
  };
}
const y_ = (e) => {
  const t = Bi(e);
  return t.values.slice(0, 3).map((n, r) => t.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, fl = (e, t) => {
  try {
    return y_(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function _d(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.includes("rgb") ? r = r.map((o, a) => a < 3 ? parseInt(o, 10) : o) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function e3(e) {
  e = Bi(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, o = t[2] / 100, a = r * Math.min(o, 1 - o), l = (p, f = (p + n / 30) % 12) => o - a * Math.max(Math.min(f - 3, 9 - f, 1), -1);
  let c = "rgb";
  const d = [Math.round(l(0) * 255), Math.round(l(8) * 255), Math.round(l(4) * 255)];
  return e.type === "hsla" && (c += "a", d.push(t[3])), _d({
    type: c,
    values: d
  });
}
function cg(e) {
  e = Bi(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Bi(e3(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function P1(e, t) {
  const n = cg(e), r = cg(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function ht(e, t) {
  return e = Bi(e), t = r0(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, _d(e);
}
function uu(e, t, n) {
  try {
    return ht(e, t);
  } catch {
    return e;
  }
}
function ds(e, t) {
  if (e = Bi(e), t = r0(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return _d(e);
}
function an(e, t, n) {
  try {
    return ds(e, t);
  } catch {
    return e;
  }
}
function ps(e, t) {
  if (e = Bi(e), t = r0(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return _d(e);
}
function sn(e, t, n) {
  try {
    return ps(e, t);
  } catch {
    return e;
  }
}
function v_(e, t = 0.15) {
  return cg(e) > 0.5 ? ds(e, t) : ps(e, t);
}
function du(e, t, n) {
  try {
    return v_(e, t);
  } catch {
    return e;
  }
}
function yo(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...r) {
    return e(...r) || t(...r);
  };
}
function b_(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function t3(e, t, n, r, o) {
  const a = e[t], l = o || t;
  if (a == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let c;
  const d = a.type;
  return typeof d == "function" && !b_(d) && (c = "Did you accidentally use a plain function component for an element instead?"), c !== void 0 ? new Error(`Invalid ${r} \`${l}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${c} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Ts = yo(i.element, t3);
Ts.isRequired = yo(i.element.isRequired, t3);
function x_(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function w_(e, t, n, r, o) {
  const a = e[t], l = o || t;
  if (a == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let c;
  return typeof a == "function" && !x_(a) && (c = "Did you accidentally provide a plain function component instead?"), c !== void 0 ? new Error(`Invalid ${r} \`${l}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${c} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Dd = yo(i.elementType, w_), $_ = "exact-prop: ​";
function Id(e) {
  return process.env.NODE_ENV === "production" ? e : {
    ...e,
    [$_]: (t) => {
      const n = Object.keys(t).filter((r) => !e.hasOwnProperty(r));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((r) => `\`${r}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
function li(e, t, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const a = e[t], l = o || t;
  return a == null ? null : a && a.nodeType !== 1 ? new Error(`Invalid ${r} \`${l}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const gn = i.oneOfType([i.func, i.object]);
function ug(...e) {
  return e.reduce((t, n) => n == null ? t : function(...o) {
    t.apply(this, o), n.apply(this, o);
  }, () => {
  });
}
function o0(e, t = 166) {
  let n;
  function r(...o) {
    const a = () => {
      e.apply(this, o);
    };
    clearTimeout(n), n = setTimeout(a, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function os(e, t) {
  var n, r, o;
  return /* @__PURE__ */ w.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? ((o = (r = (n = e.type) == null ? void 0 : n._payload) == null ? void 0 : r.value) == null ? void 0 : o.muiName)
  ) !== -1;
}
function er(e) {
  return e && e.ownerDocument || document;
}
function ci(e) {
  return er(e).defaultView || window;
}
function C_(e, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const n = t ? {
    ...t.propTypes
  } : null;
  return (o) => (a, l, c, d, p, ...f) => {
    const m = p || l, g = n == null ? void 0 : n[m];
    if (g) {
      const y = g(a, l, c, d, p, ...f);
      if (y)
        return y;
    }
    return typeof a[l] < "u" && !a[o] ? new Error(`The prop \`${m}\` of \`${e}\` can only be used together with the \`${o}\` prop.`) : null;
  };
}
function Wu(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let E1 = 0;
function S_(e) {
  const [t, n] = w.useState(e), r = e || t;
  return w.useEffect(() => {
    t == null && (E1 += 1, n(`mui-${E1}`));
  }, [t]), r;
}
const T_ = {
  ...w
}, R1 = T_.useId;
function Mr(e) {
  if (R1 !== void 0) {
    const t = R1();
    return e ?? t;
  }
  return S_(e);
}
function O_(e, t, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const a = o || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${a}\` is not supported. Please remove it.`) : null;
}
function sr({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = w.useRef(e !== void 0), [a, l] = w.useState(t), c = o ? e : a;
  if (process.env.NODE_ENV !== "production") {
    w.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: p
    } = w.useRef(t);
    w.useEffect(() => {
      !o && !Object.is(p, t) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const d = w.useCallback((p) => {
    o || l(p);
  }, []);
  return [c, d];
}
function ze(e) {
  const t = w.useRef(e);
  return Nn(() => {
    t.current = e;
  }), w.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function It(...e) {
  return w.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      Wu(n, t);
    });
  }, e);
}
const k1 = {};
function n3(e, t) {
  const n = w.useRef(k1);
  return n.current === k1 && (n.current = e(t)), n;
}
const P_ = [];
function E_(e) {
  w.useEffect(e, P_);
}
class Md {
  constructor() {
    qe(this, "currentId", null);
    qe(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    qe(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new Md();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function Ja() {
  const e = n3(Md.create).current;
  return E_(e.disposeEffect), e;
}
function qu(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
function r3(e = window) {
  const t = e.document.documentElement.clientWidth;
  return e.innerWidth - t;
}
const R_ = (e) => {
  const t = w.useRef({});
  return w.useEffect(() => {
    t.current = e;
  }), t.current;
}, k_ = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function __(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function o3(e, t, n, r) {
  const o = e[t];
  if (o == null || !Number.isInteger(o)) {
    const a = __(o);
    return new RangeError(`Invalid ${r} \`${t}\` of type \`${a}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function i3(e, t, ...n) {
  return e[t] === void 0 ? null : o3(e, t, ...n);
}
function dg() {
  return null;
}
i3.isRequired = o3;
dg.isRequired = dg;
const i0 = process.env.NODE_ENV === "production" ? dg : i3;
function Be(e, t, n = void 0) {
  const r = {};
  for (const o in e) {
    const a = e[o];
    let l = "", c = !0;
    for (let d = 0; d < a.length; d += 1) {
      const p = a[d];
      p && (l += (c === !0 ? "" : " ") + t(p), c = !1, n && n[p] && (l += " " + n[p]));
    }
    r[o] = l;
  }
  return r;
}
function D_(e) {
  return typeof e == "string";
}
function a3(e, t, n) {
  return e === void 0 || D_(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function s3(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function _1(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function l3(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: o,
    className: a
  } = e;
  if (!t) {
    const y = _e(n == null ? void 0 : n.className, a, o == null ? void 0 : o.className, r == null ? void 0 : r.className), b = {
      ...n == null ? void 0 : n.style,
      ...o == null ? void 0 : o.style,
      ...r == null ? void 0 : r.style
    }, v = {
      ...n,
      ...o,
      ...r
    };
    return y.length > 0 && (v.className = y), Object.keys(b).length > 0 && (v.style = b), {
      props: v,
      internalRef: void 0
    };
  }
  const l = s3({
    ...o,
    ...r
  }), c = _1(r), d = _1(o), p = t(l), f = _e(p == null ? void 0 : p.className, n == null ? void 0 : n.className, a, o == null ? void 0 : o.className, r == null ? void 0 : r.className), m = {
    ...p == null ? void 0 : p.style,
    ...n == null ? void 0 : n.style,
    ...o == null ? void 0 : o.style,
    ...r == null ? void 0 : r.style
  }, g = {
    ...p,
    ...n,
    ...d,
    ...c
  };
  return f.length > 0 && (g.className = f), Object.keys(m).length > 0 && (g.style = m), {
    props: g,
    internalRef: p.ref
  };
}
function Ad(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function Lt(e) {
  var m;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: r,
    skipResolvingSlotProps: o = !1,
    ...a
  } = e, l = o ? {} : Ad(n, r), {
    props: c,
    internalRef: d
  } = l3({
    ...a,
    externalSlotProps: l
  }), p = It(d, l == null ? void 0 : l.ref, (m = e.additionalProps) == null ? void 0 : m.ref);
  return a3(t, {
    ...c,
    ref: p
  }, r);
}
function Os(e) {
  var t;
  return parseInt(w.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
const a0 = /* @__PURE__ */ w.createContext(null);
process.env.NODE_ENV !== "production" && (a0.displayName = "ThemeContext");
function s0() {
  const e = w.useContext(a0);
  return process.env.NODE_ENV !== "production" && w.useDebugValue(e), e;
}
const I_ = typeof Symbol == "function" && Symbol.for, M_ = I_ ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function A_(e, t) {
  if (typeof t == "function") {
    const n = t(e);
    return process.env.NODE_ENV !== "production" && (n || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), n;
  }
  return {
    ...e,
    ...t
  };
}
function Uu(e) {
  const {
    children: t,
    theme: n
  } = e, r = s0();
  process.env.NODE_ENV !== "production" && r === null && typeof n == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const o = w.useMemo(() => {
    const a = r === null ? {
      ...n
    } : A_(r, n);
    return a != null && (a[M_] = r !== null), a;
  }, [n, r]);
  return /* @__PURE__ */ x.jsx(a0.Provider, {
    value: o,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (Uu.propTypes = {
  /**
   * Your component tree.
   */
  children: i.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: i.oneOfType([i.object, i.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Uu.propTypes = Id(Uu.propTypes));
const c3 = /* @__PURE__ */ w.createContext();
function u3({
  value: e,
  ...t
}) {
  return /* @__PURE__ */ x.jsx(c3.Provider, {
    value: e ?? !0,
    ...t
  });
}
process.env.NODE_ENV !== "production" && (u3.propTypes = {
  children: i.node,
  value: i.bool
});
const no = () => w.useContext(c3) ?? !1, d3 = /* @__PURE__ */ w.createContext(void 0);
function p3({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ x.jsx(d3.Provider, {
    value: e,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (p3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: i.node,
  /**
   * @ignore
   */
  value: i.object
});
function N_(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  if (!t || !t.components || !t.components[n])
    return r;
  const o = t.components[n];
  return o.defaultProps ? _l(o.defaultProps, r) : !o.styleOverrides && !o.variants ? _l(o, r) : r;
}
function j_({
  props: e,
  name: t
}) {
  const n = w.useContext(d3);
  return N_({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const D1 = {};
function I1(e, t, n, r = !1) {
  return w.useMemo(() => {
    const o = e && t[e] || t;
    if (typeof n == "function") {
      const a = n(o), l = e ? {
        ...t,
        [e]: a
      } : a;
      return r ? () => l : l;
    }
    return e ? {
      ...t,
      [e]: n
    } : {
      ...t,
      ...n
    };
  }, [e, t, n, r]);
}
function Dl(e) {
  const {
    children: t,
    theme: n,
    themeId: r
  } = e, o = t0(D1), a = s0() || D1;
  process.env.NODE_ENV !== "production" && (o === null && typeof n == "function" || r && o && !o[r] && typeof n == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const l = I1(r, o, n), c = I1(r, a, n, !0), d = (r ? l[r] : l).direction === "rtl";
  return /* @__PURE__ */ x.jsx(Uu, {
    theme: c,
    children: /* @__PURE__ */ x.jsx(Kl.Provider, {
      value: l,
      children: /* @__PURE__ */ x.jsx(u3, {
        value: d,
        children: /* @__PURE__ */ x.jsx(p3, {
          value: r ? l[r].components : l.components,
          children: t
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (Dl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: i.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: i.oneOfType([i.func, i.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: i.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Dl.propTypes = Id(Dl.propTypes));
const M1 = {
  theme: void 0
};
function F_(e) {
  let t, n;
  return function(o) {
    let a = t;
    return (a === void 0 || o.theme !== n) && (M1.theme = o.theme, a = HC(e(M1)), t = a, n = o.theme), a;
  };
}
const l0 = "mode", c0 = "color-scheme", L_ = "data-color-scheme";
function B_(e) {
  const {
    defaultMode: t = "system",
    defaultLightColorScheme: n = "light",
    defaultDarkColorScheme: r = "dark",
    modeStorageKey: o = l0,
    colorSchemeStorageKey: a = c0,
    attribute: l = L_,
    colorSchemeNode: c = "document.documentElement",
    nonce: d
  } = e || {};
  let p = "", f = l;
  if (l === "class" && (f = ".%s"), l === "data" && (f = "[data-%s]"), f.startsWith(".")) {
    const g = f.substring(1);
    p += `${c}.classList.remove('${g}'.replace('%s', light), '${g}'.replace('%s', dark));
      ${c}.classList.add('${g}'.replace('%s', colorScheme));`;
  }
  const m = f.match(/\[([^\]]+)\]/);
  if (m) {
    const [g, y] = m[1].split("=");
    y || (p += `${c}.removeAttribute('${g}'.replace('%s', light));
      ${c}.removeAttribute('${g}'.replace('%s', dark));`), p += `
      ${c}.setAttribute('${g}'.replace('%s', colorScheme), ${y ? `${y}.replace('%s', colorScheme)` : '""'});`;
  } else
    p += `${c}.setAttribute('${f}', colorScheme);`;
  return /* @__PURE__ */ x.jsx("script", {
    suppressHydrationWarning: !0,
    nonce: typeof window > "u" ? d : "",
    dangerouslySetInnerHTML: {
      __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${o}') || '${t}';
  const dark = localStorage.getItem('${a}-dark') || '${r}';
  const light = localStorage.getItem('${a}-light') || '${n}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${p}
  }
} catch(e){}})();`
    }
  }, "mui-color-scheme-init");
}
function A1(e) {
  if (typeof window < "u" && typeof window.matchMedia == "function" && e === "system")
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function f3(e, t) {
  if (e.mode === "light" || e.mode === "system" && e.systemMode === "light")
    return t("light");
  if (e.mode === "dark" || e.mode === "system" && e.systemMode === "dark")
    return t("dark");
}
function V_(e) {
  return f3(e, (t) => {
    if (t === "light")
      return e.lightColorScheme;
    if (t === "dark")
      return e.darkColorScheme;
  });
}
function Wf(e, t) {
  if (typeof window > "u")
    return;
  let n;
  try {
    n = localStorage.getItem(e) || void 0, n || localStorage.setItem(e, t);
  } catch {
  }
  return n || t;
}
function z_(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: n,
    defaultDarkColorScheme: r,
    supportedColorSchemes: o = [],
    modeStorageKey: a = l0,
    colorSchemeStorageKey: l = c0,
    storageWindow: c = typeof window > "u" ? void 0 : window,
    noSsr: d = !1
  } = e, p = o.join(","), f = o.length > 1, [m, g] = w.useState(() => {
    const T = Wf(a, t), O = Wf(`${l}-light`, n), k = Wf(`${l}-dark`, r);
    return {
      mode: T,
      systemMode: A1(T),
      lightColorScheme: O,
      darkColorScheme: k
    };
  }), [y, b] = w.useState(d || !f);
  w.useEffect(() => {
    b(!0);
  }, []);
  const v = V_(m), $ = w.useCallback((T) => {
    g((O) => {
      if (T === O.mode)
        return O;
      const k = T ?? t;
      try {
        localStorage.setItem(a, k);
      } catch {
      }
      return {
        ...O,
        mode: k,
        systemMode: A1(k)
      };
    });
  }, [a, t]), S = w.useCallback((T) => {
    T ? typeof T == "string" ? T && !p.includes(T) ? console.error(`\`${T}\` does not exist in \`theme.colorSchemes\`.`) : g((O) => {
      const k = {
        ...O
      };
      return f3(O, (I) => {
        try {
          localStorage.setItem(`${l}-${I}`, T);
        } catch {
        }
        I === "light" && (k.lightColorScheme = T), I === "dark" && (k.darkColorScheme = T);
      }), k;
    }) : g((O) => {
      const k = {
        ...O
      }, I = T.light === null ? n : T.light, D = T.dark === null ? r : T.dark;
      if (I)
        if (!p.includes(I))
          console.error(`\`${I}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          k.lightColorScheme = I;
          try {
            localStorage.setItem(`${l}-light`, I);
          } catch {
          }
        }
      if (D)
        if (!p.includes(D))
          console.error(`\`${D}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          k.darkColorScheme = D;
          try {
            localStorage.setItem(`${l}-dark`, D);
          } catch {
          }
        }
      return k;
    }) : g((O) => {
      try {
        localStorage.setItem(`${l}-light`, n), localStorage.setItem(`${l}-dark`, r);
      } catch {
      }
      return {
        ...O,
        lightColorScheme: n,
        darkColorScheme: r
      };
    });
  }, [p, l, n, r]), R = w.useCallback((T) => {
    m.mode === "system" && g((O) => {
      const k = T != null && T.matches ? "dark" : "light";
      return O.systemMode === k ? O : {
        ...O,
        systemMode: k
      };
    });
  }, [m.mode]), P = w.useRef(R);
  return P.current = R, w.useEffect(() => {
    if (typeof window.matchMedia != "function" || !f)
      return;
    const T = (...k) => P.current(...k), O = window.matchMedia("(prefers-color-scheme: dark)");
    return O.addListener(T), T(O), () => {
      O.removeListener(T);
    };
  }, [f]), w.useEffect(() => {
    if (c && f) {
      const T = (O) => {
        const k = O.newValue;
        typeof O.key == "string" && O.key.startsWith(l) && (!k || p.match(k)) && (O.key.endsWith("light") && S({
          light: k
        }), O.key.endsWith("dark") && S({
          dark: k
        })), O.key === a && (!k || ["light", "dark", "system"].includes(k)) && $(k || t);
      };
      return c.addEventListener("storage", T), () => {
        c.removeEventListener("storage", T);
      };
    }
  }, [S, $, a, l, p, t, c, f]), {
    ...m,
    mode: y ? m.mode : void 0,
    systemMode: y ? m.systemMode : void 0,
    colorScheme: y ? v : void 0,
    setMode: $,
    setColorScheme: S
  };
}
const W_ = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function q_(e) {
  const {
    themeId: t,
    /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */
    theme: n = {},
    modeStorageKey: r = l0,
    colorSchemeStorageKey: o = c0,
    disableTransitionOnChange: a = !1,
    defaultColorScheme: l,
    resolveTheme: c
  } = e, d = {
    allColorSchemes: [],
    colorScheme: void 0,
    darkColorScheme: void 0,
    lightColorScheme: void 0,
    mode: void 0,
    setColorScheme: () => {
    },
    setMode: () => {
    },
    systemMode: void 0
  }, p = /* @__PURE__ */ w.createContext(void 0);
  process.env.NODE_ENV !== "production" && (p.displayName = "ColorSchemeContext");
  const f = () => w.useContext(p) || d, m = {}, g = {};
  function y(S) {
    var kt, Ee, Ae, pt;
    const {
      children: R,
      theme: P,
      modeStorageKey: T = r,
      colorSchemeStorageKey: O = o,
      disableTransitionOnChange: k = a,
      storageWindow: I = typeof window > "u" ? void 0 : window,
      documentNode: D = typeof document > "u" ? void 0 : document,
      colorSchemeNode: j = typeof document > "u" ? void 0 : document.documentElement,
      disableNestedContext: E = !1,
      disableStyleSheetGeneration: M = !1,
      defaultMode: F = "system",
      noSsr: B
    } = S, V = w.useRef(!1), z = s0(), L = w.useContext(p), G = !!L && !E, se = w.useMemo(() => P || (typeof n == "function" ? n() : n), [P]), ne = se[t], K = ne || se, {
      colorSchemes: Q = m,
      components: ye = g,
      cssVarPrefix: we
    } = K, fe = Object.keys(Q).filter((Ue) => !!Q[Ue]).join(","), X = w.useMemo(() => fe.split(","), [fe]), re = typeof l == "string" ? l : l.light, ie = typeof l == "string" ? l : l.dark, Y = Q[re] && Q[ie] ? F : ((Ee = (kt = Q[K.defaultColorScheme]) == null ? void 0 : kt.palette) == null ? void 0 : Ee.mode) || ((Ae = K.palette) == null ? void 0 : Ae.mode), {
      mode: Z,
      setMode: ue,
      systemMode: ge,
      lightColorScheme: W,
      darkColorScheme: J,
      colorScheme: le,
      setColorScheme: me
    } = z_({
      supportedColorSchemes: X,
      defaultLightColorScheme: re,
      defaultDarkColorScheme: ie,
      modeStorageKey: T,
      colorSchemeStorageKey: O,
      defaultMode: Y,
      storageWindow: I,
      noSsr: B
    });
    let be = Z, de = le;
    G && (be = L.mode, de = L.colorScheme);
    const Oe = w.useMemo(() => {
      var rt;
      const Ue = de || K.defaultColorScheme, et = ((rt = K.generateThemeVars) == null ? void 0 : rt.call(K)) || K.vars, Je = {
        ...K,
        components: ye,
        colorSchemes: Q,
        cssVarPrefix: we,
        vars: et
      };
      if (typeof Je.generateSpacing == "function" && (Je.spacing = Je.generateSpacing()), Ue) {
        const je = Q[Ue];
        je && typeof je == "object" && Object.keys(je).forEach(($t) => {
          je[$t] && typeof je[$t] == "object" ? Je[$t] = {
            ...Je[$t],
            ...je[$t]
          } : Je[$t] = je[$t];
        });
      }
      return c ? c(Je) : Je;
    }, [K, de, ye, Q, we]), Re = K.colorSchemeSelector;
    Nn(() => {
      if (de && j && Re && Re !== "media") {
        const Ue = Re;
        let et = Re;
        if (Ue === "class" && (et = ".%s"), Ue === "data" && (et = "[data-%s]"), Ue != null && Ue.startsWith("data-") && !Ue.includes("%s") && (et = `[${Ue}="%s"]`), et.startsWith("."))
          j.classList.remove(...X.map((Je) => et.substring(1).replace("%s", Je))), j.classList.add(et.substring(1).replace("%s", de));
        else {
          const Je = et.replace("%s", de).match(/\[([^\]]+)\]/);
          if (Je) {
            const [rt, je] = Je[1].split("=");
            je || X.forEach(($t) => {
              j.removeAttribute(rt.replace(de, $t));
            }), j.setAttribute(rt, je ? je.replace(/"|'/g, "") : "");
          } else
            j.setAttribute(et, de);
        }
      }
    }, [de, Re, j, X]), w.useEffect(() => {
      let Ue;
      if (k && V.current && D) {
        const et = D.createElement("style");
        et.appendChild(D.createTextNode(W_)), D.head.appendChild(et), window.getComputedStyle(D.body), Ue = setTimeout(() => {
          D.head.removeChild(et);
        }, 1);
      }
      return () => {
        clearTimeout(Ue);
      };
    }, [de, k, D]), w.useEffect(() => (V.current = !0, () => {
      V.current = !1;
    }), []);
    const We = w.useMemo(() => ({
      allColorSchemes: X,
      colorScheme: de,
      darkColorScheme: J,
      lightColorScheme: W,
      mode: be,
      setColorScheme: me,
      setMode: process.env.NODE_ENV === "production" ? ue : (Ue) => {
        Oe.colorSchemeSelector === "media" && console.error(["MUI: The `setMode` function has no effect if `colorSchemeSelector` is `media` (`media` is the default value).", "To toggle the mode manually, please configure `colorSchemeSelector` to use a class or data attribute.", "To learn more, visit https://mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually"].join(`
`)), ue(Ue);
      },
      systemMode: ge
    }), [X, de, J, W, be, me, ue, ge, Oe.colorSchemeSelector]);
    let Ye = !0;
    (M || K.cssVariables === !1 || G && (z == null ? void 0 : z.cssVarPrefix) === we) && (Ye = !1);
    const Ie = /* @__PURE__ */ x.jsxs(w.Fragment, {
      children: [/* @__PURE__ */ x.jsx(Dl, {
        themeId: ne ? t : void 0,
        theme: Oe,
        children: R
      }), Ye && /* @__PURE__ */ x.jsx(Jg, {
        styles: ((pt = Oe.generateStyleSheets) == null ? void 0 : pt.call(Oe)) || []
      })]
    });
    return G ? Ie : /* @__PURE__ */ x.jsx(p.Provider, {
      value: We,
      children: Ie
    });
  }
  process.env.NODE_ENV !== "production" && (y.propTypes = {
    /**
     * The component tree.
     */
    children: i.node,
    /**
     * The node used to attach the color-scheme attribute
     */
    colorSchemeNode: i.any,
    /**
     * localStorage key used to store `colorScheme`
     */
    colorSchemeStorageKey: i.string,
    /**
     * The default mode when the storage is empty,
     * require the theme to have `colorSchemes` with light and dark.
     */
    defaultMode: i.string,
    /**
     * If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
     */
    disableNestedContext: i.bool,
    /**
     * If `true`, the style sheet won't be generated.
     *
     * This is useful for controlling nested CssVarsProvider behavior.
     */
    disableStyleSheetGeneration: i.bool,
    /**
     * Disable CSS transitions when switching between modes or color schemes.
     */
    disableTransitionOnChange: i.bool,
    /**
     * The document to attach the attribute to.
     */
    documentNode: i.any,
    /**
     * The key in the local storage used to store current color scheme.
     */
    modeStorageKey: i.string,
    /**
     * If `true`, the mode will be the same value as the storage without an extra rerendering after the hydration.
     * You should use this option in conjuction with `InitColorSchemeScript` component.
     */
    noSsr: i.bool,
    /**
     * The window that attaches the 'storage' event listener.
     * @default window
     */
    storageWindow: i.any,
    /**
     * The calculated theme object that will be passed through context.
     */
    theme: i.object
  });
  const b = typeof l == "string" ? l : l.light, v = typeof l == "string" ? l : l.dark;
  return {
    CssVarsProvider: y,
    useColorScheme: f,
    getInitColorSchemeScript: (S) => B_({
      colorSchemeStorageKey: o,
      defaultLightColorScheme: b,
      defaultDarkColorScheme: v,
      modeStorageKey: r,
      ...S
    })
  };
}
function U_(e = "") {
  function t(...r) {
    if (!r.length)
      return "";
    const o = r[0];
    return typeof o == "string" && !o.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${o}${t(...r.slice(1))})` : `, ${o}`;
  }
  return (r, ...o) => `var(--${e ? `${e}-` : ""}${r}${t(...o)})`;
}
const N1 = (e, t, n, r = []) => {
  let o = e;
  t.forEach((a, l) => {
    l === t.length - 1 ? Array.isArray(o) ? o[Number(a)] = n : o && typeof o == "object" && (o[a] = n) : o && typeof o == "object" && (o[a] || (o[a] = r.includes(a) ? [] : {}), o = o[a]);
  });
}, H_ = (e, t, n) => {
  function r(o, a = [], l = []) {
    Object.entries(o).forEach(([c, d]) => {
      (!n || n && !n([...a, c])) && d != null && (typeof d == "object" && Object.keys(d).length > 0 ? r(d, [...a, c], Array.isArray(d) ? [...l, c] : l) : t([...a, c], d, l));
    });
  }
  r(e);
}, G_ = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((r) => e.includes(r)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function qf(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = t || {}, o = {}, a = {}, l = {};
  return H_(
    e,
    (c, d, p) => {
      if ((typeof d == "string" || typeof d == "number") && (!r || !r(c, d))) {
        const f = `--${n ? `${n}-` : ""}${c.join("-")}`, m = G_(c, d);
        Object.assign(o, {
          [f]: m
        }), N1(a, c, `var(${f})`, p), N1(l, c, `var(${f}, ${m})`, p);
      }
    },
    (c) => c[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: o,
    vars: a,
    varsWithDefaults: l
  };
}
function Y_(e, t = {}) {
  const {
    getSelector: n = $,
    disableCssColorScheme: r,
    colorSchemeSelector: o
  } = t, {
    colorSchemes: a = {},
    components: l,
    defaultColorScheme: c = "light",
    ...d
  } = e, {
    vars: p,
    css: f,
    varsWithDefaults: m
  } = qf(d, t);
  let g = m;
  const y = {}, {
    [c]: b,
    ...v
  } = a;
  if (Object.entries(v || {}).forEach(([P, T]) => {
    const {
      vars: O,
      css: k,
      varsWithDefaults: I
    } = qf(T, t);
    g = Vn(g, I), y[P] = {
      css: k,
      vars: O
    };
  }), b) {
    const {
      css: P,
      vars: T,
      varsWithDefaults: O
    } = qf(b, t);
    g = Vn(g, O), y[c] = {
      css: P,
      vars: T
    };
  }
  function $(P, T) {
    var k, I;
    let O = o;
    if (o === "class" && (O = ".%s"), o === "data" && (O = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (O = `[${o}="%s"]`), P) {
      if (O === "media")
        return e.defaultColorScheme === P ? ":root" : {
          [`@media (prefers-color-scheme: ${((I = (k = a[P]) == null ? void 0 : k.palette) == null ? void 0 : I.mode) || P})`]: {
            ":root": T
          }
        };
      if (O)
        return e.defaultColorScheme === P ? `:root, ${O.replace("%s", String(P))}` : O.replace("%s", String(P));
    }
    return ":root";
  }
  return {
    vars: g,
    generateThemeVars: () => {
      let P = {
        ...p
      };
      return Object.entries(y).forEach(([, {
        vars: T
      }]) => {
        P = Vn(P, T);
      }), P;
    },
    generateStyleSheets: () => {
      var D, j;
      const P = [], T = e.defaultColorScheme || "light";
      function O(E, M) {
        Object.keys(M).length && P.push(typeof E == "string" ? {
          [E]: {
            ...M
          }
        } : E);
      }
      O(n(void 0, {
        ...f
      }), f);
      const {
        [T]: k,
        ...I
      } = y;
      if (k) {
        const {
          css: E
        } = k, M = (j = (D = a[T]) == null ? void 0 : D.palette) == null ? void 0 : j.mode, F = !r && M ? {
          colorScheme: M,
          ...E
        } : {
          ...E
        };
        O(n(T, {
          ...F
        }), F);
      }
      return Object.entries(I).forEach(([E, {
        css: M
      }]) => {
        var V, z;
        const F = (z = (V = a[E]) == null ? void 0 : V.palette) == null ? void 0 : z.mode, B = !r && F ? {
          colorScheme: F,
          ...M
        } : {
          ...M
        };
        O(n(E, {
          ...B
        }), B);
      }), P;
    }
  };
}
function K_(e) {
  return function(n) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && n !== "light" && n !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${n}'.`), `@media (prefers-color-scheme: ${n})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
const X_ = (e, t) => e.filter((n) => t.includes(n)), Ps = (e, t, n) => {
  const r = e.keys[0];
  Array.isArray(t) ? t.forEach((o, a) => {
    n((l, c) => {
      a <= e.keys.length - 1 && (a === 0 ? Object.assign(l, c) : l[e.up(e.keys[a])] = c);
    }, o);
  }) : t && typeof t == "object" ? (Object.keys(t).length > e.keys.length ? e.keys : X_(e.keys, Object.keys(t))).forEach((a) => {
    if (e.keys.includes(a)) {
      const l = t[a];
      l !== void 0 && n((c, d) => {
        r === a ? Object.assign(c, d) : c[e.up(a)] = d;
      }, l);
    }
  }) : (typeof t == "number" || typeof t == "string") && n((o, a) => {
    Object.assign(o, a);
  }, t);
};
function Hu(e) {
  return `--Grid-${e}Spacing`;
}
function Nd(e) {
  return `--Grid-parent-${e}Spacing`;
}
const j1 = "--Grid-columns", is = "--Grid-parent-columns", Z_ = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return Ps(e.breakpoints, t.size, (r, o) => {
    let a = {};
    o === "grow" && (a = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    }), o === "auto" && (a = {
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: "none",
      width: "auto"
    }), typeof o == "number" && (a = {
      flexGrow: 0,
      flexBasis: "auto",
      width: `calc(100% * ${o} / var(${is}) - (var(${is}) - ${o}) * (var(${Nd("column")}) / var(${is})))`
    }), r(n, a);
  }), n;
}, Q_ = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return Ps(e.breakpoints, t.offset, (r, o) => {
    let a = {};
    o === "auto" && (a = {
      marginLeft: "auto"
    }), typeof o == "number" && (a = {
      marginLeft: o === 0 ? "0px" : `calc(100% * ${o} / var(${is}) + var(${Nd("column")}) * ${o} / var(${is}))`
    }), r(n, a);
  }), n;
}, J_ = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {
    [j1]: 12
  };
  return Ps(e.breakpoints, t.columns, (r, o) => {
    const a = o ?? 12;
    r(n, {
      [j1]: a,
      "> *": {
        [is]: a
      }
    });
  }), n;
}, eD = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Ps(e.breakpoints, t.rowSpacing, (r, o) => {
    var l;
    const a = typeof o == "string" ? o : (l = e.spacing) == null ? void 0 : l.call(e, o);
    r(n, {
      [Hu("row")]: a,
      "> *": {
        [Nd("row")]: a
      }
    });
  }), n;
}, tD = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Ps(e.breakpoints, t.columnSpacing, (r, o) => {
    var l;
    const a = typeof o == "string" ? o : (l = e.spacing) == null ? void 0 : l.call(e, o);
    r(n, {
      [Hu("column")]: a,
      "> *": {
        [Nd("column")]: a
      }
    });
  }), n;
}, nD = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Ps(e.breakpoints, t.direction, (r, o) => {
    r(n, {
      flexDirection: o
    });
  }), n;
}, rD = ({
  ownerState: e
}) => ({
  minWidth: 0,
  boxSizing: "border-box",
  ...e.container && {
    display: "flex",
    flexWrap: "wrap",
    ...e.wrap && e.wrap !== "wrap" && {
      flexWrap: e.wrap
    },
    gap: `var(${Hu("row")}) var(${Hu("column")})`
  }
}), oD = (e) => {
  const t = [];
  return Object.entries(e).forEach(([n, r]) => {
    r !== !1 && r !== void 0 && t.push(`grid-${n}-${String(r)}`);
  }), t;
}, iD = (e, t = "xs") => {
  function n(r) {
    return r === void 0 ? !1 : typeof r == "string" && !Number.isNaN(Number(r)) || typeof r == "number" && r > 0;
  }
  if (n(e))
    return [`spacing-${t}-${String(e)}`];
  if (typeof e == "object" && !Array.isArray(e)) {
    const r = [];
    return Object.entries(e).forEach(([o, a]) => {
      n(a) && r.push(`spacing-${o}-${String(a)}`);
    }), r;
  }
  return [];
}, aD = (e) => e === void 0 ? [] : typeof e == "object" ? Object.entries(e).map(([t, n]) => `direction-${t}-${n}`) : [`direction-xs-${String(e)}`], sD = Jl(), lD = XC("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function cD(e) {
  return n0({
    props: e,
    name: "MuiGrid",
    defaultTheme: sD
  });
}
function uD(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = lD,
    useThemeProps: n = cD,
    useTheme: r = ec,
    componentName: o = "MuiGrid"
  } = e, a = (p, f) => {
    const {
      container: m,
      direction: g,
      spacing: y,
      wrap: b,
      size: v
    } = p, $ = {
      root: ["root", m && "container", b !== "wrap" && `wrap-xs-${String(b)}`, ...aD(g), ...oD(v), ...m ? iD(y, f.breakpoints.keys[0]) : []]
    };
    return Be($, (S) => Fe(o, S), {});
  };
  function l(p, f, m = () => !0) {
    const g = {};
    return p === null || (Array.isArray(p) ? p.forEach((y, b) => {
      y !== null && m(y) && f.keys[b] && (g[f.keys[b]] = y);
    }) : typeof p == "object" ? Object.keys(p).forEach((y) => {
      const b = p[y];
      b != null && m(b) && (g[y] = b);
    }) : g[f.keys[0]] = p), g;
  }
  const c = t(J_, tD, eD, Z_, nD, rD, Q_), d = /* @__PURE__ */ w.forwardRef(function(f, m) {
    const g = r(), y = n(f), b = kd(y), {
      className: v,
      children: $,
      columns: S = 12,
      container: R = !1,
      component: P = "div",
      direction: T = "row",
      wrap: O = "wrap",
      size: k = {},
      offset: I = {},
      spacing: D = 0,
      rowSpacing: j = D,
      columnSpacing: E = D,
      unstable_level: M = 0,
      ...F
    } = b, B = l(k, g.breakpoints, (Q) => Q !== !1), V = l(I, g.breakpoints), z = f.columns ?? (M ? void 0 : S), L = f.spacing ?? (M ? void 0 : D), G = f.rowSpacing ?? f.spacing ?? (M ? void 0 : j), se = f.columnSpacing ?? f.spacing ?? (M ? void 0 : E), ne = {
      ...b,
      level: M,
      columns: z,
      container: R,
      direction: T,
      wrap: O,
      spacing: L,
      rowSpacing: G,
      columnSpacing: se,
      size: B,
      offset: V
    }, K = a(ne, g);
    return /* @__PURE__ */ x.jsx(c, {
      ref: m,
      as: P,
      ownerState: ne,
      className: _e(K.root, v),
      ...F,
      children: w.Children.map($, (Q) => {
        var ye;
        return /* @__PURE__ */ w.isValidElement(Q) && os(Q, ["Grid"]) && R && Q.props.container ? /* @__PURE__ */ w.cloneElement(Q, {
          unstable_level: ((ye = Q.props) == null ? void 0 : ye.unstable_level) ?? M + 1
        }) : Q;
      })
    });
  });
  return process.env.NODE_ENV !== "production" && (d.propTypes = {
    children: i.node,
    className: i.string,
    columns: i.oneOfType([i.arrayOf(i.number), i.number, i.object]),
    columnSpacing: i.oneOfType([i.arrayOf(i.oneOfType([i.number, i.string])), i.number, i.object, i.string]),
    component: i.elementType,
    container: i.bool,
    direction: i.oneOfType([i.oneOf(["column-reverse", "column", "row-reverse", "row"]), i.arrayOf(i.oneOf(["column-reverse", "column", "row-reverse", "row"])), i.object]),
    offset: i.oneOfType([i.string, i.number, i.arrayOf(i.oneOfType([i.string, i.number])), i.object]),
    rowSpacing: i.oneOfType([i.arrayOf(i.oneOfType([i.number, i.string])), i.number, i.object, i.string]),
    size: i.oneOfType([i.string, i.bool, i.number, i.arrayOf(i.oneOfType([i.string, i.bool, i.number])), i.object]),
    spacing: i.oneOfType([i.arrayOf(i.oneOfType([i.number, i.string])), i.number, i.object, i.string]),
    sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
    wrap: i.oneOf(["nowrap", "wrap-reverse", "wrap"])
  }), d.muiName = "Grid", d;
}
const dD = Jl(), pD = XC("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function fD(e) {
  return n0({
    props: e,
    name: "MuiStack",
    defaultTheme: dD
  });
}
function hD(e, t) {
  const n = w.Children.toArray(e).filter(Boolean);
  return n.reduce((r, o, a) => (r.push(o), a < n.length - 1 && r.push(/* @__PURE__ */ w.cloneElement(t, {
    key: `separator-${a}`
  })), r), []);
}
const mD = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], gD = ({
  ownerState: e,
  theme: t
}) => {
  let n = {
    display: "flex",
    flexDirection: "column",
    ...go({
      theme: t
    }, zf({
      values: e.direction,
      breakpoints: t.breakpoints.values
    }), (r) => ({
      flexDirection: r
    }))
  };
  if (e.spacing) {
    const r = Sd(t), o = Object.keys(t.breakpoints.values).reduce((d, p) => ((typeof e.spacing == "object" && e.spacing[p] != null || typeof e.direction == "object" && e.direction[p] != null) && (d[p] = !0), d), {}), a = zf({
      values: e.direction,
      base: o
    }), l = zf({
      values: e.spacing,
      base: o
    });
    typeof a == "object" && Object.keys(a).forEach((d, p, f) => {
      if (!a[d]) {
        const g = p > 0 ? a[f[p - 1]] : "column";
        a[d] = g;
      }
    }), n = Vn(n, go({
      theme: t
    }, l, (d, p) => e.useFlexGap ? {
      gap: ba(r, d)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${mD(p ? a[p] : e.direction)}`]: ba(r, d)
      }
    }));
  }
  return n = c8(t.breakpoints, n), n;
};
function yD(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = pD,
    useThemeProps: n = fD,
    componentName: r = "MuiStack"
  } = e, o = () => Be({
    root: ["root"]
  }, (d) => Fe(r, d), {}), a = t(gD), l = /* @__PURE__ */ w.forwardRef(function(d, p) {
    const f = n(d), m = kd(f), {
      component: g = "div",
      direction: y = "column",
      spacing: b = 0,
      divider: v,
      children: $,
      className: S,
      useFlexGap: R = !1,
      ...P
    } = m, T = {
      direction: y,
      spacing: b,
      useFlexGap: R
    }, O = o();
    return /* @__PURE__ */ x.jsx(a, {
      as: g,
      ownerState: T,
      ref: p,
      className: _e(O.root, S),
      ...P,
      children: v ? hD($, v) : $
    });
  });
  return process.env.NODE_ENV !== "production" && (l.propTypes = {
    children: i.node,
    direction: i.oneOfType([i.oneOf(["column-reverse", "column", "row-reverse", "row"]), i.arrayOf(i.oneOf(["column-reverse", "column", "row-reverse", "row"])), i.object]),
    divider: i.node,
    spacing: i.oneOfType([i.arrayOf(i.oneOfType([i.number, i.string])), i.number, i.object, i.string]),
    sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
  }), l;
}
const Il = {
  black: "#000",
  white: "#fff"
}, jd = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Wa = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, ti = {
  50: "#ffebee",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, fa = {
  50: "#fff3e0",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, qa = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, Ua = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, ni = {
  50: "#e8f5e9",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function h3() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: Il.white,
      default: Il.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const vD = h3();
function m3() {
  return {
    text: {
      primary: Il.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: Il.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const F1 = m3();
function L1(e, t, n, r) {
  const o = r.light || r, a = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = ps(e.main, o) : t === "dark" && (e.dark = ds(e.main, a)));
}
function bD(e = "light") {
  return e === "dark" ? {
    main: qa[200],
    light: qa[50],
    dark: qa[400]
  } : {
    main: qa[700],
    light: qa[400],
    dark: qa[800]
  };
}
function xD(e = "light") {
  return e === "dark" ? {
    main: Wa[200],
    light: Wa[50],
    dark: Wa[400]
  } : {
    main: Wa[500],
    light: Wa[300],
    dark: Wa[700]
  };
}
function wD(e = "light") {
  return e === "dark" ? {
    main: ti[500],
    light: ti[300],
    dark: ti[700]
  } : {
    main: ti[700],
    light: ti[400],
    dark: ti[800]
  };
}
function $D(e = "light") {
  return e === "dark" ? {
    main: Ua[400],
    light: Ua[300],
    dark: Ua[700]
  } : {
    main: Ua[700],
    light: Ua[500],
    dark: Ua[900]
  };
}
function CD(e = "light") {
  return e === "dark" ? {
    main: ni[400],
    light: ni[300],
    dark: ni[700]
  } : {
    main: ni[800],
    light: ni[500],
    dark: ni[900]
  };
}
function SD(e = "light") {
  return e === "dark" ? {
    main: fa[400],
    light: fa[300],
    dark: fa[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: fa[500],
    dark: fa[900]
  };
}
function u0(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2,
    ...o
  } = e, a = e.primary || bD(t), l = e.secondary || xD(t), c = e.error || wD(t), d = e.info || $D(t), p = e.success || CD(t), f = e.warning || SD(t);
  function m(v) {
    const $ = P1(v, F1.text.primary) >= n ? F1.text.primary : vD.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const S = P1(v, $);
      S < 3 && console.error([`MUI: The contrast ratio of ${S}:1 for ${$} on ${v}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return $;
  }
  const g = ({
    color: v,
    name: $,
    mainShade: S = 500,
    lightShade: R = 300,
    darkShade: P = 700
  }) => {
    if (v = {
      ...v
    }, !v.main && v[S] && (v.main = v[S]), !v.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${$ ? ` (${$})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${S}\` property.` : No(11, $ ? ` (${$})` : "", S));
    if (typeof v.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${$ ? ` (${$})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(v.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : No(12, $ ? ` (${$})` : "", JSON.stringify(v.main)));
    return L1(v, "light", R, r), L1(v, "dark", P, r), v.contrastText || (v.contrastText = m(v.main)), v;
  };
  let y;
  return t === "light" ? y = h3() : t === "dark" && (y = m3()), process.env.NODE_ENV !== "production" && (y || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), Vn({
    // A collection of common colors.
    common: {
      ...Il
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: g({
      color: a,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: g({
      color: l,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: g({
      color: c,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: g({
      color: f,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: g({
      color: d,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: g({
      color: p,
      name: "success"
    }),
    // The grey colors.
    grey: jd,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: m,
    // Generate a rich color object.
    augmentColor: g,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r,
    // The light and dark mode object.
    ...y
  }, o);
}
function TD(e) {
  const t = {};
  return Object.entries(e).forEach((r) => {
    const [o, a] = r;
    typeof a == "object" && (t[o] = `${a.fontStyle ? `${a.fontStyle} ` : ""}${a.fontVariant ? `${a.fontVariant} ` : ""}${a.fontWeight ? `${a.fontWeight} ` : ""}${a.fontStretch ? `${a.fontStretch} ` : ""}${a.fontSize || ""}${a.lineHeight ? `/${a.lineHeight} ` : ""}${a.fontFamily || ""}`);
  }), t;
}
function OD(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function PD(e) {
  return Math.round(e * 1e5) / 1e5;
}
const B1 = {
  textTransform: "uppercase"
}, V1 = '"Roboto", "Helvetica", "Arial", sans-serif';
function g3(e, t) {
  const {
    fontFamily: n = V1,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: o = 300,
    fontWeightRegular: a = 400,
    fontWeightMedium: l = 500,
    fontWeightBold: c = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: d = 16,
    // Apply the CSS properties to all the variants.
    allVariants: p,
    pxToRem: f,
    ...m
  } = typeof t == "function" ? t(e) : t;
  process.env.NODE_ENV !== "production" && (typeof r != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof d != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const g = r / 14, y = f || (($) => `${$ / d * g}rem`), b = ($, S, R, P, T) => ({
    fontFamily: n,
    fontWeight: $,
    fontSize: y(S),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: R,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === V1 ? {
      letterSpacing: `${PD(P / S)}em`
    } : {},
    ...T,
    ...p
  }), v = {
    h1: b(o, 96, 1.167, -1.5),
    h2: b(o, 60, 1.2, -0.5),
    h3: b(a, 48, 1.167, 0),
    h4: b(a, 34, 1.235, 0.25),
    h5: b(a, 24, 1.334, 0),
    h6: b(l, 20, 1.6, 0.15),
    subtitle1: b(a, 16, 1.75, 0.15),
    subtitle2: b(l, 14, 1.57, 0.1),
    body1: b(a, 16, 1.5, 0.15),
    body2: b(a, 14, 1.43, 0.15),
    button: b(l, 14, 1.75, 0.4, B1),
    caption: b(a, 12, 1.66, 0.4),
    overline: b(a, 12, 2.66, 1, B1),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Vn({
    htmlFontSize: d,
    pxToRem: y,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: o,
    fontWeightRegular: a,
    fontWeightMedium: l,
    fontWeightBold: c,
    ...v
  }, m, {
    clone: !1
    // No need to clone deep
  });
}
const ED = 0.2, RD = 0.14, kD = 0.12;
function hn(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${ED})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${RD})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${kD})`].join(",");
}
const _D = ["none", hn(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), hn(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), hn(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), hn(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), hn(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), hn(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), hn(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), hn(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), hn(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), hn(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), hn(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), hn(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), hn(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), hn(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), hn(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), hn(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), hn(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), hn(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), hn(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), hn(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), hn(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), hn(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), hn(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), hn(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], DD = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, ID = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function z1(e) {
  return `${Math.round(e)}ms`;
}
function MD(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function AD(e) {
  const t = {
    ...DD,
    ...e.easing
  }, n = {
    ...ID,
    ...e.duration
  };
  return {
    getAutoHeightDuration: MD,
    create: (o = ["all"], a = {}) => {
      const {
        duration: l = n.standard,
        easing: c = t.easeInOut,
        delay: d = 0,
        ...p
      } = a;
      if (process.env.NODE_ENV !== "production") {
        const f = (g) => typeof g == "string", m = (g) => !Number.isNaN(parseFloat(g));
        !f(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !m(l) && !f(l) && console.error(`MUI: Argument "duration" must be a number or a string but found ${l}.`), f(c) || console.error('MUI: Argument "easing" must be a string.'), !m(d) && !f(d) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof a != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(p).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(p).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((f) => `${f} ${typeof l == "string" ? l : z1(l)} ${c} ${typeof d == "string" ? d : z1(d)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const ND = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function jD(e) {
  return ko(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function y3(e = {}) {
  const t = {
    ...e
  };
  function n(r) {
    const o = Object.entries(r);
    for (let a = 0; a < o.length; a++) {
      const [l, c] = o[a];
      !jD(c) || l.startsWith("unstable_") ? delete r[l] : ko(c) && (r[l] = {
        ...c
      }, n(r[l]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function pg(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: r = {},
    spacing: o,
    palette: a = {},
    transitions: l = {},
    typography: c = {},
    shape: d,
    ...p
  } = e;
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : No(20));
  const f = u0(a), m = Jl(e);
  let g = Vn(m, {
    mixins: OD(m.breakpoints, r),
    palette: f,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: _D.slice(),
    typography: g3(f, c),
    transitions: AD(l),
    zIndex: {
      ...ND
    }
  });
  if (g = Vn(g, p), g = t.reduce((y, b) => Vn(y, b), g), process.env.NODE_ENV !== "production") {
    const y = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], b = (v, $) => {
      let S;
      for (S in v) {
        const R = v[S];
        if (y.includes(S) && Object.keys(R).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const P = Fe("", S);
            console.error([`MUI: The \`${$}\` component increases the CSS specificity of the \`${S}\` internal state.`, "You can not override it like this: ", JSON.stringify(v, null, 2), "", `Instead, you need to use the '&.${P}' syntax:`, JSON.stringify({
              root: {
                [`&.${P}`]: R
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          v[S] = {};
        }
      }
    };
    Object.keys(g.components).forEach((v) => {
      const $ = g.components[v].styleOverrides;
      $ && v.startsWith("Mui") && b($, v);
    });
  }
  return g.unstable_sxConfig = {
    ...Ql,
    ...p == null ? void 0 : p.unstable_sxConfig
  }, g.unstable_sx = function(b) {
    return Li({
      sx: b,
      theme: this
    });
  }, g.toRuntimeSource = y3, g;
}
function fg(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const FD = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = fg(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function v3(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function b3(e) {
  return e === "dark" ? FD : [];
}
function LD(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: r,
    ...o
  } = e, a = u0(t);
  return {
    palette: a,
    opacity: {
      ...v3(a.mode),
      ...n
    },
    overlays: r || b3(a.mode),
    ...o
  };
}
function BD(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const VD = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], zD = (e) => (t, n) => {
  const r = e.rootSelector || ":root", o = e.colorSchemeSelector;
  let a = o;
  if (o === "class" && (a = ".%s"), o === "data" && (a = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (a = `[${o}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const l = {};
      return VD(e.cssVarPrefix).forEach((c) => {
        l[c] = n[c], delete n[c];
      }), a === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: l
        }
      } : a ? {
        [a.replace("%s", t)]: l,
        [`${r}, ${a.replace("%s", t)}`]: n
      } : {
        [r]: {
          ...n,
          ...l
        }
      };
    }
    if (a && a !== "media")
      return `${r}, ${a.replace("%s", String(t))}`;
  } else if (t) {
    if (a === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [r]: n
        }
      };
    if (a)
      return a.replace("%s", String(t));
  }
  return r;
};
function WD(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function ve(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function hl(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : e3(e);
}
function Qo(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = fl(hl(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function qD(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const So = (e) => {
  try {
    return e();
  } catch {
  }
}, UD = (e = "mui") => U_(e);
function Uf(e, t, n, r) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const o = r === "dark" ? "dark" : "light";
  if (!n) {
    e[r] = LD({
      ...t,
      palette: {
        mode: o,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: a,
    ...l
  } = pg({
    ...n,
    palette: {
      mode: o,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[r] = {
    ...t,
    palette: a,
    opacity: {
      ...v3(o),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || b3(o)
  }, l;
}
function HD(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: o = !1,
    cssVarPrefix: a = "mui",
    shouldSkipGeneratingVar: l = BD,
    colorSchemeSelector: c = n.light && n.dark ? "media" : void 0,
    rootSelector: d = ":root",
    ...p
  } = e, f = Object.keys(n)[0], m = r || (n.light && f !== "light" ? "light" : f), g = UD(a), {
    [m]: y,
    light: b,
    dark: v,
    ...$
  } = n, S = {
    ...$
  };
  let R = y;
  if ((m === "dark" && !("dark" in n) || m === "light" && !("light" in n)) && (R = !0), !R)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${m}\` option is either missing or invalid.` : No(21, m));
  const P = Uf(S, R, p, m);
  b && !S.light && Uf(S, b, void 0, "light"), v && !S.dark && Uf(S, v, void 0, "dark");
  let T = {
    defaultColorScheme: m,
    ...P,
    cssVarPrefix: a,
    colorSchemeSelector: c,
    rootSelector: d,
    getCssVar: g,
    colorSchemes: S,
    font: {
      ...TD(P.typography),
      ...P.font
    },
    spacing: qD(p.spacing)
  };
  Object.keys(T.colorSchemes).forEach((j) => {
    const E = T.colorSchemes[j].palette, M = (F) => {
      const B = F.split("-"), V = B[1], z = B[2];
      return g(F, E[V][z]);
    };
    if (E.mode === "light" && (ve(E.common, "background", "#fff"), ve(E.common, "onBackground", "#000")), E.mode === "dark" && (ve(E.common, "background", "#000"), ve(E.common, "onBackground", "#fff")), WD(E, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), E.mode === "light") {
      ve(E.Alert, "errorColor", an(E.error.light, 0.6)), ve(E.Alert, "infoColor", an(E.info.light, 0.6)), ve(E.Alert, "successColor", an(E.success.light, 0.6)), ve(E.Alert, "warningColor", an(E.warning.light, 0.6)), ve(E.Alert, "errorFilledBg", M("palette-error-main")), ve(E.Alert, "infoFilledBg", M("palette-info-main")), ve(E.Alert, "successFilledBg", M("palette-success-main")), ve(E.Alert, "warningFilledBg", M("palette-warning-main")), ve(E.Alert, "errorFilledColor", So(() => E.getContrastText(E.error.main))), ve(E.Alert, "infoFilledColor", So(() => E.getContrastText(E.info.main))), ve(E.Alert, "successFilledColor", So(() => E.getContrastText(E.success.main))), ve(E.Alert, "warningFilledColor", So(() => E.getContrastText(E.warning.main))), ve(E.Alert, "errorStandardBg", sn(E.error.light, 0.9)), ve(E.Alert, "infoStandardBg", sn(E.info.light, 0.9)), ve(E.Alert, "successStandardBg", sn(E.success.light, 0.9)), ve(E.Alert, "warningStandardBg", sn(E.warning.light, 0.9)), ve(E.Alert, "errorIconColor", M("palette-error-main")), ve(E.Alert, "infoIconColor", M("palette-info-main")), ve(E.Alert, "successIconColor", M("palette-success-main")), ve(E.Alert, "warningIconColor", M("palette-warning-main")), ve(E.AppBar, "defaultBg", M("palette-grey-100")), ve(E.Avatar, "defaultBg", M("palette-grey-400")), ve(E.Button, "inheritContainedBg", M("palette-grey-300")), ve(E.Button, "inheritContainedHoverBg", M("palette-grey-A100")), ve(E.Chip, "defaultBorder", M("palette-grey-400")), ve(E.Chip, "defaultAvatarColor", M("palette-grey-700")), ve(E.Chip, "defaultIconColor", M("palette-grey-700")), ve(E.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), ve(E.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), ve(E.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), ve(E.LinearProgress, "primaryBg", sn(E.primary.main, 0.62)), ve(E.LinearProgress, "secondaryBg", sn(E.secondary.main, 0.62)), ve(E.LinearProgress, "errorBg", sn(E.error.main, 0.62)), ve(E.LinearProgress, "infoBg", sn(E.info.main, 0.62)), ve(E.LinearProgress, "successBg", sn(E.success.main, 0.62)), ve(E.LinearProgress, "warningBg", sn(E.warning.main, 0.62)), ve(E.Skeleton, "bg", `rgba(${M("palette-text-primaryChannel")} / 0.11)`), ve(E.Slider, "primaryTrack", sn(E.primary.main, 0.62)), ve(E.Slider, "secondaryTrack", sn(E.secondary.main, 0.62)), ve(E.Slider, "errorTrack", sn(E.error.main, 0.62)), ve(E.Slider, "infoTrack", sn(E.info.main, 0.62)), ve(E.Slider, "successTrack", sn(E.success.main, 0.62)), ve(E.Slider, "warningTrack", sn(E.warning.main, 0.62));
      const F = du(E.background.default, 0.8);
      ve(E.SnackbarContent, "bg", F), ve(E.SnackbarContent, "color", So(() => E.getContrastText(F))), ve(E.SpeedDialAction, "fabHoverBg", du(E.background.paper, 0.15)), ve(E.StepConnector, "border", M("palette-grey-400")), ve(E.StepContent, "border", M("palette-grey-400")), ve(E.Switch, "defaultColor", M("palette-common-white")), ve(E.Switch, "defaultDisabledColor", M("palette-grey-100")), ve(E.Switch, "primaryDisabledColor", sn(E.primary.main, 0.62)), ve(E.Switch, "secondaryDisabledColor", sn(E.secondary.main, 0.62)), ve(E.Switch, "errorDisabledColor", sn(E.error.main, 0.62)), ve(E.Switch, "infoDisabledColor", sn(E.info.main, 0.62)), ve(E.Switch, "successDisabledColor", sn(E.success.main, 0.62)), ve(E.Switch, "warningDisabledColor", sn(E.warning.main, 0.62)), ve(E.TableCell, "border", sn(uu(E.divider, 1), 0.88)), ve(E.Tooltip, "bg", uu(E.grey[700], 0.92));
    }
    if (E.mode === "dark") {
      ve(E.Alert, "errorColor", sn(E.error.light, 0.6)), ve(E.Alert, "infoColor", sn(E.info.light, 0.6)), ve(E.Alert, "successColor", sn(E.success.light, 0.6)), ve(E.Alert, "warningColor", sn(E.warning.light, 0.6)), ve(E.Alert, "errorFilledBg", M("palette-error-dark")), ve(E.Alert, "infoFilledBg", M("palette-info-dark")), ve(E.Alert, "successFilledBg", M("palette-success-dark")), ve(E.Alert, "warningFilledBg", M("palette-warning-dark")), ve(E.Alert, "errorFilledColor", So(() => E.getContrastText(E.error.dark))), ve(E.Alert, "infoFilledColor", So(() => E.getContrastText(E.info.dark))), ve(E.Alert, "successFilledColor", So(() => E.getContrastText(E.success.dark))), ve(E.Alert, "warningFilledColor", So(() => E.getContrastText(E.warning.dark))), ve(E.Alert, "errorStandardBg", an(E.error.light, 0.9)), ve(E.Alert, "infoStandardBg", an(E.info.light, 0.9)), ve(E.Alert, "successStandardBg", an(E.success.light, 0.9)), ve(E.Alert, "warningStandardBg", an(E.warning.light, 0.9)), ve(E.Alert, "errorIconColor", M("palette-error-main")), ve(E.Alert, "infoIconColor", M("palette-info-main")), ve(E.Alert, "successIconColor", M("palette-success-main")), ve(E.Alert, "warningIconColor", M("palette-warning-main")), ve(E.AppBar, "defaultBg", M("palette-grey-900")), ve(E.AppBar, "darkBg", M("palette-background-paper")), ve(E.AppBar, "darkColor", M("palette-text-primary")), ve(E.Avatar, "defaultBg", M("palette-grey-600")), ve(E.Button, "inheritContainedBg", M("palette-grey-800")), ve(E.Button, "inheritContainedHoverBg", M("palette-grey-700")), ve(E.Chip, "defaultBorder", M("palette-grey-700")), ve(E.Chip, "defaultAvatarColor", M("palette-grey-300")), ve(E.Chip, "defaultIconColor", M("palette-grey-300")), ve(E.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), ve(E.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), ve(E.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), ve(E.LinearProgress, "primaryBg", an(E.primary.main, 0.5)), ve(E.LinearProgress, "secondaryBg", an(E.secondary.main, 0.5)), ve(E.LinearProgress, "errorBg", an(E.error.main, 0.5)), ve(E.LinearProgress, "infoBg", an(E.info.main, 0.5)), ve(E.LinearProgress, "successBg", an(E.success.main, 0.5)), ve(E.LinearProgress, "warningBg", an(E.warning.main, 0.5)), ve(E.Skeleton, "bg", `rgba(${M("palette-text-primaryChannel")} / 0.13)`), ve(E.Slider, "primaryTrack", an(E.primary.main, 0.5)), ve(E.Slider, "secondaryTrack", an(E.secondary.main, 0.5)), ve(E.Slider, "errorTrack", an(E.error.main, 0.5)), ve(E.Slider, "infoTrack", an(E.info.main, 0.5)), ve(E.Slider, "successTrack", an(E.success.main, 0.5)), ve(E.Slider, "warningTrack", an(E.warning.main, 0.5));
      const F = du(E.background.default, 0.98);
      ve(E.SnackbarContent, "bg", F), ve(E.SnackbarContent, "color", So(() => E.getContrastText(F))), ve(E.SpeedDialAction, "fabHoverBg", du(E.background.paper, 0.15)), ve(E.StepConnector, "border", M("palette-grey-600")), ve(E.StepContent, "border", M("palette-grey-600")), ve(E.Switch, "defaultColor", M("palette-grey-300")), ve(E.Switch, "defaultDisabledColor", M("palette-grey-600")), ve(E.Switch, "primaryDisabledColor", an(E.primary.main, 0.55)), ve(E.Switch, "secondaryDisabledColor", an(E.secondary.main, 0.55)), ve(E.Switch, "errorDisabledColor", an(E.error.main, 0.55)), ve(E.Switch, "infoDisabledColor", an(E.info.main, 0.55)), ve(E.Switch, "successDisabledColor", an(E.success.main, 0.55)), ve(E.Switch, "warningDisabledColor", an(E.warning.main, 0.55)), ve(E.TableCell, "border", an(uu(E.divider, 1), 0.68)), ve(E.Tooltip, "bg", uu(E.grey[700], 0.92));
    }
    Qo(E.background, "default"), Qo(E.background, "paper"), Qo(E.common, "background"), Qo(E.common, "onBackground"), Qo(E, "divider"), Object.keys(E).forEach((F) => {
      const B = E[F];
      F !== "tonalOffset" && B && typeof B == "object" && (B.main && ve(E[F], "mainChannel", fl(hl(B.main))), B.light && ve(E[F], "lightChannel", fl(hl(B.light))), B.dark && ve(E[F], "darkChannel", fl(hl(B.dark))), B.contrastText && ve(E[F], "contrastTextChannel", fl(hl(B.contrastText))), F === "text" && (Qo(E[F], "primary"), Qo(E[F], "secondary")), F === "action" && (B.active && Qo(E[F], "active"), B.selected && Qo(E[F], "selected")));
    });
  }), T = t.reduce((j, E) => Vn(j, E), T);
  const O = {
    prefix: a,
    disableCssColorScheme: o,
    shouldSkipGeneratingVar: l,
    getSelector: zD(T)
  }, {
    vars: k,
    generateThemeVars: I,
    generateStyleSheets: D
  } = Y_(T, O);
  return T.vars = k, Object.entries(T.colorSchemes[T.defaultColorScheme]).forEach(([j, E]) => {
    T[j] = E;
  }), T.generateThemeVars = I, T.generateStyleSheets = D, T.generateSpacing = function() {
    return VC(p.spacing, Sd(this));
  }, T.getColorSchemeSelector = K_(c), T.spacing = T.generateSpacing(), T.shouldSkipGeneratingVar = l, T.unstable_sxConfig = {
    ...Ql,
    ...p == null ? void 0 : p.unstable_sxConfig
  }, T.unstable_sx = function(E) {
    return Li({
      sx: E,
      theme: this
    });
  }, T.toRuntimeSource = y3, T;
}
function W1(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: u0({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function tc(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: o = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: a = n == null ? void 0 : n.mode,
    ...l
  } = e, c = a || "light", d = o == null ? void 0 : o[c], p = {
    ...o,
    ...n ? {
      [c]: {
        ...typeof d != "boolean" && d,
        palette: n
      }
    } : void 0
  };
  if (r === !1) {
    if (!("colorSchemes" in e))
      return pg(e, ...t);
    let f = n;
    "palette" in e || p[c] && (p[c] !== !0 ? f = p[c].palette : c === "dark" && (f = {
      mode: "dark"
    }));
    const m = pg({
      ...e,
      palette: f
    }, ...t);
    return m.defaultColorScheme = c, m.colorSchemes = p, m.palette.mode === "light" && (m.colorSchemes.light = {
      ...p.light !== !0 && p.light,
      palette: m.palette
    }, W1(m, "dark", p.dark)), m.palette.mode === "dark" && (m.colorSchemes.dark = {
      ...p.dark !== !0 && p.dark,
      palette: m.palette
    }, W1(m, "light", p.light)), m;
  }
  return !n && !("light" in p) && c === "light" && (p.light = !0), HD({
    ...l,
    colorSchemes: p,
    defaultColorScheme: c,
    ...typeof r != "boolean" && r
  }, ...t);
}
const Fd = tc();
function tr() {
  const e = ec(Fd);
  return process.env.NODE_ENV !== "production" && w.useDebugValue(e), e[Kr] || e;
}
function dn({
  props: e,
  name: t
}) {
  return n0({
    props: e,
    name: t,
    defaultTheme: Fd,
    themeId: Kr
  });
}
function x3(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const nr = (e) => x3(e) && e !== "classes", ae = YC({
  themeId: Kr,
  defaultTheme: Fd,
  rootShouldForwardProp: nr
});
function q1({
  theme: e,
  ...t
}) {
  const n = Kr in e ? e[Kr] : void 0;
  return /* @__PURE__ */ x.jsx(Dl, {
    ...t,
    themeId: n ? Kr : void 0,
    theme: n || e
  });
}
const pu = {
  colorSchemeStorageKey: "mui-color-scheme",
  defaultLightColorScheme: "light",
  defaultDarkColorScheme: "dark",
  modeStorageKey: "mui-mode"
}, {
  CssVarsProvider: GD
} = q_({
  themeId: Kr,
  // @ts-ignore ignore module augmentation tests
  theme: () => tc({
    cssVariables: !0
  }),
  colorSchemeStorageKey: pu.colorSchemeStorageKey,
  modeStorageKey: pu.modeStorageKey,
  defaultColorScheme: {
    light: pu.defaultLightColorScheme,
    dark: pu.defaultDarkColorScheme
  },
  resolveTheme: (e) => {
    const t = {
      ...e,
      typography: g3(e.palette, e.typography)
    };
    return t.unstable_sx = function(r) {
      return Li({
        sx: r,
        theme: this
      });
    }, t;
  }
}), YD = GD;
function w3({
  theme: e,
  ...t
}) {
  return typeof e == "function" ? /* @__PURE__ */ x.jsx(q1, {
    theme: e,
    ...t
  }) : "colorSchemes" in (Kr in e ? e[Kr] : e) ? /* @__PURE__ */ x.jsx(YD, {
    theme: e,
    ...t
  }) : /* @__PURE__ */ x.jsx(q1, {
    theme: e,
    ...t
  });
}
function $3(e) {
  return /* @__PURE__ */ x.jsx(zC, {
    ...e,
    defaultTheme: Fd,
    themeId: Kr
  });
}
process.env.NODE_ENV !== "production" && ($3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: i.oneOfType([i.array, i.func, i.number, i.object, i.string, i.bool])
});
function KD(e) {
  return function(n) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ x.jsx($3, {
        styles: typeof e == "function" ? (r) => e({
          theme: r,
          ...n
        }) : e
      })
    );
  };
}
function XD() {
  return kd;
}
const dt = F_;
process.env.NODE_ENV !== "production" && (i.node, i.object.isRequired);
function lt(e) {
  return j_(e);
}
function ZD(e) {
  return Fe("MuiSvgIcon", e);
}
Le("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const QD = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, o = {
    root: ["root", t !== "inherit" && `color${Pe(t)}`, `fontSize${Pe(n)}`]
  };
  return Be(o, ZD, r);
}, JD = ae("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${Pe(n.color)}`], t[`fontSize${Pe(n.fontSize)}`]];
  }
})(dt(({
  theme: e
}) => {
  var t, n, r, o, a, l, c, d, p, f, m, g, y, b;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (o = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : o.call(t, "fill", {
      duration: (r = (n = (e.vars ?? e).transitions) == null ? void 0 : n.duration) == null ? void 0 : r.shorter
    }),
    variants: [
      {
        props: (v) => !v.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((l = (a = e.typography) == null ? void 0 : a.pxToRem) == null ? void 0 : l.call(a, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((d = (c = e.typography) == null ? void 0 : c.pxToRem) == null ? void 0 : d.call(c, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((f = (p = e.typography) == null ? void 0 : p.pxToRem) == null ? void 0 : f.call(p, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, v]) => v && v.main).map(([v]) => {
        var $, S;
        return {
          props: {
            color: v
          },
          style: {
            color: (S = ($ = (e.vars ?? e).palette) == null ? void 0 : $[v]) == null ? void 0 : S.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (g = (m = (e.vars ?? e).palette) == null ? void 0 : m.action) == null ? void 0 : g.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (b = (y = (e.vars ?? e).palette) == null ? void 0 : y.action) == null ? void 0 : b.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), Gu = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: o,
    className: a,
    color: l = "inherit",
    component: c = "svg",
    fontSize: d = "medium",
    htmlColor: p,
    inheritViewBox: f = !1,
    titleAccess: m,
    viewBox: g = "0 0 24 24",
    ...y
  } = r, b = /* @__PURE__ */ w.isValidElement(o) && o.type === "svg", v = {
    ...r,
    color: l,
    component: c,
    fontSize: d,
    instanceFontSize: t.fontSize,
    inheritViewBox: f,
    viewBox: g,
    hasSvgAsChild: b
  }, $ = {};
  f || ($.viewBox = g);
  const S = QD(v);
  return /* @__PURE__ */ x.jsxs(JD, {
    as: c,
    className: _e(S.root, a),
    focusable: "false",
    color: p,
    "aria-hidden": m ? void 0 : !0,
    role: m ? "img" : void 0,
    ref: n,
    ...$,
    ...y,
    ...b && o.props,
    ownerState: v,
    children: [b ? o.props.children : o, m ? /* @__PURE__ */ x.jsx("title", {
      children: m
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (Gu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: i.oneOfType([i.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), i.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: i.oneOfType([i.oneOf(["inherit", "large", "medium", "small"]), i.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: i.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: i.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: i.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: i.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: i.string
});
Gu.muiName = "SvgIcon";
function jt(e, t) {
  function n(r, o) {
    return /* @__PURE__ */ x.jsx(Gu, {
      "data-testid": `${t}Icon`,
      ref: o,
      ...r,
      children: e
    });
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = Gu.muiName, /* @__PURE__ */ w.memo(/* @__PURE__ */ w.forwardRef(n));
}
function mt(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
function hg(e, t) {
  return hg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, hg(e, t);
}
function d0(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, hg(e, t);
}
function eI(e, t) {
  return e.classList ? !!t && e.classList.contains(t) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ") !== -1;
}
function tI(e, t) {
  e.classList ? e.classList.add(t) : eI(e, t) || (typeof e.className == "string" ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
}
function U1(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function nI(e, t) {
  e.classList ? e.classList.remove(t) : typeof e.className == "string" ? e.className = U1(e.className, t) : e.setAttribute("class", U1(e.className && e.className.baseVal || "", t));
}
const H1 = {
  disabled: !1
};
var rI = process.env.NODE_ENV !== "production" ? i.oneOfType([i.number, i.shape({
  enter: i.number,
  exit: i.number,
  appear: i.number
}).isRequired]) : null, oI = process.env.NODE_ENV !== "production" ? i.oneOfType([i.string, i.shape({
  enter: i.string,
  exit: i.string,
  active: i.string
}), i.shape({
  enter: i.string,
  enterDone: i.string,
  enterActive: i.string,
  exit: i.string,
  exitDone: i.string,
  exitActive: i.string
})]) : null;
const Yu = Ne.createContext(null);
var C3 = function(t) {
  return t.scrollTop;
}, ml = "unmounted", ca = "exited", ua = "entering", Qa = "entered", mg = "exiting", ro = /* @__PURE__ */ function(e) {
  d0(t, e);
  function t(r, o) {
    var a;
    a = e.call(this, r, o) || this;
    var l = o, c = l && !l.isMounting ? r.enter : r.appear, d;
    return a.appearStatus = null, r.in ? c ? (d = ca, a.appearStatus = ua) : d = Qa : r.unmountOnExit || r.mountOnEnter ? d = ml : d = ca, a.state = {
      status: d
    }, a.nextCallback = null, a;
  }
  t.getDerivedStateFromProps = function(o, a) {
    var l = o.in;
    return l && a.status === ml ? {
      status: ca
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(o) {
    var a = null;
    if (o !== this.props) {
      var l = this.state.status;
      this.props.in ? l !== ua && l !== Qa && (a = ua) : (l === ua || l === Qa) && (a = mg);
    }
    this.updateStatus(!1, a);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var o = this.props.timeout, a, l, c;
    return a = l = c = o, o != null && typeof o != "number" && (a = o.exit, l = o.enter, c = o.appear !== void 0 ? o.appear : l), {
      exit: a,
      enter: l,
      appear: c
    };
  }, n.updateStatus = function(o, a) {
    if (o === void 0 && (o = !1), a !== null)
      if (this.cancelNextCallback(), a === ua) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var l = this.props.nodeRef ? this.props.nodeRef.current : ru.findDOMNode(this);
          l && C3(l);
        }
        this.performEnter(o);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === ca && this.setState({
      status: ml
    });
  }, n.performEnter = function(o) {
    var a = this, l = this.props.enter, c = this.context ? this.context.isMounting : o, d = this.props.nodeRef ? [c] : [ru.findDOMNode(this), c], p = d[0], f = d[1], m = this.getTimeouts(), g = c ? m.appear : m.enter;
    if (!o && !l || H1.disabled) {
      this.safeSetState({
        status: Qa
      }, function() {
        a.props.onEntered(p);
      });
      return;
    }
    this.props.onEnter(p, f), this.safeSetState({
      status: ua
    }, function() {
      a.props.onEntering(p, f), a.onTransitionEnd(g, function() {
        a.safeSetState({
          status: Qa
        }, function() {
          a.props.onEntered(p, f);
        });
      });
    });
  }, n.performExit = function() {
    var o = this, a = this.props.exit, l = this.getTimeouts(), c = this.props.nodeRef ? void 0 : ru.findDOMNode(this);
    if (!a || H1.disabled) {
      this.safeSetState({
        status: ca
      }, function() {
        o.props.onExited(c);
      });
      return;
    }
    this.props.onExit(c), this.safeSetState({
      status: mg
    }, function() {
      o.props.onExiting(c), o.onTransitionEnd(l.exit, function() {
        o.safeSetState({
          status: ca
        }, function() {
          o.props.onExited(c);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(o, a) {
    a = this.setNextCallback(a), this.setState(o, a);
  }, n.setNextCallback = function(o) {
    var a = this, l = !0;
    return this.nextCallback = function(c) {
      l && (l = !1, a.nextCallback = null, o(c));
    }, this.nextCallback.cancel = function() {
      l = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(o, a) {
    this.setNextCallback(a);
    var l = this.props.nodeRef ? this.props.nodeRef.current : ru.findDOMNode(this), c = o == null && !this.props.addEndListener;
    if (!l || c) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var d = this.props.nodeRef ? [this.nextCallback] : [l, this.nextCallback], p = d[0], f = d[1];
      this.props.addEndListener(p, f);
    }
    o != null && setTimeout(this.nextCallback, o);
  }, n.render = function() {
    var o = this.state.status;
    if (o === ml)
      return null;
    var a = this.props, l = a.children;
    a.in, a.mountOnEnter, a.unmountOnExit, a.appear, a.enter, a.exit, a.timeout, a.addEndListener, a.onEnter, a.onEntering, a.onEntered, a.onExit, a.onExiting, a.onExited, a.nodeRef;
    var c = mt(a, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ Ne.createElement(Yu.Provider, {
        value: null
      }, typeof l == "function" ? l(o, c) : Ne.cloneElement(Ne.Children.only(l), c))
    );
  }, t;
}(Ne.Component);
ro.contextType = Yu;
ro.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: i.shape({
    current: typeof Element > "u" ? i.any : function(e, t, n, r, o, a) {
      var l = e[t];
      return i.instanceOf(l && "ownerDocument" in l ? l.ownerDocument.defaultView.Element : Element)(e, t, n, r, o, a);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: i.oneOfType([i.func.isRequired, i.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: i.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: i.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: i.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: i.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: i.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: i.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = rI;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      o[a - 1] = arguments[a];
    return n.apply(void 0, [t].concat(o));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: i.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: i.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: i.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: i.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: i.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: i.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: i.func
} : {};
function Ha() {
}
ro.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Ha,
  onEntering: Ha,
  onEntered: Ha,
  onExit: Ha,
  onExiting: Ha,
  onExited: Ha
};
ro.UNMOUNTED = ml;
ro.EXITED = ca;
ro.ENTERING = ua;
ro.ENTERED = Qa;
ro.EXITING = mg;
var iI = function(t, n) {
  return t && n && n.split(" ").forEach(function(r) {
    return tI(t, r);
  });
}, Hf = function(t, n) {
  return t && n && n.split(" ").forEach(function(r) {
    return nI(t, r);
  });
}, p0 = /* @__PURE__ */ function(e) {
  d0(t, e);
  function t() {
    for (var r, o = arguments.length, a = new Array(o), l = 0; l < o; l++)
      a[l] = arguments[l];
    return r = e.call.apply(e, [this].concat(a)) || this, r.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, r.onEnter = function(c, d) {
      var p = r.resolveArguments(c, d), f = p[0], m = p[1];
      r.removeClasses(f, "exit"), r.addClass(f, m ? "appear" : "enter", "base"), r.props.onEnter && r.props.onEnter(c, d);
    }, r.onEntering = function(c, d) {
      var p = r.resolveArguments(c, d), f = p[0], m = p[1], g = m ? "appear" : "enter";
      r.addClass(f, g, "active"), r.props.onEntering && r.props.onEntering(c, d);
    }, r.onEntered = function(c, d) {
      var p = r.resolveArguments(c, d), f = p[0], m = p[1], g = m ? "appear" : "enter";
      r.removeClasses(f, g), r.addClass(f, g, "done"), r.props.onEntered && r.props.onEntered(c, d);
    }, r.onExit = function(c) {
      var d = r.resolveArguments(c), p = d[0];
      r.removeClasses(p, "appear"), r.removeClasses(p, "enter"), r.addClass(p, "exit", "base"), r.props.onExit && r.props.onExit(c);
    }, r.onExiting = function(c) {
      var d = r.resolveArguments(c), p = d[0];
      r.addClass(p, "exit", "active"), r.props.onExiting && r.props.onExiting(c);
    }, r.onExited = function(c) {
      var d = r.resolveArguments(c), p = d[0];
      r.removeClasses(p, "exit"), r.addClass(p, "exit", "done"), r.props.onExited && r.props.onExited(c);
    }, r.resolveArguments = function(c, d) {
      return r.props.nodeRef ? [r.props.nodeRef.current, c] : [c, d];
    }, r.getClassNames = function(c) {
      var d = r.props.classNames, p = typeof d == "string", f = p && d ? d + "-" : "", m = p ? "" + f + c : d[c], g = p ? m + "-active" : d[c + "Active"], y = p ? m + "-done" : d[c + "Done"];
      return {
        baseClassName: m,
        activeClassName: g,
        doneClassName: y
      };
    }, r;
  }
  var n = t.prototype;
  return n.addClass = function(o, a, l) {
    var c = this.getClassNames(a)[l + "ClassName"], d = this.getClassNames("enter"), p = d.doneClassName;
    a === "appear" && l === "done" && p && (c += " " + p), l === "active" && o && C3(o), c && (this.appliedClasses[a][l] = c, iI(o, c));
  }, n.removeClasses = function(o, a) {
    var l = this.appliedClasses[a], c = l.base, d = l.active, p = l.done;
    this.appliedClasses[a] = {}, c && Hf(o, c), d && Hf(o, d), p && Hf(o, p);
  }, n.render = function() {
    var o = this.props;
    o.classNames;
    var a = mt(o, ["classNames"]);
    return /* @__PURE__ */ Ne.createElement(ro, ee({}, a, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, t;
}(Ne.Component);
p0.defaultProps = {
  classNames: ""
};
p0.propTypes = process.env.NODE_ENV !== "production" ? ee({}, ro.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: oI,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: i.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: i.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: i.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: i.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: i.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: i.func
}) : {};
function aI(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function f0(e, t) {
  var n = function(a) {
    return t && xl(a) ? t(a) : a;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && xC.map(e, function(o) {
    return o;
  }).forEach(function(o) {
    r[o.key] = n(o);
  }), r;
}
function sI(e, t) {
  e = e || {}, t = t || {};
  function n(f) {
    return f in t ? t[f] : e[f];
  }
  var r = /* @__PURE__ */ Object.create(null), o = [];
  for (var a in e)
    a in t ? o.length && (r[a] = o, o = []) : o.push(a);
  var l, c = {};
  for (var d in t) {
    if (r[d])
      for (l = 0; l < r[d].length; l++) {
        var p = r[d][l];
        c[r[d][l]] = n(p);
      }
    c[d] = n(d);
  }
  for (l = 0; l < o.length; l++)
    c[o[l]] = n(o[l]);
  return c;
}
function ma(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function lI(e, t) {
  return f0(e.children, function(n) {
    return Ou(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: ma(n, "appear", e),
      enter: ma(n, "enter", e),
      exit: ma(n, "exit", e)
    });
  });
}
function cI(e, t, n) {
  var r = f0(e.children), o = sI(t, r);
  return Object.keys(o).forEach(function(a) {
    var l = o[a];
    if (xl(l)) {
      var c = a in t, d = a in r, p = t[a], f = xl(p) && !p.props.in;
      d && (!c || f) ? o[a] = Ou(l, {
        onExited: n.bind(null, l),
        in: !0,
        exit: ma(l, "exit", e),
        enter: ma(l, "enter", e)
      }) : !d && c && !f ? o[a] = Ou(l, {
        in: !1
      }) : d && c && xl(p) && (o[a] = Ou(l, {
        onExited: n.bind(null, l),
        in: p.props.in,
        exit: ma(l, "exit", e),
        enter: ma(l, "enter", e)
      }));
    }
  }), o;
}
var uI = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, dI = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, nc = /* @__PURE__ */ function(e) {
  d0(t, e);
  function t(r, o) {
    var a;
    a = e.call(this, r, o) || this;
    var l = a.handleExited.bind(aI(a));
    return a.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: l,
      firstRender: !0
    }, a;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(o, a) {
    var l = a.children, c = a.handleExited, d = a.firstRender;
    return {
      children: d ? lI(o, c) : cI(o, l, c),
      firstRender: !1
    };
  }, n.handleExited = function(o, a) {
    var l = f0(this.props.children);
    o.key in l || (o.props.onExited && o.props.onExited(a), this.mounted && this.setState(function(c) {
      var d = ee({}, c.children);
      return delete d[o.key], {
        children: d
      };
    }));
  }, n.render = function() {
    var o = this.props, a = o.component, l = o.childFactory, c = mt(o, ["component", "childFactory"]), d = this.state.contextValue, p = uI(this.state.children).map(l);
    return delete c.appear, delete c.enter, delete c.exit, a === null ? /* @__PURE__ */ Ne.createElement(Yu.Provider, {
      value: d
    }, p) : /* @__PURE__ */ Ne.createElement(Yu.Provider, {
      value: d
    }, /* @__PURE__ */ Ne.createElement(a, c, p));
  }, t;
}(Ne.Component);
nc.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: i.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: i.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: i.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: i.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: i.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: i.func
} : {};
nc.defaultProps = dI;
const S3 = (e) => e.scrollTop;
function Ku(e, t) {
  const {
    timeout: n,
    easing: r,
    style: o = {}
  } = e;
  return {
    duration: o.transitionDuration ?? (typeof n == "number" ? n : n[t.mode] || 0),
    easing: o.transitionTimingFunction ?? (typeof r == "object" ? r[t.mode] : r),
    delay: o.transitionDelay
  };
}
function pI(e) {
  return Fe("MuiPaper", e);
}
Le("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const fI = (e) => {
  const {
    square: t,
    elevation: n,
    variant: r,
    classes: o
  } = e, a = {
    root: ["root", r, !t && "rounded", r === "elevation" && `elevation${n}`]
  };
  return Be(a, pI, o);
}, hI = ae("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(dt(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), mi = /* @__PURE__ */ w.forwardRef(function(t, n) {
  var y;
  const r = lt({
    props: t,
    name: "MuiPaper"
  }), o = tr(), {
    className: a,
    component: l = "div",
    elevation: c = 1,
    square: d = !1,
    variant: p = "elevation",
    ...f
  } = r, m = {
    ...r,
    component: l,
    elevation: c,
    square: d,
    variant: p
  }, g = fI(m);
  return process.env.NODE_ENV !== "production" && o.shadows[c] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${c}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${c}]\` is defined.`].join(`
`)), /* @__PURE__ */ x.jsx(hI, {
    as: l,
    ownerState: m,
    className: _e(g.root, a),
    ref: n,
    ...f,
    style: {
      ...p === "elevation" && {
        "--Paper-shadow": (o.vars || o).shadows[c],
        ...o.vars && {
          "--Paper-overlay": (y = o.vars.overlays) == null ? void 0 : y[c]
        },
        ...!o.vars && o.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${ht("#fff", fg(c))}, ${ht("#fff", fg(c))})`
        }
      },
      ...f.style
    }
  });
});
process.env.NODE_ENV !== "production" && (mi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: yo(i0, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: i.bool,
  /**
   * @ignore
   */
  style: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: i.oneOfType([i.oneOf(["elevation", "outlined"]), i.string])
});
function Nt(e, t) {
  const {
    className: n,
    elementType: r,
    ownerState: o,
    externalForwardedProps: a,
    internalForwardedProps: l,
    shouldForwardComponentProp: c = !1,
    ...d
  } = t, {
    component: p,
    slots: f = {
      [e]: void 0
    },
    slotProps: m = {
      [e]: void 0
    },
    ...g
  } = a, y = f[e] || r, b = Ad(m[e], o), {
    props: {
      component: v,
      ...$
    },
    internalRef: S
  } = l3({
    className: n,
    ...d,
    externalForwardedProps: e === "root" ? g : void 0,
    externalSlotProps: b
  }), R = It(S, b == null ? void 0 : b.ref, t.ref), P = e === "root" ? v || p : v, T = a3(y, {
    ...e === "root" && !p && !f[e] && l,
    ...e !== "root" && !f[e] && l,
    ...$,
    ...P && !c && {
      as: P
    },
    ...P && c && {
      component: P
    },
    ref: R
  }, o);
  return [y, T];
}
class Xu {
  constructor() {
    qe(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new Xu();
  }
  static use() {
    const t = n3(Xu.create).current, [n, r] = w.useState(!1);
    return t.shouldMount = n, t.setShouldMount = r, w.useEffect(t.mountEffect, [n]), t;
  }
  mount() {
    return this.mounted || (this.mounted = gI(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.pulsate(...t);
    });
  }
}
function mI() {
  return Xu.use();
}
function gI() {
  let e, t;
  const n = new Promise((r, o) => {
    e = r, t = o;
  });
  return n.resolve = e, n.reject = t, n;
}
function T3(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: o,
    rippleY: a,
    rippleSize: l,
    in: c,
    onExited: d,
    timeout: p
  } = e, [f, m] = w.useState(!1), g = _e(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), y = {
    width: l,
    height: l,
    top: -(l / 2) + a,
    left: -(l / 2) + o
  }, b = _e(n.child, f && n.childLeaving, r && n.childPulsate);
  return !c && !f && m(!0), w.useEffect(() => {
    if (!c && d != null) {
      const v = setTimeout(d, p);
      return () => {
        clearTimeout(v);
      };
    }
  }, [d, c, p]), /* @__PURE__ */ x.jsx("span", {
    className: g,
    style: y,
    children: /* @__PURE__ */ x.jsx("span", {
      className: b
    })
  });
}
process.env.NODE_ENV !== "production" && (T3.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object.isRequired,
  className: i.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: i.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: i.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: i.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: i.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: i.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: i.number,
  /**
   * exit delay
   */
  timeout: i.number.isRequired
});
const Hr = Le("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), gg = 550, yI = 80, vI = Xl`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, bI = Xl`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, xI = Xl`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, wI = ae("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), $I = ae(T3, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${Hr.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${vI};
    animation-duration: ${gg}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${Hr.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${Hr.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${Hr.childLeaving} {
    opacity: 0;
    animation-name: ${bI};
    animation-duration: ${gg}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${Hr.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${xI};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, O3 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: o = !1,
    classes: a = {},
    className: l,
    ...c
  } = r, [d, p] = w.useState([]), f = w.useRef(0), m = w.useRef(null);
  w.useEffect(() => {
    m.current && (m.current(), m.current = null);
  }, [d]);
  const g = w.useRef(!1), y = Ja(), b = w.useRef(null), v = w.useRef(null), $ = w.useCallback((T) => {
    const {
      pulsate: O,
      rippleX: k,
      rippleY: I,
      rippleSize: D,
      cb: j
    } = T;
    p((E) => [...E, /* @__PURE__ */ x.jsx($I, {
      classes: {
        ripple: _e(a.ripple, Hr.ripple),
        rippleVisible: _e(a.rippleVisible, Hr.rippleVisible),
        ripplePulsate: _e(a.ripplePulsate, Hr.ripplePulsate),
        child: _e(a.child, Hr.child),
        childLeaving: _e(a.childLeaving, Hr.childLeaving),
        childPulsate: _e(a.childPulsate, Hr.childPulsate)
      },
      timeout: gg,
      pulsate: O,
      rippleX: k,
      rippleY: I,
      rippleSize: D
    }, f.current)]), f.current += 1, m.current = j;
  }, [a]), S = w.useCallback((T = {}, O = {}, k = () => {
  }) => {
    const {
      pulsate: I = !1,
      center: D = o || O.pulsate,
      fakeElement: j = !1
      // For test purposes
    } = O;
    if ((T == null ? void 0 : T.type) === "mousedown" && g.current) {
      g.current = !1;
      return;
    }
    (T == null ? void 0 : T.type) === "touchstart" && (g.current = !0);
    const E = j ? null : v.current, M = E ? E.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let F, B, V;
    if (D || T === void 0 || T.clientX === 0 && T.clientY === 0 || !T.clientX && !T.touches)
      F = Math.round(M.width / 2), B = Math.round(M.height / 2);
    else {
      const {
        clientX: z,
        clientY: L
      } = T.touches && T.touches.length > 0 ? T.touches[0] : T;
      F = Math.round(z - M.left), B = Math.round(L - M.top);
    }
    if (D)
      V = Math.sqrt((2 * M.width ** 2 + M.height ** 2) / 3), V % 2 === 0 && (V += 1);
    else {
      const z = Math.max(Math.abs((E ? E.clientWidth : 0) - F), F) * 2 + 2, L = Math.max(Math.abs((E ? E.clientHeight : 0) - B), B) * 2 + 2;
      V = Math.sqrt(z ** 2 + L ** 2);
    }
    T != null && T.touches ? b.current === null && (b.current = () => {
      $({
        pulsate: I,
        rippleX: F,
        rippleY: B,
        rippleSize: V,
        cb: k
      });
    }, y.start(yI, () => {
      b.current && (b.current(), b.current = null);
    })) : $({
      pulsate: I,
      rippleX: F,
      rippleY: B,
      rippleSize: V,
      cb: k
    });
  }, [o, $, y]), R = w.useCallback(() => {
    S({}, {
      pulsate: !0
    });
  }, [S]), P = w.useCallback((T, O) => {
    if (y.clear(), (T == null ? void 0 : T.type) === "touchend" && b.current) {
      b.current(), b.current = null, y.start(0, () => {
        P(T, O);
      });
      return;
    }
    b.current = null, p((k) => k.length > 0 ? k.slice(1) : k), m.current = O;
  }, [y]);
  return w.useImperativeHandle(n, () => ({
    pulsate: R,
    start: S,
    stop: P
  }), [R, S, P]), /* @__PURE__ */ x.jsx(wI, {
    className: _e(Hr.root, a.root, l),
    ref: v,
    ...c,
    children: /* @__PURE__ */ x.jsx(nc, {
      component: null,
      exit: !0,
      children: d
    })
  });
});
process.env.NODE_ENV !== "production" && (O3.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: i.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string
});
function CI(e) {
  return Fe("MuiButtonBase", e);
}
const SI = Le("MuiButtonBase", ["root", "disabled", "focusVisible"]), TI = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: o
  } = e, l = Be({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, CI, o);
  return n && r && (l.root += ` ${r}`), l;
}, OI = ae("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${SI.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), jo = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: o,
    centerRipple: a = !1,
    children: l,
    className: c,
    component: d = "button",
    disabled: p = !1,
    disableRipple: f = !1,
    disableTouchRipple: m = !1,
    focusRipple: g = !1,
    focusVisibleClassName: y,
    LinkComponent: b = "a",
    onBlur: v,
    onClick: $,
    onContextMenu: S,
    onDragLeave: R,
    onFocus: P,
    onFocusVisible: T,
    onKeyDown: O,
    onKeyUp: k,
    onMouseDown: I,
    onMouseLeave: D,
    onMouseUp: j,
    onTouchEnd: E,
    onTouchMove: M,
    onTouchStart: F,
    tabIndex: B = 0,
    TouchRippleProps: V,
    touchRippleRef: z,
    type: L,
    ...G
  } = r, se = w.useRef(null), ne = mI(), K = It(ne.ref, z), [Q, ye] = w.useState(!1);
  p && Q && ye(!1), w.useImperativeHandle(o, () => ({
    focusVisible: () => {
      ye(!0), se.current.focus();
    }
  }), []);
  const we = ne.shouldMount && !f && !p;
  w.useEffect(() => {
    Q && g && !f && ne.pulsate();
  }, [f, g, Q, ne]);
  const fe = Jo(ne, "start", I, m), X = Jo(ne, "stop", S, m), re = Jo(ne, "stop", R, m), ie = Jo(ne, "stop", j, m), Y = Jo(ne, "stop", (Ie) => {
    Q && Ie.preventDefault(), D && D(Ie);
  }, m), Z = Jo(ne, "start", F, m), ue = Jo(ne, "stop", E, m), ge = Jo(ne, "stop", M, m), W = Jo(ne, "stop", (Ie) => {
    qu(Ie.target) || ye(!1), v && v(Ie);
  }, !1), J = ze((Ie) => {
    se.current || (se.current = Ie.currentTarget), qu(Ie.target) && (ye(!0), T && T(Ie)), P && P(Ie);
  }), le = () => {
    const Ie = se.current;
    return d && d !== "button" && !(Ie.tagName === "A" && Ie.href);
  }, me = ze((Ie) => {
    g && !Ie.repeat && Q && Ie.key === " " && ne.stop(Ie, () => {
      ne.start(Ie);
    }), Ie.target === Ie.currentTarget && le() && Ie.key === " " && Ie.preventDefault(), O && O(Ie), Ie.target === Ie.currentTarget && le() && Ie.key === "Enter" && !p && (Ie.preventDefault(), $ && $(Ie));
  }), be = ze((Ie) => {
    g && Ie.key === " " && Q && !Ie.defaultPrevented && ne.stop(Ie, () => {
      ne.pulsate(Ie);
    }), k && k(Ie), $ && Ie.target === Ie.currentTarget && le() && Ie.key === " " && !Ie.defaultPrevented && $(Ie);
  });
  let de = d;
  de === "button" && (G.href || G.to) && (de = b);
  const Oe = {};
  de === "button" ? (Oe.type = L === void 0 ? "button" : L, Oe.disabled = p) : (!G.href && !G.to && (Oe.role = "button"), p && (Oe["aria-disabled"] = p));
  const Re = It(n, se), We = {
    ...r,
    centerRipple: a,
    component: d,
    disabled: p,
    disableRipple: f,
    disableTouchRipple: m,
    focusRipple: g,
    tabIndex: B,
    focusVisible: Q
  }, Ye = TI(We);
  return /* @__PURE__ */ x.jsxs(OI, {
    as: de,
    className: _e(Ye.root, c),
    ownerState: We,
    onBlur: W,
    onClick: $,
    onContextMenu: X,
    onFocus: J,
    onKeyDown: me,
    onKeyUp: be,
    onMouseDown: fe,
    onMouseLeave: Y,
    onMouseUp: ie,
    onDragLeave: re,
    onTouchEnd: ue,
    onTouchMove: ge,
    onTouchStart: Z,
    ref: Re,
    tabIndex: p ? -1 : B,
    type: L,
    ...Oe,
    ...G,
    children: [l, we ? /* @__PURE__ */ x.jsx(O3, {
      ref: K,
      center: a,
      ...V
    }) : null]
  });
});
function Jo(e, t, n, r = !1) {
  return ze((o) => (n && n(o), r || e[t](o), !0));
}
process.env.NODE_ENV !== "production" && (jo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: gn,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: i.bool,
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Dd,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: i.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: i.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: i.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: i.string,
  /**
   * @ignore
   */
  href: i.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: i.elementType,
  /**
   * @ignore
   */
  onBlur: i.func,
  /**
   * @ignore
   */
  onClick: i.func,
  /**
   * @ignore
   */
  onContextMenu: i.func,
  /**
   * @ignore
   */
  onDragLeave: i.func,
  /**
   * @ignore
   */
  onFocus: i.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: i.func,
  /**
   * @ignore
   */
  onKeyDown: i.func,
  /**
   * @ignore
   */
  onKeyUp: i.func,
  /**
   * @ignore
   */
  onMouseDown: i.func,
  /**
   * @ignore
   */
  onMouseLeave: i.func,
  /**
   * @ignore
   */
  onMouseUp: i.func,
  /**
   * @ignore
   */
  onTouchEnd: i.func,
  /**
   * @ignore
   */
  onTouchMove: i.func,
  /**
   * @ignore
   */
  onTouchStart: i.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * @default 0
   */
  tabIndex: i.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: i.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: i.oneOfType([i.func, i.shape({
    current: i.shape({
      pulsate: i.func.isRequired,
      start: i.func.isRequired,
      stop: i.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: i.oneOfType([i.oneOf(["button", "reset", "submit"]), i.string])
});
function PI(e) {
  return typeof e.main == "string";
}
function EI(e, t = []) {
  if (!PI(e))
    return !1;
  for (const n of t)
    if (!e.hasOwnProperty(n) || typeof e[n] != "string")
      return !1;
  return !0;
}
function An(e = []) {
  return ([, t]) => t && EI(t, e);
}
function RI(e) {
  return Fe("MuiAlert", e);
}
const G1 = Le("MuiAlert", ["root", "action", "icon", "message", "filled", "colorSuccess", "colorInfo", "colorWarning", "colorError", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]);
function kI(e) {
  return Fe("MuiCircularProgress", e);
}
const _I = Le("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]), Di = 44, yg = Xl`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, vg = Xl`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`, DI = typeof yg != "string" ? Zg`
        animation: ${yg} 1.4s linear infinite;
      ` : null, II = typeof vg != "string" ? Zg`
        animation: ${vg} 1.4s ease-in-out infinite;
      ` : null, MI = (e) => {
  const {
    classes: t,
    variant: n,
    color: r,
    disableShrink: o
  } = e, a = {
    root: ["root", n, `color${Pe(r)}`],
    svg: ["svg"],
    circle: ["circle", `circle${Pe(n)}`, o && "circleDisableShrink"]
  };
  return Be(a, kI, t);
}, AI = ae("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`color${Pe(n.color)}`]];
  }
})(dt(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: DI || {
      animation: `${yg} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(An()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), NI = ae("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), jI = ae("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.circle, t[`circle${Pe(n.variant)}`], n.disableShrink && t.circleDisableShrink];
  }
})(dt(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink,
    style: II || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${vg} 1.4s ease-in-out infinite`
    }
  }]
}))), Fo = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: o,
    color: a = "primary",
    disableShrink: l = !1,
    size: c = 40,
    style: d,
    thickness: p = 3.6,
    value: f = 0,
    variant: m = "indeterminate",
    ...g
  } = r, y = {
    ...r,
    color: a,
    disableShrink: l,
    size: c,
    thickness: p,
    value: f,
    variant: m
  }, b = MI(y), v = {}, $ = {}, S = {};
  if (m === "determinate") {
    const R = 2 * Math.PI * ((Di - p) / 2);
    v.strokeDasharray = R.toFixed(3), S["aria-valuenow"] = Math.round(f), v.strokeDashoffset = `${((100 - f) / 100 * R).toFixed(3)}px`, $.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ x.jsx(AI, {
    className: _e(b.root, o),
    style: {
      width: c,
      height: c,
      ...$,
      ...d
    },
    ownerState: y,
    ref: n,
    role: "progressbar",
    ...S,
    ...g,
    children: /* @__PURE__ */ x.jsx(NI, {
      className: b.svg,
      ownerState: y,
      viewBox: `${Di / 2} ${Di / 2} ${Di} ${Di}`,
      children: /* @__PURE__ */ x.jsx(jI, {
        className: b.circle,
        style: v,
        ownerState: y,
        cx: Di,
        cy: Di,
        r: (Di - p) / 2,
        fill: "none",
        strokeWidth: p
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Fo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: i.oneOfType([i.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), i.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: yo(i.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: i.oneOfType([i.number, i.string]),
  /**
   * @ignore
   */
  style: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: i.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: i.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: i.oneOf(["determinate", "indeterminate"])
});
function FI(e) {
  return Fe("MuiIconButton", e);
}
const Y1 = Le("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge", "loading", "loadingIndicator", "loadingWrapper"]), LI = (e) => {
  const {
    classes: t,
    disabled: n,
    color: r,
    edge: o,
    size: a,
    loading: l
  } = e, c = {
    root: ["root", l && "loading", n && "disabled", r !== "default" && `color${Pe(r)}`, o && `edge${Pe(o)}`, `size${Pe(a)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  return Be(c, FI, t);
}, BI = ae(jo, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.loading && t.loading, n.color !== "default" && t[`color${Pe(n.color)}`], n.edge && t[`edge${Pe(n.edge)}`], t[`size${Pe(n.size)}`]];
  }
})(dt(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : ht(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), dt(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(An()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(An()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : ht((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${Y1.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  },
  [`&.${Y1.loading}`]: {
    color: "transparent"
  }
}))), VI = ae("span", {
  name: "MuiIconButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: (e.vars || e).palette.action.disabled,
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }]
})), Vo = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: o = !1,
    children: a,
    className: l,
    color: c = "default",
    disabled: d = !1,
    disableFocusRipple: p = !1,
    size: f = "medium",
    id: m,
    loading: g = null,
    loadingIndicator: y,
    ...b
  } = r, v = Mr(m), $ = y ?? /* @__PURE__ */ x.jsx(Fo, {
    "aria-labelledby": v,
    color: "inherit",
    size: 16
  }), S = {
    ...r,
    edge: o,
    color: c,
    disabled: d,
    disableFocusRipple: p,
    loading: g,
    loadingIndicator: $,
    size: f
  }, R = LI(S);
  return /* @__PURE__ */ x.jsxs(BI, {
    id: g ? v : m,
    className: _e(R.root, l),
    centerRipple: !0,
    focusRipple: !p,
    disabled: d || g,
    ref: n,
    ...b,
    ownerState: S,
    children: [typeof g == "boolean" && // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ x.jsx("span", {
      className: R.loadingWrapper,
      style: {
        display: "contents"
      },
      children: /* @__PURE__ */ x.jsx(VI, {
        className: R.loadingIndicator,
        ownerState: S,
        children: g && $
      })
    }), a]
  });
});
process.env.NODE_ENV !== "production" && (Vo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: yo(i.node, (e) => w.Children.toArray(e.children).some((n) => /* @__PURE__ */ w.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: i.oneOfType([i.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), i.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: i.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: i.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: i.oneOf(["end", "start", !1]),
  /**
   * @ignore
   */
  id: i.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: i.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: i.node,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: i.oneOfType([i.oneOf(["small", "medium", "large"]), i.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
const zI = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), WI = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), qI = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), UI = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined"), P3 = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), HI = (e) => {
  const {
    variant: t,
    color: n,
    severity: r,
    classes: o
  } = e, a = {
    root: ["root", `color${Pe(n || r)}`, `${t}${Pe(n || r)}`, `${t}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return Be(a, RI, o);
}, GI = ae(mi, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${Pe(n.color || n.severity)}`]];
  }
})(dt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? ds : ps, n = e.palette.mode === "light" ? ps : ds;
  return {
    ...e.typography.body2,
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px",
    variants: [...Object.entries(e.palette).filter(An(["light"])).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "standard"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${r}Color`] : t(e.palette[r].light, 0.6),
        backgroundColor: e.vars ? e.vars.palette.Alert[`${r}StandardBg`] : n(e.palette[r].light, 0.9),
        [`& .${G1.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${r}IconColor`]
        } : {
          color: e.palette[r].main
        }
      }
    })), ...Object.entries(e.palette).filter(An(["light"])).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "outlined"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${r}Color`] : t(e.palette[r].light, 0.6),
        border: `1px solid ${(e.vars || e).palette[r].light}`,
        [`& .${G1.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${r}IconColor`]
        } : {
          color: e.palette[r].main
        }
      }
    })), ...Object.entries(e.palette).filter(An(["dark"])).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "filled"
      },
      style: {
        fontWeight: e.typography.fontWeightMedium,
        ...e.vars ? {
          color: e.vars.palette.Alert[`${r}FilledColor`],
          backgroundColor: e.vars.palette.Alert[`${r}FilledBg`]
        } : {
          backgroundColor: e.palette.mode === "dark" ? e.palette[r].dark : e.palette[r].main,
          color: e.palette.getContrastText(e.palette[r].main)
        }
      }
    }))]
  };
})), YI = ae("div", {
  name: "MuiAlert",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), KI = ae("div", {
  name: "MuiAlert",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), XI = ae("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), K1 = {
  success: /* @__PURE__ */ x.jsx(zI, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ x.jsx(WI, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ x.jsx(qI, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ x.jsx(UI, {
    fontSize: "inherit"
  })
}, Du = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiAlert"
  }), {
    action: o,
    children: a,
    className: l,
    closeText: c = "Close",
    color: d,
    components: p = {},
    componentsProps: f = {},
    icon: m,
    iconMapping: g = K1,
    onClose: y,
    role: b = "alert",
    severity: v = "success",
    slotProps: $ = {},
    slots: S = {},
    variant: R = "standard",
    ...P
  } = r, T = {
    ...r,
    color: d,
    severity: v,
    variant: R,
    colorSeverity: d || v
  }, O = HI(T), k = {
    slots: {
      closeButton: p.CloseButton,
      closeIcon: p.CloseIcon,
      ...S
    },
    slotProps: {
      ...f,
      ...$
    }
  }, [I, D] = Nt("root", {
    ref: n,
    shouldForwardComponentProp: !0,
    className: _e(O.root, l),
    elementType: GI,
    externalForwardedProps: {
      ...k,
      ...P
    },
    ownerState: T,
    additionalProps: {
      role: b,
      elevation: 0
    }
  }), [j, E] = Nt("icon", {
    className: O.icon,
    elementType: YI,
    externalForwardedProps: k,
    ownerState: T
  }), [M, F] = Nt("message", {
    className: O.message,
    elementType: KI,
    externalForwardedProps: k,
    ownerState: T
  }), [B, V] = Nt("action", {
    className: O.action,
    elementType: XI,
    externalForwardedProps: k,
    ownerState: T
  }), [z, L] = Nt("closeButton", {
    elementType: Vo,
    externalForwardedProps: k,
    ownerState: T
  }), [G, se] = Nt("closeIcon", {
    elementType: P3,
    externalForwardedProps: k,
    ownerState: T
  });
  return /* @__PURE__ */ x.jsxs(I, {
    ...D,
    children: [m !== !1 ? /* @__PURE__ */ x.jsx(j, {
      ...E,
      children: m || g[v] || K1[v]
    }) : null, /* @__PURE__ */ x.jsx(M, {
      ...F,
      children: a
    }), o != null ? /* @__PURE__ */ x.jsx(B, {
      ...V,
      children: o
    }) : null, o == null && y ? /* @__PURE__ */ x.jsx(B, {
      ...V,
      children: /* @__PURE__ */ x.jsx(z, {
        size: "small",
        "aria-label": c,
        title: c,
        color: "inherit",
        onClick: y,
        ...L,
        children: /* @__PURE__ */ x.jsx(G, {
          fontSize: "small",
          ...se
        })
      })
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (Du.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: i.node,
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: i.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: i.oneOfType([i.oneOf(["error", "info", "success", "warning"]), i.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: i.shape({
    CloseButton: i.elementType,
    CloseIcon: i.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: i.shape({
    closeButton: i.object,
    closeIcon: i.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: i.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: i.shape({
    error: i.node,
    info: i.node,
    success: i.node,
    warning: i.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: i.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: i.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: i.oneOfType([i.oneOf(["error", "info", "success", "warning"]), i.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    action: i.oneOfType([i.func, i.object]),
    closeButton: i.oneOfType([i.func, i.object]),
    closeIcon: i.oneOfType([i.func, i.object]),
    icon: i.oneOfType([i.func, i.object]),
    message: i.oneOfType([i.func, i.object]),
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    action: i.elementType,
    closeButton: i.elementType,
    closeIcon: i.elementType,
    icon: i.elementType,
    message: i.elementType,
    root: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: i.oneOfType([i.oneOf(["filled", "outlined", "standard"]), i.string])
});
function ZI(e) {
  return Fe("MuiTypography", e);
}
const X1 = Le("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]), QI = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, JI = XD(), eM = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: r,
    paragraph: o,
    variant: a,
    classes: l
  } = e, c = {
    root: ["root", a, e.align !== "inherit" && `align${Pe(t)}`, n && "gutterBottom", r && "noWrap", o && "paragraph"]
  };
  return Be(c, ZI, l);
}, tM = ae("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${Pe(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(dt(({
  theme: e
}) => {
  var t;
  return {
    margin: 0,
    variants: [{
      props: {
        variant: "inherit"
      },
      style: {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit"
      }
    }, ...Object.entries(e.typography).filter(([n, r]) => n !== "inherit" && r && typeof r == "object").map(([n, r]) => ({
      props: {
        variant: n
      },
      style: r
    })), ...Object.entries(e.palette).filter(An()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main
      }
    })), ...Object.entries(((t = e.palette) == null ? void 0 : t.text) || {}).filter(([, n]) => typeof n == "string").map(([n]) => ({
      props: {
        color: `text${Pe(n)}`
      },
      style: {
        color: (e.vars || e).palette.text[n]
      }
    })), {
      props: ({
        ownerState: n
      }) => n.align !== "inherit",
      style: {
        textAlign: "var(--Typography-textAlign)"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.noWrap,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.gutterBottom,
      style: {
        marginBottom: "0.35em"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.paragraph,
      style: {
        marginBottom: 16
      }
    }]
  };
})), Z1 = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, Qe = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    color: r,
    ...o
  } = lt({
    props: t,
    name: "MuiTypography"
  }), a = !QI[r], l = JI({
    ...o,
    ...a && {
      color: r
    }
  }), {
    align: c = "inherit",
    className: d,
    component: p,
    gutterBottom: f = !1,
    noWrap: m = !1,
    paragraph: g = !1,
    variant: y = "body1",
    variantMapping: b = Z1,
    ...v
  } = l, $ = {
    ...l,
    align: c,
    color: r,
    className: d,
    component: p,
    gutterBottom: f,
    noWrap: m,
    paragraph: g,
    variant: y,
    variantMapping: b
  }, S = p || (g ? "p" : b[y] || Z1[y]) || "span", R = eM($);
  return /* @__PURE__ */ x.jsx(tM, {
    as: S,
    ref: n,
    className: _e(R.root, d),
    ...v,
    ownerState: $,
    style: {
      ...c !== "inherit" && {
        "--Typography-textAlign": c
      },
      ...v.style
    }
  });
});
process.env.NODE_ENV !== "production" && (Qe.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: i.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: i.oneOfType([i.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), i.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: i.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: i.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: i.bool,
  /**
   * @ignore
   */
  style: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: i.oneOfType([i.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), i.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: i.object
});
function Q1(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function nM(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: n = !0,
    limit: r,
    matchFrom: o = "any",
    stringify: a,
    trim: l = !1
  } = e;
  return (c, {
    inputValue: d,
    getOptionLabel: p
  }) => {
    let f = l ? d.trim() : d;
    n && (f = f.toLowerCase()), t && (f = Q1(f));
    const m = f ? c.filter((g) => {
      let y = (a || p)(g);
      return n && (y = y.toLowerCase()), t && (y = Q1(y)), o === "start" ? y.startsWith(f) : y.includes(f);
    }) : c;
    return typeof r == "number" ? m.slice(0, r) : m;
  };
}
const rM = nM(), oM = 5, iM = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
}, aM = [];
function J1(e, t, n) {
  if (t || e == null)
    return "";
  const r = n(e);
  return typeof r == "string" ? r : "";
}
function sM(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = iM,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: n = "Mui",
    autoComplete: r = !1,
    autoHighlight: o = !1,
    autoSelect: a = !1,
    blurOnSelect: l = !1,
    clearOnBlur: c = !e.freeSolo,
    clearOnEscape: d = !1,
    componentName: p = "useAutocomplete",
    defaultValue: f = e.multiple ? aM : null,
    disableClearable: m = !1,
    disableCloseOnSelect: g = !1,
    disabled: y,
    disabledItemsFocusable: b = !1,
    disableListWrap: v = !1,
    filterOptions: $ = rM,
    filterSelectedOptions: S = !1,
    freeSolo: R = !1,
    getOptionDisabled: P,
    getOptionKey: T,
    getOptionLabel: O = (pe) => pe.label ?? pe,
    groupBy: k,
    handleHomeEndKeys: I = !e.freeSolo,
    id: D,
    includeInputInList: j = !1,
    inputValue: E,
    isOptionEqualToValue: M = (pe, ce) => pe === ce,
    multiple: F = !1,
    onChange: B,
    onClose: V,
    onHighlightChange: z,
    onInputChange: L,
    onOpen: G,
    open: se,
    openOnFocus: ne = !1,
    options: K,
    readOnly: Q = !1,
    selectOnFocus: ye = !e.freeSolo,
    value: we
  } = e, fe = Mr(D);
  let X = O;
  X = (pe) => {
    const ce = O(pe);
    if (typeof ce != "string") {
      if (process.env.NODE_ENV !== "production") {
        const Te = ce === void 0 ? "undefined" : `${typeof ce} (${ce})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${p} returned ${Te} instead of a string for ${JSON.stringify(pe)}.`);
      }
      return String(ce);
    }
    return ce;
  };
  const re = w.useRef(!1), ie = w.useRef(!0), Y = w.useRef(null), Z = w.useRef(null), [ue, ge] = w.useState(null), [W, J] = w.useState(-1), le = o ? 0 : -1, me = w.useRef(le), be = w.useRef(J1(f, F, X)).current, [de, Oe] = sr({
    controlled: we,
    default: f,
    name: p
  }), [Re, We] = sr({
    controlled: E,
    default: be,
    name: p,
    state: "inputValue"
  }), [Ye, Ie] = w.useState(!1), kt = w.useCallback((pe, ce, Te) => {
    if (!(F ? de.length < ce.length : ce !== null) && !c)
      return;
    const Ge = J1(ce, F, X);
    Re !== Ge && (We(Ge), L && L(pe, Ge, Te));
  }, [X, Re, F, L, We, c, de]), [Ee, Ae] = sr({
    controlled: se,
    default: !1,
    name: p,
    state: "open"
  }), [pt, Ue] = w.useState(!0), et = !F && de != null && Re === X(de), Je = Ee && !Q, rt = Je ? $(
    K.filter((pe) => !(S && (F ? de : [de]).some((ce) => ce !== null && M(pe, ce)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: et && pt ? "" : Re,
      getOptionLabel: X
    }
  ) : [], je = R_({
    filteredOptions: rt,
    value: de,
    inputValue: Re
  });
  w.useEffect(() => {
    const pe = de !== je.value;
    Ye && !pe || R && !pe || kt(null, de, "reset");
  }, [de, kt, Ye, je.value, R]);
  const $t = Ee && rt.length > 0 && !Q, Pt = ze((pe) => {
    pe === -1 ? Y.current.focus() : ue.querySelector(`[data-tag-index="${pe}"]`).focus();
  });
  w.useEffect(() => {
    F && W > de.length - 1 && (J(-1), Pt(-1));
  }, [de, F, W, Pt]);
  function Ft(pe, ce) {
    if (!Z.current || pe < 0 || pe >= rt.length)
      return -1;
    let Te = pe;
    for (; ; ) {
      const Ke = Z.current.querySelector(`[data-option-index="${Te}"]`), Ge = b ? !1 : !Ke || Ke.disabled || Ke.getAttribute("aria-disabled") === "true";
      if (Ke && Ke.hasAttribute("tabindex") && !Ge)
        return Te;
      if (ce === "next" ? Te = (Te + 1) % rt.length : Te = (Te - 1 + rt.length) % rt.length, Te === pe)
        return -1;
    }
  }
  const Jt = ze(({
    event: pe,
    index: ce,
    reason: Te = "auto"
  }) => {
    if (me.current = ce, ce === -1 ? Y.current.removeAttribute("aria-activedescendant") : Y.current.setAttribute("aria-activedescendant", `${fe}-option-${ce}`), z && z(pe, ce === -1 ? null : rt[ce], Te), !Z.current)
      return;
    const Ke = Z.current.querySelector(`[role="option"].${n}-focused`);
    Ke && (Ke.classList.remove(`${n}-focused`), Ke.classList.remove(`${n}-focusVisible`));
    let Ge = Z.current;
    if (Z.current.getAttribute("role") !== "listbox" && (Ge = Z.current.parentElement.querySelector('[role="listbox"]')), !Ge)
      return;
    if (ce === -1) {
      Ge.scrollTop = 0;
      return;
    }
    const nt = Z.current.querySelector(`[data-option-index="${ce}"]`);
    if (nt && (nt.classList.add(`${n}-focused`), Te === "keyboard" && nt.classList.add(`${n}-focusVisible`), Ge.scrollHeight > Ge.clientHeight && Te !== "mouse" && Te !== "touch")) {
      const _t = nt, rn = Ge.clientHeight + Ge.scrollTop, rr = _t.offsetTop + _t.offsetHeight;
      rr > rn ? Ge.scrollTop = rr - Ge.clientHeight : _t.offsetTop - _t.offsetHeight * (k ? 1.3 : 0) < Ge.scrollTop && (Ge.scrollTop = _t.offsetTop - _t.offsetHeight * (k ? 1.3 : 0));
    }
  }), Me = ze(({
    event: pe,
    diff: ce,
    direction: Te = "next",
    reason: Ke = "auto"
  }) => {
    if (!Je)
      return;
    const nt = Ft((() => {
      const _t = rt.length - 1;
      if (ce === "reset")
        return le;
      if (ce === "start")
        return 0;
      if (ce === "end")
        return _t;
      const rn = me.current + ce;
      return rn < 0 ? rn === -1 && j ? -1 : v && me.current !== -1 || Math.abs(ce) > 1 ? 0 : _t : rn > _t ? rn === _t + 1 && j ? -1 : v || Math.abs(ce) > 1 ? _t : 0 : rn;
    })(), Te);
    if (Jt({
      index: nt,
      reason: Ke,
      event: pe
    }), r && ce !== "reset")
      if (nt === -1)
        Y.current.value = Re;
      else {
        const _t = X(rt[nt]);
        Y.current.value = _t, _t.toLowerCase().indexOf(Re.toLowerCase()) === 0 && Re.length > 0 && Y.current.setSelectionRange(Re.length, _t.length);
      }
  }), it = () => {
    const pe = (ce, Te) => {
      const Ke = ce ? X(ce) : "", Ge = Te ? X(Te) : "";
      return Ke === Ge;
    };
    if (me.current !== -1 && je.filteredOptions && je.filteredOptions.length !== rt.length && je.inputValue === Re && (F ? de.length === je.value.length && je.value.every((ce, Te) => X(de[Te]) === X(ce)) : pe(je.value, de))) {
      const ce = je.filteredOptions[me.current];
      if (ce)
        return rt.findIndex((Te) => X(Te) === X(ce));
    }
    return -1;
  }, bt = w.useCallback(() => {
    if (!Je)
      return;
    const pe = it();
    if (pe !== -1) {
      me.current = pe;
      return;
    }
    const ce = F ? de[0] : de;
    if (rt.length === 0 || ce == null) {
      Me({
        diff: "reset"
      });
      return;
    }
    if (Z.current) {
      if (ce != null) {
        const Te = rt[me.current];
        if (F && Te && de.findIndex((Ge) => M(Te, Ge)) !== -1)
          return;
        const Ke = rt.findIndex((Ge) => M(Ge, ce));
        Ke === -1 ? Me({
          diff: "reset"
        }) : Jt({
          index: Ke
        });
        return;
      }
      if (me.current >= rt.length - 1) {
        Jt({
          index: rt.length - 1
        });
        return;
      }
      Jt({
        index: me.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    rt.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    F ? !1 : de,
    S,
    Me,
    Jt,
    Je,
    Re,
    F
  ]), gt = ze((pe) => {
    Wu(Z, pe), pe && bt();
  });
  process.env.NODE_ENV !== "production" && w.useEffect(() => {
    (!Y.current || Y.current.nodeName !== "INPUT") && (Y.current && Y.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${p} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${Y.current} while an HTMLInputElement was expected.`, `Instead, ${p} expects an input element.`, "", p === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [p]), w.useEffect(() => {
    bt();
  }, [bt]);
  const Et = (pe) => {
    Ee || (Ae(!0), Ue(!0), G && G(pe));
  }, xn = (pe, ce) => {
    Ee && (Ae(!1), V && V(pe, ce));
  }, ln = (pe, ce, Te, Ke) => {
    if (F) {
      if (de.length === ce.length && de.every((Ge, nt) => Ge === ce[nt]))
        return;
    } else if (de === ce)
      return;
    B && B(pe, ce, Te, Ke), Oe(ce);
  }, wr = w.useRef(!1), Yn = (pe, ce, Te = "selectOption", Ke = "options") => {
    let Ge = Te, nt = ce;
    if (F) {
      if (nt = Array.isArray(de) ? de.slice() : [], process.env.NODE_ENV !== "production") {
        const rn = nt.filter((rr) => M(ce, rr));
        rn.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${p} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${rn.length} matches.`].join(`
`));
      }
      const _t = nt.findIndex((rn) => M(ce, rn));
      _t === -1 ? nt.push(ce) : Ke !== "freeSolo" && (nt.splice(_t, 1), Ge = "removeOption");
    }
    kt(pe, nt, Ge), ln(pe, nt, Ge, {
      option: ce
    }), !g && (!pe || !pe.ctrlKey && !pe.metaKey) && xn(pe, Ge), (l === !0 || l === "touch" && wr.current || l === "mouse" && !wr.current) && Y.current.blur();
  };
  function oo(pe, ce) {
    if (pe === -1)
      return -1;
    let Te = pe;
    for (; ; ) {
      if (ce === "next" && Te === de.length || ce === "previous" && Te === -1)
        return -1;
      const Ke = ue.querySelector(`[data-tag-index="${Te}"]`);
      if (!Ke || !Ke.hasAttribute("tabindex") || Ke.disabled || Ke.getAttribute("aria-disabled") === "true")
        Te += ce === "next" ? 1 : -1;
      else
        return Te;
    }
  }
  const vo = (pe, ce) => {
    if (!F)
      return;
    Re === "" && xn(pe, "toggleInput");
    let Te = W;
    W === -1 ? Re === "" && ce === "previous" && (Te = de.length - 1) : (Te += ce === "next" ? 1 : -1, Te < 0 && (Te = 0), Te === de.length && (Te = -1)), Te = oo(Te, ce), J(Te), Pt(Te);
  }, tt = (pe) => {
    re.current = !0, We(""), L && L(pe, "", "clear"), ln(pe, F ? [] : null, "clear");
  }, In = (pe) => (ce) => {
    if (pe.onKeyDown && pe.onKeyDown(ce), !ce.defaultMuiPrevented && (W !== -1 && !["ArrowLeft", "ArrowRight"].includes(ce.key) && (J(-1), Pt(-1)), ce.which !== 229))
      switch (ce.key) {
        case "Home":
          Je && I && (ce.preventDefault(), Me({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: ce
          }));
          break;
        case "End":
          Je && I && (ce.preventDefault(), Me({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: ce
          }));
          break;
        case "PageUp":
          ce.preventDefault(), Me({
            diff: -5,
            direction: "previous",
            reason: "keyboard",
            event: ce
          }), Et(ce);
          break;
        case "PageDown":
          ce.preventDefault(), Me({
            diff: oM,
            direction: "next",
            reason: "keyboard",
            event: ce
          }), Et(ce);
          break;
        case "ArrowDown":
          ce.preventDefault(), Me({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: ce
          }), Et(ce);
          break;
        case "ArrowUp":
          ce.preventDefault(), Me({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: ce
          }), Et(ce);
          break;
        case "ArrowLeft":
          vo(ce, "previous");
          break;
        case "ArrowRight":
          vo(ce, "next");
          break;
        case "Enter":
          if (me.current !== -1 && Je) {
            const Te = rt[me.current], Ke = P ? P(Te) : !1;
            if (ce.preventDefault(), Ke)
              return;
            Yn(ce, Te, "selectOption"), r && Y.current.setSelectionRange(Y.current.value.length, Y.current.value.length);
          } else R && Re !== "" && et === !1 && (F && ce.preventDefault(), Yn(ce, Re, "createOption", "freeSolo"));
          break;
        case "Escape":
          Je ? (ce.preventDefault(), ce.stopPropagation(), xn(ce, "escape")) : d && (Re !== "" || F && de.length > 0) && (ce.preventDefault(), ce.stopPropagation(), tt(ce));
          break;
        case "Backspace":
          if (F && !Q && Re === "" && de.length > 0) {
            const Te = W === -1 ? de.length - 1 : W, Ke = de.slice();
            Ke.splice(Te, 1), ln(ce, Ke, "removeOption", {
              option: de[Te]
            });
          }
          break;
        case "Delete":
          if (F && !Q && Re === "" && de.length > 0 && W !== -1) {
            const Te = W, Ke = de.slice();
            Ke.splice(Te, 1), ln(ce, Ke, "removeOption", {
              option: de[Te]
            });
          }
          break;
      }
  }, bo = (pe) => {
    Ie(!0), ne && !re.current && Et(pe);
  }, io = (pe) => {
    if (t(Z)) {
      Y.current.focus();
      return;
    }
    Ie(!1), ie.current = !0, re.current = !1, a && me.current !== -1 && Je ? Yn(pe, rt[me.current], "blur") : a && R && Re !== "" ? Yn(pe, Re, "blur", "freeSolo") : c && kt(pe, de, "blur"), xn(pe, "blur");
  }, Ar = (pe) => {
    const ce = pe.target.value;
    Re !== ce && (We(ce), Ue(!1), L && L(pe, ce, "input")), ce === "" ? !m && !F && ln(pe, null, "clear") : Et(pe);
  }, xo = (pe) => {
    const ce = Number(pe.currentTarget.getAttribute("data-option-index"));
    me.current !== ce && Jt({
      event: pe,
      index: ce,
      reason: "mouse"
    });
  }, zo = (pe) => {
    Jt({
      event: pe,
      index: Number(pe.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), wr.current = !0;
  }, Hi = (pe) => {
    const ce = Number(pe.currentTarget.getAttribute("data-option-index"));
    Yn(pe, rt[ce], "selectOption"), wr.current = !1;
  }, Gi = (pe) => (ce) => {
    const Te = de.slice();
    Te.splice(pe, 1), ln(ce, Te, "removeOption", {
      option: de[pe]
    });
  }, Yi = (pe) => {
    Ee ? xn(pe, "toggleInput") : Et(pe);
  }, U = (pe) => {
    pe.currentTarget.contains(pe.target) && pe.target.getAttribute("id") !== fe && pe.preventDefault();
  }, Ce = (pe) => {
    pe.currentTarget.contains(pe.target) && (Y.current.focus(), ye && ie.current && Y.current.selectionEnd - Y.current.selectionStart === 0 && Y.current.select(), ie.current = !1);
  }, De = (pe) => {
    !y && (Re === "" || !Ee) && Yi(pe);
  };
  let Ze = R && Re.length > 0;
  Ze = Ze || (F ? de.length > 0 : de !== null);
  let St = rt;
  if (k) {
    const pe = /* @__PURE__ */ new Map();
    let ce = !1;
    St = rt.reduce((Te, Ke, Ge) => {
      const nt = k(Ke);
      return Te.length > 0 && Te[Te.length - 1].group === nt ? Te[Te.length - 1].options.push(Ke) : (process.env.NODE_ENV !== "production" && (pe.get(nt) && !ce && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${p} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), ce = !0), pe.set(nt, !0)), Te.push({
        key: Ge,
        index: Ge,
        group: nt,
        options: [Ke]
      })), Te;
    }, []);
  }
  return y && Ye && io(), {
    getRootProps: (pe = {}) => ({
      ...pe,
      onKeyDown: In(pe),
      onMouseDown: U,
      onClick: Ce
    }),
    getInputLabelProps: () => ({
      id: `${fe}-label`,
      htmlFor: fe
    }),
    getInputProps: () => ({
      id: fe,
      value: Re,
      onBlur: io,
      onFocus: bo,
      onChange: Ar,
      onMouseDown: De,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": Je ? "" : null,
      "aria-autocomplete": r ? "both" : "list",
      "aria-controls": $t ? `${fe}-listbox` : void 0,
      "aria-expanded": $t,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: Y,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: y
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: tt
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Yi
    }),
    getTagProps: ({
      index: pe
    }) => ({
      key: pe,
      "data-tag-index": pe,
      tabIndex: -1,
      ...!Q && {
        onDelete: Gi(pe)
      }
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${fe}-listbox`,
      "aria-labelledby": `${fe}-label`,
      ref: gt,
      onMouseDown: (pe) => {
        pe.preventDefault();
      }
    }),
    getOptionProps: ({
      index: pe,
      option: ce
    }) => {
      const Te = (F ? de : [de]).some((Ge) => Ge != null && M(ce, Ge)), Ke = P ? P(ce) : !1;
      return {
        key: (T == null ? void 0 : T(ce)) ?? X(ce),
        tabIndex: -1,
        role: "option",
        id: `${fe}-option-${pe}`,
        onMouseMove: xo,
        onClick: Hi,
        onTouchStart: zo,
        "data-option-index": pe,
        "aria-disabled": Ke,
        "aria-selected": Te
      };
    },
    id: fe,
    inputValue: Re,
    value: de,
    dirty: Ze,
    expanded: Je && ue,
    popupOpen: Je,
    focused: Ye || W !== -1,
    anchorEl: ue,
    setAnchorEl: ge,
    focusedTag: W,
    groupedOptions: St
  };
}
var vr = "top", Qr = "bottom", Jr = "right", br = "left", h0 = "auto", rc = [vr, Qr, Jr, br], fs = "start", Ml = "end", lM = "clippingParents", E3 = "viewport", Qs = "popper", cM = "reference", ex = /* @__PURE__ */ rc.reduce(function(e, t) {
  return e.concat([t + "-" + fs, t + "-" + Ml]);
}, []), R3 = /* @__PURE__ */ [].concat(rc, [h0]).reduce(function(e, t) {
  return e.concat([t, t + "-" + fs, t + "-" + Ml]);
}, []), uM = "beforeRead", dM = "read", pM = "afterRead", fM = "beforeMain", hM = "main", mM = "afterMain", gM = "beforeWrite", yM = "write", vM = "afterWrite", bM = [uM, dM, pM, fM, hM, mM, gM, yM, vM];
function Lo(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Ir(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function xa(e) {
  var t = Ir(e).Element;
  return e instanceof t || e instanceof Element;
}
function Xr(e) {
  var t = Ir(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function m0(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Ir(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function xM(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, a = t.elements[n];
    !Xr(a) || !Lo(a) || (Object.assign(a.style, r), Object.keys(o).forEach(function(l) {
      var c = o[l];
      c === !1 ? a.removeAttribute(l) : a.setAttribute(l, c === !0 ? "" : c);
    }));
  });
}
function wM(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], a = t.attributes[r] || {}, l = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), c = l.reduce(function(d, p) {
        return d[p] = "", d;
      }, {});
      !Xr(o) || !Lo(o) || (Object.assign(o.style, c), Object.keys(a).forEach(function(d) {
        o.removeAttribute(d);
      }));
    });
  };
}
const $M = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: xM,
  effect: wM,
  requires: ["computeStyles"]
};
function Mo(e) {
  return e.split("-")[0];
}
var ga = Math.max, Zu = Math.min, hs = Math.round;
function bg() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function k3() {
  return !/^((?!chrome|android).)*safari/i.test(bg());
}
function ms(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, a = 1;
  t && Xr(e) && (o = e.offsetWidth > 0 && hs(r.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && hs(r.height) / e.offsetHeight || 1);
  var l = xa(e) ? Ir(e) : window, c = l.visualViewport, d = !k3() && n, p = (r.left + (d && c ? c.offsetLeft : 0)) / o, f = (r.top + (d && c ? c.offsetTop : 0)) / a, m = r.width / o, g = r.height / a;
  return {
    width: m,
    height: g,
    top: f,
    right: p + m,
    bottom: f + g,
    left: p,
    x: p,
    y: f
  };
}
function g0(e) {
  var t = ms(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function _3(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && m0(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function ui(e) {
  return Ir(e).getComputedStyle(e);
}
function CM(e) {
  return ["table", "td", "th"].indexOf(Lo(e)) >= 0;
}
function qi(e) {
  return ((xa(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ld(e) {
  return Lo(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (m0(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    qi(e)
  );
}
function tx(e) {
  return !Xr(e) || // https://github.com/popperjs/popper-core/issues/837
  ui(e).position === "fixed" ? null : e.offsetParent;
}
function SM(e) {
  var t = /firefox/i.test(bg()), n = /Trident/i.test(bg());
  if (n && Xr(e)) {
    var r = ui(e);
    if (r.position === "fixed")
      return null;
  }
  var o = Ld(e);
  for (m0(o) && (o = o.host); Xr(o) && ["html", "body"].indexOf(Lo(o)) < 0; ) {
    var a = ui(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function oc(e) {
  for (var t = Ir(e), n = tx(e); n && CM(n) && ui(n).position === "static"; )
    n = tx(n);
  return n && (Lo(n) === "html" || Lo(n) === "body" && ui(n).position === "static") ? t : n || SM(e) || t;
}
function y0(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function $l(e, t, n) {
  return ga(e, Zu(t, n));
}
function TM(e, t, n) {
  var r = $l(e, t, n);
  return r > n ? n : r;
}
function D3() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function I3(e) {
  return Object.assign({}, D3(), e);
}
function M3(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var OM = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, I3(typeof t != "number" ? t : M3(t, rc));
};
function PM(e) {
  var t, n = e.state, r = e.name, o = e.options, a = n.elements.arrow, l = n.modifiersData.popperOffsets, c = Mo(n.placement), d = y0(c), p = [br, Jr].indexOf(c) >= 0, f = p ? "height" : "width";
  if (!(!a || !l)) {
    var m = OM(o.padding, n), g = g0(a), y = d === "y" ? vr : br, b = d === "y" ? Qr : Jr, v = n.rects.reference[f] + n.rects.reference[d] - l[d] - n.rects.popper[f], $ = l[d] - n.rects.reference[d], S = oc(a), R = S ? d === "y" ? S.clientHeight || 0 : S.clientWidth || 0 : 0, P = v / 2 - $ / 2, T = m[y], O = R - g[f] - m[b], k = R / 2 - g[f] / 2 + P, I = $l(T, k, O), D = d;
    n.modifiersData[r] = (t = {}, t[D] = I, t.centerOffset = I - k, t);
  }
}
function EM(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || _3(t.elements.popper, o) && (t.elements.arrow = o));
}
const RM = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: PM,
  effect: EM,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function gs(e) {
  return e.split("-")[1];
}
var kM = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function _M(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: hs(n * o) / o || 0,
    y: hs(r * o) / o || 0
  };
}
function nx(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, a = e.variation, l = e.offsets, c = e.position, d = e.gpuAcceleration, p = e.adaptive, f = e.roundOffsets, m = e.isFixed, g = l.x, y = g === void 0 ? 0 : g, b = l.y, v = b === void 0 ? 0 : b, $ = typeof f == "function" ? f({
    x: y,
    y: v
  }) : {
    x: y,
    y: v
  };
  y = $.x, v = $.y;
  var S = l.hasOwnProperty("x"), R = l.hasOwnProperty("y"), P = br, T = vr, O = window;
  if (p) {
    var k = oc(n), I = "clientHeight", D = "clientWidth";
    if (k === Ir(n) && (k = qi(n), ui(k).position !== "static" && c === "absolute" && (I = "scrollHeight", D = "scrollWidth")), k = k, o === vr || (o === br || o === Jr) && a === Ml) {
      T = Qr;
      var j = m && k === O && O.visualViewport ? O.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[I]
      );
      v -= j - r.height, v *= d ? 1 : -1;
    }
    if (o === br || (o === vr || o === Qr) && a === Ml) {
      P = Jr;
      var E = m && k === O && O.visualViewport ? O.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[D]
      );
      y -= E - r.width, y *= d ? 1 : -1;
    }
  }
  var M = Object.assign({
    position: c
  }, p && kM), F = f === !0 ? _M({
    x: y,
    y: v
  }, Ir(n)) : {
    x: y,
    y: v
  };
  if (y = F.x, v = F.y, d) {
    var B;
    return Object.assign({}, M, (B = {}, B[T] = R ? "0" : "", B[P] = S ? "0" : "", B.transform = (O.devicePixelRatio || 1) <= 1 ? "translate(" + y + "px, " + v + "px)" : "translate3d(" + y + "px, " + v + "px, 0)", B));
  }
  return Object.assign({}, M, (t = {}, t[T] = R ? v + "px" : "", t[P] = S ? y + "px" : "", t.transform = "", t));
}
function DM(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, a = n.adaptive, l = a === void 0 ? !0 : a, c = n.roundOffsets, d = c === void 0 ? !0 : c, p = {
    placement: Mo(t.placement),
    variation: gs(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, nx(Object.assign({}, p, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: l,
    roundOffsets: d
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, nx(Object.assign({}, p, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: d
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const IM = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: DM,
  data: {}
};
var fu = {
  passive: !0
};
function MM(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, a = o === void 0 ? !0 : o, l = r.resize, c = l === void 0 ? !0 : l, d = Ir(t.elements.popper), p = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && p.forEach(function(f) {
    f.addEventListener("scroll", n.update, fu);
  }), c && d.addEventListener("resize", n.update, fu), function() {
    a && p.forEach(function(f) {
      f.removeEventListener("scroll", n.update, fu);
    }), c && d.removeEventListener("resize", n.update, fu);
  };
}
const AM = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: MM,
  data: {}
};
var NM = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Iu(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return NM[t];
  });
}
var jM = {
  start: "end",
  end: "start"
};
function rx(e) {
  return e.replace(/start|end/g, function(t) {
    return jM[t];
  });
}
function v0(e) {
  var t = Ir(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function b0(e) {
  return ms(qi(e)).left + v0(e).scrollLeft;
}
function FM(e, t) {
  var n = Ir(e), r = qi(e), o = n.visualViewport, a = r.clientWidth, l = r.clientHeight, c = 0, d = 0;
  if (o) {
    a = o.width, l = o.height;
    var p = k3();
    (p || !p && t === "fixed") && (c = o.offsetLeft, d = o.offsetTop);
  }
  return {
    width: a,
    height: l,
    x: c + b0(e),
    y: d
  };
}
function LM(e) {
  var t, n = qi(e), r = v0(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, a = ga(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), l = ga(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), c = -r.scrollLeft + b0(e), d = -r.scrollTop;
  return ui(o || n).direction === "rtl" && (c += ga(n.clientWidth, o ? o.clientWidth : 0) - a), {
    width: a,
    height: l,
    x: c,
    y: d
  };
}
function x0(e) {
  var t = ui(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function A3(e) {
  return ["html", "body", "#document"].indexOf(Lo(e)) >= 0 ? e.ownerDocument.body : Xr(e) && x0(e) ? e : A3(Ld(e));
}
function Cl(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = A3(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), a = Ir(r), l = o ? [a].concat(a.visualViewport || [], x0(r) ? r : []) : r, c = t.concat(l);
  return o ? c : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    c.concat(Cl(Ld(l)))
  );
}
function xg(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function BM(e, t) {
  var n = ms(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function ox(e, t, n) {
  return t === E3 ? xg(FM(e, n)) : xa(t) ? BM(t, n) : xg(LM(qi(e)));
}
function VM(e) {
  var t = Cl(Ld(e)), n = ["absolute", "fixed"].indexOf(ui(e).position) >= 0, r = n && Xr(e) ? oc(e) : e;
  return xa(r) ? t.filter(function(o) {
    return xa(o) && _3(o, r) && Lo(o) !== "body";
  }) : [];
}
function zM(e, t, n, r) {
  var o = t === "clippingParents" ? VM(e) : [].concat(t), a = [].concat(o, [n]), l = a[0], c = a.reduce(function(d, p) {
    var f = ox(e, p, r);
    return d.top = ga(f.top, d.top), d.right = Zu(f.right, d.right), d.bottom = Zu(f.bottom, d.bottom), d.left = ga(f.left, d.left), d;
  }, ox(e, l, r));
  return c.width = c.right - c.left, c.height = c.bottom - c.top, c.x = c.left, c.y = c.top, c;
}
function N3(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? Mo(r) : null, a = r ? gs(r) : null, l = t.x + t.width / 2 - n.width / 2, c = t.y + t.height / 2 - n.height / 2, d;
  switch (o) {
    case vr:
      d = {
        x: l,
        y: t.y - n.height
      };
      break;
    case Qr:
      d = {
        x: l,
        y: t.y + t.height
      };
      break;
    case Jr:
      d = {
        x: t.x + t.width,
        y: c
      };
      break;
    case br:
      d = {
        x: t.x - n.width,
        y: c
      };
      break;
    default:
      d = {
        x: t.x,
        y: t.y
      };
  }
  var p = o ? y0(o) : null;
  if (p != null) {
    var f = p === "y" ? "height" : "width";
    switch (a) {
      case fs:
        d[p] = d[p] - (t[f] / 2 - n[f] / 2);
        break;
      case Ml:
        d[p] = d[p] + (t[f] / 2 - n[f] / 2);
        break;
    }
  }
  return d;
}
function Al(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, a = n.strategy, l = a === void 0 ? e.strategy : a, c = n.boundary, d = c === void 0 ? lM : c, p = n.rootBoundary, f = p === void 0 ? E3 : p, m = n.elementContext, g = m === void 0 ? Qs : m, y = n.altBoundary, b = y === void 0 ? !1 : y, v = n.padding, $ = v === void 0 ? 0 : v, S = I3(typeof $ != "number" ? $ : M3($, rc)), R = g === Qs ? cM : Qs, P = e.rects.popper, T = e.elements[b ? R : g], O = zM(xa(T) ? T : T.contextElement || qi(e.elements.popper), d, f, l), k = ms(e.elements.reference), I = N3({
    reference: k,
    element: P,
    placement: o
  }), D = xg(Object.assign({}, P, I)), j = g === Qs ? D : k, E = {
    top: O.top - j.top + S.top,
    bottom: j.bottom - O.bottom + S.bottom,
    left: O.left - j.left + S.left,
    right: j.right - O.right + S.right
  }, M = e.modifiersData.offset;
  if (g === Qs && M) {
    var F = M[o];
    Object.keys(E).forEach(function(B) {
      var V = [Jr, Qr].indexOf(B) >= 0 ? 1 : -1, z = [vr, Qr].indexOf(B) >= 0 ? "y" : "x";
      E[B] += F[z] * V;
    });
  }
  return E;
}
function WM(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, a = n.rootBoundary, l = n.padding, c = n.flipVariations, d = n.allowedAutoPlacements, p = d === void 0 ? R3 : d, f = gs(r), m = f ? c ? ex : ex.filter(function(b) {
    return gs(b) === f;
  }) : rc, g = m.filter(function(b) {
    return p.indexOf(b) >= 0;
  });
  g.length === 0 && (g = m);
  var y = g.reduce(function(b, v) {
    return b[v] = Al(e, {
      placement: v,
      boundary: o,
      rootBoundary: a,
      padding: l
    })[Mo(v)], b;
  }, {});
  return Object.keys(y).sort(function(b, v) {
    return y[b] - y[v];
  });
}
function qM(e) {
  if (Mo(e) === h0)
    return [];
  var t = Iu(e);
  return [rx(e), t, rx(t)];
}
function UM(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, a = o === void 0 ? !0 : o, l = n.altAxis, c = l === void 0 ? !0 : l, d = n.fallbackPlacements, p = n.padding, f = n.boundary, m = n.rootBoundary, g = n.altBoundary, y = n.flipVariations, b = y === void 0 ? !0 : y, v = n.allowedAutoPlacements, $ = t.options.placement, S = Mo($), R = S === $, P = d || (R || !b ? [Iu($)] : qM($)), T = [$].concat(P).reduce(function(fe, X) {
      return fe.concat(Mo(X) === h0 ? WM(t, {
        placement: X,
        boundary: f,
        rootBoundary: m,
        padding: p,
        flipVariations: b,
        allowedAutoPlacements: v
      }) : X);
    }, []), O = t.rects.reference, k = t.rects.popper, I = /* @__PURE__ */ new Map(), D = !0, j = T[0], E = 0; E < T.length; E++) {
      var M = T[E], F = Mo(M), B = gs(M) === fs, V = [vr, Qr].indexOf(F) >= 0, z = V ? "width" : "height", L = Al(t, {
        placement: M,
        boundary: f,
        rootBoundary: m,
        altBoundary: g,
        padding: p
      }), G = V ? B ? Jr : br : B ? Qr : vr;
      O[z] > k[z] && (G = Iu(G));
      var se = Iu(G), ne = [];
      if (a && ne.push(L[F] <= 0), c && ne.push(L[G] <= 0, L[se] <= 0), ne.every(function(fe) {
        return fe;
      })) {
        j = M, D = !1;
        break;
      }
      I.set(M, ne);
    }
    if (D)
      for (var K = b ? 3 : 1, Q = function(X) {
        var re = T.find(function(ie) {
          var Y = I.get(ie);
          if (Y)
            return Y.slice(0, X).every(function(Z) {
              return Z;
            });
        });
        if (re)
          return j = re, "break";
      }, ye = K; ye > 0; ye--) {
        var we = Q(ye);
        if (we === "break") break;
      }
    t.placement !== j && (t.modifiersData[r]._skip = !0, t.placement = j, t.reset = !0);
  }
}
const HM = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: UM,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ix(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function ax(e) {
  return [vr, Jr, Qr, br].some(function(t) {
    return e[t] >= 0;
  });
}
function GM(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, a = t.modifiersData.preventOverflow, l = Al(t, {
    elementContext: "reference"
  }), c = Al(t, {
    altBoundary: !0
  }), d = ix(l, r), p = ix(c, o, a), f = ax(d), m = ax(p);
  t.modifiersData[n] = {
    referenceClippingOffsets: d,
    popperEscapeOffsets: p,
    isReferenceHidden: f,
    hasPopperEscaped: m
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": m
  });
}
const YM = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: GM
};
function KM(e, t, n) {
  var r = Mo(e), o = [br, vr].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, l = a[0], c = a[1];
  return l = l || 0, c = (c || 0) * o, [br, Jr].indexOf(r) >= 0 ? {
    x: c,
    y: l
  } : {
    x: l,
    y: c
  };
}
function XM(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, a = o === void 0 ? [0, 0] : o, l = R3.reduce(function(f, m) {
    return f[m] = KM(m, t.rects, a), f;
  }, {}), c = l[t.placement], d = c.x, p = c.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += d, t.modifiersData.popperOffsets.y += p), t.modifiersData[r] = l;
}
const ZM = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: XM
};
function QM(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = N3({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const JM = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: QM,
  data: {}
};
function e7(e) {
  return e === "x" ? "y" : "x";
}
function t7(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, a = o === void 0 ? !0 : o, l = n.altAxis, c = l === void 0 ? !1 : l, d = n.boundary, p = n.rootBoundary, f = n.altBoundary, m = n.padding, g = n.tether, y = g === void 0 ? !0 : g, b = n.tetherOffset, v = b === void 0 ? 0 : b, $ = Al(t, {
    boundary: d,
    rootBoundary: p,
    padding: m,
    altBoundary: f
  }), S = Mo(t.placement), R = gs(t.placement), P = !R, T = y0(S), O = e7(T), k = t.modifiersData.popperOffsets, I = t.rects.reference, D = t.rects.popper, j = typeof v == "function" ? v(Object.assign({}, t.rects, {
    placement: t.placement
  })) : v, E = typeof j == "number" ? {
    mainAxis: j,
    altAxis: j
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, j), M = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, F = {
    x: 0,
    y: 0
  };
  if (k) {
    if (a) {
      var B, V = T === "y" ? vr : br, z = T === "y" ? Qr : Jr, L = T === "y" ? "height" : "width", G = k[T], se = G + $[V], ne = G - $[z], K = y ? -D[L] / 2 : 0, Q = R === fs ? I[L] : D[L], ye = R === fs ? -D[L] : -I[L], we = t.elements.arrow, fe = y && we ? g0(we) : {
        width: 0,
        height: 0
      }, X = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : D3(), re = X[V], ie = X[z], Y = $l(0, I[L], fe[L]), Z = P ? I[L] / 2 - K - Y - re - E.mainAxis : Q - Y - re - E.mainAxis, ue = P ? -I[L] / 2 + K + Y + ie + E.mainAxis : ye + Y + ie + E.mainAxis, ge = t.elements.arrow && oc(t.elements.arrow), W = ge ? T === "y" ? ge.clientTop || 0 : ge.clientLeft || 0 : 0, J = (B = M == null ? void 0 : M[T]) != null ? B : 0, le = G + Z - J - W, me = G + ue - J, be = $l(y ? Zu(se, le) : se, G, y ? ga(ne, me) : ne);
      k[T] = be, F[T] = be - G;
    }
    if (c) {
      var de, Oe = T === "x" ? vr : br, Re = T === "x" ? Qr : Jr, We = k[O], Ye = O === "y" ? "height" : "width", Ie = We + $[Oe], kt = We - $[Re], Ee = [vr, br].indexOf(S) !== -1, Ae = (de = M == null ? void 0 : M[O]) != null ? de : 0, pt = Ee ? Ie : We - I[Ye] - D[Ye] - Ae + E.altAxis, Ue = Ee ? We + I[Ye] + D[Ye] - Ae - E.altAxis : kt, et = y && Ee ? TM(pt, We, Ue) : $l(y ? pt : Ie, We, y ? Ue : kt);
      k[O] = et, F[O] = et - We;
    }
    t.modifiersData[r] = F;
  }
}
const n7 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: t7,
  requiresIfExists: ["offset"]
};
function r7(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function o7(e) {
  return e === Ir(e) || !Xr(e) ? v0(e) : r7(e);
}
function i7(e) {
  var t = e.getBoundingClientRect(), n = hs(t.width) / e.offsetWidth || 1, r = hs(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function a7(e, t, n) {
  n === void 0 && (n = !1);
  var r = Xr(t), o = Xr(t) && i7(t), a = qi(t), l = ms(e, o, n), c = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Lo(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  x0(a)) && (c = o7(t)), Xr(t) ? (d = ms(t, !0), d.x += t.clientLeft, d.y += t.clientTop) : a && (d.x = b0(a))), {
    x: l.left + c.scrollLeft - d.x,
    y: l.top + c.scrollTop - d.y,
    width: l.width,
    height: l.height
  };
}
function s7(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function o(a) {
    n.add(a.name);
    var l = [].concat(a.requires || [], a.requiresIfExists || []);
    l.forEach(function(c) {
      if (!n.has(c)) {
        var d = t.get(c);
        d && o(d);
      }
    }), r.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || o(a);
  }), r;
}
function l7(e) {
  var t = s7(e);
  return bM.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function c7(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function u7(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var sx = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function lx() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function d7(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, a = o === void 0 ? sx : o;
  return function(c, d, p) {
    p === void 0 && (p = a);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, sx, a),
      modifiersData: {},
      elements: {
        reference: c,
        popper: d
      },
      attributes: {},
      styles: {}
    }, m = [], g = !1, y = {
      state: f,
      setOptions: function(S) {
        var R = typeof S == "function" ? S(f.options) : S;
        v(), f.options = Object.assign({}, a, f.options, R), f.scrollParents = {
          reference: xa(c) ? Cl(c) : c.contextElement ? Cl(c.contextElement) : [],
          popper: Cl(d)
        };
        var P = l7(u7([].concat(r, f.options.modifiers)));
        return f.orderedModifiers = P.filter(function(T) {
          return T.enabled;
        }), b(), y.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var S = f.elements, R = S.reference, P = S.popper;
          if (lx(R, P)) {
            f.rects = {
              reference: a7(R, oc(P), f.options.strategy === "fixed"),
              popper: g0(P)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(E) {
              return f.modifiersData[E.name] = Object.assign({}, E.data);
            });
            for (var T = 0; T < f.orderedModifiers.length; T++) {
              if (f.reset === !0) {
                f.reset = !1, T = -1;
                continue;
              }
              var O = f.orderedModifiers[T], k = O.fn, I = O.options, D = I === void 0 ? {} : I, j = O.name;
              typeof k == "function" && (f = k({
                state: f,
                options: D,
                name: j,
                instance: y
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: c7(function() {
        return new Promise(function($) {
          y.forceUpdate(), $(f);
        });
      }),
      destroy: function() {
        v(), g = !0;
      }
    };
    if (!lx(c, d))
      return y;
    y.setOptions(p).then(function($) {
      !g && p.onFirstUpdate && p.onFirstUpdate($);
    });
    function b() {
      f.orderedModifiers.forEach(function($) {
        var S = $.name, R = $.options, P = R === void 0 ? {} : R, T = $.effect;
        if (typeof T == "function") {
          var O = T({
            state: f,
            name: S,
            instance: y,
            options: P
          }), k = function() {
          };
          m.push(O || k);
        }
      });
    }
    function v() {
      m.forEach(function($) {
        return $();
      }), m = [];
    }
    return y;
  };
}
var p7 = [AM, JM, IM, $M, ZM, HM, n7, RM, YM], f7 = /* @__PURE__ */ d7({
  defaultModifiers: p7
});
function h7(e) {
  return typeof e == "function" ? e() : e;
}
const Nl = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    children: r,
    container: o,
    disablePortal: a = !1
  } = t, [l, c] = w.useState(null), d = It(/* @__PURE__ */ w.isValidElement(r) ? Os(r) : null, n);
  if (Nn(() => {
    a || c(h7(o) || document.body);
  }, [o, a]), Nn(() => {
    if (l && !a)
      return Wu(n, l), () => {
        Wu(n, null);
      };
  }, [n, l, a]), a) {
    if (/* @__PURE__ */ w.isValidElement(r)) {
      const p = {
        ref: d
      };
      return /* @__PURE__ */ w.cloneElement(r, p);
    }
    return r;
  }
  return l && /* @__PURE__ */ Lk.createPortal(r, l);
});
process.env.NODE_ENV !== "production" && (Nl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: i.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: i.oneOfType([li, i.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: i.bool
});
process.env.NODE_ENV !== "production" && (Nl.propTypes = Id(Nl.propTypes));
function m7(e) {
  return Fe("MuiPopper", e);
}
Le("MuiPopper", ["root"]);
function g7(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function Qu(e) {
  return typeof e == "function" ? e() : e;
}
function Bd(e) {
  return e.nodeType !== void 0;
}
function y7(e) {
  return !Bd(e);
}
const v7 = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"]
  }, m7, t);
}, b7 = {}, x7 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: o,
    direction: a,
    disablePortal: l,
    modifiers: c,
    open: d,
    placement: p,
    popperOptions: f,
    popperRef: m,
    slotProps: g = {},
    slots: y = {},
    TransitionProps: b,
    // @ts-ignore internal logic
    ownerState: v,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...$
  } = t, S = w.useRef(null), R = It(S, n), P = w.useRef(null), T = It(P, m), O = w.useRef(T);
  Nn(() => {
    O.current = T;
  }, [T]), w.useImperativeHandle(m, () => P.current, []);
  const k = g7(p, a), [I, D] = w.useState(k), [j, E] = w.useState(Qu(r));
  w.useEffect(() => {
    P.current && P.current.forceUpdate();
  }), w.useEffect(() => {
    r && E(Qu(r));
  }, [r]), Nn(() => {
    if (!j || !d)
      return;
    const z = (se) => {
      D(se.placement);
    };
    if (process.env.NODE_ENV !== "production" && j && Bd(j) && j.nodeType === 1) {
      const se = j.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && se.top === 0 && se.left === 0 && se.right === 0 && se.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let L = [{
      name: "preventOverflow",
      options: {
        altBoundary: l
      }
    }, {
      name: "flip",
      options: {
        altBoundary: l
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: se
      }) => {
        z(se);
      }
    }];
    c != null && (L = L.concat(c)), f && f.modifiers != null && (L = L.concat(f.modifiers));
    const G = f7(j, S.current, {
      placement: k,
      ...f,
      modifiers: L
    });
    return O.current(G), () => {
      G.destroy(), O.current(null);
    };
  }, [j, l, c, d, f, k]);
  const M = {
    placement: I
  };
  b !== null && (M.TransitionProps = b);
  const F = v7(t), B = y.root ?? "div", V = Lt({
    elementType: B,
    externalSlotProps: g.root,
    externalForwardedProps: $,
    additionalProps: {
      role: "tooltip",
      ref: R
    },
    ownerState: t,
    className: F.root
  });
  return /* @__PURE__ */ x.jsx(B, {
    ...V,
    children: typeof o == "function" ? o(M) : o
  });
}), j3 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: o,
    container: a,
    direction: l = "ltr",
    disablePortal: c = !1,
    keepMounted: d = !1,
    modifiers: p,
    open: f,
    placement: m = "bottom",
    popperOptions: g = b7,
    popperRef: y,
    style: b,
    transition: v = !1,
    slotProps: $ = {},
    slots: S = {},
    ...R
  } = t, [P, T] = w.useState(!0), O = () => {
    T(!1);
  }, k = () => {
    T(!0);
  };
  if (!d && !f && (!v || P))
    return null;
  let I;
  if (a)
    I = a;
  else if (r) {
    const E = Qu(r);
    I = E && Bd(E) ? er(E).body : er(null).body;
  }
  const D = !f && d && (!v || P) ? "none" : void 0, j = v ? {
    in: f,
    onEnter: O,
    onExited: k
  } : void 0;
  return /* @__PURE__ */ x.jsx(Nl, {
    disablePortal: c,
    container: I,
    children: /* @__PURE__ */ x.jsx(x7, {
      anchorEl: r,
      direction: l,
      disablePortal: c,
      modifiers: p,
      ref: n,
      open: v ? !P : f,
      placement: m,
      popperOptions: g,
      popperRef: y,
      slotProps: $,
      slots: S,
      ...R,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: D,
        ...b
      },
      TransitionProps: j,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (j3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: yo(i.oneOfType([li, i.object, i.func]), (e) => {
    if (e.open) {
      const t = Qu(e.anchorEl);
      if (t && Bd(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || y7(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: i.oneOfType([i.node, i.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: i.oneOfType([li, i.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: i.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: i.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: i.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: i.arrayOf(i.shape({
    data: i.object,
    effect: i.func,
    enabled: i.bool,
    fn: i.func,
    name: i.any,
    options: i.object,
    phase: i.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: i.arrayOf(i.string),
    requiresIfExists: i.arrayOf(i.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: i.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: i.shape({
    modifiers: i.array,
    onFirstUpdate: i.func,
    placement: i.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: i.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: gn,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: i.shape({
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: i.shape({
    root: i.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: i.bool
});
const w7 = ae(j3, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Es = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = no(), o = lt({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: a,
    component: l,
    components: c,
    componentsProps: d,
    container: p,
    disablePortal: f,
    keepMounted: m,
    modifiers: g,
    open: y,
    placement: b,
    popperOptions: v,
    popperRef: $,
    transition: S,
    slots: R,
    slotProps: P,
    ...T
  } = o, O = (R == null ? void 0 : R.root) ?? (c == null ? void 0 : c.Root), k = {
    anchorEl: a,
    container: p,
    disablePortal: f,
    keepMounted: m,
    modifiers: g,
    open: y,
    placement: b,
    popperOptions: v,
    popperRef: $,
    transition: S,
    ...T
  };
  return /* @__PURE__ */ x.jsx(w7, {
    as: l,
    direction: r ? "rtl" : "ltr",
    slots: {
      root: O
    },
    slotProps: P ?? d,
    ...k,
    ref: n
  });
});
process.env.NODE_ENV !== "production" && (Es.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: i.oneOfType([li, i.object, i.func]),
  /**
   * Popper render function or node.
   */
  children: i.oneOfType([i.node, i.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: i.shape({
    Root: i.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: i.shape({
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: i.oneOfType([li, i.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: i.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: i.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: i.arrayOf(i.shape({
    data: i.object,
    effect: i.func,
    enabled: i.bool,
    fn: i.func,
    name: i.any,
    options: i.object,
    phase: i.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: i.arrayOf(i.string),
    requiresIfExists: i.arrayOf(i.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: i.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: i.shape({
    modifiers: i.array,
    onFirstUpdate: i.func,
    placement: i.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: i.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: gn,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: i.shape({
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: i.shape({
    root: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: i.bool
});
function $7(e) {
  return Fe("MuiListSubheader", e);
}
Le("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const C7 = (e) => {
  const {
    classes: t,
    color: n,
    disableGutters: r,
    inset: o,
    disableSticky: a
  } = e, l = {
    root: ["root", n !== "default" && `color${Pe(n)}`, !r && "gutters", o && "inset", !a && "sticky"]
  };
  return Be(l, $7, t);
}, S7 = ae("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${Pe(n.color)}`], !n.disableGutters && t.gutters, n.inset && t.inset, !n.disableSticky && t.sticky];
  }
})(dt(({
  theme: e
}) => ({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14),
  variants: [{
    props: {
      color: "primary"
    },
    style: {
      color: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.inset,
    style: {
      paddingLeft: 72
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableSticky,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: (e.vars || e).palette.background.paper
    }
  }]
}))), Ju = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: o,
    color: a = "default",
    component: l = "li",
    disableGutters: c = !1,
    disableSticky: d = !1,
    inset: p = !1,
    ...f
  } = r, m = {
    ...r,
    color: a,
    component: l,
    disableGutters: c,
    disableSticky: d,
    inset: p
  }, g = C7(m);
  return /* @__PURE__ */ x.jsx(S7, {
    as: l,
    className: _e(g.root, o),
    ref: n,
    ownerState: m,
    ...f
  });
});
Ju && (Ju.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (Ju.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: i.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: i.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: i.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: i.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
const T7 = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function O7(e) {
  return Fe("MuiChip", e);
}
const Ot = Le("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), P7 = (e) => {
  const {
    classes: t,
    disabled: n,
    size: r,
    color: o,
    iconColor: a,
    onDelete: l,
    clickable: c,
    variant: d
  } = e, p = {
    root: ["root", d, n && "disabled", `size${Pe(r)}`, `color${Pe(o)}`, c && "clickable", c && `clickableColor${Pe(o)}`, l && "deletable", l && `deletableColor${Pe(o)}`, `${d}${Pe(o)}`],
    label: ["label", `label${Pe(r)}`],
    avatar: ["avatar", `avatar${Pe(r)}`, `avatarColor${Pe(o)}`],
    icon: ["icon", `icon${Pe(r)}`, `iconColor${Pe(a)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${Pe(r)}`, `deleteIconColor${Pe(o)}`, `deleteIcon${Pe(d)}Color${Pe(o)}`]
  };
  return Be(p, O7, t);
}, E7 = ae("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      color: r,
      iconColor: o,
      clickable: a,
      onDelete: l,
      size: c,
      variant: d
    } = n;
    return [{
      [`& .${Ot.avatar}`]: t.avatar
    }, {
      [`& .${Ot.avatar}`]: t[`avatar${Pe(c)}`]
    }, {
      [`& .${Ot.avatar}`]: t[`avatarColor${Pe(r)}`]
    }, {
      [`& .${Ot.icon}`]: t.icon
    }, {
      [`& .${Ot.icon}`]: t[`icon${Pe(c)}`]
    }, {
      [`& .${Ot.icon}`]: t[`iconColor${Pe(o)}`]
    }, {
      [`& .${Ot.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${Ot.deleteIcon}`]: t[`deleteIcon${Pe(c)}`]
    }, {
      [`& .${Ot.deleteIcon}`]: t[`deleteIconColor${Pe(r)}`]
    }, {
      [`& .${Ot.deleteIcon}`]: t[`deleteIcon${Pe(d)}Color${Pe(r)}`]
    }, t.root, t[`size${Pe(c)}`], t[`color${Pe(r)}`], a && t.clickable, a && r !== "default" && t[`clickableColor${Pe(r)})`], l && t.deletable, l && r !== "default" && t[`deletableColor${Pe(r)}`], t[d], t[`${d}${Pe(r)}`]];
  }
})(dt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${Ot.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${Ot.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${Ot.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${Ot.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${Ot.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${Ot.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${Ot.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : ht(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : ht(e.palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${Ot.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${Ot.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(e.palette).filter(An(["contrastText"])).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        backgroundColor: (e.vars || e).palette[n].main,
        color: (e.vars || e).palette[n].contrastText,
        [`& .${Ot.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].contrastTextChannel} / 0.7)` : ht(e.palette[n].contrastText, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].contrastText
          }
        }
      }
    })), {
      props: (n) => n.iconColor === n.color,
      style: {
        [`& .${Ot.icon}`]: {
          color: e.vars ? e.vars.palette.Chip.defaultIconColor : t
        }
      }
    }, {
      props: (n) => n.iconColor === n.color && n.color !== "default",
      style: {
        [`& .${Ot.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${Ot.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : ht(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        }
      }
    }, ...Object.entries(e.palette).filter(An(["dark"])).map(([n]) => ({
      props: {
        color: n,
        onDelete: !0
      },
      style: {
        [`&.${Ot.focusVisible}`]: {
          background: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : ht(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
        },
        [`&.${Ot.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : ht(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[1]
        }
      }
    }, ...Object.entries(e.palette).filter(An(["dark"])).map(([n]) => ({
      props: {
        color: n,
        clickable: !0
      },
      style: {
        [`&:hover, &.${Ot.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
        [`&.${Ot.clickable}:hover`]: {
          backgroundColor: (e.vars || e).palette.action.hover
        },
        [`&.${Ot.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette.action.focus
        },
        [`& .${Ot.avatar}`]: {
          marginLeft: 4
        },
        [`& .${Ot.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${Ot.icon}`]: {
          marginLeft: 4
        },
        [`& .${Ot.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${Ot.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${Ot.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(e.palette).filter(An()).map(([n]) => ({
      props: {
        variant: "outlined",
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : ht(e.palette[n].main, 0.7)}`,
        [`&.${Ot.clickable}:hover`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : ht(e.palette[n].main, e.palette.action.hoverOpacity)
        },
        [`&.${Ot.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.focusOpacity})` : ht(e.palette[n].main, e.palette.action.focusOpacity)
        },
        [`& .${Ot.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : ht(e.palette[n].main, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].main
          }
        }
      }
    }))]
  };
})), R7 = ae("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      size: r
    } = n;
    return [t.label, t[`label${Pe(r)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function cx(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const Vd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiChip"
  }), {
    avatar: o,
    className: a,
    clickable: l,
    color: c = "default",
    component: d,
    deleteIcon: p,
    disabled: f = !1,
    icon: m,
    label: g,
    onClick: y,
    onDelete: b,
    onKeyDown: v,
    onKeyUp: $,
    size: S = "medium",
    variant: R = "filled",
    tabIndex: P,
    skipFocusWhenDisabled: T = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    ...O
  } = r, k = w.useRef(null), I = It(k, n), D = (ne) => {
    ne.stopPropagation(), b && b(ne);
  }, j = (ne) => {
    ne.currentTarget === ne.target && cx(ne) && ne.preventDefault(), v && v(ne);
  }, E = (ne) => {
    ne.currentTarget === ne.target && b && cx(ne) && b(ne), $ && $(ne);
  }, M = l !== !1 && y ? !0 : l, F = M || b ? jo : d || "div", B = {
    ...r,
    component: F,
    disabled: f,
    size: S,
    color: c,
    iconColor: /* @__PURE__ */ w.isValidElement(m) && m.props.color || c,
    onDelete: !!b,
    clickable: M,
    variant: R
  }, V = P7(B), z = F === jo ? {
    component: d || "div",
    focusVisibleClassName: V.focusVisible,
    ...b && {
      disableRipple: !0
    }
  } : {};
  let L = null;
  b && (L = p && /* @__PURE__ */ w.isValidElement(p) ? /* @__PURE__ */ w.cloneElement(p, {
    className: _e(p.props.className, V.deleteIcon),
    onClick: D
  }) : /* @__PURE__ */ x.jsx(T7, {
    className: _e(V.deleteIcon),
    onClick: D
  }));
  let G = null;
  o && /* @__PURE__ */ w.isValidElement(o) && (G = /* @__PURE__ */ w.cloneElement(o, {
    className: _e(V.avatar, o.props.className)
  }));
  let se = null;
  return m && /* @__PURE__ */ w.isValidElement(m) && (se = /* @__PURE__ */ w.cloneElement(m, {
    className: _e(V.icon, m.props.className)
  })), process.env.NODE_ENV !== "production" && G && se && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ x.jsxs(E7, {
    as: F,
    className: _e(V.root, a),
    disabled: M && f ? !0 : void 0,
    onClick: y,
    onKeyDown: j,
    onKeyUp: E,
    ref: I,
    tabIndex: T && f ? -1 : P,
    ownerState: B,
    ...z,
    ...O,
    children: [G || se, /* @__PURE__ */ x.jsx(R7, {
      className: _e(V.label),
      ownerState: B,
      children: g
    }), L]
  });
});
process.env.NODE_ENV !== "production" && (Vd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: i.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: O_,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: i.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: i.oneOfType([i.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), i.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: i.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * Icon element.
   */
  icon: i.element,
  /**
   * The content of the component.
   */
  label: i.node,
  /**
   * @ignore
   */
  onClick: i.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: i.func,
  /**
   * @ignore
   */
  onKeyDown: i.func,
  /**
   * @ignore
   */
  onKeyUp: i.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: i.oneOfType([i.oneOf(["medium", "small"]), i.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: i.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * @ignore
   */
  tabIndex: i.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: i.oneOfType([i.oneOf(["filled", "outlined"]), i.string])
});
function hu(e) {
  return parseInt(e, 10) || 0;
}
const k7 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function _7(e) {
  for (const t in e)
    return !1;
  return !0;
}
function D7(e) {
  return _7(e) || e.outerHeightStyle === 0 && !e.overflowing;
}
const F3 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    onChange: r,
    maxRows: o,
    minRows: a = 1,
    style: l,
    value: c,
    ...d
  } = t, {
    current: p
  } = w.useRef(c != null), f = w.useRef(null), m = It(n, f), g = w.useRef(null), y = w.useRef(null), b = w.useCallback(() => {
    const R = f.current, P = y.current;
    if (!R || !P)
      return;
    const O = ci(R).getComputedStyle(R);
    if (O.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    P.style.width = O.width, P.value = R.value || t.placeholder || "x", P.value.slice(-1) === `
` && (P.value += " ");
    const k = O.boxSizing, I = hu(O.paddingBottom) + hu(O.paddingTop), D = hu(O.borderBottomWidth) + hu(O.borderTopWidth), j = P.scrollHeight;
    P.value = "x";
    const E = P.scrollHeight;
    let M = j;
    a && (M = Math.max(Number(a) * E, M)), o && (M = Math.min(Number(o) * E, M)), M = Math.max(M, E);
    const F = M + (k === "border-box" ? I + D : 0), B = Math.abs(M - j) <= 1;
    return {
      outerHeightStyle: F,
      overflowing: B
    };
  }, [o, a, t.placeholder]), v = w.useCallback(() => {
    const R = f.current, P = b();
    if (!R || !P || D7(P))
      return;
    const T = P.outerHeightStyle;
    g.current !== T && (g.current = T, R.style.height = `${T}px`), R.style.overflow = P.overflowing ? "hidden" : "";
  }, [b]), $ = w.useRef(-1);
  Nn(() => {
    const R = o0(() => v()), P = f == null ? void 0 : f.current;
    if (!P)
      return;
    const T = ci(P);
    T.addEventListener("resize", R);
    let O;
    return typeof ResizeObserver < "u" && (O = new ResizeObserver(() => {
      O.unobserve(P), cancelAnimationFrame($.current), v(), $.current = requestAnimationFrame(() => {
        O.observe(P);
      });
    }), O.observe(P)), () => {
      R.clear(), cancelAnimationFrame($.current), T.removeEventListener("resize", R), O && O.disconnect();
    };
  }, [b, v]), Nn(() => {
    v();
  });
  const S = (R) => {
    p || v(), r && r(R);
  };
  return /* @__PURE__ */ x.jsxs(w.Fragment, {
    children: [/* @__PURE__ */ x.jsx("textarea", {
      value: c,
      onChange: S,
      ref: m,
      rows: a,
      style: l,
      ...d
    }), /* @__PURE__ */ x.jsx("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: y,
      tabIndex: -1,
      style: {
        ...k7.shadow,
        ...l,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
process.env.NODE_ENV !== "production" && (F3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: i.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: i.oneOfType([i.number, i.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: i.oneOfType([i.number, i.string]),
  /**
   * @ignore
   */
  onChange: i.func,
  /**
   * @ignore
   */
  placeholder: i.string,
  /**
   * @ignore
   */
  style: i.object,
  /**
   * @ignore
   */
  value: i.oneOfType([i.arrayOf(i.string), i.number, i.string])
});
function jl(e) {
  return typeof e == "string";
}
function Ui({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((r, o) => (r[o] = e[o], n && typeof e[o] > "u" && (r[o] = n[o]), r), {});
}
const ic = /* @__PURE__ */ w.createContext(void 0);
process.env.NODE_ENV !== "production" && (ic.displayName = "FormControlContext");
function cr() {
  return w.useContext(ic);
}
function ux(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function ed(e, t = !1) {
  return e && (ux(e.value) && e.value !== "" || t && ux(e.defaultValue) && e.defaultValue !== "");
}
function I7(e) {
  return e.startAdornment;
}
function M7(e) {
  return Fe("MuiInputBase", e);
}
const Rr = Le("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var dx;
const zd = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${Pe(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, Wd = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, A7 = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    error: o,
    endAdornment: a,
    focused: l,
    formControl: c,
    fullWidth: d,
    hiddenLabel: p,
    multiline: f,
    readOnly: m,
    size: g,
    startAdornment: y,
    type: b
  } = e, v = {
    root: ["root", `color${Pe(n)}`, r && "disabled", o && "error", d && "fullWidth", l && "focused", c && "formControl", g && g !== "medium" && `size${Pe(g)}`, f && "multiline", y && "adornedStart", a && "adornedEnd", p && "hiddenLabel", m && "readOnly"],
    input: ["input", r && "disabled", b === "search" && "inputTypeSearch", f && "inputMultiline", g === "small" && "inputSizeSmall", p && "inputHiddenLabel", y && "inputAdornedStart", a && "inputAdornedEnd", m && "readOnly"]
  };
  return Be(v, M7, t);
}, qd = ae("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: zd
})(dt(({
  theme: e
}) => ({
  ...e.typography.body1,
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${Rr.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: t,
      size: n
    }) => t.multiline && n === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), Ud = ae("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: Wd
})(dt(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = {
    color: "currentColor",
    ...e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: t ? 0.42 : 0.5
    },
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }, r = {
    opacity: "0 !important"
  }, o = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": n,
    "&::-moz-placeholder": n,
    // Firefox 19+
    "&::-ms-input-placeholder": n,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${Rr.formControl} &`]: {
      "&::-webkit-input-placeholder": r,
      "&::-moz-placeholder": r,
      // Firefox 19+
      "&::-ms-input-placeholder": r,
      // Edge
      "&:focus::-webkit-input-placeholder": o,
      "&:focus::-moz-placeholder": o,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": o
      // Edge
    },
    [`&.${Rr.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: a
      }) => !a.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: a
      }) => a.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), px = KD({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), Hd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": o,
    autoComplete: a,
    autoFocus: l,
    className: c,
    color: d,
    components: p = {},
    componentsProps: f = {},
    defaultValue: m,
    disabled: g,
    disableInjectingGlobalStyles: y,
    endAdornment: b,
    error: v,
    fullWidth: $ = !1,
    id: S,
    inputComponent: R = "input",
    inputProps: P = {},
    inputRef: T,
    margin: O,
    maxRows: k,
    minRows: I,
    multiline: D = !1,
    name: j,
    onBlur: E,
    onChange: M,
    onClick: F,
    onFocus: B,
    onKeyDown: V,
    onKeyUp: z,
    placeholder: L,
    readOnly: G,
    renderSuffix: se,
    rows: ne,
    size: K,
    slotProps: Q = {},
    slots: ye = {},
    startAdornment: we,
    type: fe = "text",
    value: X,
    ...re
  } = r, ie = P.value != null ? P.value : X, {
    current: Y
  } = w.useRef(ie != null), Z = w.useRef(), ue = w.useCallback((je) => {
    process.env.NODE_ENV !== "production" && je && je.nodeName !== "INPUT" && !je.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), ge = It(Z, T, P.ref, ue), [W, J] = w.useState(!1), le = cr();
  process.env.NODE_ENV !== "production" && w.useEffect(() => {
    if (le)
      return le.registerEffect();
  }, [le]);
  const me = Ui({
    props: r,
    muiFormControl: le,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  me.focused = le ? le.focused : W, w.useEffect(() => {
    !le && g && W && (J(!1), E && E());
  }, [le, g, W, E]);
  const be = le && le.onFilled, de = le && le.onEmpty, Oe = w.useCallback((je) => {
    ed(je) ? be && be() : de && de();
  }, [be, de]);
  Nn(() => {
    Y && Oe({
      value: ie
    });
  }, [ie, Oe, Y]);
  const Re = (je) => {
    B && B(je), P.onFocus && P.onFocus(je), le && le.onFocus ? le.onFocus(je) : J(!0);
  }, We = (je) => {
    E && E(je), P.onBlur && P.onBlur(je), le && le.onBlur ? le.onBlur(je) : J(!1);
  }, Ye = (je, ...$t) => {
    if (!Y) {
      const Pt = je.target || Z.current;
      if (Pt == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : No(1));
      Oe({
        value: Pt.value
      });
    }
    P.onChange && P.onChange(je, ...$t), M && M(je, ...$t);
  };
  w.useEffect(() => {
    Oe(Z.current);
  }, []);
  const Ie = (je) => {
    Z.current && je.currentTarget === je.target && Z.current.focus(), F && F(je);
  };
  let kt = R, Ee = P;
  D && kt === "input" && (ne ? (process.env.NODE_ENV !== "production" && (I || k) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), Ee = {
    type: void 0,
    minRows: ne,
    maxRows: ne,
    ...Ee
  }) : Ee = {
    type: void 0,
    maxRows: k,
    minRows: I,
    ...Ee
  }, kt = F3);
  const Ae = (je) => {
    Oe(je.animationName === "mui-auto-fill-cancel" ? Z.current : {
      value: "x"
    });
  };
  w.useEffect(() => {
    le && le.setAdornedStart(!!we);
  }, [le, we]);
  const pt = {
    ...r,
    color: me.color || "primary",
    disabled: me.disabled,
    endAdornment: b,
    error: me.error,
    focused: me.focused,
    formControl: le,
    fullWidth: $,
    hiddenLabel: me.hiddenLabel,
    multiline: D,
    size: me.size,
    startAdornment: we,
    type: fe
  }, Ue = A7(pt), et = ye.root || p.Root || qd, Je = Q.root || f.root || {}, rt = ye.input || p.Input || Ud;
  return Ee = {
    ...Ee,
    ...Q.input ?? f.input
  }, /* @__PURE__ */ x.jsxs(w.Fragment, {
    children: [!y && typeof px == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (dx || (dx = /* @__PURE__ */ x.jsx(px, {}))), /* @__PURE__ */ x.jsxs(et, {
      ...Je,
      ref: n,
      onClick: Ie,
      ...re,
      ...!jl(et) && {
        ownerState: {
          ...pt,
          ...Je.ownerState
        }
      },
      className: _e(Ue.root, Je.className, c, G && "MuiInputBase-readOnly"),
      children: [we, /* @__PURE__ */ x.jsx(ic.Provider, {
        value: null,
        children: /* @__PURE__ */ x.jsx(rt, {
          "aria-invalid": me.error,
          "aria-describedby": o,
          autoComplete: a,
          autoFocus: l,
          defaultValue: m,
          disabled: me.disabled,
          id: S,
          onAnimationStart: Ae,
          name: j,
          placeholder: L,
          readOnly: G,
          required: me.required,
          rows: ne,
          value: ie,
          onKeyDown: V,
          onKeyUp: z,
          type: fe,
          ...Ee,
          ...!jl(rt) && {
            as: kt,
            ownerState: {
              ...pt,
              ...Ee.ownerState
            }
          },
          ref: ge,
          className: _e(Ue.input, Ee.className, G && "MuiInputBase-readOnly"),
          onBlur: We,
          onChange: Ye,
          onFocus: Re
        })
      }), b, se ? se({
        ...me,
        startAdornment: we
      }) : null]
    })]
  });
});
process.env.NODE_ENV !== "production" && (Hd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": i.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: i.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: i.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: i.oneOfType([i.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), i.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: i.shape({
    Input: i.elementType,
    Root: i.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: i.shape({
    input: i.object,
    root: i.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: i.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: i.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: i.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: i.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: i.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: i.bool,
  /**
   * The id of the `input` element.
   */
  id: i.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: Dd,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: i.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: i.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: i.oneOfType([i.number, i.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: i.oneOfType([i.number, i.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: i.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: i.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: i.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: i.func,
  /**
   * @ignore
   */
  onClick: i.func,
  /**
   * @ignore
   */
  onFocus: i.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: i.func,
  /**
   * @ignore
   */
  onKeyDown: i.func,
  /**
   * @ignore
   */
  onKeyUp: i.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: i.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: i.bool,
  /**
   * @ignore
   */
  renderSuffix: i.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: i.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: i.oneOfType([i.number, i.string]),
  /**
   * The size of the component.
   */
  size: i.oneOfType([i.oneOf(["medium", "small"]), i.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: i.shape({
    input: i.object,
    root: i.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: i.shape({
    input: i.elementType,
    root: i.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: i.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: i.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: i.any
});
function N7(e) {
  return Fe("MuiInput", e);
}
const Ni = {
  ...Rr,
  ...Le("MuiInput", ["root", "underline", "input"])
};
function j7(e) {
  return Fe("MuiOutlinedInput", e);
}
const Ur = {
  ...Rr,
  ...Le("MuiOutlinedInput", ["root", "notchedOutline", "input"])
};
function F7(e) {
  return Fe("MuiFilledInput", e);
}
const kr = {
  ...Rr,
  ...Le("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, L3 = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function L7(e) {
  return Fe("MuiAutocomplete", e);
}
const wt = Le("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var fx, hx;
const B7 = (e) => {
  const {
    classes: t,
    disablePortal: n,
    expanded: r,
    focused: o,
    fullWidth: a,
    hasClearIcon: l,
    hasPopupIcon: c,
    inputFocused: d,
    popupOpen: p,
    size: f
  } = e, m = {
    root: ["root", r && "expanded", o && "focused", a && "fullWidth", l && "hasClearIcon", c && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", d && "inputFocused"],
    tag: ["tag", `tagSize${Pe(f)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", p && "popupIndicatorOpen"],
    popper: ["popper", n && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return Be(m, L7, t);
}, V7 = ae("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      fullWidth: r,
      hasClearIcon: o,
      hasPopupIcon: a,
      inputFocused: l,
      size: c
    } = n;
    return [{
      [`& .${wt.tag}`]: t.tag
    }, {
      [`& .${wt.tag}`]: t[`tagSize${Pe(c)}`]
    }, {
      [`& .${wt.inputRoot}`]: t.inputRoot
    }, {
      [`& .${wt.input}`]: t.input
    }, {
      [`& .${wt.input}`]: l && t.inputFocused
    }, t.root, r && t.fullWidth, a && t.hasPopupIcon, o && t.hasClearIcon];
  }
})({
  [`&.${wt.focused} .${wt.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${wt.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${wt.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${wt.inputRoot}`]: {
    [`.${wt.hasPopupIcon}&, .${wt.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${wt.hasPopupIcon}.${wt.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${wt.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${Ni.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${Ni.root}.${Rr.sizeSmall}`]: {
    [`& .${Ni.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${Ur.root}`]: {
    padding: 9,
    [`.${wt.hasPopupIcon}&, .${wt.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${wt.hasPopupIcon}.${wt.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${wt.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${wt.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${Ur.root}.${Rr.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${wt.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${kr.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${wt.hasPopupIcon}&, .${wt.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${wt.hasPopupIcon}.${wt.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${kr.input}`]: {
      padding: "7px 4px"
    },
    [`& .${wt.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${kr.root}.${Rr.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${kr.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${Rr.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${kr.root}.${Rr.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${wt.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${kr.root}.${Rr.hiddenLabel}.${Rr.sizeSmall}`]: {
    [`& .${wt.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${wt.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${wt.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${wt.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${wt.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), z7 = ae("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), W7 = ae(Vo, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), q7 = ae(Vo, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popupIndicator, n.popupOpen && t.popupIndicatorOpen];
  }
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), U7 = ae(Es, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${wt.option}`]: t.option
    }, t.popper, n.disablePortal && t.popperDisablePortal];
  }
})(dt(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
}))), H7 = ae(mi, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(dt(({
  theme: e
}) => ({
  ...e.typography.body1,
  overflow: "auto"
}))), G7 = ae("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})(dt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), Y7 = ae("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})(dt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), K7 = ae("ul", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(dt(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${wt.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${wt.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${wt.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : ht(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${wt.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : ht(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${wt.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : ht(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
}))), X7 = ae(Ju, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})(dt(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
}))), Z7 = ae("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${wt.option}`]: {
    paddingLeft: 24
  }
}), ac = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: o = !1,
    autoHighlight: a = !1,
    autoSelect: l = !1,
    blurOnSelect: c = !1,
    ChipProps: d,
    className: p,
    clearIcon: f = fx || (fx = /* @__PURE__ */ x.jsx(P3, {
      fontSize: "small"
    })),
    clearOnBlur: m = !r.freeSolo,
    clearOnEscape: g = !1,
    clearText: y = "Clear",
    closeText: b = "Close",
    componentsProps: v,
    defaultValue: $ = r.multiple ? [] : null,
    disableClearable: S = !1,
    disableCloseOnSelect: R = !1,
    disabled: P = !1,
    disabledItemsFocusable: T = !1,
    disableListWrap: O = !1,
    disablePortal: k = !1,
    filterOptions: I,
    filterSelectedOptions: D = !1,
    forcePopupIcon: j = "auto",
    freeSolo: E = !1,
    fullWidth: M = !1,
    getLimitTagsText: F = (Mt) => `+${Mt}`,
    getOptionDisabled: B,
    getOptionKey: V,
    getOptionLabel: z,
    isOptionEqualToValue: L,
    groupBy: G,
    handleHomeEndKeys: se = !r.freeSolo,
    id: ne,
    includeInputInList: K = !1,
    inputValue: Q,
    limitTags: ye = -1,
    ListboxComponent: we,
    ListboxProps: fe,
    loading: X = !1,
    loadingText: re = "Loading…",
    multiple: ie = !1,
    noOptionsText: Y = "No options",
    onChange: Z,
    onClose: ue,
    onHighlightChange: ge,
    onInputChange: W,
    onOpen: J,
    open: le,
    openOnFocus: me = !1,
    openText: be = "Open",
    options: de,
    PaperComponent: Oe,
    PopperComponent: Re,
    popupIcon: We = hx || (hx = /* @__PURE__ */ x.jsx(L3, {})),
    readOnly: Ye = !1,
    renderGroup: Ie,
    renderInput: kt,
    renderOption: Ee,
    renderTags: Ae,
    selectOnFocus: pt = !r.freeSolo,
    size: Ue = "medium",
    slots: et = {},
    slotProps: Je = {},
    value: rt,
    ...je
  } = r, {
    getRootProps: $t,
    getInputProps: Pt,
    getInputLabelProps: Ft,
    getPopupIndicatorProps: Jt,
    getClearProps: Me,
    getTagProps: it,
    getListboxProps: bt,
    getOptionProps: gt,
    value: Et,
    dirty: xn,
    expanded: ln,
    id: wr,
    popupOpen: Yn,
    focused: oo,
    focusedTag: vo,
    anchorEl: tt,
    setAnchorEl: In,
    inputValue: bo,
    groupedOptions: io
  } = sM({
    ...r,
    componentName: "Autocomplete"
  }), Ar = !S && !P && xn && !Ye, xo = (!E || j === !0) && j !== !1, {
    onMouseDown: zo
  } = Pt(), {
    ref: Hi,
    ...Gi
  } = bt(), U = z || ((Mt) => Mt.label ?? Mt), Ce = {
    ...r,
    disablePortal: k,
    expanded: ln,
    focused: oo,
    fullWidth: M,
    getOptionLabel: U,
    hasClearIcon: Ar,
    hasPopupIcon: xo,
    inputFocused: vo === -1,
    popupOpen: Yn,
    size: Ue
  }, De = B7(Ce), Ze = {
    slots: {
      paper: Oe,
      popper: Re,
      ...et
    },
    slotProps: {
      chip: d,
      listbox: fe,
      ...v,
      ...Je
    }
  }, [St, pe] = Nt("listbox", {
    elementType: K7,
    externalForwardedProps: Ze,
    ownerState: Ce,
    className: De.listbox,
    additionalProps: Gi,
    ref: Hi
  }), [ce, Te] = Nt("paper", {
    elementType: mi,
    externalForwardedProps: Ze,
    ownerState: Ce,
    className: De.paper
  }), [Ke, Ge] = Nt("popper", {
    elementType: Es,
    externalForwardedProps: Ze,
    ownerState: Ce,
    className: De.popper,
    additionalProps: {
      disablePortal: k,
      style: {
        width: tt ? tt.clientWidth : null
      },
      role: "presentation",
      anchorEl: tt,
      open: Yn
    }
  });
  let nt;
  if (ie && Et.length > 0) {
    const Mt = ($r) => ({
      className: De.tag,
      disabled: P,
      ...it($r)
    });
    Ae ? nt = Ae(Et, Mt, Ce) : nt = Et.map(($r, ao) => {
      const {
        key: Ki,
        ...$p
      } = Mt({
        index: ao
      });
      return /* @__PURE__ */ x.jsx(Vd, {
        label: U($r),
        size: Ue,
        ...$p,
        ...Ze.slotProps.chip
      }, Ki);
    });
  }
  if (ye > -1 && Array.isArray(nt)) {
    const Mt = nt.length - ye;
    !oo && Mt > 0 && (nt = nt.splice(0, ye), nt.push(/* @__PURE__ */ x.jsx("span", {
      className: De.tag,
      children: F(Mt)
    }, nt.length)));
  }
  const rn = Ie || ((Mt) => /* @__PURE__ */ x.jsxs("li", {
    children: [/* @__PURE__ */ x.jsx(X7, {
      className: De.groupLabel,
      ownerState: Ce,
      component: "div",
      children: Mt.group
    }), /* @__PURE__ */ x.jsx(Z7, {
      className: De.groupUl,
      ownerState: Ce,
      children: Mt.children
    })]
  }, Mt.key)), Pn = Ee || ((Mt, $r) => {
    const {
      key: ao,
      ...Ki
    } = Mt;
    return /* @__PURE__ */ x.jsx("li", {
      ...Ki,
      children: U($r)
    }, ao);
  }), xi = (Mt, $r) => {
    const ao = gt({
      option: Mt,
      index: $r
    });
    return Pn({
      ...ao,
      className: De.option
    }, Mt, {
      selected: ao["aria-selected"],
      index: $r,
      inputValue: bo
    }, Ce);
  }, wi = Ze.slotProps.clearIndicator, $i = Ze.slotProps.popupIndicator;
  return /* @__PURE__ */ x.jsxs(w.Fragment, {
    children: [/* @__PURE__ */ x.jsx(V7, {
      ref: n,
      className: _e(De.root, p),
      ownerState: Ce,
      ...$t(je),
      children: kt({
        id: wr,
        disabled: P,
        fullWidth: !0,
        size: Ue === "small" ? "small" : void 0,
        InputLabelProps: Ft(),
        InputProps: {
          ref: In,
          className: De.inputRoot,
          startAdornment: nt,
          onMouseDown: (Mt) => {
            Mt.target === Mt.currentTarget && zo(Mt);
          },
          ...(Ar || xo) && {
            endAdornment: /* @__PURE__ */ x.jsxs(z7, {
              className: De.endAdornment,
              ownerState: Ce,
              children: [Ar ? /* @__PURE__ */ x.jsx(W7, {
                ...Me(),
                "aria-label": y,
                title: y,
                ownerState: Ce,
                ...wi,
                className: _e(De.clearIndicator, wi == null ? void 0 : wi.className),
                children: f
              }) : null, xo ? /* @__PURE__ */ x.jsx(q7, {
                ...Jt(),
                disabled: P,
                "aria-label": Yn ? b : be,
                title: Yn ? b : be,
                ownerState: Ce,
                ...$i,
                className: _e(De.popupIndicator, $i == null ? void 0 : $i.className),
                children: We
              }) : null]
            })
          }
        },
        inputProps: {
          className: De.input,
          disabled: P,
          readOnly: Ye,
          ...Pt()
        }
      })
    }), tt ? /* @__PURE__ */ x.jsx(U7, {
      as: Ke,
      ...Ge,
      children: /* @__PURE__ */ x.jsxs(H7, {
        as: ce,
        ...Te,
        children: [X && io.length === 0 ? /* @__PURE__ */ x.jsx(G7, {
          className: De.loading,
          ownerState: Ce,
          children: re
        }) : null, io.length === 0 && !E && !X ? /* @__PURE__ */ x.jsx(Y7, {
          className: De.noOptions,
          ownerState: Ce,
          role: "presentation",
          onMouseDown: (Mt) => {
            Mt.preventDefault();
          },
          children: Y
        }) : null, io.length > 0 ? /* @__PURE__ */ x.jsx(St, {
          as: we,
          ...pe,
          children: io.map((Mt, $r) => G ? rn({
            key: Mt.key,
            group: Mt.group,
            children: Mt.options.map((ao, Ki) => xi(ao, Mt.index + Ki))
          }) : xi(Mt, $r))
        }) : null]
      })
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (ac.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: i.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: i.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: i.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: i.oneOfType([i.oneOf(["mouse", "touch"]), i.bool]),
  /**
   * Props applied to the [`Chip`](https://mui.com/material-ui/api/chip/) element.
   * @deprecated Use `slotProps.chip` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ChipProps: i.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: i.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: i.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: i.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: i.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: i.string,
  /**
   * The props used for each slot inside.
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: i.shape({
    clearIndicator: i.object,
    paper: i.object,
    popper: i.object,
    popupIndicator: i.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: yo(i.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: i.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: i.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: i.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: i.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: i.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: i.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: i.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: i.oneOfType([i.oneOf(["auto"]), i.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: i.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: i.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: i.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: i.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: i.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: i.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} option The Autocomplete option.
   * @returns {string}
   */
  groupBy: i.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: i.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: i.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: i.bool,
  /**
   * The input value.
   */
  inputValue: i.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: i.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: i0,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   * @deprecated Use `slotProps.listbox.component` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxComponent: i.elementType,
  /**
   * Props applied to the Listbox element.
   * @deprecated Use `slotProps.listbox` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxProps: i.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: i.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: i.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: i.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: i.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: i.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: i.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: i.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`, `"blur"`, `"selectOption"`, `"removeOption"`
   */
  onInputChange: i.func,
  /**
   * @ignore
   */
  onKeyDown: i.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: i.func,
  /**
   * If `true`, the component is shown.
   */
  open: i.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: i.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: i.string,
  /**
   * A list of options that will be shown in the Autocomplete.
   */
  options: i.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   * @deprecated Use `slots.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperComponent: i.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   * @deprecated Use `slots.popper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: i.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: i.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: i.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: i.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: i.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: i.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: i.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: i.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: i.oneOfType([i.oneOf(["small", "medium"]), i.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    chip: i.oneOfType([i.func, i.object]),
    clearIndicator: i.oneOfType([i.func, i.object]),
    listbox: i.oneOfType([i.func, i.object]),
    paper: i.oneOfType([i.func, i.object]),
    popper: i.oneOfType([i.func, i.object]),
    popupIndicator: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    listbox: i.elementType,
    paper: i.elementType,
    popper: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: yo(i.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
const Q7 = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
function J7(e) {
  return Fe("MuiAvatar", e);
}
Le("MuiAvatar", ["root", "colorDefault", "circular", "rounded", "square", "img", "fallback"]);
const eA = (e) => {
  const {
    classes: t,
    variant: n,
    colorDefault: r
  } = e;
  return Be({
    root: ["root", n, r && "colorDefault"],
    img: ["img"],
    fallback: ["fallback"]
  }, J7, t);
}, tA = ae("div", {
  name: "MuiAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], n.colorDefault && t.colorDefault];
  }
})(dt(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: e.typography.fontFamily,
  fontSize: e.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: "50%",
  overflow: "hidden",
  userSelect: "none",
  variants: [{
    props: {
      variant: "rounded"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius
    }
  }, {
    props: {
      variant: "square"
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: !0
    },
    style: {
      color: (e.vars || e).palette.background.default,
      ...e.vars ? {
        backgroundColor: e.vars.palette.Avatar.defaultBg
      } : {
        backgroundColor: e.palette.grey[400],
        ...e.applyStyles("dark", {
          backgroundColor: e.palette.grey[600]
        })
      }
    }
  }]
}))), nA = ae("img", {
  name: "MuiAvatar",
  slot: "Img",
  overridesResolver: (e, t) => t.img
})({
  width: "100%",
  height: "100%",
  textAlign: "center",
  // Handle non-square image.
  objectFit: "cover",
  // Hide alt text.
  color: "transparent",
  // Hide the image broken icon, only works on Chrome.
  textIndent: 1e4
}), rA = ae(Q7, {
  name: "MuiAvatar",
  slot: "Fallback",
  overridesResolver: (e, t) => t.fallback
})({
  width: "75%",
  height: "75%"
});
function oA({
  crossOrigin: e,
  referrerPolicy: t,
  src: n,
  srcSet: r
}) {
  const [o, a] = w.useState(!1);
  return w.useEffect(() => {
    if (!n && !r)
      return;
    a(!1);
    let l = !0;
    const c = new Image();
    return c.onload = () => {
      l && a("loaded");
    }, c.onerror = () => {
      l && a("error");
    }, c.crossOrigin = e, c.referrerPolicy = t, c.src = n, r && (c.srcset = r), () => {
      l = !1;
    };
  }, [e, t, n, r]), o;
}
const B3 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiAvatar"
  }), {
    alt: o,
    children: a,
    className: l,
    component: c = "div",
    slots: d = {},
    slotProps: p = {},
    imgProps: f,
    sizes: m,
    src: g,
    srcSet: y,
    variant: b = "circular",
    ...v
  } = r;
  let $ = null;
  const S = {
    ...r,
    component: c,
    variant: b
  }, R = oA({
    ...f,
    ...typeof p.img == "function" ? p.img(S) : p.img,
    src: g,
    srcSet: y
  }), P = g || y, T = P && R !== "error";
  S.colorDefault = !T, delete S.ownerState;
  const O = eA(S), [k, I] = Nt("img", {
    className: O.img,
    elementType: nA,
    externalForwardedProps: {
      slots: d,
      slotProps: {
        img: {
          ...f,
          ...p.img
        }
      }
    },
    additionalProps: {
      alt: o,
      src: g,
      srcSet: y,
      sizes: m
    },
    ownerState: S
  });
  return T ? $ = /* @__PURE__ */ x.jsx(k, {
    ...I
  }) : a || a === 0 ? $ = a : P && o ? $ = o[0] : $ = /* @__PURE__ */ x.jsx(rA, {
    ownerState: S,
    className: O.fallback
  }), /* @__PURE__ */ x.jsx(tA, {
    as: c,
    className: _e(O.root, l),
    ref: n,
    ...v,
    ownerState: S,
    children: $
  });
});
process.env.NODE_ENV !== "production" && (B3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: i.string,
  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attributes) applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   * @deprecated Use `slotProps.img` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  imgProps: i.object,
  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: i.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    img: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    img: i.elementType
  }),
  /**
   * The `src` attribute for the `img` element.
   */
  src: i.string,
  /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */
  srcSet: i.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The shape of the avatar.
   * @default 'circular'
   */
  variant: i.oneOfType([i.oneOf(["circular", "rounded", "square"]), i.string])
});
const iA = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Vi = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = tr(), o = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: a,
    appear: l = !0,
    children: c,
    easing: d,
    in: p,
    onEnter: f,
    onEntered: m,
    onEntering: g,
    onExit: y,
    onExited: b,
    onExiting: v,
    style: $,
    timeout: S = o,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: R = ro,
    ...P
  } = t, T = w.useRef(null), O = It(T, Os(c), n), k = (V) => (z) => {
    if (V) {
      const L = T.current;
      z === void 0 ? V(L) : V(L, z);
    }
  }, I = k(g), D = k((V, z) => {
    S3(V);
    const L = Ku({
      style: $,
      timeout: S,
      easing: d
    }, {
      mode: "enter"
    });
    V.style.webkitTransition = r.transitions.create("opacity", L), V.style.transition = r.transitions.create("opacity", L), f && f(V, z);
  }), j = k(m), E = k(v), M = k((V) => {
    const z = Ku({
      style: $,
      timeout: S,
      easing: d
    }, {
      mode: "exit"
    });
    V.style.webkitTransition = r.transitions.create("opacity", z), V.style.transition = r.transitions.create("opacity", z), y && y(V);
  }), F = k(b), B = (V) => {
    a && a(T.current, V);
  };
  return /* @__PURE__ */ x.jsx(R, {
    appear: l,
    in: p,
    nodeRef: T,
    onEnter: D,
    onEntered: j,
    onEntering: I,
    onExit: M,
    onExited: F,
    onExiting: E,
    addEndListener: B,
    timeout: S,
    ...P,
    children: (V, {
      ownerState: z,
      ...L
    }) => /* @__PURE__ */ w.cloneElement(c, {
      style: {
        opacity: 0,
        visibility: V === "exited" && !p ? "hidden" : void 0,
        ...iA[V],
        ...$,
        ...c.props.style
      },
      ref: O,
      ...L
    })
  });
});
process.env.NODE_ENV !== "production" && (Vi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: i.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: i.bool,
  /**
   * A single child content element.
   */
  children: Ts.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: i.oneOfType([i.shape({
    enter: i.string,
    exit: i.string
  }), i.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: i.bool,
  /**
   * @ignore
   */
  onEnter: i.func,
  /**
   * @ignore
   */
  onEntered: i.func,
  /**
   * @ignore
   */
  onEntering: i.func,
  /**
   * @ignore
   */
  onExit: i.func,
  /**
   * @ignore
   */
  onExited: i.func,
  /**
   * @ignore
   */
  onExiting: i.func,
  /**
   * @ignore
   */
  style: i.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: i.oneOfType([i.number, i.shape({
    appear: i.number,
    enter: i.number,
    exit: i.number
  })])
});
function aA(e) {
  return Fe("MuiBackdrop", e);
}
Le("MuiBackdrop", ["root", "invisible"]);
const sA = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return Be({
    root: ["root", n && "invisible"]
  }, aA, t);
}, lA = ae("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), w0 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: o,
    className: a,
    component: l = "div",
    invisible: c = !1,
    open: d,
    components: p = {},
    componentsProps: f = {},
    slotProps: m = {},
    slots: g = {},
    TransitionComponent: y,
    transitionDuration: b,
    ...v
  } = r, $ = {
    ...r,
    component: l,
    invisible: c
  }, S = sA($), R = {
    transition: y,
    root: p.Root,
    ...g
  }, P = {
    ...f,
    ...m
  }, T = {
    slots: R,
    slotProps: P
  }, [O, k] = Nt("root", {
    elementType: lA,
    externalForwardedProps: T,
    className: _e(S.root, a),
    ownerState: $
  }), [I, D] = Nt("transition", {
    elementType: Vi,
    externalForwardedProps: T,
    ownerState: $
  });
  return /* @__PURE__ */ x.jsx(I, {
    in: d,
    timeout: b,
    ...v,
    ...D,
    children: /* @__PURE__ */ x.jsx(O, {
      "aria-hidden": !0,
      ...k,
      classes: S,
      ref: n,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (w0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: i.shape({
    Root: i.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: i.shape({
    root: i.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: i.bool,
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    root: i.oneOfType([i.func, i.object]),
    transition: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    root: i.elementType,
    transition: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: i.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: i.oneOfType([i.number, i.shape({
    appear: i.number,
    enter: i.number,
    exit: i.number
  })])
});
const cA = Le("MuiBox", ["root"]), uA = tc(), Zr = n_({
  themeId: Kr,
  defaultTheme: uA,
  defaultClassName: cA.root,
  generateClassName: WC.generate
});
process.env.NODE_ENV !== "production" && (Zr.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: i.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function dA(e) {
  return Fe("MuiButton", e);
}
const ia = Le("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge", "loading", "loadingWrapper", "loadingIconPlaceholder", "loadingIndicator", "loadingPositionCenter", "loadingPositionStart", "loadingPositionEnd"]), V3 = /* @__PURE__ */ w.createContext({});
process.env.NODE_ENV !== "production" && (V3.displayName = "ButtonGroupContext");
const z3 = /* @__PURE__ */ w.createContext(void 0);
process.env.NODE_ENV !== "production" && (z3.displayName = "ButtonGroupButtonContext");
const pA = (e) => {
  const {
    color: t,
    disableElevation: n,
    fullWidth: r,
    size: o,
    variant: a,
    loading: l,
    loadingPosition: c,
    classes: d
  } = e, p = {
    root: ["root", l && "loading", a, `${a}${Pe(t)}`, `size${Pe(o)}`, `${a}Size${Pe(o)}`, `color${Pe(t)}`, n && "disableElevation", r && "fullWidth", l && `loadingPosition${Pe(c)}`],
    startIcon: ["icon", "startIcon", `iconSize${Pe(o)}`],
    endIcon: ["icon", "endIcon", `iconSize${Pe(o)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  }, f = Be(p, dA, d);
  return {
    ...d,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...f
  };
}, W3 = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}], fA = ae(jo, {
  shouldForwardProp: (e) => nr(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${Pe(n.color)}`], t[`size${Pe(n.size)}`], t[`${n.variant}Size${Pe(n.size)}`], n.color === "inherit" && t.colorInherit, n.disableElevation && t.disableElevation, n.fullWidth && t.fullWidth, n.loading && t.loading];
  }
})(dt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], n = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return {
    ...e.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${ia.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    },
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        color: "var(--variant-containedColor)",
        backgroundColor: "var(--variant-containedBg)",
        boxShadow: (e.vars || e).shadows[2],
        "&:hover": {
          boxShadow: (e.vars || e).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (e.vars || e).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[8]
        },
        [`&.${ia.focusVisible}`]: {
          boxShadow: (e.vars || e).shadows[6]
        },
        [`&.${ia.disabled}`]: {
          color: (e.vars || e).palette.action.disabled,
          boxShadow: (e.vars || e).shadows[0],
          backgroundColor: (e.vars || e).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: "var(--variant-outlinedBorder, currentColor)",
        backgroundColor: "var(--variant-outlinedBg)",
        color: "var(--variant-outlinedColor)",
        [`&.${ia.disabled}`]: {
          border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: "var(--variant-textColor)",
        backgroundColor: "var(--variant-textBg)"
      }
    }, ...Object.entries(e.palette).filter(An()).map(([r]) => ({
      props: {
        color: r
      },
      style: {
        "--variant-textColor": (e.vars || e).palette[r].main,
        "--variant-outlinedColor": (e.vars || e).palette[r].main,
        "--variant-outlinedBorder": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.5)` : ht(e.palette[r].main, 0.5),
        "--variant-containedColor": (e.vars || e).palette[r].contrastText,
        "--variant-containedBg": (e.vars || e).palette[r].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (e.vars || e).palette[r].dark,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : ht(e.palette[r].main, e.palette.action.hoverOpacity),
            "--variant-outlinedBorder": (e.vars || e).palette[r].main,
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : ht(e.palette[r].main, e.palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedBg : t,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedHoverBg : n,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : ht(e.palette.text.primary, e.palette.action.hoverOpacity),
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : ht(e.palette.text.primary, e.palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: !0
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${ia.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${ia.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: !0
      },
      style: {
        width: "100%"
      }
    }, {
      props: {
        loadingPosition: "center"
      },
      style: {
        transition: e.transitions.create(["background-color", "box-shadow", "border-color"], {
          duration: e.transitions.duration.short
        }),
        [`&.${ia.loading}`]: {
          color: "transparent"
        }
      }
    }]
  };
})), hA = ae("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.startIcon, n.loading && t.startIconLoadingStart, t[`iconSize${Pe(n.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginRight: -8
    }
  }, ...W3]
})), mA = ae("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.endIcon, n.loading && t.endIconLoadingEnd, t[`iconSize${Pe(n.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginLeft: -8
    }
  }, ...W3]
})), gA = ae("span", {
  name: "MuiButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }, {
    props: {
      loadingPosition: "start"
    },
    style: {
      left: 14
    }
  }, {
    props: {
      loadingPosition: "start",
      size: "small"
    },
    style: {
      left: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "start"
    },
    style: {
      left: 6
    }
  }, {
    props: {
      loadingPosition: "center"
    },
    style: {
      left: "50%",
      transform: "translate(-50%)",
      color: (e.vars || e).palette.action.disabled
    }
  }, {
    props: {
      loadingPosition: "end"
    },
    style: {
      right: 14
    }
  }, {
    props: {
      loadingPosition: "end",
      size: "small"
    },
    style: {
      right: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "end"
    },
    style: {
      right: 6
    }
  }, {
    props: {
      loadingPosition: "start",
      fullWidth: !0
    },
    style: {
      position: "relative",
      left: -10
    }
  }, {
    props: {
      loadingPosition: "end",
      fullWidth: !0
    },
    style: {
      position: "relative",
      right: -10
    }
  }]
})), mx = ae("span", {
  name: "MuiButton",
  slot: "LoadingIconPlaceholder",
  overridesResolver: (e, t) => t.loadingIconPlaceholder
})({
  display: "inline-block",
  width: "1em",
  height: "1em"
}), Tn = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = w.useContext(V3), o = w.useContext(z3), a = _l(r, t), l = lt({
    props: a,
    name: "MuiButton"
  }), {
    children: c,
    color: d = "primary",
    component: p = "button",
    className: f,
    disabled: m = !1,
    disableElevation: g = !1,
    disableFocusRipple: y = !1,
    endIcon: b,
    focusVisibleClassName: v,
    fullWidth: $ = !1,
    id: S,
    loading: R = null,
    loadingIndicator: P,
    loadingPosition: T = "center",
    size: O = "medium",
    startIcon: k,
    type: I,
    variant: D = "text",
    ...j
  } = l, E = Mr(S), M = P ?? /* @__PURE__ */ x.jsx(Fo, {
    "aria-labelledby": E,
    color: "inherit",
    size: 16
  }), F = {
    ...l,
    color: d,
    component: p,
    disabled: m,
    disableElevation: g,
    disableFocusRipple: y,
    fullWidth: $,
    loading: R,
    loadingIndicator: M,
    loadingPosition: T,
    size: O,
    type: I,
    variant: D
  }, B = pA(F), V = (k || R && T === "start") && /* @__PURE__ */ x.jsx(hA, {
    className: B.startIcon,
    ownerState: F,
    children: k || /* @__PURE__ */ x.jsx(mx, {
      className: B.loadingIconPlaceholder,
      ownerState: F
    })
  }), z = (b || R && T === "end") && /* @__PURE__ */ x.jsx(mA, {
    className: B.endIcon,
    ownerState: F,
    children: b || /* @__PURE__ */ x.jsx(mx, {
      className: B.loadingIconPlaceholder,
      ownerState: F
    })
  }), L = o || "", G = typeof R == "boolean" ? (
    // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ x.jsx("span", {
      className: B.loadingWrapper,
      style: {
        display: "contents"
      },
      children: R && /* @__PURE__ */ x.jsx(gA, {
        className: B.loadingIndicator,
        ownerState: F,
        children: M
      })
    })
  ) : null;
  return /* @__PURE__ */ x.jsxs(fA, {
    ownerState: F,
    className: _e(r.className, B.root, f, L),
    component: p,
    disabled: m || R,
    focusRipple: !y,
    focusVisibleClassName: _e(B.focusVisible, v),
    ref: n,
    type: I,
    id: R ? E : S,
    ...j,
    classes: B,
    children: [V, T !== "end" && G, c, T === "end" && G, z]
  });
});
process.env.NODE_ENV !== "production" && (Tn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: i.oneOfType([i.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), i.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: i.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: i.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: i.bool,
  /**
   * Element placed after the children.
   */
  endIcon: i.node,
  /**
   * @ignore
   */
  focusVisibleClassName: i.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: i.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: i.string,
  /**
   * @ignore
   */
  id: i.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: i.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: i.node,
  /**
   * The loading indicator can be positioned on the start, end, or the center of the button.
   * @default 'center'
   */
  loadingPosition: i.oneOf(["center", "end", "start"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: i.oneOfType([i.oneOf(["small", "medium", "large"]), i.string]),
  /**
   * Element placed before the children.
   */
  startIcon: i.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * @ignore
   */
  type: i.oneOfType([i.oneOf(["button", "reset", "submit"]), i.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: i.oneOfType([i.oneOf(["contained", "outlined", "text"]), i.string])
});
function yA(e) {
  return Fe("PrivateSwitchBase", e);
}
Le("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const vA = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: r,
    edge: o
  } = e, a = {
    root: ["root", n && "checked", r && "disabled", o && `edge${Pe(o)}`],
    input: ["input"]
  };
  return Be(a, yA, t);
}, bA = ae(jo)({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "start" && t.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "end" && t.size !== "small",
    style: {
      marginRight: -12
    }
  }]
}), xA = ae("input", {
  shouldForwardProp: nr
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), $0 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    autoFocus: r,
    checked: o,
    checkedIcon: a,
    className: l,
    defaultChecked: c,
    disabled: d,
    disableFocusRipple: p = !1,
    edge: f = !1,
    icon: m,
    id: g,
    inputProps: y,
    inputRef: b,
    name: v,
    onBlur: $,
    onChange: S,
    onFocus: R,
    readOnly: P,
    required: T = !1,
    tabIndex: O,
    type: k,
    value: I,
    ...D
  } = t, [j, E] = sr({
    controlled: o,
    default: !!c,
    name: "SwitchBase",
    state: "checked"
  }), M = cr(), F = (ne) => {
    R && R(ne), M && M.onFocus && M.onFocus(ne);
  }, B = (ne) => {
    $ && $(ne), M && M.onBlur && M.onBlur(ne);
  }, V = (ne) => {
    if (ne.nativeEvent.defaultPrevented)
      return;
    const K = ne.target.checked;
    E(K), S && S(ne, K);
  };
  let z = d;
  M && typeof z > "u" && (z = M.disabled);
  const L = k === "checkbox" || k === "radio", G = {
    ...t,
    checked: j,
    disabled: z,
    disableFocusRipple: p,
    edge: f
  }, se = vA(G);
  return /* @__PURE__ */ x.jsxs(bA, {
    component: "span",
    className: _e(se.root, l),
    centerRipple: !0,
    focusRipple: !p,
    disabled: z,
    tabIndex: null,
    role: void 0,
    onFocus: F,
    onBlur: B,
    ownerState: G,
    ref: n,
    ...D,
    children: [/* @__PURE__ */ x.jsx(xA, {
      autoFocus: r,
      checked: o,
      defaultChecked: c,
      className: se.input,
      disabled: z,
      id: L ? g : void 0,
      name: v,
      onChange: V,
      readOnly: P,
      ref: b,
      required: T,
      ownerState: G,
      tabIndex: O,
      type: k,
      ...k === "checkbox" && I === void 0 ? {} : {
        value: I
      },
      ...y
    }), j ? a : m]
  });
});
process.env.NODE_ENV !== "production" && ($0.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: i.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: i.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: i.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * @ignore
   */
  defaultChecked: i.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: i.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: i.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: i.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: i.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: i.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: i.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /*
   * @ignore
   */
  name: i.string,
  /**
   * @ignore
   */
  onBlur: i.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: i.func,
  /**
   * @ignore
   */
  onFocus: i.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: i.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: i.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.object,
  /**
   * @ignore
   */
  tabIndex: i.oneOfType([i.number, i.string]),
  /**
   * The input component prop `type`.
   */
  type: i.string.isRequired,
  /**
   * The value of the component.
   */
  value: i.any
});
const wA = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), $A = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), CA = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function SA(e) {
  return Fe("MuiCheckbox", e);
}
const Gf = Le("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), TA = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: r,
    size: o
  } = e, a = {
    root: ["root", n && "indeterminate", `color${Pe(r)}`, `size${Pe(o)}`]
  }, l = Be(a, SA, t);
  return {
    ...t,
    // forward the disabled and checked classes to the SwitchBase
    ...l
  };
}, OA = ae($0, {
  shouldForwardProp: (e) => nr(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${Pe(n.size)}`], n.color !== "default" && t[`color${Pe(n.color)}`]];
  }
})(dt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : ht(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(An()).map(([t]) => ({
    props: {
      color: t,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : ht(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(An()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Gf.checked}, &.${Gf.indeterminate}`]: {
        color: (e.vars || e).palette[t].main
      },
      [`&.${Gf.disabled}`]: {
        color: (e.vars || e).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
}))), PA = /* @__PURE__ */ x.jsx($A, {}), EA = /* @__PURE__ */ x.jsx(wA, {}), RA = /* @__PURE__ */ x.jsx(CA, {}), Gd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: o = PA,
    color: a = "primary",
    icon: l = EA,
    indeterminate: c = !1,
    indeterminateIcon: d = RA,
    inputProps: p,
    size: f = "medium",
    disableRipple: m = !1,
    className: g,
    ...y
  } = r, b = c ? d : l, v = c ? d : o, $ = {
    ...r,
    disableRipple: m,
    color: a,
    indeterminate: c,
    size: f
  }, S = TA($);
  return /* @__PURE__ */ x.jsx(OA, {
    type: "checkbox",
    inputProps: {
      "data-indeterminate": c,
      ...p
    },
    icon: /* @__PURE__ */ w.cloneElement(b, {
      fontSize: b.props.fontSize ?? f
    }),
    checkedIcon: /* @__PURE__ */ w.cloneElement(v, {
      fontSize: v.props.fontSize ?? f
    }),
    ownerState: $,
    ref: n,
    className: _e(S.root, g),
    disableRipple: m,
    ...y,
    classes: S
  });
});
process.env.NODE_ENV !== "production" && (Gd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: i.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: i.oneOfType([i.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), i.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: i.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: i.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: i.node,
  /**
   * The id of the `input` element.
   */
  id: i.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: i.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: i.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: i.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: i.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: i.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: i.oneOfType([i.oneOf(["medium", "small"]), i.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: i.any
});
function kA(e) {
  const t = er(e);
  return t.body === e ? ci(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function Sl(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function gx(e) {
  return parseInt(ci(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function _A(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(e.tagName), r = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || r;
}
function yx(e, t, n, r, o) {
  const a = [t, n, ...r];
  [].forEach.call(e.children, (l) => {
    const c = !a.includes(l), d = !_A(l);
    c && d && Sl(l, o);
  });
}
function Yf(e, t) {
  let n = -1;
  return e.some((r, o) => t(r) ? (n = o, !0) : !1), n;
}
function DA(e, t) {
  const n = [], r = e.container;
  if (!t.disableScrollLock) {
    if (kA(r)) {
      const l = r3(ci(r));
      n.push({
        value: r.style.paddingRight,
        property: "padding-right",
        el: r
      }), r.style.paddingRight = `${gx(r) + l}px`;
      const c = er(r).querySelectorAll(".mui-fixed");
      [].forEach.call(c, (d) => {
        n.push({
          value: d.style.paddingRight,
          property: "padding-right",
          el: d
        }), d.style.paddingRight = `${gx(d) + l}px`;
      });
    }
    let a;
    if (r.parentNode instanceof DocumentFragment)
      a = er(r).body;
    else {
      const l = r.parentElement, c = ci(r);
      a = (l == null ? void 0 : l.nodeName) === "HTML" && c.getComputedStyle(l).overflowY === "scroll" ? l : r;
    }
    n.push({
      value: a.style.overflow,
      property: "overflow",
      el: a
    }, {
      value: a.style.overflowX,
      property: "overflow-x",
      el: a
    }, {
      value: a.style.overflowY,
      property: "overflow-y",
      el: a
    }), a.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: a,
      el: l,
      property: c
    }) => {
      a ? l.style.setProperty(c, a) : l.style.removeProperty(c);
    });
  };
}
function IA(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class MA {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(t, n) {
    let r = this.modals.indexOf(t);
    if (r !== -1)
      return r;
    r = this.modals.length, this.modals.push(t), t.modalRef && Sl(t.modalRef, !1);
    const o = IA(n);
    yx(n, t.mount, t.modalRef, o, !0);
    const a = Yf(this.containers, (l) => l.container === n);
    return a !== -1 ? (this.containers[a].modals.push(t), r) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: o
    }), r);
  }
  mount(t, n) {
    const r = Yf(this.containers, (a) => a.modals.includes(t)), o = this.containers[r];
    o.restore || (o.restore = DA(o, n));
  }
  remove(t, n = !0) {
    const r = this.modals.indexOf(t);
    if (r === -1)
      return r;
    const o = Yf(this.containers, (l) => l.modals.includes(t)), a = this.containers[o];
    if (a.modals.splice(a.modals.indexOf(t), 1), this.modals.splice(r, 1), a.modals.length === 0)
      a.restore && a.restore(), t.modalRef && Sl(t.modalRef, n), yx(a.container, t.mount, t.modalRef, a.hiddenSiblings, !1), this.containers.splice(o, 1);
    else {
      const l = a.modals[a.modals.length - 1];
      l.modalRef && Sl(l.modalRef, !1);
    }
    return r;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const AA = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function NA(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function jA(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (r) => e.ownerDocument.querySelector(`input[type="radio"]${r}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function FA(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || jA(e));
}
function LA(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(AA)).forEach((r, o) => {
    const a = NA(r);
    a === -1 || !FA(r) || (a === 0 ? t.push(r) : n.push({
      documentOrder: o,
      tabIndex: a,
      node: r
    }));
  }), n.sort((r, o) => r.tabIndex === o.tabIndex ? r.documentOrder - o.documentOrder : r.tabIndex - o.tabIndex).map((r) => r.node).concat(t);
}
function BA() {
  return !0;
}
function Fl(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: r = !1,
    disableRestoreFocus: o = !1,
    getTabbable: a = LA,
    isEnabled: l = BA,
    open: c
  } = e, d = w.useRef(!1), p = w.useRef(null), f = w.useRef(null), m = w.useRef(null), g = w.useRef(null), y = w.useRef(!1), b = w.useRef(null), v = It(Os(t), b), $ = w.useRef(null);
  w.useEffect(() => {
    !c || !b.current || (y.current = !n);
  }, [n, c]), w.useEffect(() => {
    if (!c || !b.current)
      return;
    const P = er(b.current);
    return b.current.contains(P.activeElement) || (b.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), b.current.setAttribute("tabIndex", "-1")), y.current && b.current.focus()), () => {
      o || (m.current && m.current.focus && (d.current = !0, m.current.focus()), m.current = null);
    };
  }, [c]), w.useEffect(() => {
    if (!c || !b.current)
      return;
    const P = er(b.current), T = (I) => {
      $.current = I, !(r || !l() || I.key !== "Tab") && P.activeElement === b.current && I.shiftKey && (d.current = !0, f.current && f.current.focus());
    }, O = () => {
      var j, E;
      const I = b.current;
      if (I === null)
        return;
      if (!P.hasFocus() || !l() || d.current) {
        d.current = !1;
        return;
      }
      if (I.contains(P.activeElement) || r && P.activeElement !== p.current && P.activeElement !== f.current)
        return;
      if (P.activeElement !== g.current)
        g.current = null;
      else if (g.current !== null)
        return;
      if (!y.current)
        return;
      let D = [];
      if ((P.activeElement === p.current || P.activeElement === f.current) && (D = a(b.current)), D.length > 0) {
        const M = !!((j = $.current) != null && j.shiftKey && ((E = $.current) == null ? void 0 : E.key) === "Tab"), F = D[0], B = D[D.length - 1];
        typeof F != "string" && typeof B != "string" && (M ? B.focus() : F.focus());
      } else
        I.focus();
    };
    P.addEventListener("focusin", O), P.addEventListener("keydown", T, !0);
    const k = setInterval(() => {
      P.activeElement && P.activeElement.tagName === "BODY" && O();
    }, 50);
    return () => {
      clearInterval(k), P.removeEventListener("focusin", O), P.removeEventListener("keydown", T, !0);
    };
  }, [n, r, o, l, c, a]);
  const S = (P) => {
    m.current === null && (m.current = P.relatedTarget), y.current = !0, g.current = P.target;
    const T = t.props.onFocus;
    T && T(P);
  }, R = (P) => {
    m.current === null && (m.current = P.relatedTarget), y.current = !0;
  };
  return /* @__PURE__ */ x.jsxs(w.Fragment, {
    children: [/* @__PURE__ */ x.jsx("div", {
      tabIndex: c ? 0 : -1,
      onFocus: R,
      ref: p,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ w.cloneElement(t, {
      ref: v,
      onFocus: S
    }), /* @__PURE__ */ x.jsx("div", {
      tabIndex: c ? 0 : -1,
      onFocus: R,
      ref: f,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (Fl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: Ts,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: i.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: i.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: i.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: i.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: i.func,
  /**
   * If `true`, focus is locked.
   */
  open: i.bool.isRequired
});
process.env.NODE_ENV !== "production" && (Fl.propTypes = Id(Fl.propTypes));
function VA(e) {
  return typeof e == "function" ? e() : e;
}
function zA(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const vx = () => {
}, mu = new MA();
function WA(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: r = !1,
    closeAfterTransition: o = !1,
    onTransitionEnter: a,
    onTransitionExited: l,
    children: c,
    onClose: d,
    open: p,
    rootRef: f
  } = e, m = w.useRef({}), g = w.useRef(null), y = w.useRef(null), b = It(y, f), [v, $] = w.useState(!p), S = zA(c);
  let R = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (R = !1);
  const P = () => er(g.current), T = () => (m.current.modalRef = y.current, m.current.mount = g.current, m.current), O = () => {
    mu.mount(T(), {
      disableScrollLock: r
    }), y.current && (y.current.scrollTop = 0);
  }, k = ze(() => {
    const z = VA(t) || P().body;
    mu.add(T(), z), y.current && O();
  }), I = () => mu.isTopModal(T()), D = ze((z) => {
    g.current = z, z && (p && I() ? O() : y.current && Sl(y.current, R));
  }), j = w.useCallback(() => {
    mu.remove(T(), R);
  }, [R]);
  w.useEffect(() => () => {
    j();
  }, [j]), w.useEffect(() => {
    p ? k() : (!S || !o) && j();
  }, [p, j, S, o, k]);
  const E = (z) => (L) => {
    var G;
    (G = z.onKeyDown) == null || G.call(z, L), !(L.key !== "Escape" || L.which === 229 || // Wait until IME is settled.
    !I()) && (n || (L.stopPropagation(), d && d(L, "escapeKeyDown")));
  }, M = (z) => (L) => {
    var G;
    (G = z.onClick) == null || G.call(z, L), L.target === L.currentTarget && d && d(L, "backdropClick");
  };
  return {
    getRootProps: (z = {}) => {
      const L = s3(e);
      delete L.onTransitionEnter, delete L.onTransitionExited;
      const G = {
        ...L,
        ...z
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...G,
        onKeyDown: E(G),
        ref: b
      };
    },
    getBackdropProps: (z = {}) => {
      const L = z;
      return {
        "aria-hidden": !0,
        ...L,
        onClick: M(L),
        open: p
      };
    },
    getTransitionProps: () => {
      const z = () => {
        $(!1), a && a();
      }, L = () => {
        $(!0), l && l(), o && j();
      };
      return {
        onEnter: ug(z, (c == null ? void 0 : c.props.onEnter) ?? vx),
        onExited: ug(L, (c == null ? void 0 : c.props.onExited) ?? vx)
      };
    },
    rootRef: b,
    portalRef: D,
    isTopModal: I,
    exited: v,
    hasTransition: S
  };
}
function qA(e) {
  return Fe("MuiModal", e);
}
Le("MuiModal", ["root", "hidden", "backdrop"]);
const UA = (e) => {
  const {
    open: t,
    exited: n,
    classes: r
  } = e;
  return Be({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, qA, r);
}, HA = ae("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(dt(({
  theme: e
}) => ({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: t
    }) => !t.open && t.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), GA = ae(w0, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), C0 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: o = GA,
    BackdropProps: a,
    classes: l,
    className: c,
    closeAfterTransition: d = !1,
    children: p,
    container: f,
    component: m,
    components: g = {},
    componentsProps: y = {},
    disableAutoFocus: b = !1,
    disableEnforceFocus: v = !1,
    disableEscapeKeyDown: $ = !1,
    disablePortal: S = !1,
    disableRestoreFocus: R = !1,
    disableScrollLock: P = !1,
    hideBackdrop: T = !1,
    keepMounted: O = !1,
    onBackdropClick: k,
    onClose: I,
    onTransitionEnter: D,
    onTransitionExited: j,
    open: E,
    slotProps: M = {},
    slots: F = {},
    // eslint-disable-next-line react/prop-types
    theme: B,
    ...V
  } = r, z = {
    ...r,
    closeAfterTransition: d,
    disableAutoFocus: b,
    disableEnforceFocus: v,
    disableEscapeKeyDown: $,
    disablePortal: S,
    disableRestoreFocus: R,
    disableScrollLock: P,
    hideBackdrop: T,
    keepMounted: O
  }, {
    getRootProps: L,
    getBackdropProps: G,
    getTransitionProps: se,
    portalRef: ne,
    isTopModal: K,
    exited: Q,
    hasTransition: ye
  } = WA({
    ...z,
    rootRef: n
  }), we = {
    ...z,
    exited: Q
  }, fe = UA(we), X = {};
  if (p.props.tabIndex === void 0 && (X.tabIndex = "-1"), ye) {
    const {
      onEnter: W,
      onExited: J
    } = se();
    X.onEnter = W, X.onExited = J;
  }
  const re = {
    ...V,
    slots: {
      root: g.Root,
      backdrop: g.Backdrop,
      ...F
    },
    slotProps: {
      ...y,
      ...M
    }
  }, [ie, Y] = Nt("root", {
    elementType: HA,
    externalForwardedProps: re,
    getSlotProps: L,
    additionalProps: {
      ref: n,
      as: m
    },
    ownerState: we,
    className: _e(c, fe == null ? void 0 : fe.root, !we.open && we.exited && (fe == null ? void 0 : fe.hidden))
  }), [Z, ue] = Nt("backdrop", {
    elementType: o,
    externalForwardedProps: re,
    additionalProps: a,
    getSlotProps: (W) => G({
      ...W,
      onClick: (J) => {
        k && k(J), W != null && W.onClick && W.onClick(J);
      }
    }),
    className: _e(a == null ? void 0 : a.className, fe == null ? void 0 : fe.backdrop),
    ownerState: we
  }), ge = It(a == null ? void 0 : a.ref, ue.ref);
  return !O && !E && (!ye || Q) ? null : /* @__PURE__ */ x.jsx(Nl, {
    ref: ne,
    container: f,
    disablePortal: S,
    children: /* @__PURE__ */ x.jsxs(ie, {
      ...Y,
      children: [!T && o ? /* @__PURE__ */ x.jsx(Z, {
        ...ue,
        ref: ge
      }) : null, /* @__PURE__ */ x.jsx(Fl, {
        disableEnforceFocus: v,
        disableAutoFocus: b,
        disableRestoreFocus: R,
        isEnabled: K,
        open: E,
        children: /* @__PURE__ */ w.cloneElement(p, X)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (C0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: i.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: i.object,
  /**
   * A single child content element.
   */
  children: Ts.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: i.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: i.shape({
    Backdrop: i.elementType,
    Root: i.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: i.shape({
    backdrop: i.oneOfType([i.func, i.object]),
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: i.oneOfType([li, i.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: i.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: i.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: i.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: i.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: i.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: i.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: i.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: i.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: i.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: i.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: i.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: i.func,
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: i.shape({
    backdrop: i.oneOfType([i.func, i.object]),
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: i.shape({
    backdrop: i.elementType,
    root: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function YA(e) {
  return Fe("MuiDialog", e);
}
const Tl = Le("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), S0 = /* @__PURE__ */ w.createContext({});
process.env.NODE_ENV !== "production" && (S0.displayName = "DialogContext");
const KA = ae(w0, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), XA = (e) => {
  const {
    classes: t,
    scroll: n,
    maxWidth: r,
    fullWidth: o,
    fullScreen: a
  } = e, l = {
    root: ["root"],
    container: ["container", `scroll${Pe(n)}`],
    paper: ["paper", `paperScroll${Pe(n)}`, `paperWidth${Pe(String(r))}`, o && "paperFullWidth", a && "paperFullScreen"]
  };
  return Be(l, YA, t);
}, ZA = ae(C0, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), QA = ae("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.container, t[`scroll${Pe(n.scroll)}`]];
  }
})({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      "&::after": {
        content: '""',
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0"
      }
    }
  }]
}), JA = ae(mi, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`scrollPaper${Pe(n.scroll)}`], t[`paperWidth${Pe(String(n.maxWidth))}`], n.fullWidth && t.paperFullWidth, n.fullScreen && t.paperFullScreen];
  }
})(dt(({
  theme: e
}) => ({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  },
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100% - 64px)"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      display: "inline-block",
      verticalAlign: "middle",
      textAlign: "initial"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.maxWidth,
    style: {
      maxWidth: "calc(100% - 64px)"
    }
  }, {
    props: {
      maxWidth: "xs"
    },
    style: {
      maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
      [`&.${Tl.paperScrollBody}`]: {
        [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  }, ...Object.keys(e.breakpoints.values).filter((t) => t !== "xs").map((t) => ({
    props: {
      maxWidth: t
    },
    style: {
      maxWidth: `${e.breakpoints.values[t]}${e.breakpoints.unit}`,
      [`&.${Tl.paperScrollBody}`]: {
        [e.breakpoints.down(e.breakpoints.values[t] + 32 * 2)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  })), {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "calc(100% - 64px)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullScreen,
    style: {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
      [`&.${Tl.paperScrollBody}`]: {
        margin: 0,
        maxWidth: "100%"
      }
    }
  }]
}))), Sa = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiDialog"
  }), o = tr(), a = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    "aria-describedby": l,
    "aria-labelledby": c,
    "aria-modal": d = !0,
    BackdropComponent: p,
    BackdropProps: f,
    children: m,
    className: g,
    disableEscapeKeyDown: y = !1,
    fullScreen: b = !1,
    fullWidth: v = !1,
    maxWidth: $ = "sm",
    onBackdropClick: S,
    onClick: R,
    onClose: P,
    open: T,
    PaperComponent: O = mi,
    PaperProps: k = {},
    scroll: I = "paper",
    slots: D = {},
    slotProps: j = {},
    TransitionComponent: E = Vi,
    transitionDuration: M = a,
    TransitionProps: F,
    ...B
  } = r, V = {
    ...r,
    disableEscapeKeyDown: y,
    fullScreen: b,
    fullWidth: v,
    maxWidth: $,
    scroll: I
  }, z = XA(V), L = w.useRef(), G = (le) => {
    L.current = le.target === le.currentTarget;
  }, se = (le) => {
    R && R(le), L.current && (L.current = null, S && S(le), P && P(le, "backdropClick"));
  }, ne = Mr(c), K = w.useMemo(() => ({
    titleId: ne
  }), [ne]), Q = {
    transition: E,
    ...D
  }, ye = {
    transition: F,
    paper: k,
    backdrop: f,
    ...j
  }, we = {
    slots: Q,
    slotProps: ye
  }, [fe, X] = Nt("root", {
    elementType: ZA,
    shouldForwardComponentProp: !0,
    externalForwardedProps: we,
    ownerState: V,
    className: _e(z.root, g),
    ref: n
  }), [re, ie] = Nt("backdrop", {
    elementType: KA,
    shouldForwardComponentProp: !0,
    externalForwardedProps: we,
    ownerState: V
  }), [Y, Z] = Nt("paper", {
    elementType: JA,
    shouldForwardComponentProp: !0,
    externalForwardedProps: we,
    ownerState: V,
    className: _e(z.paper, k.className)
  }), [ue, ge] = Nt("container", {
    elementType: QA,
    externalForwardedProps: we,
    ownerState: V,
    className: _e(z.container)
  }), [W, J] = Nt("transition", {
    elementType: Vi,
    externalForwardedProps: we,
    ownerState: V,
    additionalProps: {
      appear: !0,
      in: T,
      timeout: M,
      role: "presentation"
    }
  });
  return /* @__PURE__ */ x.jsx(fe, {
    closeAfterTransition: !0,
    slots: {
      backdrop: re
    },
    slotProps: {
      backdrop: {
        transitionDuration: M,
        as: p,
        ...ie
      }
    },
    disableEscapeKeyDown: y,
    onClose: P,
    open: T,
    onClick: se,
    ...X,
    ...B,
    children: /* @__PURE__ */ x.jsx(W, {
      ...J,
      children: /* @__PURE__ */ x.jsx(ue, {
        onMouseDown: G,
        ...ge,
        children: /* @__PURE__ */ x.jsx(Y, {
          as: O,
          elevation: 24,
          role: "dialog",
          "aria-describedby": l,
          "aria-labelledby": ne,
          "aria-modal": d,
          ...Z,
          children: /* @__PURE__ */ x.jsx(S0.Provider, {
            value: K,
            children: m
          })
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Sa.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": i.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": i.string,
  /**
   * Informs assistive technologies that the element is modal.
   * It's added on the element with role="dialog".
   * @default true
   */
  "aria-modal": i.oneOfType([i.oneOf(["false", "true"]), i.bool]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: i.elementType,
  /**
   * @ignore
   */
  BackdropProps: i.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: i.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: i.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: i.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: i.oneOfType([i.oneOf(["xs", "sm", "md", "lg", "xl", !1]), i.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: i.func,
  /**
   * @ignore
   */
  onClick: i.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: i.func,
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: i.elementType,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @default {}
   * @deprecated Use `slotProps.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperProps: i.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: i.oneOf(["body", "paper"]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    backdrop: i.oneOfType([i.func, i.object]),
    container: i.oneOfType([i.func, i.object]),
    paper: i.oneOfType([i.func, i.object]),
    root: i.oneOfType([i.func, i.object]),
    transition: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    backdrop: i.elementType,
    container: i.elementType,
    paper: i.elementType,
    root: i.elementType,
    transition: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: i.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: i.oneOfType([i.number, i.shape({
    appear: i.number,
    enter: i.number,
    exit: i.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionProps: i.object
});
function eN(e) {
  return Fe("MuiDialogActions", e);
}
Le("MuiDialogActions", ["root", "spacing"]);
const tN = (e) => {
  const {
    classes: t,
    disableSpacing: n
  } = e;
  return Be({
    root: ["root", !n && "spacing"]
  }, eN, t);
}, nN = ae("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableSpacing && t.spacing];
  }
})({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disableSpacing,
    style: {
      "& > :not(style) ~ :not(style)": {
        marginLeft: 8
      }
    }
  }]
}), ii = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: o,
    disableSpacing: a = !1,
    ...l
  } = r, c = {
    ...r,
    disableSpacing: a
  }, d = tN(c);
  return /* @__PURE__ */ x.jsx(nN, {
    className: _e(d.root, o),
    ownerState: c,
    ref: n,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (ii.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: i.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function rN(e) {
  return Fe("MuiDialogContent", e);
}
Le("MuiDialogContent", ["root", "dividers"]);
function oN(e) {
  return Fe("MuiDialogTitle", e);
}
const iN = Le("MuiDialogTitle", ["root"]), aN = (e) => {
  const {
    classes: t,
    dividers: n
  } = e;
  return Be({
    root: ["root", n && "dividers"]
  }, rN, t);
}, sN = ae("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.dividers && t.dividers];
  }
})(dt(({
  theme: e
}) => ({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px",
  variants: [{
    props: ({
      ownerState: t
    }) => t.dividers,
    style: {
      padding: "16px 24px",
      borderTop: `1px solid ${(e.vars || e).palette.divider}`,
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dividers,
    style: {
      [`.${iN.root} + &`]: {
        paddingTop: 0
      }
    }
  }]
}))), Yd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiDialogContent"
  }), {
    className: o,
    dividers: a = !1,
    ...l
  } = r, c = {
    ...r,
    dividers: a
  }, d = aN(c);
  return /* @__PURE__ */ x.jsx(sN, {
    className: _e(d.root, o),
    ownerState: c,
    ref: n,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (Yd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: i.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
const lN = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"]
  }, oN, t);
}, cN = ae(Qe, {
  name: "MuiDialogTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: "16px 24px",
  flex: "0 0 auto"
}), wa = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiDialogTitle"
  }), {
    className: o,
    id: a,
    ...l
  } = r, c = r, d = lN(c), {
    titleId: p = a
  } = w.useContext(S0);
  return /* @__PURE__ */ x.jsx(cN, {
    component: "h2",
    className: _e(d.root, o),
    ownerState: c,
    ref: n,
    variant: "h6",
    id: a ?? p,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (wa.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * @ignore
   */
  id: i.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function uN(e) {
  return Fe("MuiDivider", e);
}
const bx = Le("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), dN = (e) => {
  const {
    absolute: t,
    children: n,
    classes: r,
    flexItem: o,
    light: a,
    orientation: l,
    textAlign: c,
    variant: d
  } = e;
  return Be({
    root: ["root", t && "absolute", d, a && "light", l === "vertical" && "vertical", o && "flexItem", n && "withChildren", n && l === "vertical" && "withChildrenVertical", c === "right" && l !== "vertical" && "textAlignRight", c === "left" && l !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", l === "vertical" && "wrapperVertical"]
  }, uN, r);
}, pN = ae("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.absolute && t.absolute, t[n.variant], n.light && t.light, n.orientation === "vertical" && t.vertical, n.flexItem && t.flexItem, n.children && t.withChildren, n.children && n.orientation === "vertical" && t.withChildrenVertical, n.textAlign === "right" && n.orientation !== "vertical" && t.textAlignRight, n.textAlign === "left" && n.orientation !== "vertical" && t.textAlignLeft];
  }
})(dt(({
  theme: e
}) => ({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin",
  variants: [{
    props: {
      absolute: !0
    },
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    }
  }, {
    props: {
      light: !0
    },
    style: {
      borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : ht(e.palette.divider, 0.08)
    }
  }, {
    props: {
      variant: "inset"
    },
    style: {
      marginLeft: 72
    }
  }, {
    props: {
      variant: "middle",
      orientation: "horizontal"
    },
    style: {
      marginLeft: e.spacing(2),
      marginRight: e.spacing(2)
    }
  }, {
    props: {
      variant: "middle",
      orientation: "vertical"
    },
    style: {
      marginTop: e.spacing(1),
      marginBottom: e.spacing(1)
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      borderBottomWidth: 0,
      borderRightWidth: "thin"
    }
  }, {
    props: {
      flexItem: !0
    },
    style: {
      alignSelf: "stretch",
      height: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.children,
    style: {
      display: "flex",
      textAlign: "center",
      border: 0,
      borderTopStyle: "solid",
      borderLeftStyle: "solid",
      "&::before, &::after": {
        content: '""',
        alignSelf: "center"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.children && t.orientation !== "vertical",
    style: {
      "&::before, &::after": {
        width: "100%",
        borderTop: `thin solid ${(e.vars || e).palette.divider}`,
        borderTopStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.orientation === "vertical" && t.children,
    style: {
      flexDirection: "column",
      "&::before, &::after": {
        height: "100%",
        borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
        borderLeftStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "right" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "90%"
      },
      "&::after": {
        width: "10%"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "left" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "10%"
      },
      "&::after": {
        width: "90%"
      }
    }
  }]
}))), fN = ae("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.wrapper, n.orientation === "vertical" && t.wrapperVertical];
  }
})(dt(({
  theme: e
}) => ({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      paddingTop: `calc(${e.spacing(1)} * 1.2)`,
      paddingBottom: `calc(${e.spacing(1)} * 1.2)`
    }
  }]
}))), ys = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: o = !1,
    children: a,
    className: l,
    orientation: c = "horizontal",
    component: d = a || c === "vertical" ? "div" : "hr",
    flexItem: p = !1,
    light: f = !1,
    role: m = d !== "hr" ? "separator" : void 0,
    textAlign: g = "center",
    variant: y = "fullWidth",
    ...b
  } = r, v = {
    ...r,
    absolute: o,
    component: d,
    flexItem: p,
    light: f,
    orientation: c,
    role: m,
    textAlign: g,
    variant: y
  }, $ = dN(v);
  return /* @__PURE__ */ x.jsx(pN, {
    as: d,
    className: _e($.root, l),
    role: m,
    ref: n,
    ownerState: v,
    "aria-orientation": m === "separator" && (d !== "hr" || c === "vertical") ? c : void 0,
    ...b,
    children: a ? /* @__PURE__ */ x.jsx(fN, {
      className: $.wrapper,
      ownerState: v,
      children: a
    }) : null
  });
});
ys && (ys.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (ys.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: i.bool,
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: i.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  light: i.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: i.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: i.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: i.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: i.oneOfType([i.oneOf(["fullWidth", "inset", "middle"]), i.string])
});
const hN = (e) => {
  const {
    classes: t,
    disableUnderline: n,
    startAdornment: r,
    endAdornment: o,
    size: a,
    hiddenLabel: l,
    multiline: c
  } = e, d = {
    root: ["root", !n && "underline", r && "adornedStart", o && "adornedEnd", a === "small" && `size${Pe(a)}`, l && "hiddenLabel", c && "multiline"],
    input: ["input"]
  }, p = Be(d, F7, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...p
  };
}, mN = ae(qd, {
  shouldForwardProp: (e) => nr(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...zd(e, t), !n.disableUnderline && t.underline];
  }
})(dt(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", r = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", o = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", a = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : o,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
      }
    },
    [`&.${kr.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
    },
    [`&.${kr.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : a
    },
    variants: [{
      props: ({
        ownerState: l
      }) => !l.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${kr.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${kr.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${kr.disabled}, .${kr.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${kr.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(An()).map(([l]) => {
      var c;
      return {
        props: {
          disableUnderline: !1,
          color: l
        },
        style: {
          "&::after": {
            borderBottom: `2px solid ${(c = (e.vars || e).palette[l]) == null ? void 0 : c.main}`
          }
        }
      };
    }), {
      props: ({
        ownerState: l
      }) => l.startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        ownerState: l
      }) => l.endAdornment,
      style: {
        paddingRight: 12
      }
    }, {
      props: ({
        ownerState: l
      }) => l.multiline,
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: ({
        ownerState: l,
        size: c
      }) => l.multiline && c === "small",
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: ({
        ownerState: l
      }) => l.multiline && l.hiddenLabel,
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: ({
        ownerState: l
      }) => l.multiline && l.hiddenLabel && l.size === "small",
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
})), gN = ae(Ud, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: Wd
})(dt(({
  theme: e
}) => ({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel,
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel && t.size === "small",
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
}))), Kd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiFilledInput"
  }), {
    disableUnderline: o = !1,
    components: a = {},
    componentsProps: l,
    fullWidth: c = !1,
    hiddenLabel: d,
    // declare here to prevent spreading to DOM
    inputComponent: p = "input",
    multiline: f = !1,
    slotProps: m,
    slots: g = {},
    type: y = "text",
    ...b
  } = r, v = {
    ...r,
    disableUnderline: o,
    fullWidth: c,
    inputComponent: p,
    multiline: f,
    type: y
  }, $ = hN(r), S = {
    root: {
      ownerState: v
    },
    input: {
      ownerState: v
    }
  }, R = m ?? l ? Vn(S, m ?? l) : S, P = g.root ?? a.Root ?? mN, T = g.input ?? a.Input ?? gN;
  return /* @__PURE__ */ x.jsx(Hd, {
    slots: {
      root: P,
      input: T
    },
    slotProps: R,
    fullWidth: c,
    inputComponent: p,
    multiline: f,
    ref: n,
    type: y,
    ...b,
    classes: $
  });
});
process.env.NODE_ENV !== "production" && (Kd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: i.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: i.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: i.oneOfType([i.oneOf(["primary", "secondary"]), i.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: i.shape({
    Input: i.elementType,
    Root: i.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: i.shape({
    input: i.object,
    root: i.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: i.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: i.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: i.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: i.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: i.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: i.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: i.bool,
  /**
   * The id of the `input` element.
   */
  id: i.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: i.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: i.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: i.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: i.oneOfType([i.number, i.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: i.oneOfType([i.number, i.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: i.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: i.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: i.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: i.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: i.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: i.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: i.oneOfType([i.number, i.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: i.shape({
    input: i.object,
    root: i.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: i.shape({
    input: i.elementType,
    root: i.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: i.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: i.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: i.any
});
Kd.muiName = "Input";
function yN(e) {
  return Fe("MuiFormControl", e);
}
Le("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const vN = (e) => {
  const {
    classes: t,
    margin: n,
    fullWidth: r
  } = e, o = {
    root: ["root", n !== "none" && `margin${Pe(n)}`, r && "fullWidth"]
  };
  return Be(o, yN, t);
}, bN = ae("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`margin${Pe(n.margin)}`], n.fullWidth && t.fullWidth];
  }
})({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  // Fix alignment issue on Safari.
  variants: [{
    props: {
      margin: "normal"
    },
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, {
    props: {
      margin: "dense"
    },
    style: {
      marginTop: 8,
      marginBottom: 4
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
}), Gn = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiFormControl"
  }), {
    children: o,
    className: a,
    color: l = "primary",
    component: c = "div",
    disabled: d = !1,
    error: p = !1,
    focused: f,
    fullWidth: m = !1,
    hiddenLabel: g = !1,
    margin: y = "none",
    required: b = !1,
    size: v = "medium",
    variant: $ = "outlined",
    ...S
  } = r, R = {
    ...r,
    color: l,
    component: c,
    disabled: d,
    error: p,
    fullWidth: m,
    hiddenLabel: g,
    margin: y,
    required: b,
    size: v,
    variant: $
  }, P = vN(R), [T, O] = w.useState(() => {
    let L = !1;
    return o && w.Children.forEach(o, (G) => {
      if (!os(G, ["Input", "Select"]))
        return;
      const se = os(G, ["Select"]) ? G.props.input : G;
      se && I7(se.props) && (L = !0);
    }), L;
  }), [k, I] = w.useState(() => {
    let L = !1;
    return o && w.Children.forEach(o, (G) => {
      os(G, ["Input", "Select"]) && (ed(G.props, !0) || ed(G.props.inputProps, !0)) && (L = !0);
    }), L;
  }), [D, j] = w.useState(!1);
  d && D && j(!1);
  const E = f !== void 0 && !d ? f : D;
  let M;
  const F = w.useRef(!1);
  process.env.NODE_ENV !== "production" && (M = () => (F.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), F.current = !0, () => {
    F.current = !1;
  }));
  const B = w.useCallback(() => {
    I(!0);
  }, []), V = w.useCallback(() => {
    I(!1);
  }, []), z = w.useMemo(() => ({
    adornedStart: T,
    setAdornedStart: O,
    color: l,
    disabled: d,
    error: p,
    filled: k,
    focused: E,
    fullWidth: m,
    hiddenLabel: g,
    size: v,
    onBlur: () => {
      j(!1);
    },
    onFocus: () => {
      j(!0);
    },
    onEmpty: V,
    onFilled: B,
    registerEffect: M,
    required: b,
    variant: $
  }), [T, l, d, p, k, E, m, g, M, V, B, b, v, $]);
  return /* @__PURE__ */ x.jsx(ic.Provider, {
    value: z,
    children: /* @__PURE__ */ x.jsx(bN, {
      as: c,
      ownerState: R,
      className: _e(P.root, a),
      ref: n,
      ...S,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (Gn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: i.oneOfType([i.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), i.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: i.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: i.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: i.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: i.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: i.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: i.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: i.oneOfType([i.oneOf(["medium", "small"]), i.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: i.oneOf(["filled", "outlined", "standard"])
});
function xN(e) {
  return Fe("MuiFormControlLabel", e);
}
const gl = Le("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), wN = (e) => {
  const {
    classes: t,
    disabled: n,
    labelPlacement: r,
    error: o,
    required: a
  } = e, l = {
    root: ["root", n && "disabled", `labelPlacement${Pe(r)}`, o && "error", a && "required"],
    label: ["label", n && "disabled"],
    asterisk: ["asterisk", o && "error"]
  };
  return Be(l, xN, t);
}, $N = ae("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${gl.label}`]: t.label
    }, t.root, t[`labelPlacement${Pe(n.labelPlacement)}`]];
  }
})(dt(({
  theme: e
}) => ({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${gl.disabled}`]: {
    cursor: "default"
  },
  [`& .${gl.label}`]: {
    [`&.${gl.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  },
  variants: [{
    props: {
      labelPlacement: "start"
    },
    style: {
      flexDirection: "row-reverse",
      marginRight: -11
    }
  }, {
    props: {
      labelPlacement: "top"
    },
    style: {
      flexDirection: "column-reverse"
    }
  }, {
    props: {
      labelPlacement: "bottom"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      labelPlacement: t
    }) => t === "start" || t === "top" || t === "bottom",
    style: {
      marginLeft: 16
      // used for row presentation of radio/checkbox
    }
  }]
}))), CN = ae("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(dt(({
  theme: e
}) => ({
  [`&.${gl.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), Xd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiFormControlLabel"
  }), {
    checked: o,
    className: a,
    componentsProps: l = {},
    control: c,
    disabled: d,
    disableTypography: p,
    inputRef: f,
    label: m,
    labelPlacement: g = "end",
    name: y,
    onChange: b,
    required: v,
    slots: $ = {},
    slotProps: S = {},
    value: R,
    ...P
  } = r, T = cr(), O = d ?? c.props.disabled ?? (T == null ? void 0 : T.disabled), k = v ?? c.props.required, I = {
    disabled: O,
    required: k
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((z) => {
    typeof c.props[z] > "u" && typeof r[z] < "u" && (I[z] = r[z]);
  });
  const D = Ui({
    props: r,
    muiFormControl: T,
    states: ["error"]
  }), j = {
    ...r,
    disabled: O,
    labelPlacement: g,
    required: k,
    error: D.error
  }, E = wN(j), M = {
    slots: $,
    slotProps: {
      ...l,
      ...S
    }
  }, [F, B] = Nt("typography", {
    elementType: Qe,
    externalForwardedProps: M,
    ownerState: j
  });
  let V = m;
  return V != null && V.type !== Qe && !p && (V = /* @__PURE__ */ x.jsx(F, {
    component: "span",
    ...B,
    className: _e(E.label, B == null ? void 0 : B.className),
    children: V
  })), /* @__PURE__ */ x.jsxs($N, {
    className: _e(E.root, a),
    ownerState: j,
    ref: n,
    ...P,
    children: [/* @__PURE__ */ w.cloneElement(c, I), k ? /* @__PURE__ */ x.jsxs("div", {
      children: [V, /* @__PURE__ */ x.jsxs(CN, {
        ownerState: j,
        "aria-hidden": !0,
        className: E.asterisk,
        children: [" ", "*"]
      })]
    }) : V]
  });
});
process.env.NODE_ENV !== "production" && (Xd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: i.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: i.shape({
    typography: i.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: i.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: i.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: i.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: i.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: i.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: i.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: i.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: i.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    typography: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    typography: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The value of the component.
   */
  value: i.any
});
function SN(e) {
  return Fe("MuiFormGroup", e);
}
Le("MuiFormGroup", ["root", "row", "error"]);
const TN = (e) => {
  const {
    classes: t,
    row: n,
    error: r
  } = e;
  return Be({
    root: ["root", n && "row", r && "error"]
  }, SN, t);
}, ON = ae("div", {
  name: "MuiFormGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.row && t.row];
  }
})({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  variants: [{
    props: {
      row: !0
    },
    style: {
      flexDirection: "row"
    }
  }]
}), T0 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiFormGroup"
  }), {
    className: o,
    row: a = !1,
    ...l
  } = r, c = cr(), d = Ui({
    props: r,
    muiFormControl: c,
    states: ["error"]
  }), p = {
    ...r,
    row: a,
    error: d.error
  }, f = TN(p);
  return /* @__PURE__ */ x.jsx(ON, {
    className: _e(f.root, o),
    ownerState: p,
    ref: n,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (T0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row: i.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function PN(e) {
  return Fe("MuiFormHelperText", e);
}
const xx = Le("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var wx;
const EN = (e) => {
  const {
    classes: t,
    contained: n,
    size: r,
    disabled: o,
    error: a,
    filled: l,
    focused: c,
    required: d
  } = e, p = {
    root: ["root", o && "disabled", a && "error", r && `size${Pe(r)}`, n && "contained", c && "focused", l && "filled", d && "required"]
  };
  return Be(p, PN, t);
}, RN = ae("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size && t[`size${Pe(n.size)}`], n.contained && t.contained, n.filled && t.filled];
  }
})(dt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.caption,
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${xx.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${xx.error}`]: {
    color: (e.vars || e).palette.error.main
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginTop: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.contained,
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }]
}))), O0 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: o,
    className: a,
    component: l = "p",
    disabled: c,
    error: d,
    filled: p,
    focused: f,
    margin: m,
    required: g,
    variant: y,
    ...b
  } = r, v = cr(), $ = Ui({
    props: r,
    muiFormControl: v,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), S = {
    ...r,
    component: l,
    contained: $.variant === "filled" || $.variant === "outlined",
    variant: $.variant,
    size: $.size,
    disabled: $.disabled,
    error: $.error,
    filled: $.filled,
    focused: $.focused,
    required: $.required
  };
  delete S.ownerState;
  const R = EN(S);
  return /* @__PURE__ */ x.jsx(RN, {
    as: l,
    className: _e(R.root, a),
    ref: n,
    ...b,
    ownerState: S,
    children: o === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      wx || (wx = /* @__PURE__ */ x.jsx("span", {
        className: "notranslate",
        "aria-hidden": !0,
        children: "​"
      }))
    ) : o
  });
});
process.env.NODE_ENV !== "production" && (O0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: i.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: i.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: i.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: i.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: i.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: i.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The variant to use.
   */
  variant: i.oneOfType([i.oneOf(["filled", "outlined", "standard"]), i.string])
});
function kN(e) {
  return Fe("MuiFormLabel", e);
}
const Ol = Le("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), _N = (e) => {
  const {
    classes: t,
    color: n,
    focused: r,
    disabled: o,
    error: a,
    filled: l,
    required: c
  } = e, d = {
    root: ["root", `color${Pe(n)}`, o && "disabled", a && "error", l && "filled", r && "focused", c && "required"],
    asterisk: ["asterisk", a && "error"]
  };
  return Be(d, kN, t);
}, DN = ae("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color === "secondary" && t.colorSecondary, n.filled && t.filled];
  }
})(dt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.body1,
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  variants: [...Object.entries(e.palette).filter(An()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Ol.focused}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    props: {},
    style: {
      [`&.${Ol.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      },
      [`&.${Ol.error}`]: {
        color: (e.vars || e).palette.error.main
      }
    }
  }]
}))), IN = ae("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(dt(({
  theme: e
}) => ({
  [`&.${Ol.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), ur = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: o,
    className: a,
    color: l,
    component: c = "label",
    disabled: d,
    error: p,
    filled: f,
    focused: m,
    required: g,
    ...y
  } = r, b = cr(), v = Ui({
    props: r,
    muiFormControl: b,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), $ = {
    ...r,
    color: v.color || "primary",
    component: c,
    disabled: v.disabled,
    error: v.error,
    filled: v.filled,
    focused: v.focused,
    required: v.required
  }, S = _N($);
  return /* @__PURE__ */ x.jsxs(DN, {
    as: c,
    ownerState: $,
    className: _e(S.root, a),
    ref: n,
    ...y,
    children: [o, v.required && /* @__PURE__ */ x.jsxs(IN, {
      ownerState: $,
      "aria-hidden": !0,
      className: S.asterisk,
      children: [" ", "*"]
    })]
  });
});
process.env.NODE_ENV !== "production" && (ur.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: i.oneOfType([i.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), i.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: i.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: i.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: i.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: i.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: i.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
const Jn = uD({
  createStyledComponent: ae("div", {
    name: "MuiGrid2",
    slot: "Root",
    overridesResolver: (e, t) => {
      const {
        ownerState: n
      } = e;
      return [t.root, n.container && t.container];
    }
  }),
  componentName: "MuiGrid2",
  useThemeProps: (e) => lt({
    props: e,
    name: "MuiGrid2"
  }),
  useTheme: tr
});
process.env.NODE_ENV !== "production" && (Jn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * The number of columns.
   * @default 12
   */
  columns: i.oneOfType([i.arrayOf(i.number), i.number, i.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: i.oneOfType([i.arrayOf(i.oneOfType([i.number, i.string])), i.number, i.object, i.string]),
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: i.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: i.oneOfType([i.oneOf(["column-reverse", "column", "row-reverse", "row"]), i.arrayOf(i.oneOf(["column-reverse", "column", "row-reverse", "row"])), i.object]),
  /**
   * Defines the offset value for the type `item` components.
   */
  offset: i.oneOfType([i.string, i.number, i.arrayOf(i.oneOfType([i.string, i.number])), i.object]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: i.oneOfType([i.arrayOf(i.oneOfType([i.number, i.string])), i.number, i.object, i.string]),
  /**
   * Defines the size of the the type `item` components.
   */
  size: i.oneOfType([i.string, i.bool, i.number, i.arrayOf(i.oneOfType([i.string, i.bool, i.number])), i.object]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: i.oneOfType([i.arrayOf(i.oneOfType([i.number, i.string])), i.number, i.object, i.string]),
  /**
   * @ignore
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * @internal
   * The level of the grid starts from `0` and increases when the grid nests
   * inside another grid. Nesting is defined as a container Grid being a direct
   * child of a container Grid.
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid container> // level 1
   *     <Grid container> // level 2
   * ```
   *
   * Only consecutive grid is considered nesting. A grid container will start at
   * `0` if there are non-Grid container element above it.
   *
   * ```js
   * <Grid container> // level 0
   *   <div>
   *     <Grid container> // level 0
   * ```
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid>
   *     <Grid container> // level 0
   * ```
   */
  unstable_level: i.number,
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: i.oneOf(["nowrap", "wrap-reverse", "wrap"])
});
if (process.env.NODE_ENV !== "production") {
  const e = Jn, t = C_("Grid2", e);
  e.propTypes = {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    ...e.propTypes,
    direction: t("container"),
    spacing: t("container"),
    wrap: t("container")
  };
}
function wg(e) {
  return `scale(${e}, ${e ** 2})`;
}
const MN = {
  entering: {
    opacity: 1,
    transform: wg(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, Kf = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), vs = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    addEndListener: r,
    appear: o = !0,
    children: a,
    easing: l,
    in: c,
    onEnter: d,
    onEntered: p,
    onEntering: f,
    onExit: m,
    onExited: g,
    onExiting: y,
    style: b,
    timeout: v = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: $ = ro,
    ...S
  } = t, R = Ja(), P = w.useRef(), T = tr(), O = w.useRef(null), k = It(O, Os(a), n), I = (z) => (L) => {
    if (z) {
      const G = O.current;
      L === void 0 ? z(G) : z(G, L);
    }
  }, D = I(f), j = I((z, L) => {
    S3(z);
    const {
      duration: G,
      delay: se,
      easing: ne
    } = Ku({
      style: b,
      timeout: v,
      easing: l
    }, {
      mode: "enter"
    });
    let K;
    v === "auto" ? (K = T.transitions.getAutoHeightDuration(z.clientHeight), P.current = K) : K = G, z.style.transition = [T.transitions.create("opacity", {
      duration: K,
      delay: se
    }), T.transitions.create("transform", {
      duration: Kf ? K : K * 0.666,
      delay: se,
      easing: ne
    })].join(","), d && d(z, L);
  }), E = I(p), M = I(y), F = I((z) => {
    const {
      duration: L,
      delay: G,
      easing: se
    } = Ku({
      style: b,
      timeout: v,
      easing: l
    }, {
      mode: "exit"
    });
    let ne;
    v === "auto" ? (ne = T.transitions.getAutoHeightDuration(z.clientHeight), P.current = ne) : ne = L, z.style.transition = [T.transitions.create("opacity", {
      duration: ne,
      delay: G
    }), T.transitions.create("transform", {
      duration: Kf ? ne : ne * 0.666,
      delay: Kf ? G : G || ne * 0.333,
      easing: se
    })].join(","), z.style.opacity = 0, z.style.transform = wg(0.75), m && m(z);
  }), B = I(g), V = (z) => {
    v === "auto" && R.start(P.current || 0, z), r && r(O.current, z);
  };
  return /* @__PURE__ */ x.jsx($, {
    appear: o,
    in: c,
    nodeRef: O,
    onEnter: j,
    onEntered: E,
    onEntering: D,
    onExit: F,
    onExited: B,
    onExiting: M,
    addEndListener: V,
    timeout: v === "auto" ? null : v,
    ...S,
    children: (z, {
      ownerState: L,
      ...G
    }) => /* @__PURE__ */ w.cloneElement(a, {
      style: {
        opacity: 0,
        transform: wg(0.75),
        visibility: z === "exited" && !c ? "hidden" : void 0,
        ...MN[z],
        ...b,
        ...a.props.style
      },
      ref: k,
      ...G
    })
  });
});
process.env.NODE_ENV !== "production" && (vs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: i.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: i.bool,
  /**
   * A single child content element.
   */
  children: Ts.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: i.oneOfType([i.shape({
    enter: i.string,
    exit: i.string
  }), i.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: i.bool,
  /**
   * @ignore
   */
  onEnter: i.func,
  /**
   * @ignore
   */
  onEntered: i.func,
  /**
   * @ignore
   */
  onEntering: i.func,
  /**
   * @ignore
   */
  onExit: i.func,
  /**
   * @ignore
   */
  onExited: i.func,
  /**
   * @ignore
   */
  onExiting: i.func,
  /**
   * @ignore
   */
  style: i.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: i.oneOfType([i.oneOf(["auto"]), i.number, i.shape({
    appear: i.number,
    enter: i.number,
    exit: i.number
  })])
});
vs && (vs.muiSupportAuto = !0);
const P0 = JC({
  themeId: Kr
}), AN = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, o = Be({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, N7, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...o
  };
}, NN = ae(qd, {
  shouldForwardProp: (e) => nr(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...zd(e, t), !n.disableUnderline && t.underline];
  }
})(dt(({
  theme: e
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    position: "relative",
    variants: [{
      props: ({
        ownerState: r
      }) => r.formControl,
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: ({
        ownerState: r
      }) => !r.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${Ni.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${Ni.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${Ni.disabled}, .${Ni.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${Ni.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(An()).map(([r]) => ({
      props: {
        color: r,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(e.vars || e).palette[r].main}`
        }
      }
    }))]
  };
})), jN = ae(Ud, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: Wd
})({}), Zd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: o = !1,
    components: a = {},
    componentsProps: l,
    fullWidth: c = !1,
    inputComponent: d = "input",
    multiline: p = !1,
    slotProps: f,
    slots: m = {},
    type: g = "text",
    ...y
  } = r, b = AN(r), $ = {
    root: {
      ownerState: {
        disableUnderline: o
      }
    }
  }, S = f ?? l ? Vn(f ?? l, $) : $, R = m.root ?? a.Root ?? NN, P = m.input ?? a.Input ?? jN;
  return /* @__PURE__ */ x.jsx(Hd, {
    slots: {
      root: R,
      input: P
    },
    slotProps: S,
    fullWidth: c,
    inputComponent: d,
    multiline: p,
    ref: n,
    type: g,
    ...y,
    classes: b
  });
});
process.env.NODE_ENV !== "production" && (Zd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: i.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: i.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: i.oneOfType([i.oneOf(["primary", "secondary"]), i.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: i.shape({
    Input: i.elementType,
    Root: i.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: i.shape({
    input: i.object,
    root: i.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: i.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: i.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: i.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: i.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: i.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: i.bool,
  /**
   * The id of the `input` element.
   */
  id: i.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: i.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: i.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: i.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: i.oneOfType([i.number, i.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: i.oneOfType([i.number, i.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: i.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: i.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: i.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: i.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: i.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: i.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: i.oneOfType([i.number, i.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: i.shape({
    input: i.object,
    root: i.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: i.shape({
    input: i.elementType,
    root: i.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: i.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: i.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: i.any
});
Zd.muiName = "Input";
function FN(e) {
  return Fe("MuiInputAdornment", e);
}
const $x = Le("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var Cx;
const LN = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[`position${Pe(n.position)}`], n.disablePointerEvents === !0 && t.disablePointerEvents, t[n.variant]];
}, BN = (e) => {
  const {
    classes: t,
    disablePointerEvents: n,
    hiddenLabel: r,
    position: o,
    size: a,
    variant: l
  } = e, c = {
    root: ["root", n && "disablePointerEvents", o && `position${Pe(o)}`, l, r && "hiddenLabel", a && `size${Pe(a)}`]
  };
  return Be(c, FN, t);
}, VN = ae("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: LN
})(dt(({
  theme: e
}) => ({
  display: "flex",
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active,
  variants: [{
    props: {
      variant: "filled"
    },
    style: {
      [`&.${$x.positionStart}&:not(.${$x.hiddenLabel})`]: {
        marginTop: 16
      }
    }
  }, {
    props: {
      position: "start"
    },
    style: {
      marginRight: 8
    }
  }, {
    props: {
      position: "end"
    },
    style: {
      marginLeft: 8
    }
  }, {
    props: {
      disablePointerEvents: !0
    },
    style: {
      pointerEvents: "none"
    }
  }]
}))), Rs = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: o,
    className: a,
    component: l = "div",
    disablePointerEvents: c = !1,
    disableTypography: d = !1,
    position: p,
    variant: f,
    ...m
  } = r, g = cr() || {};
  let y = f;
  f && g.variant && process.env.NODE_ENV !== "production" && f === g.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), g && !y && (y = g.variant);
  const b = {
    ...r,
    hiddenLabel: g.hiddenLabel,
    size: g.size,
    disablePointerEvents: c,
    position: p,
    variant: y
  }, v = BN(b);
  return /* @__PURE__ */ x.jsx(ic.Provider, {
    value: null,
    children: /* @__PURE__ */ x.jsx(VN, {
      as: l,
      ownerState: b,
      className: _e(v.root, a),
      ref: n,
      ...m,
      children: typeof o == "string" && !d ? /* @__PURE__ */ x.jsx(Qe, {
        color: "textSecondary",
        children: o
      }) : /* @__PURE__ */ x.jsxs(w.Fragment, {
        children: [p === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          Cx || (Cx = /* @__PURE__ */ x.jsx("span", {
            className: "notranslate",
            "aria-hidden": !0,
            children: "​"
          }))
        ) : null, o]
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Rs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: i.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: i.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: i.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: i.oneOf(["filled", "outlined", "standard"])
});
function zN(e) {
  return Fe("MuiInputLabel", e);
}
Le("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const WN = (e) => {
  const {
    classes: t,
    formControl: n,
    size: r,
    shrink: o,
    disableAnimation: a,
    variant: l,
    required: c
  } = e, d = {
    root: ["root", n && "formControl", !a && "animated", o && "shrink", r && r !== "normal" && `size${Pe(r)}`, l],
    asterisk: [c && "asterisk"]
  }, p = Be(d, zN, t);
  return {
    ...t,
    // forward the focused, disabled, etc. classes to the FormLabel
    ...p
  };
}, qN = ae(ur, {
  shouldForwardProp: (e) => nr(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Ol.asterisk}`]: t.asterisk
    }, t.root, n.formControl && t.formControl, n.size === "small" && t.sizeSmall, n.shrink && t.shrink, !n.disableAnimation && t.animated, n.focused && t.focused, t[n.variant]];
  }
})(dt(({
  theme: e
}) => ({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  variants: [{
    props: ({
      ownerState: t
    }) => t.formControl,
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 20px) scale(1)"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: "translate(0, 17px) scale(1)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.shrink,
    style: {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
      maxWidth: "133%"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableAnimation,
    style: {
      transition: e.transitions.create(["color", "transform", "max-width"], {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "filled",
      size: "small"
    },
    style: {
      transform: "translate(12px, 13px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n
    }) => t === "filled" && n.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      transform: "translate(12px, 7px) scale(0.75)",
      maxWidth: "calc(133% - 24px)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n,
      size: r
    }) => t === "filled" && n.shrink && r === "small",
    style: {
      transform: "translate(12px, 4px) scale(0.75)"
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "outlined",
      size: "small"
    },
    style: {
      transform: "translate(14px, 9px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n
    }) => t === "outlined" && n.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      // Theoretically, we should have (8+5)*2/0.75 = 34px
      // but it feels a better when it bleeds a bit on the left, so 32px.
      maxWidth: "calc(133% - 32px)",
      transform: "translate(14px, -9px) scale(0.75)"
    }
  }]
}))), E0 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: o = !1,
    margin: a,
    shrink: l,
    variant: c,
    className: d,
    ...p
  } = r, f = cr();
  let m = l;
  typeof m > "u" && f && (m = f.filled || f.focused || f.adornedStart);
  const g = Ui({
    props: r,
    muiFormControl: f,
    states: ["size", "variant", "required", "focused"]
  }), y = {
    ...r,
    disableAnimation: o,
    formControl: f,
    shrink: m,
    size: g.size,
    variant: g.variant,
    required: g.required,
    focused: g.focused
  }, b = WN(y);
  return /* @__PURE__ */ x.jsx(qN, {
    "data-shrink": m,
    ref: n,
    className: _e(b.root, d),
    ...p,
    ownerState: y,
    classes: b
  });
});
process.env.NODE_ENV !== "production" && (E0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: i.oneOfType([i.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), i.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: i.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: i.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: i.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: i.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: i.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: i.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: i.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: i.oneOfType([i.oneOf(["normal", "small"]), i.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The variant to use.
   */
  variant: i.oneOf(["filled", "outlined", "standard"])
});
const ai = /* @__PURE__ */ w.createContext({});
process.env.NODE_ENV !== "production" && (ai.displayName = "ListContext");
function UN(e) {
  return Fe("MuiList", e);
}
Le("MuiList", ["root", "padding", "dense", "subheader"]);
const HN = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: r,
    subheader: o
  } = e;
  return Be({
    root: ["root", !n && "padding", r && "dense", o && "subheader"]
  }, UN, t);
}, GN = ae("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: e
    }) => e.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), sc = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiList"
  }), {
    children: o,
    className: a,
    component: l = "ul",
    dense: c = !1,
    disablePadding: d = !1,
    subheader: p,
    ...f
  } = r, m = w.useMemo(() => ({
    dense: c
  }), [c]), g = {
    ...r,
    component: l,
    dense: c,
    disablePadding: d
  }, y = HN(g);
  return /* @__PURE__ */ x.jsx(ai.Provider, {
    value: m,
    children: /* @__PURE__ */ x.jsxs(GN, {
      as: l,
      className: _e(y.root, a),
      ref: n,
      ownerState: g,
      ...f,
      children: [p, o]
    })
  });
});
process.env.NODE_ENV !== "production" && (sc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: i.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: i.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: i.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function YN(e) {
  return Fe("MuiListItem", e);
}
Le("MuiListItem", ["root", "container", "dense", "alignItemsFlexStart", "divider", "gutters", "padding", "secondaryAction"]);
const KN = Le("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
function XN(e) {
  return Fe("MuiListItemSecondaryAction", e);
}
Le("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const ZN = (e) => {
  const {
    disableGutters: t,
    classes: n
  } = e;
  return Be({
    root: ["root", t && "disableGutters"]
  }, XN, n);
}, QN = ae("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.disableGutters && t.disableGutters];
  }
})({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  variants: [{
    props: ({
      ownerState: e
    }) => e.disableGutters,
    style: {
      right: 0
    }
  }]
}), R0 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: o,
    ...a
  } = r, l = w.useContext(ai), c = {
    ...r,
    disableGutters: l.disableGutters
  }, d = ZN(c);
  return /* @__PURE__ */ x.jsx(QN, {
    className: _e(d.root, o),
    ownerState: c,
    ref: n,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (R0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
R0.muiName = "ListItemSecondaryAction";
const JN = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters, !n.disablePadding && t.padding, n.hasSecondaryAction && t.secondaryAction];
}, ej = (e) => {
  const {
    alignItems: t,
    classes: n,
    dense: r,
    disableGutters: o,
    disablePadding: a,
    divider: l,
    hasSecondaryAction: c
  } = e;
  return Be({
    root: ["root", r && "dense", !o && "gutters", !a && "padding", l && "divider", t === "flex-start" && "alignItemsFlexStart", c && "secondaryAction"],
    container: ["container"]
  }, YN, n);
}, tj = ae("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: JN
})(dt(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !!t.secondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.secondaryAction,
    style: {
      [`& > .${KN.root}`]: {
        paddingRight: 48
      }
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.button,
    style: {
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: (e.vars || e).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hasSecondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }]
}))), nj = ae("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), q3 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: o = "center",
    children: a,
    className: l,
    component: c,
    components: d = {},
    componentsProps: p = {},
    ContainerComponent: f = "li",
    ContainerProps: {
      className: m,
      ...g
    } = {},
    dense: y = !1,
    disableGutters: b = !1,
    disablePadding: v = !1,
    divider: $ = !1,
    secondaryAction: S,
    slotProps: R = {},
    slots: P = {},
    ...T
  } = r, O = w.useContext(ai), k = w.useMemo(() => ({
    dense: y || O.dense || !1,
    alignItems: o,
    disableGutters: b
  }), [o, O.dense, y, b]), I = w.useRef(null), D = w.Children.toArray(a), j = D.length && os(D[D.length - 1], ["ListItemSecondaryAction"]), E = {
    ...r,
    alignItems: o,
    dense: k.dense,
    disableGutters: b,
    disablePadding: v,
    divider: $,
    hasSecondaryAction: j
  }, M = ej(E), F = It(I, n), B = P.root || d.Root || tj, V = R.root || p.root || {}, z = {
    className: _e(M.root, V.className, l),
    ...T
  };
  let L = c || "li";
  return j ? (L = !z.component && !c ? "div" : L, f === "li" && (L === "li" ? L = "div" : z.component === "li" && (z.component = "div")), /* @__PURE__ */ x.jsx(ai.Provider, {
    value: k,
    children: /* @__PURE__ */ x.jsxs(nj, {
      as: f,
      className: _e(M.container, m),
      ref: F,
      ownerState: E,
      ...g,
      children: [/* @__PURE__ */ x.jsx(B, {
        ...V,
        ...!jl(B) && {
          as: L,
          ownerState: {
            ...E,
            ...V.ownerState
          }
        },
        ...z,
        children: D
      }), D.pop()]
    })
  })) : /* @__PURE__ */ x.jsx(ai.Provider, {
    value: k,
    children: /* @__PURE__ */ x.jsxs(B, {
      ...V,
      as: L,
      ref: F,
      ...!jl(B) && {
        ownerState: {
          ...E,
          ...V.ownerState
        }
      },
      ...z,
      children: [D, S && /* @__PURE__ */ x.jsx(R0, {
        children: S
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (q3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: i.oneOf(["center", "flex-start"]),
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: yo(i.node, (e) => {
    const t = w.Children.toArray(e.children);
    let n = -1;
    for (let r = t.length - 1; r >= 0; r -= 1) {
      const o = t[r];
      if (os(o, ["ListItemSecondaryAction"])) {
        n = r;
        break;
      }
    }
    return n !== -1 && n !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  components: i.shape({
    Root: i.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  componentsProps: i.shape({
    root: i.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated Use the `component` or `slots.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerComponent: Dd,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated Use the `slotProps.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerProps: i.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: i.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: i.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: i.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: i.bool,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: i.node,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: i.shape({
    root: i.object
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: i.shape({
    root: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
const Sx = Le("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
function rj(e) {
  return Fe("MuiListItemText", e);
}
const es = Le("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), oj = (e) => {
  const {
    classes: t,
    inset: n,
    primary: r,
    secondary: o,
    dense: a
  } = e;
  return Be({
    root: ["root", n && "inset", a && "dense", r && o && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, rj, t);
}, ij = ae("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${es.primary}`]: t.primary
    }, {
      [`& .${es.secondary}`]: t.secondary
    }, t.root, n.inset && t.inset, n.primary && n.secondary && t.multiline, n.dense && t.dense];
  }
})({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4,
  [`.${X1.root}:where(& .${es.primary})`]: {
    display: "block"
  },
  [`.${X1.root}:where(& .${es.secondary})`]: {
    display: "block"
  },
  variants: [{
    props: ({
      ownerState: e
    }) => e.primary && e.secondary,
    style: {
      marginTop: 6,
      marginBottom: 6
    }
  }, {
    props: ({
      ownerState: e
    }) => e.inset,
    style: {
      paddingLeft: 56
    }
  }]
}), U3 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiListItemText"
  }), {
    children: o,
    className: a,
    disableTypography: l = !1,
    inset: c = !1,
    primary: d,
    primaryTypographyProps: p,
    secondary: f,
    secondaryTypographyProps: m,
    slots: g = {},
    slotProps: y = {},
    ...b
  } = r, {
    dense: v
  } = w.useContext(ai);
  let $ = d ?? o, S = f;
  const R = {
    ...r,
    disableTypography: l,
    inset: c,
    primary: !!$,
    secondary: !!S,
    dense: v
  }, P = oj(R), T = {
    slots: g,
    slotProps: {
      primary: p,
      secondary: m,
      ...y
    }
  }, [O, k] = Nt("primary", {
    className: P.primary,
    elementType: Qe,
    externalForwardedProps: T,
    ownerState: R
  }), [I, D] = Nt("secondary", {
    className: P.secondary,
    elementType: Qe,
    externalForwardedProps: T,
    ownerState: R
  });
  return $ != null && $.type !== Qe && !l && ($ = /* @__PURE__ */ x.jsx(O, {
    variant: v ? "body2" : "body1",
    component: k != null && k.variant ? void 0 : "span",
    ...k,
    children: $
  })), S != null && S.type !== Qe && !l && (S = /* @__PURE__ */ x.jsx(I, {
    variant: "body2",
    color: "textSecondary",
    ...D,
    children: S
  })), /* @__PURE__ */ x.jsxs(ij, {
    className: _e(P.root, a),
    ownerState: R,
    ref: n,
    ...b,
    children: [$, S]
  });
});
process.env.NODE_ENV !== "production" && (U3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: i.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: i.bool,
  /**
   * The main content element.
   */
  primary: i.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.primary` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  primaryTypographyProps: i.object,
  /**
   * The secondary content element.
   */
  secondary: i.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.secondary` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  secondaryTypographyProps: i.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    primary: i.oneOfType([i.func, i.object]),
    secondary: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    primary: i.elementType,
    secondary: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function Xf(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function Tx(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function H3(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.startsWith(t.keys.join(""));
}
function Js(e, t, n, r, o, a) {
  let l = !1, c = o(e, t, t ? n : !1);
  for (; c; ) {
    if (c === e.firstChild) {
      if (l)
        return !1;
      l = !0;
    }
    const d = r ? !1 : c.disabled || c.getAttribute("aria-disabled") === "true";
    if (!c.hasAttribute("tabindex") || !H3(c, a) || d)
      c = o(e, c, n);
    else
      return c.focus(), !0;
  }
  return !1;
}
const G3 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: r,
    autoFocus: o = !1,
    autoFocusItem: a = !1,
    children: l,
    className: c,
    disabledItemsFocusable: d = !1,
    disableListWrap: p = !1,
    onKeyDown: f,
    variant: m = "selectedMenu",
    ...g
  } = t, y = w.useRef(null), b = w.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Nn(() => {
    o && y.current.focus();
  }, [o]), w.useImperativeHandle(r, () => ({
    adjustStyleForScrollbar: (P, {
      direction: T
    }) => {
      const O = !y.current.style.width;
      if (P.clientHeight < y.current.clientHeight && O) {
        const k = `${r3(ci(P))}px`;
        y.current.style[T === "rtl" ? "paddingLeft" : "paddingRight"] = k, y.current.style.width = `calc(100% + ${k})`;
      }
      return y.current;
    }
  }), []);
  const v = (P) => {
    const T = y.current, O = P.key;
    if (P.ctrlKey || P.metaKey || P.altKey) {
      f && f(P);
      return;
    }
    const I = er(T).activeElement;
    if (O === "ArrowDown")
      P.preventDefault(), Js(T, I, p, d, Xf);
    else if (O === "ArrowUp")
      P.preventDefault(), Js(T, I, p, d, Tx);
    else if (O === "Home")
      P.preventDefault(), Js(T, null, p, d, Xf);
    else if (O === "End")
      P.preventDefault(), Js(T, null, p, d, Tx);
    else if (O.length === 1) {
      const D = b.current, j = O.toLowerCase(), E = performance.now();
      D.keys.length > 0 && (E - D.lastTime > 500 ? (D.keys = [], D.repeating = !0, D.previousKeyMatched = !0) : D.repeating && j !== D.keys[0] && (D.repeating = !1)), D.lastTime = E, D.keys.push(j);
      const M = I && !D.repeating && H3(I, D);
      D.previousKeyMatched && (M || Js(T, I, !1, d, Xf, D)) ? P.preventDefault() : D.previousKeyMatched = !1;
    }
    f && f(P);
  }, $ = It(y, n);
  let S = -1;
  w.Children.forEach(l, (P, T) => {
    if (!/* @__PURE__ */ w.isValidElement(P)) {
      S === T && (S += 1, S >= l.length && (S = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && va.isFragment(P) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), P.props.disabled || (m === "selectedMenu" && P.props.selected || S === -1) && (S = T), S === T && (P.props.disabled || P.props.muiSkipListHighlight || P.type.muiSkipListHighlight) && (S += 1, S >= l.length && (S = -1));
  });
  const R = w.Children.map(l, (P, T) => {
    if (T === S) {
      const O = {};
      return a && (O.autoFocus = !0), P.props.tabIndex === void 0 && m === "selectedMenu" && (O.tabIndex = 0), /* @__PURE__ */ w.cloneElement(P, O);
    }
    return P;
  });
  return /* @__PURE__ */ x.jsx(sc, {
    role: "menu",
    ref: $,
    className: c,
    onKeyDown: v,
    tabIndex: o ? 0 : -1,
    ...g,
    children: R
  });
});
process.env.NODE_ENV !== "production" && (G3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: i.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: i.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: i.node,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: i.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: i.bool,
  /**
   * @ignore
   */
  onKeyDown: i.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: i.oneOf(["menu", "selectedMenu"])
});
function aj(e) {
  return Fe("MuiPopover", e);
}
Le("MuiPopover", ["root", "paper"]);
function Ox(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function Px(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function Ex(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function Mu(e) {
  return typeof e == "function" ? e() : e;
}
const sj = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"],
    paper: ["paper"]
  }, aj, t);
}, lj = ae(C0, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Y3 = ae(mi, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), K3 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiPopover"
  }), {
    action: o,
    anchorEl: a,
    anchorOrigin: l = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: c,
    anchorReference: d = "anchorEl",
    children: p,
    className: f,
    container: m,
    elevation: g = 8,
    marginThreshold: y = 16,
    open: b,
    PaperProps: v = {},
    slots: $ = {},
    slotProps: S = {},
    transformOrigin: R = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: P = vs,
    transitionDuration: T = "auto",
    TransitionProps: {
      onEntering: O,
      ...k
    } = {},
    disableScrollLock: I = !1,
    ...D
  } = r, j = (S == null ? void 0 : S.paper) ?? v, E = w.useRef(), M = {
    ...r,
    anchorOrigin: l,
    anchorReference: d,
    elevation: g,
    marginThreshold: y,
    externalPaperSlotProps: j,
    transformOrigin: R,
    TransitionComponent: P,
    transitionDuration: T,
    TransitionProps: k
  }, F = sj(M), B = w.useCallback(() => {
    if (d === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (c || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), c;
    const ue = Mu(a), ge = ue && ue.nodeType === 1 ? ue : er(E.current).body, W = ge.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const J = ge.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && J.top === 0 && J.left === 0 && J.right === 0 && J.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: W.top + Ox(W, l.vertical),
      left: W.left + Px(W, l.horizontal)
    };
  }, [a, l.horizontal, l.vertical, c, d]), V = w.useCallback((ue) => ({
    vertical: Ox(ue, R.vertical),
    horizontal: Px(ue, R.horizontal)
  }), [R.horizontal, R.vertical]), z = w.useCallback((ue) => {
    const ge = {
      width: ue.offsetWidth,
      height: ue.offsetHeight
    }, W = V(ge);
    if (d === "none")
      return {
        top: null,
        left: null,
        transformOrigin: Ex(W)
      };
    const J = B();
    let le = J.top - W.vertical, me = J.left - W.horizontal;
    const be = le + ge.height, de = me + ge.width, Oe = ci(Mu(a)), Re = Oe.innerHeight - y, We = Oe.innerWidth - y;
    if (y !== null && le < y) {
      const Ye = le - y;
      le -= Ye, W.vertical += Ye;
    } else if (y !== null && be > Re) {
      const Ye = be - Re;
      le -= Ye, W.vertical += Ye;
    }
    if (process.env.NODE_ENV !== "production" && ge.height > Re && ge.height && Re && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${ge.height - Re}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), y !== null && me < y) {
      const Ye = me - y;
      me -= Ye, W.horizontal += Ye;
    } else if (de > We) {
      const Ye = de - We;
      me -= Ye, W.horizontal += Ye;
    }
    return {
      top: `${Math.round(le)}px`,
      left: `${Math.round(me)}px`,
      transformOrigin: Ex(W)
    };
  }, [a, d, B, V, y]), [L, G] = w.useState(b), se = w.useCallback(() => {
    const ue = E.current;
    if (!ue)
      return;
    const ge = z(ue);
    ge.top !== null && ue.style.setProperty("top", ge.top), ge.left !== null && (ue.style.left = ge.left), ue.style.transformOrigin = ge.transformOrigin, G(!0);
  }, [z]);
  w.useEffect(() => (I && window.addEventListener("scroll", se), () => window.removeEventListener("scroll", se)), [a, I, se]);
  const ne = (ue, ge) => {
    O && O(ue, ge), se();
  }, K = () => {
    G(!1);
  };
  w.useEffect(() => {
    b && se();
  }), w.useImperativeHandle(o, () => b ? {
    updatePosition: () => {
      se();
    }
  } : null, [b, se]), w.useEffect(() => {
    if (!b)
      return;
    const ue = o0(() => {
      se();
    }), ge = ci(a);
    return ge.addEventListener("resize", ue), () => {
      ue.clear(), ge.removeEventListener("resize", ue);
    };
  }, [a, b, se]);
  let Q = T;
  T === "auto" && !P.muiSupportAuto && (Q = void 0);
  const ye = m || (a ? er(Mu(a)).body : void 0), we = {
    slots: $,
    slotProps: {
      ...S,
      paper: j
    }
  }, [fe, X] = Nt("paper", {
    elementType: Y3,
    externalForwardedProps: we,
    additionalProps: {
      elevation: g,
      className: _e(F.paper, j == null ? void 0 : j.className),
      style: L ? j.style : {
        ...j.style,
        opacity: 0
      }
    },
    ownerState: M
  }), [re, {
    slotProps: ie,
    ...Y
  }] = Nt("root", {
    elementType: lj,
    externalForwardedProps: we,
    additionalProps: {
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: ye,
      open: b
    },
    ownerState: M,
    className: _e(F.root, f)
  }), Z = It(E, X.ref);
  return /* @__PURE__ */ x.jsx(re, {
    ...Y,
    ...!jl(re) && {
      slotProps: ie,
      disableScrollLock: I
    },
    ...D,
    ref: n,
    children: /* @__PURE__ */ x.jsx(P, {
      appear: !0,
      in: b,
      onEntering: ne,
      onExited: K,
      timeout: Q,
      ...k,
      children: /* @__PURE__ */ x.jsx(fe, {
        ...X,
        ref: Z,
        children: p
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (K3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: gn,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: yo(i.oneOfType([li, i.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = Mu(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: i.shape({
    horizontal: i.oneOfType([i.oneOf(["center", "left", "right"]), i.number]).isRequired,
    vertical: i.oneOfType([i.oneOf(["bottom", "center", "top"]), i.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: i.shape({
    left: i.number.isRequired,
    top: i.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: i.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slotProps.root.slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slotProps.root.slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: i.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.root.slotProps.backdrop` instead.
   */
  BackdropProps: i.object,
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: i.oneOfType([li, i.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: i.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: i0,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: i.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: i.func,
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: i.shape({
    component: Dd
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    paper: i.oneOfType([i.func, i.object]),
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    paper: i.elementType,
    root: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: i.shape({
    horizontal: i.oneOfType([i.oneOf(["center", "left", "right"]), i.number]).isRequired,
    vertical: i.oneOfType([i.oneOf(["bottom", "center", "top"]), i.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: i.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: i.oneOfType([i.oneOf(["auto"]), i.number, i.shape({
    appear: i.number,
    enter: i.number,
    exit: i.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: i.object
});
function cj(e) {
  return Fe("MuiMenu", e);
}
Le("MuiMenu", ["root", "paper", "list"]);
const uj = {
  vertical: "top",
  horizontal: "right"
}, dj = {
  vertical: "top",
  horizontal: "left"
}, pj = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, cj, t);
}, fj = ae(K3, {
  shouldForwardProp: (e) => nr(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), hj = ae(Y3, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), mj = ae(G3, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), k0 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: o = !0,
    children: a,
    className: l,
    disableAutoFocusItem: c = !1,
    MenuListProps: d = {},
    onClose: p,
    open: f,
    PaperProps: m = {},
    PopoverClasses: g,
    transitionDuration: y = "auto",
    TransitionProps: {
      onEntering: b,
      ...v
    } = {},
    variant: $ = "selectedMenu",
    slots: S = {},
    slotProps: R = {},
    ...P
  } = r, T = no(), O = {
    ...r,
    autoFocus: o,
    disableAutoFocusItem: c,
    MenuListProps: d,
    onEntering: b,
    PaperProps: m,
    transitionDuration: y,
    TransitionProps: v,
    variant: $
  }, k = pj(O), I = o && !c && f, D = w.useRef(null), j = (L, G) => {
    D.current && D.current.adjustStyleForScrollbar(L, {
      direction: T ? "rtl" : "ltr"
    }), b && b(L, G);
  }, E = (L) => {
    L.key === "Tab" && (L.preventDefault(), p && p(L, "tabKeyDown"));
  };
  let M = -1;
  w.Children.map(a, (L, G) => {
    /* @__PURE__ */ w.isValidElement(L) && (process.env.NODE_ENV !== "production" && va.isFragment(L) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), L.props.disabled || ($ === "selectedMenu" && L.props.selected || M === -1) && (M = G));
  });
  const F = S.paper ?? hj, B = R.paper ?? m, V = Lt({
    elementType: S.root,
    externalSlotProps: R.root,
    ownerState: O,
    className: [k.root, l]
  }), z = Lt({
    elementType: F,
    externalSlotProps: B,
    ownerState: O,
    className: k.paper
  });
  return /* @__PURE__ */ x.jsx(fj, {
    onClose: p,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: T ? "right" : "left"
    },
    transformOrigin: T ? uj : dj,
    slots: {
      paper: F,
      root: S.root
    },
    slotProps: {
      root: V,
      paper: z
    },
    open: f,
    ref: n,
    transitionDuration: y,
    TransitionProps: {
      onEntering: j,
      ...v
    },
    ownerState: O,
    ...P,
    classes: g,
    children: /* @__PURE__ */ x.jsx(mj, {
      onKeyDown: E,
      actions: D,
      autoFocus: o && (M === -1 || c),
      autoFocusItem: I,
      variant: $,
      ...d,
      className: _e(k.list, d.className),
      children: a
    })
  });
});
process.env.NODE_ENV !== "production" && (k0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: i.oneOfType([li, i.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: i.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: i.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: i.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: i.func,
  /**
   * If `true`, the component is shown.
   */
  open: i.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: i.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: i.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    paper: i.oneOfType([i.func, i.object]),
    root: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    paper: i.elementType,
    root: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: i.oneOfType([i.oneOf(["auto"]), i.number, i.shape({
    appear: i.number,
    enter: i.number,
    exit: i.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: i.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: i.oneOf(["menu", "selectedMenu"])
});
function gj(e) {
  return Fe("MuiMenuItem", e);
}
const el = Le("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), yj = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, vj = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: r,
    disableGutters: o,
    selected: a,
    classes: l
  } = e, d = Be({
    root: ["root", n && "dense", t && "disabled", !o && "gutters", r && "divider", a && "selected"]
  }, gj, l);
  return {
    ...l,
    ...d
  };
}, bj = ae(jo, {
  shouldForwardProp: (e) => nr(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: yj
})(dt(({
  theme: e
}) => ({
  ...e.typography.body1,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${el.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : ht(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${el.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : ht(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${el.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : ht(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : ht(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${el.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${el.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${bx.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${bx.inset}`]: {
    marginLeft: 52
  },
  [`& .${es.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${es.inset}`]: {
    paddingLeft: 36
  },
  [`& .${Sx.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dense,
    style: {
      [e.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4,
      ...e.typography.body2,
      [`& .${Sx.root} svg`]: {
        fontSize: "1.25rem"
      }
    }
  }]
}))), td = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: o = !1,
    component: a = "li",
    dense: l = !1,
    divider: c = !1,
    disableGutters: d = !1,
    focusVisibleClassName: p,
    role: f = "menuitem",
    tabIndex: m,
    className: g,
    ...y
  } = r, b = w.useContext(ai), v = w.useMemo(() => ({
    dense: l || b.dense || !1,
    disableGutters: d
  }), [b.dense, l, d]), $ = w.useRef(null);
  Nn(() => {
    o && ($.current ? $.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [o]);
  const S = {
    ...r,
    dense: v.dense,
    divider: c,
    disableGutters: d
  }, R = vj(r), P = It($, n);
  let T;
  return r.disabled || (T = m !== void 0 ? m : -1), /* @__PURE__ */ x.jsx(ai.Provider, {
    value: v,
    children: /* @__PURE__ */ x.jsx(bj, {
      ref: P,
      role: f,
      tabIndex: T,
      component: a,
      focusVisibleClassName: _e(R.focusVisible, p),
      className: _e(R.root, g),
      ...y,
      ownerState: S,
      classes: R
    })
  });
});
process.env.NODE_ENV !== "production" && (td.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: i.bool,
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: i.bool,
  /**
   * @ignore
   */
  disabled: i.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: i.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: i.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: i.string,
  /**
   * @ignore
   */
  role: i.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: i.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * @default 0
   */
  tabIndex: i.number
});
function xj(e) {
  return Fe("MuiNativeSelect", e);
}
const _0 = Le("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), wj = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: o,
    open: a,
    error: l
  } = e, c = {
    select: ["select", n, r && "disabled", o && "multiple", l && "error"],
    icon: ["icon", `icon${Pe(n)}`, a && "iconOpen", r && "disabled"]
  };
  return Be(c, xj, t);
}, X3 = ae("select")(({
  theme: e
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${_0.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.variant !== "filled" && t.variant !== "outlined",
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius,
      "&:focus": {
        borderRadius: (e.vars || e).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
})), $j = ae(X3, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: nr,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${_0.multiple}`]: t.multiple
    }];
  }
})({}), Z3 = ae("svg")(({
  theme: e
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (e.vars || e).palette.action.active,
  [`&.${_0.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.open,
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
})), Cj = ae(Z3, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${Pe(n.variant)}`], n.open && t.iconOpen];
  }
})({}), Q3 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    className: r,
    disabled: o,
    error: a,
    IconComponent: l,
    inputRef: c,
    variant: d = "standard",
    ...p
  } = t, f = {
    ...t,
    disabled: o,
    variant: d,
    error: a
  }, m = wj(f);
  return /* @__PURE__ */ x.jsxs(w.Fragment, {
    children: [/* @__PURE__ */ x.jsx($j, {
      ownerState: f,
      className: _e(m.select, r),
      disabled: o,
      ref: c || n,
      ...p
    }), t.multiple ? null : /* @__PURE__ */ x.jsx(Cj, {
      as: l,
      ownerState: f,
      className: m.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (Q3.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * The CSS class name of the select element.
   */
  className: i.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: i.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: i.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: i.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: gn,
  /**
   * @ignore
   */
  multiple: i.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: i.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: i.func,
  /**
   * The input value.
   */
  value: i.any,
  /**
   * The variant to use.
   */
  variant: i.oneOf(["standard", "outlined", "filled"])
});
var Rx;
const Sj = ae("fieldset", {
  shouldForwardProp: nr
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), Tj = ae("legend", {
  shouldForwardProp: nr
})(dt(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: ({
      ownerState: t
    }) => !t.withLabel,
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel,
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel && t.notched,
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function J3(e) {
  const {
    children: t,
    classes: n,
    className: r,
    label: o,
    notched: a,
    ...l
  } = e, c = o != null && o !== "", d = {
    ...e,
    notched: a,
    withLabel: c
  };
  return /* @__PURE__ */ x.jsx(Sj, {
    "aria-hidden": !0,
    className: r,
    ownerState: d,
    ...l,
    children: /* @__PURE__ */ x.jsx(Tj, {
      ownerState: d,
      children: c ? /* @__PURE__ */ x.jsx("span", {
        children: o
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        Rx || (Rx = /* @__PURE__ */ x.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      )
    })
  });
}
process.env.NODE_ENV !== "production" && (J3.propTypes = {
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The label.
   */
  label: i.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: i.bool.isRequired,
  /**
   * @ignore
   */
  style: i.object
});
const Oj = (e) => {
  const {
    classes: t
  } = e, r = Be({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, j7, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...r
  };
}, Pj = ae(qd, {
  shouldForwardProp: (e) => nr(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: zd
})(dt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${Ur.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${Ur.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${Ur.focused} .${Ur.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(e.palette).filter(An()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        [`&.${Ur.focused} .${Ur.notchedOutline}`]: {
          borderColor: (e.vars || e).palette[n].main
        }
      }
    })), {
      props: {},
      // to overide the above style
      style: {
        [`&.${Ur.error} .${Ur.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.error.main
        },
        [`&.${Ur.disabled} .${Ur.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.action.disabled
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.startAdornment,
      style: {
        paddingLeft: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.endAdornment,
      style: {
        paddingRight: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.multiline,
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: ({
        ownerState: n,
        size: r
      }) => n.multiline && r === "small",
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
})), Ej = ae(J3, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(dt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
})), Rj = ae(Ud, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: Wd
})(dt(({
  theme: e
}) => ({
  padding: "16.5px 14px",
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }]
}))), Qd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  var r;
  const o = lt({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: a = {},
    fullWidth: l = !1,
    inputComponent: c = "input",
    label: d,
    multiline: p = !1,
    notched: f,
    slots: m = {},
    type: g = "text",
    ...y
  } = o, b = Oj(o), v = cr(), $ = Ui({
    props: o,
    muiFormControl: v,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), S = {
    ...o,
    color: $.color || "primary",
    disabled: $.disabled,
    error: $.error,
    focused: $.focused,
    formControl: v,
    fullWidth: l,
    hiddenLabel: $.hiddenLabel,
    multiline: p,
    size: $.size,
    type: g
  }, R = m.root ?? a.Root ?? Pj, P = m.input ?? a.Input ?? Rj;
  return /* @__PURE__ */ x.jsx(Hd, {
    slots: {
      root: R,
      input: P
    },
    renderSuffix: (T) => /* @__PURE__ */ x.jsx(Ej, {
      ownerState: S,
      className: b.notchedOutline,
      label: d != null && d !== "" && $.required ? r || (r = /* @__PURE__ */ x.jsxs(w.Fragment, {
        children: [d, " ", "*"]
      })) : d,
      notched: typeof f < "u" ? f : !!(T.startAdornment || T.filled || T.focused)
    }),
    fullWidth: l,
    inputComponent: c,
    multiline: p,
    ref: n,
    type: g,
    ...y,
    classes: {
      ...b,
      notchedOutline: null
    }
  });
});
process.env.NODE_ENV !== "production" && (Qd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: i.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: i.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: i.oneOfType([i.oneOf(["primary", "secondary"]), i.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: i.shape({
    Input: i.elementType,
    Root: i.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: i.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: i.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: i.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: i.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: i.bool,
  /**
   * The id of the `input` element.
   */
  id: i.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: i.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: i.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: i.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: i.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: i.oneOfType([i.number, i.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: i.oneOfType([i.number, i.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: i.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: i.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: i.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: i.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: i.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: i.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: i.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: i.oneOfType([i.number, i.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: i.shape({
    input: i.elementType,
    root: i.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: i.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: i.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: i.any
});
Qd.muiName = "Input";
const kj = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), _j = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), Dj = ae("span", {
  shouldForwardProp: nr
})({
  position: "relative",
  display: "flex"
}), Ij = ae(kj)({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), Mj = ae(_j)(dt(({
  theme: e
}) => ({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: {
      checked: !0
    },
    style: {
      transform: "scale(1)",
      transition: e.transitions.create("transform", {
        easing: e.transitions.easing.easeOut,
        duration: e.transitions.duration.shortest
      })
    }
  }]
})));
function D0(e) {
  const {
    checked: t = !1,
    classes: n = {},
    fontSize: r
  } = e, o = {
    ...e,
    checked: t
  };
  return /* @__PURE__ */ x.jsxs(Dj, {
    className: n.root,
    ownerState: o,
    children: [/* @__PURE__ */ x.jsx(Ij, {
      fontSize: r,
      className: n.background,
      ownerState: o
    }), /* @__PURE__ */ x.jsx(Mj, {
      fontSize: r,
      className: n.dot,
      ownerState: o
    })]
  });
}
process.env.NODE_ENV !== "production" && (D0.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: i.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: i.oneOf(["small", "medium"])
});
const I0 = /* @__PURE__ */ w.createContext(void 0);
process.env.NODE_ENV !== "production" && (I0.displayName = "RadioGroupContext");
function Aj() {
  return w.useContext(I0);
}
function Nj(e) {
  return Fe("MuiRadio", e);
}
const kx = Le("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), jj = (e) => {
  const {
    classes: t,
    color: n,
    size: r
  } = e, o = {
    root: ["root", `color${Pe(n)}`, r !== "medium" && `size${Pe(r)}`]
  };
  return {
    ...t,
    ...Be(o, Nj, t)
  };
}, Fj = ae($0, {
  shouldForwardProp: (e) => nr(e) || e === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size !== "medium" && t[`size${Pe(n.size)}`], t[`color${Pe(n.color)}`]];
  }
})(dt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  [`&.${kx.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: {
      color: "default",
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : ht(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(An()).map(([t]) => ({
    props: {
      color: t,
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : ht(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(An()).map(([t]) => ({
    props: {
      color: t,
      disabled: !1
    },
    style: {
      [`&.${kx.checked}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
})));
function Lj(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
const _x = /* @__PURE__ */ x.jsx(D0, {
  checked: !0
}), Dx = /* @__PURE__ */ x.jsx(D0, {}), M0 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiRadio"
  }), {
    checked: o,
    checkedIcon: a = _x,
    color: l = "primary",
    icon: c = Dx,
    name: d,
    onChange: p,
    size: f = "medium",
    className: m,
    disabled: g,
    disableRipple: y = !1,
    ...b
  } = r, v = cr();
  let $ = g;
  v && typeof $ > "u" && ($ = v.disabled), $ ?? ($ = !1);
  const S = {
    ...r,
    disabled: $,
    disableRipple: y,
    color: l,
    size: f
  }, R = jj(S), P = Aj();
  let T = o;
  const O = ug(p, P && P.onChange);
  let k = d;
  return P && (typeof T > "u" && (T = Lj(P.value, r.value)), typeof k > "u" && (k = P.name)), /* @__PURE__ */ x.jsx(Fj, {
    type: "radio",
    icon: /* @__PURE__ */ w.cloneElement(c, {
      fontSize: Dx.props.fontSize ?? f
    }),
    checkedIcon: /* @__PURE__ */ w.cloneElement(a, {
      fontSize: _x.props.fontSize ?? f
    }),
    disabled: $,
    ownerState: S,
    classes: R,
    name: k,
    checked: T,
    onChange: O,
    ref: n,
    className: _e(R.root, m),
    ...b
  });
});
process.env.NODE_ENV !== "production" && (M0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: i.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: i.oneOfType([i.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), i.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: i.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: i.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: i.node,
  /**
   * The id of the `input` element.
   */
  id: i.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: i.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * Name attribute of the `input` element.
   */
  name: i.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: i.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: i.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: i.oneOfType([i.oneOf(["medium", "small"]), i.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: i.any
});
function Bj(e) {
  return Fe("MuiRadioGroup", e);
}
Le("MuiRadioGroup", ["root", "row", "error"]);
const Vj = (e) => {
  const {
    classes: t,
    row: n,
    error: r
  } = e;
  return Be({
    root: ["root", n && "row", r && "error"]
  }, Bj, t);
}, eS = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: r,
    children: o,
    className: a,
    defaultValue: l,
    name: c,
    onChange: d,
    value: p,
    ...f
  } = t, m = w.useRef(null), g = Vj(t), [y, b] = sr({
    controlled: p,
    default: l,
    name: "RadioGroup"
  });
  w.useImperativeHandle(r, () => ({
    focus: () => {
      let R = m.current.querySelector("input:not(:disabled):checked");
      R || (R = m.current.querySelector("input:not(:disabled)")), R && R.focus();
    }
  }), []);
  const v = It(n, m), $ = Mr(c), S = w.useMemo(() => ({
    name: $,
    onChange(R) {
      b(R.target.value), d && d(R, R.target.value);
    },
    value: y
  }), [$, d, b, y]);
  return /* @__PURE__ */ x.jsx(I0.Provider, {
    value: S,
    children: /* @__PURE__ */ x.jsx(T0, {
      role: "radiogroup",
      ref: v,
      className: _e(g.root, a),
      ...f,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (eS.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: i.any,
  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: i.string,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: i.func,
  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: i.any
});
function tS(e) {
  return Fe("MuiSelect", e);
}
const tl = Le("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var Ix;
const zj = ae(X3, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${tl.select}`]: t.select
      },
      {
        [`&.${tl.select}`]: t[n.variant]
      },
      {
        [`&.${tl.error}`]: t.error
      },
      {
        [`&.${tl.multiple}`]: t.multiple
      }
    ];
  }
})({
  // Win specificity over the input base
  [`&.${tl.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), Wj = ae(Z3, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${Pe(n.variant)}`], n.open && t.iconOpen];
  }
})({}), qj = ae("input", {
  shouldForwardProp: (e) => x3(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function Mx(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function Uj(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const Hj = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: o,
    open: a,
    error: l
  } = e, c = {
    select: ["select", n, r && "disabled", o && "multiple", l && "error"],
    icon: ["icon", `icon${Pe(n)}`, a && "iconOpen", r && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return Be(c, tS, t);
}, nS = /* @__PURE__ */ w.forwardRef(function(t, n) {
  var Jt;
  const {
    "aria-describedby": r,
    "aria-label": o,
    autoFocus: a,
    autoWidth: l,
    children: c,
    className: d,
    defaultOpen: p,
    defaultValue: f,
    disabled: m,
    displayEmpty: g,
    error: y = !1,
    IconComponent: b,
    inputRef: v,
    labelId: $,
    MenuProps: S = {},
    multiple: R,
    name: P,
    onBlur: T,
    onChange: O,
    onClose: k,
    onFocus: I,
    onOpen: D,
    open: j,
    readOnly: E,
    renderValue: M,
    required: F,
    SelectDisplayProps: B = {},
    tabIndex: V,
    // catching `type` from Input which makes no sense for SelectInput
    type: z,
    value: L,
    variant: G = "standard",
    ...se
  } = t, [ne, K] = sr({
    controlled: L,
    default: f,
    name: "Select"
  }), [Q, ye] = sr({
    controlled: j,
    default: p,
    name: "Select"
  }), we = w.useRef(null), fe = w.useRef(null), [X, re] = w.useState(null), {
    current: ie
  } = w.useRef(j != null), [Y, Z] = w.useState(), ue = It(n, v), ge = w.useCallback((Me) => {
    fe.current = Me, Me && re(Me);
  }, []), W = X == null ? void 0 : X.parentNode;
  w.useImperativeHandle(ue, () => ({
    focus: () => {
      fe.current.focus();
    },
    node: we.current,
    value: ne
  }), [ne]), w.useEffect(() => {
    p && Q && X && !ie && (Z(l ? null : W.clientWidth), fe.current.focus());
  }, [X, l]), w.useEffect(() => {
    a && fe.current.focus();
  }, [a]), w.useEffect(() => {
    if (!$)
      return;
    const Me = er(fe.current).getElementById($);
    if (Me) {
      const it = () => {
        getSelection().isCollapsed && fe.current.focus();
      };
      return Me.addEventListener("click", it), () => {
        Me.removeEventListener("click", it);
      };
    }
  }, [$]);
  const J = (Me, it) => {
    Me ? D && D(it) : k && k(it), ie || (Z(l ? null : W.clientWidth), ye(Me));
  }, le = (Me) => {
    Me.button === 0 && (Me.preventDefault(), fe.current.focus(), J(!0, Me));
  }, me = (Me) => {
    J(!1, Me);
  }, be = w.Children.toArray(c), de = (Me) => {
    const it = be.find((bt) => bt.props.value === Me.target.value);
    it !== void 0 && (K(it.props.value), O && O(Me, it));
  }, Oe = (Me) => (it) => {
    let bt;
    if (it.currentTarget.hasAttribute("tabindex")) {
      if (R) {
        bt = Array.isArray(ne) ? ne.slice() : [];
        const gt = ne.indexOf(Me.props.value);
        gt === -1 ? bt.push(Me.props.value) : bt.splice(gt, 1);
      } else
        bt = Me.props.value;
      if (Me.props.onClick && Me.props.onClick(it), ne !== bt && (K(bt), O)) {
        const gt = it.nativeEvent || it, Et = new gt.constructor(gt.type, gt);
        Object.defineProperty(Et, "target", {
          writable: !0,
          value: {
            value: bt,
            name: P
          }
        }), O(Et, Me);
      }
      R || J(!1, it);
    }
  }, Re = (Me) => {
    E || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].includes(Me.key) && (Me.preventDefault(), J(!0, Me));
  }, We = X !== null && Q, Ye = (Me) => {
    !We && T && (Object.defineProperty(Me, "target", {
      writable: !0,
      value: {
        value: ne,
        name: P
      }
    }), T(Me));
  };
  delete se["aria-invalid"];
  let Ie, kt;
  const Ee = [];
  let Ae = !1, pt = !1;
  (ed({
    value: ne
  }) || g) && (M ? Ie = M(ne) : Ae = !0);
  const Ue = be.map((Me) => {
    if (!/* @__PURE__ */ w.isValidElement(Me))
      return null;
    process.env.NODE_ENV !== "production" && va.isFragment(Me) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let it;
    if (R) {
      if (!Array.isArray(ne))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : No(2));
      it = ne.some((bt) => Mx(bt, Me.props.value)), it && Ae && Ee.push(Me.props.children);
    } else
      it = Mx(ne, Me.props.value), it && Ae && (kt = Me.props.children);
    return it && (pt = !0), /* @__PURE__ */ w.cloneElement(Me, {
      "aria-selected": it ? "true" : "false",
      onClick: Oe(Me),
      onKeyUp: (bt) => {
        bt.key === " " && bt.preventDefault(), Me.props.onKeyUp && Me.props.onKeyUp(bt);
      },
      role: "option",
      selected: it,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": Me.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && w.useEffect(() => {
    if (!pt && !R && ne !== "") {
      const Me = be.map((it) => it.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${ne}\` for the select ${P ? `(name="${P}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${Me.filter((it) => it != null).map((it) => `\`${it}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [pt, be, R, P, ne]), Ae && (R ? Ee.length === 0 ? Ie = null : Ie = Ee.reduce((Me, it, bt) => (Me.push(it), bt < Ee.length - 1 && Me.push(", "), Me), []) : Ie = kt);
  let et = Y;
  !l && ie && X && (et = W.clientWidth);
  let Je;
  typeof V < "u" ? Je = V : Je = m ? null : 0;
  const rt = B.id || (P ? `mui-component-select-${P}` : void 0), je = {
    ...t,
    variant: G,
    value: ne,
    open: We,
    error: y
  }, $t = Hj(je), Pt = {
    ...S.PaperProps,
    ...(Jt = S.slotProps) == null ? void 0 : Jt.paper
  }, Ft = Mr();
  return /* @__PURE__ */ x.jsxs(w.Fragment, {
    children: [/* @__PURE__ */ x.jsx(zj, {
      as: "div",
      ref: ge,
      tabIndex: Je,
      role: "combobox",
      "aria-controls": We ? Ft : void 0,
      "aria-disabled": m ? "true" : void 0,
      "aria-expanded": We ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": o,
      "aria-labelledby": [$, rt].filter(Boolean).join(" ") || void 0,
      "aria-describedby": r,
      "aria-required": F ? "true" : void 0,
      "aria-invalid": y ? "true" : void 0,
      onKeyDown: Re,
      onMouseDown: m || E ? null : le,
      onBlur: Ye,
      onFocus: I,
      ...B,
      ownerState: je,
      className: _e(B.className, $t.select, d),
      id: rt,
      children: Uj(Ie) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        Ix || (Ix = /* @__PURE__ */ x.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      ) : Ie
    }), /* @__PURE__ */ x.jsx(qj, {
      "aria-invalid": y,
      value: Array.isArray(ne) ? ne.join(",") : ne,
      name: P,
      ref: we,
      "aria-hidden": !0,
      onChange: de,
      tabIndex: -1,
      disabled: m,
      className: $t.nativeInput,
      autoFocus: a,
      required: F,
      ...se,
      ownerState: je
    }), /* @__PURE__ */ x.jsx(Wj, {
      as: b,
      className: $t.icon,
      ownerState: je
    }), /* @__PURE__ */ x.jsx(k0, {
      id: `menu-${P || ""}`,
      anchorEl: W,
      open: We,
      onClose: me,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      ...S,
      MenuListProps: {
        "aria-labelledby": $,
        role: "listbox",
        "aria-multiselectable": R ? "true" : void 0,
        disableListWrap: !0,
        id: Ft,
        ...S.MenuListProps
      },
      slotProps: {
        ...S.slotProps,
        paper: {
          ...Pt,
          style: {
            minWidth: et,
            ...Pt != null ? Pt.style : null
          }
        }
      },
      children: Ue
    })]
  });
});
process.env.NODE_ENV !== "production" && (nS.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": i.string,
  /**
   * @ignore
   */
  "aria-label": i.string,
  /**
   * @ignore
   */
  autoFocus: i.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: i.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * The CSS class name of the select element.
   */
  className: i.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: i.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: i.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: i.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: i.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: i.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: i.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: gn,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: i.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: i.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: i.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: i.string,
  /**
   * @ignore
   */
  onBlur: i.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: i.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: i.func,
  /**
   * @ignore
   */
  onFocus: i.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: i.func,
  /**
   * If `true`, the component is shown.
   */
  open: i.bool,
  /**
   * @ignore
   */
  readOnly: i.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: i.func,
  /**
   * If `true`, the component is required.
   */
  required: i.bool,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: i.object,
  /**
   * @ignore
   */
  tabIndex: i.oneOfType([i.number, i.string]),
  /**
   * @ignore
   */
  type: i.any,
  /**
   * The input value.
   */
  value: i.any,
  /**
   * The variant to use.
   */
  variant: i.oneOf(["standard", "outlined", "filled"])
});
const Gj = (e) => {
  const {
    classes: t
  } = e, r = Be({
    root: ["root"]
  }, tS, t);
  return {
    ...t,
    ...r
  };
}, A0 = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => nr(e) && e !== "variant",
  slot: "Root"
}, Yj = ae(Zd, A0)(""), Kj = ae(Qd, A0)(""), Xj = ae(Kd, A0)(""), Jd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: o = !1,
    children: a,
    classes: l = {},
    className: c,
    defaultOpen: d = !1,
    displayEmpty: p = !1,
    IconComponent: f = L3,
    id: m,
    input: g,
    inputProps: y,
    label: b,
    labelId: v,
    MenuProps: $,
    multiple: S = !1,
    native: R = !1,
    onClose: P,
    onOpen: T,
    open: O,
    renderValue: k,
    SelectDisplayProps: I,
    variant: D = "outlined",
    ...j
  } = r, E = R ? Q3 : nS, M = cr(), F = Ui({
    props: r,
    muiFormControl: M,
    states: ["variant", "error"]
  }), B = F.variant || D, V = {
    ...r,
    variant: B,
    classes: l
  }, z = Gj(V), {
    root: L,
    ...G
  } = z, se = g || {
    standard: /* @__PURE__ */ x.jsx(Yj, {
      ownerState: V
    }),
    outlined: /* @__PURE__ */ x.jsx(Kj, {
      label: b,
      ownerState: V
    }),
    filled: /* @__PURE__ */ x.jsx(Xj, {
      ownerState: V
    })
  }[B], ne = It(n, Os(se));
  return /* @__PURE__ */ x.jsx(w.Fragment, {
    children: /* @__PURE__ */ w.cloneElement(se, {
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: E,
      inputProps: {
        children: a,
        error: F.error,
        IconComponent: f,
        variant: B,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: S,
        ...R ? {
          id: m
        } : {
          autoWidth: o,
          defaultOpen: d,
          displayEmpty: p,
          labelId: v,
          MenuProps: $,
          onClose: P,
          onOpen: T,
          open: O,
          renderValue: k,
          SelectDisplayProps: {
            id: m,
            ...I
          }
        },
        ...y,
        classes: y ? Vn(G, y.classes) : G,
        ...g ? g.props.inputProps : {}
      },
      ...(S && R || p) && B === "outlined" ? {
        notched: !0
      } : {},
      ref: ne,
      className: _e(se.props.className, c, z.root),
      // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
      ...!g && {
        variant: B
      },
      ...j
    })
  });
});
process.env.NODE_ENV !== "production" && (Jd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: i.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: i.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: i.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: i.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: i.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: i.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: i.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: i.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: i.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: i.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: i.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: i.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: i.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: i.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: i.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: i.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: i.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: i.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: i.oneOfType([i.oneOf([""]), i.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: i.oneOf(["filled", "outlined", "standard"])
});
Jd.muiName = "Select";
function Zj(e) {
  return Fe("MuiTooltip", e);
}
const Sn = Le("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]);
function Qj(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Jj = (e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: r,
    touch: o,
    placement: a
  } = e, l = {
    popper: ["popper", !n && "popperInteractive", r && "popperArrow"],
    tooltip: ["tooltip", r && "tooltipArrow", o && "touch", `tooltipPlacement${Pe(a.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return Be(l, Zj, t);
}, eF = ae(Es, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})(dt(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableInteractive,
    style: {
      pointerEvents: "auto"
    }
  }, {
    props: ({
      open: t
    }) => !t,
    style: {
      pointerEvents: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      [`&[data-popper-placement*="bottom"] .${Sn.arrow}`]: {
        top: 0,
        marginTop: "-0.71em",
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${Sn.arrow}`]: {
        bottom: 0,
        marginBottom: "-0.71em",
        "&::before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${Sn.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${Sn.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "0 0"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${Sn.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${Sn.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${Sn.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${Sn.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }]
}))), tF = ae("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${Pe(n.placement.split("-")[0])}`]];
  }
})(dt(({
  theme: e
}) => ({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : ht(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium,
  [`.${Sn.popper}[data-popper-placement*="left"] &`]: {
    transformOrigin: "right center"
  },
  [`.${Sn.popper}[data-popper-placement*="right"] &`]: {
    transformOrigin: "left center"
  },
  [`.${Sn.popper}[data-popper-placement*="top"] &`]: {
    transformOrigin: "center bottom",
    marginBottom: "14px"
  },
  [`.${Sn.popper}[data-popper-placement*="bottom"] &`]: {
    transformOrigin: "center top",
    marginTop: "14px"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      position: "relative",
      margin: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      padding: "8px 16px",
      fontSize: e.typography.pxToRem(14),
      lineHeight: `${Qj(16 / 14)}em`,
      fontWeight: e.typography.fontWeightRegular
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl,
    style: {
      [`.${Sn.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "14px"
      },
      [`.${Sn.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl && t.touch,
    style: {
      [`.${Sn.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "24px"
      },
      [`.${Sn.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl,
    style: {
      [`.${Sn.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "14px"
      },
      [`.${Sn.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl && t.touch,
    style: {
      [`.${Sn.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "24px"
      },
      [`.${Sn.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${Sn.popper}[data-popper-placement*="top"] &`]: {
        marginBottom: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${Sn.popper}[data-popper-placement*="bottom"] &`]: {
        marginTop: "24px"
      }
    }
  }]
}))), nF = ae("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(dt(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : ht(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
})));
let gu = !1;
const Ax = new Md();
let nl = {
  x: 0,
  y: 0
};
function yu(e, t) {
  return (n, ...r) => {
    t && t(n, ...r), e(n, ...r);
  };
}
const Fi = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: o = !1,
    children: a,
    classes: l,
    components: c = {},
    componentsProps: d = {},
    describeChild: p = !1,
    disableFocusListener: f = !1,
    disableHoverListener: m = !1,
    disableInteractive: g = !1,
    disableTouchListener: y = !1,
    enterDelay: b = 100,
    enterNextDelay: v = 0,
    enterTouchDelay: $ = 700,
    followCursor: S = !1,
    id: R,
    leaveDelay: P = 0,
    leaveTouchDelay: T = 1500,
    onClose: O,
    onOpen: k,
    open: I,
    placement: D = "bottom",
    PopperComponent: j,
    PopperProps: E = {},
    slotProps: M = {},
    slots: F = {},
    title: B,
    TransitionComponent: V,
    TransitionProps: z,
    ...L
  } = r, G = /* @__PURE__ */ w.isValidElement(a) ? a : /* @__PURE__ */ x.jsx("span", {
    children: a
  }), se = tr(), ne = no(), [K, Q] = w.useState(), [ye, we] = w.useState(null), fe = w.useRef(!1), X = g || S, re = Ja(), ie = Ja(), Y = Ja(), Z = Ja(), [ue, ge] = sr({
    controlled: I,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let W = ue;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: tt
    } = w.useRef(I !== void 0);
    w.useEffect(() => {
      K && K.disabled && !tt && B !== "" && K.tagName.toLowerCase() === "button" && console.warn(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [B, K, tt]);
  }
  const J = Mr(R), le = w.useRef(), me = ze(() => {
    le.current !== void 0 && (document.body.style.WebkitUserSelect = le.current, le.current = void 0), Z.clear();
  });
  w.useEffect(() => me, [me]);
  const be = (tt) => {
    Ax.clear(), gu = !0, ge(!0), k && !W && k(tt);
  }, de = ze(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (tt) => {
      Ax.start(800 + P, () => {
        gu = !1;
      }), ge(!1), O && W && O(tt), re.start(se.transitions.duration.shortest, () => {
        fe.current = !1;
      });
    }
  ), Oe = (tt) => {
    fe.current && tt.type !== "touchstart" || (K && K.removeAttribute("title"), ie.clear(), Y.clear(), b || gu && v ? ie.start(gu ? v : b, () => {
      be(tt);
    }) : be(tt));
  }, Re = (tt) => {
    ie.clear(), Y.start(P, () => {
      de(tt);
    });
  }, [, We] = w.useState(!1), Ye = (tt) => {
    qu(tt.target) || (We(!1), Re(tt));
  }, Ie = (tt) => {
    K || Q(tt.currentTarget), qu(tt.target) && (We(!0), Oe(tt));
  }, kt = (tt) => {
    fe.current = !0;
    const In = G.props;
    In.onTouchStart && In.onTouchStart(tt);
  }, Ee = (tt) => {
    kt(tt), Y.clear(), re.clear(), me(), le.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Z.start($, () => {
      document.body.style.WebkitUserSelect = le.current, Oe(tt);
    });
  }, Ae = (tt) => {
    G.props.onTouchEnd && G.props.onTouchEnd(tt), me(), Y.start(T, () => {
      de(tt);
    });
  };
  w.useEffect(() => {
    if (!W)
      return;
    function tt(In) {
      In.key === "Escape" && de(In);
    }
    return document.addEventListener("keydown", tt), () => {
      document.removeEventListener("keydown", tt);
    };
  }, [de, W]);
  const pt = It(Os(G), Q, n);
  !B && B !== 0 && (W = !1);
  const Ue = w.useRef(), et = (tt) => {
    const In = G.props;
    In.onMouseMove && In.onMouseMove(tt), nl = {
      x: tt.clientX,
      y: tt.clientY
    }, Ue.current && Ue.current.update();
  }, Je = {}, rt = typeof B == "string";
  p ? (Je.title = !W && rt && !m ? B : null, Je["aria-describedby"] = W ? J : null) : (Je["aria-label"] = rt ? B : null, Je["aria-labelledby"] = W && !rt ? J : null);
  const je = {
    ...Je,
    ...L,
    ...G.props,
    className: _e(L.className, G.props.className),
    onTouchStart: kt,
    ref: pt,
    ...S ? {
      onMouseMove: et
    } : {}
  };
  process.env.NODE_ENV !== "production" && (je["data-mui-internal-clone-element"] = !0, w.useEffect(() => {
    K && !K.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [K]));
  const $t = {};
  y || (je.onTouchStart = Ee, je.onTouchEnd = Ae), m || (je.onMouseOver = yu(Oe, je.onMouseOver), je.onMouseLeave = yu(Re, je.onMouseLeave), X || ($t.onMouseOver = Oe, $t.onMouseLeave = Re)), f || (je.onFocus = yu(Ie, je.onFocus), je.onBlur = yu(Ye, je.onBlur), X || ($t.onFocus = Ie, $t.onBlur = Ye)), process.env.NODE_ENV !== "production" && G.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${G.props.title}\` or the Tooltip component.`].join(`
`));
  const Pt = {
    ...r,
    isRtl: ne,
    arrow: o,
    disableInteractive: X,
    placement: D,
    PopperComponentProp: j,
    touch: fe.current
  }, Ft = typeof M.popper == "function" ? M.popper(Pt) : M.popper, Jt = w.useMemo(() => {
    var In, bo;
    let tt = [{
      name: "arrow",
      enabled: !!ye,
      options: {
        element: ye,
        padding: 4
      }
    }];
    return (In = E.popperOptions) != null && In.modifiers && (tt = tt.concat(E.popperOptions.modifiers)), (bo = Ft == null ? void 0 : Ft.popperOptions) != null && bo.modifiers && (tt = tt.concat(Ft.popperOptions.modifiers)), {
      ...E.popperOptions,
      ...Ft == null ? void 0 : Ft.popperOptions,
      modifiers: tt
    };
  }, [ye, E.popperOptions, Ft == null ? void 0 : Ft.popperOptions]), Me = Jj(Pt), it = typeof M.transition == "function" ? M.transition(Pt) : M.transition, bt = {
    slots: {
      popper: c.Popper,
      transition: c.Transition ?? V,
      tooltip: c.Tooltip,
      arrow: c.Arrow,
      ...F
    },
    slotProps: {
      arrow: M.arrow ?? d.arrow,
      popper: {
        ...E,
        ...Ft ?? d.popper
      },
      // resolvedPopperProps can be spread because it's already an object
      tooltip: M.tooltip ?? d.tooltip,
      transition: {
        ...z,
        ...it ?? d.transition
      }
    }
  }, [gt, Et] = Nt("popper", {
    elementType: eF,
    externalForwardedProps: bt,
    ownerState: Pt,
    className: _e(Me.popper, E == null ? void 0 : E.className)
  }), [xn, ln] = Nt("transition", {
    elementType: vs,
    externalForwardedProps: bt,
    ownerState: Pt
  }), [wr, Yn] = Nt("tooltip", {
    elementType: tF,
    className: Me.tooltip,
    externalForwardedProps: bt,
    ownerState: Pt
  }), [oo, vo] = Nt("arrow", {
    elementType: nF,
    className: Me.arrow,
    externalForwardedProps: bt,
    ownerState: Pt,
    ref: we
  });
  return /* @__PURE__ */ x.jsxs(w.Fragment, {
    children: [/* @__PURE__ */ w.cloneElement(G, je), /* @__PURE__ */ x.jsx(gt, {
      as: j ?? Es,
      placement: D,
      anchorEl: S ? {
        getBoundingClientRect: () => ({
          top: nl.y,
          left: nl.x,
          right: nl.x,
          bottom: nl.y,
          width: 0,
          height: 0
        })
      } : K,
      popperRef: Ue,
      open: K ? W : !1,
      id: J,
      transition: !0,
      ...$t,
      ...Et,
      popperOptions: Jt,
      children: ({
        TransitionProps: tt
      }) => /* @__PURE__ */ x.jsx(xn, {
        timeout: se.transitions.duration.shorter,
        ...tt,
        ...ln,
        children: /* @__PURE__ */ x.jsxs(wr, {
          ...Yn,
          children: [B, o ? /* @__PURE__ */ x.jsx(oo, {
            ...vo
          }) : null]
        })
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (Fi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: i.bool,
  /**
   * Tooltip reference element.
   */
  children: Ts.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: i.shape({
    Arrow: i.elementType,
    Popper: i.elementType,
    Tooltip: i.elementType,
    Transition: i.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: i.shape({
    arrow: i.object,
    popper: i.object,
    tooltip: i.object,
    transition: i.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: i.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: i.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: i.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: i.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: i.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: i.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: i.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: i.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: i.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: i.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: i.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: i.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: i.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: i.func,
  /**
   * If `true`, the component is shown.
   */
  open: i.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: i.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @deprecated use the `slots.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: i.elementType,
  /**
   * Props applied to the [`Popper`](https://mui.com/material-ui/api/popper/) element.
   * @deprecated use the `slotProps.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PopperProps: i.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    arrow: i.oneOfType([i.func, i.object]),
    popper: i.oneOfType([i.func, i.object]),
    tooltip: i.oneOfType([i.func, i.object]),
    transition: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    arrow: i.elementType,
    popper: i.elementType,
    tooltip: i.elementType,
    transition: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: i.node,
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: i.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: i.object
});
const Qt = yD({
  createStyledComponent: ae("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => lt({
    props: e,
    name: "MuiStack"
  })
});
process.env.NODE_ENV !== "production" && (Qt.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: i.oneOfType([i.oneOf(["column-reverse", "column", "row-reverse", "row"]), i.arrayOf(i.oneOf(["column-reverse", "column", "row-reverse", "row"])), i.object]),
  /**
   * Add an element between each child.
   */
  divider: i.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: i.oneOfType([i.arrayOf(i.oneOfType([i.number, i.string])), i.number, i.object, i.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: i.bool
});
const N0 = /* @__PURE__ */ w.createContext();
process.env.NODE_ENV !== "production" && (N0.displayName = "TableContext");
function rF(e) {
  return Fe("MuiTable", e);
}
Le("MuiTable", ["root", "stickyHeader"]);
const oF = (e) => {
  const {
    classes: t,
    stickyHeader: n
  } = e;
  return Be({
    root: ["root", n && "stickyHeader"]
  }, rF, t);
}, iF = ae("table", {
  name: "MuiTable",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.stickyHeader && t.stickyHeader];
  }
})(dt(({
  theme: e
}) => ({
  display: "table",
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& caption": {
    ...e.typography.body2,
    padding: e.spacing(2),
    color: (e.vars || e).palette.text.secondary,
    textAlign: "left",
    captionSide: "bottom"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.stickyHeader,
    style: {
      borderCollapse: "separate"
    }
  }]
}))), Nx = "table", rS = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiTable"
  }), {
    className: o,
    component: a = Nx,
    padding: l = "normal",
    size: c = "medium",
    stickyHeader: d = !1,
    ...p
  } = r, f = {
    ...r,
    component: a,
    padding: l,
    size: c,
    stickyHeader: d
  }, m = oF(f), g = w.useMemo(() => ({
    padding: l,
    size: c,
    stickyHeader: d
  }), [l, c, d]);
  return /* @__PURE__ */ x.jsx(N0.Provider, {
    value: g,
    children: /* @__PURE__ */ x.jsx(iF, {
      as: a,
      role: a === Nx ? null : "table",
      ref: n,
      className: _e(m.root, o),
      ownerState: f,
      ...p
    })
  });
});
process.env.NODE_ENV !== "production" && (rS.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */
  padding: i.oneOf(["checkbox", "none", "normal"]),
  /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */
  size: i.oneOfType([i.oneOf(["medium", "small"]), i.string]),
  /**
   * Set the header sticky.
   * @default false
   */
  stickyHeader: i.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
const lc = /* @__PURE__ */ w.createContext();
process.env.NODE_ENV !== "production" && (lc.displayName = "Tablelvl2Context");
function aF(e) {
  return Fe("MuiTableBody", e);
}
Le("MuiTableBody", ["root"]);
const sF = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"]
  }, aF, t);
}, lF = ae("tbody", {
  name: "MuiTableBody",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-row-group"
}), cF = {
  variant: "body"
}, jx = "tbody", oS = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiTableBody"
  }), {
    className: o,
    component: a = jx,
    ...l
  } = r, c = {
    ...r,
    component: a
  }, d = sF(c);
  return /* @__PURE__ */ x.jsx(lc.Provider, {
    value: cF,
    children: /* @__PURE__ */ x.jsx(lF, {
      className: _e(d.root, o),
      as: a,
      ref: n,
      role: a === jx ? null : "rowgroup",
      ownerState: c,
      ...l
    })
  });
});
process.env.NODE_ENV !== "production" && (oS.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function uF(e) {
  return Fe("MuiTableCell", e);
}
const dF = Le("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), pF = (e) => {
  const {
    classes: t,
    variant: n,
    align: r,
    padding: o,
    size: a,
    stickyHeader: l
  } = e, c = {
    root: ["root", n, l && "stickyHeader", r !== "inherit" && `align${Pe(r)}`, o !== "normal" && `padding${Pe(o)}`, `size${Pe(a)}`]
  };
  return Be(c, uF, t);
}, fF = ae("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`size${Pe(n.size)}`], n.padding !== "normal" && t[`padding${Pe(n.padding)}`], n.align !== "inherit" && t[`align${Pe(n.align)}`], n.stickyHeader && t.stickyHeader];
  }
})(dt(({
  theme: e
}) => ({
  ...e.typography.body2,
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? ps(ht(e.palette.divider, 1), 0.88) : ds(ht(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16,
  variants: [{
    props: {
      variant: "head"
    },
    style: {
      color: (e.vars || e).palette.text.primary,
      lineHeight: e.typography.pxToRem(24),
      fontWeight: e.typography.fontWeightMedium
    }
  }, {
    props: {
      variant: "body"
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }, {
    props: {
      variant: "footer"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      lineHeight: e.typography.pxToRem(21),
      fontSize: e.typography.pxToRem(12)
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      padding: "6px 16px",
      [`&.${dF.paddingCheckbox}`]: {
        width: 24,
        // prevent the checkbox column from growing
        padding: "0 12px 0 16px",
        "& > *": {
          padding: 0
        }
      }
    }
  }, {
    props: {
      padding: "checkbox"
    },
    style: {
      width: 48,
      // prevent the checkbox column from growing
      padding: "0 0 0 4px"
    }
  }, {
    props: {
      padding: "none"
    },
    style: {
      padding: 0
    }
  }, {
    props: {
      align: "left"
    },
    style: {
      textAlign: "left"
    }
  }, {
    props: {
      align: "center"
    },
    style: {
      textAlign: "center"
    }
  }, {
    props: {
      align: "right"
    },
    style: {
      textAlign: "right",
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      align: "justify"
    },
    style: {
      textAlign: "justify"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.stickyHeader,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 2,
      backgroundColor: (e.vars || e).palette.background.default
    }
  }]
}))), da = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiTableCell"
  }), {
    align: o = "inherit",
    className: a,
    component: l,
    padding: c,
    scope: d,
    size: p,
    sortDirection: f,
    variant: m,
    ...g
  } = r, y = w.useContext(N0), b = w.useContext(lc), v = b && b.variant === "head";
  let $;
  l ? $ = l : $ = v ? "th" : "td";
  let S = d;
  $ === "td" ? S = void 0 : !S && v && (S = "col");
  const R = m || b && b.variant, P = {
    ...r,
    align: o,
    component: $,
    padding: c || (y && y.padding ? y.padding : "normal"),
    size: p || (y && y.size ? y.size : "medium"),
    sortDirection: f,
    stickyHeader: R === "head" && y && y.stickyHeader,
    variant: R
  }, T = pF(P);
  let O = null;
  return f && (O = f === "asc" ? "ascending" : "descending"), /* @__PURE__ */ x.jsx(fF, {
    as: $,
    ref: n,
    className: _e(T.root, a),
    "aria-sort": O,
    scope: S,
    ownerState: P,
    ...g
  });
});
process.env.NODE_ENV !== "production" && (da.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: i.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: i.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: i.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: i.oneOfType([i.oneOf(["medium", "small"]), i.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: i.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: i.oneOfType([i.oneOf(["body", "footer", "head"]), i.string])
});
function hF(e) {
  return Fe("MuiTableHead", e);
}
Le("MuiTableHead", ["root"]);
const mF = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"]
  }, hF, t);
}, gF = ae("thead", {
  name: "MuiTableHead",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-header-group"
}), yF = {
  variant: "head"
}, Fx = "thead", iS = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiTableHead"
  }), {
    className: o,
    component: a = Fx,
    ...l
  } = r, c = {
    ...r,
    component: a
  }, d = mF(c);
  return /* @__PURE__ */ x.jsx(lc.Provider, {
    value: yF,
    children: /* @__PURE__ */ x.jsx(gF, {
      as: a,
      className: _e(d.root, o),
      ref: n,
      role: a === Fx ? null : "rowgroup",
      ownerState: c,
      ...l
    })
  });
});
process.env.NODE_ENV !== "production" && (iS.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function vF(e) {
  return Fe("MuiTableRow", e);
}
const Lx = Le("MuiTableRow", ["root", "selected", "hover", "head", "footer"]), bF = (e) => {
  const {
    classes: t,
    selected: n,
    hover: r,
    head: o,
    footer: a
  } = e;
  return Be({
    root: ["root", n && "selected", r && "hover", o && "head", a && "footer"]
  }, vF, t);
}, xF = ae("tr", {
  name: "MuiTableRow",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.head && t.head, n.footer && t.footer];
  }
})(dt(({
  theme: e
}) => ({
  color: "inherit",
  display: "table-row",
  verticalAlign: "middle",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${Lx.hover}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${Lx.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : ht(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : ht(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
    }
  }
}))), Bx = "tr", $g = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiTableRow"
  }), {
    className: o,
    component: a = Bx,
    hover: l = !1,
    selected: c = !1,
    ...d
  } = r, p = w.useContext(lc), f = {
    ...r,
    component: a,
    hover: l,
    selected: c,
    head: p && p.variant === "head",
    footer: p && p.variant === "footer"
  }, m = bF(f);
  return /* @__PURE__ */ x.jsx(xF, {
    as: a,
    ref: n,
    className: _e(m.root, o),
    role: a === Bx ? null : "row",
    ownerState: f,
    ...d
  });
});
process.env.NODE_ENV !== "production" && ($g.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Should be valid `<tr>` children such as `TableCell`.
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If `true`, the table row will shade on hover.
   * @default false
   */
  hover: i.bool,
  /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */
  selected: i.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function wF(e) {
  return Fe("MuiTextField", e);
}
Le("MuiTextField", ["root"]);
const $F = {
  standard: Zd,
  filled: Kd,
  outlined: Qd
}, CF = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"]
  }, wF, t);
}, SF = ae(Gn, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), di = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = lt({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: o,
    autoFocus: a = !1,
    children: l,
    className: c,
    color: d = "primary",
    defaultValue: p,
    disabled: f = !1,
    error: m = !1,
    FormHelperTextProps: g,
    fullWidth: y = !1,
    helperText: b,
    id: v,
    InputLabelProps: $,
    inputProps: S,
    InputProps: R,
    inputRef: P,
    label: T,
    maxRows: O,
    minRows: k,
    multiline: I = !1,
    name: D,
    onBlur: j,
    onChange: E,
    onFocus: M,
    placeholder: F,
    required: B = !1,
    rows: V,
    select: z = !1,
    SelectProps: L,
    slots: G = {},
    slotProps: se = {},
    type: ne,
    value: K,
    variant: Q = "outlined",
    ...ye
  } = r, we = {
    ...r,
    autoFocus: a,
    color: d,
    disabled: f,
    error: m,
    fullWidth: y,
    multiline: I,
    required: B,
    select: z,
    variant: Q
  }, fe = CF(we);
  process.env.NODE_ENV !== "production" && z && !l && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const X = Mr(v), re = b && X ? `${X}-helper-text` : void 0, ie = T && X ? `${X}-label` : void 0, Y = $F[Q], Z = {
    slots: G,
    slotProps: {
      input: R,
      inputLabel: $,
      htmlInput: S,
      formHelperText: g,
      select: L,
      ...se
    }
  }, ue = {}, ge = Z.slotProps.inputLabel;
  Q === "outlined" && (ge && typeof ge.shrink < "u" && (ue.notched = ge.shrink), ue.label = T), z && ((!L || !L.native) && (ue.id = void 0), ue["aria-describedby"] = void 0);
  const [W, J] = Nt("input", {
    elementType: Y,
    externalForwardedProps: Z,
    additionalProps: ue,
    ownerState: we
  }), [le, me] = Nt("inputLabel", {
    elementType: E0,
    externalForwardedProps: Z,
    ownerState: we
  }), [be, de] = Nt("htmlInput", {
    elementType: "input",
    externalForwardedProps: Z,
    ownerState: we
  }), [Oe, Re] = Nt("formHelperText", {
    elementType: O0,
    externalForwardedProps: Z,
    ownerState: we
  }), [We, Ye] = Nt("select", {
    elementType: Jd,
    externalForwardedProps: Z,
    ownerState: we
  }), Ie = /* @__PURE__ */ x.jsx(W, {
    "aria-describedby": re,
    autoComplete: o,
    autoFocus: a,
    defaultValue: p,
    fullWidth: y,
    multiline: I,
    name: D,
    rows: V,
    maxRows: O,
    minRows: k,
    type: ne,
    value: K,
    id: X,
    inputRef: P,
    onBlur: j,
    onChange: E,
    onFocus: M,
    placeholder: F,
    inputProps: de,
    slots: {
      input: G.htmlInput ? be : void 0
    },
    ...J
  });
  return /* @__PURE__ */ x.jsxs(SF, {
    className: _e(fe.root, c),
    disabled: f,
    error: m,
    fullWidth: y,
    ref: n,
    required: B,
    color: d,
    variant: Q,
    ownerState: we,
    ...ye,
    children: [T != null && T !== "" && /* @__PURE__ */ x.jsx(le, {
      htmlFor: X,
      id: ie,
      ...me,
      children: T
    }), z ? /* @__PURE__ */ x.jsx(We, {
      "aria-describedby": re,
      id: X,
      labelId: ie,
      value: K,
      input: Ie,
      ...Ye,
      children: l
    }) : Ie, b && /* @__PURE__ */ x.jsx(Oe, {
      id: re,
      ...Re,
      children: b
    })]
  });
});
process.env.NODE_ENV !== "production" && (di.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: i.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: i.bool,
  /**
   * @ignore
   */
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * @ignore
   */
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: i.oneOfType([i.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), i.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: i.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: i.bool,
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: i.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: i.bool,
  /**
   * The helper text content.
   */
  helperText: i.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: i.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: i.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: i.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: i.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * The label content.
   */
  label: i.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: i.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: i.oneOfType([i.number, i.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: i.oneOfType([i.number, i.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: i.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: i.string,
  /**
   * @ignore
   */
  onBlur: i.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: i.func,
  /**
   * @ignore
   */
  onFocus: i.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: i.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: i.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: i.oneOfType([i.number, i.string]),
  /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: i.bool,
  /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SelectProps: i.object,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: i.oneOfType([i.oneOf(["medium", "small"]), i.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: i.shape({
    formHelperText: i.oneOfType([i.func, i.object]),
    htmlInput: i.oneOfType([i.func, i.object]),
    input: i.oneOfType([i.func, i.object]),
    inputLabel: i.oneOfType([i.func, i.object]),
    select: i.oneOfType([i.func, i.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: i.shape({
    formHelperText: i.elementType,
    htmlInput: i.elementType,
    input: i.elementType,
    inputLabel: i.elementType,
    select: i.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: i.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: i.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: i.oneOf(["filled", "outlined", "standard"])
});
const Zf = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
var rl = {}, Vx;
function TF() {
  if (Vx) return rl;
  Vx = 1, Object.defineProperty(rl, "__esModule", { value: !0 }), rl.parse = l, rl.serialize = p;
  const e = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/, t = /^[\u0021-\u003A\u003C-\u007E]*$/, n = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, r = /^[\u0020-\u003A\u003D-\u007E]*$/, o = Object.prototype.toString, a = /* @__PURE__ */ (() => {
    const g = function() {
    };
    return g.prototype = /* @__PURE__ */ Object.create(null), g;
  })();
  function l(g, y) {
    const b = new a(), v = g.length;
    if (v < 2)
      return b;
    const $ = (y == null ? void 0 : y.decode) || f;
    let S = 0;
    do {
      const R = g.indexOf("=", S);
      if (R === -1)
        break;
      const P = g.indexOf(";", S), T = P === -1 ? v : P;
      if (R > T) {
        S = g.lastIndexOf(";", R - 1) + 1;
        continue;
      }
      const O = c(g, S, R), k = d(g, R, O), I = g.slice(O, k);
      if (b[I] === void 0) {
        let D = c(g, R + 1, T), j = d(g, T, D);
        const E = $(g.slice(D, j));
        b[I] = E;
      }
      S = T + 1;
    } while (S < v);
    return b;
  }
  function c(g, y, b) {
    do {
      const v = g.charCodeAt(y);
      if (v !== 32 && v !== 9)
        return y;
    } while (++y < b);
    return b;
  }
  function d(g, y, b) {
    for (; y > b; ) {
      const v = g.charCodeAt(--y);
      if (v !== 32 && v !== 9)
        return y + 1;
    }
    return b;
  }
  function p(g, y, b) {
    const v = (b == null ? void 0 : b.encode) || encodeURIComponent;
    if (!e.test(g))
      throw new TypeError(`argument name is invalid: ${g}`);
    const $ = v(y);
    if (!t.test($))
      throw new TypeError(`argument val is invalid: ${y}`);
    let S = g + "=" + $;
    if (!b)
      return S;
    if (b.maxAge !== void 0) {
      if (!Number.isInteger(b.maxAge))
        throw new TypeError(`option maxAge is invalid: ${b.maxAge}`);
      S += "; Max-Age=" + b.maxAge;
    }
    if (b.domain) {
      if (!n.test(b.domain))
        throw new TypeError(`option domain is invalid: ${b.domain}`);
      S += "; Domain=" + b.domain;
    }
    if (b.path) {
      if (!r.test(b.path))
        throw new TypeError(`option path is invalid: ${b.path}`);
      S += "; Path=" + b.path;
    }
    if (b.expires) {
      if (!m(b.expires) || !Number.isFinite(b.expires.valueOf()))
        throw new TypeError(`option expires is invalid: ${b.expires}`);
      S += "; Expires=" + b.expires.toUTCString();
    }
    if (b.httpOnly && (S += "; HttpOnly"), b.secure && (S += "; Secure"), b.partitioned && (S += "; Partitioned"), b.priority)
      switch (typeof b.priority == "string" ? b.priority.toLowerCase() : void 0) {
        case "low":
          S += "; Priority=Low";
          break;
        case "medium":
          S += "; Priority=Medium";
          break;
        case "high":
          S += "; Priority=High";
          break;
        default:
          throw new TypeError(`option priority is invalid: ${b.priority}`);
      }
    if (b.sameSite)
      switch (typeof b.sameSite == "string" ? b.sameSite.toLowerCase() : b.sameSite) {
        case !0:
        case "strict":
          S += "; SameSite=Strict";
          break;
        case "lax":
          S += "; SameSite=Lax";
          break;
        case "none":
          S += "; SameSite=None";
          break;
        default:
          throw new TypeError(`option sameSite is invalid: ${b.sameSite}`);
      }
    return S;
  }
  function f(g) {
    if (g.indexOf("%") === -1)
      return g;
    try {
      return decodeURIComponent(g);
    } catch {
      return g;
    }
  }
  function m(g) {
    return o.call(g) === "[object Date]";
  }
  return rl;
}
TF();
/**
 * react-router v7.2.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Hn(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function pi(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
function Cg({
  pathname: e = "/",
  search: t = "",
  hash: n = ""
}) {
  return t && t !== "?" && (e += t.charAt(0) === "?" ? t : "?" + t), n && n !== "#" && (e += n.charAt(0) === "#" ? n : "#" + n), e;
}
function j0(e) {
  let t = {};
  if (e) {
    let n = e.indexOf("#");
    n >= 0 && (t.hash = e.substring(n), e = e.substring(0, n));
    let r = e.indexOf("?");
    r >= 0 && (t.search = e.substring(r), e = e.substring(0, r)), e && (t.pathname = e);
  }
  return t;
}
function aS(e, t, n = "/") {
  return OF(e, t, n, !1);
}
function OF(e, t, n, r) {
  let o = typeof t == "string" ? j0(t) : t, a = $a(o.pathname || "/", n);
  if (a == null)
    return null;
  let l = sS(e);
  PF(l);
  let c = null;
  for (let d = 0; c == null && d < l.length; ++d) {
    let p = FF(a);
    c = NF(
      l[d],
      p,
      r
    );
  }
  return c;
}
function sS(e, t = [], n = [], r = "") {
  let o = (a, l, c) => {
    let d = {
      relativePath: c === void 0 ? a.path || "" : c,
      caseSensitive: a.caseSensitive === !0,
      childrenIndex: l,
      route: a
    };
    d.relativePath.startsWith("/") && (Hn(
      d.relativePath.startsWith(r),
      `Absolute route path "${d.relativePath}" nested under path "${r}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`
    ), d.relativePath = d.relativePath.slice(r.length));
    let p = si([r, d.relativePath]), f = n.concat(d);
    a.children && a.children.length > 0 && (Hn(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      a.index !== !0,
      `Index routes must not have child routes. Please remove all child routes from route path "${p}".`
    ), sS(a.children, t, f, p)), !(a.path == null && !a.index) && t.push({
      path: p,
      score: MF(p, a.index),
      routesMeta: f
    });
  };
  return e.forEach((a, l) => {
    var c;
    if (a.path === "" || !((c = a.path) != null && c.includes("?")))
      o(a, l);
    else
      for (let d of lS(a.path))
        o(a, l, d);
  }), t;
}
function lS(e) {
  let t = e.split("/");
  if (t.length === 0) return [];
  let [n, ...r] = t, o = n.endsWith("?"), a = n.replace(/\?$/, "");
  if (r.length === 0)
    return o ? [a, ""] : [a];
  let l = lS(r.join("/")), c = [];
  return c.push(
    ...l.map(
      (d) => d === "" ? a : [a, d].join("/")
    )
  ), o && c.push(...l), c.map(
    (d) => e.startsWith("/") && d === "" ? "/" : d
  );
}
function PF(e) {
  e.sort(
    (t, n) => t.score !== n.score ? n.score - t.score : AF(
      t.routesMeta.map((r) => r.childrenIndex),
      n.routesMeta.map((r) => r.childrenIndex)
    )
  );
}
var EF = /^:[\w-]+$/, RF = 3, kF = 2, _F = 1, DF = 10, IF = -2, zx = (e) => e === "*";
function MF(e, t) {
  let n = e.split("/"), r = n.length;
  return n.some(zx) && (r += IF), t && (r += kF), n.filter((o) => !zx(o)).reduce(
    (o, a) => o + (EF.test(a) ? RF : a === "" ? _F : DF),
    r
  );
}
function AF(e, t) {
  return e.length === t.length && e.slice(0, -1).every((r, o) => r === t[o]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    e[e.length - 1] - t[t.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function NF(e, t, n = !1) {
  let { routesMeta: r } = e, o = {}, a = "/", l = [];
  for (let c = 0; c < r.length; ++c) {
    let d = r[c], p = c === r.length - 1, f = a === "/" ? t : t.slice(a.length) || "/", m = nd(
      { path: d.relativePath, caseSensitive: d.caseSensitive, end: p },
      f
    ), g = d.route;
    if (!m && p && n && !r[r.length - 1].route.index && (m = nd(
      {
        path: d.relativePath,
        caseSensitive: d.caseSensitive,
        end: !1
      },
      f
    )), !m)
      return null;
    Object.assign(o, m.params), l.push({
      // TODO: Can this as be avoided?
      params: o,
      pathname: si([a, m.pathname]),
      pathnameBase: zF(
        si([a, m.pathnameBase])
      ),
      route: g
    }), m.pathnameBase !== "/" && (a = si([a, m.pathnameBase]));
  }
  return l;
}
function nd(e, t) {
  typeof e == "string" && (e = { path: e, caseSensitive: !1, end: !0 });
  let [n, r] = jF(
    e.path,
    e.caseSensitive,
    e.end
  ), o = t.match(n);
  if (!o) return null;
  let a = o[0], l = a.replace(/(.)\/+$/, "$1"), c = o.slice(1);
  return {
    params: r.reduce(
      (p, { paramName: f, isOptional: m }, g) => {
        if (f === "*") {
          let b = c[g] || "";
          l = a.slice(0, a.length - b.length).replace(/(.)\/+$/, "$1");
        }
        const y = c[g];
        return m && !y ? p[f] = void 0 : p[f] = (y || "").replace(/%2F/g, "/"), p;
      },
      {}
    ),
    pathname: a,
    pathnameBase: l,
    pattern: e
  };
}
function jF(e, t = !1, n = !0) {
  pi(
    e === "*" || !e.endsWith("*") || e.endsWith("/*"),
    `Route path "${e}" will be treated as if it were "${e.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${e.replace(/\*$/, "/*")}".`
  );
  let r = [], o = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(
    /\/:([\w-]+)(\?)?/g,
    (l, c, d) => (r.push({ paramName: c, isOptional: d != null }), d ? "/?([^\\/]+)?" : "/([^\\/]+)")
  );
  return e.endsWith("*") ? (r.push({ paramName: "*" }), o += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : n ? o += "\\/*$" : e !== "" && e !== "/" && (o += "(?:(?=\\/|$))"), [new RegExp(o, t ? void 0 : "i"), r];
}
function FF(e) {
  try {
    return e.split("/").map((t) => decodeURIComponent(t).replace(/\//g, "%2F")).join("/");
  } catch (t) {
    return pi(
      !1,
      `The URL path "${e}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${t}).`
    ), e;
  }
}
function $a(e, t) {
  if (t === "/") return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let n = t.endsWith("/") ? t.length - 1 : t.length, r = e.charAt(n);
  return r && r !== "/" ? null : e.slice(n) || "/";
}
function LF(e, t = "/") {
  let {
    pathname: n,
    search: r = "",
    hash: o = ""
  } = typeof e == "string" ? j0(e) : e;
  return {
    pathname: n ? n.startsWith("/") ? n : BF(n, t) : t,
    search: WF(r),
    hash: qF(o)
  };
}
function BF(e, t) {
  let n = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((o) => {
    o === ".." ? n.length > 1 && n.pop() : o !== "." && n.push(o);
  }), n.length > 1 ? n.join("/") : "/";
}
function Qf(e, t, n, r) {
  return `Cannot include a '${e}' character in a manually specified \`to.${t}\` field [${JSON.stringify(
    r
  )}].  Please separate it out to the \`to.${n}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function VF(e) {
  return e.filter(
    (t, n) => n === 0 || t.route.path && t.route.path.length > 0
  );
}
function cS(e) {
  let t = VF(e);
  return t.map(
    (n, r) => r === t.length - 1 ? n.pathname : n.pathnameBase
  );
}
function uS(e, t, n, r = !1) {
  let o;
  typeof e == "string" ? o = j0(e) : (o = { ...e }, Hn(
    !o.pathname || !o.pathname.includes("?"),
    Qf("?", "pathname", "search", o)
  ), Hn(
    !o.pathname || !o.pathname.includes("#"),
    Qf("#", "pathname", "hash", o)
  ), Hn(
    !o.search || !o.search.includes("#"),
    Qf("#", "search", "hash", o)
  ));
  let a = e === "" || o.pathname === "", l = a ? "/" : o.pathname, c;
  if (l == null)
    c = n;
  else {
    let m = t.length - 1;
    if (!r && l.startsWith("..")) {
      let g = l.split("/");
      for (; g[0] === ".."; )
        g.shift(), m -= 1;
      o.pathname = g.join("/");
    }
    c = m >= 0 ? t[m] : "/";
  }
  let d = LF(o, c), p = l && l !== "/" && l.endsWith("/"), f = (a || l === ".") && n.endsWith("/");
  return !d.pathname.endsWith("/") && (p || f) && (d.pathname += "/"), d;
}
var si = (e) => e.join("/").replace(/\/\/+/g, "/"), zF = (e) => e.replace(/\/+$/, "").replace(/^\/*/, "/"), WF = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, qF = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e;
function UF(e) {
  return e != null && typeof e.status == "number" && typeof e.statusText == "string" && typeof e.internal == "boolean" && "data" in e;
}
var dS = [
  "POST",
  "PUT",
  "PATCH",
  "DELETE"
];
new Set(
  dS
);
var HF = [
  "GET",
  ...dS
];
new Set(HF);
var ks = w.createContext(null);
ks.displayName = "DataRouter";
var ep = w.createContext(null);
ep.displayName = "DataRouterState";
var pS = w.createContext({
  isTransitioning: !1
});
pS.displayName = "ViewTransition";
var GF = w.createContext(
  /* @__PURE__ */ new Map()
);
GF.displayName = "Fetchers";
var YF = w.createContext(null);
YF.displayName = "Await";
var gi = w.createContext(
  null
);
gi.displayName = "Navigation";
var F0 = w.createContext(
  null
);
F0.displayName = "Location";
var yi = w.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
yi.displayName = "Route";
var L0 = w.createContext(null);
L0.displayName = "RouteError";
function KF(e, { relative: t } = {}) {
  Hn(
    tp(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  );
  let { basename: n, navigator: r } = w.useContext(gi), { hash: o, pathname: a, search: l } = cc(e, { relative: t }), c = a;
  return n !== "/" && (c = a === "/" ? n : si([n, a])), r.createHref({ pathname: c, search: l, hash: o });
}
function tp() {
  return w.useContext(F0) != null;
}
function Ta() {
  return Hn(
    tp(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ), w.useContext(F0).location;
}
var fS = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function hS(e) {
  w.useContext(gi).static || w.useLayoutEffect(e);
}
function XF() {
  let { isDataRoute: e } = w.useContext(yi);
  return e ? cL() : ZF();
}
function ZF() {
  Hn(
    tp(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  );
  let e = w.useContext(ks), { basename: t, navigator: n } = w.useContext(gi), { matches: r } = w.useContext(yi), { pathname: o } = Ta(), a = JSON.stringify(cS(r)), l = w.useRef(!1);
  return hS(() => {
    l.current = !0;
  }), w.useCallback(
    (d, p = {}) => {
      if (pi(l.current, fS), !l.current) return;
      if (typeof d == "number") {
        n.go(d);
        return;
      }
      let f = uS(
        d,
        JSON.parse(a),
        o,
        p.relative === "path"
      );
      e == null && t !== "/" && (f.pathname = f.pathname === "/" ? t : si([t, f.pathname])), (p.replace ? n.replace : n.push)(
        f,
        p.state,
        p
      );
    },
    [
      t,
      n,
      a,
      o,
      e
    ]
  );
}
w.createContext(null);
function cc(e, { relative: t } = {}) {
  let { matches: n } = w.useContext(yi), { pathname: r } = Ta(), o = JSON.stringify(cS(n));
  return w.useMemo(
    () => uS(
      e,
      JSON.parse(o),
      r,
      t === "path"
    ),
    [e, o, r, t]
  );
}
function QF(e, t, n, r) {
  Hn(
    tp(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  );
  let { navigator: o, static: a } = w.useContext(gi), { matches: l } = w.useContext(yi), c = l[l.length - 1], d = c ? c.params : {}, p = c ? c.pathname : "/", f = c ? c.pathnameBase : "/", m = c && c.route;
  {
    let R = m && m.path || "";
    mS(
      p,
      !m || R.endsWith("*") || R.endsWith("*?"),
      `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${p}" (under <Route path="${R}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${R}"> to <Route path="${R === "/" ? "*" : `${R}/*`}">.`
    );
  }
  let g = Ta(), y;
  y = g;
  let b = y.pathname || "/", v = b;
  if (f !== "/") {
    let R = f.replace(/^\//, "").split("/");
    v = "/" + b.replace(/^\//, "").split("/").slice(R.length).join("/");
  }
  let $ = !a && n && n.matches && n.matches.length > 0 ? n.matches : aS(e, { pathname: v });
  return pi(
    m || $ != null,
    `No routes matched location "${y.pathname}${y.search}${y.hash}" `
  ), pi(
    $ == null || $[$.length - 1].route.element !== void 0 || $[$.length - 1].route.Component !== void 0 || $[$.length - 1].route.lazy !== void 0,
    `Matched leaf route at location "${y.pathname}${y.search}${y.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`
  ), rL(
    $ && $.map(
      (R) => Object.assign({}, R, {
        params: Object.assign({}, d, R.params),
        pathname: si([
          f,
          // Re-encode pathnames that were decoded inside matchRoutes
          o.encodeLocation ? o.encodeLocation(R.pathname).pathname : R.pathname
        ]),
        pathnameBase: R.pathnameBase === "/" ? f : si([
          f,
          // Re-encode pathnames that were decoded inside matchRoutes
          o.encodeLocation ? o.encodeLocation(R.pathnameBase).pathname : R.pathnameBase
        ])
      })
    ),
    l,
    n,
    r
  );
}
function JF() {
  let e = lL(), t = UF(e) ? `${e.status} ${e.statusText}` : e instanceof Error ? e.message : JSON.stringify(e), n = e instanceof Error ? e.stack : null, r = "rgba(200,200,200, 0.5)", o = { padding: "0.5rem", backgroundColor: r }, a = { padding: "2px 4px", backgroundColor: r }, l = null;
  return console.error(
    "Error handled by React Router default ErrorBoundary:",
    e
  ), l = /* @__PURE__ */ w.createElement(w.Fragment, null, /* @__PURE__ */ w.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ w.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ w.createElement("code", { style: a }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ w.createElement("code", { style: a }, "errorElement"), " prop on your route.")), /* @__PURE__ */ w.createElement(w.Fragment, null, /* @__PURE__ */ w.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ w.createElement("h3", { style: { fontStyle: "italic" } }, t), n ? /* @__PURE__ */ w.createElement("pre", { style: o }, n) : null, l);
}
var eL = /* @__PURE__ */ w.createElement(JF, null), tL = class extends w.Component {
  constructor(e) {
    super(e), this.state = {
      location: e.location,
      revalidation: e.revalidation,
      error: e.error
    };
  }
  static getDerivedStateFromError(e) {
    return { error: e };
  }
  static getDerivedStateFromProps(e, t) {
    return t.location !== e.location || t.revalidation !== "idle" && e.revalidation === "idle" ? {
      error: e.error,
      location: e.location,
      revalidation: e.revalidation
    } : {
      error: e.error !== void 0 ? e.error : t.error,
      location: t.location,
      revalidation: e.revalidation || t.revalidation
    };
  }
  componentDidCatch(e, t) {
    console.error(
      "React Router caught the following error during render",
      e,
      t
    );
  }
  render() {
    return this.state.error !== void 0 ? /* @__PURE__ */ w.createElement(yi.Provider, { value: this.props.routeContext }, /* @__PURE__ */ w.createElement(
      L0.Provider,
      {
        value: this.state.error,
        children: this.props.component
      }
    )) : this.props.children;
  }
};
function nL({ routeContext: e, match: t, children: n }) {
  let r = w.useContext(ks);
  return r && r.static && r.staticContext && (t.route.errorElement || t.route.ErrorBoundary) && (r.staticContext._deepestRenderedBoundaryId = t.route.id), /* @__PURE__ */ w.createElement(yi.Provider, { value: e }, n);
}
function rL(e, t = [], n = null, r = null) {
  if (e == null) {
    if (!n)
      return null;
    if (n.errors)
      e = n.matches;
    else if (t.length === 0 && !n.initialized && n.matches.length > 0)
      e = n.matches;
    else
      return null;
  }
  let o = e, a = n == null ? void 0 : n.errors;
  if (a != null) {
    let d = o.findIndex(
      (p) => p.route.id && (a == null ? void 0 : a[p.route.id]) !== void 0
    );
    Hn(
      d >= 0,
      `Could not find a matching route for errors on route IDs: ${Object.keys(
        a
      ).join(",")}`
    ), o = o.slice(
      0,
      Math.min(o.length, d + 1)
    );
  }
  let l = !1, c = -1;
  if (n)
    for (let d = 0; d < o.length; d++) {
      let p = o[d];
      if ((p.route.HydrateFallback || p.route.hydrateFallbackElement) && (c = d), p.route.id) {
        let { loaderData: f, errors: m } = n, g = p.route.loader && !f.hasOwnProperty(p.route.id) && (!m || m[p.route.id] === void 0);
        if (p.route.lazy || g) {
          l = !0, c >= 0 ? o = o.slice(0, c + 1) : o = [o[0]];
          break;
        }
      }
    }
  return o.reduceRight((d, p, f) => {
    let m, g = !1, y = null, b = null;
    n && (m = a && p.route.id ? a[p.route.id] : void 0, y = p.route.errorElement || eL, l && (c < 0 && f === 0 ? (mS(
      "route-fallback",
      !1,
      "No `HydrateFallback` element provided to render during initial hydration"
    ), g = !0, b = null) : c === f && (g = !0, b = p.route.hydrateFallbackElement || null)));
    let v = t.concat(o.slice(0, f + 1)), $ = () => {
      let S;
      return m ? S = y : g ? S = b : p.route.Component ? S = /* @__PURE__ */ w.createElement(p.route.Component, null) : p.route.element ? S = p.route.element : S = d, /* @__PURE__ */ w.createElement(
        nL,
        {
          match: p,
          routeContext: {
            outlet: d,
            matches: v,
            isDataRoute: n != null
          },
          children: S
        }
      );
    };
    return n && (p.route.ErrorBoundary || p.route.errorElement || f === 0) ? /* @__PURE__ */ w.createElement(
      tL,
      {
        location: n.location,
        revalidation: n.revalidation,
        component: y,
        error: m,
        children: $(),
        routeContext: { outlet: null, matches: v, isDataRoute: !0 }
      }
    ) : $();
  }, null);
}
function B0(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function oL(e) {
  let t = w.useContext(ks);
  return Hn(t, B0(e)), t;
}
function iL(e) {
  let t = w.useContext(ep);
  return Hn(t, B0(e)), t;
}
function aL(e) {
  let t = w.useContext(yi);
  return Hn(t, B0(e)), t;
}
function V0(e) {
  let t = aL(e), n = t.matches[t.matches.length - 1];
  return Hn(
    n.route.id,
    `${e} can only be used on routes that contain a unique "id"`
  ), n.route.id;
}
function sL() {
  return V0(
    "useRouteId"
    /* UseRouteId */
  );
}
function lL() {
  var r;
  let e = w.useContext(L0), t = iL(
    "useRouteError"
    /* UseRouteError */
  ), n = V0(
    "useRouteError"
    /* UseRouteError */
  );
  return e !== void 0 ? e : (r = t.errors) == null ? void 0 : r[n];
}
function cL() {
  let { router: e } = oL(
    "useNavigate"
    /* UseNavigateStable */
  ), t = V0(
    "useNavigate"
    /* UseNavigateStable */
  ), n = w.useRef(!1);
  return hS(() => {
    n.current = !0;
  }), w.useCallback(
    async (o, a = {}) => {
      pi(n.current, fS), n.current && (typeof o == "number" ? e.navigate(o) : await e.navigate(o, { fromRouteId: t, ...a }));
    },
    [e, t]
  );
}
var Wx = {};
function mS(e, t, n) {
  !t && !Wx[e] && (Wx[e] = !0, pi(!1, n));
}
w.memo(uL);
function uL({
  routes: e,
  future: t,
  state: n
}) {
  return QF(e, void 0, n, t);
}
var Au = "get", Nu = "application/x-www-form-urlencoded";
function np(e) {
  return e != null && typeof e.tagName == "string";
}
function dL(e) {
  return np(e) && e.tagName.toLowerCase() === "button";
}
function pL(e) {
  return np(e) && e.tagName.toLowerCase() === "form";
}
function fL(e) {
  return np(e) && e.tagName.toLowerCase() === "input";
}
function hL(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function mL(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !hL(e);
}
var vu = null;
function gL() {
  if (vu === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), vu = !1;
    } catch {
      vu = !0;
    }
  return vu;
}
var yL = /* @__PURE__ */ new Set([
  "application/x-www-form-urlencoded",
  "multipart/form-data",
  "text/plain"
]);
function Jf(e) {
  return e != null && !yL.has(e) ? (pi(
    !1,
    `"${e}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${Nu}"`
  ), null) : e;
}
function vL(e, t) {
  let n, r, o, a, l;
  if (pL(e)) {
    let c = e.getAttribute("action");
    r = c ? $a(c, t) : null, n = e.getAttribute("method") || Au, o = Jf(e.getAttribute("enctype")) || Nu, a = new FormData(e);
  } else if (dL(e) || fL(e) && (e.type === "submit" || e.type === "image")) {
    let c = e.form;
    if (c == null)
      throw new Error(
        'Cannot submit a <button> or <input type="submit"> without a <form>'
      );
    let d = e.getAttribute("formaction") || c.getAttribute("action");
    if (r = d ? $a(d, t) : null, n = e.getAttribute("formmethod") || c.getAttribute("method") || Au, o = Jf(e.getAttribute("formenctype")) || Jf(c.getAttribute("enctype")) || Nu, a = new FormData(c, e), !gL()) {
      let { name: p, type: f, value: m } = e;
      if (f === "image") {
        let g = p ? `${p}.` : "";
        a.append(`${g}x`, "0"), a.append(`${g}y`, "0");
      } else p && a.append(p, m);
    }
  } else {
    if (np(e))
      throw new Error(
        'Cannot submit element that is not <form>, <button>, or <input type="submit|image">'
      );
    n = Au, r = null, o = Nu, l = e;
  }
  return a && o === "text/plain" && (l = a, a = void 0), { action: r, method: n.toLowerCase(), encType: o, formData: a, body: l };
}
function z0(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
async function bL(e, t) {
  if (e.id in t)
    return t[e.id];
  try {
    let n = await import(
      /* @vite-ignore */
      /* webpackIgnore: true */
      e.module
    );
    return t[e.id] = n, n;
  } catch (n) {
    return console.error(
      `Error loading route module \`${e.module}\`, reloading page...`
    ), console.error(n), window.__reactRouterContext && window.__reactRouterContext.isSpaMode, window.location.reload(), new Promise(() => {
    });
  }
}
function xL(e) {
  return e == null ? !1 : e.href == null ? e.rel === "preload" && typeof e.imageSrcSet == "string" && typeof e.imageSizes == "string" : typeof e.rel == "string" && typeof e.href == "string";
}
async function wL(e, t, n) {
  let r = await Promise.all(
    e.map(async (o) => {
      let a = t.routes[o.route.id];
      if (a) {
        let l = await bL(a, n);
        return l.links ? l.links() : [];
      }
      return [];
    })
  );
  return TL(
    r.flat(1).filter(xL).filter((o) => o.rel === "stylesheet" || o.rel === "preload").map(
      (o) => o.rel === "stylesheet" ? { ...o, rel: "prefetch", as: "style" } : { ...o, rel: "prefetch" }
    )
  );
}
function qx(e, t, n, r, o, a) {
  let l = (d, p) => n[p] ? d.route.id !== n[p].route.id : !0, c = (d, p) => {
    var f;
    return (
      // param change, /users/123 -> /users/456
      n[p].pathname !== d.pathname || // splat param changed, which is not present in match.path
      // e.g. /files/images/avatar.jpg -> files/finances.xls
      ((f = n[p].route.path) == null ? void 0 : f.endsWith("*")) && n[p].params["*"] !== d.params["*"]
    );
  };
  return a === "assets" ? t.filter(
    (d, p) => l(d, p) || c(d, p)
  ) : a === "data" ? t.filter((d, p) => {
    var m;
    let f = r.routes[d.route.id];
    if (!f || !f.hasLoader)
      return !1;
    if (l(d, p) || c(d, p))
      return !0;
    if (d.route.shouldRevalidate) {
      let g = d.route.shouldRevalidate({
        currentUrl: new URL(
          o.pathname + o.search + o.hash,
          window.origin
        ),
        currentParams: ((m = n[0]) == null ? void 0 : m.params) || {},
        nextUrl: new URL(e, window.origin),
        nextParams: d.params,
        defaultShouldRevalidate: !0
      });
      if (typeof g == "boolean")
        return g;
    }
    return !0;
  }) : [];
}
function $L(e, t, { includeHydrateFallback: n } = {}) {
  return CL(
    e.map((r) => {
      let o = t.routes[r.route.id];
      if (!o) return [];
      let a = [o.module];
      return o.clientActionModule && (a = a.concat(o.clientActionModule)), o.clientLoaderModule && (a = a.concat(o.clientLoaderModule)), n && o.hydrateFallbackModule && (a = a.concat(o.hydrateFallbackModule)), o.imports && (a = a.concat(o.imports)), a;
    }).flat(1)
  );
}
function CL(e) {
  return [...new Set(e)];
}
function SL(e) {
  let t = {}, n = Object.keys(e).sort();
  for (let r of n)
    t[r] = e[r];
  return t;
}
function TL(e, t) {
  let n = /* @__PURE__ */ new Set();
  return new Set(t), e.reduce((r, o) => {
    let a = JSON.stringify(SL(o));
    return n.has(a) || (n.add(a), r.push({ key: a, link: o })), r;
  }, []);
}
function OL(e) {
  let t = typeof e == "string" ? new URL(
    e,
    // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window > "u" ? "server://singlefetch/" : window.location.origin
  ) : e;
  return t.pathname === "/" ? t.pathname = "_root.data" : t.pathname = `${t.pathname.replace(/\/$/, "")}.data`, t;
}
function PL() {
  let e = w.useContext(ks);
  return z0(
    e,
    "You must render this element inside a <DataRouterContext.Provider> element"
  ), e;
}
function EL() {
  let e = w.useContext(ep);
  return z0(
    e,
    "You must render this element inside a <DataRouterStateContext.Provider> element"
  ), e;
}
var W0 = w.createContext(void 0);
W0.displayName = "FrameworkContext";
function gS() {
  let e = w.useContext(W0);
  return z0(
    e,
    "You must render this element inside a <HydratedRouter> element"
  ), e;
}
function RL(e, t) {
  let n = w.useContext(W0), [r, o] = w.useState(!1), [a, l] = w.useState(!1), { onFocus: c, onBlur: d, onMouseEnter: p, onMouseLeave: f, onTouchStart: m } = t, g = w.useRef(null);
  w.useEffect(() => {
    if (e === "render" && l(!0), e === "viewport") {
      let v = (S) => {
        S.forEach((R) => {
          l(R.isIntersecting);
        });
      }, $ = new IntersectionObserver(v, { threshold: 0.5 });
      return g.current && $.observe(g.current), () => {
        $.disconnect();
      };
    }
  }, [e]), w.useEffect(() => {
    if (r) {
      let v = setTimeout(() => {
        l(!0);
      }, 100);
      return () => {
        clearTimeout(v);
      };
    }
  }, [r]);
  let y = () => {
    o(!0);
  }, b = () => {
    o(!1), l(!1);
  };
  return n ? e !== "intent" ? [a, g, {}] : [
    a,
    g,
    {
      onFocus: ol(c, y),
      onBlur: ol(d, b),
      onMouseEnter: ol(p, y),
      onMouseLeave: ol(f, b),
      onTouchStart: ol(m, y)
    }
  ] : [!1, g, {}];
}
function ol(e, t) {
  return (n) => {
    e && e(n), n.defaultPrevented || t(n);
  };
}
function kL({
  page: e,
  ...t
}) {
  let { router: n } = PL(), r = w.useMemo(
    () => aS(n.routes, e, n.basename),
    [n.routes, e, n.basename]
  );
  return r ? /* @__PURE__ */ w.createElement(DL, { page: e, matches: r, ...t }) : null;
}
function _L(e) {
  let { manifest: t, routeModules: n } = gS(), [r, o] = w.useState([]);
  return w.useEffect(() => {
    let a = !1;
    return wL(e, t, n).then(
      (l) => {
        a || o(l);
      }
    ), () => {
      a = !0;
    };
  }, [e, t, n]), r;
}
function DL({
  page: e,
  matches: t,
  ...n
}) {
  let r = Ta(), { manifest: o, routeModules: a } = gS(), { loaderData: l, matches: c } = EL(), d = w.useMemo(
    () => qx(
      e,
      t,
      c,
      o,
      r,
      "data"
    ),
    [e, t, c, o, r]
  ), p = w.useMemo(
    () => qx(
      e,
      t,
      c,
      o,
      r,
      "assets"
    ),
    [e, t, c, o, r]
  ), f = w.useMemo(() => {
    if (e === r.pathname + r.search + r.hash)
      return [];
    let y = /* @__PURE__ */ new Set(), b = !1;
    if (t.forEach(($) => {
      var R;
      let S = o.routes[$.route.id];
      !S || !S.hasLoader || (!d.some((P) => P.route.id === $.route.id) && $.route.id in l && ((R = a[$.route.id]) != null && R.shouldRevalidate) || S.hasClientLoader ? b = !0 : y.add($.route.id));
    }), y.size === 0)
      return [];
    let v = OL(e);
    return b && y.size > 0 && v.searchParams.set(
      "_routes",
      t.filter(($) => y.has($.route.id)).map(($) => $.route.id).join(",")
    ), [v.pathname + v.search];
  }, [
    l,
    r,
    o,
    d,
    t,
    e,
    a
  ]), m = w.useMemo(
    () => $L(p, o),
    [p, o]
  ), g = _L(p);
  return /* @__PURE__ */ w.createElement(w.Fragment, null, f.map((y) => /* @__PURE__ */ w.createElement("link", { key: y, rel: "prefetch", as: "fetch", href: y, ...n })), m.map((y) => /* @__PURE__ */ w.createElement("link", { key: y, rel: "modulepreload", href: y, ...n })), g.map(({ key: y, link: b }) => (
    // these don't spread `linkProps` because they are full link descriptors
    // already with their own props
    /* @__PURE__ */ w.createElement("link", { key: y, ...b })
  )));
}
function IL(...e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
var yS = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
try {
  yS && (window.__reactRouterVersion = "7.2.0");
} catch {
}
var vS = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, q0 = w.forwardRef(
  function({
    onClick: t,
    discover: n = "render",
    prefetch: r = "none",
    relative: o,
    reloadDocument: a,
    replace: l,
    state: c,
    target: d,
    to: p,
    preventScrollReset: f,
    viewTransition: m,
    ...g
  }, y) {
    let { basename: b } = w.useContext(gi), v = typeof p == "string" && vS.test(p), $, S = !1;
    if (typeof p == "string" && v && ($ = p, yS))
      try {
        let j = new URL(window.location.href), E = p.startsWith("//") ? new URL(j.protocol + p) : new URL(p), M = $a(E.pathname, b);
        E.origin === j.origin && M != null ? p = M + E.search + E.hash : S = !0;
      } catch {
        pi(
          !1,
          `<Link to="${p}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`
        );
      }
    let R = KF(p, { relative: o }), [P, T, O] = RL(
      r,
      g
    ), k = jL(p, {
      replace: l,
      state: c,
      target: d,
      preventScrollReset: f,
      relative: o,
      viewTransition: m
    });
    function I(j) {
      t && t(j), j.defaultPrevented || k(j);
    }
    let D = (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      /* @__PURE__ */ w.createElement(
        "a",
        {
          ...g,
          ...O,
          href: $ || R,
          onClick: S || a ? t : I,
          ref: IL(y, T),
          target: d,
          "data-discover": !v && n === "render" ? "true" : void 0
        }
      )
    );
    return P && !v ? /* @__PURE__ */ w.createElement(w.Fragment, null, D, /* @__PURE__ */ w.createElement(kL, { page: R })) : D;
  }
);
q0.displayName = "Link";
var ML = w.forwardRef(
  function({
    "aria-current": t = "page",
    caseSensitive: n = !1,
    className: r = "",
    end: o = !1,
    style: a,
    to: l,
    viewTransition: c,
    children: d,
    ...p
  }, f) {
    let m = cc(l, { relative: p.relative }), g = Ta(), y = w.useContext(ep), { navigator: b, basename: v } = w.useContext(gi), $ = y != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    zL(m) && c === !0, S = b.encodeLocation ? b.encodeLocation(m).pathname : m.pathname, R = g.pathname, P = y && y.navigation && y.navigation.location ? y.navigation.location.pathname : null;
    n || (R = R.toLowerCase(), P = P ? P.toLowerCase() : null, S = S.toLowerCase()), P && v && (P = $a(P, v) || P);
    const T = S !== "/" && S.endsWith("/") ? S.length - 1 : S.length;
    let O = R === S || !o && R.startsWith(S) && R.charAt(T) === "/", k = P != null && (P === S || !o && P.startsWith(S) && P.charAt(S.length) === "/"), I = {
      isActive: O,
      isPending: k,
      isTransitioning: $
    }, D = O ? t : void 0, j;
    typeof r == "function" ? j = r(I) : j = [
      r,
      O ? "active" : null,
      k ? "pending" : null,
      $ ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let E = typeof a == "function" ? a(I) : a;
    return /* @__PURE__ */ w.createElement(
      q0,
      {
        ...p,
        "aria-current": D,
        className: j,
        ref: f,
        style: E,
        to: l,
        viewTransition: c
      },
      typeof d == "function" ? d(I) : d
    );
  }
);
ML.displayName = "NavLink";
var AL = w.forwardRef(
  ({
    discover: e = "render",
    fetcherKey: t,
    navigate: n,
    reloadDocument: r,
    replace: o,
    state: a,
    method: l = Au,
    action: c,
    onSubmit: d,
    relative: p,
    preventScrollReset: f,
    viewTransition: m,
    ...g
  }, y) => {
    let b = BL(), v = VL(c, { relative: p }), $ = l.toLowerCase() === "get" ? "get" : "post", S = typeof c == "string" && vS.test(c), R = (P) => {
      if (d && d(P), P.defaultPrevented) return;
      P.preventDefault();
      let T = P.nativeEvent.submitter, O = (T == null ? void 0 : T.getAttribute("formmethod")) || l;
      b(T || P.currentTarget, {
        fetcherKey: t,
        method: O,
        navigate: n,
        replace: o,
        state: a,
        relative: p,
        preventScrollReset: f,
        viewTransition: m
      });
    };
    return /* @__PURE__ */ w.createElement(
      "form",
      {
        ref: y,
        method: $,
        action: v,
        onSubmit: r ? d : R,
        ...g,
        "data-discover": !S && e === "render" ? "true" : void 0
      }
    );
  }
);
AL.displayName = "Form";
function NL(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function bS(e) {
  let t = w.useContext(ks);
  return Hn(t, NL(e)), t;
}
function jL(e, {
  target: t,
  replace: n,
  state: r,
  preventScrollReset: o,
  relative: a,
  viewTransition: l
} = {}) {
  let c = XF(), d = Ta(), p = cc(e, { relative: a });
  return w.useCallback(
    (f) => {
      if (mL(f, t)) {
        f.preventDefault();
        let m = n !== void 0 ? n : Cg(d) === Cg(p);
        c(e, {
          replace: m,
          state: r,
          preventScrollReset: o,
          relative: a,
          viewTransition: l
        });
      }
    },
    [
      d,
      c,
      p,
      n,
      r,
      t,
      e,
      o,
      a,
      l
    ]
  );
}
var FL = 0, LL = () => `__${String(++FL)}__`;
function BL() {
  let { router: e } = bS(
    "useSubmit"
    /* UseSubmit */
  ), { basename: t } = w.useContext(gi), n = sL();
  return w.useCallback(
    async (r, o = {}) => {
      let { action: a, method: l, encType: c, formData: d, body: p } = vL(
        r,
        t
      );
      if (o.navigate === !1) {
        let f = o.fetcherKey || LL();
        await e.fetch(f, n, o.action || a, {
          preventScrollReset: o.preventScrollReset,
          formData: d,
          body: p,
          formMethod: o.method || l,
          formEncType: o.encType || c,
          flushSync: o.flushSync
        });
      } else
        await e.navigate(o.action || a, {
          preventScrollReset: o.preventScrollReset,
          formData: d,
          body: p,
          formMethod: o.method || l,
          formEncType: o.encType || c,
          replace: o.replace,
          state: o.state,
          fromRouteId: n,
          flushSync: o.flushSync,
          viewTransition: o.viewTransition
        });
    },
    [e, t, n]
  );
}
function VL(e, { relative: t } = {}) {
  let { basename: n } = w.useContext(gi), r = w.useContext(yi);
  Hn(r, "useFormAction must be used inside a RouteContext");
  let [o] = r.matches.slice(-1), a = { ...cc(e || ".", { relative: t }) }, l = Ta();
  if (e == null) {
    a.search = l.search;
    let c = new URLSearchParams(a.search), d = c.getAll("index");
    if (d.some((f) => f === "")) {
      c.delete("index"), d.filter((m) => m).forEach((m) => c.append("index", m));
      let f = c.toString();
      a.search = f ? `?${f}` : "";
    }
  }
  return (!e || e === ".") && o.route.index && (a.search = a.search ? a.search.replace(/^\?/, "?index&") : "?index"), n !== "/" && (a.pathname = a.pathname === "/" ? n : si([n, a.pathname])), Cg(a);
}
function zL(e, t = {}) {
  let n = w.useContext(pS);
  Hn(
    n != null,
    "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?"
  );
  let { basename: r } = bS(
    "useViewTransitionState"
    /* useViewTransitionState */
  ), o = cc(e, { relative: t.relative });
  if (!n.isTransitioning)
    return !1;
  let a = $a(n.currentLocation.pathname, r) || n.currentLocation.pathname, l = $a(n.nextLocation.pathname, r) || n.nextLocation.pathname;
  return nd(o.pathname, l) != null || nd(o.pathname, a) != null;
}
new TextEncoder();
const Ux = Hl((e, t) => {
  const { href: n, ...r } = e;
  return /* @__PURE__ */ x.jsx(q0, { ref: t, to: n, ...r });
}), ei = {
  fontFamily: "Lato, sans-serif",
  paletteOptions: {
    primary: {
      contrastText: "#ffffff",
      25: "E8F3D9",
      50: "#D8EBBF",
      100: "#C9E4A6",
      200: "#C9DC8C",
      300: "#A9D472",
      400: "#9ACD59",
      500: "#8AC53F",
      600: "#74A535",
      700: "#577B27",
      800: "#486620",
      900: "#324716",
      950: "#1C270C"
    },
    grey: {
      25: "#FBFBFB",
      50: "#F3F3F3",
      100: "#E1E1E2",
      200: "#D4D5D5",
      300: "#AEAEAF",
      400: "#878889",
      500: "#6D6E70",
      600: "#5E5F60",
      700: "#4F4F50",
      800: "#3F4041",
      900: "#303031",
      950: "#212121"
    }
  }
}, at = tc({
  typography: {
    // text size reset
    fontSize: 24,
    fontFamily: ei.fontFamily,
    button: {
      textTransform: "none"
    },
    h1: {
      fontSize: "4.8rem"
    }
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          position: "initial",
          boxShadow: "none"
        }
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: !0,
        LinkComponent: Ux
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          fontSize: "1.8rem"
        }
      }
    },
    MuiCheckbox: {
      defaultProps: {
        disableRipple: !0
      }
    },
    MuiLink: {
      defaultProps: {
        component: Ux
      },
      styleOverrides: {
        root: {
          textDecoration: "none",
          ":hover": {
            color: "inherit",
            textDecoration: "none"
          }
        }
      }
    }
  },
  palette: {
    primary: {
      main: ei.paletteOptions.primary[700],
      light: ei.paletteOptions.primary[600],
      dark: ei.paletteOptions.primary[800],
      ...ei.paletteOptions.primary
    },
    secondary: {
      main: ei.paletteOptions.grey[500],
      light: ei.paletteOptions.grey[200],
      dark: ei.paletteOptions.grey[700]
    },
    text: {
      primary: "#000000"
    },
    background: {
      default: jd[100]
    },
    success: {
      main: ni[500],
      light: ni[50],
      dark: ni[800]
    },
    warning: {
      main: "#EF6C00",
      light: fa[50],
      dark: fa[700]
    },
    error: {
      main: ti[500],
      light: ti[50],
      dark: ti[700]
    },
    info: {
      main: "#00A9E0",
      light: "#E5F7FC",
      dark: "#014361"
    },
    shadows: {
      light: "#10182808",
      dark: "#10182814"
    },
    grey: ei.paletteOptions.grey
  }
}), mr = at.spacing(1), WL = {
  borderRadius: mr,
  boxShadow: `0px 2px 4px -2px ${at.palette.shadows.light}, 0px 4px 8px -2px ${at.palette.shadows.dark}`,
  border: `1px solid ${at.palette.grey[100]}`,
  marginTop: at.spacing(0.5)
}, bu = (e) => ({
  backgroundColor: at.palette[e].light,
  borderColor: at.palette[e].main,
  color: at.palette[e].dark
}), il = (e, t) => {
  switch (t) {
    case "outlined":
      return e === "primary" ? {
        borderWidth: "2px",
        backgroundColor: "#ffffff",
        borderColor: at.palette.primary[400],
        color: at.palette.primary[700],
        "&:hover": {
          backgroundColor: at.palette.primary[25],
          borderColor: at.palette.primary[100]
        }
      } : {
        backgroundColor: "#ffffff",
        borderColor: at.palette.grey[200],
        color: at.palette.grey[500],
        "&:hover": {
          backgroundColor: at.palette.grey[50],
          borderColor: at.palette.grey[400]
        }
      };
    case "contained":
      return e === "primary" ? {
        border: `1px solid ${at.palette.primary[700]}`,
        color: "white",
        backgroundColor: at.palette.primary[700],
        "&:hover": {
          border: `1px solid ${at.palette.primary[300]}`,
          backgroundColor: at.palette.primary[900]
        }
      } : {};
    default:
      return {};
  }
}, xS = tc(at, {
  mixins: {
    // App toolbar height should be controlled from here so useAppBarHeight can pick it up
    toolbar: {
      minHeight: 80,
      "@media (min-width:600px)": { minHeight: 80 },
      "@media (min-width:0px) and (orientation: landscape)": { minHeight: 80 }
    },
    modalStyle: {
      position: "absolute",
      top: "50%",
      left: "50%",
      maxHeight: "75vh",
      display: "flex",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "background.paper",
      borderRadius: mr,
      border: "none",
      outline: "none",
      p: 3
    },
    activeButton: {
      border: `2px solid ${at.palette.primary[500]} !important`,
      boxShadow: `0px 0px 0px 4px ${at.palette.primary[50]}`,
      "&:hover": { backgroundColor: "white !important" }
    },
    roundedIconButton: {
      borderWidth: "1px",
      borderRadius: at.spacing(1),
      borderStyle: "solid"
    }
  },
  components: {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          height: 4
        }
      }
    },
    MuiAvatar: {
      styleOverrides: {
        rounded: {
          borderRadius: mr
        }
      }
    },
    MuiPaper: { styleOverrides: { root: WL } },
    MuiFormControl: {
      styleOverrides: {
        root: {
          gap: 2
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          color: at.palette.grey[700]
        }
      }
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: Zf
      }
    },
    MuiAutocomplete: {
      defaultProps: {
        popupIcon: /* @__PURE__ */ x.jsx(Zf, {})
      }
    },
    MuiPickersCalendarHeader: {
      defaultProps: {
        slots: {
          switchViewIcon: Zf
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          "& .MuiMenuItem-root + .MuiDivider-root": {
            marginTop: 0,
            marginBottom: 0
          }
        }
      }
    },
    MuiDivider: {
      defaultProps: {
        variant: "middle"
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&, input, fieldset": {
            borderRadius: mr,
            borderColor: at.palette.grey[300]
          },
          "&:not(:is(:focus, .Mui-disabled)):hover fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: at.palette.primary.light,
            borderWidth: "2px",
            textDecoration: "none"
          },
          "&:is(.Mui-focused, :focus) fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: `${at.palette.primary.main} !important`,
            boxShadow: `0px 0px 0px 4px ${at.palette.primary.light}7A`
          },
          "&:is(.Mui-disabled)": {
            backgroundColor: `${at.palette.grey[50]}`
          }
        }
      }
    },
    MuiTable: {
      styleOverrides: {
        root: {
          boxShadow: `0px 1px 3px 0px ${at.palette.shadows.light}, 0px 1px 2px 0px ${at.palette.shadows.dark}`,
          borderRadius: mr,
          borderCollapse: "separate",
          border: `1px solid ${at.palette.grey[50]}`
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: at.palette.grey[50],
          fontWeight: 500,
          "& th:first-of-type": {
            borderTopLeftRadius: mr
          },
          "& th:last-of-type": {
            borderTopRightRadius: mr
          }
        }
      }
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          "& tr:last-of-type": {
            // Remove bottom border from last row
            "& td": {
              borderBottom: "none"
            },
            "& td:first-of-type": {
              borderBottomLeftRadius: mr
            },
            "td:last-of-type": {
              borderBottomRightRadius: mr
            }
          }
        }
      }
    },
    MuiMultiSectionDigitalClock: {
      styleOverrides: {
        root: {
          "& .MuiButtonBase-root": {
            borderRadius: mr
          }
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: mr,
          "&.MuiAlert-outlinedInfo": bu("info"),
          "&.MuiAlert-outlinedError": bu("error"),
          "&.MuiAlert-outlinedSuccess": bu("success"),
          "&.MuiAlert-outlinedWarning": bu("warning"),
          // Style all alert message children except MUI button components
          '& .MuiAlert-message *:not([class*="MuiButtonBase-root"])': {
            color: "inherit",
            margin: 0
          }
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          boxShadow: `0px 1px 2px 0px ${at.palette.grey[700]}, 0px 1px 3px 0px ${at.palette.grey[300]}`
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          padding: `${at.spacing(1)} ${at.spacing(1.5)}`,
          borderRadius: mr,
          fontSize: "14px",
          // Styles for outlined buttons
          "&.MuiButton-outlined:not(.Mui-disabled)": {
            "&.MuiButton-colorSecondary": il("secondary", "outlined"),
            "&.MuiButton-colorPrimary": il("primary", "outlined")
          },
          // Styles for contained buttons
          "&.MuiButton-contained:not(.Mui-disabled)": {
            boxShadow: "none",
            "&.MuiButton-colorPrimary": il("primary", "contained")
          },
          // Used for buttons that render as a link
          "&.MuiButton-containedPrimary[href]:hover": {
            color: at.palette.primary.contrastText
          },
          "&.Mui-disabled": {
            backgroundColor: at.palette.grey[50],
            color: at.palette.grey[400],
            border: `1px solid ${at.palette.grey[200]}`
          }
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          "&:not(.Mui-disabled)": {
            "&.MuiIconButton-colorSecondary": il("secondary", "outlined"),
            "&.MuiIconButton-colorPrimary": il("primary", "outlined")
          },
          "&.Mui-disabled": {
            backgroundColor: at.palette.grey[50],
            color: at.palette.grey[400],
            border: `1px solid ${at.palette.grey[200]}`
          },
          "&.openDatePickerIconButton.Mui-disabled": {
            border: "none"
          }
        }
      }
    },
    MuiSkeleton: {
      styleOverrides: {
        rounded: {
          borderRadius: mr
        }
      }
    },
    MuiGrid2: {
      styleOverrides: {
        root: {
          // Hide grid if it has no children with content (i.e. all children are empty)
          ":not(:has(> *:not(:empty)))": {
            display: "none"
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          "&:after": {
            position: "absolute",
            content: '""',
            bottom: 0,
            left: "6px",
            right: "6px",
            borderTop: "1px solid #D4D5D5",
            zIndex: 1
          }
        },
        indicator: {
          display: "none"
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          display: "flex",
          flex: 1,
          borderRadius: mr,
          border: "1px solid #D4D5D5",
          background: "#FBFBFB",
          padding: at.spacing(2),
          "&:not(:last-child)": {
            marginRight: at.spacing(2)
          },
          position: "relative",
          zIndex: 0,
          '&[aria-selected="true"]': {
            bottom: "-1px",
            borderBottom: "none",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            color: "inherit",
            backgroundColor: "#ffffff",
            zIndex: 2,
            height: at.spacing(13.25),
            ":after": {
              position: "absolute",
              content: '""',
              bottom: at.spacing(0.5),
              left: at.spacing(2.5),
              right: at.spacing(2.5),
              borderTop: "1px solid #D4D5D5",
              opacity: 0.3,
              zIndex: 3
            }
          },
          height: at.spacing(12)
        }
      }
    }
  }
}), uc = (e) => (t) => /* @__PURE__ */ x.jsx(w3, { theme: xS, children: /* @__PURE__ */ x.jsx(e, { ...t }) }), wS = ({
  label: e,
  disabled: t,
  value: n,
  onChange: r,
  error: o,
  name: a,
  options: l,
  readOnly: c = !1,
  placeholderValue: d,
  loading: p,
  onRenderValue: f,
  multiple: m
}) => {
  const g = d ?? "Select option";
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(Gn, { fullWidth: !0, size: "small", children: [
      e && /* @__PURE__ */ x.jsx(ur, { id: `${a}-label`, disabled: t, children: e }),
      /* @__PURE__ */ x.jsxs(
        Jd,
        {
          displayEmpty: !0,
          size: "small",
          value: n,
          name: a,
          error: !!o,
          labelId: `${a}-label`,
          disabled: t || p,
          onChange: (y) => r(y.target.value),
          readOnly: c,
          multiple: m,
          renderValue: (y) => p ? /* @__PURE__ */ x.jsxs(Qt, { alignItems: "center", direction: "row", spacing: 1, children: [
            /* @__PURE__ */ x.jsx(Fo, { size: "1em" }),
            /* @__PURE__ */ x.jsx(Qe, { children: "Loading..." })
          ] }) : !y || y.length === 0 ? /* @__PURE__ */ x.jsx(Qe, { variant: "inherit", color: "secondary", children: g }) : m ? f ? f(y) : y.length : f ? f(y) : y,
          children: [
            /* @__PURE__ */ x.jsx(td, { value: "", children: /* @__PURE__ */ x.jsx("em", { children: g }) }),
            l.map((y) => /* @__PURE__ */ x.jsxs(td, { value: y.value, children: [
              m && /* @__PURE__ */ x.jsx(Gd, { checked: !l.find((b) => b.value === y.value) }),
              y.label || y.value
            ] }, y.value))
          ]
        }
      )
    ] }),
    o && /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "error", children: o.message })
  ] });
}, qL = ({ open: e, onClose: t, ariaLabelBy: n, actions: r, title: o, children: a }) => {
  const l = tr(), c = P0(l.breakpoints.down("md"));
  return /* @__PURE__ */ x.jsxs(Sa, { scroll: "paper", fullScreen: c, open: e, onClose: t, "aria-labelledby": n, children: [
    /* @__PURE__ */ x.jsx(wa, { id: n, children: o }),
    /* @__PURE__ */ x.jsx(Yd, { dividers: !0, children: a }),
    /* @__PURE__ */ x.jsx(ii, { children: r })
  ] });
}, $S = ({ name: e, label: t, disabled: n, value: r, onChange: o, error: a, readOnly: l }) => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
  /* @__PURE__ */ x.jsx(Gn, { fullWidth: !0, size: "small", sx: { pointerEvents: l ? "none" : "auto" }, children: /* @__PURE__ */ x.jsx(
    Xd,
    {
      disabled: n,
      control: /* @__PURE__ */ x.jsx(Gd, { disabled: n, value: "on", checked: r, onChange: (c) => o(c.target.checked), id: `${e}-input`, name: e }),
      label: t,
      htmlFor: `${e}-input`
    }
  ) }),
  a && /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "error", children: a.message })
] }), CS = ({ color: e, IconComponent: t }) => /* @__PURE__ */ x.jsx(
  Qt,
  {
    alignItems: "center",
    justifyContent: "center",
    flexShrink: "0",
    borderRadius: "24px",
    bgcolor: (n) => `${n.palette[e].light}33`,
    sx: { width: "48px", height: "48px" },
    children: /* @__PURE__ */ x.jsx(
      Qt,
      {
        alignItems: "center",
        justifyContent: "center",
        flexShrink: "0",
        borderRadius: "24px",
        bgcolor: (n) => `${n.palette[e].light}33`,
        sx: { width: "36px", height: "36px" },
        children: /* @__PURE__ */ x.jsx(t, { opacity: 0.6, color: "secondary" })
      }
    )
  }
);
var SS = /* @__PURE__ */ ((e) => (e.ID = "id", e.firstName = "First_Name", e.lastName = "Last_Name", e.preferredName = "Preferred_Name", e.gender = "Gender", e.dateOfBirth = "Date_of_Birth", e.cityOfBirth = "birth_city", e.occupation = "Occupation", e.age = "Age", e.countryOfBirth = "birth_country", e.residence = "permanent_residence", e.citizenship = "citizenship", e.email = "Email", e.mobile = "Mobile", e.homePhone = "home_number", e.workPhone = "Work_Phone", e.phone = "Phone", e.addressLine1 = "street", e.addressLine2 = "Address_Line_2", e.city = "city", e.postalCode = "postal_code", e.country = "country", e.state = "State", e.emergencyContactName = "Emergency_Contact", e.emergencyContactRelation = "EC_Relation_to_applicant_father_mother_friend_etc", e.emergencyContactPhoneNumber = "EC_Phone_Number", e.relationship = "Relationship", e.parentStatus = "Life_Status", e.isLegalGuardian = "Is_a_legal_guardian", e.contactClassification = "Contact_Classification", e.studentFamilyLookup = "Account_Name", e))(SS || {}), UL = /* @__PURE__ */ ((e) => (e.guardian = "Parent/Guardian", e.familyMember = "Student Family Member", e.friendsAndRelatives = "Friends / Relatives in the U.S.", e.student = "Student", e))(UL || {}), HL = /* @__PURE__ */ ((e) => (e.ID = "id", e.maritalStatus = "Are_your_parents", e.houseType = "Do_you_live_in", e.otherMaritalStatus = "If_other_please_explain", e.contactListGet = "Contacts__r", e))(HL || {}), Qn = /* @__PURE__ */ ((e) => (e.Text = "text", e.Date = "date", e.Radio = "radio", e.Dropdown = "dropdown", e.Checkbox = "checkbox", e.Checkboxset = "checkboxset", e.TagsAutocomplete = "tags-autocomplete", e.PictureUploader = "pictureuploader", e.FileUploader = "fileuploader", e.AddressAutocomplete = "address-autocomplete", e.SelectionRangeTable = "selection-range-table", e.Number = "number", e.GroupedAutocomplete = "grouped-autocomplete", e.Phone = "phone", e.Autocomplete = "autocomplete", e))(Qn || {});
const GL = ({ onClick: e, progress: t, formName: n }) => {
  const r = tr();
  return /* @__PURE__ */ x.jsx(Fi, { title: `${t}% Complete`, arrow: !0, placement: "top", children: /* @__PURE__ */ x.jsx(Tn, { color: "primary", variant: "outlined", onClick: e, children: /* @__PURE__ */ x.jsxs(Qt, { direction: "row", alignItems: "center", gap: 1, children: [
    /* @__PURE__ */ x.jsxs(Qt, { sx: { position: "relative" }, alignItems: "center", children: [
      /* @__PURE__ */ x.jsx(
        Fo,
        {
          variant: "determinate",
          value: 100,
          size: r.spacing(2),
          sx: {
            color: r.palette.grey[50],
            position: "absolute",
            left: 0,
            [`& .${_I.circle}`]: {
              strokeLinecap: "round"
            }
          }
        }
      ),
      /* @__PURE__ */ x.jsx(Fo, { variant: "determinate", value: t, size: r.spacing(2), sx: { color: r.palette.primary.main } })
    ] }),
    n
  ] }) }) });
}, YL = (e) => /* @__PURE__ */ w.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), KL = ({ submitText: e, progressText: t, onClick: n, progress: r, tooltipText: o, loading: a = !1 }) => {
  const l = tr(), c = r === 100;
  return /* @__PURE__ */ x.jsx(x.Fragment, { children: c ? /* @__PURE__ */ x.jsx(Tn, { loading: a, endIcon: /* @__PURE__ */ x.jsx(YL, { stroke: "white" }), variant: "contained", color: "primary", onClick: n, children: e ?? "Submit Application" }) : /* @__PURE__ */ x.jsx(Fi, { title: o, arrow: !0, placement: "top", children: /* @__PURE__ */ x.jsx(
    Tn,
    {
      endIcon: /* @__PURE__ */ x.jsx(Fo, { variant: "determinate", value: r, size: l.spacing(2), sx: { color: l.palette.primary.main } }),
      variant: "outlined",
      color: "secondary",
      onClick: n,
      loading: a,
      children: /* @__PURE__ */ x.jsx(Qt, { direction: "row", alignItems: "center", gap: 1, children: t ?? `Progress: ${r}%` })
    }
  ) }) });
}, iee = uc(GL), aee = uc(KL);
var eh, Hx;
function _s() {
  if (Hx) return eh;
  Hx = 1;
  var e = Array.isArray;
  return eh = e, eh;
}
var th, Gx;
function TS() {
  if (Gx) return th;
  Gx = 1;
  var e = typeof ji == "object" && ji && ji.Object === Object && ji;
  return th = e, th;
}
var nh, Yx;
function vi() {
  if (Yx) return nh;
  Yx = 1;
  var e = TS(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return nh = n, nh;
}
var rh, Kx;
function rp() {
  if (Kx) return rh;
  Kx = 1;
  var e = vi(), t = e.Symbol;
  return rh = t, rh;
}
var oh, Xx;
function XL() {
  if (Xx) return oh;
  Xx = 1;
  var e = rp(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, o = e ? e.toStringTag : void 0;
  function a(l) {
    var c = n.call(l, o), d = l[o];
    try {
      l[o] = void 0;
      var p = !0;
    } catch {
    }
    var f = r.call(l);
    return p && (c ? l[o] = d : delete l[o]), f;
  }
  return oh = a, oh;
}
var ih, Zx;
function ZL() {
  if (Zx) return ih;
  Zx = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return ih = n, ih;
}
var ah, Qx;
function dc() {
  if (Qx) return ah;
  Qx = 1;
  var e = rp(), t = XL(), n = ZL(), r = "[object Null]", o = "[object Undefined]", a = e ? e.toStringTag : void 0;
  function l(c) {
    return c == null ? c === void 0 ? o : r : a && a in Object(c) ? t(c) : n(c);
  }
  return ah = l, ah;
}
var sh, Jx;
function pc() {
  if (Jx) return sh;
  Jx = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return sh = e, sh;
}
var lh, e2;
function U0() {
  if (e2) return lh;
  e2 = 1;
  var e = dc(), t = pc(), n = "[object Symbol]";
  function r(o) {
    return typeof o == "symbol" || t(o) && e(o) == n;
  }
  return lh = r, lh;
}
var ch, t2;
function QL() {
  if (t2) return ch;
  t2 = 1;
  var e = _s(), t = U0(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function o(a, l) {
    if (e(a))
      return !1;
    var c = typeof a;
    return c == "number" || c == "symbol" || c == "boolean" || a == null || t(a) ? !0 : r.test(a) || !n.test(a) || l != null && a in Object(l);
  }
  return ch = o, ch;
}
var uh, n2;
function OS() {
  if (n2) return uh;
  n2 = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return uh = e, uh;
}
var dh, r2;
function PS() {
  if (r2) return dh;
  r2 = 1;
  var e = dc(), t = OS(), n = "[object AsyncFunction]", r = "[object Function]", o = "[object GeneratorFunction]", a = "[object Proxy]";
  function l(c) {
    if (!t(c))
      return !1;
    var d = e(c);
    return d == r || d == o || d == n || d == a;
  }
  return dh = l, dh;
}
var ph, o2;
function JL() {
  if (o2) return ph;
  o2 = 1;
  var e = vi(), t = e["__core-js_shared__"];
  return ph = t, ph;
}
var fh, i2;
function eB() {
  if (i2) return fh;
  i2 = 1;
  var e = JL(), t = function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!t && t in r;
  }
  return fh = n, fh;
}
var hh, a2;
function ES() {
  if (a2) return hh;
  a2 = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return hh = n, hh;
}
var mh, s2;
function tB() {
  if (s2) return mh;
  s2 = 1;
  var e = PS(), t = eB(), n = OS(), r = ES(), o = /[\\^$.*+?()[\]{}|]/g, a = /^\[object .+?Constructor\]$/, l = Function.prototype, c = Object.prototype, d = l.toString, p = c.hasOwnProperty, f = RegExp(
    "^" + d.call(p).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function m(g) {
    if (!n(g) || t(g))
      return !1;
    var y = e(g) ? f : a;
    return y.test(r(g));
  }
  return mh = m, mh;
}
var gh, l2;
function nB() {
  if (l2) return gh;
  l2 = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return gh = e, gh;
}
var yh, c2;
function Ds() {
  if (c2) return yh;
  c2 = 1;
  var e = tB(), t = nB();
  function n(r, o) {
    var a = t(r, o);
    return e(a) ? a : void 0;
  }
  return yh = n, yh;
}
var vh, u2;
function op() {
  if (u2) return vh;
  u2 = 1;
  var e = Ds(), t = e(Object, "create");
  return vh = t, vh;
}
var bh, d2;
function rB() {
  if (d2) return bh;
  d2 = 1;
  var e = op();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return bh = t, bh;
}
var xh, p2;
function oB() {
  if (p2) return xh;
  p2 = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return xh = e, xh;
}
var wh, f2;
function iB() {
  if (f2) return wh;
  f2 = 1;
  var e = op(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function o(a) {
    var l = this.__data__;
    if (e) {
      var c = l[a];
      return c === t ? void 0 : c;
    }
    return r.call(l, a) ? l[a] : void 0;
  }
  return wh = o, wh;
}
var $h, h2;
function aB() {
  if (h2) return $h;
  h2 = 1;
  var e = op(), t = Object.prototype, n = t.hasOwnProperty;
  function r(o) {
    var a = this.__data__;
    return e ? a[o] !== void 0 : n.call(a, o);
  }
  return $h = r, $h;
}
var Ch, m2;
function sB() {
  if (m2) return Ch;
  m2 = 1;
  var e = op(), t = "__lodash_hash_undefined__";
  function n(r, o) {
    var a = this.__data__;
    return this.size += this.has(r) ? 0 : 1, a[r] = e && o === void 0 ? t : o, this;
  }
  return Ch = n, Ch;
}
var Sh, g2;
function lB() {
  if (g2) return Sh;
  g2 = 1;
  var e = rB(), t = oB(), n = iB(), r = aB(), o = sB();
  function a(l) {
    var c = -1, d = l == null ? 0 : l.length;
    for (this.clear(); ++c < d; ) {
      var p = l[c];
      this.set(p[0], p[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = o, Sh = a, Sh;
}
var Th, y2;
function cB() {
  if (y2) return Th;
  y2 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Th = e, Th;
}
var Oh, v2;
function RS() {
  if (v2) return Oh;
  v2 = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return Oh = e, Oh;
}
var Ph, b2;
function ip() {
  if (b2) return Ph;
  b2 = 1;
  var e = RS();
  function t(n, r) {
    for (var o = n.length; o--; )
      if (e(n[o][0], r))
        return o;
    return -1;
  }
  return Ph = t, Ph;
}
var Eh, x2;
function uB() {
  if (x2) return Eh;
  x2 = 1;
  var e = ip(), t = Array.prototype, n = t.splice;
  function r(o) {
    var a = this.__data__, l = e(a, o);
    if (l < 0)
      return !1;
    var c = a.length - 1;
    return l == c ? a.pop() : n.call(a, l, 1), --this.size, !0;
  }
  return Eh = r, Eh;
}
var Rh, w2;
function dB() {
  if (w2) return Rh;
  w2 = 1;
  var e = ip();
  function t(n) {
    var r = this.__data__, o = e(r, n);
    return o < 0 ? void 0 : r[o][1];
  }
  return Rh = t, Rh;
}
var kh, $2;
function pB() {
  if ($2) return kh;
  $2 = 1;
  var e = ip();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return kh = t, kh;
}
var _h, C2;
function fB() {
  if (C2) return _h;
  C2 = 1;
  var e = ip();
  function t(n, r) {
    var o = this.__data__, a = e(o, n);
    return a < 0 ? (++this.size, o.push([n, r])) : o[a][1] = r, this;
  }
  return _h = t, _h;
}
var Dh, S2;
function ap() {
  if (S2) return Dh;
  S2 = 1;
  var e = cB(), t = uB(), n = dB(), r = pB(), o = fB();
  function a(l) {
    var c = -1, d = l == null ? 0 : l.length;
    for (this.clear(); ++c < d; ) {
      var p = l[c];
      this.set(p[0], p[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = o, Dh = a, Dh;
}
var Ih, T2;
function H0() {
  if (T2) return Ih;
  T2 = 1;
  var e = Ds(), t = vi(), n = e(t, "Map");
  return Ih = n, Ih;
}
var Mh, O2;
function hB() {
  if (O2) return Mh;
  O2 = 1;
  var e = lB(), t = ap(), n = H0();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return Mh = r, Mh;
}
var Ah, P2;
function mB() {
  if (P2) return Ah;
  P2 = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return Ah = e, Ah;
}
var Nh, E2;
function sp() {
  if (E2) return Nh;
  E2 = 1;
  var e = mB();
  function t(n, r) {
    var o = n.__data__;
    return e(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
  }
  return Nh = t, Nh;
}
var jh, R2;
function gB() {
  if (R2) return jh;
  R2 = 1;
  var e = sp();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return jh = t, jh;
}
var Fh, k2;
function yB() {
  if (k2) return Fh;
  k2 = 1;
  var e = sp();
  function t(n) {
    return e(this, n).get(n);
  }
  return Fh = t, Fh;
}
var Lh, _2;
function vB() {
  if (_2) return Lh;
  _2 = 1;
  var e = sp();
  function t(n) {
    return e(this, n).has(n);
  }
  return Lh = t, Lh;
}
var Bh, D2;
function bB() {
  if (D2) return Bh;
  D2 = 1;
  var e = sp();
  function t(n, r) {
    var o = e(this, n), a = o.size;
    return o.set(n, r), this.size += o.size == a ? 0 : 1, this;
  }
  return Bh = t, Bh;
}
var Vh, I2;
function G0() {
  if (I2) return Vh;
  I2 = 1;
  var e = hB(), t = gB(), n = yB(), r = vB(), o = bB();
  function a(l) {
    var c = -1, d = l == null ? 0 : l.length;
    for (this.clear(); ++c < d; ) {
      var p = l[c];
      this.set(p[0], p[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = o, Vh = a, Vh;
}
var zh, M2;
function xB() {
  if (M2) return zh;
  M2 = 1;
  var e = G0(), t = "Expected a function";
  function n(r, o) {
    if (typeof r != "function" || o != null && typeof o != "function")
      throw new TypeError(t);
    var a = function() {
      var l = arguments, c = o ? o.apply(this, l) : l[0], d = a.cache;
      if (d.has(c))
        return d.get(c);
      var p = r.apply(this, l);
      return a.cache = d.set(c, p) || d, p;
    };
    return a.cache = new (n.Cache || e)(), a;
  }
  return n.Cache = e, zh = n, zh;
}
var Wh, A2;
function wB() {
  if (A2) return Wh;
  A2 = 1;
  var e = xB(), t = 500;
  function n(r) {
    var o = e(r, function(l) {
      return a.size === t && a.clear(), l;
    }), a = o.cache;
    return o;
  }
  return Wh = n, Wh;
}
var qh, N2;
function $B() {
  if (N2) return qh;
  N2 = 1;
  var e = wB(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(o) {
    var a = [];
    return o.charCodeAt(0) === 46 && a.push(""), o.replace(t, function(l, c, d, p) {
      a.push(d ? p.replace(n, "$1") : c || l);
    }), a;
  });
  return qh = r, qh;
}
var Uh, j2;
function CB() {
  if (j2) return Uh;
  j2 = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, a = Array(o); ++r < o; )
      a[r] = n(t[r], r, t);
    return a;
  }
  return Uh = e, Uh;
}
var Hh, F2;
function SB() {
  if (F2) return Hh;
  F2 = 1;
  var e = rp(), t = CB(), n = _s(), r = U0(), o = e ? e.prototype : void 0, a = o ? o.toString : void 0;
  function l(c) {
    if (typeof c == "string")
      return c;
    if (n(c))
      return t(c, l) + "";
    if (r(c))
      return a ? a.call(c) : "";
    var d = c + "";
    return d == "0" && 1 / c == -1 / 0 ? "-0" : d;
  }
  return Hh = l, Hh;
}
var Gh, L2;
function TB() {
  if (L2) return Gh;
  L2 = 1;
  var e = SB();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return Gh = t, Gh;
}
var Yh, B2;
function OB() {
  if (B2) return Yh;
  B2 = 1;
  var e = _s(), t = QL(), n = $B(), r = TB();
  function o(a, l) {
    return e(a) ? a : t(a, l) ? [a] : n(r(a));
  }
  return Yh = o, Yh;
}
var Kh, V2;
function PB() {
  if (V2) return Kh;
  V2 = 1;
  var e = U0();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return Kh = t, Kh;
}
var Xh, z2;
function EB() {
  if (z2) return Xh;
  z2 = 1;
  var e = OB(), t = PB();
  function n(r, o) {
    o = e(o, r);
    for (var a = 0, l = o.length; r != null && a < l; )
      r = r[t(o[a++])];
    return a && a == l ? r : void 0;
  }
  return Xh = n, Xh;
}
var Zh, W2;
function RB() {
  if (W2) return Zh;
  W2 = 1;
  var e = EB();
  function t(n, r, o) {
    var a = n == null ? void 0 : e(n, r);
    return a === void 0 ? o : a;
  }
  return Zh = t, Zh;
}
var kB = RB();
const _B = /* @__PURE__ */ Cs(kB);
var DB = (e) => e.type === "checkbox", IB = (e) => e instanceof Date, kS = (e) => e == null;
const MB = (e) => typeof e == "object";
var Is = (e) => !kS(e) && !Array.isArray(e) && MB(e) && !IB(e), AB = (e) => Is(e) && e.target ? DB(e.target) ? e.target.checked : e.target.value : e, NB = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, jB = (e, t) => e.has(NB(t)), FB = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Is(t) && t.hasOwnProperty("isPrototypeOf");
}, LB = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Y0(e) {
  let t;
  const n = Array.isArray(e), r = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(LB && (e instanceof Blob || r)) && (n || Is(e)))
    if (t = n ? [] : {}, !n && !FB(e))
      t = e;
    else
      for (const o in e)
        e.hasOwnProperty(o) && (t[o] = Y0(e[o]));
  else
    return e;
  return t;
}
var _S = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Sg = (e) => e === void 0, gr = (e, t, n) => {
  if (!t || !Is(e))
    return n;
  const r = _S(t.split(/[,[\].]+?/)).reduce((o, a) => kS(o) ? o : o[a], e);
  return Sg(r) || r === e ? Sg(e[t]) ? n : e[t] : r;
}, q2 = (e) => typeof e == "boolean", BB = (e) => /^\w*$/.test(e), VB = (e) => _S(e.replace(/["|']|\]/g, "").split(/\.|\[/)), U2 = (e, t, n) => {
  let r = -1;
  const o = BB(t) ? [t] : VB(t), a = o.length, l = a - 1;
  for (; ++r < a; ) {
    const c = o[r];
    let d = n;
    if (r !== l) {
      const p = e[c];
      d = Is(p) || Array.isArray(p) ? p : isNaN(+o[r + 1]) ? {} : [];
    }
    if (c === "__proto__" || c === "constructor" || c === "prototype")
      return;
    e[c] = d, e = e[c];
  }
  return e;
};
const H2 = {
  BLUR: "blur",
  CHANGE: "change"
}, G2 = {
  all: "all"
}, zB = Ne.createContext(null), K0 = () => Ne.useContext(zB);
var WB = (e, t, n, r = !0) => {
  const o = {
    defaultValues: t._defaultValues
  };
  for (const a in e)
    Object.defineProperty(o, a, {
      get: () => {
        const l = a;
        return t._proxyFormState[l] !== G2.all && (t._proxyFormState[l] = !r || G2.all), n && (n[l] = !0), e[l];
      }
    });
  return o;
}, qB = (e) => Is(e) && !Object.keys(e).length, UB = (e, t, n, r) => {
  n(e);
  const { name: o, ...a } = e;
  return qB(a) || Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find((l) => t[l] === !0);
}, HB = (e) => Array.isArray(e) ? e : [e], DS = (e, t, n) => !e || !t || e === t || HB(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r)));
function IS(e) {
  const t = Ne.useRef(e);
  t.current = e, Ne.useEffect(() => {
    const n = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [e.disabled]);
}
function GB(e) {
  const t = K0(), { control: n = t.control, disabled: r, name: o, exact: a } = e || {}, [l, c] = Ne.useState(n._formState), d = Ne.useRef(!0), p = Ne.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), f = Ne.useRef(o);
  return f.current = o, IS({
    disabled: r,
    next: (m) => d.current && DS(f.current, m.name, a) && UB(m, p.current, n._updateFormState) && c({
      ...n._formState,
      ...m
    }),
    subject: n._subjects.state
  }), Ne.useEffect(() => (d.current = !0, p.current.isValid && n._updateValid(!0), () => {
    d.current = !1;
  }), [n]), Ne.useMemo(() => WB(l, n, p.current, !1), [l, n]);
}
var YB = (e) => typeof e == "string", KB = (e, t, n, r, o) => YB(e) ? gr(n, e, o) : Array.isArray(e) ? e.map((a) => gr(n, a)) : n;
function MS(e) {
  const t = K0(), { control: n = t.control, name: r, defaultValue: o, disabled: a, exact: l } = e || {}, c = Ne.useRef(r);
  c.current = r, IS({
    disabled: a,
    subject: n._subjects.values,
    next: (f) => {
      DS(c.current, f.name, l) && p(Y0(KB(c.current, n._names, f.values || n._formValues, !1, o)));
    }
  });
  const [d, p] = Ne.useState(n._getWatch(r, o));
  return Ne.useEffect(() => n._removeUnmounted()), d;
}
function AS(e) {
  const t = K0(), { name: n, disabled: r, control: o = t.control, shouldUnregister: a } = e, l = jB(o._names.array, n), c = MS({
    control: o,
    name: n,
    defaultValue: gr(o._formValues, n, gr(o._defaultValues, n, e.defaultValue)),
    exact: !0
  }), d = GB({
    control: o,
    name: n,
    exact: !0
  }), p = Ne.useRef(o.register(n, {
    ...e.rules,
    value: c,
    ...q2(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Ne.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!gr(d.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!gr(d.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!gr(d.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!gr(d.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => gr(d.errors, n)
    }
  }), [d, n]), m = Ne.useMemo(() => ({
    name: n,
    value: c,
    ...q2(r) || d.disabled ? { disabled: d.disabled || r } : {},
    onChange: (g) => p.current.onChange({
      target: {
        value: AB(g),
        name: n
      },
      type: H2.CHANGE
    }),
    onBlur: () => p.current.onBlur({
      target: {
        value: gr(o._formValues, n),
        name: n
      },
      type: H2.BLUR
    }),
    ref: (g) => {
      const y = gr(o._fields, n);
      y && g && (y._f.ref = {
        focus: () => g.focus(),
        select: () => g.select(),
        setCustomValidity: (b) => g.setCustomValidity(b),
        reportValidity: () => g.reportValidity()
      });
    }
  }), [
    n,
    o._formValues,
    r,
    d.disabled,
    c,
    o._fields
  ]);
  return Ne.useEffect(() => {
    const g = o._options.shouldUnregister || a, y = (b, v) => {
      const $ = gr(o._fields, b);
      $ && $._f && ($._f.mount = v);
    };
    if (y(n, !0), g) {
      const b = Y0(gr(o._options.defaultValues, n));
      U2(o._defaultValues, n, b), Sg(gr(o._formValues, n)) && U2(o._formValues, n, b);
    }
    return !l && o.register(n), () => {
      (l ? g && !o._state.action : g) ? o.unregister(n) : y(n, !1);
    };
  }, [n, o, l, a]), Ne.useEffect(() => {
    o._updateDisabledField({
      disabled: r,
      fields: o._fields,
      name: n
    });
  }, [r, n, o]), Ne.useMemo(() => ({
    field: m,
    formState: d,
    fieldState: f
  }), [m, d, f]);
}
const NS = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-7]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", [10, 11, 12, 13, 14], [["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d|90)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function lp(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(NS), e.apply(this, n);
}
function Y2(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), r = t[0].split("."), o = 0; o < 3; o++) {
    var a = Number(n[o]), l = Number(r[o]);
    if (a > l) return 1;
    if (l > a) return -1;
    if (!isNaN(a) && isNaN(l)) return 1;
    if (isNaN(a) && !isNaN(l)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var XB = {}.constructor;
function ya(e) {
  return e != null && e.constructor === XB;
}
function Tg(e) {
  "@babel/helpers - typeof";
  return Tg = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Tg(e);
}
function cp(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ZB(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function up(e, t, n) {
  return t && ZB(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var QB = "1.2.0", JB = "1.7.35", K2 = " ext. ", eV = /^\d+$/, zn = /* @__PURE__ */ function() {
  function e(t) {
    cp(this, e), jS(t), this.metadata = t, FS.call(this, t);
  }
  return up(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var r = this.countryCallingCodes()[n];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, r) {
      if (n && eV.test(n) && (r = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new X2(this.getCountryMetadata(n), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new X2(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var r = this.countryCallingCodes()[n];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var r = this.getCountryCodesForCallingCode(n);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var r = this.getCountryCodeForCallingCode(n);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var o = this.nonGeographic()[n];
        if (o)
          return o;
      } else {
        var a = this.countryCallingCodes()[n];
        if (a && a.length === 1 && a[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), X2 = /* @__PURE__ */ function() {
  function e(t, n) {
    cp(this, e), this.globalMetadataObject = n, this.metadata = t, FS.call(this, n.metadata);
  }
  return up(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(o) {
        return new tV(o, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && Z2(this.types(), n))
        return new rV(Z2(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? K2 : this.metadata[13] || K2;
    }
  }]), e;
}(), tV = /* @__PURE__ */ function() {
  function e(t, n) {
    cp(this, e), this._format = t, this.metadata = n;
  }
  return up(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !nV.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), nV = /^\(?\$1\)?$/, rV = /* @__PURE__ */ function() {
  function e(t, n) {
    cp(this, e), this.type = t, this.metadata = n;
  }
  return up(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function Z2(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function jS(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!ya(e) || !ya(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(ya(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + oV(e) + ": " + e, "."));
}
var oV = function(t) {
  return Tg(t);
};
function dp(e, t) {
  if (t = new zn(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function iV(e, t) {
  return t.countries.hasOwnProperty(e);
}
function FS(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? Y2(t, QB) === -1 ? this.v2 = !0 : Y2(t, JB) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function pp(e, t) {
  return aV(e, void 0, t);
}
function aV(e, t, n) {
  var r = n.type(t), o = r && r.possibleLengths() || n.possibleLengths();
  if (!o)
    return "IS_POSSIBLE";
  var a = e.length, l = o[0];
  return l === a ? "IS_POSSIBLE" : l > a ? "TOO_SHORT" : o[o.length - 1] < a ? "TOO_LONG" : o.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function sV(e, t, n) {
  if (t === void 0 && (t = {}), n = new zn(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return LS(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function LS(e, t) {
  switch (pp(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function fi(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function lV(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = cV(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cV(e, t) {
  if (e) {
    if (typeof e == "string") return Q2(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Q2(e, t);
  }
}
function Q2(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var uV = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function X0(e, t, n) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    n = new zn(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var r = t.v2 ? e.nationalNumber : e.phone;
    if (fi(r, n.nationalNumberPattern())) {
      if (Qh(r, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || Qh(r, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var o = lV(uV), a; !(a = o()).done; ) {
        var l = a.value;
        if (Qh(r, l, n))
          return l;
      }
    }
  }
}
function Qh(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : fi(e, t.pattern());
}
function dV(e, t, n) {
  if (t = t || {}, n = new zn(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return X0(e, t, n.metadata) !== void 0;
  var r = t.v2 ? e.nationalNumber : e.phone;
  return fi(r, n.nationalNumberPattern());
}
function pV(e, t, n) {
  var r = new zn(n), o = r.getCountryCodesForCallingCode(e);
  return o ? o.filter(function(a) {
    return fV(t, a, n);
  }) : [];
}
function fV(e, t, n) {
  var r = new zn(n);
  return r.selectNumberingPlan(t), r.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var Z0 = 2, hV = 17, mV = 3, lr = "0-9０-９٠-٩۰-۹", gV = "-‐-―−ー－", yV = "／/", vV = "．.", bV = "  ­​⁠　", xV = "()（）［］\\[\\]", wV = "~⁓∼～", mo = "".concat(gV).concat(yV).concat(vV).concat(bV).concat(xV).concat(wV), fp = "+＋", $V = new RegExp("([" + lr + "])");
function BS(e, t, n, r) {
  if (t) {
    var o = new zn(r);
    o.selectNumberingPlan(t, n);
    var a = new RegExp(o.IDDPrefix());
    if (e.search(a) === 0) {
      e = e.slice(e.match(a)[0].length);
      var l = e.match($V);
      if (!(l && l[1] != null && l[1].length > 0 && l[1] === "0"))
        return e;
    }
  }
}
function Og(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), r = n.exec(e);
    if (r) {
      var o, a, l = r.length - 1, c = l > 0 && r[l];
      if (t.nationalPrefixTransformRule() && c)
        o = e.replace(n, t.nationalPrefixTransformRule()), l > 1 && (a = r[1]);
      else {
        var d = r[0];
        o = e.slice(d.length), c && (a = r[1]);
      }
      var p;
      if (c) {
        var f = e.indexOf(r[1]), m = e.slice(0, f);
        m === t.numberingPlan.nationalPrefix() && (p = t.numberingPlan.nationalPrefix());
      } else
        p = r[0];
      return {
        nationalNumber: o,
        nationalPrefix: p,
        carrierCode: a
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function Pg(e, t) {
  var n = Og(e, t), r = n.carrierCode, o = n.nationalNumber;
  if (o !== e) {
    if (!CV(e, o, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !SV(o, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: o,
    carrierCode: r
  };
}
function CV(e, t, n) {
  return !(fi(e, n.nationalNumberPattern()) && !fi(t, n.nationalNumberPattern()));
}
function SV(e, t) {
  switch (pp(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function VS(e, t, n, r) {
  var o = t ? dp(t, r) : n;
  if (e.indexOf(o) === 0) {
    r = new zn(r), r.selectNumberingPlan(t, n);
    var a = e.slice(o.length), l = Pg(a, r), c = l.nationalNumber, d = Pg(e, r), p = d.nationalNumber;
    if (!fi(p, r.nationalNumberPattern()) && fi(c, r.nationalNumberPattern()) || pp(p, r) === "TOO_LONG")
      return {
        countryCallingCode: o,
        number: a
      };
  }
  return {
    number: e
  };
}
function Q0(e, t, n, r) {
  if (!e)
    return {};
  var o;
  if (e[0] !== "+") {
    var a = BS(e, t, n, r);
    if (a && a !== e)
      o = !0, e = "+" + a;
    else {
      if (t || n) {
        var l = VS(e, t, n, r), c = l.countryCallingCode, d = l.number;
        if (c)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: c,
            number: d
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  r = new zn(r);
  for (var p = 2; p - 1 <= mV && p <= e.length; ) {
    var f = e.slice(1, p);
    if (r.hasCallingCode(f))
      return r.selectNumberingPlan(f), {
        countryCallingCodeSource: o ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: f,
        number: e.slice(p)
      };
    p++;
  }
  return {};
}
function zS(e) {
  return e.replace(new RegExp("[".concat(mo, "]+"), "g"), " ").trim();
}
var WS = /(\$\d)/;
function qS(e, t, n) {
  var r = n.useInternationalFormat, o = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var a = e.replace(new RegExp(t.pattern()), r ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    o && t.nationalPrefixFormattingRule() ? t.format().replace(WS, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return r ? zS(a) : a;
}
var TV = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function OV(e, t, n) {
  var r = new zn(n);
  if (r.selectNumberingPlan(e, t), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (TV.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
var PV = ";ext=", Ga = function(t) {
  return "([".concat(lr, "]{1,").concat(t, "})");
};
function US(e) {
  var t = "20", n = "15", r = "9", o = "6", a = "[  \\t,]*", l = "[:\\.．]?[  \\t,-]*", c = "#?", d = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", p = "(?:[xｘ#＃~～]|int|ｉｎｔ)", f = "[- ]+", m = "[  \\t]*", g = "(?:,{2}|;)", y = PV + Ga(t), b = a + d + l + Ga(t) + c, v = a + p + l + Ga(r) + c, $ = f + Ga(o) + "#", S = m + g + l + Ga(n) + c, R = m + "(?:,)+" + l + Ga(r) + c;
  return y + "|" + b + "|" + v + "|" + $ + "|" + S + "|" + R;
}
var EV = "[" + lr + "]{" + Z0 + "}", RV = "[" + fp + "]{0,1}(?:[" + mo + "]*[" + lr + "]){3,}[" + mo + lr + "]*", kV = new RegExp("^[" + fp + "]{0,1}(?:[" + mo + "]*[" + lr + "]){1,2}$", "i"), _V = RV + // Phone number extensions
"(?:" + US() + ")?", DV = new RegExp(
  // Either a short two-digit-only phone number
  "^" + EV + "$|^" + _V + "$",
  "i"
);
function IV(e) {
  return e.length >= Z0 && DV.test(e);
}
function MV(e) {
  return kV.test(e);
}
function AV(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function NV(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = jV(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jV(e, t) {
  if (e) {
    if (typeof e == "string") return J2(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return J2(e, t);
  }
}
function J2(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function ew(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function tw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ew(Object(n), !0).forEach(function(r) {
      FV(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ew(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function FV(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var nw = {
  formatExtension: function(t, n, r) {
    return "".concat(t).concat(r.ext()).concat(n);
  }
};
function LV(e, t, n, r) {
  if (n ? n = tw(tw({}, nw), n) : n = nw, r = new zn(r), e.country && e.country !== "001") {
    if (!r.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    r.country(e.country);
  } else if (e.countryCallingCode)
    r.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var o = r.countryCallingCode(), a = n.v2 ? e.nationalNumber : e.phone, l;
  switch (t) {
    case "NATIONAL":
      return a ? (l = rd(a, e.carrierCode, "NATIONAL", r, n), Jh(l, e.ext, r, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return a ? (l = rd(a, null, "INTERNATIONAL", r, n), l = "+".concat(o, " ").concat(l), Jh(l, e.ext, r, n.formatExtension)) : "+".concat(o);
    case "E.164":
      return "+".concat(o).concat(a);
    case "RFC3966":
      return AV({
        number: "+".concat(o).concat(a),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!n.fromCountry)
        return;
      var c = VV(a, e.carrierCode, o, n.fromCountry, r);
      return Jh(c, e.ext, r, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function rd(e, t, n, r, o) {
  var a = BV(r.formats(), e);
  return a ? qS(e, a, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && o && o.nationalPrefix === !1),
    carrierCode: t,
    metadata: r
  }) : e;
}
function BV(e, t) {
  for (var n = NV(e), r; !(r = n()).done; ) {
    var o = r.value;
    if (o.leadingDigitsPatterns().length > 0) {
      var a = o.leadingDigitsPatterns()[o.leadingDigitsPatterns().length - 1];
      if (t.search(a) !== 0)
        continue;
    }
    if (fi(t, o.pattern()))
      return o;
  }
}
function Jh(e, t, n, r) {
  return t ? r(e, t, n) : e;
}
function VV(e, t, n, r, o) {
  var a = dp(r, o.metadata);
  if (a === n) {
    var l = rd(e, t, "NATIONAL", o);
    return n === "1" ? n + " " + l : l;
  }
  var c = OV(r, void 0, o.metadata);
  if (c)
    return "".concat(c, " ").concat(n, " ").concat(rd(e, null, "INTERNATIONAL", o));
}
function rw(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ow(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rw(Object(n), !0).forEach(function(r) {
      zV(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rw(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function zV(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function WV(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qV(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function UV(e, t, n) {
  return t && qV(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var HS = /* @__PURE__ */ function() {
  function e(t, n, r) {
    if (WV(this, e), !t)
      throw new TypeError("First argument is required");
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    if (typeof t == "string") {
      if (t[0] === "+" && !n)
        throw new TypeError("`metadata` argument not passed");
      if (ya(n) && ya(n.countries)) {
        r = n;
        var o = t;
        if (!YV.test(o))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var a = Q0(o, void 0, void 0, r), l = a.countryCallingCode, c = a.number;
        if (n = c, t = l, !n)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!n)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof n != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    jS(r);
    var d = GV(t, r), p = d.country, f = d.countryCallingCode;
    this.country = p, this.countryCallingCode = f, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return UV(e, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : pV(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return sV(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return dV(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new zn(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return X0(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, r) {
      return LV(this, n, r ? ow(ow({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), e;
}(), HV = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function GV(e, t) {
  var n, r, o = new zn(t);
  return HV(e) ? (n = e, o.selectNumberingPlan(n), r = o.countryCallingCode()) : r = e, {
    country: n,
    countryCallingCode: r
  };
}
var YV = /^\+\d+$/;
function Eg(e) {
  "@babel/helpers - typeof";
  return Eg = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Eg(e);
}
function KV(e, t, n) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function XV(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ZV(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ll(e, t);
}
function QV(e) {
  var t = YS();
  return function() {
    var r = Bl(e), o;
    if (t) {
      var a = Bl(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return JV(this, o);
  };
}
function JV(e, t) {
  if (t && (Eg(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return GS(e);
}
function GS(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Rg(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Rg = function(r) {
    if (r === null || !ez(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r)) return t.get(r);
      t.set(r, o);
    }
    function o() {
      return ju(r, arguments, Bl(this).constructor);
    }
    return o.prototype = Object.create(r.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), Ll(o, r);
  }, Rg(e);
}
function ju(e, t, n) {
  return YS() ? ju = Reflect.construct : ju = function(o, a, l) {
    var c = [null];
    c.push.apply(c, a);
    var d = Function.bind.apply(o, c), p = new d();
    return l && Ll(p, l.prototype), p;
  }, ju.apply(null, arguments);
}
function YS() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ez(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function Ll(e, t) {
  return Ll = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Ll(e, t);
}
function Bl(e) {
  return Bl = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Bl(e);
}
var ri = /* @__PURE__ */ function(e) {
  ZV(n, e);
  var t = QV(n);
  function n(r) {
    var o;
    return XV(this, n), o = t.call(this, r), Object.setPrototypeOf(GS(o), n.prototype), o.name = o.constructor.name, o;
  }
  return KV(n);
}(/* @__PURE__ */ Rg(Error)), iw = new RegExp("(?:" + US() + ")$", "i");
function tz(e) {
  var t = e.search(iw);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), r = e.match(iw), o = 1; o < r.length; ) {
    if (r[o])
      return {
        number: n,
        ext: r[o]
      };
    o++;
  }
}
function nz(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = rz(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rz(e, t) {
  if (e) {
    if (typeof e == "string") return aw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return aw(e, t);
  }
}
function aw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var oz = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function KS(e) {
  return oz[e];
}
function od(e) {
  for (var t = "", n = nz(e.split("")), r; !(r = n()).done; ) {
    var o = r.value, a = KS(o);
    a && (t += a);
  }
  return t;
}
function iz(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = az(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function az(e, t) {
  if (e) {
    if (typeof e == "string") return sw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sw(e, t);
  }
}
function sw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function lw(e) {
  for (var t = "", n = iz(e.split("")), r; !(r = n()).done; ) {
    var o = r.value;
    t += sz(o, t) || "";
  }
  return t;
}
function sz(e, t, n) {
  return e === "+" ? t ? void 0 : "+" : KS(e);
}
function lz(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = cz(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cz(e, t) {
  if (e) {
    if (typeof e == "string") return cw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return cw(e, t);
  }
}
function cw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function XS(e, t) {
  var n = t.countries;
  t.defaultCountry;
  var r = t.metadata;
  r = new zn(r);
  for (var o = lz(n), a; !(a = o()).done; ) {
    var l = a.value;
    if (r.country(l), r.leadingDigits()) {
      if (e && e.search(r.leadingDigits()) === 0)
        return l;
    } else if (X0({
      phone: e,
      country: l
    }, void 0, r.metadata))
      return l;
  }
}
function ZS(e, t) {
  var n = t.nationalNumber, r = t.defaultCountry, o = t.metadata, a = o.getCountryCodesForCallingCode(e);
  if (a)
    return a.length === 1 ? a[0] : XS(n, {
      countries: a,
      defaultCountry: r,
      metadata: o.metadata
    });
}
var QS = "+", uz = "[\\-\\.\\(\\)]?", uw = "([" + lr + "]|" + uz + ")", dz = "^\\" + QS + uw + "*[" + lr + "]" + uw + "*$", pz = new RegExp(dz, "g"), kg = lr, fz = "[" + kg + "]+((\\-)*[" + kg + "])*", hz = "a-zA-Z", mz = "[" + hz + "]+((\\-)*[" + kg + "])*", gz = "^(" + fz + "\\.)*" + mz + "\\.?$", yz = new RegExp(gz, "g"), dw = "tel:", _g = ";phone-context=", vz = ";isub=";
function bz(e) {
  var t = e.indexOf(_g);
  if (t < 0)
    return null;
  var n = t + _g.length;
  if (n >= e.length)
    return "";
  var r = e.indexOf(";", n);
  return r >= 0 ? e.substring(n, r) : e.substring(n);
}
function xz(e) {
  return e === null ? !0 : e.length === 0 ? !1 : pz.test(e) || yz.test(e);
}
function wz(e, t) {
  var n = t.extractFormattedPhoneNumber, r = bz(e);
  if (!xz(r))
    throw new ri("NOT_A_NUMBER");
  var o;
  if (r === null)
    o = n(e) || "";
  else {
    o = "", r.charAt(0) === QS && (o += r);
    var a = e.indexOf(dw), l;
    a >= 0 ? l = a + dw.length : l = 0;
    var c = e.indexOf(_g);
    o += e.substring(l, c);
  }
  var d = o.indexOf(vz);
  if (d > 0 && (o = o.substring(0, d)), o !== "")
    return o;
}
var $z = 250, Cz = new RegExp("[" + fp + lr + "]"), Sz = new RegExp("[^" + lr + "#]+$");
function Tz(e, t, n) {
  if (t = t || {}, n = new zn(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new ri("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var r = Pz(e, t.v2, t.extract), o = r.number, a = r.ext, l = r.error;
  if (!o) {
    if (t.v2)
      throw l === "TOO_SHORT" ? new ri("TOO_SHORT") : new ri("NOT_A_NUMBER");
    return {};
  }
  var c = Rz(o, t.defaultCountry, t.defaultCallingCode, n), d = c.country, p = c.nationalNumber, f = c.countryCallingCode, m = c.countryCallingCodeSource, g = c.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new ri("INVALID_COUNTRY");
    return {};
  }
  if (!p || p.length < Z0) {
    if (t.v2)
      throw new ri("TOO_SHORT");
    return {};
  }
  if (p.length > hV) {
    if (t.v2)
      throw new ri("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var y = new HS(f, p, n.metadata);
    return d && (y.country = d), g && (y.carrierCode = g), a && (y.ext = a), y.__countryCallingCodeSource = m, y;
  }
  var b = (t.extended ? n.hasSelectedNumberingPlan() : d) ? fi(p, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: d,
    countryCallingCode: f,
    carrierCode: g,
    valid: b,
    possible: b ? !0 : !!(t.extended === !0 && n.possibleLengths() && LS(p, n)),
    phone: p,
    ext: a
  } : b ? Ez(d, p, a) : {};
}
function Oz(e, t, n) {
  if (e) {
    if (e.length > $z) {
      if (n)
        throw new ri("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var r = e.search(Cz);
    if (!(r < 0))
      return e.slice(r).replace(Sz, "");
  }
}
function Pz(e, t, n) {
  var r = wz(e, {
    extractFormattedPhoneNumber: function(l) {
      return Oz(l, n, t);
    }
  });
  if (!r)
    return {};
  if (!IV(r))
    return MV(r) ? {
      error: "TOO_SHORT"
    } : {};
  var o = tz(r);
  return o.ext ? o : {
    number: r
  };
}
function Ez(e, t, n) {
  var r = {
    country: e,
    phone: t
  };
  return n && (r.ext = n), r;
}
function Rz(e, t, n, r) {
  var o = Q0(lw(e), t, n, r.metadata), a = o.countryCallingCodeSource, l = o.countryCallingCode, c = o.number, d;
  if (l)
    r.selectNumberingPlan(l);
  else if (c && (t || n))
    r.selectNumberingPlan(t, n), t && (d = t), l = n || dp(t, r.metadata);
  else return {};
  if (!c)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: l
    };
  var p = Pg(lw(c), r), f = p.nationalNumber, m = p.carrierCode, g = ZS(l, {
    nationalNumber: f,
    defaultCountry: t,
    metadata: r
  });
  return g && (d = g, g === "001" || r.country(d)), {
    country: d,
    countryCallingCode: l,
    countryCallingCodeSource: a,
    nationalNumber: f,
    carrierCode: m
  };
}
function pw(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pw(Object(n), !0).forEach(function(r) {
      kz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pw(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function kz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function JS(e, t, n) {
  return Tz(e, fw(fw({}, t), {}, {
    v2: !0
  }), n);
}
function hw(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _z(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hw(Object(n), !0).forEach(function(r) {
      Dz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : hw(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Dz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Iz(e, t) {
  return jz(e) || Nz(e, t) || Az(e, t) || Mz();
}
function Mz() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Az(e, t) {
  if (e) {
    if (typeof e == "string") return mw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mw(e, t);
  }
}
function mw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Nz(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, a = !1, l, c;
    try {
      for (n = n.call(e); !(o = (l = n.next()).done) && (r.push(l.value), !(t && r.length === t)); o = !0)
        ;
    } catch (d) {
      a = !0, c = d;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (a) throw c;
      }
    }
    return r;
  }
}
function jz(e) {
  if (Array.isArray(e)) return e;
}
function eT(e) {
  var t = Array.prototype.slice.call(e), n = Iz(t, 4), r = n[0], o = n[1], a = n[2], l = n[3], c, d, p;
  if (typeof r == "string")
    c = r;
  else throw new TypeError("A text for parsing must be a string.");
  if (!o || typeof o == "string")
    l ? (d = a, p = l) : (d = void 0, p = a), o && (d = _z({
      defaultCountry: o
    }, d));
  else if (ya(o))
    a ? (d = o, p = a) : p = o;
  else throw new Error("Invalid second argument: ".concat(o));
  return {
    text: c,
    options: d,
    metadata: p
  };
}
function Fz() {
  var e = eT(arguments), t = e.text, n = e.options, r = e.metadata;
  return JS(t, n, r);
}
function gw(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function yw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gw(Object(n), !0).forEach(function(r) {
      Lz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gw(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Lz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Bz(e, t, n) {
  t && t.defaultCountry && !iV(t.defaultCountry, n) && (t = yw(yw({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return JS(e, t, n);
  } catch (r) {
    if (!(r instanceof ri)) throw r;
  }
}
function vw(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vw(Object(n), !0).forEach(function(r) {
      Vz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vw(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Vz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function zz() {
  var e = eT(arguments), t = e.text, n = e.options, r = e.metadata;
  n = bw(bw({}, n), {}, {
    extract: !1
  });
  var o = Bz(t, n, r);
  return o && o.isValid() || !1;
}
function Wz(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qz(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Uz(e, t, n) {
  return t && qz(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Hz = /* @__PURE__ */ function() {
  function e(t) {
    var n = t.onCountryChange, r = t.onCallingCodeChange;
    Wz(this, e), this.onCountryChange = n, this.onCallingCodeChange = r;
  }
  return Uz(e, [{
    key: "reset",
    value: function(n) {
      var r = n.country, o = n.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, o);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(n) {
      for (var r = 0, o = Object.keys(n); r < o.length; r++) {
        var a = o[r];
        this[a] = n[a];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(n, r) {
      this.setCountry(n), this.setCallingCode(r);
    }
  }, {
    key: "setCountry",
    value: function(n) {
      this.country = n, this.onCountryChange(n);
    }
  }, {
    key: "setCallingCode",
    value: function(n) {
      this.callingCode = n, this.onCallingCodeChange(n, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, r) {
      this.international = !0, this.initCountryAndCallingCode(n, r);
    }
  }, {
    key: "appendDigits",
    value: function(n) {
      this.digits += n;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(n) {
      this.nationalSignificantNumber += n;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), e;
}();
function Gz(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Yz(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Yz(e, t) {
  if (e) {
    if (typeof e == "string") return xw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return xw(e, t);
  }
}
function xw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var ho = "x", em = new RegExp(ho);
function Fu(e, t) {
  if (t < 1)
    return "";
  for (var n = ""; t > 1; )
    t & 1 && (n += e), t >>= 1, e += e;
  return n + e;
}
function ww(e, t) {
  return e[t] === ")" && t++, Kz(e.slice(0, t));
}
function Kz(e) {
  for (var t = [], n = 0; n < e.length; )
    e[n] === "(" ? t.push(n) : e[n] === ")" && t.pop(), n++;
  var r = 0, o = "";
  t.push(e.length);
  for (var a = 0, l = t; a < l.length; a++) {
    var c = l[a];
    o += e.slice(r, c), r = c + 1;
  }
  return o;
}
function Xz(e, t, n) {
  for (var r = Gz(n.split("")), o; !(o = r()).done; ) {
    var a = o.value;
    if (e.slice(t + 1).search(em) < 0)
      return;
    t = e.search(em), e = e.replace(em, a);
  }
  return [e, t];
}
function Zz(e, t, n) {
  var r = n.metadata, o = n.shouldTryNationalPrefixFormattingRule, a = n.getSeparatorAfterNationalPrefix, l = new RegExp("^(?:".concat(t.pattern(), ")$"));
  if (l.test(e.nationalSignificantNumber))
    return Jz(e, t, {
      metadata: r,
      shouldTryNationalPrefixFormattingRule: o,
      getSeparatorAfterNationalPrefix: a
    });
}
function Qz(e, t) {
  return pp(e, t) === "IS_POSSIBLE";
}
function Jz(e, t, n) {
  var r = n.metadata, o = n.shouldTryNationalPrefixFormattingRule, a = n.getSeparatorAfterNationalPrefix;
  if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, o(t)) {
    var l = $w(e, t, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: a,
      metadata: r
    });
    if (l)
      return l;
  }
  return $w(e, t, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: a,
    metadata: r
  });
}
function $w(e, t, n) {
  var r = n.metadata, o = n.useNationalPrefixFormattingRule, a = n.getSeparatorAfterNationalPrefix, l = qS(e.nationalSignificantNumber, t, {
    carrierCode: e.carrierCode,
    useInternationalFormat: e.international,
    withNationalPrefix: o,
    metadata: r
  });
  if (o || (e.nationalPrefix ? l = e.nationalPrefix + a(t) + l : e.complexPrefixBeforeNationalSignificantNumber && (l = e.complexPrefixBeforeNationalSignificantNumber + " " + l)), eW(l, e))
    return l;
}
function eW(e, t) {
  return od(e) === t.getNationalDigits();
}
function tW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function nW(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function rW(e, t, n) {
  return t && nW(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var oW = /* @__PURE__ */ function() {
  function e() {
    tW(this, e);
  }
  return rW(e, [{
    key: "parse",
    value: function(n) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(n), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var r = this.context[0], o = r.branches, a = r.instructions;
      if (o)
        return {
          op: "|",
          args: o.concat([tm(a)])
        };
      if (a.length === 0)
        throw new Error("Pattern is required");
      return a.length === 1 ? a[0] : a;
    }
  }, {
    key: "startContext",
    value: function(n) {
      this.context.push(n);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(n) {
      if (!n)
        throw new Error("Pattern is required");
      var r = n.match(sW);
      if (!r) {
        if (aW.test(n))
          throw new Error("Illegal characters found in a pattern: ".concat(n));
        this.getContext().instructions = this.getContext().instructions.concat(n.split(""));
        return;
      }
      var o = r[1], a = n.slice(0, r.index), l = n.slice(r.index + o.length);
      switch (o) {
        case "(?:":
          a && this.parsePattern(a), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (a && this.parsePattern(a), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var c = this.getContext(), d = c.branches;
          d.push(tm(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: d
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (a && this.parsePattern(a), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(tm(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          a && this.parsePattern(a), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: iW(a)
          });
          break;
        /* istanbul ignore next */
        default:
          throw new Error("Unknown operator: ".concat(o));
      }
      l && this.parsePattern(l);
    }
  }]), e;
}();
function iW(e) {
  for (var t = [], n = 0; n < e.length; ) {
    if (e[n] === "-") {
      if (n === 0 || n === e.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var r = e[n - 1].charCodeAt(0) + 1, o = e[n + 1].charCodeAt(0) - 1, a = r; a <= o; )
        t.push(String.fromCharCode(a)), a++;
    } else
      t.push(e[n]);
    n++;
  }
  return t;
}
var aW = /[\(\)\[\]\?\:\|]/, sW = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function tm(e) {
  return e.length === 1 ? e[0] : e;
}
function Cw(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = lW(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lW(e, t) {
  if (e) {
    if (typeof e == "string") return Sw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Sw(e, t);
  }
}
function Sw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function cW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function uW(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function dW(e, t, n) {
  return t && uW(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var pW = /* @__PURE__ */ function() {
  function e(t) {
    cW(this, e), this.matchTree = new oW().parse(t);
  }
  return dW(e, [{
    key: "match",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = r.allowOverflow;
      if (!n)
        throw new Error("String is required");
      var a = Dg(n.split(""), this.matchTree, !0);
      if (a && a.match && delete a.matchedChars, !(a && a.overflow && !o))
        return a;
    }
  }]), e;
}();
function Dg(e, t, n) {
  if (typeof t == "string") {
    var r = e.join("");
    return t.indexOf(r) === 0 ? e.length === t.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : r.indexOf(t) === 0 ? n && e.length > t.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, t.length)
    } : void 0;
  }
  if (Array.isArray(t)) {
    for (var o = e.slice(), a = 0; a < t.length; ) {
      var l = t[a], c = Dg(o, l, n && a === t.length - 1);
      if (c) {
        if (c.overflow)
          return c;
        if (c.match) {
          if (o = o.slice(c.matchedChars.length), o.length === 0)
            return a === t.length - 1 ? {
              match: !0,
              matchedChars: e
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (c.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(c, null, 2)));
        }
      } else return;
      a++;
    }
    return n ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - o.length)
    };
  }
  switch (t.op) {
    case "|":
      for (var d, p = Cw(t.args), f; !(f = p()).done; ) {
        var m = f.value, g = Dg(e, m, n);
        if (g) {
          if (g.overflow)
            return g;
          if (g.match)
            return {
              match: !0,
              matchedChars: g.matchedChars
            };
          if (g.partialMatch)
            d = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(g, null, 2)));
        }
      }
      return d ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var y = Cw(t.args), b; !(b = y()).done; ) {
        var v = b.value;
        if (e[0] === v)
          return e.length === 1 ? {
            match: !0,
            matchedChars: e
          } : n ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [v]
          };
      }
      return;
    /* istanbul ignore next */
    default:
      throw new Error("Unsupported instruction tree: ".concat(t));
  }
}
function Tw(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = fW(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fW(e, t) {
  if (e) {
    if (typeof e == "string") return Ow(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ow(e, t);
  }
}
function Ow(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function hW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function mW(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function gW(e, t, n) {
  return t && mW(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Ig = "9", yW = 15, vW = Fu(Ig, yW), bW = /[- ]/, xW = function() {
  return /\[([^\[\]])*\]/g;
}, wW = function() {
  return /\d(?=[^,}][^,}])/g;
}, $W = new RegExp("[" + mo + "]*\\$1[" + mo + "]*(\\$\\d[" + mo + "]*)*$"), Pw = 3, CW = /* @__PURE__ */ function() {
  function e(t) {
    t.state;
    var n = t.metadata;
    hW(this, e), this.metadata = n, this.resetFormat();
  }
  return gW(e, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(n, r) {
      this.resetFormat(), n ? (this.isNANP = n.callingCode() === "1", this.matchingFormats = n.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(n, r) {
      var o = this;
      if (Qz(r.nationalSignificantNumber, this.metadata))
        for (var a = Tw(this.matchingFormats), l; !(l = a()).done; ) {
          var c = l.value, d = Zz(r, c, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(f) {
              return o.shouldTryNationalPrefixFormattingRule(f, {
                international: r.international,
                nationalPrefix: r.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(f) {
              return o.getSeparatorAfterNationalPrefix(f);
            }
          });
          if (d)
            return this.resetFormat(), this.chosenFormat = c, this.setNationalNumberTemplate(d.replace(/\d/g, ho), r), this.populatedNationalNumberTemplate = d, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(ho), d;
        }
      return this.formatNationalNumberWithNextDigits(n, r);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(n, r) {
      var o = this.chosenFormat, a = this.chooseFormat(r);
      if (a)
        return a === o ? this.formatNextNationalNumberDigits(n) : this.formatNextNationalNumberDigits(r.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(n) {
      var r = this, o = n.nationalSignificantNumber, a = n.nationalPrefix, l = n.international, c = o, d = c.length - Pw;
      d < 0 && (d = 0), this.matchingFormats = this.matchingFormats.filter(function(p) {
        return r.formatSuits(p, l, a) && r.formatMatches(p, c, d);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(n, r, o) {
      return !(o && !n.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !n.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !o && n.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(n, r, o) {
      var a = n.leadingDigitsPatterns().length;
      if (a === 0)
        return !0;
      o = Math.min(o, a - 1);
      var l = n.leadingDigitsPatterns()[o];
      if (r.length < Pw)
        try {
          return new pW(l).match(r, {
            allowOverflow: !0
          }) !== void 0;
        } catch (c) {
          return console.error(c), !0;
        }
      return new RegExp("^(".concat(l, ")")).test(r);
    }
  }, {
    key: "getFormatFormat",
    value: function(n, r) {
      return r ? n.internationalFormat() : n.format();
    }
  }, {
    key: "chooseFormat",
    value: function(n) {
      for (var r = this, o = function() {
        var p = l.value;
        return r.chosenFormat === p ? "break" : $W.test(r.getFormatFormat(p, n.international)) ? r.createTemplateForFormat(p, n) ? (r.chosenFormat = p, "break") : (r.matchingFormats = r.matchingFormats.filter(function(f) {
          return f !== p;
        }), "continue") : "continue";
      }, a = Tw(this.matchingFormats.slice()), l; !(l = a()).done; ) {
        var c = o();
        if (c === "break") break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(n, r) {
      if (!(n.pattern().indexOf("|") >= 0)) {
        var o = this.getTemplateForFormat(n, r);
        if (o)
          return this.setNationalNumberTemplate(o, r), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(n) {
      return this.isNANP || n && n.nationalPrefixFormattingRule() && bW.test(n.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(n, r) {
      var o = n.IDDPrefix, a = n.missingPlus;
      return o ? r && r.spacing === !1 ? o : o + " " : a ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(n) {
      if (this.template) {
        for (var r = -1, o = 0, a = n.international ? this.getInternationalPrefixBeforeCountryCallingCode(n, {
          spacing: !1
        }) : ""; o < a.length + n.getDigitsWithoutInternationalPrefix().length; )
          r = this.template.indexOf(ho, r + 1), o++;
        return ww(this.template, r + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(n, r) {
      this.nationalNumberTemplate = n, this.populatedNationalNumberTemplate = n, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, ho) + Fu(ho, r.callingCode.length) + " " + n : this.template = n;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(n, r) {
      var o = r.nationalSignificantNumber, a = r.international, l = r.nationalPrefix, c = r.complexPrefixBeforeNationalSignificantNumber, d = n.pattern();
      d = d.replace(xW(), "\\d").replace(wW(), "\\d");
      var p = vW.match(d)[0];
      if (!(o.length > p.length)) {
        var f = new RegExp("^" + d + "$"), m = o.replace(/\d/g, Ig);
        f.test(m) && (p = m);
        var g = this.getFormatFormat(n, a), y;
        if (this.shouldTryNationalPrefixFormattingRule(n, {
          international: a,
          nationalPrefix: l
        })) {
          var b = g.replace(WS, n.nationalPrefixFormattingRule());
          if (od(n.nationalPrefixFormattingRule()) === (l || "") + od("$1") && (g = b, y = !0, l))
            for (var v = l.length; v > 0; )
              g = g.replace(/\d/, ho), v--;
        }
        var $ = p.replace(new RegExp(d), g).replace(new RegExp(Ig, "g"), ho);
        return y || (c ? $ = Fu(ho, c.length) + " " + $ : l && ($ = Fu(ho, l.length) + this.getSeparatorAfterNationalPrefix(n) + $)), a && ($ = zS($)), $;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(n) {
      var r = Xz(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, n);
      if (!r) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], ww(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(n, r) {
      var o = r.international, a = r.nationalPrefix;
      if (n.nationalPrefixFormattingRule()) {
        var l = n.usesNationalPrefix();
        if (l && a || !l && !o)
          return !0;
      }
    }
  }]), e;
}();
function tT(e, t) {
  return PW(e) || OW(e, t) || TW(e, t) || SW();
}
function SW() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function TW(e, t) {
  if (e) {
    if (typeof e == "string") return Ew(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ew(e, t);
  }
}
function Ew(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function OW(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, a = !1, l, c;
    try {
      for (n = n.call(e); !(o = (l = n.next()).done) && (r.push(l.value), !(t && r.length === t)); o = !0)
        ;
    } catch (d) {
      a = !0, c = d;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (a) throw c;
      }
    }
    return r;
  }
}
function PW(e) {
  if (Array.isArray(e)) return e;
}
function EW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function RW(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function kW(e, t, n) {
  return t && RW(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var _W = "[" + mo + lr + "]+", DW = new RegExp("^" + _W + "$", "i"), IW = "(?:[" + fp + "][" + mo + lr + "]*|[" + mo + lr + "]+)", MW = new RegExp("[^" + mo + lr + "]+.*$"), AW = /[^\d\[\]]/, NW = /* @__PURE__ */ function() {
  function e(t) {
    var n = t.defaultCountry, r = t.defaultCallingCode, o = t.metadata, a = t.onNationalSignificantNumberChange;
    EW(this, e), this.defaultCountry = n, this.defaultCallingCode = r, this.metadata = o, this.onNationalSignificantNumberChange = a;
  }
  return kW(e, [{
    key: "input",
    value: function(n, r) {
      var o = LW(n), a = tT(o, 2), l = a[0], c = a[1], d = od(l), p;
      return c && (r.digits || (r.startInternationalNumber(), d || (p = !0))), d && this.inputDigits(d, r), {
        digits: d,
        justLeadingPlus: p
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(n, r) {
      var o = r.digits, a = o.length < 3 && o.length + n.length >= 3;
      if (r.appendDigits(n), a && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
        if (!this.extractCountryCallingCode(r))
          return;
      } else
        r.appendNationalSignificantNumberDigits(n);
      r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(l) {
        return r.update(l);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(n) {
      var r = n.international, o = n.callingCode;
      return r && !o;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(n) {
      var r = Q0("+" + n.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), o = r.countryCallingCode, a = r.number;
      if (o)
        return n.setCallingCode(o), n.update({
          nationalSignificantNumber: a
        }), !0;
    }
  }, {
    key: "reset",
    value: function(n) {
      if (n) {
        this.hasSelectedNumberingPlan = !0;
        var r = n._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = r && AW.test(r);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(n, r) {
      if (this.hasSelectedNumberingPlan) {
        var o = Og(n, this.metadata), a = o.nationalPrefix, l = o.nationalNumber, c = o.carrierCode;
        if (l !== n)
          return this.onExtractedNationalNumber(a, c, l, n, r), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(n, r, o) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(n, o);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var a = Og(n, this.metadata), l = a.nationalPrefix, c = a.nationalNumber, d = a.carrierCode;
        if (c !== r)
          return this.onExtractedNationalNumber(l, d, c, n, o), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(n, r, o, a, l) {
      var c, d, p = a.lastIndexOf(o);
      if (p >= 0 && p === a.length - o.length) {
        d = !0;
        var f = a.slice(0, p);
        f !== n && (c = f);
      }
      l({
        nationalPrefix: n,
        carrierCode: r,
        nationalSignificantNumber: o,
        nationalSignificantNumberMatchesInput: d,
        complexPrefixBeforeNationalSignificantNumber: c
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(n) {
      if (this.extractAnotherNationalSignificantNumber(n.getNationalDigits(), n.nationalSignificantNumber, function(r) {
        return n.update(r);
      }))
        return !0;
      if (this.extractIddPrefix(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
      if (this.fixMissingPlus(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(n) {
      var r = n.international, o = n.IDDPrefix, a = n.digits;
      if (n.nationalSignificantNumber, !(r || o)) {
        var l = BS(a, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (l !== void 0 && l !== a)
          return n.update({
            IDDPrefix: a.slice(0, a.length - l.length)
          }), this.startInternationalNumber(n, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(n) {
      if (!n.international) {
        var r = VS(n.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), o = r.countryCallingCode;
        if (r.number, o)
          return n.update({
            missingPlus: !0
          }), this.startInternationalNumber(n, {
            country: n.country,
            callingCode: o
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, r) {
      var o = r.country, a = r.callingCode;
      n.startInternationalNumber(o, a), n.nationalSignificantNumber && (n.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(n) {
      this.extractCountryCallingCode(n) && this.extractNationalSignificantNumber(n.getNationalDigits(), function(r) {
        return n.update(r);
      });
    }
  }]), e;
}();
function jW(e) {
  var t = e.search(IW);
  if (!(t < 0)) {
    e = e.slice(t);
    var n;
    return e[0] === "+" && (n = !0, e = e.slice(1)), e = e.replace(MW, ""), n && (e = "+" + e), e;
  }
}
function FW(e) {
  var t = jW(e) || "";
  return t[0] === "+" ? [t.slice(1), !0] : [t];
}
function LW(e) {
  var t = FW(e), n = tT(t, 2), r = n[0], o = n[1];
  return DW.test(r) || (r = ""), [r, o];
}
function BW(e, t) {
  return qW(e) || WW(e, t) || zW(e, t) || VW();
}
function VW() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zW(e, t) {
  if (e) {
    if (typeof e == "string") return Rw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Rw(e, t);
  }
}
function Rw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function WW(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, a = !1, l, c;
    try {
      for (n = n.call(e); !(o = (l = n.next()).done) && (r.push(l.value), !(t && r.length === t)); o = !0)
        ;
    } catch (d) {
      a = !0, c = d;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (a) throw c;
      }
    }
    return r;
  }
}
function qW(e) {
  if (Array.isArray(e)) return e;
}
function UW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function HW(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function GW(e, t, n) {
  return t && HW(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var nT = /* @__PURE__ */ function() {
  function e(t, n) {
    UW(this, e), this.metadata = new zn(n);
    var r = this.getCountryAndCallingCode(t), o = BW(r, 2), a = o[0], l = o[1];
    this.defaultCountry = a, this.defaultCallingCode = l, this.reset();
  }
  return GW(e, [{
    key: "getCountryAndCallingCode",
    value: function(n) {
      var r, o;
      return n && (ya(n) ? (r = n.defaultCountry, o = n.defaultCallingCode) : r = n), r && !this.metadata.hasCountry(r) && (r = void 0), [r, o];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(n) {
      var r = this.parser.input(n, this.state), o = r.digits, a = r.justLeadingPlus;
      if (a)
        this.formattedOutput = "+";
      else if (o) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var l;
        if (this.metadata.hasSelectedNumberingPlan() && (l = this.formatter.format(o, this.state)), l === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var c = this.state.getNationalDigits();
          c && (l = this.formatter.format(c, this.state));
        }
        this.formattedOutput = l ? this.getFullNumber(l) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var n = this;
      return this.state = new Hz({
        onCountryChange: function(o) {
          n.country = o;
        },
        onCallingCodeChange: function(o, a) {
          n.metadata.selectNumberingPlan(a, o), n.formatter.reset(n.metadata.numberingPlan, n.state), n.parser.reset(n.metadata.numberingPlan);
        }
      }), this.formatter = new CW({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new NW({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          n.determineTheCountryIfNeeded(), n.formatter.reset(n.metadata.numberingPlan, n.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var n = this.state.digits;
      if (n)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var n = this.state.country;
      return n;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(n) {
      var r = this;
      if (this.isInternational()) {
        var o = function(c) {
          return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
            spacing: !!c
          }) + c;
        }, a = this.state.callingCode;
        return o(a ? n ? "".concat(a, " ").concat(n) : a : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return n;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var n = this.state, r = n.nationalSignificantNumber, o = n.complexPrefixBeforeNationalSignificantNumber, a = n.nationalPrefix, l = r, c = o || a;
      return c && (l = c + l), l;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var n = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(n ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var n = this.getNonFormattedNumber();
      if (n)
        return n.replace(/[\+\d]/g, ho);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var n = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(n);
      return r && r.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(ZS(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var n = this.state, r = n.digits, o = n.callingCode, a = n.country, l = n.nationalSignificantNumber;
      if (r) {
        if (this.isInternational())
          return o ? "+" + o + l : "+" + r;
        if (a || o) {
          var c = a ? this.metadata.countryCallingCode() : o;
          return "+" + c + l;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var n = this.state, r = n.nationalSignificantNumber, o = n.carrierCode, a = n.callingCode, l = this._getCountry();
      if (r && !(!l && !a)) {
        if (l && l === this.defaultCountry) {
          var c = new zn(this.metadata.metadata);
          c.selectNumberingPlan(l);
          var d = c.numberingPlan.callingCode(), p = this.metadata.getCountryCodesForCallingCode(d);
          if (p.length > 1) {
            var f = XS(r, {
              countries: p,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            f && (l = f);
          }
        }
        var m = new HS(l || a, r, this.metadata.metadata);
        return o && (m.carrierCode = o), m;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var n = this.getNumber();
      return n ? n.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var n = this.getNumber();
      return n ? n.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), e;
}();
function YW(e) {
  return new zn(e).getCountries();
}
function kw() {
  return lp(Fz, arguments);
}
function _w() {
  return lp(zz, arguments);
}
function id(e) {
  return nT.call(this, e, NS);
}
id.prototype = Object.create(nT.prototype, {});
id.prototype.constructor = id;
function KW() {
  return lp(YW, arguments);
}
function nm() {
  return lp(dp, arguments);
}
const XW = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02z"
}), "Phone"), ZW = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "ClearOutlined"), QW = (e) => [].concat(
  ...e.map((t, n) => [t, /* @__PURE__ */ x.jsx(ys, { "aria-hidden": !0, component: "li" }, `menu-divider-${n}`)])
).slice(0, -1), JW = ({
  label: e,
  disabled: t,
  value: n,
  onChange: r,
  error: o,
  name: a,
  defaultCountry: l,
  readOnly: c = !1,
  placeholder: d = "Enter phone number (including country code)"
}) => {
  const [p, f] = Kt(l || ""), [m, g] = Kt(n || (l ? nm(l) : "")), y = Ln(
    () => KW().map((O) => ({ countryCode: O })).sort((O, k) => O.countryCode.toLowerCase().localeCompare(k.countryCode.toLowerCase())),
    []
  ), [b, v] = Kt(null), $ = !!b, S = (O) => v(O.currentTarget), R = () => v(null), P = (O) => {
    R(), f(O), g(`+${nm(O)}`);
  }, T = () => {
    g(""), f(l || ""), r("");
  };
  return nn(() => {
    if (n && _w(n)) {
      const O = kw(n);
      f(O.country || ""), g(O.formatInternational());
    }
  }, [n]), /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(Gn, { fullWidth: !0, size: "small", "data-cy-field-type": "standard-phone-number", children: [
      /* @__PURE__ */ x.jsx(ur, { id: `${a}-label`, children: e }),
      /* @__PURE__ */ x.jsx(
        di,
        {
          size: "small",
          type: "text",
          "aria-labelledby": `${a}-label`,
          value: m,
          error: !!o,
          placeholder: d,
          slotProps: {
            htmlInput: { readOnly: c },
            input: {
              startAdornment: /* @__PURE__ */ x.jsxs(Rs, { position: "start", children: [
                /* @__PURE__ */ x.jsx(
                  B3,
                  {
                    id: `${a}-standard-phone-number-country-code-selector`,
                    "aria-controls": $ ? "school-selector-menu" : void 0,
                    "aria-expanded": $ ? "true" : void 0,
                    "aria-haspopup": !0,
                    src: p ? `/images/flag-icons/flags/4x3/${p.toLowerCase()}.svg` : "",
                    sx: { width: 26, height: 26, fontSize: "16px", cursor: "pointer" },
                    onClick: S,
                    children: /* @__PURE__ */ x.jsx(XW, { sx: { fontSize: "16px" } })
                  }
                ),
                /* @__PURE__ */ x.jsx(
                  k0,
                  {
                    id: `${a}-standard-phone-number-menu`,
                    anchorEl: b,
                    open: $,
                    onClose: R,
                    MenuListProps: { "aria-labelledby": `${a}-standard-phone-number-country-code-selector` },
                    children: QW(
                      y.map((O, k) => /* @__PURE__ */ x.jsx(td, { onClick: () => P(O.countryCode), tabIndex: k, children: /* @__PURE__ */ x.jsxs(U3, { children: [
                        O.countryCode,
                        " +",
                        nm(O.countryCode)
                      ] }) }, O.countryCode))
                    )
                  }
                )
              ] }),
              endAdornment: /* @__PURE__ */ x.jsx(Vo, { onClick: T, sx: { visibility: m ? "visible" : "hidden" }, children: /* @__PURE__ */ x.jsx(ZW, {}) })
            }
          },
          disabled: t,
          onChange: (O) => {
            const k = O.target.value;
            if (!k) return T();
            const I = m === "" && !l ? `+${k}` : k, D = new id(l || void 0).input(I);
            if (_w(D)) {
              const j = kw(D), E = j.formatInternational();
              f(j.country || ""), g(E), r(E);
            } else
              g(D), f("");
          }
        }
      )
    ] }),
    o ? /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "error", children: o.message }) : /* @__PURE__ */ x.jsx("br", {})
  ] });
}, hp = ({
  name: e,
  label: t,
  disabled: n = !1,
  value: r = "",
  onChange: o,
  error: a,
  readOnly: l = !1,
  multiline: c = !1,
  rows: d = 1,
  textSuffix: p,
  fullWidth: f = !0,
  helperText: m,
  maxLength: g,
  slotProps: y,
  placeholder: b,
  maxWords: v
}) => {
  const $ = p && /* @__PURE__ */ x.jsx(Rs, { position: "end", children: /* @__PURE__ */ x.jsx(Qe, { variant: "caption", children: p }) }), S = At(
    (D) => {
      if (!D) return { remainingWords: v || 0, words: [] };
      const j = D.split(/\s+/).filter((M) => M.length !== 0);
      return { remainingWords: v && v - j.length || 0, words: j };
    },
    [v]
  ), [R, P] = Kt(S(r)), T = Ln(() => {
    if (!g) return;
    const D = r ? g - r.length : g;
    return `${D} ${D === 1 ? "character" : "characters"} remaining`;
  }, [r, g]), O = At(
    (D) => {
      if (v && o) {
        D.preventDefault();
        const j = D.clipboardData.getData("text/plain"), { remainingWords: E, words: M } = S(j);
        if (E < 0) {
          const F = M.slice(0, E).join(" ").length;
          o(j.slice(0, F)), P({ remainingWords: 0, words: M.slice(0, E) });
        } else
          o(j), P({ remainingWords: E, words: M });
      }
    },
    [o, v, S]
  ), k = At(
    (D) => {
      if (o)
        if (v) {
          const { remainingWords: j, words: E } = S(D.target.value);
          j >= 0 && (o(j === 0 ? D.target.value.trimEnd() : D.target.value), P({ remainingWords: j, words: E }));
        } else
          o(D.target.value);
    },
    [o, v, P, S]
  ), I = Ln(() => {
    var D;
    return a ? a.message ? a.message : (D = a[e]) != null && D.message ? a[e].message : "" : "";
  }, [a, e]);
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(Gn, { fullWidth: f, size: "small", children: [
      /* @__PURE__ */ x.jsx(ur, { id: `${e}-label`, disabled: n, children: t }),
      /* @__PURE__ */ x.jsx(
        di,
        {
          size: "small",
          "aria-labelledby": `${e}-label`,
          value: r,
          error: !!a,
          disabled: n,
          onPaste: O,
          onChange: k,
          slotProps: {
            ...y,
            input: { ...y == null ? void 0 : y.input, endAdornment: $ },
            htmlInput: {
              ...y == null ? void 0 : y.htmlInput,
              readOnly: l,
              ...g && { maxLength: g }
            }
          },
          multiline: c,
          rows: d,
          placeholder: b,
          helperText: m,
          "data-testid": `${e}-input`
        }
      )
    ] }),
    (g || v) && /* @__PURE__ */ x.jsxs(Qe, { pl: 1.5, variant: "caption", sx: (D) => ({ color: n ? D.palette.grey[300] : D.palette.grey[500] }), children: [
      g && T,
      v && `${R.words.length} ${R.words.length === 1 ? "word" : "words"} (max ${v})`
    ] }),
    I ? /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "error", children: I }) : /* @__PURE__ */ x.jsx(x.Fragment, {})
  ] });
}, rT = (e) => {
  try {
    const t = "àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœøṕŕßśșțùúüûǘẃẍÿź·/_,:;", n = "aaaaaaaaceeeeghiiiimnnnooooooprssstuuuuuwxyz------", r = new RegExp(t.split("").join("|"), "g");
    return e.toLowerCase().replace(/\s+/g, "-").replace(r, (o) => n.charAt(t.indexOf(o))).replace(/&/g, "-and-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
  } catch (t) {
    throw new TypeError(t);
  }
};
var yl = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var eq = yl.exports, Dw;
function tq() {
  return Dw || (Dw = 1, function(e, t) {
    (function() {
      var n, r = "4.17.21", o = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", c = "Invalid `variable` option passed into `_.template`", d = "__lodash_hash_undefined__", p = 500, f = "__lodash_placeholder__", m = 1, g = 2, y = 4, b = 1, v = 2, $ = 1, S = 2, R = 4, P = 8, T = 16, O = 32, k = 64, I = 128, D = 256, j = 512, E = 30, M = "...", F = 800, B = 16, V = 1, z = 2, L = 3, G = 1 / 0, se = 9007199254740991, ne = 17976931348623157e292, K = NaN, Q = 4294967295, ye = Q - 1, we = Q >>> 1, fe = [
        ["ary", I],
        ["bind", $],
        ["bindKey", S],
        ["curry", P],
        ["curryRight", T],
        ["flip", j],
        ["partial", O],
        ["partialRight", k],
        ["rearg", D]
      ], X = "[object Arguments]", re = "[object Array]", ie = "[object AsyncFunction]", Y = "[object Boolean]", Z = "[object Date]", ue = "[object DOMException]", ge = "[object Error]", W = "[object Function]", J = "[object GeneratorFunction]", le = "[object Map]", me = "[object Number]", be = "[object Null]", de = "[object Object]", Oe = "[object Promise]", Re = "[object Proxy]", We = "[object RegExp]", Ye = "[object Set]", Ie = "[object String]", kt = "[object Symbol]", Ee = "[object Undefined]", Ae = "[object WeakMap]", pt = "[object WeakSet]", Ue = "[object ArrayBuffer]", et = "[object DataView]", Je = "[object Float32Array]", rt = "[object Float64Array]", je = "[object Int8Array]", $t = "[object Int16Array]", Pt = "[object Int32Array]", Ft = "[object Uint8Array]", Jt = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", it = "[object Uint32Array]", bt = /\b__p \+= '';/g, gt = /\b(__p \+=) '' \+/g, Et = /(__e\(.*?\)|\b__t\)) \+\n'';/g, xn = /&(?:amp|lt|gt|quot|#39);/g, ln = /[&<>"']/g, wr = RegExp(xn.source), Yn = RegExp(ln.source), oo = /<%-([\s\S]+?)%>/g, vo = /<%([\s\S]+?)%>/g, tt = /<%=([\s\S]+?)%>/g, In = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, bo = /^\w*$/, io = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ar = /[\\^$.*+?()[\]{}|]/g, xo = RegExp(Ar.source), zo = /^\s+/, Hi = /\s/, Gi = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Yi = /\{\n\/\* \[wrapped with (.+)\] \*/, U = /,? & /, Ce = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, De = /[()=,{}\[\]\/\s]/, Ze = /\\(\\)?/g, St = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, pe = /\w*$/, ce = /^[-+]0x[0-9a-f]+$/i, Te = /^0b[01]+$/i, Ke = /^\[object .+?Constructor\]$/, Ge = /^0o[0-7]+$/i, nt = /^(?:0|[1-9]\d*)$/, _t = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, rn = /($^)/, rr = /['\n\r\u2028\u2029\\]/g, Pn = "\\ud800-\\udfff", xi = "\\u0300-\\u036f", wi = "\\ufe20-\\ufe2f", $i = "\\u20d0-\\u20ff", Mt = xi + wi + $i, $r = "\\u2700-\\u27bf", ao = "a-z\\xdf-\\xf6\\xf8-\\xff", Ki = "\\xac\\xb1\\xd7\\xf7", $p = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", _O = "\\u2000-\\u206f", DO = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $y = "A-Z\\xc0-\\xd6\\xd8-\\xde", Cy = "\\ufe0e\\ufe0f", Sy = Ki + $p + _O + DO, Cp = "['’]", IO = "[" + Pn + "]", Ty = "[" + Sy + "]", yc = "[" + Mt + "]", Oy = "\\d+", MO = "[" + $r + "]", Py = "[" + ao + "]", Ey = "[^" + Pn + Sy + Oy + $r + ao + $y + "]", Sp = "\\ud83c[\\udffb-\\udfff]", AO = "(?:" + yc + "|" + Sp + ")", Ry = "[^" + Pn + "]", Tp = "(?:\\ud83c[\\udde6-\\uddff]){2}", Op = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ra = "[" + $y + "]", ky = "\\u200d", _y = "(?:" + Py + "|" + Ey + ")", NO = "(?:" + Ra + "|" + Ey + ")", Dy = "(?:" + Cp + "(?:d|ll|m|re|s|t|ve))?", Iy = "(?:" + Cp + "(?:D|LL|M|RE|S|T|VE))?", My = AO + "?", Ay = "[" + Cy + "]?", jO = "(?:" + ky + "(?:" + [Ry, Tp, Op].join("|") + ")" + Ay + My + ")*", FO = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", LO = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Ny = Ay + My + jO, BO = "(?:" + [MO, Tp, Op].join("|") + ")" + Ny, VO = "(?:" + [Ry + yc + "?", yc, Tp, Op, IO].join("|") + ")", zO = RegExp(Cp, "g"), WO = RegExp(yc, "g"), Pp = RegExp(Sp + "(?=" + Sp + ")|" + VO + Ny, "g"), qO = RegExp([
        Ra + "?" + Py + "+" + Dy + "(?=" + [Ty, Ra, "$"].join("|") + ")",
        NO + "+" + Iy + "(?=" + [Ty, Ra + _y, "$"].join("|") + ")",
        Ra + "?" + _y + "+" + Dy,
        Ra + "+" + Iy,
        LO,
        FO,
        Oy,
        BO
      ].join("|"), "g"), UO = RegExp("[" + ky + Pn + Mt + Cy + "]"), HO = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, GO = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], YO = -1, un = {};
      un[Je] = un[rt] = un[je] = un[$t] = un[Pt] = un[Ft] = un[Jt] = un[Me] = un[it] = !0, un[X] = un[re] = un[Ue] = un[Y] = un[et] = un[Z] = un[ge] = un[W] = un[le] = un[me] = un[de] = un[We] = un[Ye] = un[Ie] = un[Ae] = !1;
      var cn = {};
      cn[X] = cn[re] = cn[Ue] = cn[et] = cn[Y] = cn[Z] = cn[Je] = cn[rt] = cn[je] = cn[$t] = cn[Pt] = cn[le] = cn[me] = cn[de] = cn[We] = cn[Ye] = cn[Ie] = cn[kt] = cn[Ft] = cn[Jt] = cn[Me] = cn[it] = !0, cn[ge] = cn[W] = cn[Ae] = !1;
      var KO = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, XO = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, ZO = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, QO = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, JO = parseFloat, eP = parseInt, jy = typeof ji == "object" && ji && ji.Object === Object && ji, tP = typeof self == "object" && self && self.Object === Object && self, Wn = jy || tP || Function("return this")(), Ep = t && !t.nodeType && t, Xi = Ep && !0 && e && !e.nodeType && e, Fy = Xi && Xi.exports === Ep, Rp = Fy && jy.process, Nr = function() {
        try {
          var te = Xi && Xi.require && Xi.require("util").types;
          return te || Rp && Rp.binding && Rp.binding("util");
        } catch {
        }
      }(), Ly = Nr && Nr.isArrayBuffer, By = Nr && Nr.isDate, Vy = Nr && Nr.isMap, zy = Nr && Nr.isRegExp, Wy = Nr && Nr.isSet, qy = Nr && Nr.isTypedArray;
      function Cr(te, xe, he) {
        switch (he.length) {
          case 0:
            return te.call(xe);
          case 1:
            return te.call(xe, he[0]);
          case 2:
            return te.call(xe, he[0], he[1]);
          case 3:
            return te.call(xe, he[0], he[1], he[2]);
        }
        return te.apply(xe, he);
      }
      function nP(te, xe, he, He) {
        for (var ft = -1, Bt = te == null ? 0 : te.length; ++ft < Bt; ) {
          var jn = te[ft];
          xe(He, jn, he(jn), te);
        }
        return He;
      }
      function jr(te, xe) {
        for (var he = -1, He = te == null ? 0 : te.length; ++he < He && xe(te[he], he, te) !== !1; )
          ;
        return te;
      }
      function rP(te, xe) {
        for (var he = te == null ? 0 : te.length; he-- && xe(te[he], he, te) !== !1; )
          ;
        return te;
      }
      function Uy(te, xe) {
        for (var he = -1, He = te == null ? 0 : te.length; ++he < He; )
          if (!xe(te[he], he, te))
            return !1;
        return !0;
      }
      function Ci(te, xe) {
        for (var he = -1, He = te == null ? 0 : te.length, ft = 0, Bt = []; ++he < He; ) {
          var jn = te[he];
          xe(jn, he, te) && (Bt[ft++] = jn);
        }
        return Bt;
      }
      function vc(te, xe) {
        var he = te == null ? 0 : te.length;
        return !!he && ka(te, xe, 0) > -1;
      }
      function kp(te, xe, he) {
        for (var He = -1, ft = te == null ? 0 : te.length; ++He < ft; )
          if (he(xe, te[He]))
            return !0;
        return !1;
      }
      function fn(te, xe) {
        for (var he = -1, He = te == null ? 0 : te.length, ft = Array(He); ++he < He; )
          ft[he] = xe(te[he], he, te);
        return ft;
      }
      function Si(te, xe) {
        for (var he = -1, He = xe.length, ft = te.length; ++he < He; )
          te[ft + he] = xe[he];
        return te;
      }
      function _p(te, xe, he, He) {
        var ft = -1, Bt = te == null ? 0 : te.length;
        for (He && Bt && (he = te[++ft]); ++ft < Bt; )
          he = xe(he, te[ft], ft, te);
        return he;
      }
      function oP(te, xe, he, He) {
        var ft = te == null ? 0 : te.length;
        for (He && ft && (he = te[--ft]); ft--; )
          he = xe(he, te[ft], ft, te);
        return he;
      }
      function Dp(te, xe) {
        for (var he = -1, He = te == null ? 0 : te.length; ++he < He; )
          if (xe(te[he], he, te))
            return !0;
        return !1;
      }
      var iP = Ip("length");
      function aP(te) {
        return te.split("");
      }
      function sP(te) {
        return te.match(Ce) || [];
      }
      function Hy(te, xe, he) {
        var He;
        return he(te, function(ft, Bt, jn) {
          if (xe(ft, Bt, jn))
            return He = Bt, !1;
        }), He;
      }
      function bc(te, xe, he, He) {
        for (var ft = te.length, Bt = he + (He ? 1 : -1); He ? Bt-- : ++Bt < ft; )
          if (xe(te[Bt], Bt, te))
            return Bt;
        return -1;
      }
      function ka(te, xe, he) {
        return xe === xe ? bP(te, xe, he) : bc(te, Gy, he);
      }
      function lP(te, xe, he, He) {
        for (var ft = he - 1, Bt = te.length; ++ft < Bt; )
          if (He(te[ft], xe))
            return ft;
        return -1;
      }
      function Gy(te) {
        return te !== te;
      }
      function Yy(te, xe) {
        var he = te == null ? 0 : te.length;
        return he ? Ap(te, xe) / he : K;
      }
      function Ip(te) {
        return function(xe) {
          return xe == null ? n : xe[te];
        };
      }
      function Mp(te) {
        return function(xe) {
          return te == null ? n : te[xe];
        };
      }
      function Ky(te, xe, he, He, ft) {
        return ft(te, function(Bt, jn, on) {
          he = He ? (He = !1, Bt) : xe(he, Bt, jn, on);
        }), he;
      }
      function cP(te, xe) {
        var he = te.length;
        for (te.sort(xe); he--; )
          te[he] = te[he].value;
        return te;
      }
      function Ap(te, xe) {
        for (var he, He = -1, ft = te.length; ++He < ft; ) {
          var Bt = xe(te[He]);
          Bt !== n && (he = he === n ? Bt : he + Bt);
        }
        return he;
      }
      function Np(te, xe) {
        for (var he = -1, He = Array(te); ++he < te; )
          He[he] = xe(he);
        return He;
      }
      function uP(te, xe) {
        return fn(xe, function(he) {
          return [he, te[he]];
        });
      }
      function Xy(te) {
        return te && te.slice(0, ev(te) + 1).replace(zo, "");
      }
      function Sr(te) {
        return function(xe) {
          return te(xe);
        };
      }
      function jp(te, xe) {
        return fn(xe, function(he) {
          return te[he];
        });
      }
      function Ms(te, xe) {
        return te.has(xe);
      }
      function Zy(te, xe) {
        for (var he = -1, He = te.length; ++he < He && ka(xe, te[he], 0) > -1; )
          ;
        return he;
      }
      function Qy(te, xe) {
        for (var he = te.length; he-- && ka(xe, te[he], 0) > -1; )
          ;
        return he;
      }
      function dP(te, xe) {
        for (var he = te.length, He = 0; he--; )
          te[he] === xe && ++He;
        return He;
      }
      var pP = Mp(KO), fP = Mp(XO);
      function hP(te) {
        return "\\" + QO[te];
      }
      function mP(te, xe) {
        return te == null ? n : te[xe];
      }
      function _a(te) {
        return UO.test(te);
      }
      function gP(te) {
        return HO.test(te);
      }
      function yP(te) {
        for (var xe, he = []; !(xe = te.next()).done; )
          he.push(xe.value);
        return he;
      }
      function Fp(te) {
        var xe = -1, he = Array(te.size);
        return te.forEach(function(He, ft) {
          he[++xe] = [ft, He];
        }), he;
      }
      function Jy(te, xe) {
        return function(he) {
          return te(xe(he));
        };
      }
      function Ti(te, xe) {
        for (var he = -1, He = te.length, ft = 0, Bt = []; ++he < He; ) {
          var jn = te[he];
          (jn === xe || jn === f) && (te[he] = f, Bt[ft++] = he);
        }
        return Bt;
      }
      function xc(te) {
        var xe = -1, he = Array(te.size);
        return te.forEach(function(He) {
          he[++xe] = He;
        }), he;
      }
      function vP(te) {
        var xe = -1, he = Array(te.size);
        return te.forEach(function(He) {
          he[++xe] = [He, He];
        }), he;
      }
      function bP(te, xe, he) {
        for (var He = he - 1, ft = te.length; ++He < ft; )
          if (te[He] === xe)
            return He;
        return -1;
      }
      function xP(te, xe, he) {
        for (var He = he + 1; He--; )
          if (te[He] === xe)
            return He;
        return He;
      }
      function Da(te) {
        return _a(te) ? $P(te) : iP(te);
      }
      function so(te) {
        return _a(te) ? CP(te) : aP(te);
      }
      function ev(te) {
        for (var xe = te.length; xe-- && Hi.test(te.charAt(xe)); )
          ;
        return xe;
      }
      var wP = Mp(ZO);
      function $P(te) {
        for (var xe = Pp.lastIndex = 0; Pp.test(te); )
          ++xe;
        return xe;
      }
      function CP(te) {
        return te.match(Pp) || [];
      }
      function SP(te) {
        return te.match(qO) || [];
      }
      var TP = function te(xe) {
        xe = xe == null ? Wn : Ia.defaults(Wn.Object(), xe, Ia.pick(Wn, GO));
        var he = xe.Array, He = xe.Date, ft = xe.Error, Bt = xe.Function, jn = xe.Math, on = xe.Object, Lp = xe.RegExp, OP = xe.String, Fr = xe.TypeError, wc = he.prototype, PP = Bt.prototype, Ma = on.prototype, $c = xe["__core-js_shared__"], Cc = PP.toString, Xt = Ma.hasOwnProperty, EP = 0, tv = function() {
          var s = /[^.]+$/.exec($c && $c.keys && $c.keys.IE_PROTO || "");
          return s ? "Symbol(src)_1." + s : "";
        }(), Sc = Ma.toString, RP = Cc.call(on), kP = Wn._, _P = Lp(
          "^" + Cc.call(Xt).replace(Ar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Tc = Fy ? xe.Buffer : n, Oi = xe.Symbol, Oc = xe.Uint8Array, nv = Tc ? Tc.allocUnsafe : n, Pc = Jy(on.getPrototypeOf, on), rv = on.create, ov = Ma.propertyIsEnumerable, Ec = wc.splice, iv = Oi ? Oi.isConcatSpreadable : n, As = Oi ? Oi.iterator : n, Zi = Oi ? Oi.toStringTag : n, Rc = function() {
          try {
            var s = na(on, "defineProperty");
            return s({}, "", {}), s;
          } catch {
          }
        }(), DP = xe.clearTimeout !== Wn.clearTimeout && xe.clearTimeout, IP = He && He.now !== Wn.Date.now && He.now, MP = xe.setTimeout !== Wn.setTimeout && xe.setTimeout, kc = jn.ceil, _c = jn.floor, Bp = on.getOwnPropertySymbols, AP = Tc ? Tc.isBuffer : n, av = xe.isFinite, NP = wc.join, jP = Jy(on.keys, on), Fn = jn.max, Kn = jn.min, FP = He.now, LP = xe.parseInt, sv = jn.random, BP = wc.reverse, Vp = na(xe, "DataView"), Ns = na(xe, "Map"), zp = na(xe, "Promise"), Aa = na(xe, "Set"), js = na(xe, "WeakMap"), Fs = na(on, "create"), Dc = js && new js(), Na = {}, VP = ra(Vp), zP = ra(Ns), WP = ra(zp), qP = ra(Aa), UP = ra(js), Ic = Oi ? Oi.prototype : n, Ls = Ic ? Ic.valueOf : n, lv = Ic ? Ic.toString : n;
        function A(s) {
          if (wn(s) && !yt(s) && !(s instanceof Rt)) {
            if (s instanceof Lr)
              return s;
            if (Xt.call(s, "__wrapped__"))
              return cb(s);
          }
          return new Lr(s);
        }
        var ja = /* @__PURE__ */ function() {
          function s() {
          }
          return function(u) {
            if (!yn(u))
              return {};
            if (rv)
              return rv(u);
            s.prototype = u;
            var h = new s();
            return s.prototype = n, h;
          };
        }();
        function Mc() {
        }
        function Lr(s, u) {
          this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!u, this.__index__ = 0, this.__values__ = n;
        }
        A.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: oo,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: vo,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: tt,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: A
          }
        }, A.prototype = Mc.prototype, A.prototype.constructor = A, Lr.prototype = ja(Mc.prototype), Lr.prototype.constructor = Lr;
        function Rt(s) {
          this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Q, this.__views__ = [];
        }
        function HP() {
          var s = new Rt(this.__wrapped__);
          return s.__actions__ = dr(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = dr(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = dr(this.__views__), s;
        }
        function GP() {
          if (this.__filtered__) {
            var s = new Rt(this);
            s.__dir__ = -1, s.__filtered__ = !0;
          } else
            s = this.clone(), s.__dir__ *= -1;
          return s;
        }
        function YP() {
          var s = this.__wrapped__.value(), u = this.__dir__, h = yt(s), C = u < 0, _ = h ? s.length : 0, N = a4(0, _, this.__views__), q = N.start, H = N.end, oe = H - q, $e = C ? H : q - 1, Se = this.__iteratees__, ke = Se.length, Ve = 0, Xe = Kn(oe, this.__takeCount__);
          if (!h || !C && _ == oe && Xe == oe)
            return Dv(s, this.__actions__);
          var ct = [];
          e:
            for (; oe-- && Ve < Xe; ) {
              $e += u;
              for (var xt = -1, ut = s[$e]; ++xt < ke; ) {
                var Tt = Se[xt], Dt = Tt.iteratee, Pr = Tt.type, ar = Dt(ut);
                if (Pr == z)
                  ut = ar;
                else if (!ar) {
                  if (Pr == V)
                    continue e;
                  break e;
                }
              }
              ct[Ve++] = ut;
            }
          return ct;
        }
        Rt.prototype = ja(Mc.prototype), Rt.prototype.constructor = Rt;
        function Qi(s) {
          var u = -1, h = s == null ? 0 : s.length;
          for (this.clear(); ++u < h; ) {
            var C = s[u];
            this.set(C[0], C[1]);
          }
        }
        function KP() {
          this.__data__ = Fs ? Fs(null) : {}, this.size = 0;
        }
        function XP(s) {
          var u = this.has(s) && delete this.__data__[s];
          return this.size -= u ? 1 : 0, u;
        }
        function ZP(s) {
          var u = this.__data__;
          if (Fs) {
            var h = u[s];
            return h === d ? n : h;
          }
          return Xt.call(u, s) ? u[s] : n;
        }
        function QP(s) {
          var u = this.__data__;
          return Fs ? u[s] !== n : Xt.call(u, s);
        }
        function JP(s, u) {
          var h = this.__data__;
          return this.size += this.has(s) ? 0 : 1, h[s] = Fs && u === n ? d : u, this;
        }
        Qi.prototype.clear = KP, Qi.prototype.delete = XP, Qi.prototype.get = ZP, Qi.prototype.has = QP, Qi.prototype.set = JP;
        function Wo(s) {
          var u = -1, h = s == null ? 0 : s.length;
          for (this.clear(); ++u < h; ) {
            var C = s[u];
            this.set(C[0], C[1]);
          }
        }
        function eE() {
          this.__data__ = [], this.size = 0;
        }
        function tE(s) {
          var u = this.__data__, h = Ac(u, s);
          if (h < 0)
            return !1;
          var C = u.length - 1;
          return h == C ? u.pop() : Ec.call(u, h, 1), --this.size, !0;
        }
        function nE(s) {
          var u = this.__data__, h = Ac(u, s);
          return h < 0 ? n : u[h][1];
        }
        function rE(s) {
          return Ac(this.__data__, s) > -1;
        }
        function oE(s, u) {
          var h = this.__data__, C = Ac(h, s);
          return C < 0 ? (++this.size, h.push([s, u])) : h[C][1] = u, this;
        }
        Wo.prototype.clear = eE, Wo.prototype.delete = tE, Wo.prototype.get = nE, Wo.prototype.has = rE, Wo.prototype.set = oE;
        function qo(s) {
          var u = -1, h = s == null ? 0 : s.length;
          for (this.clear(); ++u < h; ) {
            var C = s[u];
            this.set(C[0], C[1]);
          }
        }
        function iE() {
          this.size = 0, this.__data__ = {
            hash: new Qi(),
            map: new (Ns || Wo)(),
            string: new Qi()
          };
        }
        function aE(s) {
          var u = Gc(this, s).delete(s);
          return this.size -= u ? 1 : 0, u;
        }
        function sE(s) {
          return Gc(this, s).get(s);
        }
        function lE(s) {
          return Gc(this, s).has(s);
        }
        function cE(s, u) {
          var h = Gc(this, s), C = h.size;
          return h.set(s, u), this.size += h.size == C ? 0 : 1, this;
        }
        qo.prototype.clear = iE, qo.prototype.delete = aE, qo.prototype.get = sE, qo.prototype.has = lE, qo.prototype.set = cE;
        function Ji(s) {
          var u = -1, h = s == null ? 0 : s.length;
          for (this.__data__ = new qo(); ++u < h; )
            this.add(s[u]);
        }
        function uE(s) {
          return this.__data__.set(s, d), this;
        }
        function dE(s) {
          return this.__data__.has(s);
        }
        Ji.prototype.add = Ji.prototype.push = uE, Ji.prototype.has = dE;
        function lo(s) {
          var u = this.__data__ = new Wo(s);
          this.size = u.size;
        }
        function pE() {
          this.__data__ = new Wo(), this.size = 0;
        }
        function fE(s) {
          var u = this.__data__, h = u.delete(s);
          return this.size = u.size, h;
        }
        function hE(s) {
          return this.__data__.get(s);
        }
        function mE(s) {
          return this.__data__.has(s);
        }
        function gE(s, u) {
          var h = this.__data__;
          if (h instanceof Wo) {
            var C = h.__data__;
            if (!Ns || C.length < o - 1)
              return C.push([s, u]), this.size = ++h.size, this;
            h = this.__data__ = new qo(C);
          }
          return h.set(s, u), this.size = h.size, this;
        }
        lo.prototype.clear = pE, lo.prototype.delete = fE, lo.prototype.get = hE, lo.prototype.has = mE, lo.prototype.set = gE;
        function cv(s, u) {
          var h = yt(s), C = !h && oa(s), _ = !h && !C && _i(s), N = !h && !C && !_ && Va(s), q = h || C || _ || N, H = q ? Np(s.length, OP) : [], oe = H.length;
          for (var $e in s)
            (u || Xt.call(s, $e)) && !(q && // Safari 9 has enumerable `arguments.length` in strict mode.
            ($e == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            _ && ($e == "offset" || $e == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            N && ($e == "buffer" || $e == "byteLength" || $e == "byteOffset") || // Skip index properties.
            Yo($e, oe))) && H.push($e);
          return H;
        }
        function uv(s) {
          var u = s.length;
          return u ? s[Jp(0, u - 1)] : n;
        }
        function yE(s, u) {
          return Yc(dr(s), ea(u, 0, s.length));
        }
        function vE(s) {
          return Yc(dr(s));
        }
        function Wp(s, u, h) {
          (h !== n && !co(s[u], h) || h === n && !(u in s)) && Uo(s, u, h);
        }
        function Bs(s, u, h) {
          var C = s[u];
          (!(Xt.call(s, u) && co(C, h)) || h === n && !(u in s)) && Uo(s, u, h);
        }
        function Ac(s, u) {
          for (var h = s.length; h--; )
            if (co(s[h][0], u))
              return h;
          return -1;
        }
        function bE(s, u, h, C) {
          return Pi(s, function(_, N, q) {
            u(C, _, h(_), q);
          }), C;
        }
        function dv(s, u) {
          return s && $o(u, Bn(u), s);
        }
        function xE(s, u) {
          return s && $o(u, fr(u), s);
        }
        function Uo(s, u, h) {
          u == "__proto__" && Rc ? Rc(s, u, {
            configurable: !0,
            enumerable: !0,
            value: h,
            writable: !0
          }) : s[u] = h;
        }
        function qp(s, u) {
          for (var h = -1, C = u.length, _ = he(C), N = s == null; ++h < C; )
            _[h] = N ? n : Tf(s, u[h]);
          return _;
        }
        function ea(s, u, h) {
          return s === s && (h !== n && (s = s <= h ? s : h), u !== n && (s = s >= u ? s : u)), s;
        }
        function Br(s, u, h, C, _, N) {
          var q, H = u & m, oe = u & g, $e = u & y;
          if (h && (q = _ ? h(s, C, _, N) : h(s)), q !== n)
            return q;
          if (!yn(s))
            return s;
          var Se = yt(s);
          if (Se) {
            if (q = l4(s), !H)
              return dr(s, q);
          } else {
            var ke = Xn(s), Ve = ke == W || ke == J;
            if (_i(s))
              return Av(s, H);
            if (ke == de || ke == X || Ve && !_) {
              if (q = oe || Ve ? {} : eb(s), !H)
                return oe ? ZE(s, xE(q, s)) : XE(s, dv(q, s));
            } else {
              if (!cn[ke])
                return _ ? s : {};
              q = c4(s, ke, H);
            }
          }
          N || (N = new lo());
          var Xe = N.get(s);
          if (Xe)
            return Xe;
          N.set(s, q), Rb(s) ? s.forEach(function(ut) {
            q.add(Br(ut, u, h, ut, s, N));
          }) : Pb(s) && s.forEach(function(ut, Tt) {
            q.set(Tt, Br(ut, u, h, Tt, s, N));
          });
          var ct = $e ? oe ? df : uf : oe ? fr : Bn, xt = Se ? n : ct(s);
          return jr(xt || s, function(ut, Tt) {
            xt && (Tt = ut, ut = s[Tt]), Bs(q, Tt, Br(ut, u, h, Tt, s, N));
          }), q;
        }
        function wE(s) {
          var u = Bn(s);
          return function(h) {
            return pv(h, s, u);
          };
        }
        function pv(s, u, h) {
          var C = h.length;
          if (s == null)
            return !C;
          for (s = on(s); C--; ) {
            var _ = h[C], N = u[_], q = s[_];
            if (q === n && !(_ in s) || !N(q))
              return !1;
          }
          return !0;
        }
        function fv(s, u, h) {
          if (typeof s != "function")
            throw new Fr(l);
          return Gs(function() {
            s.apply(n, h);
          }, u);
        }
        function Vs(s, u, h, C) {
          var _ = -1, N = vc, q = !0, H = s.length, oe = [], $e = u.length;
          if (!H)
            return oe;
          h && (u = fn(u, Sr(h))), C ? (N = kp, q = !1) : u.length >= o && (N = Ms, q = !1, u = new Ji(u));
          e:
            for (; ++_ < H; ) {
              var Se = s[_], ke = h == null ? Se : h(Se);
              if (Se = C || Se !== 0 ? Se : 0, q && ke === ke) {
                for (var Ve = $e; Ve--; )
                  if (u[Ve] === ke)
                    continue e;
                oe.push(Se);
              } else N(u, ke, C) || oe.push(Se);
            }
          return oe;
        }
        var Pi = Bv(wo), hv = Bv(Hp, !0);
        function $E(s, u) {
          var h = !0;
          return Pi(s, function(C, _, N) {
            return h = !!u(C, _, N), h;
          }), h;
        }
        function Nc(s, u, h) {
          for (var C = -1, _ = s.length; ++C < _; ) {
            var N = s[C], q = u(N);
            if (q != null && (H === n ? q === q && !Or(q) : h(q, H)))
              var H = q, oe = N;
          }
          return oe;
        }
        function CE(s, u, h, C) {
          var _ = s.length;
          for (h = vt(h), h < 0 && (h = -h > _ ? 0 : _ + h), C = C === n || C > _ ? _ : vt(C), C < 0 && (C += _), C = h > C ? 0 : _b(C); h < C; )
            s[h++] = u;
          return s;
        }
        function mv(s, u) {
          var h = [];
          return Pi(s, function(C, _, N) {
            u(C, _, N) && h.push(C);
          }), h;
        }
        function qn(s, u, h, C, _) {
          var N = -1, q = s.length;
          for (h || (h = d4), _ || (_ = []); ++N < q; ) {
            var H = s[N];
            u > 0 && h(H) ? u > 1 ? qn(H, u - 1, h, C, _) : Si(_, H) : C || (_[_.length] = H);
          }
          return _;
        }
        var Up = Vv(), gv = Vv(!0);
        function wo(s, u) {
          return s && Up(s, u, Bn);
        }
        function Hp(s, u) {
          return s && gv(s, u, Bn);
        }
        function jc(s, u) {
          return Ci(u, function(h) {
            return Ko(s[h]);
          });
        }
        function ta(s, u) {
          u = Ri(u, s);
          for (var h = 0, C = u.length; s != null && h < C; )
            s = s[Co(u[h++])];
          return h && h == C ? s : n;
        }
        function yv(s, u, h) {
          var C = u(s);
          return yt(s) ? C : Si(C, h(s));
        }
        function or(s) {
          return s == null ? s === n ? Ee : be : Zi && Zi in on(s) ? i4(s) : v4(s);
        }
        function Gp(s, u) {
          return s > u;
        }
        function SE(s, u) {
          return s != null && Xt.call(s, u);
        }
        function TE(s, u) {
          return s != null && u in on(s);
        }
        function OE(s, u, h) {
          return s >= Kn(u, h) && s < Fn(u, h);
        }
        function Yp(s, u, h) {
          for (var C = h ? kp : vc, _ = s[0].length, N = s.length, q = N, H = he(N), oe = 1 / 0, $e = []; q--; ) {
            var Se = s[q];
            q && u && (Se = fn(Se, Sr(u))), oe = Kn(Se.length, oe), H[q] = !h && (u || _ >= 120 && Se.length >= 120) ? new Ji(q && Se) : n;
          }
          Se = s[0];
          var ke = -1, Ve = H[0];
          e:
            for (; ++ke < _ && $e.length < oe; ) {
              var Xe = Se[ke], ct = u ? u(Xe) : Xe;
              if (Xe = h || Xe !== 0 ? Xe : 0, !(Ve ? Ms(Ve, ct) : C($e, ct, h))) {
                for (q = N; --q; ) {
                  var xt = H[q];
                  if (!(xt ? Ms(xt, ct) : C(s[q], ct, h)))
                    continue e;
                }
                Ve && Ve.push(ct), $e.push(Xe);
              }
            }
          return $e;
        }
        function PE(s, u, h, C) {
          return wo(s, function(_, N, q) {
            u(C, h(_), N, q);
          }), C;
        }
        function zs(s, u, h) {
          u = Ri(u, s), s = ob(s, u);
          var C = s == null ? s : s[Co(zr(u))];
          return C == null ? n : Cr(C, s, h);
        }
        function vv(s) {
          return wn(s) && or(s) == X;
        }
        function EE(s) {
          return wn(s) && or(s) == Ue;
        }
        function RE(s) {
          return wn(s) && or(s) == Z;
        }
        function Ws(s, u, h, C, _) {
          return s === u ? !0 : s == null || u == null || !wn(s) && !wn(u) ? s !== s && u !== u : kE(s, u, h, C, Ws, _);
        }
        function kE(s, u, h, C, _, N) {
          var q = yt(s), H = yt(u), oe = q ? re : Xn(s), $e = H ? re : Xn(u);
          oe = oe == X ? de : oe, $e = $e == X ? de : $e;
          var Se = oe == de, ke = $e == de, Ve = oe == $e;
          if (Ve && _i(s)) {
            if (!_i(u))
              return !1;
            q = !0, Se = !1;
          }
          if (Ve && !Se)
            return N || (N = new lo()), q || Va(s) ? Zv(s, u, h, C, _, N) : r4(s, u, oe, h, C, _, N);
          if (!(h & b)) {
            var Xe = Se && Xt.call(s, "__wrapped__"), ct = ke && Xt.call(u, "__wrapped__");
            if (Xe || ct) {
              var xt = Xe ? s.value() : s, ut = ct ? u.value() : u;
              return N || (N = new lo()), _(xt, ut, h, C, N);
            }
          }
          return Ve ? (N || (N = new lo()), o4(s, u, h, C, _, N)) : !1;
        }
        function _E(s) {
          return wn(s) && Xn(s) == le;
        }
        function Kp(s, u, h, C) {
          var _ = h.length, N = _, q = !C;
          if (s == null)
            return !N;
          for (s = on(s); _--; ) {
            var H = h[_];
            if (q && H[2] ? H[1] !== s[H[0]] : !(H[0] in s))
              return !1;
          }
          for (; ++_ < N; ) {
            H = h[_];
            var oe = H[0], $e = s[oe], Se = H[1];
            if (q && H[2]) {
              if ($e === n && !(oe in s))
                return !1;
            } else {
              var ke = new lo();
              if (C)
                var Ve = C($e, Se, oe, s, u, ke);
              if (!(Ve === n ? Ws(Se, $e, b | v, C, ke) : Ve))
                return !1;
            }
          }
          return !0;
        }
        function bv(s) {
          if (!yn(s) || f4(s))
            return !1;
          var u = Ko(s) ? _P : Ke;
          return u.test(ra(s));
        }
        function DE(s) {
          return wn(s) && or(s) == We;
        }
        function IE(s) {
          return wn(s) && Xn(s) == Ye;
        }
        function ME(s) {
          return wn(s) && eu(s.length) && !!un[or(s)];
        }
        function xv(s) {
          return typeof s == "function" ? s : s == null ? hr : typeof s == "object" ? yt(s) ? Cv(s[0], s[1]) : $v(s) : zb(s);
        }
        function Xp(s) {
          if (!Hs(s))
            return jP(s);
          var u = [];
          for (var h in on(s))
            Xt.call(s, h) && h != "constructor" && u.push(h);
          return u;
        }
        function AE(s) {
          if (!yn(s))
            return y4(s);
          var u = Hs(s), h = [];
          for (var C in s)
            C == "constructor" && (u || !Xt.call(s, C)) || h.push(C);
          return h;
        }
        function Zp(s, u) {
          return s < u;
        }
        function wv(s, u) {
          var h = -1, C = pr(s) ? he(s.length) : [];
          return Pi(s, function(_, N, q) {
            C[++h] = u(_, N, q);
          }), C;
        }
        function $v(s) {
          var u = ff(s);
          return u.length == 1 && u[0][2] ? nb(u[0][0], u[0][1]) : function(h) {
            return h === s || Kp(h, s, u);
          };
        }
        function Cv(s, u) {
          return mf(s) && tb(u) ? nb(Co(s), u) : function(h) {
            var C = Tf(h, s);
            return C === n && C === u ? Of(h, s) : Ws(u, C, b | v);
          };
        }
        function Fc(s, u, h, C, _) {
          s !== u && Up(u, function(N, q) {
            if (_ || (_ = new lo()), yn(N))
              NE(s, u, q, h, Fc, C, _);
            else {
              var H = C ? C(yf(s, q), N, q + "", s, u, _) : n;
              H === n && (H = N), Wp(s, q, H);
            }
          }, fr);
        }
        function NE(s, u, h, C, _, N, q) {
          var H = yf(s, h), oe = yf(u, h), $e = q.get(oe);
          if ($e) {
            Wp(s, h, $e);
            return;
          }
          var Se = N ? N(H, oe, h + "", s, u, q) : n, ke = Se === n;
          if (ke) {
            var Ve = yt(oe), Xe = !Ve && _i(oe), ct = !Ve && !Xe && Va(oe);
            Se = oe, Ve || Xe || ct ? yt(H) ? Se = H : En(H) ? Se = dr(H) : Xe ? (ke = !1, Se = Av(oe, !0)) : ct ? (ke = !1, Se = Nv(oe, !0)) : Se = [] : Ys(oe) || oa(oe) ? (Se = H, oa(H) ? Se = Db(H) : (!yn(H) || Ko(H)) && (Se = eb(oe))) : ke = !1;
          }
          ke && (q.set(oe, Se), _(Se, oe, C, N, q), q.delete(oe)), Wp(s, h, Se);
        }
        function Sv(s, u) {
          var h = s.length;
          if (h)
            return u += u < 0 ? h : 0, Yo(u, h) ? s[u] : n;
        }
        function Tv(s, u, h) {
          u.length ? u = fn(u, function(N) {
            return yt(N) ? function(q) {
              return ta(q, N.length === 1 ? N[0] : N);
            } : N;
          }) : u = [hr];
          var C = -1;
          u = fn(u, Sr(st()));
          var _ = wv(s, function(N, q, H) {
            var oe = fn(u, function($e) {
              return $e(N);
            });
            return { criteria: oe, index: ++C, value: N };
          });
          return cP(_, function(N, q) {
            return KE(N, q, h);
          });
        }
        function jE(s, u) {
          return Ov(s, u, function(h, C) {
            return Of(s, C);
          });
        }
        function Ov(s, u, h) {
          for (var C = -1, _ = u.length, N = {}; ++C < _; ) {
            var q = u[C], H = ta(s, q);
            h(H, q) && qs(N, Ri(q, s), H);
          }
          return N;
        }
        function FE(s) {
          return function(u) {
            return ta(u, s);
          };
        }
        function Qp(s, u, h, C) {
          var _ = C ? lP : ka, N = -1, q = u.length, H = s;
          for (s === u && (u = dr(u)), h && (H = fn(s, Sr(h))); ++N < q; )
            for (var oe = 0, $e = u[N], Se = h ? h($e) : $e; (oe = _(H, Se, oe, C)) > -1; )
              H !== s && Ec.call(H, oe, 1), Ec.call(s, oe, 1);
          return s;
        }
        function Pv(s, u) {
          for (var h = s ? u.length : 0, C = h - 1; h--; ) {
            var _ = u[h];
            if (h == C || _ !== N) {
              var N = _;
              Yo(_) ? Ec.call(s, _, 1) : nf(s, _);
            }
          }
          return s;
        }
        function Jp(s, u) {
          return s + _c(sv() * (u - s + 1));
        }
        function LE(s, u, h, C) {
          for (var _ = -1, N = Fn(kc((u - s) / (h || 1)), 0), q = he(N); N--; )
            q[C ? N : ++_] = s, s += h;
          return q;
        }
        function ef(s, u) {
          var h = "";
          if (!s || u < 1 || u > se)
            return h;
          do
            u % 2 && (h += s), u = _c(u / 2), u && (s += s);
          while (u);
          return h;
        }
        function Ct(s, u) {
          return vf(rb(s, u, hr), s + "");
        }
        function BE(s) {
          return uv(za(s));
        }
        function VE(s, u) {
          var h = za(s);
          return Yc(h, ea(u, 0, h.length));
        }
        function qs(s, u, h, C) {
          if (!yn(s))
            return s;
          u = Ri(u, s);
          for (var _ = -1, N = u.length, q = N - 1, H = s; H != null && ++_ < N; ) {
            var oe = Co(u[_]), $e = h;
            if (oe === "__proto__" || oe === "constructor" || oe === "prototype")
              return s;
            if (_ != q) {
              var Se = H[oe];
              $e = C ? C(Se, oe, H) : n, $e === n && ($e = yn(Se) ? Se : Yo(u[_ + 1]) ? [] : {});
            }
            Bs(H, oe, $e), H = H[oe];
          }
          return s;
        }
        var Ev = Dc ? function(s, u) {
          return Dc.set(s, u), s;
        } : hr, zE = Rc ? function(s, u) {
          return Rc(s, "toString", {
            configurable: !0,
            enumerable: !1,
            value: Ef(u),
            writable: !0
          });
        } : hr;
        function WE(s) {
          return Yc(za(s));
        }
        function Vr(s, u, h) {
          var C = -1, _ = s.length;
          u < 0 && (u = -u > _ ? 0 : _ + u), h = h > _ ? _ : h, h < 0 && (h += _), _ = u > h ? 0 : h - u >>> 0, u >>>= 0;
          for (var N = he(_); ++C < _; )
            N[C] = s[C + u];
          return N;
        }
        function qE(s, u) {
          var h;
          return Pi(s, function(C, _, N) {
            return h = u(C, _, N), !h;
          }), !!h;
        }
        function Lc(s, u, h) {
          var C = 0, _ = s == null ? C : s.length;
          if (typeof u == "number" && u === u && _ <= we) {
            for (; C < _; ) {
              var N = C + _ >>> 1, q = s[N];
              q !== null && !Or(q) && (h ? q <= u : q < u) ? C = N + 1 : _ = N;
            }
            return _;
          }
          return tf(s, u, hr, h);
        }
        function tf(s, u, h, C) {
          var _ = 0, N = s == null ? 0 : s.length;
          if (N === 0)
            return 0;
          u = h(u);
          for (var q = u !== u, H = u === null, oe = Or(u), $e = u === n; _ < N; ) {
            var Se = _c((_ + N) / 2), ke = h(s[Se]), Ve = ke !== n, Xe = ke === null, ct = ke === ke, xt = Or(ke);
            if (q)
              var ut = C || ct;
            else $e ? ut = ct && (C || Ve) : H ? ut = ct && Ve && (C || !Xe) : oe ? ut = ct && Ve && !Xe && (C || !xt) : Xe || xt ? ut = !1 : ut = C ? ke <= u : ke < u;
            ut ? _ = Se + 1 : N = Se;
          }
          return Kn(N, ye);
        }
        function Rv(s, u) {
          for (var h = -1, C = s.length, _ = 0, N = []; ++h < C; ) {
            var q = s[h], H = u ? u(q) : q;
            if (!h || !co(H, oe)) {
              var oe = H;
              N[_++] = q === 0 ? 0 : q;
            }
          }
          return N;
        }
        function kv(s) {
          return typeof s == "number" ? s : Or(s) ? K : +s;
        }
        function Tr(s) {
          if (typeof s == "string")
            return s;
          if (yt(s))
            return fn(s, Tr) + "";
          if (Or(s))
            return lv ? lv.call(s) : "";
          var u = s + "";
          return u == "0" && 1 / s == -1 / 0 ? "-0" : u;
        }
        function Ei(s, u, h) {
          var C = -1, _ = vc, N = s.length, q = !0, H = [], oe = H;
          if (h)
            q = !1, _ = kp;
          else if (N >= o) {
            var $e = u ? null : t4(s);
            if ($e)
              return xc($e);
            q = !1, _ = Ms, oe = new Ji();
          } else
            oe = u ? [] : H;
          e:
            for (; ++C < N; ) {
              var Se = s[C], ke = u ? u(Se) : Se;
              if (Se = h || Se !== 0 ? Se : 0, q && ke === ke) {
                for (var Ve = oe.length; Ve--; )
                  if (oe[Ve] === ke)
                    continue e;
                u && oe.push(ke), H.push(Se);
              } else _(oe, ke, h) || (oe !== H && oe.push(ke), H.push(Se));
            }
          return H;
        }
        function nf(s, u) {
          return u = Ri(u, s), s = ob(s, u), s == null || delete s[Co(zr(u))];
        }
        function _v(s, u, h, C) {
          return qs(s, u, h(ta(s, u)), C);
        }
        function Bc(s, u, h, C) {
          for (var _ = s.length, N = C ? _ : -1; (C ? N-- : ++N < _) && u(s[N], N, s); )
            ;
          return h ? Vr(s, C ? 0 : N, C ? N + 1 : _) : Vr(s, C ? N + 1 : 0, C ? _ : N);
        }
        function Dv(s, u) {
          var h = s;
          return h instanceof Rt && (h = h.value()), _p(u, function(C, _) {
            return _.func.apply(_.thisArg, Si([C], _.args));
          }, h);
        }
        function rf(s, u, h) {
          var C = s.length;
          if (C < 2)
            return C ? Ei(s[0]) : [];
          for (var _ = -1, N = he(C); ++_ < C; )
            for (var q = s[_], H = -1; ++H < C; )
              H != _ && (N[_] = Vs(N[_] || q, s[H], u, h));
          return Ei(qn(N, 1), u, h);
        }
        function Iv(s, u, h) {
          for (var C = -1, _ = s.length, N = u.length, q = {}; ++C < _; ) {
            var H = C < N ? u[C] : n;
            h(q, s[C], H);
          }
          return q;
        }
        function of(s) {
          return En(s) ? s : [];
        }
        function af(s) {
          return typeof s == "function" ? s : hr;
        }
        function Ri(s, u) {
          return yt(s) ? s : mf(s, u) ? [s] : lb(qt(s));
        }
        var UE = Ct;
        function ki(s, u, h) {
          var C = s.length;
          return h = h === n ? C : h, !u && h >= C ? s : Vr(s, u, h);
        }
        var Mv = DP || function(s) {
          return Wn.clearTimeout(s);
        };
        function Av(s, u) {
          if (u)
            return s.slice();
          var h = s.length, C = nv ? nv(h) : new s.constructor(h);
          return s.copy(C), C;
        }
        function sf(s) {
          var u = new s.constructor(s.byteLength);
          return new Oc(u).set(new Oc(s)), u;
        }
        function HE(s, u) {
          var h = u ? sf(s.buffer) : s.buffer;
          return new s.constructor(h, s.byteOffset, s.byteLength);
        }
        function GE(s) {
          var u = new s.constructor(s.source, pe.exec(s));
          return u.lastIndex = s.lastIndex, u;
        }
        function YE(s) {
          return Ls ? on(Ls.call(s)) : {};
        }
        function Nv(s, u) {
          var h = u ? sf(s.buffer) : s.buffer;
          return new s.constructor(h, s.byteOffset, s.length);
        }
        function jv(s, u) {
          if (s !== u) {
            var h = s !== n, C = s === null, _ = s === s, N = Or(s), q = u !== n, H = u === null, oe = u === u, $e = Or(u);
            if (!H && !$e && !N && s > u || N && q && oe && !H && !$e || C && q && oe || !h && oe || !_)
              return 1;
            if (!C && !N && !$e && s < u || $e && h && _ && !C && !N || H && h && _ || !q && _ || !oe)
              return -1;
          }
          return 0;
        }
        function KE(s, u, h) {
          for (var C = -1, _ = s.criteria, N = u.criteria, q = _.length, H = h.length; ++C < q; ) {
            var oe = jv(_[C], N[C]);
            if (oe) {
              if (C >= H)
                return oe;
              var $e = h[C];
              return oe * ($e == "desc" ? -1 : 1);
            }
          }
          return s.index - u.index;
        }
        function Fv(s, u, h, C) {
          for (var _ = -1, N = s.length, q = h.length, H = -1, oe = u.length, $e = Fn(N - q, 0), Se = he(oe + $e), ke = !C; ++H < oe; )
            Se[H] = u[H];
          for (; ++_ < q; )
            (ke || _ < N) && (Se[h[_]] = s[_]);
          for (; $e--; )
            Se[H++] = s[_++];
          return Se;
        }
        function Lv(s, u, h, C) {
          for (var _ = -1, N = s.length, q = -1, H = h.length, oe = -1, $e = u.length, Se = Fn(N - H, 0), ke = he(Se + $e), Ve = !C; ++_ < Se; )
            ke[_] = s[_];
          for (var Xe = _; ++oe < $e; )
            ke[Xe + oe] = u[oe];
          for (; ++q < H; )
            (Ve || _ < N) && (ke[Xe + h[q]] = s[_++]);
          return ke;
        }
        function dr(s, u) {
          var h = -1, C = s.length;
          for (u || (u = he(C)); ++h < C; )
            u[h] = s[h];
          return u;
        }
        function $o(s, u, h, C) {
          var _ = !h;
          h || (h = {});
          for (var N = -1, q = u.length; ++N < q; ) {
            var H = u[N], oe = C ? C(h[H], s[H], H, h, s) : n;
            oe === n && (oe = s[H]), _ ? Uo(h, H, oe) : Bs(h, H, oe);
          }
          return h;
        }
        function XE(s, u) {
          return $o(s, hf(s), u);
        }
        function ZE(s, u) {
          return $o(s, Qv(s), u);
        }
        function Vc(s, u) {
          return function(h, C) {
            var _ = yt(h) ? nP : bE, N = u ? u() : {};
            return _(h, s, st(C, 2), N);
          };
        }
        function Fa(s) {
          return Ct(function(u, h) {
            var C = -1, _ = h.length, N = _ > 1 ? h[_ - 1] : n, q = _ > 2 ? h[2] : n;
            for (N = s.length > 3 && typeof N == "function" ? (_--, N) : n, q && ir(h[0], h[1], q) && (N = _ < 3 ? n : N, _ = 1), u = on(u); ++C < _; ) {
              var H = h[C];
              H && s(u, H, C, N);
            }
            return u;
          });
        }
        function Bv(s, u) {
          return function(h, C) {
            if (h == null)
              return h;
            if (!pr(h))
              return s(h, C);
            for (var _ = h.length, N = u ? _ : -1, q = on(h); (u ? N-- : ++N < _) && C(q[N], N, q) !== !1; )
              ;
            return h;
          };
        }
        function Vv(s) {
          return function(u, h, C) {
            for (var _ = -1, N = on(u), q = C(u), H = q.length; H--; ) {
              var oe = q[s ? H : ++_];
              if (h(N[oe], oe, N) === !1)
                break;
            }
            return u;
          };
        }
        function QE(s, u, h) {
          var C = u & $, _ = Us(s);
          function N() {
            var q = this && this !== Wn && this instanceof N ? _ : s;
            return q.apply(C ? h : this, arguments);
          }
          return N;
        }
        function zv(s) {
          return function(u) {
            u = qt(u);
            var h = _a(u) ? so(u) : n, C = h ? h[0] : u.charAt(0), _ = h ? ki(h, 1).join("") : u.slice(1);
            return C[s]() + _;
          };
        }
        function La(s) {
          return function(u) {
            return _p(Bb(Lb(u).replace(zO, "")), s, "");
          };
        }
        function Us(s) {
          return function() {
            var u = arguments;
            switch (u.length) {
              case 0:
                return new s();
              case 1:
                return new s(u[0]);
              case 2:
                return new s(u[0], u[1]);
              case 3:
                return new s(u[0], u[1], u[2]);
              case 4:
                return new s(u[0], u[1], u[2], u[3]);
              case 5:
                return new s(u[0], u[1], u[2], u[3], u[4]);
              case 6:
                return new s(u[0], u[1], u[2], u[3], u[4], u[5]);
              case 7:
                return new s(u[0], u[1], u[2], u[3], u[4], u[5], u[6]);
            }
            var h = ja(s.prototype), C = s.apply(h, u);
            return yn(C) ? C : h;
          };
        }
        function JE(s, u, h) {
          var C = Us(s);
          function _() {
            for (var N = arguments.length, q = he(N), H = N, oe = Ba(_); H--; )
              q[H] = arguments[H];
            var $e = N < 3 && q[0] !== oe && q[N - 1] !== oe ? [] : Ti(q, oe);
            if (N -= $e.length, N < h)
              return Gv(
                s,
                u,
                zc,
                _.placeholder,
                n,
                q,
                $e,
                n,
                n,
                h - N
              );
            var Se = this && this !== Wn && this instanceof _ ? C : s;
            return Cr(Se, this, q);
          }
          return _;
        }
        function Wv(s) {
          return function(u, h, C) {
            var _ = on(u);
            if (!pr(u)) {
              var N = st(h, 3);
              u = Bn(u), h = function(H) {
                return N(_[H], H, _);
              };
            }
            var q = s(u, h, C);
            return q > -1 ? _[N ? u[q] : q] : n;
          };
        }
        function qv(s) {
          return Go(function(u) {
            var h = u.length, C = h, _ = Lr.prototype.thru;
            for (s && u.reverse(); C--; ) {
              var N = u[C];
              if (typeof N != "function")
                throw new Fr(l);
              if (_ && !q && Hc(N) == "wrapper")
                var q = new Lr([], !0);
            }
            for (C = q ? C : h; ++C < h; ) {
              N = u[C];
              var H = Hc(N), oe = H == "wrapper" ? pf(N) : n;
              oe && gf(oe[0]) && oe[1] == (I | P | O | D) && !oe[4].length && oe[9] == 1 ? q = q[Hc(oe[0])].apply(q, oe[3]) : q = N.length == 1 && gf(N) ? q[H]() : q.thru(N);
            }
            return function() {
              var $e = arguments, Se = $e[0];
              if (q && $e.length == 1 && yt(Se))
                return q.plant(Se).value();
              for (var ke = 0, Ve = h ? u[ke].apply(this, $e) : Se; ++ke < h; )
                Ve = u[ke].call(this, Ve);
              return Ve;
            };
          });
        }
        function zc(s, u, h, C, _, N, q, H, oe, $e) {
          var Se = u & I, ke = u & $, Ve = u & S, Xe = u & (P | T), ct = u & j, xt = Ve ? n : Us(s);
          function ut() {
            for (var Tt = arguments.length, Dt = he(Tt), Pr = Tt; Pr--; )
              Dt[Pr] = arguments[Pr];
            if (Xe)
              var ar = Ba(ut), Er = dP(Dt, ar);
            if (C && (Dt = Fv(Dt, C, _, Xe)), N && (Dt = Lv(Dt, N, q, Xe)), Tt -= Er, Xe && Tt < $e) {
              var Rn = Ti(Dt, ar);
              return Gv(
                s,
                u,
                zc,
                ut.placeholder,
                h,
                Dt,
                Rn,
                H,
                oe,
                $e - Tt
              );
            }
            var uo = ke ? h : this, Zo = Ve ? uo[s] : s;
            return Tt = Dt.length, H ? Dt = b4(Dt, H) : ct && Tt > 1 && Dt.reverse(), Se && oe < Tt && (Dt.length = oe), this && this !== Wn && this instanceof ut && (Zo = xt || Us(Zo)), Zo.apply(uo, Dt);
          }
          return ut;
        }
        function Uv(s, u) {
          return function(h, C) {
            return PE(h, s, u(C), {});
          };
        }
        function Wc(s, u) {
          return function(h, C) {
            var _;
            if (h === n && C === n)
              return u;
            if (h !== n && (_ = h), C !== n) {
              if (_ === n)
                return C;
              typeof h == "string" || typeof C == "string" ? (h = Tr(h), C = Tr(C)) : (h = kv(h), C = kv(C)), _ = s(h, C);
            }
            return _;
          };
        }
        function lf(s) {
          return Go(function(u) {
            return u = fn(u, Sr(st())), Ct(function(h) {
              var C = this;
              return s(u, function(_) {
                return Cr(_, C, h);
              });
            });
          });
        }
        function qc(s, u) {
          u = u === n ? " " : Tr(u);
          var h = u.length;
          if (h < 2)
            return h ? ef(u, s) : u;
          var C = ef(u, kc(s / Da(u)));
          return _a(u) ? ki(so(C), 0, s).join("") : C.slice(0, s);
        }
        function e4(s, u, h, C) {
          var _ = u & $, N = Us(s);
          function q() {
            for (var H = -1, oe = arguments.length, $e = -1, Se = C.length, ke = he(Se + oe), Ve = this && this !== Wn && this instanceof q ? N : s; ++$e < Se; )
              ke[$e] = C[$e];
            for (; oe--; )
              ke[$e++] = arguments[++H];
            return Cr(Ve, _ ? h : this, ke);
          }
          return q;
        }
        function Hv(s) {
          return function(u, h, C) {
            return C && typeof C != "number" && ir(u, h, C) && (h = C = n), u = Xo(u), h === n ? (h = u, u = 0) : h = Xo(h), C = C === n ? u < h ? 1 : -1 : Xo(C), LE(u, h, C, s);
          };
        }
        function Uc(s) {
          return function(u, h) {
            return typeof u == "string" && typeof h == "string" || (u = Wr(u), h = Wr(h)), s(u, h);
          };
        }
        function Gv(s, u, h, C, _, N, q, H, oe, $e) {
          var Se = u & P, ke = Se ? q : n, Ve = Se ? n : q, Xe = Se ? N : n, ct = Se ? n : N;
          u |= Se ? O : k, u &= ~(Se ? k : O), u & R || (u &= -4);
          var xt = [
            s,
            u,
            _,
            Xe,
            ke,
            ct,
            Ve,
            H,
            oe,
            $e
          ], ut = h.apply(n, xt);
          return gf(s) && ib(ut, xt), ut.placeholder = C, ab(ut, s, u);
        }
        function cf(s) {
          var u = jn[s];
          return function(h, C) {
            if (h = Wr(h), C = C == null ? 0 : Kn(vt(C), 292), C && av(h)) {
              var _ = (qt(h) + "e").split("e"), N = u(_[0] + "e" + (+_[1] + C));
              return _ = (qt(N) + "e").split("e"), +(_[0] + "e" + (+_[1] - C));
            }
            return u(h);
          };
        }
        var t4 = Aa && 1 / xc(new Aa([, -0]))[1] == G ? function(s) {
          return new Aa(s);
        } : _f;
        function Yv(s) {
          return function(u) {
            var h = Xn(u);
            return h == le ? Fp(u) : h == Ye ? vP(u) : uP(u, s(u));
          };
        }
        function Ho(s, u, h, C, _, N, q, H) {
          var oe = u & S;
          if (!oe && typeof s != "function")
            throw new Fr(l);
          var $e = C ? C.length : 0;
          if ($e || (u &= -97, C = _ = n), q = q === n ? q : Fn(vt(q), 0), H = H === n ? H : vt(H), $e -= _ ? _.length : 0, u & k) {
            var Se = C, ke = _;
            C = _ = n;
          }
          var Ve = oe ? n : pf(s), Xe = [
            s,
            u,
            h,
            C,
            _,
            Se,
            ke,
            N,
            q,
            H
          ];
          if (Ve && g4(Xe, Ve), s = Xe[0], u = Xe[1], h = Xe[2], C = Xe[3], _ = Xe[4], H = Xe[9] = Xe[9] === n ? oe ? 0 : s.length : Fn(Xe[9] - $e, 0), !H && u & (P | T) && (u &= -25), !u || u == $)
            var ct = QE(s, u, h);
          else u == P || u == T ? ct = JE(s, u, H) : (u == O || u == ($ | O)) && !_.length ? ct = e4(s, u, h, C) : ct = zc.apply(n, Xe);
          var xt = Ve ? Ev : ib;
          return ab(xt(ct, Xe), s, u);
        }
        function Kv(s, u, h, C) {
          return s === n || co(s, Ma[h]) && !Xt.call(C, h) ? u : s;
        }
        function Xv(s, u, h, C, _, N) {
          return yn(s) && yn(u) && (N.set(u, s), Fc(s, u, n, Xv, N), N.delete(u)), s;
        }
        function n4(s) {
          return Ys(s) ? n : s;
        }
        function Zv(s, u, h, C, _, N) {
          var q = h & b, H = s.length, oe = u.length;
          if (H != oe && !(q && oe > H))
            return !1;
          var $e = N.get(s), Se = N.get(u);
          if ($e && Se)
            return $e == u && Se == s;
          var ke = -1, Ve = !0, Xe = h & v ? new Ji() : n;
          for (N.set(s, u), N.set(u, s); ++ke < H; ) {
            var ct = s[ke], xt = u[ke];
            if (C)
              var ut = q ? C(xt, ct, ke, u, s, N) : C(ct, xt, ke, s, u, N);
            if (ut !== n) {
              if (ut)
                continue;
              Ve = !1;
              break;
            }
            if (Xe) {
              if (!Dp(u, function(Tt, Dt) {
                if (!Ms(Xe, Dt) && (ct === Tt || _(ct, Tt, h, C, N)))
                  return Xe.push(Dt);
              })) {
                Ve = !1;
                break;
              }
            } else if (!(ct === xt || _(ct, xt, h, C, N))) {
              Ve = !1;
              break;
            }
          }
          return N.delete(s), N.delete(u), Ve;
        }
        function r4(s, u, h, C, _, N, q) {
          switch (h) {
            case et:
              if (s.byteLength != u.byteLength || s.byteOffset != u.byteOffset)
                return !1;
              s = s.buffer, u = u.buffer;
            case Ue:
              return !(s.byteLength != u.byteLength || !N(new Oc(s), new Oc(u)));
            case Y:
            case Z:
            case me:
              return co(+s, +u);
            case ge:
              return s.name == u.name && s.message == u.message;
            case We:
            case Ie:
              return s == u + "";
            case le:
              var H = Fp;
            case Ye:
              var oe = C & b;
              if (H || (H = xc), s.size != u.size && !oe)
                return !1;
              var $e = q.get(s);
              if ($e)
                return $e == u;
              C |= v, q.set(s, u);
              var Se = Zv(H(s), H(u), C, _, N, q);
              return q.delete(s), Se;
            case kt:
              if (Ls)
                return Ls.call(s) == Ls.call(u);
          }
          return !1;
        }
        function o4(s, u, h, C, _, N) {
          var q = h & b, H = uf(s), oe = H.length, $e = uf(u), Se = $e.length;
          if (oe != Se && !q)
            return !1;
          for (var ke = oe; ke--; ) {
            var Ve = H[ke];
            if (!(q ? Ve in u : Xt.call(u, Ve)))
              return !1;
          }
          var Xe = N.get(s), ct = N.get(u);
          if (Xe && ct)
            return Xe == u && ct == s;
          var xt = !0;
          N.set(s, u), N.set(u, s);
          for (var ut = q; ++ke < oe; ) {
            Ve = H[ke];
            var Tt = s[Ve], Dt = u[Ve];
            if (C)
              var Pr = q ? C(Dt, Tt, Ve, u, s, N) : C(Tt, Dt, Ve, s, u, N);
            if (!(Pr === n ? Tt === Dt || _(Tt, Dt, h, C, N) : Pr)) {
              xt = !1;
              break;
            }
            ut || (ut = Ve == "constructor");
          }
          if (xt && !ut) {
            var ar = s.constructor, Er = u.constructor;
            ar != Er && "constructor" in s && "constructor" in u && !(typeof ar == "function" && ar instanceof ar && typeof Er == "function" && Er instanceof Er) && (xt = !1);
          }
          return N.delete(s), N.delete(u), xt;
        }
        function Go(s) {
          return vf(rb(s, n, pb), s + "");
        }
        function uf(s) {
          return yv(s, Bn, hf);
        }
        function df(s) {
          return yv(s, fr, Qv);
        }
        var pf = Dc ? function(s) {
          return Dc.get(s);
        } : _f;
        function Hc(s) {
          for (var u = s.name + "", h = Na[u], C = Xt.call(Na, u) ? h.length : 0; C--; ) {
            var _ = h[C], N = _.func;
            if (N == null || N == s)
              return _.name;
          }
          return u;
        }
        function Ba(s) {
          var u = Xt.call(A, "placeholder") ? A : s;
          return u.placeholder;
        }
        function st() {
          var s = A.iteratee || Rf;
          return s = s === Rf ? xv : s, arguments.length ? s(arguments[0], arguments[1]) : s;
        }
        function Gc(s, u) {
          var h = s.__data__;
          return p4(u) ? h[typeof u == "string" ? "string" : "hash"] : h.map;
        }
        function ff(s) {
          for (var u = Bn(s), h = u.length; h--; ) {
            var C = u[h], _ = s[C];
            u[h] = [C, _, tb(_)];
          }
          return u;
        }
        function na(s, u) {
          var h = mP(s, u);
          return bv(h) ? h : n;
        }
        function i4(s) {
          var u = Xt.call(s, Zi), h = s[Zi];
          try {
            s[Zi] = n;
            var C = !0;
          } catch {
          }
          var _ = Sc.call(s);
          return C && (u ? s[Zi] = h : delete s[Zi]), _;
        }
        var hf = Bp ? function(s) {
          return s == null ? [] : (s = on(s), Ci(Bp(s), function(u) {
            return ov.call(s, u);
          }));
        } : Df, Qv = Bp ? function(s) {
          for (var u = []; s; )
            Si(u, hf(s)), s = Pc(s);
          return u;
        } : Df, Xn = or;
        (Vp && Xn(new Vp(new ArrayBuffer(1))) != et || Ns && Xn(new Ns()) != le || zp && Xn(zp.resolve()) != Oe || Aa && Xn(new Aa()) != Ye || js && Xn(new js()) != Ae) && (Xn = function(s) {
          var u = or(s), h = u == de ? s.constructor : n, C = h ? ra(h) : "";
          if (C)
            switch (C) {
              case VP:
                return et;
              case zP:
                return le;
              case WP:
                return Oe;
              case qP:
                return Ye;
              case UP:
                return Ae;
            }
          return u;
        });
        function a4(s, u, h) {
          for (var C = -1, _ = h.length; ++C < _; ) {
            var N = h[C], q = N.size;
            switch (N.type) {
              case "drop":
                s += q;
                break;
              case "dropRight":
                u -= q;
                break;
              case "take":
                u = Kn(u, s + q);
                break;
              case "takeRight":
                s = Fn(s, u - q);
                break;
            }
          }
          return { start: s, end: u };
        }
        function s4(s) {
          var u = s.match(Yi);
          return u ? u[1].split(U) : [];
        }
        function Jv(s, u, h) {
          u = Ri(u, s);
          for (var C = -1, _ = u.length, N = !1; ++C < _; ) {
            var q = Co(u[C]);
            if (!(N = s != null && h(s, q)))
              break;
            s = s[q];
          }
          return N || ++C != _ ? N : (_ = s == null ? 0 : s.length, !!_ && eu(_) && Yo(q, _) && (yt(s) || oa(s)));
        }
        function l4(s) {
          var u = s.length, h = new s.constructor(u);
          return u && typeof s[0] == "string" && Xt.call(s, "index") && (h.index = s.index, h.input = s.input), h;
        }
        function eb(s) {
          return typeof s.constructor == "function" && !Hs(s) ? ja(Pc(s)) : {};
        }
        function c4(s, u, h) {
          var C = s.constructor;
          switch (u) {
            case Ue:
              return sf(s);
            case Y:
            case Z:
              return new C(+s);
            case et:
              return HE(s, h);
            case Je:
            case rt:
            case je:
            case $t:
            case Pt:
            case Ft:
            case Jt:
            case Me:
            case it:
              return Nv(s, h);
            case le:
              return new C();
            case me:
            case Ie:
              return new C(s);
            case We:
              return GE(s);
            case Ye:
              return new C();
            case kt:
              return YE(s);
          }
        }
        function u4(s, u) {
          var h = u.length;
          if (!h)
            return s;
          var C = h - 1;
          return u[C] = (h > 1 ? "& " : "") + u[C], u = u.join(h > 2 ? ", " : " "), s.replace(Gi, `{
/* [wrapped with ` + u + `] */
`);
        }
        function d4(s) {
          return yt(s) || oa(s) || !!(iv && s && s[iv]);
        }
        function Yo(s, u) {
          var h = typeof s;
          return u = u ?? se, !!u && (h == "number" || h != "symbol" && nt.test(s)) && s > -1 && s % 1 == 0 && s < u;
        }
        function ir(s, u, h) {
          if (!yn(h))
            return !1;
          var C = typeof u;
          return (C == "number" ? pr(h) && Yo(u, h.length) : C == "string" && u in h) ? co(h[u], s) : !1;
        }
        function mf(s, u) {
          if (yt(s))
            return !1;
          var h = typeof s;
          return h == "number" || h == "symbol" || h == "boolean" || s == null || Or(s) ? !0 : bo.test(s) || !In.test(s) || u != null && s in on(u);
        }
        function p4(s) {
          var u = typeof s;
          return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? s !== "__proto__" : s === null;
        }
        function gf(s) {
          var u = Hc(s), h = A[u];
          if (typeof h != "function" || !(u in Rt.prototype))
            return !1;
          if (s === h)
            return !0;
          var C = pf(h);
          return !!C && s === C[0];
        }
        function f4(s) {
          return !!tv && tv in s;
        }
        var h4 = $c ? Ko : If;
        function Hs(s) {
          var u = s && s.constructor, h = typeof u == "function" && u.prototype || Ma;
          return s === h;
        }
        function tb(s) {
          return s === s && !yn(s);
        }
        function nb(s, u) {
          return function(h) {
            return h == null ? !1 : h[s] === u && (u !== n || s in on(h));
          };
        }
        function m4(s) {
          var u = Qc(s, function(C) {
            return h.size === p && h.clear(), C;
          }), h = u.cache;
          return u;
        }
        function g4(s, u) {
          var h = s[1], C = u[1], _ = h | C, N = _ < ($ | S | I), q = C == I && h == P || C == I && h == D && s[7].length <= u[8] || C == (I | D) && u[7].length <= u[8] && h == P;
          if (!(N || q))
            return s;
          C & $ && (s[2] = u[2], _ |= h & $ ? 0 : R);
          var H = u[3];
          if (H) {
            var oe = s[3];
            s[3] = oe ? Fv(oe, H, u[4]) : H, s[4] = oe ? Ti(s[3], f) : u[4];
          }
          return H = u[5], H && (oe = s[5], s[5] = oe ? Lv(oe, H, u[6]) : H, s[6] = oe ? Ti(s[5], f) : u[6]), H = u[7], H && (s[7] = H), C & I && (s[8] = s[8] == null ? u[8] : Kn(s[8], u[8])), s[9] == null && (s[9] = u[9]), s[0] = u[0], s[1] = _, s;
        }
        function y4(s) {
          var u = [];
          if (s != null)
            for (var h in on(s))
              u.push(h);
          return u;
        }
        function v4(s) {
          return Sc.call(s);
        }
        function rb(s, u, h) {
          return u = Fn(u === n ? s.length - 1 : u, 0), function() {
            for (var C = arguments, _ = -1, N = Fn(C.length - u, 0), q = he(N); ++_ < N; )
              q[_] = C[u + _];
            _ = -1;
            for (var H = he(u + 1); ++_ < u; )
              H[_] = C[_];
            return H[u] = h(q), Cr(s, this, H);
          };
        }
        function ob(s, u) {
          return u.length < 2 ? s : ta(s, Vr(u, 0, -1));
        }
        function b4(s, u) {
          for (var h = s.length, C = Kn(u.length, h), _ = dr(s); C--; ) {
            var N = u[C];
            s[C] = Yo(N, h) ? _[N] : n;
          }
          return s;
        }
        function yf(s, u) {
          if (!(u === "constructor" && typeof s[u] == "function") && u != "__proto__")
            return s[u];
        }
        var ib = sb(Ev), Gs = MP || function(s, u) {
          return Wn.setTimeout(s, u);
        }, vf = sb(zE);
        function ab(s, u, h) {
          var C = u + "";
          return vf(s, u4(C, x4(s4(C), h)));
        }
        function sb(s) {
          var u = 0, h = 0;
          return function() {
            var C = FP(), _ = B - (C - h);
            if (h = C, _ > 0) {
              if (++u >= F)
                return arguments[0];
            } else
              u = 0;
            return s.apply(n, arguments);
          };
        }
        function Yc(s, u) {
          var h = -1, C = s.length, _ = C - 1;
          for (u = u === n ? C : u; ++h < u; ) {
            var N = Jp(h, _), q = s[N];
            s[N] = s[h], s[h] = q;
          }
          return s.length = u, s;
        }
        var lb = m4(function(s) {
          var u = [];
          return s.charCodeAt(0) === 46 && u.push(""), s.replace(io, function(h, C, _, N) {
            u.push(_ ? N.replace(Ze, "$1") : C || h);
          }), u;
        });
        function Co(s) {
          if (typeof s == "string" || Or(s))
            return s;
          var u = s + "";
          return u == "0" && 1 / s == -1 / 0 ? "-0" : u;
        }
        function ra(s) {
          if (s != null) {
            try {
              return Cc.call(s);
            } catch {
            }
            try {
              return s + "";
            } catch {
            }
          }
          return "";
        }
        function x4(s, u) {
          return jr(fe, function(h) {
            var C = "_." + h[0];
            u & h[1] && !vc(s, C) && s.push(C);
          }), s.sort();
        }
        function cb(s) {
          if (s instanceof Rt)
            return s.clone();
          var u = new Lr(s.__wrapped__, s.__chain__);
          return u.__actions__ = dr(s.__actions__), u.__index__ = s.__index__, u.__values__ = s.__values__, u;
        }
        function w4(s, u, h) {
          (h ? ir(s, u, h) : u === n) ? u = 1 : u = Fn(vt(u), 0);
          var C = s == null ? 0 : s.length;
          if (!C || u < 1)
            return [];
          for (var _ = 0, N = 0, q = he(kc(C / u)); _ < C; )
            q[N++] = Vr(s, _, _ += u);
          return q;
        }
        function $4(s) {
          for (var u = -1, h = s == null ? 0 : s.length, C = 0, _ = []; ++u < h; ) {
            var N = s[u];
            N && (_[C++] = N);
          }
          return _;
        }
        function C4() {
          var s = arguments.length;
          if (!s)
            return [];
          for (var u = he(s - 1), h = arguments[0], C = s; C--; )
            u[C - 1] = arguments[C];
          return Si(yt(h) ? dr(h) : [h], qn(u, 1));
        }
        var S4 = Ct(function(s, u) {
          return En(s) ? Vs(s, qn(u, 1, En, !0)) : [];
        }), T4 = Ct(function(s, u) {
          var h = zr(u);
          return En(h) && (h = n), En(s) ? Vs(s, qn(u, 1, En, !0), st(h, 2)) : [];
        }), O4 = Ct(function(s, u) {
          var h = zr(u);
          return En(h) && (h = n), En(s) ? Vs(s, qn(u, 1, En, !0), n, h) : [];
        });
        function P4(s, u, h) {
          var C = s == null ? 0 : s.length;
          return C ? (u = h || u === n ? 1 : vt(u), Vr(s, u < 0 ? 0 : u, C)) : [];
        }
        function E4(s, u, h) {
          var C = s == null ? 0 : s.length;
          return C ? (u = h || u === n ? 1 : vt(u), u = C - u, Vr(s, 0, u < 0 ? 0 : u)) : [];
        }
        function R4(s, u) {
          return s && s.length ? Bc(s, st(u, 3), !0, !0) : [];
        }
        function k4(s, u) {
          return s && s.length ? Bc(s, st(u, 3), !0) : [];
        }
        function _4(s, u, h, C) {
          var _ = s == null ? 0 : s.length;
          return _ ? (h && typeof h != "number" && ir(s, u, h) && (h = 0, C = _), CE(s, u, h, C)) : [];
        }
        function ub(s, u, h) {
          var C = s == null ? 0 : s.length;
          if (!C)
            return -1;
          var _ = h == null ? 0 : vt(h);
          return _ < 0 && (_ = Fn(C + _, 0)), bc(s, st(u, 3), _);
        }
        function db(s, u, h) {
          var C = s == null ? 0 : s.length;
          if (!C)
            return -1;
          var _ = C - 1;
          return h !== n && (_ = vt(h), _ = h < 0 ? Fn(C + _, 0) : Kn(_, C - 1)), bc(s, st(u, 3), _, !0);
        }
        function pb(s) {
          var u = s == null ? 0 : s.length;
          return u ? qn(s, 1) : [];
        }
        function D4(s) {
          var u = s == null ? 0 : s.length;
          return u ? qn(s, G) : [];
        }
        function I4(s, u) {
          var h = s == null ? 0 : s.length;
          return h ? (u = u === n ? 1 : vt(u), qn(s, u)) : [];
        }
        function M4(s) {
          for (var u = -1, h = s == null ? 0 : s.length, C = {}; ++u < h; ) {
            var _ = s[u];
            C[_[0]] = _[1];
          }
          return C;
        }
        function fb(s) {
          return s && s.length ? s[0] : n;
        }
        function A4(s, u, h) {
          var C = s == null ? 0 : s.length;
          if (!C)
            return -1;
          var _ = h == null ? 0 : vt(h);
          return _ < 0 && (_ = Fn(C + _, 0)), ka(s, u, _);
        }
        function N4(s) {
          var u = s == null ? 0 : s.length;
          return u ? Vr(s, 0, -1) : [];
        }
        var j4 = Ct(function(s) {
          var u = fn(s, of);
          return u.length && u[0] === s[0] ? Yp(u) : [];
        }), F4 = Ct(function(s) {
          var u = zr(s), h = fn(s, of);
          return u === zr(h) ? u = n : h.pop(), h.length && h[0] === s[0] ? Yp(h, st(u, 2)) : [];
        }), L4 = Ct(function(s) {
          var u = zr(s), h = fn(s, of);
          return u = typeof u == "function" ? u : n, u && h.pop(), h.length && h[0] === s[0] ? Yp(h, n, u) : [];
        });
        function B4(s, u) {
          return s == null ? "" : NP.call(s, u);
        }
        function zr(s) {
          var u = s == null ? 0 : s.length;
          return u ? s[u - 1] : n;
        }
        function V4(s, u, h) {
          var C = s == null ? 0 : s.length;
          if (!C)
            return -1;
          var _ = C;
          return h !== n && (_ = vt(h), _ = _ < 0 ? Fn(C + _, 0) : Kn(_, C - 1)), u === u ? xP(s, u, _) : bc(s, Gy, _, !0);
        }
        function z4(s, u) {
          return s && s.length ? Sv(s, vt(u)) : n;
        }
        var W4 = Ct(hb);
        function hb(s, u) {
          return s && s.length && u && u.length ? Qp(s, u) : s;
        }
        function q4(s, u, h) {
          return s && s.length && u && u.length ? Qp(s, u, st(h, 2)) : s;
        }
        function U4(s, u, h) {
          return s && s.length && u && u.length ? Qp(s, u, n, h) : s;
        }
        var H4 = Go(function(s, u) {
          var h = s == null ? 0 : s.length, C = qp(s, u);
          return Pv(s, fn(u, function(_) {
            return Yo(_, h) ? +_ : _;
          }).sort(jv)), C;
        });
        function G4(s, u) {
          var h = [];
          if (!(s && s.length))
            return h;
          var C = -1, _ = [], N = s.length;
          for (u = st(u, 3); ++C < N; ) {
            var q = s[C];
            u(q, C, s) && (h.push(q), _.push(C));
          }
          return Pv(s, _), h;
        }
        function bf(s) {
          return s == null ? s : BP.call(s);
        }
        function Y4(s, u, h) {
          var C = s == null ? 0 : s.length;
          return C ? (h && typeof h != "number" && ir(s, u, h) ? (u = 0, h = C) : (u = u == null ? 0 : vt(u), h = h === n ? C : vt(h)), Vr(s, u, h)) : [];
        }
        function K4(s, u) {
          return Lc(s, u);
        }
        function X4(s, u, h) {
          return tf(s, u, st(h, 2));
        }
        function Z4(s, u) {
          var h = s == null ? 0 : s.length;
          if (h) {
            var C = Lc(s, u);
            if (C < h && co(s[C], u))
              return C;
          }
          return -1;
        }
        function Q4(s, u) {
          return Lc(s, u, !0);
        }
        function J4(s, u, h) {
          return tf(s, u, st(h, 2), !0);
        }
        function eR(s, u) {
          var h = s == null ? 0 : s.length;
          if (h) {
            var C = Lc(s, u, !0) - 1;
            if (co(s[C], u))
              return C;
          }
          return -1;
        }
        function tR(s) {
          return s && s.length ? Rv(s) : [];
        }
        function nR(s, u) {
          return s && s.length ? Rv(s, st(u, 2)) : [];
        }
        function rR(s) {
          var u = s == null ? 0 : s.length;
          return u ? Vr(s, 1, u) : [];
        }
        function oR(s, u, h) {
          return s && s.length ? (u = h || u === n ? 1 : vt(u), Vr(s, 0, u < 0 ? 0 : u)) : [];
        }
        function iR(s, u, h) {
          var C = s == null ? 0 : s.length;
          return C ? (u = h || u === n ? 1 : vt(u), u = C - u, Vr(s, u < 0 ? 0 : u, C)) : [];
        }
        function aR(s, u) {
          return s && s.length ? Bc(s, st(u, 3), !1, !0) : [];
        }
        function sR(s, u) {
          return s && s.length ? Bc(s, st(u, 3)) : [];
        }
        var lR = Ct(function(s) {
          return Ei(qn(s, 1, En, !0));
        }), cR = Ct(function(s) {
          var u = zr(s);
          return En(u) && (u = n), Ei(qn(s, 1, En, !0), st(u, 2));
        }), uR = Ct(function(s) {
          var u = zr(s);
          return u = typeof u == "function" ? u : n, Ei(qn(s, 1, En, !0), n, u);
        });
        function dR(s) {
          return s && s.length ? Ei(s) : [];
        }
        function pR(s, u) {
          return s && s.length ? Ei(s, st(u, 2)) : [];
        }
        function fR(s, u) {
          return u = typeof u == "function" ? u : n, s && s.length ? Ei(s, n, u) : [];
        }
        function xf(s) {
          if (!(s && s.length))
            return [];
          var u = 0;
          return s = Ci(s, function(h) {
            if (En(h))
              return u = Fn(h.length, u), !0;
          }), Np(u, function(h) {
            return fn(s, Ip(h));
          });
        }
        function mb(s, u) {
          if (!(s && s.length))
            return [];
          var h = xf(s);
          return u == null ? h : fn(h, function(C) {
            return Cr(u, n, C);
          });
        }
        var hR = Ct(function(s, u) {
          return En(s) ? Vs(s, u) : [];
        }), mR = Ct(function(s) {
          return rf(Ci(s, En));
        }), gR = Ct(function(s) {
          var u = zr(s);
          return En(u) && (u = n), rf(Ci(s, En), st(u, 2));
        }), yR = Ct(function(s) {
          var u = zr(s);
          return u = typeof u == "function" ? u : n, rf(Ci(s, En), n, u);
        }), vR = Ct(xf);
        function bR(s, u) {
          return Iv(s || [], u || [], Bs);
        }
        function xR(s, u) {
          return Iv(s || [], u || [], qs);
        }
        var wR = Ct(function(s) {
          var u = s.length, h = u > 1 ? s[u - 1] : n;
          return h = typeof h == "function" ? (s.pop(), h) : n, mb(s, h);
        });
        function gb(s) {
          var u = A(s);
          return u.__chain__ = !0, u;
        }
        function $R(s, u) {
          return u(s), s;
        }
        function Kc(s, u) {
          return u(s);
        }
        var CR = Go(function(s) {
          var u = s.length, h = u ? s[0] : 0, C = this.__wrapped__, _ = function(N) {
            return qp(N, s);
          };
          return u > 1 || this.__actions__.length || !(C instanceof Rt) || !Yo(h) ? this.thru(_) : (C = C.slice(h, +h + (u ? 1 : 0)), C.__actions__.push({
            func: Kc,
            args: [_],
            thisArg: n
          }), new Lr(C, this.__chain__).thru(function(N) {
            return u && !N.length && N.push(n), N;
          }));
        });
        function SR() {
          return gb(this);
        }
        function TR() {
          return new Lr(this.value(), this.__chain__);
        }
        function OR() {
          this.__values__ === n && (this.__values__ = kb(this.value()));
          var s = this.__index__ >= this.__values__.length, u = s ? n : this.__values__[this.__index__++];
          return { done: s, value: u };
        }
        function PR() {
          return this;
        }
        function ER(s) {
          for (var u, h = this; h instanceof Mc; ) {
            var C = cb(h);
            C.__index__ = 0, C.__values__ = n, u ? _.__wrapped__ = C : u = C;
            var _ = C;
            h = h.__wrapped__;
          }
          return _.__wrapped__ = s, u;
        }
        function RR() {
          var s = this.__wrapped__;
          if (s instanceof Rt) {
            var u = s;
            return this.__actions__.length && (u = new Rt(this)), u = u.reverse(), u.__actions__.push({
              func: Kc,
              args: [bf],
              thisArg: n
            }), new Lr(u, this.__chain__);
          }
          return this.thru(bf);
        }
        function kR() {
          return Dv(this.__wrapped__, this.__actions__);
        }
        var _R = Vc(function(s, u, h) {
          Xt.call(s, h) ? ++s[h] : Uo(s, h, 1);
        });
        function DR(s, u, h) {
          var C = yt(s) ? Uy : $E;
          return h && ir(s, u, h) && (u = n), C(s, st(u, 3));
        }
        function IR(s, u) {
          var h = yt(s) ? Ci : mv;
          return h(s, st(u, 3));
        }
        var MR = Wv(ub), AR = Wv(db);
        function NR(s, u) {
          return qn(Xc(s, u), 1);
        }
        function jR(s, u) {
          return qn(Xc(s, u), G);
        }
        function FR(s, u, h) {
          return h = h === n ? 1 : vt(h), qn(Xc(s, u), h);
        }
        function yb(s, u) {
          var h = yt(s) ? jr : Pi;
          return h(s, st(u, 3));
        }
        function vb(s, u) {
          var h = yt(s) ? rP : hv;
          return h(s, st(u, 3));
        }
        var LR = Vc(function(s, u, h) {
          Xt.call(s, h) ? s[h].push(u) : Uo(s, h, [u]);
        });
        function BR(s, u, h, C) {
          s = pr(s) ? s : za(s), h = h && !C ? vt(h) : 0;
          var _ = s.length;
          return h < 0 && (h = Fn(_ + h, 0)), tu(s) ? h <= _ && s.indexOf(u, h) > -1 : !!_ && ka(s, u, h) > -1;
        }
        var VR = Ct(function(s, u, h) {
          var C = -1, _ = typeof u == "function", N = pr(s) ? he(s.length) : [];
          return Pi(s, function(q) {
            N[++C] = _ ? Cr(u, q, h) : zs(q, u, h);
          }), N;
        }), zR = Vc(function(s, u, h) {
          Uo(s, h, u);
        });
        function Xc(s, u) {
          var h = yt(s) ? fn : wv;
          return h(s, st(u, 3));
        }
        function WR(s, u, h, C) {
          return s == null ? [] : (yt(u) || (u = u == null ? [] : [u]), h = C ? n : h, yt(h) || (h = h == null ? [] : [h]), Tv(s, u, h));
        }
        var qR = Vc(function(s, u, h) {
          s[h ? 0 : 1].push(u);
        }, function() {
          return [[], []];
        });
        function UR(s, u, h) {
          var C = yt(s) ? _p : Ky, _ = arguments.length < 3;
          return C(s, st(u, 4), h, _, Pi);
        }
        function HR(s, u, h) {
          var C = yt(s) ? oP : Ky, _ = arguments.length < 3;
          return C(s, st(u, 4), h, _, hv);
        }
        function GR(s, u) {
          var h = yt(s) ? Ci : mv;
          return h(s, Jc(st(u, 3)));
        }
        function YR(s) {
          var u = yt(s) ? uv : BE;
          return u(s);
        }
        function KR(s, u, h) {
          (h ? ir(s, u, h) : u === n) ? u = 1 : u = vt(u);
          var C = yt(s) ? yE : VE;
          return C(s, u);
        }
        function XR(s) {
          var u = yt(s) ? vE : WE;
          return u(s);
        }
        function ZR(s) {
          if (s == null)
            return 0;
          if (pr(s))
            return tu(s) ? Da(s) : s.length;
          var u = Xn(s);
          return u == le || u == Ye ? s.size : Xp(s).length;
        }
        function QR(s, u, h) {
          var C = yt(s) ? Dp : qE;
          return h && ir(s, u, h) && (u = n), C(s, st(u, 3));
        }
        var JR = Ct(function(s, u) {
          if (s == null)
            return [];
          var h = u.length;
          return h > 1 && ir(s, u[0], u[1]) ? u = [] : h > 2 && ir(u[0], u[1], u[2]) && (u = [u[0]]), Tv(s, qn(u, 1), []);
        }), Zc = IP || function() {
          return Wn.Date.now();
        };
        function e5(s, u) {
          if (typeof u != "function")
            throw new Fr(l);
          return s = vt(s), function() {
            if (--s < 1)
              return u.apply(this, arguments);
          };
        }
        function bb(s, u, h) {
          return u = h ? n : u, u = s && u == null ? s.length : u, Ho(s, I, n, n, n, n, u);
        }
        function xb(s, u) {
          var h;
          if (typeof u != "function")
            throw new Fr(l);
          return s = vt(s), function() {
            return --s > 0 && (h = u.apply(this, arguments)), s <= 1 && (u = n), h;
          };
        }
        var wf = Ct(function(s, u, h) {
          var C = $;
          if (h.length) {
            var _ = Ti(h, Ba(wf));
            C |= O;
          }
          return Ho(s, C, u, h, _);
        }), wb = Ct(function(s, u, h) {
          var C = $ | S;
          if (h.length) {
            var _ = Ti(h, Ba(wb));
            C |= O;
          }
          return Ho(u, C, s, h, _);
        });
        function $b(s, u, h) {
          u = h ? n : u;
          var C = Ho(s, P, n, n, n, n, n, u);
          return C.placeholder = $b.placeholder, C;
        }
        function Cb(s, u, h) {
          u = h ? n : u;
          var C = Ho(s, T, n, n, n, n, n, u);
          return C.placeholder = Cb.placeholder, C;
        }
        function Sb(s, u, h) {
          var C, _, N, q, H, oe, $e = 0, Se = !1, ke = !1, Ve = !0;
          if (typeof s != "function")
            throw new Fr(l);
          u = Wr(u) || 0, yn(h) && (Se = !!h.leading, ke = "maxWait" in h, N = ke ? Fn(Wr(h.maxWait) || 0, u) : N, Ve = "trailing" in h ? !!h.trailing : Ve);
          function Xe(Rn) {
            var uo = C, Zo = _;
            return C = _ = n, $e = Rn, q = s.apply(Zo, uo), q;
          }
          function ct(Rn) {
            return $e = Rn, H = Gs(Tt, u), Se ? Xe(Rn) : q;
          }
          function xt(Rn) {
            var uo = Rn - oe, Zo = Rn - $e, Wb = u - uo;
            return ke ? Kn(Wb, N - Zo) : Wb;
          }
          function ut(Rn) {
            var uo = Rn - oe, Zo = Rn - $e;
            return oe === n || uo >= u || uo < 0 || ke && Zo >= N;
          }
          function Tt() {
            var Rn = Zc();
            if (ut(Rn))
              return Dt(Rn);
            H = Gs(Tt, xt(Rn));
          }
          function Dt(Rn) {
            return H = n, Ve && C ? Xe(Rn) : (C = _ = n, q);
          }
          function Pr() {
            H !== n && Mv(H), $e = 0, C = oe = _ = H = n;
          }
          function ar() {
            return H === n ? q : Dt(Zc());
          }
          function Er() {
            var Rn = Zc(), uo = ut(Rn);
            if (C = arguments, _ = this, oe = Rn, uo) {
              if (H === n)
                return ct(oe);
              if (ke)
                return Mv(H), H = Gs(Tt, u), Xe(oe);
            }
            return H === n && (H = Gs(Tt, u)), q;
          }
          return Er.cancel = Pr, Er.flush = ar, Er;
        }
        var t5 = Ct(function(s, u) {
          return fv(s, 1, u);
        }), n5 = Ct(function(s, u, h) {
          return fv(s, Wr(u) || 0, h);
        });
        function r5(s) {
          return Ho(s, j);
        }
        function Qc(s, u) {
          if (typeof s != "function" || u != null && typeof u != "function")
            throw new Fr(l);
          var h = function() {
            var C = arguments, _ = u ? u.apply(this, C) : C[0], N = h.cache;
            if (N.has(_))
              return N.get(_);
            var q = s.apply(this, C);
            return h.cache = N.set(_, q) || N, q;
          };
          return h.cache = new (Qc.Cache || qo)(), h;
        }
        Qc.Cache = qo;
        function Jc(s) {
          if (typeof s != "function")
            throw new Fr(l);
          return function() {
            var u = arguments;
            switch (u.length) {
              case 0:
                return !s.call(this);
              case 1:
                return !s.call(this, u[0]);
              case 2:
                return !s.call(this, u[0], u[1]);
              case 3:
                return !s.call(this, u[0], u[1], u[2]);
            }
            return !s.apply(this, u);
          };
        }
        function o5(s) {
          return xb(2, s);
        }
        var i5 = UE(function(s, u) {
          u = u.length == 1 && yt(u[0]) ? fn(u[0], Sr(st())) : fn(qn(u, 1), Sr(st()));
          var h = u.length;
          return Ct(function(C) {
            for (var _ = -1, N = Kn(C.length, h); ++_ < N; )
              C[_] = u[_].call(this, C[_]);
            return Cr(s, this, C);
          });
        }), $f = Ct(function(s, u) {
          var h = Ti(u, Ba($f));
          return Ho(s, O, n, u, h);
        }), Tb = Ct(function(s, u) {
          var h = Ti(u, Ba(Tb));
          return Ho(s, k, n, u, h);
        }), a5 = Go(function(s, u) {
          return Ho(s, D, n, n, n, u);
        });
        function s5(s, u) {
          if (typeof s != "function")
            throw new Fr(l);
          return u = u === n ? u : vt(u), Ct(s, u);
        }
        function l5(s, u) {
          if (typeof s != "function")
            throw new Fr(l);
          return u = u == null ? 0 : Fn(vt(u), 0), Ct(function(h) {
            var C = h[u], _ = ki(h, 0, u);
            return C && Si(_, C), Cr(s, this, _);
          });
        }
        function c5(s, u, h) {
          var C = !0, _ = !0;
          if (typeof s != "function")
            throw new Fr(l);
          return yn(h) && (C = "leading" in h ? !!h.leading : C, _ = "trailing" in h ? !!h.trailing : _), Sb(s, u, {
            leading: C,
            maxWait: u,
            trailing: _
          });
        }
        function u5(s) {
          return bb(s, 1);
        }
        function d5(s, u) {
          return $f(af(u), s);
        }
        function p5() {
          if (!arguments.length)
            return [];
          var s = arguments[0];
          return yt(s) ? s : [s];
        }
        function f5(s) {
          return Br(s, y);
        }
        function h5(s, u) {
          return u = typeof u == "function" ? u : n, Br(s, y, u);
        }
        function m5(s) {
          return Br(s, m | y);
        }
        function g5(s, u) {
          return u = typeof u == "function" ? u : n, Br(s, m | y, u);
        }
        function y5(s, u) {
          return u == null || pv(s, u, Bn(u));
        }
        function co(s, u) {
          return s === u || s !== s && u !== u;
        }
        var v5 = Uc(Gp), b5 = Uc(function(s, u) {
          return s >= u;
        }), oa = vv(/* @__PURE__ */ function() {
          return arguments;
        }()) ? vv : function(s) {
          return wn(s) && Xt.call(s, "callee") && !ov.call(s, "callee");
        }, yt = he.isArray, x5 = Ly ? Sr(Ly) : EE;
        function pr(s) {
          return s != null && eu(s.length) && !Ko(s);
        }
        function En(s) {
          return wn(s) && pr(s);
        }
        function w5(s) {
          return s === !0 || s === !1 || wn(s) && or(s) == Y;
        }
        var _i = AP || If, $5 = By ? Sr(By) : RE;
        function C5(s) {
          return wn(s) && s.nodeType === 1 && !Ys(s);
        }
        function S5(s) {
          if (s == null)
            return !0;
          if (pr(s) && (yt(s) || typeof s == "string" || typeof s.splice == "function" || _i(s) || Va(s) || oa(s)))
            return !s.length;
          var u = Xn(s);
          if (u == le || u == Ye)
            return !s.size;
          if (Hs(s))
            return !Xp(s).length;
          for (var h in s)
            if (Xt.call(s, h))
              return !1;
          return !0;
        }
        function T5(s, u) {
          return Ws(s, u);
        }
        function O5(s, u, h) {
          h = typeof h == "function" ? h : n;
          var C = h ? h(s, u) : n;
          return C === n ? Ws(s, u, n, h) : !!C;
        }
        function Cf(s) {
          if (!wn(s))
            return !1;
          var u = or(s);
          return u == ge || u == ue || typeof s.message == "string" && typeof s.name == "string" && !Ys(s);
        }
        function P5(s) {
          return typeof s == "number" && av(s);
        }
        function Ko(s) {
          if (!yn(s))
            return !1;
          var u = or(s);
          return u == W || u == J || u == ie || u == Re;
        }
        function Ob(s) {
          return typeof s == "number" && s == vt(s);
        }
        function eu(s) {
          return typeof s == "number" && s > -1 && s % 1 == 0 && s <= se;
        }
        function yn(s) {
          var u = typeof s;
          return s != null && (u == "object" || u == "function");
        }
        function wn(s) {
          return s != null && typeof s == "object";
        }
        var Pb = Vy ? Sr(Vy) : _E;
        function E5(s, u) {
          return s === u || Kp(s, u, ff(u));
        }
        function R5(s, u, h) {
          return h = typeof h == "function" ? h : n, Kp(s, u, ff(u), h);
        }
        function k5(s) {
          return Eb(s) && s != +s;
        }
        function _5(s) {
          if (h4(s))
            throw new ft(a);
          return bv(s);
        }
        function D5(s) {
          return s === null;
        }
        function I5(s) {
          return s == null;
        }
        function Eb(s) {
          return typeof s == "number" || wn(s) && or(s) == me;
        }
        function Ys(s) {
          if (!wn(s) || or(s) != de)
            return !1;
          var u = Pc(s);
          if (u === null)
            return !0;
          var h = Xt.call(u, "constructor") && u.constructor;
          return typeof h == "function" && h instanceof h && Cc.call(h) == RP;
        }
        var Sf = zy ? Sr(zy) : DE;
        function M5(s) {
          return Ob(s) && s >= -9007199254740991 && s <= se;
        }
        var Rb = Wy ? Sr(Wy) : IE;
        function tu(s) {
          return typeof s == "string" || !yt(s) && wn(s) && or(s) == Ie;
        }
        function Or(s) {
          return typeof s == "symbol" || wn(s) && or(s) == kt;
        }
        var Va = qy ? Sr(qy) : ME;
        function A5(s) {
          return s === n;
        }
        function N5(s) {
          return wn(s) && Xn(s) == Ae;
        }
        function j5(s) {
          return wn(s) && or(s) == pt;
        }
        var F5 = Uc(Zp), L5 = Uc(function(s, u) {
          return s <= u;
        });
        function kb(s) {
          if (!s)
            return [];
          if (pr(s))
            return tu(s) ? so(s) : dr(s);
          if (As && s[As])
            return yP(s[As]());
          var u = Xn(s), h = u == le ? Fp : u == Ye ? xc : za;
          return h(s);
        }
        function Xo(s) {
          if (!s)
            return s === 0 ? s : 0;
          if (s = Wr(s), s === G || s === -1 / 0) {
            var u = s < 0 ? -1 : 1;
            return u * ne;
          }
          return s === s ? s : 0;
        }
        function vt(s) {
          var u = Xo(s), h = u % 1;
          return u === u ? h ? u - h : u : 0;
        }
        function _b(s) {
          return s ? ea(vt(s), 0, Q) : 0;
        }
        function Wr(s) {
          if (typeof s == "number")
            return s;
          if (Or(s))
            return K;
          if (yn(s)) {
            var u = typeof s.valueOf == "function" ? s.valueOf() : s;
            s = yn(u) ? u + "" : u;
          }
          if (typeof s != "string")
            return s === 0 ? s : +s;
          s = Xy(s);
          var h = Te.test(s);
          return h || Ge.test(s) ? eP(s.slice(2), h ? 2 : 8) : ce.test(s) ? K : +s;
        }
        function Db(s) {
          return $o(s, fr(s));
        }
        function B5(s) {
          return s ? ea(vt(s), -9007199254740991, se) : s === 0 ? s : 0;
        }
        function qt(s) {
          return s == null ? "" : Tr(s);
        }
        var V5 = Fa(function(s, u) {
          if (Hs(u) || pr(u)) {
            $o(u, Bn(u), s);
            return;
          }
          for (var h in u)
            Xt.call(u, h) && Bs(s, h, u[h]);
        }), Ib = Fa(function(s, u) {
          $o(u, fr(u), s);
        }), nu = Fa(function(s, u, h, C) {
          $o(u, fr(u), s, C);
        }), z5 = Fa(function(s, u, h, C) {
          $o(u, Bn(u), s, C);
        }), W5 = Go(qp);
        function q5(s, u) {
          var h = ja(s);
          return u == null ? h : dv(h, u);
        }
        var U5 = Ct(function(s, u) {
          s = on(s);
          var h = -1, C = u.length, _ = C > 2 ? u[2] : n;
          for (_ && ir(u[0], u[1], _) && (C = 1); ++h < C; )
            for (var N = u[h], q = fr(N), H = -1, oe = q.length; ++H < oe; ) {
              var $e = q[H], Se = s[$e];
              (Se === n || co(Se, Ma[$e]) && !Xt.call(s, $e)) && (s[$e] = N[$e]);
            }
          return s;
        }), H5 = Ct(function(s) {
          return s.push(n, Xv), Cr(Mb, n, s);
        });
        function G5(s, u) {
          return Hy(s, st(u, 3), wo);
        }
        function Y5(s, u) {
          return Hy(s, st(u, 3), Hp);
        }
        function K5(s, u) {
          return s == null ? s : Up(s, st(u, 3), fr);
        }
        function X5(s, u) {
          return s == null ? s : gv(s, st(u, 3), fr);
        }
        function Z5(s, u) {
          return s && wo(s, st(u, 3));
        }
        function Q5(s, u) {
          return s && Hp(s, st(u, 3));
        }
        function J5(s) {
          return s == null ? [] : jc(s, Bn(s));
        }
        function e9(s) {
          return s == null ? [] : jc(s, fr(s));
        }
        function Tf(s, u, h) {
          var C = s == null ? n : ta(s, u);
          return C === n ? h : C;
        }
        function t9(s, u) {
          return s != null && Jv(s, u, SE);
        }
        function Of(s, u) {
          return s != null && Jv(s, u, TE);
        }
        var n9 = Uv(function(s, u, h) {
          u != null && typeof u.toString != "function" && (u = Sc.call(u)), s[u] = h;
        }, Ef(hr)), r9 = Uv(function(s, u, h) {
          u != null && typeof u.toString != "function" && (u = Sc.call(u)), Xt.call(s, u) ? s[u].push(h) : s[u] = [h];
        }, st), o9 = Ct(zs);
        function Bn(s) {
          return pr(s) ? cv(s) : Xp(s);
        }
        function fr(s) {
          return pr(s) ? cv(s, !0) : AE(s);
        }
        function i9(s, u) {
          var h = {};
          return u = st(u, 3), wo(s, function(C, _, N) {
            Uo(h, u(C, _, N), C);
          }), h;
        }
        function a9(s, u) {
          var h = {};
          return u = st(u, 3), wo(s, function(C, _, N) {
            Uo(h, _, u(C, _, N));
          }), h;
        }
        var s9 = Fa(function(s, u, h) {
          Fc(s, u, h);
        }), Mb = Fa(function(s, u, h, C) {
          Fc(s, u, h, C);
        }), l9 = Go(function(s, u) {
          var h = {};
          if (s == null)
            return h;
          var C = !1;
          u = fn(u, function(N) {
            return N = Ri(N, s), C || (C = N.length > 1), N;
          }), $o(s, df(s), h), C && (h = Br(h, m | g | y, n4));
          for (var _ = u.length; _--; )
            nf(h, u[_]);
          return h;
        });
        function c9(s, u) {
          return Ab(s, Jc(st(u)));
        }
        var u9 = Go(function(s, u) {
          return s == null ? {} : jE(s, u);
        });
        function Ab(s, u) {
          if (s == null)
            return {};
          var h = fn(df(s), function(C) {
            return [C];
          });
          return u = st(u), Ov(s, h, function(C, _) {
            return u(C, _[0]);
          });
        }
        function d9(s, u, h) {
          u = Ri(u, s);
          var C = -1, _ = u.length;
          for (_ || (_ = 1, s = n); ++C < _; ) {
            var N = s == null ? n : s[Co(u[C])];
            N === n && (C = _, N = h), s = Ko(N) ? N.call(s) : N;
          }
          return s;
        }
        function p9(s, u, h) {
          return s == null ? s : qs(s, u, h);
        }
        function f9(s, u, h, C) {
          return C = typeof C == "function" ? C : n, s == null ? s : qs(s, u, h, C);
        }
        var Nb = Yv(Bn), jb = Yv(fr);
        function h9(s, u, h) {
          var C = yt(s), _ = C || _i(s) || Va(s);
          if (u = st(u, 4), h == null) {
            var N = s && s.constructor;
            _ ? h = C ? new N() : [] : yn(s) ? h = Ko(N) ? ja(Pc(s)) : {} : h = {};
          }
          return (_ ? jr : wo)(s, function(q, H, oe) {
            return u(h, q, H, oe);
          }), h;
        }
        function m9(s, u) {
          return s == null ? !0 : nf(s, u);
        }
        function g9(s, u, h) {
          return s == null ? s : _v(s, u, af(h));
        }
        function y9(s, u, h, C) {
          return C = typeof C == "function" ? C : n, s == null ? s : _v(s, u, af(h), C);
        }
        function za(s) {
          return s == null ? [] : jp(s, Bn(s));
        }
        function v9(s) {
          return s == null ? [] : jp(s, fr(s));
        }
        function b9(s, u, h) {
          return h === n && (h = u, u = n), h !== n && (h = Wr(h), h = h === h ? h : 0), u !== n && (u = Wr(u), u = u === u ? u : 0), ea(Wr(s), u, h);
        }
        function x9(s, u, h) {
          return u = Xo(u), h === n ? (h = u, u = 0) : h = Xo(h), s = Wr(s), OE(s, u, h);
        }
        function w9(s, u, h) {
          if (h && typeof h != "boolean" && ir(s, u, h) && (u = h = n), h === n && (typeof u == "boolean" ? (h = u, u = n) : typeof s == "boolean" && (h = s, s = n)), s === n && u === n ? (s = 0, u = 1) : (s = Xo(s), u === n ? (u = s, s = 0) : u = Xo(u)), s > u) {
            var C = s;
            s = u, u = C;
          }
          if (h || s % 1 || u % 1) {
            var _ = sv();
            return Kn(s + _ * (u - s + JO("1e-" + ((_ + "").length - 1))), u);
          }
          return Jp(s, u);
        }
        var $9 = La(function(s, u, h) {
          return u = u.toLowerCase(), s + (h ? Fb(u) : u);
        });
        function Fb(s) {
          return Pf(qt(s).toLowerCase());
        }
        function Lb(s) {
          return s = qt(s), s && s.replace(_t, pP).replace(WO, "");
        }
        function C9(s, u, h) {
          s = qt(s), u = Tr(u);
          var C = s.length;
          h = h === n ? C : ea(vt(h), 0, C);
          var _ = h;
          return h -= u.length, h >= 0 && s.slice(h, _) == u;
        }
        function S9(s) {
          return s = qt(s), s && Yn.test(s) ? s.replace(ln, fP) : s;
        }
        function T9(s) {
          return s = qt(s), s && xo.test(s) ? s.replace(Ar, "\\$&") : s;
        }
        var O9 = La(function(s, u, h) {
          return s + (h ? "-" : "") + u.toLowerCase();
        }), P9 = La(function(s, u, h) {
          return s + (h ? " " : "") + u.toLowerCase();
        }), E9 = zv("toLowerCase");
        function R9(s, u, h) {
          s = qt(s), u = vt(u);
          var C = u ? Da(s) : 0;
          if (!u || C >= u)
            return s;
          var _ = (u - C) / 2;
          return qc(_c(_), h) + s + qc(kc(_), h);
        }
        function k9(s, u, h) {
          s = qt(s), u = vt(u);
          var C = u ? Da(s) : 0;
          return u && C < u ? s + qc(u - C, h) : s;
        }
        function _9(s, u, h) {
          s = qt(s), u = vt(u);
          var C = u ? Da(s) : 0;
          return u && C < u ? qc(u - C, h) + s : s;
        }
        function D9(s, u, h) {
          return h || u == null ? u = 0 : u && (u = +u), LP(qt(s).replace(zo, ""), u || 0);
        }
        function I9(s, u, h) {
          return (h ? ir(s, u, h) : u === n) ? u = 1 : u = vt(u), ef(qt(s), u);
        }
        function M9() {
          var s = arguments, u = qt(s[0]);
          return s.length < 3 ? u : u.replace(s[1], s[2]);
        }
        var A9 = La(function(s, u, h) {
          return s + (h ? "_" : "") + u.toLowerCase();
        });
        function N9(s, u, h) {
          return h && typeof h != "number" && ir(s, u, h) && (u = h = n), h = h === n ? Q : h >>> 0, h ? (s = qt(s), s && (typeof u == "string" || u != null && !Sf(u)) && (u = Tr(u), !u && _a(s)) ? ki(so(s), 0, h) : s.split(u, h)) : [];
        }
        var j9 = La(function(s, u, h) {
          return s + (h ? " " : "") + Pf(u);
        });
        function F9(s, u, h) {
          return s = qt(s), h = h == null ? 0 : ea(vt(h), 0, s.length), u = Tr(u), s.slice(h, h + u.length) == u;
        }
        function L9(s, u, h) {
          var C = A.templateSettings;
          h && ir(s, u, h) && (u = n), s = qt(s), u = nu({}, u, C, Kv);
          var _ = nu({}, u.imports, C.imports, Kv), N = Bn(_), q = jp(_, N), H, oe, $e = 0, Se = u.interpolate || rn, ke = "__p += '", Ve = Lp(
            (u.escape || rn).source + "|" + Se.source + "|" + (Se === tt ? St : rn).source + "|" + (u.evaluate || rn).source + "|$",
            "g"
          ), Xe = "//# sourceURL=" + (Xt.call(u, "sourceURL") ? (u.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++YO + "]") + `
`;
          s.replace(Ve, function(ut, Tt, Dt, Pr, ar, Er) {
            return Dt || (Dt = Pr), ke += s.slice($e, Er).replace(rr, hP), Tt && (H = !0, ke += `' +
__e(` + Tt + `) +
'`), ar && (oe = !0, ke += `';
` + ar + `;
__p += '`), Dt && (ke += `' +
((__t = (` + Dt + `)) == null ? '' : __t) +
'`), $e = Er + ut.length, ut;
          }), ke += `';
`;
          var ct = Xt.call(u, "variable") && u.variable;
          if (!ct)
            ke = `with (obj) {
` + ke + `
}
`;
          else if (De.test(ct))
            throw new ft(c);
          ke = (oe ? ke.replace(bt, "") : ke).replace(gt, "$1").replace(Et, "$1;"), ke = "function(" + (ct || "obj") + `) {
` + (ct ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (H ? ", __e = _.escape" : "") + (oe ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ke + `return __p
}`;
          var xt = Vb(function() {
            return Bt(N, Xe + "return " + ke).apply(n, q);
          });
          if (xt.source = ke, Cf(xt))
            throw xt;
          return xt;
        }
        function B9(s) {
          return qt(s).toLowerCase();
        }
        function V9(s) {
          return qt(s).toUpperCase();
        }
        function z9(s, u, h) {
          if (s = qt(s), s && (h || u === n))
            return Xy(s);
          if (!s || !(u = Tr(u)))
            return s;
          var C = so(s), _ = so(u), N = Zy(C, _), q = Qy(C, _) + 1;
          return ki(C, N, q).join("");
        }
        function W9(s, u, h) {
          if (s = qt(s), s && (h || u === n))
            return s.slice(0, ev(s) + 1);
          if (!s || !(u = Tr(u)))
            return s;
          var C = so(s), _ = Qy(C, so(u)) + 1;
          return ki(C, 0, _).join("");
        }
        function q9(s, u, h) {
          if (s = qt(s), s && (h || u === n))
            return s.replace(zo, "");
          if (!s || !(u = Tr(u)))
            return s;
          var C = so(s), _ = Zy(C, so(u));
          return ki(C, _).join("");
        }
        function U9(s, u) {
          var h = E, C = M;
          if (yn(u)) {
            var _ = "separator" in u ? u.separator : _;
            h = "length" in u ? vt(u.length) : h, C = "omission" in u ? Tr(u.omission) : C;
          }
          s = qt(s);
          var N = s.length;
          if (_a(s)) {
            var q = so(s);
            N = q.length;
          }
          if (h >= N)
            return s;
          var H = h - Da(C);
          if (H < 1)
            return C;
          var oe = q ? ki(q, 0, H).join("") : s.slice(0, H);
          if (_ === n)
            return oe + C;
          if (q && (H += oe.length - H), Sf(_)) {
            if (s.slice(H).search(_)) {
              var $e, Se = oe;
              for (_.global || (_ = Lp(_.source, qt(pe.exec(_)) + "g")), _.lastIndex = 0; $e = _.exec(Se); )
                var ke = $e.index;
              oe = oe.slice(0, ke === n ? H : ke);
            }
          } else if (s.indexOf(Tr(_), H) != H) {
            var Ve = oe.lastIndexOf(_);
            Ve > -1 && (oe = oe.slice(0, Ve));
          }
          return oe + C;
        }
        function H9(s) {
          return s = qt(s), s && wr.test(s) ? s.replace(xn, wP) : s;
        }
        var G9 = La(function(s, u, h) {
          return s + (h ? " " : "") + u.toUpperCase();
        }), Pf = zv("toUpperCase");
        function Bb(s, u, h) {
          return s = qt(s), u = h ? n : u, u === n ? gP(s) ? SP(s) : sP(s) : s.match(u) || [];
        }
        var Vb = Ct(function(s, u) {
          try {
            return Cr(s, n, u);
          } catch (h) {
            return Cf(h) ? h : new ft(h);
          }
        }), Y9 = Go(function(s, u) {
          return jr(u, function(h) {
            h = Co(h), Uo(s, h, wf(s[h], s));
          }), s;
        });
        function K9(s) {
          var u = s == null ? 0 : s.length, h = st();
          return s = u ? fn(s, function(C) {
            if (typeof C[1] != "function")
              throw new Fr(l);
            return [h(C[0]), C[1]];
          }) : [], Ct(function(C) {
            for (var _ = -1; ++_ < u; ) {
              var N = s[_];
              if (Cr(N[0], this, C))
                return Cr(N[1], this, C);
            }
          });
        }
        function X9(s) {
          return wE(Br(s, m));
        }
        function Ef(s) {
          return function() {
            return s;
          };
        }
        function Z9(s, u) {
          return s == null || s !== s ? u : s;
        }
        var Q9 = qv(), J9 = qv(!0);
        function hr(s) {
          return s;
        }
        function Rf(s) {
          return xv(typeof s == "function" ? s : Br(s, m));
        }
        function ek(s) {
          return $v(Br(s, m));
        }
        function tk(s, u) {
          return Cv(s, Br(u, m));
        }
        var nk = Ct(function(s, u) {
          return function(h) {
            return zs(h, s, u);
          };
        }), rk = Ct(function(s, u) {
          return function(h) {
            return zs(s, h, u);
          };
        });
        function kf(s, u, h) {
          var C = Bn(u), _ = jc(u, C);
          h == null && !(yn(u) && (_.length || !C.length)) && (h = u, u = s, s = this, _ = jc(u, Bn(u)));
          var N = !(yn(h) && "chain" in h) || !!h.chain, q = Ko(s);
          return jr(_, function(H) {
            var oe = u[H];
            s[H] = oe, q && (s.prototype[H] = function() {
              var $e = this.__chain__;
              if (N || $e) {
                var Se = s(this.__wrapped__), ke = Se.__actions__ = dr(this.__actions__);
                return ke.push({ func: oe, args: arguments, thisArg: s }), Se.__chain__ = $e, Se;
              }
              return oe.apply(s, Si([this.value()], arguments));
            });
          }), s;
        }
        function ok() {
          return Wn._ === this && (Wn._ = kP), this;
        }
        function _f() {
        }
        function ik(s) {
          return s = vt(s), Ct(function(u) {
            return Sv(u, s);
          });
        }
        var ak = lf(fn), sk = lf(Uy), lk = lf(Dp);
        function zb(s) {
          return mf(s) ? Ip(Co(s)) : FE(s);
        }
        function ck(s) {
          return function(u) {
            return s == null ? n : ta(s, u);
          };
        }
        var uk = Hv(), dk = Hv(!0);
        function Df() {
          return [];
        }
        function If() {
          return !1;
        }
        function pk() {
          return {};
        }
        function fk() {
          return "";
        }
        function hk() {
          return !0;
        }
        function mk(s, u) {
          if (s = vt(s), s < 1 || s > se)
            return [];
          var h = Q, C = Kn(s, Q);
          u = st(u), s -= Q;
          for (var _ = Np(C, u); ++h < s; )
            u(h);
          return _;
        }
        function gk(s) {
          return yt(s) ? fn(s, Co) : Or(s) ? [s] : dr(lb(qt(s)));
        }
        function yk(s) {
          var u = ++EP;
          return qt(s) + u;
        }
        var vk = Wc(function(s, u) {
          return s + u;
        }, 0), bk = cf("ceil"), xk = Wc(function(s, u) {
          return s / u;
        }, 1), wk = cf("floor");
        function $k(s) {
          return s && s.length ? Nc(s, hr, Gp) : n;
        }
        function Ck(s, u) {
          return s && s.length ? Nc(s, st(u, 2), Gp) : n;
        }
        function Sk(s) {
          return Yy(s, hr);
        }
        function Tk(s, u) {
          return Yy(s, st(u, 2));
        }
        function Ok(s) {
          return s && s.length ? Nc(s, hr, Zp) : n;
        }
        function Pk(s, u) {
          return s && s.length ? Nc(s, st(u, 2), Zp) : n;
        }
        var Ek = Wc(function(s, u) {
          return s * u;
        }, 1), Rk = cf("round"), kk = Wc(function(s, u) {
          return s - u;
        }, 0);
        function _k(s) {
          return s && s.length ? Ap(s, hr) : 0;
        }
        function Dk(s, u) {
          return s && s.length ? Ap(s, st(u, 2)) : 0;
        }
        return A.after = e5, A.ary = bb, A.assign = V5, A.assignIn = Ib, A.assignInWith = nu, A.assignWith = z5, A.at = W5, A.before = xb, A.bind = wf, A.bindAll = Y9, A.bindKey = wb, A.castArray = p5, A.chain = gb, A.chunk = w4, A.compact = $4, A.concat = C4, A.cond = K9, A.conforms = X9, A.constant = Ef, A.countBy = _R, A.create = q5, A.curry = $b, A.curryRight = Cb, A.debounce = Sb, A.defaults = U5, A.defaultsDeep = H5, A.defer = t5, A.delay = n5, A.difference = S4, A.differenceBy = T4, A.differenceWith = O4, A.drop = P4, A.dropRight = E4, A.dropRightWhile = R4, A.dropWhile = k4, A.fill = _4, A.filter = IR, A.flatMap = NR, A.flatMapDeep = jR, A.flatMapDepth = FR, A.flatten = pb, A.flattenDeep = D4, A.flattenDepth = I4, A.flip = r5, A.flow = Q9, A.flowRight = J9, A.fromPairs = M4, A.functions = J5, A.functionsIn = e9, A.groupBy = LR, A.initial = N4, A.intersection = j4, A.intersectionBy = F4, A.intersectionWith = L4, A.invert = n9, A.invertBy = r9, A.invokeMap = VR, A.iteratee = Rf, A.keyBy = zR, A.keys = Bn, A.keysIn = fr, A.map = Xc, A.mapKeys = i9, A.mapValues = a9, A.matches = ek, A.matchesProperty = tk, A.memoize = Qc, A.merge = s9, A.mergeWith = Mb, A.method = nk, A.methodOf = rk, A.mixin = kf, A.negate = Jc, A.nthArg = ik, A.omit = l9, A.omitBy = c9, A.once = o5, A.orderBy = WR, A.over = ak, A.overArgs = i5, A.overEvery = sk, A.overSome = lk, A.partial = $f, A.partialRight = Tb, A.partition = qR, A.pick = u9, A.pickBy = Ab, A.property = zb, A.propertyOf = ck, A.pull = W4, A.pullAll = hb, A.pullAllBy = q4, A.pullAllWith = U4, A.pullAt = H4, A.range = uk, A.rangeRight = dk, A.rearg = a5, A.reject = GR, A.remove = G4, A.rest = s5, A.reverse = bf, A.sampleSize = KR, A.set = p9, A.setWith = f9, A.shuffle = XR, A.slice = Y4, A.sortBy = JR, A.sortedUniq = tR, A.sortedUniqBy = nR, A.split = N9, A.spread = l5, A.tail = rR, A.take = oR, A.takeRight = iR, A.takeRightWhile = aR, A.takeWhile = sR, A.tap = $R, A.throttle = c5, A.thru = Kc, A.toArray = kb, A.toPairs = Nb, A.toPairsIn = jb, A.toPath = gk, A.toPlainObject = Db, A.transform = h9, A.unary = u5, A.union = lR, A.unionBy = cR, A.unionWith = uR, A.uniq = dR, A.uniqBy = pR, A.uniqWith = fR, A.unset = m9, A.unzip = xf, A.unzipWith = mb, A.update = g9, A.updateWith = y9, A.values = za, A.valuesIn = v9, A.without = hR, A.words = Bb, A.wrap = d5, A.xor = mR, A.xorBy = gR, A.xorWith = yR, A.zip = vR, A.zipObject = bR, A.zipObjectDeep = xR, A.zipWith = wR, A.entries = Nb, A.entriesIn = jb, A.extend = Ib, A.extendWith = nu, kf(A, A), A.add = vk, A.attempt = Vb, A.camelCase = $9, A.capitalize = Fb, A.ceil = bk, A.clamp = b9, A.clone = f5, A.cloneDeep = m5, A.cloneDeepWith = g5, A.cloneWith = h5, A.conformsTo = y5, A.deburr = Lb, A.defaultTo = Z9, A.divide = xk, A.endsWith = C9, A.eq = co, A.escape = S9, A.escapeRegExp = T9, A.every = DR, A.find = MR, A.findIndex = ub, A.findKey = G5, A.findLast = AR, A.findLastIndex = db, A.findLastKey = Y5, A.floor = wk, A.forEach = yb, A.forEachRight = vb, A.forIn = K5, A.forInRight = X5, A.forOwn = Z5, A.forOwnRight = Q5, A.get = Tf, A.gt = v5, A.gte = b5, A.has = t9, A.hasIn = Of, A.head = fb, A.identity = hr, A.includes = BR, A.indexOf = A4, A.inRange = x9, A.invoke = o9, A.isArguments = oa, A.isArray = yt, A.isArrayBuffer = x5, A.isArrayLike = pr, A.isArrayLikeObject = En, A.isBoolean = w5, A.isBuffer = _i, A.isDate = $5, A.isElement = C5, A.isEmpty = S5, A.isEqual = T5, A.isEqualWith = O5, A.isError = Cf, A.isFinite = P5, A.isFunction = Ko, A.isInteger = Ob, A.isLength = eu, A.isMap = Pb, A.isMatch = E5, A.isMatchWith = R5, A.isNaN = k5, A.isNative = _5, A.isNil = I5, A.isNull = D5, A.isNumber = Eb, A.isObject = yn, A.isObjectLike = wn, A.isPlainObject = Ys, A.isRegExp = Sf, A.isSafeInteger = M5, A.isSet = Rb, A.isString = tu, A.isSymbol = Or, A.isTypedArray = Va, A.isUndefined = A5, A.isWeakMap = N5, A.isWeakSet = j5, A.join = B4, A.kebabCase = O9, A.last = zr, A.lastIndexOf = V4, A.lowerCase = P9, A.lowerFirst = E9, A.lt = F5, A.lte = L5, A.max = $k, A.maxBy = Ck, A.mean = Sk, A.meanBy = Tk, A.min = Ok, A.minBy = Pk, A.stubArray = Df, A.stubFalse = If, A.stubObject = pk, A.stubString = fk, A.stubTrue = hk, A.multiply = Ek, A.nth = z4, A.noConflict = ok, A.noop = _f, A.now = Zc, A.pad = R9, A.padEnd = k9, A.padStart = _9, A.parseInt = D9, A.random = w9, A.reduce = UR, A.reduceRight = HR, A.repeat = I9, A.replace = M9, A.result = d9, A.round = Rk, A.runInContext = te, A.sample = YR, A.size = ZR, A.snakeCase = A9, A.some = QR, A.sortedIndex = K4, A.sortedIndexBy = X4, A.sortedIndexOf = Z4, A.sortedLastIndex = Q4, A.sortedLastIndexBy = J4, A.sortedLastIndexOf = eR, A.startCase = j9, A.startsWith = F9, A.subtract = kk, A.sum = _k, A.sumBy = Dk, A.template = L9, A.times = mk, A.toFinite = Xo, A.toInteger = vt, A.toLength = _b, A.toLower = B9, A.toNumber = Wr, A.toSafeInteger = B5, A.toString = qt, A.toUpper = V9, A.trim = z9, A.trimEnd = W9, A.trimStart = q9, A.truncate = U9, A.unescape = H9, A.uniqueId = yk, A.upperCase = G9, A.upperFirst = Pf, A.each = yb, A.eachRight = vb, A.first = fb, kf(A, function() {
          var s = {};
          return wo(A, function(u, h) {
            Xt.call(A.prototype, h) || (s[h] = u);
          }), s;
        }(), { chain: !1 }), A.VERSION = r, jr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
          A[s].placeholder = A;
        }), jr(["drop", "take"], function(s, u) {
          Rt.prototype[s] = function(h) {
            h = h === n ? 1 : Fn(vt(h), 0);
            var C = this.__filtered__ && !u ? new Rt(this) : this.clone();
            return C.__filtered__ ? C.__takeCount__ = Kn(h, C.__takeCount__) : C.__views__.push({
              size: Kn(h, Q),
              type: s + (C.__dir__ < 0 ? "Right" : "")
            }), C;
          }, Rt.prototype[s + "Right"] = function(h) {
            return this.reverse()[s](h).reverse();
          };
        }), jr(["filter", "map", "takeWhile"], function(s, u) {
          var h = u + 1, C = h == V || h == L;
          Rt.prototype[s] = function(_) {
            var N = this.clone();
            return N.__iteratees__.push({
              iteratee: st(_, 3),
              type: h
            }), N.__filtered__ = N.__filtered__ || C, N;
          };
        }), jr(["head", "last"], function(s, u) {
          var h = "take" + (u ? "Right" : "");
          Rt.prototype[s] = function() {
            return this[h](1).value()[0];
          };
        }), jr(["initial", "tail"], function(s, u) {
          var h = "drop" + (u ? "" : "Right");
          Rt.prototype[s] = function() {
            return this.__filtered__ ? new Rt(this) : this[h](1);
          };
        }), Rt.prototype.compact = function() {
          return this.filter(hr);
        }, Rt.prototype.find = function(s) {
          return this.filter(s).head();
        }, Rt.prototype.findLast = function(s) {
          return this.reverse().find(s);
        }, Rt.prototype.invokeMap = Ct(function(s, u) {
          return typeof s == "function" ? new Rt(this) : this.map(function(h) {
            return zs(h, s, u);
          });
        }), Rt.prototype.reject = function(s) {
          return this.filter(Jc(st(s)));
        }, Rt.prototype.slice = function(s, u) {
          s = vt(s);
          var h = this;
          return h.__filtered__ && (s > 0 || u < 0) ? new Rt(h) : (s < 0 ? h = h.takeRight(-s) : s && (h = h.drop(s)), u !== n && (u = vt(u), h = u < 0 ? h.dropRight(-u) : h.take(u - s)), h);
        }, Rt.prototype.takeRightWhile = function(s) {
          return this.reverse().takeWhile(s).reverse();
        }, Rt.prototype.toArray = function() {
          return this.take(Q);
        }, wo(Rt.prototype, function(s, u) {
          var h = /^(?:filter|find|map|reject)|While$/.test(u), C = /^(?:head|last)$/.test(u), _ = A[C ? "take" + (u == "last" ? "Right" : "") : u], N = C || /^find/.test(u);
          _ && (A.prototype[u] = function() {
            var q = this.__wrapped__, H = C ? [1] : arguments, oe = q instanceof Rt, $e = H[0], Se = oe || yt(q), ke = function(Tt) {
              var Dt = _.apply(A, Si([Tt], H));
              return C && Ve ? Dt[0] : Dt;
            };
            Se && h && typeof $e == "function" && $e.length != 1 && (oe = Se = !1);
            var Ve = this.__chain__, Xe = !!this.__actions__.length, ct = N && !Ve, xt = oe && !Xe;
            if (!N && Se) {
              q = xt ? q : new Rt(this);
              var ut = s.apply(q, H);
              return ut.__actions__.push({ func: Kc, args: [ke], thisArg: n }), new Lr(ut, Ve);
            }
            return ct && xt ? s.apply(this, H) : (ut = this.thru(ke), ct ? C ? ut.value()[0] : ut.value() : ut);
          });
        }), jr(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
          var u = wc[s], h = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", C = /^(?:pop|shift)$/.test(s);
          A.prototype[s] = function() {
            var _ = arguments;
            if (C && !this.__chain__) {
              var N = this.value();
              return u.apply(yt(N) ? N : [], _);
            }
            return this[h](function(q) {
              return u.apply(yt(q) ? q : [], _);
            });
          };
        }), wo(Rt.prototype, function(s, u) {
          var h = A[u];
          if (h) {
            var C = h.name + "";
            Xt.call(Na, C) || (Na[C] = []), Na[C].push({ name: u, func: h });
          }
        }), Na[zc(n, S).name] = [{
          name: "wrapper",
          func: n
        }], Rt.prototype.clone = HP, Rt.prototype.reverse = GP, Rt.prototype.value = YP, A.prototype.at = CR, A.prototype.chain = SR, A.prototype.commit = TR, A.prototype.next = OR, A.prototype.plant = ER, A.prototype.reverse = RR, A.prototype.toJSON = A.prototype.valueOf = A.prototype.value = kR, A.prototype.first = A.prototype.head, As && (A.prototype[As] = PR), A;
      }, Ia = TP();
      Xi ? ((Xi.exports = Ia)._ = Ia, Ep._ = Ia) : Wn._ = Ia;
    }).call(eq);
  }(yl, yl.exports)), yl.exports;
}
var nq = tq();
const oT = ({ control: e, dependsOn: t, textField: n }) => {
  const r = MS({ control: e, name: t.name }), a = rq(r, t.value) || t.disabled, {
    field: { value: l, onChange: c },
    formState: { errors: d }
  } = AS({
    disabled: a,
    name: n.name,
    control: e,
    rules: n == null ? void 0 : n.rules
  });
  return /* @__PURE__ */ x.jsx(Zr, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ x.jsx(hp, { ...n, fullWidth: !1, disabled: a, value: l, onChange: c, error: nq.get(d, n.name) }) });
}, rq = (e, t) => Array.isArray(e) ? !e.includes(t) : e !== t, oq = ({
  label: e,
  disabled: t,
  value: n,
  onChange: r,
  error: o,
  name: a,
  readOnly: l = !1,
  options: c,
  direction: d = "horizontal",
  control: p,
  itemWrapperProps: f = {}
}) => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
  /* @__PURE__ */ x.jsxs(Gn, { sx: { pointerEvents: l ? "none" : "auto" }, children: [
    /* @__PURE__ */ x.jsx(ur, { id: `${a}-label`, disabled: t, children: e }),
    /* @__PURE__ */ x.jsx(eS, { "aria-labelledby": `${a}-label`, value: n, onChange: r, children: /* @__PURE__ */ x.jsx(Qt, { direction: d === "horizontal" ? "row" : "column", flexWrap: "wrap", columnGap: 3, rowGap: 1, children: c.map((m, g) => {
      const y = rT(m.value), { sx: b = {}, ...v } = f;
      return /* @__PURE__ */ x.jsxs(Zr, { sx: { display: "flex", alignItems: "flex-start", ...b }, ...v, children: [
        /* @__PURE__ */ x.jsx(
          Xd,
          {
            disabled: t,
            value: m.value,
            control: /* @__PURE__ */ x.jsx(M0, {}),
            checked: n === m.value,
            label: m.label || m.value
          },
          `${a}-radio-${y}`
        ),
        (m == null ? void 0 : m.textField) && /* @__PURE__ */ x.jsx(
          oT,
          {
            dependsOn: {
              name: a,
              disabled: !!(t || l),
              value: m.value
            },
            control: p,
            textField: m.textField
          },
          `${a}-${y}-additional`
        )
      ] }, `${a}-radio-${y}${g}`);
    }) }) })
  ] }),
  o && /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "error", children: o.message })
] }), iT = 6048e5, iq = 864e5, aT = 6e4, sT = 36e5, aq = 1e3, Iw = Symbol.for("constructDateFrom");
function mn(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Iw in e ? e[Iw](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function ot(e, t) {
  return mn(t || e, e);
}
function zi(e, t, n) {
  const r = ot(e, n == null ? void 0 : n.in);
  return isNaN(t) ? mn((n == null ? void 0 : n.in) || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Vl(e, t, n) {
  const r = ot(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return mn(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), a = mn(e, r.getTime());
  a.setMonth(r.getMonth() + t + 1, 0);
  const l = a.getDate();
  return o >= l ? a : (r.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    o
  ), r);
}
function lT(e, t, n) {
  return mn(e, +ot(e) + t);
}
function sq(e, t, n) {
  return lT(e, t * sT);
}
let lq = {};
function Oa() {
  return lq;
}
function hi(e, t) {
  var c, d, p, f;
  const n = Oa(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((d = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? n.weekStartsOn ?? ((f = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : f.weekStartsOn) ?? 0, o = ot(e, t == null ? void 0 : t.in), a = o.getDay(), l = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - l), o.setHours(0, 0, 0, 0), o;
}
function bs(e, t) {
  return hi(e, { ...t, weekStartsOn: 1 });
}
function cT(e, t) {
  const n = ot(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = mn(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const a = bs(o), l = mn(n, 0);
  l.setFullYear(r, 0, 4), l.setHours(0, 0, 0, 0);
  const c = bs(l);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= c.getTime() ? r : r - 1;
}
function ad(e) {
  const t = ot(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function fc(e, ...t) {
  const n = mn.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function xs(e, t) {
  const n = ot(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function cq(e, t, n) {
  const [r, o] = fc(
    n == null ? void 0 : n.in,
    e,
    t
  ), a = xs(r), l = xs(o), c = +a - ad(a), d = +l - ad(l);
  return Math.round((c - d) / iq);
}
function uq(e, t) {
  const n = cT(e, t), r = mn(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), bs(r);
}
function dq(e, t, n) {
  const r = ot(e, n == null ? void 0 : n.in);
  return r.setTime(r.getTime() + t * aT), r;
}
function pq(e, t, n) {
  return lT(e, t * 1e3);
}
function sd(e, t, n) {
  return zi(e, t * 7, n);
}
function ld(e, t, n) {
  return Vl(e, t * 12, n);
}
function fq(e, t, n) {
  const [r, o] = fc(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +xs(r) == +xs(o);
}
function hq(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function cd(e) {
  return !(!hq(e) && typeof e != "number" || isNaN(+ot(e)));
}
function Mw(e, t) {
  const n = ot(e, t == null ? void 0 : t.in);
  return n.setHours(23, 59, 59, 999), n;
}
function mq(e, t) {
  const n = ot(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function gq(e, t) {
  const n = ot(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function Aw(e, t) {
  const n = ot(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function uT(e, t) {
  const n = ot(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function yq(e, t) {
  var c, d, p, f;
  const n = Oa(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((d = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? n.weekStartsOn ?? ((f = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : f.weekStartsOn) ?? 0, o = ot(e, t == null ? void 0 : t.in), a = o.getDay(), l = (a < r ? -7 : 0) + 6 - (a - r);
  return o.setDate(o.getDate() + l), o.setHours(23, 59, 59, 999), o;
}
const vq = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, bq = (e, t, n) => {
  let r;
  const o = vq[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function rm(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const xq = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, wq = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, $q = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Cq = {
  date: rm({
    formats: xq,
    defaultWidth: "full"
  }),
  time: rm({
    formats: wq,
    defaultWidth: "full"
  }),
  dateTime: rm({
    formats: $q,
    defaultWidth: "full"
  })
}, Sq = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Tq = (e, t, n, r) => Sq[e];
function al(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, c = n != null && n.width ? String(n.width) : l;
      o = e.formattingValues[c] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, c = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[c] || e.values[l];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[a];
  };
}
const Oq = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Pq = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Eq = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Rq = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, kq = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, _q = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Dq = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Iq = {
  ordinalNumber: Dq,
  era: al({
    values: Oq,
    defaultWidth: "wide"
  }),
  quarter: al({
    values: Pq,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: al({
    values: Eq,
    defaultWidth: "wide"
  }),
  day: al({
    values: Rq,
    defaultWidth: "wide"
  }),
  dayPeriod: al({
    values: kq,
    defaultWidth: "wide",
    formattingValues: _q,
    defaultFormattingWidth: "wide"
  })
};
function sl(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    const l = a[0], c = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], d = Array.isArray(c) ? Aq(c, (m) => m.test(l)) : (
      // [TODO] -- I challenge you to fix the type
      Mq(c, (m) => m.test(l))
    );
    let p;
    p = e.valueCallback ? e.valueCallback(d) : d, p = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(p)
    ) : p;
    const f = t.slice(l.length);
    return { value: p, rest: f };
  };
}
function Mq(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function Aq(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Nq(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let l = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    l = n.valueCallback ? n.valueCallback(l) : l;
    const c = t.slice(o.length);
    return { value: l, rest: c };
  };
}
const jq = /^(\d+)(th|st|nd|rd)?/i, Fq = /\d+/i, Lq = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Bq = {
  any: [/^b/i, /^(a|c)/i]
}, Vq = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, zq = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Wq = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, qq = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Uq = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Hq = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Gq = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Yq = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Kq = {
  ordinalNumber: Nq({
    matchPattern: jq,
    parsePattern: Fq,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: sl({
    matchPatterns: Lq,
    defaultMatchWidth: "wide",
    parsePatterns: Bq,
    defaultParseWidth: "any"
  }),
  quarter: sl({
    matchPatterns: Vq,
    defaultMatchWidth: "wide",
    parsePatterns: zq,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: sl({
    matchPatterns: Wq,
    defaultMatchWidth: "wide",
    parsePatterns: qq,
    defaultParseWidth: "any"
  }),
  day: sl({
    matchPatterns: Uq,
    defaultMatchWidth: "wide",
    parsePatterns: Hq,
    defaultParseWidth: "any"
  }),
  dayPeriod: sl({
    matchPatterns: Gq,
    defaultMatchWidth: "any",
    parsePatterns: Yq,
    defaultParseWidth: "any"
  })
}, mp = {
  code: "en-US",
  formatDistance: bq,
  formatLong: Cq,
  formatRelative: Tq,
  localize: Iq,
  match: Kq,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Xq(e, t) {
  const n = ot(e, t == null ? void 0 : t.in);
  return cq(n, uT(n)) + 1;
}
function dT(e, t) {
  const n = ot(e, t == null ? void 0 : t.in), r = +bs(n) - +uq(n);
  return Math.round(r / iT) + 1;
}
function J0(e, t) {
  var f, m, g, y;
  const n = ot(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = Oa(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((m = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : m.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((y = (g = o.locale) == null ? void 0 : g.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, l = mn((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(r + 1, 0, a), l.setHours(0, 0, 0, 0);
  const c = hi(l, t), d = mn((t == null ? void 0 : t.in) || e, 0);
  d.setFullYear(r, 0, a), d.setHours(0, 0, 0, 0);
  const p = hi(d, t);
  return +n >= +c ? r + 1 : +n >= +p ? r : r - 1;
}
function Zq(e, t) {
  var c, d, p, f;
  const n = Oa(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((f = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, o = J0(e, t), a = mn((t == null ? void 0 : t.in) || e, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), hi(a, t);
}
function ey(e, t) {
  const n = ot(e, t == null ? void 0 : t.in), r = +hi(n, t) - +Zq(n, t);
  return Math.round(r / iT) + 1;
}
function Zt(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Ii = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Zt(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Zt(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Zt(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Zt(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Zt(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Zt(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Zt(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Zt(o, t.length);
  }
}, Ya = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Nw = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return Ii.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = J0(e, r), a = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const l = a % 100;
      return Zt(l, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : Zt(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = cT(e);
    return Zt(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Zt(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return Zt(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return Zt(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Ii.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return Zt(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = ey(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Zt(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = dT(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Zt(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Ii.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = Xq(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Zt(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return Zt(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return Zt(a, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return Zt(o, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = Ya.noon : r === 0 ? o = Ya.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = Ya.evening : r >= 12 ? o = Ya.afternoon : r >= 4 ? o = Ya.morning : o = Ya.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Ii.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Ii.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Zt(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Zt(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Ii.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Ii.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Ii.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Fw(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return pa(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return pa(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Fw(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return pa(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return pa(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + jw(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + pa(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + jw(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + pa(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return Zt(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return Zt(+e, t.length);
  }
};
function jw(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(o) : n + String(o) + t + Zt(a, 2);
}
function Fw(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Zt(Math.abs(e) / 60, 2) : pa(e, t);
}
function pa(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Zt(Math.trunc(r / 60), 2), a = Zt(r % 60, 2);
  return n + o + t + a;
}
const Lw = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, pT = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Qq = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return Lw(e, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", Lw(r, t)).replace("{{time}}", pT(o, t));
}, zl = {
  p: pT,
  P: Qq
}, Jq = /^D+$/, eU = /^Y+$/, tU = ["D", "DD", "YY", "YYYY"];
function fT(e) {
  return Jq.test(e);
}
function hT(e) {
  return eU.test(e);
}
function Mg(e, t, n) {
  const r = nU(e, t, n);
  if (console.warn(r), tU.includes(e)) throw new RangeError(r);
}
function nU(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const rU = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, oU = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, iU = /^'([^]*?)'?$/, aU = /''/g, sU = /[a-zA-Z]/;
function lU(e, t, n) {
  var f, m, g, y, b, v, $, S;
  const r = Oa(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? mp, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((m = (f = n == null ? void 0 : n.locale) == null ? void 0 : f.options) == null ? void 0 : m.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((y = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, l = (n == null ? void 0 : n.weekStartsOn) ?? ((v = (b = n == null ? void 0 : n.locale) == null ? void 0 : b.options) == null ? void 0 : v.weekStartsOn) ?? r.weekStartsOn ?? ((S = ($ = r.locale) == null ? void 0 : $.options) == null ? void 0 : S.weekStartsOn) ?? 0, c = ot(e, n == null ? void 0 : n.in);
  if (!cd(c))
    throw new RangeError("Invalid time value");
  let d = t.match(oU).map((R) => {
    const P = R[0];
    if (P === "p" || P === "P") {
      const T = zl[P];
      return T(R, o.formatLong);
    }
    return R;
  }).join("").match(rU).map((R) => {
    if (R === "''")
      return { isToken: !1, value: "'" };
    const P = R[0];
    if (P === "'")
      return { isToken: !1, value: cU(R) };
    if (Nw[P])
      return { isToken: !0, value: R };
    if (P.match(sU))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + P + "`"
      );
    return { isToken: !1, value: R };
  });
  o.localize.preprocessor && (d = o.localize.preprocessor(c, d));
  const p = {
    firstWeekContainsDate: a,
    weekStartsOn: l,
    locale: o
  };
  return d.map((R) => {
    if (!R.isToken) return R.value;
    const P = R.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && hT(P) || !(n != null && n.useAdditionalDayOfYearTokens) && fT(P)) && Mg(P, t, String(e));
    const T = Nw[P[0]];
    return T(c, P, o.localize, p);
  }).join("");
}
function cU(e) {
  const t = e.match(iU);
  return t ? t[1].replace(aU, "'") : e;
}
function uU(e, t) {
  return ot(e, t == null ? void 0 : t.in).getDate();
}
function mT(e, t) {
  const n = ot(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = n.getMonth(), a = mn(n, 0);
  return a.setFullYear(r, o + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function dU() {
  return Object.assign({}, Oa());
}
function pU(e, t) {
  return ot(e, t == null ? void 0 : t.in).getHours();
}
function fU(e, t) {
  const n = ot(e, t == null ? void 0 : t.in).getDay();
  return n === 0 ? 7 : n;
}
function hU(e) {
  return ot(e).getMilliseconds();
}
function mU(e, t) {
  return ot(e, t == null ? void 0 : t.in).getMinutes();
}
function gU(e, t) {
  return ot(e, t == null ? void 0 : t.in).getMonth();
}
function yU(e) {
  return ot(e).getSeconds();
}
function vU(e, t) {
  return ot(e, t == null ? void 0 : t.in).getFullYear();
}
function om(e, t) {
  return +ot(e) > +ot(t);
}
function im(e, t) {
  return +ot(e) < +ot(t);
}
function bU(e, t) {
  return +ot(e) == +ot(t);
}
function xU(e, t) {
  const n = wU(t) ? new t(0) : mn(t, 0);
  return n.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), n.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n;
}
function wU(e) {
  var t;
  return typeof e == "function" && ((t = e.prototype) == null ? void 0 : t.constructor) === e;
}
const $U = 10;
class gT {
  constructor() {
    qe(this, "subPriority", 0);
  }
  validate(t, n) {
    return !0;
  }
}
class CU extends gT {
  constructor(t, n, r, o, a) {
    super(), this.value = t, this.validateValue = n, this.setValue = r, this.priority = o, a && (this.subPriority = a);
  }
  validate(t, n) {
    return this.validateValue(t, this.value, n);
  }
  set(t, n, r) {
    return this.setValue(t, n, this.value, r);
  }
}
class SU extends gT {
  constructor(n, r) {
    super();
    qe(this, "priority", $U);
    qe(this, "subPriority", -1);
    this.context = n || ((o) => mn(r, o));
  }
  set(n, r) {
    return r.timestampIsSet ? n : mn(n, xU(n, this.context));
  }
}
class Wt {
  run(t, n, r, o) {
    const a = this.parse(t, n, r, o);
    return a ? {
      setter: new CU(
        a.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: a.rest
    } : null;
  }
  validate(t, n, r) {
    return !0;
  }
}
class TU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 140);
    qe(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return o.era(n, { width: "abbreviated" }) || o.era(n, { width: "narrow" });
      // A, B
      case "GGGGG":
        return o.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return o.era(n, { width: "wide" }) || o.era(n, { width: "abbreviated" }) || o.era(n, { width: "narrow" });
    }
  }
  set(n, r, o) {
    return r.era = o, n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const kn = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, _o = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function _n(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function bn(e, t) {
  const n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function Do(e, t) {
  const n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, a = n[3] ? parseInt(n[3], 10) : 0, l = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * sT + a * aT + l * aq),
    rest: t.slice(n[0].length)
  };
}
function yT(e) {
  return bn(kn.anyDigitsSigned, e);
}
function On(e, t) {
  switch (e) {
    case 1:
      return bn(kn.singleDigit, t);
    case 2:
      return bn(kn.twoDigits, t);
    case 3:
      return bn(kn.threeDigits, t);
    case 4:
      return bn(kn.fourDigits, t);
    default:
      return bn(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function ud(e, t) {
  switch (e) {
    case 1:
      return bn(kn.singleDigitSigned, t);
    case 2:
      return bn(kn.twoDigitsSigned, t);
    case 3:
      return bn(kn.threeDigitsSigned, t);
    case 4:
      return bn(kn.fourDigitsSigned, t);
    default:
      return bn(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function ty(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function vT(e, t) {
  const n = t > 0, r = n ? t : 1 - t;
  let o;
  if (r <= 50)
    o = e || 100;
  else {
    const a = r + 50, l = Math.trunc(a / 100) * 100, c = e >= a % 100;
    o = e + l - (c ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function bT(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class OU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 130);
    qe(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, o) {
    const a = (l) => ({
      year: l,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return _n(On(4, n), a);
      case "yo":
        return _n(
          o.ordinalNumber(n, {
            unit: "year"
          }),
          a
        );
      default:
        return _n(On(r.length, n), a);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, o) {
    const a = n.getFullYear();
    if (o.isTwoDigitYear) {
      const c = vT(
        o.year,
        a
      );
      return n.setFullYear(c, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const l = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return n.setFullYear(l, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class PU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 130);
    qe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const a = (l) => ({
      year: l,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return _n(On(4, n), a);
      case "Yo":
        return _n(
          o.ordinalNumber(n, {
            unit: "year"
          }),
          a
        );
      default:
        return _n(On(r.length, n), a);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, o, a) {
    const l = J0(n, a);
    if (o.isTwoDigitYear) {
      const d = vT(
        o.year,
        l
      );
      return n.setFullYear(
        d,
        0,
        a.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), hi(n, a);
    }
    const c = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return n.setFullYear(c, 0, a.firstWeekContainsDate), n.setHours(0, 0, 0, 0), hi(n, a);
  }
}
class EU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 130);
    qe(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r) {
    return ud(r === "R" ? 4 : r.length, n);
  }
  set(n, r, o) {
    const a = mn(n, 0);
    return a.setFullYear(o, 0, 4), a.setHours(0, 0, 0, 0), bs(a);
  }
}
class RU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 130);
    qe(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r) {
    return ud(r === "u" ? 4 : r.length, n);
  }
  set(n, r, o) {
    return n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class kU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 120);
    qe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return On(r.length, n);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, o) {
    return n.setMonth((o - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class _U extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 120);
    qe(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return On(r.length, n);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, o) {
    return n.setMonth((o - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class DU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    qe(this, "priority", 110);
  }
  parse(n, r, o) {
    const a = (l) => l - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "M":
        return _n(
          bn(kn.month, n),
          a
        );
      // 01, 02, ..., 12
      case "MM":
        return _n(On(2, n), a);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return _n(
          o.ordinalNumber(n, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return o.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(n, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return o.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return o.month(n, { width: "wide", context: "formatting" }) || o.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class IU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 110);
    qe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const a = (l) => l - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return _n(
          bn(kn.month, n),
          a
        );
      // 01, 02, ..., 12
      case "LL":
        return _n(On(2, n), a);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return _n(
          o.ordinalNumber(n, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return o.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(n, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return o.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return o.month(n, { width: "wide", context: "standalone" }) || o.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function MU(e, t, n) {
  const r = ot(e, n == null ? void 0 : n.in), o = ey(r, n) - t;
  return r.setDate(r.getDate() - o * 7), ot(r, n == null ? void 0 : n.in);
}
class AU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 100);
    qe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "w":
        return bn(kn.week, n);
      case "wo":
        return o.ordinalNumber(n, { unit: "week" });
      default:
        return On(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, o, a) {
    return hi(MU(n, o, a), a);
  }
}
function NU(e, t, n) {
  const r = ot(e, n == null ? void 0 : n.in), o = dT(r, n) - t;
  return r.setDate(r.getDate() - o * 7), r;
}
class jU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 100);
    qe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "I":
        return bn(kn.week, n);
      case "Io":
        return o.ordinalNumber(n, { unit: "week" });
      default:
        return On(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, o) {
    return bs(NU(n, o));
  }
}
const FU = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], LU = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class BU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 90);
    qe(this, "subPriority", 1);
    qe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "d":
        return bn(kn.date, n);
      case "do":
        return o.ordinalNumber(n, { unit: "date" });
      default:
        return On(r.length, n);
    }
  }
  validate(n, r) {
    const o = n.getFullYear(), a = bT(o), l = n.getMonth();
    return a ? r >= 1 && r <= LU[l] : r >= 1 && r <= FU[l];
  }
  set(n, r, o) {
    return n.setDate(o), n.setHours(0, 0, 0, 0), n;
  }
}
class VU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 90);
    qe(this, "subpriority", 1);
    qe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "D":
      case "DD":
        return bn(kn.dayOfYear, n);
      case "Do":
        return o.ordinalNumber(n, { unit: "date" });
      default:
        return On(r.length, n);
    }
  }
  validate(n, r) {
    const o = n.getFullYear();
    return bT(o) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(n, r, o) {
    return n.setMonth(0, o), n.setHours(0, 0, 0, 0), n;
  }
}
function ny(e, t, n) {
  var m, g, y, b;
  const r = Oa(), o = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (m = n == null ? void 0 : n.locale) == null ? void 0 : m.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((b = (y = r.locale) == null ? void 0 : y.options) == null ? void 0 : b.weekStartsOn) ?? 0, a = ot(e, n == null ? void 0 : n.in), l = a.getDay(), d = (t % 7 + 7) % 7, p = 7 - o, f = t < 0 || t > 6 ? t - (l + p) % 7 : (d + p) % 7 - (l + p) % 7;
  return zi(a, f, n);
}
class zU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 90);
    qe(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return o.day(n, { width: "wide", context: "formatting" }) || o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, a) {
    return n = ny(n, o, a), n.setHours(0, 0, 0, 0), n;
  }
}
class WU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 90);
    qe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o, a) {
    const l = (c) => {
      const d = Math.floor((c - 1) / 7) * 7;
      return (c + a.weekStartsOn + 6) % 7 + d;
    };
    switch (r) {
      // 3
      case "e":
      case "ee":
        return _n(On(r.length, n), l);
      // 3rd
      case "eo":
        return _n(
          o.ordinalNumber(n, {
            unit: "day"
          }),
          l
        );
      // Tue
      case "eee":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return o.day(n, { width: "wide", context: "formatting" }) || o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, a) {
    return n = ny(n, o, a), n.setHours(0, 0, 0, 0), n;
  }
}
class qU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 90);
    qe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, r, o, a) {
    const l = (c) => {
      const d = Math.floor((c - 1) / 7) * 7;
      return (c + a.weekStartsOn + 6) % 7 + d;
    };
    switch (r) {
      // 3
      case "c":
      case "cc":
        return _n(On(r.length, n), l);
      // 3rd
      case "co":
        return _n(
          o.ordinalNumber(n, {
            unit: "day"
          }),
          l
        );
      // Tue
      case "ccc":
        return o.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return o.day(n, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return o.day(n, { width: "wide", context: "standalone" }) || o.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, a) {
    return n = ny(n, o, a), n.setHours(0, 0, 0, 0), n;
  }
}
function UU(e, t, n) {
  const r = ot(e, n == null ? void 0 : n.in), o = fU(r, n), a = t - o;
  return zi(r, a, n);
}
class HU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 90);
    qe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const a = (l) => l === 0 ? 7 : l;
    switch (r) {
      // 2
      case "i":
      case "ii":
        return On(r.length, n);
      // 2nd
      case "io":
        return o.ordinalNumber(n, { unit: "day" });
      // Tue
      case "iii":
        return _n(
          o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // T
      case "iiiii":
        return _n(
          o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tu
      case "iiiiii":
        return _n(
          o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tuesday
      case "iiii":
      default:
        return _n(
          o.day(n, {
            width: "wide",
            context: "formatting"
          }) || o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 7;
  }
  set(n, r, o) {
    return n = UU(n, o), n.setHours(0, 0, 0, 0), n;
  }
}
class GU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 80);
    qe(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(ty(o), 0, 0, 0), n;
  }
}
class YU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 80);
    qe(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(ty(o), 0, 0, 0), n;
  }
}
class KU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 80);
    qe(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(ty(o), 0, 0, 0), n;
  }
}
class XU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 70);
    qe(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "h":
        return bn(kn.hour12h, n);
      case "ho":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return On(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 12;
  }
  set(n, r, o) {
    const a = n.getHours() >= 12;
    return a && o < 12 ? n.setHours(o + 12, 0, 0, 0) : !a && o === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(o, 0, 0, 0), n;
  }
}
class ZU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 70);
    qe(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "H":
        return bn(kn.hour23h, n);
      case "Ho":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return On(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 23;
  }
  set(n, r, o) {
    return n.setHours(o, 0, 0, 0), n;
  }
}
class QU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 70);
    qe(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "K":
        return bn(kn.hour11h, n);
      case "Ko":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return On(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.getHours() >= 12 && o < 12 ? n.setHours(o + 12, 0, 0, 0) : n.setHours(o, 0, 0, 0), n;
  }
}
class JU extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 70);
    qe(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "k":
        return bn(kn.hour24h, n);
      case "ko":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return On(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 24;
  }
  set(n, r, o) {
    const a = o <= 24 ? o % 24 : o;
    return n.setHours(a, 0, 0, 0), n;
  }
}
class eH extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 60);
    qe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "m":
        return bn(kn.minute, n);
      case "mo":
        return o.ordinalNumber(n, { unit: "minute" });
      default:
        return On(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, o) {
    return n.setMinutes(o, 0, 0), n;
  }
}
class tH extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 50);
    qe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "s":
        return bn(kn.second, n);
      case "so":
        return o.ordinalNumber(n, { unit: "second" });
      default:
        return On(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, o) {
    return n.setSeconds(o, 0), n;
  }
}
class nH extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 30);
    qe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r) {
    const o = (a) => Math.trunc(a * Math.pow(10, -r.length + 3));
    return _n(On(r.length, n), o);
  }
  set(n, r, o) {
    return n.setMilliseconds(o), n;
  }
}
class rH extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 10);
    qe(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, r) {
    switch (r) {
      case "X":
        return Do(
          _o.basicOptionalMinutes,
          n
        );
      case "XX":
        return Do(_o.basic, n);
      case "XXXX":
        return Do(
          _o.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return Do(
          _o.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return Do(_o.extended, n);
    }
  }
  set(n, r, o) {
    return r.timestampIsSet ? n : mn(
      n,
      n.getTime() - ad(n) - o
    );
  }
}
class oH extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 10);
    qe(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, r) {
    switch (r) {
      case "x":
        return Do(
          _o.basicOptionalMinutes,
          n
        );
      case "xx":
        return Do(_o.basic, n);
      case "xxxx":
        return Do(
          _o.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return Do(
          _o.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return Do(_o.extended, n);
    }
  }
  set(n, r, o) {
    return r.timestampIsSet ? n : mn(
      n,
      n.getTime() - ad(n) - o
    );
  }
}
class iH extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 40);
    qe(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return yT(n);
  }
  set(n, r, o) {
    return [mn(n, o * 1e3), { timestampIsSet: !0 }];
  }
}
class aH extends Wt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 20);
    qe(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return yT(n);
  }
  set(n, r, o) {
    return [mn(n, o), { timestampIsSet: !0 }];
  }
}
const sH = {
  G: new TU(),
  y: new OU(),
  Y: new PU(),
  R: new EU(),
  u: new RU(),
  Q: new kU(),
  q: new _U(),
  M: new DU(),
  L: new IU(),
  w: new AU(),
  I: new jU(),
  d: new BU(),
  D: new VU(),
  E: new zU(),
  e: new WU(),
  c: new qU(),
  i: new HU(),
  a: new GU(),
  b: new YU(),
  B: new KU(),
  h: new XU(),
  H: new ZU(),
  K: new QU(),
  k: new JU(),
  m: new eH(),
  s: new tH(),
  S: new nH(),
  X: new rH(),
  x: new oH(),
  t: new iH(),
  T: new aH()
}, lH = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, cH = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, uH = /^'([^]*?)'?$/, dH = /''/g, pH = /\S/, fH = /[a-zA-Z]/;
function hH(e, t, n, r) {
  var $, S, R, P, T, O, k, I;
  const o = () => mn((r == null ? void 0 : r.in) || n, NaN), a = dU(), l = (r == null ? void 0 : r.locale) ?? a.locale ?? mp, c = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((S = ($ = r == null ? void 0 : r.locale) == null ? void 0 : $.options) == null ? void 0 : S.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((P = (R = a.locale) == null ? void 0 : R.options) == null ? void 0 : P.firstWeekContainsDate) ?? 1, d = (r == null ? void 0 : r.weekStartsOn) ?? ((O = (T = r == null ? void 0 : r.locale) == null ? void 0 : T.options) == null ? void 0 : O.weekStartsOn) ?? a.weekStartsOn ?? ((I = (k = a.locale) == null ? void 0 : k.options) == null ? void 0 : I.weekStartsOn) ?? 0;
  if (!t)
    return e ? o() : ot(n, r == null ? void 0 : r.in);
  const p = {
    firstWeekContainsDate: c,
    weekStartsOn: d,
    locale: l
  }, f = [new SU(r == null ? void 0 : r.in, n)], m = t.match(cH).map((D) => {
    const j = D[0];
    if (j in zl) {
      const E = zl[j];
      return E(D, l.formatLong);
    }
    return D;
  }).join("").match(lH), g = [];
  for (let D of m) {
    !(r != null && r.useAdditionalWeekYearTokens) && hT(D) && Mg(D, t, e), !(r != null && r.useAdditionalDayOfYearTokens) && fT(D) && Mg(D, t, e);
    const j = D[0], E = sH[j];
    if (E) {
      const { incompatibleTokens: M } = E;
      if (Array.isArray(M)) {
        const B = g.find(
          (V) => M.includes(V.token) || V.token === j
        );
        if (B)
          throw new RangeError(
            `The format string mustn't contain \`${B.fullToken}\` and \`${D}\` at the same time`
          );
      } else if (E.incompatibleTokens === "*" && g.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${D}\` and any other token at the same time`
        );
      g.push({ token: j, fullToken: D });
      const F = E.run(
        e,
        D,
        l.match,
        p
      );
      if (!F)
        return o();
      f.push(F.setter), e = F.rest;
    } else {
      if (j.match(fH))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + j + "`"
        );
      if (D === "''" ? D = "'" : j === "'" && (D = mH(D)), e.indexOf(D) === 0)
        e = e.slice(D.length);
      else
        return o();
    }
  }
  if (e.length > 0 && pH.test(e))
    return o();
  const y = f.map((D) => D.priority).sort((D, j) => j - D).filter((D, j, E) => E.indexOf(D) === j).map(
    (D) => f.filter((j) => j.priority === D).sort((j, E) => E.subPriority - j.subPriority)
  ).map((D) => D[0]);
  let b = ot(n, r == null ? void 0 : r.in);
  if (isNaN(+b)) return o();
  const v = {};
  for (const D of y) {
    if (!D.validate(b, p))
      return o();
    const j = D.set(b, v, p);
    Array.isArray(j) ? (b = j[0], Object.assign(v, j[1])) : b = j;
  }
  return b;
}
function mH(e) {
  return e.match(uH)[1].replace(dH, "'");
}
function Bw(e, t) {
  const n = ot(e, t == null ? void 0 : t.in);
  return n.setMinutes(0, 0, 0), n;
}
function gH(e, t, n) {
  const [r, o] = fc(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +Bw(r) == +Bw(o);
}
function yH(e, t, n) {
  const [r, o] = fc(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function vH(e, t, n) {
  const [r, o] = fc(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function bH(e, t, n) {
  const r = +ot(e, n == null ? void 0 : n.in), [o, a] = [
    +ot(t.start, n == null ? void 0 : n.in),
    +ot(t.end, n == null ? void 0 : n.in)
  ].sort((l, c) => l - c);
  return r >= o && r <= a;
}
function Vw(e, t, n) {
  return zi(e, -t, n);
}
function xH(e, t, n) {
  const r = ot(e, n == null ? void 0 : n.in), o = r.getFullYear(), a = r.getDate(), l = mn(e, 0);
  l.setFullYear(o, t, 15), l.setHours(0, 0, 0, 0);
  const c = mT(l);
  return r.setMonth(t, Math.min(a, c)), r;
}
function wH(e, t, n) {
  const r = ot(e, n == null ? void 0 : n.in);
  return r.setDate(t), r;
}
function $H(e, t, n) {
  const r = ot(e, n == null ? void 0 : n.in);
  return r.setHours(t), r;
}
function CH(e, t, n) {
  const r = ot(e, n == null ? void 0 : n.in);
  return r.setMilliseconds(t), r;
}
function SH(e, t, n) {
  const r = ot(e, n == null ? void 0 : n.in);
  return r.setMinutes(t), r;
}
function TH(e, t, n) {
  const r = ot(e, n == null ? void 0 : n.in);
  return r.setSeconds(t), r;
}
function OH(e, t, n) {
  const r = ot(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? mn(e, NaN) : (r.setFullYear(t), r);
}
function zw(e, t, n) {
  return Vl(e, -t, n);
}
function Ww(e, t, n) {
  return sd(e, -t, n);
}
function qw(e, t, n) {
  return ld(e, -t, n);
}
const PH = ["localeText"], dd = /* @__PURE__ */ w.createContext(null);
process.env.NODE_ENV !== "production" && (dd.displayName = "MuiPickersAdapterContext");
const ry = function(t) {
  const {
    localeText: n
  } = t, r = mt(t, PH), {
    utils: o,
    localeText: a
  } = w.useContext(dd) ?? {
    utils: void 0,
    localeText: void 0
  }, l = dn({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: r,
    name: "MuiLocalizationProvider"
  }), {
    children: c,
    dateAdapter: d,
    dateFormats: p,
    dateLibInstance: f,
    adapterLocale: m,
    localeText: g
  } = l, y = w.useMemo(() => ee({}, g, a, n), [g, a, n]), b = w.useMemo(() => {
    if (!d)
      return o || null;
    const S = new d({
      locale: m,
      formats: p,
      instance: f
    });
    if (!S.isMUIAdapter)
      throw new Error(["MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    return S;
  }, [d, m, p, f, o]), v = w.useMemo(() => b ? {
    minDate: b.date("1900-01-01T00:00:00.000"),
    maxDate: b.date("2099-12-31T00:00:00.000")
  } : null, [b]), $ = w.useMemo(() => ({
    utils: b,
    defaultDates: v,
    localeText: y
  }), [v, b, y]);
  return /* @__PURE__ */ x.jsx(dd.Provider, {
    value: $,
    children: c
  });
};
process.env.NODE_ENV !== "production" && (ry.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: i.any,
  children: i.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: i.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: i.shape({
    dayOfMonth: i.string,
    dayOfMonthFull: i.string,
    fullDate: i.string,
    fullTime: i.string,
    fullTime12h: i.string,
    fullTime24h: i.string,
    hours12h: i.string,
    hours24h: i.string,
    keyboardDate: i.string,
    keyboardDateTime: i.string,
    keyboardDateTime12h: i.string,
    keyboardDateTime24h: i.string,
    meridiem: i.string,
    minutes: i.string,
    month: i.string,
    monthShort: i.string,
    normalDate: i.string,
    normalDateWithWeekday: i.string,
    seconds: i.string,
    shortDate: i.string,
    weekday: i.string,
    weekdayShort: i.string,
    year: i.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: i.any,
  /**
   * Locale for components texts
   */
  localeText: i.object
});
const EH = (e) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: ee({}, e)
      }
    }
  }
}), xT = (e) => {
  const {
    utils: t,
    formatKey: n,
    contextTranslation: r,
    propsTranslation: o
  } = e;
  return (a) => {
    const l = a !== null && t.isValid(a) ? t.format(a, n) : null;
    return (o ?? r)(a, t, l);
  };
}, wT = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "Open previous view",
  openNextView: "Open next view",
  calendarViewSwitchingButtonAriaLabel: (e) => e === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange labels
  start: "Start",
  end: "End",
  startDate: "Start date",
  startTime: "Start time",
  endDate: "End date",
  endTime: "End time",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  // Clock labels
  clockLabelText: (e, t, n, r) => `Select ${e}. ${!r && (t === null || !n.isValid(t)) ? "No time selected" : `Selected time is ${r ?? n.format(t, "fullTime")}`}`,
  hoursClockNumberText: (e) => `${e} hours`,
  minutesClockNumberText: (e) => `${e} minutes`,
  secondsClockNumberText: (e) => `${e} seconds`,
  // Digital clock labels
  selectViewText: (e) => `Select ${e}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (e) => `Week ${e}`,
  calendarWeekNumberText: (e) => `${e}`,
  // Open picker labels
  openDatePickerDialogue: (e, t, n) => n || e !== null && t.isValid(e) ? `Choose date, selected date is ${n ?? t.format(e, "fullDate")}` : "Choose date",
  openTimePickerDialogue: (e, t, n) => n || e !== null && t.isValid(e) ? `Choose time, selected time is ${n ?? t.format(e, "fullTime")}` : "Choose time",
  fieldClearLabel: "Clear",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (e) => "Y".repeat(e.digitAmount),
  fieldMonthPlaceholder: (e) => e.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (e) => e.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa",
  // View names
  year: "Year",
  month: "Month",
  day: "Day",
  weekDay: "Week day",
  hours: "Hours",
  minutes: "Minutes",
  seconds: "Seconds",
  meridiem: "Meridiem",
  // Common
  empty: "Empty"
}, RH = wT;
EH(wT);
const Pa = () => {
  const e = w.useContext(dd);
  if (e === null)
    throw new Error(["MUI X: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join(`
`));
  if (e.utils === null)
    throw new Error(["MUI X: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join(`
`));
  const t = w.useMemo(() => ee({}, RH, e.localeText), [e.localeText]);
  return w.useMemo(() => ee({}, e, {
    localeText: t
  }), [e, t]);
}, pn = () => Pa().utils, hc = () => Pa().defaultDates, gp = (e) => {
  const t = pn(), n = w.useRef(void 0);
  return n.current === void 0 && (n.current = t.date(void 0, e)), n.current;
}, bi = () => Pa().localeText, kH = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), _H = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), DH = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight"), IH = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
jt(/* @__PURE__ */ x.jsxs(w.Fragment, {
  children: [/* @__PURE__ */ x.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ x.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock");
jt(/* @__PURE__ */ x.jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
jt(/* @__PURE__ */ x.jsxs(w.Fragment, {
  children: [/* @__PURE__ */ x.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ x.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time");
const MH = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
function AH(e) {
  return Fe("MuiPickersArrowSwitcher", e);
}
Le("MuiPickersArrowSwitcher", ["root", "spacer", "button", "previousIconButton", "nextIconButton", "leftArrowIcon", "rightArrowIcon"]);
const NH = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel", "labelId"], jH = ["ownerState"], FH = ["ownerState"], LH = ae("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex"
}), BH = ae("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})(({
  theme: e
}) => ({
  width: e.spacing(3)
})), Uw = ae(Vo, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button",
  overridesResolver: (e, t) => t.button
})({
  variants: [{
    props: {
      hidden: !0
    },
    style: {
      visibility: "hidden"
    }
  }]
}), VH = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"],
    spacer: ["spacer"],
    button: ["button"],
    previousIconButton: ["previousIconButton"],
    nextIconButton: ["nextIconButton"],
    leftArrowIcon: ["leftArrowIcon"],
    rightArrowIcon: ["rightArrowIcon"]
  }, AH, t);
}, zH = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = no(), o = dn({
    props: t,
    name: "MuiPickersArrowSwitcher"
  }), {
    children: a,
    className: l,
    slots: c,
    slotProps: d,
    isNextDisabled: p,
    isNextHidden: f,
    onGoToNext: m,
    nextLabel: g,
    isPreviousDisabled: y,
    isPreviousHidden: b,
    onGoToPrevious: v,
    previousLabel: $,
    labelId: S
  } = o, R = mt(o, NH), P = o, T = VH(P), O = {
    isDisabled: p,
    isHidden: f,
    goTo: m,
    label: g
  }, k = {
    isDisabled: y,
    isHidden: b,
    goTo: v,
    label: $
  }, I = (c == null ? void 0 : c.previousIconButton) ?? Uw, D = Lt({
    elementType: I,
    externalSlotProps: d == null ? void 0 : d.previousIconButton,
    additionalProps: {
      size: "medium",
      title: k.label,
      "aria-label": k.label,
      disabled: k.isDisabled,
      edge: "end",
      onClick: k.goTo
    },
    ownerState: ee({}, P, {
      hidden: k.isHidden
    }),
    className: _e(T.button, T.previousIconButton)
  }), j = (c == null ? void 0 : c.nextIconButton) ?? Uw, E = Lt({
    elementType: j,
    externalSlotProps: d == null ? void 0 : d.nextIconButton,
    additionalProps: {
      size: "medium",
      title: O.label,
      "aria-label": O.label,
      disabled: O.isDisabled,
      edge: "start",
      onClick: O.goTo
    },
    ownerState: ee({}, P, {
      hidden: O.isHidden
    }),
    className: _e(T.button, T.nextIconButton)
  }), M = (c == null ? void 0 : c.leftArrowIcon) ?? _H, F = Lt({
    elementType: M,
    externalSlotProps: d == null ? void 0 : d.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: P,
    className: T.leftArrowIcon
  }), B = mt(F, jH), V = (c == null ? void 0 : c.rightArrowIcon) ?? DH, z = Lt({
    elementType: V,
    externalSlotProps: d == null ? void 0 : d.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: P,
    className: T.rightArrowIcon
  }), L = mt(z, FH);
  return /* @__PURE__ */ x.jsxs(LH, ee({
    ref: n,
    className: _e(T.root, l),
    ownerState: P
  }, R, {
    children: [/* @__PURE__ */ x.jsx(I, ee({}, D, {
      children: r ? /* @__PURE__ */ x.jsx(V, ee({}, L)) : /* @__PURE__ */ x.jsx(M, ee({}, B))
    })), a ? /* @__PURE__ */ x.jsx(Qe, {
      variant: "subtitle1",
      component: "span",
      id: S,
      children: a
    }) : /* @__PURE__ */ x.jsx(BH, {
      className: T.spacer,
      ownerState: P
    }), /* @__PURE__ */ x.jsx(j, ee({}, E, {
      children: r ? /* @__PURE__ */ x.jsx(M, ee({}, B)) : /* @__PURE__ */ x.jsx(V, ee({}, L))
    }))]
  }));
}), ll = (e, t) => e.length !== t.length ? !1 : t.every((n) => e.includes(n)), WH = ({
  openTo: e,
  defaultOpenTo: t,
  views: n,
  defaultViews: r
}) => {
  const o = n ?? r;
  let a;
  if (e != null)
    a = e;
  else if (o.includes(t))
    a = t;
  else if (o.length > 0)
    a = o[0];
  else
    throw new Error("MUI X: The `views` prop must contain at least one view.");
  return {
    views: o,
    openTo: a
  };
}, qH = ["hours", "minutes", "seconds"], UH = (e) => qH.includes(e), Hw = (e, t) => t.getHours(e) * 3600 + t.getMinutes(e) * 60 + t.getSeconds(e), HH = (e, t) => (n, r) => e ? t.isAfter(n, r) : Hw(n, t) > Hw(r, t);
let am = !1;
function $T({
  onChange: e,
  onViewChange: t,
  openTo: n,
  view: r,
  views: o,
  autoFocus: a,
  focusedView: l,
  onFocusedViewChange: c
}) {
  process.env.NODE_ENV !== "production" && (am || (r != null && !o.includes(r) && (console.warn(`MUI X: \`view="${r}"\` is not a valid prop.`, `It must be an element of \`views=["${o.join('", "')}"]\`.`), am = !0), r == null && n != null && !o.includes(n) && (console.warn(`MUI X: \`openTo="${n}"\` is not a valid prop.`, `It must be an element of \`views=["${o.join('", "')}"]\`.`), am = !0)));
  const d = w.useRef(n), p = w.useRef(o), f = w.useRef(o.includes(n) ? n : o[0]), [m, g] = sr({
    name: "useViews",
    state: "view",
    controlled: r,
    default: f.current
  }), y = w.useRef(a ? m : null), [b, v] = sr({
    name: "useViews",
    state: "focusedView",
    controlled: l,
    default: y.current
  });
  w.useEffect(() => {
    (d.current && d.current !== n || p.current && p.current.some((I) => !o.includes(I))) && (g(o.includes(n) ? n : o[0]), p.current = o, d.current = n);
  }, [n, g, m, o]);
  const $ = o.indexOf(m), S = o[$ - 1] ?? null, R = o[$ + 1] ?? null, P = ze((I, D) => {
    v(D ? I : (j) => I === j ? null : j), c == null || c(I, D);
  }), T = ze((I) => {
    P(I, !0), I !== m && (g(I), t && t(I));
  }), O = ze(() => {
    R && T(R);
  }), k = ze((I, D, j) => {
    const E = D === "finish", M = j ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but when it's not the final view given all `views` -> overall selection state should be `partial`.
      o.indexOf(j) < o.length - 1
    ) : !!R;
    if (e(I, E && M ? "partial" : D, j), j && j !== m) {
      const B = o[o.indexOf(j) + 1];
      B && T(B);
    } else E && O();
  });
  return {
    view: m,
    setView: T,
    focusedView: b,
    setFocusedView: P,
    nextView: R,
    previousView: S,
    // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
    defaultView: o.includes(n) ? n : o[0],
    goToNextView: O,
    setValueAndGoToNextView: k
  };
}
function GH(e, {
  disableFuture: t,
  maxDate: n,
  timezone: r
}) {
  const o = pn();
  return w.useMemo(() => {
    const a = o.date(void 0, r), l = o.startOfMonth(t && o.isBefore(a, n) ? a : n);
    return !o.isAfter(l, e);
  }, [t, n, e, o, r]);
}
function YH(e, {
  disablePast: t,
  minDate: n,
  timezone: r
}) {
  const o = pn();
  return w.useMemo(() => {
    const a = o.date(void 0, r), l = o.startOfMonth(t && o.isAfter(a, n) ? a : n);
    return !o.isBefore(l, e);
  }, [t, n, e, o, r]);
}
const Wl = 36, yp = 2, vp = 320, KH = 280, oy = 336, XH = ae("div")({
  overflow: "hidden",
  width: vp,
  maxHeight: oy,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
}), pd = (e, t, n) => {
  let r = t;
  return r = e.setHours(r, e.getHours(n)), r = e.setMinutes(r, e.getMinutes(n)), r = e.setSeconds(r, e.getSeconds(n)), r = e.setMilliseconds(r, e.getMilliseconds(n)), r;
}, Pl = ({
  date: e,
  disableFuture: t,
  disablePast: n,
  maxDate: r,
  minDate: o,
  isDateDisabled: a,
  utils: l,
  timezone: c
}) => {
  const d = pd(l, l.date(void 0, c), e);
  n && l.isBefore(o, d) && (o = d), t && l.isAfter(r, d) && (r = d);
  let p = e, f = e;
  for (l.isBefore(e, o) && (p = o, f = null), l.isAfter(e, r) && (f && (f = r), p = null); p || f; ) {
    if (p && l.isAfter(p, r) && (p = null), f && l.isBefore(f, o) && (f = null), p) {
      if (!a(p))
        return p;
      p = l.addDays(p, 1);
    }
    if (f) {
      if (!a(f))
        return f;
      f = l.addDays(f, -1);
    }
  }
  return null;
}, ZH = (e, t) => t == null || !e.isValid(t) ? null : t, eo = (e, t, n) => t == null || !e.isValid(t) ? n : t, QH = (e, t, n) => !e.isValid(t) && t != null && !e.isValid(n) && n != null ? !0 : e.isEqual(t, n), iy = (e, t) => {
  const r = [e.startOfYear(t)];
  for (; r.length < 12; ) {
    const o = r[r.length - 1];
    r.push(e.addMonths(o, 1));
  }
  return r;
}, CT = (e, t, n) => n === "date" ? e.startOfDay(e.date(void 0, t)) : e.date(void 0, t), JH = ["year", "month", "day"], Gw = (e) => JH.includes(e), ay = (e, {
  format: t,
  views: n
}, r) => {
  if (t != null)
    return t;
  const o = e.formats;
  return ll(n, ["year"]) ? o.year : ll(n, ["month"]) ? o.month : ll(n, ["day"]) ? o.dayOfMonth : ll(n, ["month", "year"]) ? `${o.month} ${o.year}` : ll(n, ["day", "month"]) ? `${o.month} ${o.dayOfMonth}` : r ? /en/.test(e.getCurrentLocaleCode()) ? o.normalDateWithWeekday : o.normalDate : o.keyboardDate;
}, eG = (e, t) => {
  const n = e.startOfWeek(t);
  return [0, 1, 2, 3, 4, 5, 6].map((r) => e.addDays(n, r));
}, sy = ({
  timezone: e,
  value: t,
  defaultValue: n,
  referenceDate: r,
  onChange: o,
  valueManager: a
}) => {
  const l = pn(), c = w.useRef(n), d = t ?? c.current ?? a.emptyValue, p = w.useMemo(() => a.getTimezone(l, d), [l, a, d]), f = ze((b) => p == null ? b : a.setTimezone(l, p, b));
  let m;
  e ? m = e : p ? m = p : r ? m = l.getTimezone(r) : m = "default";
  const g = w.useMemo(() => a.setTimezone(l, m, d), [a, l, m, d]), y = ze((b, ...v) => {
    const $ = f(b);
    o == null || o($, ...v);
  });
  return {
    value: g,
    handleValueChange: y,
    timezone: m
  };
}, ly = ({
  name: e,
  timezone: t,
  value: n,
  defaultValue: r,
  referenceDate: o,
  onChange: a,
  valueManager: l
}) => {
  const [c, d] = sr({
    name: e,
    state: "value",
    controlled: n,
    default: r ?? l.emptyValue
  }), p = ze((f, ...m) => {
    d(f), a == null || a(f, ...m);
  });
  return sy({
    timezone: t,
    value: c,
    defaultValue: void 0,
    referenceDate: o,
    onChange: p,
    valueManager: l
  });
}, Ro = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
}, tG = (e) => Math.max(...e.map((t) => Ro[t.type] ?? 1)), cl = (e, t, n) => {
  if (t === Ro.year)
    return e.startOfYear(n);
  if (t === Ro.month)
    return e.startOfMonth(n);
  if (t === Ro.day)
    return e.startOfDay(n);
  let r = n;
  return t < Ro.minutes && (r = e.setMinutes(r, 0)), t < Ro.seconds && (r = e.setSeconds(r, 0)), t < Ro.milliseconds && (r = e.setMilliseconds(r, 0)), r;
}, nG = ({
  props: e,
  utils: t,
  granularity: n,
  timezone: r,
  getTodayDate: o
}) => {
  let a = o ? o() : cl(t, n, CT(t, r));
  e.minDate != null && t.isAfterDay(e.minDate, a) && (a = cl(t, n, e.minDate)), e.maxDate != null && t.isBeforeDay(e.maxDate, a) && (a = cl(t, n, e.maxDate));
  const l = HH(e.disableIgnoringDatePartForTimeValidation ?? !1, t);
  return e.minTime != null && l(e.minTime, a) && (a = cl(t, n, e.disableIgnoringDatePartForTimeValidation ? e.minTime : pd(t, a, e.minTime))), e.maxTime != null && l(a, e.maxTime) && (a = cl(t, n, e.disableIgnoringDatePartForTimeValidation ? e.maxTime : pd(t, a, e.maxTime))), a;
}, cy = (e, t) => {
  const n = e.formatTokenMap[t];
  if (n == null)
    throw new Error([`MUI X: The token "${t}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join(`
`));
  return typeof n == "string" ? {
    type: n,
    contentType: n === "meridiem" ? "letter" : "digit",
    maxLength: void 0
  } : {
    type: n.sectionType,
    contentType: n.contentType,
    maxLength: n.maxLength
  };
}, rG = (e) => {
  switch (e) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}, bp = (e, t) => {
  const n = [], r = e.date(void 0, "default"), o = e.startOfWeek(r), a = e.endOfWeek(r);
  let l = o;
  for (; e.isBefore(l, a); )
    n.push(l), l = e.addDays(l, 1);
  return n.map((c) => e.formatByString(c, t));
}, ST = (e, t, n, r) => {
  switch (n) {
    case "month":
      return iy(e, e.date(void 0, t)).map((o) => e.formatByString(o, r));
    case "weekDay":
      return bp(e, r);
    case "meridiem": {
      const o = e.date(void 0, t);
      return [e.startOfDay(o), e.endOfDay(o)].map((a) => e.formatByString(a, r));
    }
    default:
      return [];
  }
}, Yw = "s", oG = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], iG = (e) => {
  const t = e.date(void 0);
  return e.formatByString(e.setSeconds(t, 0), Yw) === "0" ? oG : Array.from({
    length: 10
  }).map((r, o) => e.formatByString(e.setSeconds(t, o), Yw));
}, Ca = (e, t) => {
  if (t[0] === "0")
    return e;
  const n = [];
  let r = "";
  for (let o = 0; o < e.length; o += 1) {
    r += e[o];
    const a = t.indexOf(r);
    a > -1 && (n.push(a.toString()), r = "");
  }
  return n.join("");
}, uy = (e, t) => t[0] === "0" ? e : e.split("").map((n) => t[Number(n)]).join(""), Kw = (e, t) => {
  const n = Ca(e, t);
  return n !== " " && !Number.isNaN(Number(n));
}, TT = (e, t) => {
  let n = e;
  for (n = Number(n).toString(); n.length < t; )
    n = `0${n}`;
  return n;
}, OT = (e, t, n, r, o) => {
  if (process.env.NODE_ENV !== "production" && o.type !== "day" && o.contentType === "digit-with-letter")
    throw new Error([`MUI X: The token "${o.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join(`
`));
  if (o.type === "day" && o.contentType === "digit-with-letter") {
    const l = e.setDate(n.longestMonth, t);
    return e.formatByString(l, o.format);
  }
  let a = t.toString();
  return o.hasLeadingZerosInInput && (a = TT(a, o.maxLength)), uy(a, r);
}, aG = (e, t, n, r, o, a, l, c) => {
  const d = rG(r), p = r === "Home", f = r === "End", m = n.value === "" || p || f, g = () => {
    const b = o[n.type]({
      currentDate: l,
      format: n.format,
      contentType: n.contentType
    }), v = (P) => OT(e, P, b, a, n), $ = n.type === "minutes" && (c != null && c.minutesStep) ? c.minutesStep : 1;
    let R = parseInt(Ca(n.value, a), 10) + d * $;
    if (m) {
      if (n.type === "year" && !f && !p)
        return e.formatByString(e.date(void 0, t), n.format);
      d > 0 || p ? R = b.minimum : R = b.maximum;
    }
    return R % $ !== 0 && ((d < 0 || p) && (R += $ - ($ + R) % $), (d > 0 || f) && (R -= R % $)), R > b.maximum ? v(b.minimum + (R - b.maximum - 1) % (b.maximum - b.minimum + 1)) : R < b.minimum ? v(b.maximum - (b.minimum - R - 1) % (b.maximum - b.minimum + 1)) : v(R);
  }, y = () => {
    const b = ST(e, t, n.type, n.format);
    if (b.length === 0)
      return n.value;
    if (m)
      return d > 0 || p ? b[0] : b[b.length - 1];
    const S = ((b.indexOf(n.value) + d) % b.length + b.length) % b.length;
    return b[S];
  };
  return n.contentType === "digit" || n.contentType === "digit-with-letter" ? g() : y();
}, dy = (e, t, n) => {
  let r = e.value || e.placeholder;
  const o = t === "non-input" ? e.hasLeadingZerosInFormat : e.hasLeadingZerosInInput;
  return t === "non-input" && e.hasLeadingZerosInInput && !e.hasLeadingZerosInFormat && (r = Number(Ca(r, n)).toString()), ["input-rtl", "input-ltr"].includes(t) && e.contentType === "digit" && !o && r.length === 1 && (r = `${r}‎`), t === "input-rtl" && (r = `⁨${r}⁩`), r;
}, Xw = (e, t, n, r) => {
  if (process.env.NODE_ENV !== "production" && cy(e, n).type === "weekDay")
    throw new Error("changeSectionValueFormat doesn't support week day formats");
  return e.formatByString(e.parse(t, n), r);
}, PT = (e, t) => e.formatByString(e.date(void 0, "system"), t).length === 4, ET = (e, t, n, r) => {
  if (t !== "digit")
    return !1;
  const o = e.date(void 0, "default");
  switch (n) {
    // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
    case "year":
      return PT(e, r) ? e.formatByString(e.setYear(o, 1), r) === "0001" : e.formatByString(e.setYear(o, 2001), r) === "01";
    case "month":
      return e.formatByString(e.startOfYear(o), r).length > 1;
    case "day":
      return e.formatByString(e.startOfMonth(o), r).length > 1;
    case "weekDay":
      return e.formatByString(e.startOfWeek(o), r).length > 1;
    case "hours":
      return e.formatByString(e.setHours(o, 1), r).length > 1;
    case "minutes":
      return e.formatByString(e.setMinutes(o, 1), r).length > 1;
    case "seconds":
      return e.formatByString(e.setSeconds(o, 1), r).length > 1;
    default:
      throw new Error("Invalid section type");
  }
}, sG = (e, t, n) => {
  const r = t.some((d) => d.type === "day"), o = [], a = [];
  for (let d = 0; d < t.length; d += 1) {
    const p = t[d];
    r && p.type === "weekDay" || (o.push(p.format), a.push(dy(p, "non-input", n)));
  }
  const l = o.join(" "), c = a.join(" ");
  return e.parse(c, l);
}, lG = (e) => e.map((t) => `${t.startSeparator}${t.value || t.placeholder}${t.endSeparator}`).join(""), cG = (e, t, n) => {
  const o = e.map((a) => {
    const l = dy(a, n ? "input-rtl" : "input-ltr", t);
    return `${a.startSeparator}${l}${a.endSeparator}`;
  }).join("");
  return n ? `⁦${o}⁩` : o;
}, uG = (e, t, n) => {
  const r = e.date(void 0, n), o = e.endOfYear(r), a = e.endOfDay(r), {
    maxDaysInMonth: l,
    longestMonth: c
  } = iy(e, r).reduce((d, p) => {
    const f = e.getDaysInMonth(p);
    return f > d.maxDaysInMonth ? {
      maxDaysInMonth: f,
      longestMonth: p
    } : d;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: d
    }) => ({
      minimum: 0,
      maximum: PT(e, d) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: e.getMonth(o) + 1
    }),
    day: ({
      currentDate: d
    }) => ({
      minimum: 1,
      maximum: d != null && e.isValid(d) ? e.getDaysInMonth(d) : l,
      longestMonth: c
    }),
    weekDay: ({
      format: d,
      contentType: p
    }) => {
      if (p === "digit") {
        const f = bp(e, d).map(Number);
        return {
          minimum: Math.min(...f),
          maximum: Math.max(...f)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: d
    }) => {
      const p = e.getHours(a);
      return Ca(e.formatByString(e.endOfDay(r), d), t) !== p.toString() ? {
        minimum: 1,
        maximum: Number(Ca(e.formatByString(e.startOfDay(r), d), t))
      } : {
        minimum: 0,
        maximum: p
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: e.getMinutes(a)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: e.getSeconds(a)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 1
    }),
    empty: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let Zw = !1;
const Qw = (e, t) => {
  if (process.env.NODE_ENV !== "production" && !Zw) {
    const n = ["empty"];
    ["date", "date-time"].includes(t) && n.push("weekDay", "day", "month", "year"), ["time", "date-time"].includes(t) && n.push("hours", "minutes", "seconds", "meridiem");
    const r = e.find((o) => !n.includes(o.type));
    r && (console.warn(`MUI X: The field component you are using is not compatible with the "${r.type}" date section.`, `The supported date sections are ["${n.join('", "')}"]\`.`), Zw = !0);
  }
}, dG = (e, t, n, r) => {
  switch (t.type) {
    case "year":
      return e.setYear(r, e.getYear(n));
    case "month":
      return e.setMonth(r, e.getMonth(n));
    case "weekDay": {
      const o = bp(e, t.format), a = e.formatByString(n, t.format), l = o.indexOf(a), d = o.indexOf(t.value) - l;
      return e.addDays(n, d);
    }
    case "day":
      return e.setDate(r, e.getDate(n));
    case "meridiem": {
      const o = e.getHours(n) < 12, a = e.getHours(r);
      return o && a >= 12 ? e.addHours(r, -12) : !o && a < 12 ? e.addHours(r, 12) : r;
    }
    case "hours":
      return e.setHours(r, e.getHours(n));
    case "minutes":
      return e.setMinutes(r, e.getMinutes(n));
    case "seconds":
      return e.setSeconds(r, e.getSeconds(n));
    default:
      return r;
  }
}, Jw = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8,
  empty: 9
}, e$ = (e, t, n, r, o) => (
  // cloning sections before sort to avoid mutating it
  [...n].sort((a, l) => Jw[a.type] - Jw[l.type]).reduce((a, l) => !o || l.modified ? dG(e, l, t, a) : a, r)
), pG = () => navigator.userAgent.toLowerCase().includes("android"), fG = (e, t) => {
  const n = {};
  if (!t)
    return e.forEach((d, p) => {
      const f = p === 0 ? null : p - 1, m = p === e.length - 1 ? null : p + 1;
      n[p] = {
        leftIndex: f,
        rightIndex: m
      };
    }), {
      neighbors: n,
      startIndex: 0,
      endIndex: e.length - 1
    };
  const r = {}, o = {};
  let a = 0, l = 0, c = e.length - 1;
  for (; c >= 0; ) {
    l = e.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (d, p) => {
        var f;
        return p >= a && ((f = d.endSeparator) == null ? void 0 : f.includes(" ")) && // Special case where the spaces were not there in the initial input
        d.endSeparator !== " / ";
      }
    ), l === -1 && (l = e.length - 1);
    for (let d = l; d >= a; d -= 1)
      o[d] = c, r[c] = d, c -= 1;
    a = l + 1;
  }
  return e.forEach((d, p) => {
    const f = o[p], m = f === 0 ? null : r[f - 1], g = f === e.length - 1 ? null : r[f + 1];
    n[p] = {
      leftIndex: m,
      rightIndex: g
    };
  }), {
    neighbors: n,
    startIndex: r[0],
    endIndex: r[e.length - 1]
  };
}, Ag = (e, t) => {
  if (e == null)
    return null;
  if (e === "all")
    return "all";
  if (typeof e == "string") {
    const n = t.findIndex((r) => r.type === e);
    return n === -1 ? null : n;
  }
  return e;
}, hG = (e, t) => {
  if (e.value)
    switch (e.type) {
      case "month": {
        if (e.contentType === "digit")
          return t.format(t.setMonth(t.date(), Number(e.value) - 1), "month");
        const n = t.parse(e.value, e.format);
        return n ? t.format(n, "month") : void 0;
      }
      case "day":
        return e.contentType === "digit" ? t.format(t.setDate(t.startOfYear(t.date()), Number(e.value)), "dayOfMonthFull") : e.value;
      case "weekDay":
        return;
      default:
        return;
    }
}, mG = (e, t) => {
  if (e.value)
    switch (e.type) {
      case "weekDay":
        return e.contentType === "letter" ? void 0 : Number(e.value);
      case "meridiem": {
        const n = t.parse(`01:00 ${e.value}`, `${t.formats.hours12h}:${t.formats.minutes} ${e.format}`);
        return n ? t.getHours(n) >= 12 ? 1 : 0 : void 0;
      }
      case "day":
        return e.contentType === "digit-with-letter" ? parseInt(e.value, 10) : Number(e.value);
      case "month": {
        if (e.contentType === "digit")
          return Number(e.value);
        const n = t.parse(e.value, e.format);
        return n ? t.getMonth(n) + 1 : void 0;
      }
      default:
        return e.contentType !== "letter" ? Number(e.value) : void 0;
    }
}, gG = ["value", "referenceDate"], Bo = {
  emptyValue: null,
  getTodayValue: CT,
  getInitialReferenceValue: (e) => {
    let {
      value: t,
      referenceDate: n
    } = e, r = mt(e, gG);
    return t != null && r.utils.isValid(t) ? t : n ?? nG(r);
  },
  cleanValue: ZH,
  areValuesEqual: QH,
  isSameError: (e, t) => e === t,
  hasError: (e) => e != null,
  defaultErrorState: null,
  getTimezone: (e, t) => t == null || !e.isValid(t) ? null : e.getTimezone(t),
  setTimezone: (e, t, n) => n == null ? null : e.setTimezone(n, t)
}, yG = {
  updateReferenceValue: (e, t, n) => t == null || !e.isValid(t) ? n : t,
  getSectionsFromValue: (e, t, n, r) => !e.isValid(t) && !!n ? n : r(t),
  getV7HiddenInputValueFromSections: lG,
  getV6InputValueFromSections: cG,
  getActiveDateManager: (e, t) => ({
    date: t.value,
    referenceDate: t.referenceValue,
    getSections: (n) => n,
    getNewValuesFromNewActiveDate: (n) => ({
      value: n,
      referenceValue: n == null || !e.isValid(n) ? t.referenceValue : n
    })
  }),
  parseValueStr: (e, t, n) => n(e.trim(), t)
};
function vG(e, t) {
  return Array.isArray(t) ? t.every((n) => e.indexOf(n) !== -1) : e.indexOf(t) !== -1;
}
const bG = (e, t) => (n) => {
  (n.key === "Enter" || n.key === " ") && (e(n), n.preventDefault(), n.stopPropagation());
}, yr = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? yr(t.shadowRoot) : t : null;
}, xG = "@media (pointer: fine)";
function wG(e) {
  return Fe("MuiPickersDay", e);
}
const aa = Le("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]), $G = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today", "isFirstVisibleCell", "isLastVisibleCell"], CG = (e) => {
  const {
    selected: t,
    disableMargin: n,
    disableHighlightToday: r,
    today: o,
    disabled: a,
    outsideCurrentMonth: l,
    showDaysOutsideCurrentMonth: c,
    classes: d
  } = e, p = l && !c;
  return Be({
    root: ["root", t && !p && "selected", a && "disabled", !n && "dayWithMargin", !r && o && "today", l && c && "dayOutsideMonth", p && "hiddenDaySpacingFiller"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  }, wG, d);
}, RT = ({
  theme: e
}) => ee({}, e.typography.caption, {
  width: Wl,
  height: Wl,
  borderRadius: "50%",
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: "transparent",
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.short
  }),
  color: (e.vars || e).palette.text.primary,
  "@media (pointer: fine)": {
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : ht(e.palette.primary.main, e.palette.action.hoverOpacity)
    }
  },
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : ht(e.palette.primary.main, e.palette.action.focusOpacity),
    [`&.${aa.selected}`]: {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${aa.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    fontWeight: e.typography.fontWeightMedium,
    "&:hover": {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${aa.disabled}:not(.${aa.selected})`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${aa.disabled}&.${aa.selected}`]: {
    opacity: 0.6
  },
  variants: [{
    props: {
      disableMargin: !1
    },
    style: {
      margin: `0 ${yp}px`
    }
  }, {
    props: {
      outsideCurrentMonth: !0,
      showDaysOutsideCurrentMonth: !0
    },
    style: {
      color: (e.vars || e).palette.text.secondary
    }
  }, {
    props: {
      disableHighlightToday: !1,
      today: !0
    },
    style: {
      [`&:not(.${aa.selected})`]: {
        border: `1px solid ${(e.vars || e).palette.text.secondary}`
      }
    }
  }]
}), kT = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, !n.disableMargin && t.dayWithMargin, !n.disableHighlightToday && n.today && t.today, !n.outsideCurrentMonth && n.showDaysOutsideCurrentMonth && t.dayOutsideMonth, n.outsideCurrentMonth && !n.showDaysOutsideCurrentMonth && t.hiddenDaySpacingFiller];
}, SG = ae(jo, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: kT
})(RT), TG = ae("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: kT
})(({
  theme: e
}) => ee({}, RT({
  theme: e
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: "none"
})), ul = () => {
}, _T = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = dn({
    props: t,
    name: "MuiPickersDay"
  }), {
    autoFocus: o = !1,
    className: a,
    day: l,
    disabled: c = !1,
    disableHighlightToday: d = !1,
    disableMargin: p = !1,
    isAnimating: f,
    onClick: m,
    onDaySelect: g,
    onFocus: y = ul,
    onBlur: b = ul,
    onKeyDown: v = ul,
    onMouseDown: $ = ul,
    onMouseEnter: S = ul,
    outsideCurrentMonth: R,
    selected: P = !1,
    showDaysOutsideCurrentMonth: T = !1,
    children: O,
    today: k = !1
  } = r, I = mt(r, $G), D = ee({}, r, {
    autoFocus: o,
    disabled: c,
    disableHighlightToday: d,
    disableMargin: p,
    selected: P,
    showDaysOutsideCurrentMonth: T,
    today: k
  }), j = CG(D), E = pn(), M = w.useRef(null), F = It(M, n);
  Nn(() => {
    o && !c && !f && !R && M.current.focus();
  }, [o, c, f, R]);
  const B = (z) => {
    $(z), R && z.preventDefault();
  }, V = (z) => {
    c || g(l), R && z.currentTarget.focus(), m && m(z);
  };
  return R && !T ? /* @__PURE__ */ x.jsx(TG, {
    className: _e(j.root, j.hiddenDaySpacingFiller, a),
    ownerState: D,
    role: I.role
  }) : /* @__PURE__ */ x.jsx(SG, ee({
    className: _e(j.root, a),
    ref: F,
    centerRipple: !0,
    disabled: c,
    tabIndex: P ? 0 : -1,
    onKeyDown: (z) => v(z, l),
    onFocus: (z) => y(z, l),
    onBlur: (z) => b(z, l),
    onMouseEnter: (z) => S(z, l),
    onClick: V,
    onMouseDown: B
  }, I, {
    ownerState: D,
    children: O || E.format(l, "dayOfMonth")
  }));
});
process.env.NODE_ENV !== "production" && (_T.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: i.oneOfType([i.func, i.shape({
    current: i.shape({
      focusVisible: i.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: i.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  className: i.string,
  component: i.elementType,
  /**
   * The date to show.
   */
  day: i.object.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: i.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: i.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: i.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: i.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: i.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: i.string,
  isAnimating: i.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: i.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: i.bool.isRequired,
  onBlur: i.func,
  onDaySelect: i.func.isRequired,
  onFocus: i.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: i.func,
  onKeyDown: i.func,
  onMouseEnter: i.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: i.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: i.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: i.bool,
  style: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * @default 0
   */
  tabIndex: i.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: i.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: i.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: i.oneOfType([i.func, i.shape({
    current: i.shape({
      pulsate: i.func.isRequired,
      start: i.func.isRequired,
      stop: i.func.isRequired
    })
  })])
});
const OG = /* @__PURE__ */ w.memo(_T), mc = ({
  props: e,
  value: t,
  timezone: n,
  adapter: r
}) => {
  if (t === null)
    return null;
  const {
    shouldDisableDate: o,
    shouldDisableMonth: a,
    shouldDisableYear: l,
    disablePast: c,
    disableFuture: d
  } = e, p = r.utils.date(void 0, n), f = eo(r.utils, e.minDate, r.defaultDates.minDate), m = eo(r.utils, e.maxDate, r.defaultDates.maxDate);
  switch (!0) {
    case !r.utils.isValid(t):
      return "invalidDate";
    case !!(o && o(t)):
      return "shouldDisableDate";
    case !!(a && a(t)):
      return "shouldDisableMonth";
    case !!(l && l(t)):
      return "shouldDisableYear";
    case !!(d && r.utils.isAfterDay(t, p)):
      return "disableFuture";
    case !!(c && r.utils.isBeforeDay(t, p)):
      return "disablePast";
    case !!(f && r.utils.isBeforeDay(t, f)):
      return "minDate";
    case !!(m && r.utils.isAfterDay(t, m)):
      return "maxDate";
    default:
      return null;
  }
};
mc.valueManager = Bo;
const DT = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"], PG = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"], EG = ["minDateTime", "maxDateTime"], RG = [...DT, ...PG, ...EG], IT = (e) => RG.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {});
function MT(e) {
  const {
    props: t,
    validator: n,
    value: r,
    timezone: o,
    onError: a
  } = e, l = Pa(), c = w.useRef(n.valueManager.defaultErrorState), d = n({
    adapter: l,
    value: r,
    timezone: o,
    props: t
  }), p = n.valueManager.hasError(d);
  w.useEffect(() => {
    a && !n.valueManager.isSameError(d, c.current) && a(d, r), c.current = d;
  }, [n, a, d, r]);
  const f = ze((m) => n({
    adapter: l,
    value: m,
    timezone: o,
    props: t
  }));
  return {
    validationError: d,
    hasValidationError: p,
    getValidationErrorForNewValue: f
  };
}
const kG = ({
  utils: e,
  format: t
}) => {
  let n = 10, r = t, o = e.expandFormat(t);
  for (; o !== r; )
    if (r = o, o = e.expandFormat(r), n -= 1, n < 0)
      throw new Error("MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the picker component.");
  return o;
}, _G = ({
  utils: e,
  expandedFormat: t
}) => {
  const n = [], {
    start: r,
    end: o
  } = e.escapedCharacters, a = new RegExp(`(\\${r}[^\\${o}]*\\${o})+`, "g");
  let l = null;
  for (; l = a.exec(t); )
    n.push({
      start: l.index,
      end: a.lastIndex - 1
    });
  return n;
}, DG = (e, t, n, r) => {
  switch (n.type) {
    case "year":
      return t.fieldYearPlaceholder({
        digitAmount: e.formatByString(e.date(void 0, "default"), r).length,
        format: r
      });
    case "month":
      return t.fieldMonthPlaceholder({
        contentType: n.contentType,
        format: r
      });
    case "day":
      return t.fieldDayPlaceholder({
        format: r
      });
    case "weekDay":
      return t.fieldWeekDayPlaceholder({
        contentType: n.contentType,
        format: r
      });
    case "hours":
      return t.fieldHoursPlaceholder({
        format: r
      });
    case "minutes":
      return t.fieldMinutesPlaceholder({
        format: r
      });
    case "seconds":
      return t.fieldSecondsPlaceholder({
        format: r
      });
    case "meridiem":
      return t.fieldMeridiemPlaceholder({
        format: r
      });
    default:
      return r;
  }
}, IG = ({
  utils: e,
  date: t,
  shouldRespectLeadingZeros: n,
  localeText: r,
  localizedDigits: o,
  now: a,
  token: l,
  startSeparator: c
}) => {
  if (l === "")
    throw new Error("MUI X: Should not call `commitToken` with an empty token");
  const d = cy(e, l), p = ET(e, d.contentType, d.type, l), f = n ? p : d.contentType === "digit", m = t != null && e.isValid(t);
  let g = m ? e.formatByString(t, l) : "", y = null;
  if (f)
    if (p)
      y = g === "" ? e.formatByString(a, l).length : g.length;
    else {
      if (d.maxLength == null)
        throw new Error(`MUI X: The token ${l} should have a 'maxDigitNumber' property on it's adapter`);
      y = d.maxLength, m && (g = uy(TT(Ca(g, o), y), o));
    }
  return ee({}, d, {
    format: l,
    maxLength: y,
    value: g,
    placeholder: DG(e, r, d, l),
    hasLeadingZerosInFormat: p,
    hasLeadingZerosInInput: f,
    startSeparator: c,
    endSeparator: "",
    modified: !1
  });
}, MG = (e) => {
  var y;
  const {
    utils: t,
    expandedFormat: n,
    escapedParts: r
  } = e, o = t.date(void 0), a = [];
  let l = "";
  const c = Object.keys(t.formatTokenMap).sort((b, v) => v.length - b.length), d = /^([a-zA-Z]+)/, p = new RegExp(`^(${c.join("|")})*$`), f = new RegExp(`^(${c.join("|")})`), m = (b) => r.find((v) => v.start <= b && v.end >= b);
  let g = 0;
  for (; g < n.length; ) {
    const b = m(g), v = b != null, $ = (y = d.exec(n.slice(g))) == null ? void 0 : y[1];
    if (!v && $ != null && p.test($)) {
      let S = $;
      for (; S.length > 0; ) {
        const R = f.exec(S)[1];
        S = S.slice(R.length), a.push(IG(ee({}, e, {
          now: o,
          token: R,
          startSeparator: l
        }))), l = "";
      }
      g += $.length;
    } else {
      const S = n[g];
      v && (b == null ? void 0 : b.start) === g || (b == null ? void 0 : b.end) === g || (a.length === 0 ? l += S : a[a.length - 1].endSeparator += S), g += 1;
    }
  }
  return a.length === 0 && l.length > 0 && a.push({
    type: "empty",
    contentType: "letter",
    maxLength: null,
    format: "",
    value: "",
    placeholder: "",
    hasLeadingZerosInFormat: !1,
    hasLeadingZerosInInput: !1,
    startSeparator: l,
    endSeparator: "",
    modified: !1
  }), a;
}, AG = ({
  isRtl: e,
  formatDensity: t,
  sections: n
}) => n.map((r) => {
  const o = (a) => {
    let l = a;
    return e && l !== null && l.includes(" ") && (l = `⁩${l}⁦`), t === "spacious" && ["/", ".", "-"].includes(l) && (l = ` ${l} `), l;
  };
  return r.startSeparator = o(r.startSeparator), r.endSeparator = o(r.endSeparator), r;
}), t$ = (e) => {
  let t = kG(e);
  e.isRtl && e.enableAccessibleFieldDOMStructure && (t = t.split(" ").reverse().join(" "));
  const n = _G(ee({}, e, {
    expandedFormat: t
  })), r = MG(ee({}, e, {
    expandedFormat: t,
    escapedParts: n
  }));
  return AG(ee({}, e, {
    sections: r
  }));
}, NG = (e) => {
  const t = pn(), n = bi(), r = Pa(), o = no(), {
    valueManager: a,
    fieldValueManager: l,
    valueType: c,
    validator: d,
    internalProps: p,
    internalProps: {
      value: f,
      defaultValue: m,
      referenceDate: g,
      onChange: y,
      format: b,
      formatDensity: v = "dense",
      selectedSections: $,
      onSelectedSectionsChange: S,
      shouldRespectLeadingZeros: R = !1,
      timezone: P,
      enableAccessibleFieldDOMStructure: T = !1
    }
  } = e, {
    timezone: O,
    value: k,
    handleValueChange: I
  } = sy({
    timezone: P,
    value: f,
    defaultValue: m,
    referenceDate: g,
    onChange: y,
    valueManager: a
  }), D = w.useMemo(() => iG(t), [t]), j = w.useMemo(() => uG(t, D, O), [t, D, O]), E = w.useCallback((X, re = null) => l.getSectionsFromValue(t, X, re, (ie) => t$({
    utils: t,
    localeText: n,
    localizedDigits: D,
    format: b,
    date: ie,
    formatDensity: v,
    shouldRespectLeadingZeros: R,
    enableAccessibleFieldDOMStructure: T,
    isRtl: o
  })), [l, b, n, D, o, R, t, v, T]), [M, F] = w.useState(() => {
    const X = E(k);
    Qw(X, c);
    const re = {
      sections: X,
      value: k,
      referenceValue: a.emptyValue,
      tempValueStrAndroid: null
    }, ie = tG(X), Y = a.getInitialReferenceValue({
      referenceDate: g,
      value: k,
      utils: t,
      props: p,
      granularity: ie,
      timezone: O
    });
    return ee({}, re, {
      referenceValue: Y
    });
  }), [B, V] = sr({
    controlled: $,
    default: null,
    name: "useField",
    state: "selectedSections"
  }), z = (X) => {
    V(X), S == null || S(X);
  }, L = w.useMemo(() => Ag(B, M.sections), [B, M.sections]), G = L === "all" ? 0 : L, se = ({
    value: X,
    referenceValue: re,
    sections: ie
  }) => {
    if (F((Z) => ee({}, Z, {
      sections: ie,
      value: X,
      referenceValue: re,
      tempValueStrAndroid: null
    })), a.areValuesEqual(t, M.value, X))
      return;
    const Y = {
      validationError: d({
        adapter: r,
        value: X,
        timezone: O,
        props: p
      })
    };
    I(X, Y);
  }, ne = (X, re) => {
    const ie = [...M.sections];
    return ie[X] = ee({}, ie[X], {
      value: re,
      modified: !0
    }), ie;
  }, K = () => {
    se({
      value: a.emptyValue,
      referenceValue: M.referenceValue,
      sections: E(a.emptyValue)
    });
  }, Q = () => {
    if (G == null)
      return;
    const X = M.sections[G], re = l.getActiveDateManager(t, M, X), Y = re.getSections(M.sections).filter((W) => W.value !== "").length === (X.value === "" ? 0 : 1), Z = ne(G, ""), ue = Y ? null : t.getInvalidDate(), ge = re.getNewValuesFromNewActiveDate(ue);
    se(ee({}, ge, {
      sections: Z
    }));
  }, ye = (X) => {
    const re = (Z, ue) => {
      const ge = t.parse(Z, b);
      if (ge == null || !t.isValid(ge))
        return null;
      const W = t$({
        utils: t,
        localeText: n,
        localizedDigits: D,
        format: b,
        date: ge,
        formatDensity: v,
        shouldRespectLeadingZeros: R,
        enableAccessibleFieldDOMStructure: T,
        isRtl: o
      });
      return e$(t, ge, W, ue, !1);
    }, ie = l.parseValueStr(X, M.referenceValue, re), Y = l.updateReferenceValue(t, ie, M.referenceValue);
    se({
      value: ie,
      referenceValue: Y,
      sections: E(ie, M.sections)
    });
  }, we = ({
    activeSection: X,
    newSectionValue: re,
    shouldGoToNextSection: ie
  }) => {
    ie && G < M.sections.length - 1 && z(G + 1);
    const Y = l.getActiveDateManager(t, M, X), Z = ne(G, re), ue = Y.getSections(Z), ge = sG(t, ue, D);
    let W, J;
    if (ge != null && t.isValid(ge)) {
      const le = e$(t, ge, ue, Y.referenceDate, !0);
      W = Y.getNewValuesFromNewActiveDate(le), J = !0;
    } else
      W = Y.getNewValuesFromNewActiveDate(ge), J = (ge != null && !t.isValid(ge)) != (Y.date != null && !t.isValid(Y.date));
    return J ? se(ee({}, W, {
      sections: Z
    })) : F((le) => ee({}, le, W, {
      sections: Z,
      tempValueStrAndroid: null
    }));
  }, fe = (X) => F((re) => ee({}, re, {
    tempValueStrAndroid: X
  }));
  return w.useEffect(() => {
    const X = E(M.value);
    Qw(X, c), F((re) => ee({}, re, {
      sections: X
    }));
  }, [b, t.locale, o]), w.useEffect(() => {
    let X;
    a.areValuesEqual(t, M.value, k) ? X = a.getTimezone(t, M.value) !== a.getTimezone(t, k) : X = !0, X && F((re) => ee({}, re, {
      value: k,
      referenceValue: l.updateReferenceValue(t, k, re.referenceValue),
      sections: E(k)
    }));
  }, [k]), {
    state: M,
    activeSectionIndex: G,
    parsedSelectedSections: L,
    setSelectedSections: z,
    clearValue: K,
    clearActiveSection: Q,
    updateSectionValue: we,
    updateValueFromValueStr: ye,
    setTempAndroidValueStr: fe,
    getSectionsFromValue: E,
    sectionsValueBoundaries: j,
    localizedDigits: D,
    timezone: O
  };
}, jG = 5e3, Ka = (e) => e.saveQuery != null, FG = ({
  sections: e,
  updateSectionValue: t,
  sectionsValueBoundaries: n,
  localizedDigits: r,
  setTempAndroidValueStr: o,
  timezone: a
}) => {
  const l = pn(), [c, d] = w.useState(null), p = ze(() => d(null));
  w.useEffect(() => {
    var b;
    c != null && ((b = e[c.sectionIndex]) == null ? void 0 : b.type) !== c.sectionType && p();
  }, [e, c, p]), w.useEffect(() => {
    if (c != null) {
      const b = setTimeout(() => p(), jG);
      return () => {
        clearTimeout(b);
      };
    }
    return () => {
    };
  }, [c, p]);
  const f = ({
    keyPressed: b,
    sectionIndex: v
  }, $, S) => {
    const R = b.toLowerCase(), P = e[v];
    if (c != null && (!S || S(c.value)) && c.sectionIndex === v) {
      const O = `${c.value}${R}`, k = $(O, P);
      if (!Ka(k))
        return d({
          sectionIndex: v,
          value: O,
          sectionType: P.type
        }), k;
    }
    const T = $(R, P);
    return Ka(T) && !T.saveQuery ? (p(), null) : (d({
      sectionIndex: v,
      value: R,
      sectionType: P.type
    }), Ka(T) ? null : T);
  }, m = (b) => {
    const v = (R, P, T) => {
      const O = P.filter((k) => k.toLowerCase().startsWith(T));
      return O.length === 0 ? {
        saveQuery: !1
      } : {
        sectionValue: O[0],
        shouldGoToNextSection: O.length === 1
      };
    }, $ = (R, P, T, O) => {
      const k = (I) => ST(l, a, P.type, I);
      if (P.contentType === "letter")
        return v(P.format, k(P.format), R);
      if (T && O != null && cy(l, T).contentType === "letter") {
        const I = k(T), D = v(T, I, R);
        return Ka(D) ? {
          saveQuery: !1
        } : ee({}, D, {
          sectionValue: O(D.sectionValue, I)
        });
      }
      return {
        saveQuery: !1
      };
    };
    return f(b, (R, P) => {
      switch (P.type) {
        case "month": {
          const T = (O) => Xw(l, O, l.formats.month, P.format);
          return $(R, P, l.formats.month, T);
        }
        case "weekDay": {
          const T = (O, k) => k.indexOf(O).toString();
          return $(R, P, l.formats.weekday, T);
        }
        case "meridiem":
          return $(R, P);
        default:
          return {
            saveQuery: !1
          };
      }
    });
  }, g = (b) => {
    const v = (S, R) => {
      const P = Ca(S, r), T = Number(P), O = n[R.type]({
        currentDate: null,
        format: R.format,
        contentType: R.contentType
      });
      if (T > O.maximum)
        return {
          saveQuery: !1
        };
      if (T < O.minimum)
        return {
          saveQuery: !0
        };
      const k = T * 10 > O.maximum || P.length === O.maximum.toString().length;
      return {
        sectionValue: OT(l, T, O, r, R),
        shouldGoToNextSection: k
      };
    };
    return f(b, (S, R) => {
      if (R.contentType === "digit" || R.contentType === "digit-with-letter")
        return v(S, R);
      if (R.type === "month") {
        ET(l, "digit", "month", "MM");
        const P = v(S, {
          type: R.type,
          format: "MM",
          hasLeadingZerosInInput: !0,
          contentType: "digit",
          maxLength: 2
        });
        if (Ka(P))
          return P;
        const T = Xw(l, P.sectionValue, "MM", R.format);
        return ee({}, P, {
          sectionValue: T
        });
      }
      if (R.type === "weekDay") {
        const P = v(S, R);
        if (Ka(P))
          return P;
        const T = bp(l, R.format)[Number(P.sectionValue) - 1];
        return ee({}, P, {
          sectionValue: T
        });
      }
      return {
        saveQuery: !1
      };
    }, (S) => Kw(S, r));
  };
  return {
    applyCharacterEditing: ze((b) => {
      const v = e[b.sectionIndex], S = Kw(b.keyPressed, r) ? g(ee({}, b, {
        keyPressed: uy(b.keyPressed, r)
      })) : m(b);
      if (S == null) {
        o(null);
        return;
      }
      t({
        activeSection: v,
        newSectionValue: S.sectionValue,
        shouldGoToNextSection: S.shouldGoToNextSection
      });
    }),
    resetCharacterQuery: p
  };
}, LG = (e) => {
  const {
    internalProps: {
      disabled: t,
      readOnly: n = !1
    },
    forwardedProps: {
      sectionListRef: r,
      onBlur: o,
      onClick: a,
      onFocus: l,
      onInput: c,
      onPaste: d,
      focused: p,
      autoFocus: f = !1
    },
    fieldValueManager: m,
    applyCharacterEditing: g,
    resetCharacterQuery: y,
    setSelectedSections: b,
    parsedSelectedSections: v,
    state: $,
    clearActiveSection: S,
    clearValue: R,
    updateSectionValue: P,
    updateValueFromValueStr: T,
    sectionOrder: O,
    areAllSectionsEmpty: k,
    sectionsValueBoundaries: I
  } = e, D = w.useRef(null), j = It(r, D), E = bi(), M = pn(), F = Mr(), [B, V] = w.useState(!1), z = w.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!D.current)
        return;
      const J = document.getSelection();
      if (!J)
        return;
      if (v == null) {
        J.rangeCount > 0 && D.current.getRoot().contains(J.getRangeAt(0).startContainer) && J.removeAllRanges(), B && D.current.getRoot().blur();
        return;
      }
      if (!D.current.getRoot().contains(yr(document)))
        return;
      const le = new window.Range();
      let me;
      v === "all" ? me = D.current.getRoot() : $.sections[v].type === "empty" ? me = D.current.getSectionContainer(v) : me = D.current.getSectionContent(v), le.selectNodeContents(me), me.focus(), J.removeAllRanges(), J.addRange(le);
    },
    getActiveSectionIndexFromDOM: () => {
      const J = yr(document);
      return !J || !D.current || !D.current.getRoot().contains(J) ? null : D.current.getSectionIndexFromDOMElement(J);
    },
    focusField: (J = 0) => {
      if (!D.current || // if the field is already focused, we don't need to focus it again
      z.getActiveSectionIndexFromDOM() != null)
        return;
      const le = Ag(J, $.sections);
      V(!0), D.current.getSectionContent(le).focus();
    },
    setSelectedSections: (J) => {
      if (!D.current)
        return;
      const le = Ag(J, $.sections);
      V((le === "all" ? 0 : le) !== null), b(J);
    },
    isFieldFocused: () => {
      const J = yr(document);
      return !!D.current && D.current.getRoot().contains(J);
    }
  }), [v, b, $.sections, B]), L = ze((J) => {
    if (!D.current)
      return;
    const le = $.sections[J];
    D.current.getSectionContent(J).innerHTML = le.value || le.placeholder, z.syncSelectionToDOM();
  }), G = ze((J, ...le) => {
    J.isDefaultPrevented() || !D.current || (V(!0), a == null || a(J, ...le), v === "all" ? setTimeout(() => {
      const me = document.getSelection().getRangeAt(0).startOffset;
      if (me === 0) {
        b(O.startIndex);
        return;
      }
      let be = 0, de = 0;
      for (; de < me && be < $.sections.length; ) {
        const Oe = $.sections[be];
        be += 1, de += `${Oe.startSeparator}${Oe.value || Oe.placeholder}${Oe.endSeparator}`.length;
      }
      b(be - 1);
    }) : B ? D.current.getRoot().contains(J.target) || b(O.startIndex) : (V(!0), b(O.startIndex)));
  }), se = ze((J) => {
    if (c == null || c(J), !D.current || v !== "all")
      return;
    const me = J.target.textContent ?? "";
    D.current.getRoot().innerHTML = $.sections.map((be) => `${be.startSeparator}${be.value || be.placeholder}${be.endSeparator}`).join(""), z.syncSelectionToDOM(), me.length === 0 || me.charCodeAt(0) === 10 ? (y(), R(), b("all")) : me.length > 1 ? T(me) : (v === "all" && b(0), g({
      keyPressed: me,
      sectionIndex: 0
    }));
  }), ne = ze((J) => {
    if (d == null || d(J), n || v !== "all") {
      J.preventDefault();
      return;
    }
    const le = J.clipboardData.getData("text");
    J.preventDefault(), y(), T(le);
  }), K = ze((...J) => {
    if (l == null || l(...J), B || !D.current)
      return;
    V(!0), D.current.getSectionIndexFromDOMElement(yr(document)) != null || b(O.startIndex);
  }), Q = ze((...J) => {
    o == null || o(...J), setTimeout(() => {
      if (!D.current)
        return;
      const le = yr(document);
      !D.current.getRoot().contains(le) && (V(!1), b(null));
    });
  }), ye = ze((J) => (le) => {
    le.isDefaultPrevented() || b(J);
  }), we = ze((J) => {
    J.preventDefault();
  }), fe = ze((J) => () => {
    b(J);
  }), X = ze((J) => {
    if (J.preventDefault(), n || t || typeof v != "number")
      return;
    const le = $.sections[v], me = J.clipboardData.getData("text"), be = /^[a-zA-Z]+$/.test(me), de = /^[0-9]+$/.test(me), Oe = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(me);
    le.contentType === "letter" && be || le.contentType === "digit" && de || le.contentType === "digit-with-letter" && Oe ? (y(), P({
      activeSection: le,
      newSectionValue: me,
      shouldGoToNextSection: !0
    })) : !be && !de && (y(), T(me));
  }), re = ze((J) => {
    J.preventDefault(), J.dataTransfer.dropEffect = "none";
  }), ie = ze((J) => {
    if (!D.current)
      return;
    const le = J.target, me = le.textContent ?? "", be = D.current.getSectionIndexFromDOMElement(le), de = $.sections[be];
    if (n || !D.current) {
      L(be);
      return;
    }
    if (me.length === 0) {
      if (de.value === "") {
        L(be);
        return;
      }
      const Oe = J.nativeEvent.inputType;
      if (Oe === "insertParagraph" || Oe === "insertLineBreak") {
        L(be);
        return;
      }
      y(), S();
      return;
    }
    g({
      keyPressed: me,
      sectionIndex: be
    }), L(be);
  });
  Nn(() => {
    if (!(!B || !D.current)) {
      if (v === "all")
        D.current.getRoot().focus();
      else if (typeof v == "number") {
        const J = D.current.getSectionContent(v);
        J && J.focus();
      }
    }
  }, [v, B]);
  const Y = w.useMemo(() => $.sections.reduce((J, le) => (J[le.type] = I[le.type]({
    currentDate: null,
    contentType: le.contentType,
    format: le.format
  }), J), {}), [I, $.sections]), Z = v === "all", ue = w.useMemo(() => $.sections.map((J, le) => {
    const me = !Z && !t && !n;
    return {
      container: {
        "data-sectionindex": le,
        onClick: ye(le)
      },
      content: {
        tabIndex: Z || le > 0 ? -1 : 0,
        contentEditable: !Z && !t && !n,
        role: "spinbutton",
        id: `${F}-${J.type}`,
        "aria-labelledby": `${F}-${J.type}`,
        "aria-readonly": n,
        "aria-valuenow": mG(J, M),
        "aria-valuemin": Y[J.type].minimum,
        "aria-valuemax": Y[J.type].maximum,
        "aria-valuetext": J.value ? hG(J, M) : E.empty,
        "aria-label": E[J.type],
        "aria-disabled": t,
        spellCheck: me ? !1 : void 0,
        autoCapitalize: me ? "off" : void 0,
        autoCorrect: me ? "off" : void 0,
        [parseInt(w.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: me ? "next" : void 0,
        children: J.value || J.placeholder,
        onInput: ie,
        onPaste: X,
        onFocus: fe(le),
        onDragOver: re,
        onMouseUp: we,
        inputMode: J.contentType === "letter" ? "text" : "numeric"
      },
      before: {
        children: J.startSeparator
      },
      after: {
        children: J.endSeparator
      }
    };
  }), [$.sections, fe, X, re, ie, ye, we, t, n, Z, E, M, Y, F]), ge = ze((J) => {
    T(J.target.value);
  }), W = w.useMemo(() => k ? "" : m.getV7HiddenInputValueFromSections($.sections), [k, $.sections, m]);
  return w.useEffect(() => {
    if (D.current == null)
      throw new Error(["MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`", "You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.", "", "If you want to keep using an `<input />` HTML element for the editing, please remove the `enableAccessibleFieldDOMStructure` prop from your picker or field component:", "", "<DatePicker slots={{ textField: MyCustomTextField }} />", "", "Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element"].join(`
`));
    f && D.current && D.current.getSectionContent(O.startIndex).focus();
  }, []), {
    interactions: z,
    returnedValue: {
      // Forwarded
      autoFocus: f,
      readOnly: n,
      focused: p ?? B,
      sectionListRef: j,
      onBlur: Q,
      onClick: G,
      onFocus: K,
      onInput: se,
      onPaste: ne,
      // Additional
      enableAccessibleFieldDOMStructure: !0,
      elements: ue,
      // TODO v7: Try to set to undefined when there is a section selected.
      tabIndex: v === 0 ? -1 : 0,
      contentEditable: Z,
      value: W,
      onChange: ge,
      areAllSectionsEmpty: k
    }
  };
}, ts = (e) => e.replace(/[\u2066\u2067\u2068\u2069]/g, ""), BG = (e, t, n) => {
  let r = 0, o = n ? 1 : 0;
  const a = [];
  for (let l = 0; l < e.length; l += 1) {
    const c = e[l], d = dy(c, n ? "input-rtl" : "input-ltr", t), p = `${c.startSeparator}${d}${c.endSeparator}`, f = ts(p).length, m = p.length, g = ts(d), y = o + (g === "" ? 0 : d.indexOf(g[0])) + c.startSeparator.length, b = y + g.length;
    a.push(ee({}, c, {
      start: r,
      end: r + f,
      startInInput: y,
      endInInput: b
    })), r += f, o += m;
  }
  return a;
}, VG = (e) => {
  const t = no(), n = w.useRef(void 0), r = w.useRef(void 0), {
    forwardedProps: {
      onFocus: o,
      onClick: a,
      onPaste: l,
      onBlur: c,
      inputRef: d,
      placeholder: p
    },
    internalProps: {
      readOnly: f = !1,
      disabled: m = !1
    },
    parsedSelectedSections: g,
    activeSectionIndex: y,
    state: b,
    fieldValueManager: v,
    valueManager: $,
    applyCharacterEditing: S,
    resetCharacterQuery: R,
    updateSectionValue: P,
    updateValueFromValueStr: T,
    clearActiveSection: O,
    clearValue: k,
    setTempAndroidValueStr: I,
    setSelectedSections: D,
    getSectionsFromValue: j,
    areAllSectionsEmpty: E,
    localizedDigits: M
  } = e, F = w.useRef(null), B = It(d, F), V = w.useMemo(() => BG(b.sections, M, t), [b.sections, M, t]), z = w.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!F.current)
        return;
      if (g == null) {
        F.current.scrollLeft && (F.current.scrollLeft = 0);
        return;
      }
      if (F.current !== yr(document))
        return;
      const ie = F.current.scrollTop;
      if (g === "all")
        F.current.select();
      else {
        const Y = V[g], Z = Y.type === "empty" ? Y.startInInput - Y.startSeparator.length : Y.startInInput, ue = Y.type === "empty" ? Y.endInInput + Y.endSeparator.length : Y.endInInput;
        (Z !== F.current.selectionStart || ue !== F.current.selectionEnd) && F.current === yr(document) && F.current.setSelectionRange(Z, ue), clearTimeout(r.current), r.current = setTimeout(() => {
          F.current && F.current === yr(document) && // The section might loose all selection, where `selectionStart === selectionEnd`
          // https://github.com/mui/mui-x/pull/13652
          F.current.selectionStart === F.current.selectionEnd && (F.current.selectionStart !== Z || F.current.selectionEnd !== ue) && z.syncSelectionToDOM();
        });
      }
      F.current.scrollTop = ie;
    },
    getActiveSectionIndexFromDOM: () => {
      const ie = F.current.selectionStart ?? 0, Y = F.current.selectionEnd ?? 0;
      if (ie === 0 && Y === 0)
        return null;
      const Z = ie <= V[0].startInInput ? 1 : V.findIndex((ue) => ue.startInInput - ue.startSeparator.length > ie);
      return Z === -1 ? V.length - 1 : Z - 1;
    },
    focusField: (ie = 0) => {
      var Y;
      yr(document) !== F.current && ((Y = F.current) == null || Y.focus(), D(ie));
    },
    setSelectedSections: (ie) => D(ie),
    isFieldFocused: () => F.current === yr(document)
  }), [F, g, V, D]), L = () => {
    const ie = F.current.selectionStart ?? 0;
    let Y;
    ie <= V[0].startInInput || ie >= V[V.length - 1].endInInput ? Y = 1 : Y = V.findIndex((ue) => ue.startInInput - ue.startSeparator.length > ie);
    const Z = Y === -1 ? V.length - 1 : Y - 1;
    D(Z);
  }, G = ze((...ie) => {
    o == null || o(...ie);
    const Y = F.current;
    clearTimeout(n.current), n.current = setTimeout(() => {
      !Y || Y !== F.current || y == null && (// avoid selecting all sections when focusing empty field without value
      Y.value.length && Number(Y.selectionEnd) - Number(Y.selectionStart) === Y.value.length ? D("all") : L());
    });
  }), se = ze((ie, ...Y) => {
    ie.isDefaultPrevented() || (a == null || a(ie, ...Y), L());
  }), ne = ze((ie) => {
    if (l == null || l(ie), ie.preventDefault(), f || m)
      return;
    const Y = ie.clipboardData.getData("text");
    if (typeof g == "number") {
      const Z = b.sections[g], ue = /^[a-zA-Z]+$/.test(Y), ge = /^[0-9]+$/.test(Y), W = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(Y);
      if (Z.contentType === "letter" && ue || Z.contentType === "digit" && ge || Z.contentType === "digit-with-letter" && W) {
        R(), P({
          activeSection: Z,
          newSectionValue: Y,
          shouldGoToNextSection: !0
        });
        return;
      }
      if (ue || ge)
        return;
    }
    R(), T(Y);
  }), K = ze((...ie) => {
    c == null || c(...ie), D(null);
  }), Q = ze((ie) => {
    if (f)
      return;
    const Y = ie.target.value;
    if (Y === "") {
      R(), k();
      return;
    }
    const Z = ie.nativeEvent.data, ue = Z && Z.length > 1, ge = ue ? Z : Y, W = ts(ge);
    if (g === "all" && D(y), y == null || ue) {
      T(ue ? Z : W);
      return;
    }
    let J;
    if (g === "all" && W.length === 1)
      J = W;
    else {
      const le = ts(v.getV6InputValueFromSections(V, M, t));
      let me = -1, be = -1;
      for (let We = 0; We < le.length; We += 1)
        me === -1 && le[We] !== W[We] && (me = We), be === -1 && le[le.length - We - 1] !== W[W.length - We - 1] && (be = We);
      const de = V[y];
      if (me < de.start || le.length - be - 1 > de.end)
        return;
      const Re = W.length - le.length + de.end - ts(de.endSeparator || "").length;
      J = W.slice(de.start + ts(de.startSeparator || "").length, Re);
    }
    if (J.length === 0) {
      pG() && I(ge), R(), O();
      return;
    }
    S({
      keyPressed: J,
      sectionIndex: y
    });
  }), ye = w.useMemo(() => p !== void 0 ? p : v.getV6InputValueFromSections(j($.emptyValue), M, t), [p, v, j, $.emptyValue, M, t]), we = w.useMemo(() => b.tempValueStrAndroid ?? v.getV6InputValueFromSections(b.sections, M, t), [b.sections, v, b.tempValueStrAndroid, M, t]);
  w.useEffect(() => (F.current && F.current === yr(document) && D("all"), () => {
    clearTimeout(n.current), clearTimeout(r.current);
  }), []);
  const fe = w.useMemo(() => y == null || b.sections[y].contentType === "letter" ? "text" : "numeric", [y, b.sections]), re = !(F.current && F.current === yr(document)) && E;
  return {
    interactions: z,
    returnedValue: {
      // Forwarded
      readOnly: f,
      onBlur: K,
      onClick: se,
      onFocus: G,
      onPaste: ne,
      inputRef: B,
      // Additional
      enableAccessibleFieldDOMStructure: !1,
      placeholder: ye,
      inputMode: fe,
      autoComplete: "off",
      value: re ? "" : we,
      onChange: Q
    }
  };
}, zG = (e) => {
  const t = pn(), {
    internalProps: n,
    internalProps: {
      unstableFieldRef: r,
      minutesStep: o,
      enableAccessibleFieldDOMStructure: a = !1,
      disabled: l = !1,
      readOnly: c = !1
    },
    forwardedProps: {
      onKeyDown: d,
      error: p,
      clearable: f,
      onClear: m
    },
    fieldValueManager: g,
    valueManager: y,
    validator: b
  } = e, v = no(), $ = NG(e), {
    state: S,
    activeSectionIndex: R,
    parsedSelectedSections: P,
    setSelectedSections: T,
    clearValue: O,
    clearActiveSection: k,
    updateSectionValue: I,
    setTempAndroidValueStr: D,
    sectionsValueBoundaries: j,
    localizedDigits: E,
    timezone: M
  } = $, F = FG({
    sections: S.sections,
    updateSectionValue: I,
    sectionsValueBoundaries: j,
    localizedDigits: E,
    setTempAndroidValueStr: D,
    timezone: M
  }), {
    resetCharacterQuery: B
  } = F, V = y.areValuesEqual(t, S.value, y.emptyValue), z = a ? LG : VG, L = w.useMemo(() => fG(S.sections, v && !a), [S.sections, v, a]), {
    returnedValue: G,
    interactions: se
  } = z(ee({}, e, $, F, {
    areAllSectionsEmpty: V,
    sectionOrder: L
  })), ne = ze((X) => {
    if (d == null || d(X), !l)
      switch (!0) {
        // Select all
        case ((X.ctrlKey || X.metaKey) && String.fromCharCode(X.keyCode) === "A" && !X.shiftKey && !X.altKey): {
          X.preventDefault(), T("all");
          break;
        }
        // Move selection to next section
        case X.key === "ArrowRight": {
          if (X.preventDefault(), P == null)
            T(L.startIndex);
          else if (P === "all")
            T(L.endIndex);
          else {
            const re = L.neighbors[P].rightIndex;
            re !== null && T(re);
          }
          break;
        }
        // Move selection to previous section
        case X.key === "ArrowLeft": {
          if (X.preventDefault(), P == null)
            T(L.endIndex);
          else if (P === "all")
            T(L.startIndex);
          else {
            const re = L.neighbors[P].leftIndex;
            re !== null && T(re);
          }
          break;
        }
        // Reset the value of the selected section
        case X.key === "Delete": {
          if (X.preventDefault(), c)
            break;
          P == null || P === "all" ? O() : k(), B();
          break;
        }
        // Increment / decrement the selected section value
        case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes(X.key): {
          if (X.preventDefault(), c || R == null)
            break;
          P === "all" && T(R);
          const re = S.sections[R], ie = g.getActiveDateManager(t, S, re), Y = aG(t, M, re, X.key, j, E, ie.date, {
            minutesStep: o
          });
          I({
            activeSection: re,
            newSectionValue: Y,
            shouldGoToNextSection: !1
          });
          break;
        }
      }
  });
  Nn(() => {
    se.syncSelectionToDOM();
  });
  const {
    hasValidationError: K
  } = MT({
    props: n,
    validator: b,
    timezone: M,
    value: S.value,
    onError: n.onError
  }), Q = w.useMemo(() => p !== void 0 ? p : K, [K, p]);
  w.useEffect(() => {
    !Q && R == null && B();
  }, [S.referenceValue, R, Q]), w.useEffect(() => {
    S.tempValueStrAndroid != null && R != null && (B(), k());
  }, [S.sections]), w.useImperativeHandle(r, () => ({
    getSections: () => S.sections,
    getActiveSectionIndex: se.getActiveSectionIndexFromDOM,
    setSelectedSections: se.setSelectedSections,
    focusField: se.focusField,
    isFieldFocused: se.isFieldFocused
  }));
  const ye = ze((X, ...re) => {
    X.preventDefault(), m == null || m(X, ...re), O(), se.isFieldFocused() ? T(L.startIndex) : se.focusField(0);
  }), we = {
    onKeyDown: ne,
    onClear: ye,
    error: Q,
    clearable: !!(f && !V && !c && !l)
  }, fe = {
    disabled: l,
    readOnly: c
  };
  return ee({}, e.forwardedProps, we, fe, G);
}, WG = ["clearable", "onClear", "InputProps", "sx", "slots", "slotProps"], qG = ["ownerState"], UG = (e) => {
  const t = bi(), {
    clearable: n,
    onClear: r,
    InputProps: o,
    sx: a,
    slots: l,
    slotProps: c
  } = e, d = mt(e, WG), p = (l == null ? void 0 : l.clearButton) ?? Vo, f = Lt({
    elementType: p,
    externalSlotProps: c == null ? void 0 : c.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: t.fieldClearLabel
    }
  }), m = mt(f, qG), g = (l == null ? void 0 : l.clearIcon) ?? MH, y = Lt({
    elementType: g,
    externalSlotProps: c == null ? void 0 : c.clearIcon,
    ownerState: {}
  });
  return ee({}, d, {
    InputProps: ee({}, o, {
      endAdornment: /* @__PURE__ */ x.jsxs(w.Fragment, {
        children: [n && /* @__PURE__ */ x.jsx(Rs, {
          position: "end",
          sx: {
            marginRight: o != null && o.endAdornment ? -1 : -1.5
          },
          children: /* @__PURE__ */ x.jsx(p, ee({}, m, {
            onClick: r,
            children: /* @__PURE__ */ x.jsx(g, ee({
              fontSize: "small"
            }, y))
          }))
        }), o == null ? void 0 : o.endAdornment]
      })
    }),
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(a) ? a : [a]]
  });
}, HG = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef", "enableAccessibleFieldDOMStructure", "disabled", "readOnly", "dateSeparator"], GG = (e, t) => w.useMemo(() => {
  const n = ee({}, e), r = {}, o = (a) => {
    n.hasOwnProperty(a) && (r[a] = n[a], delete n[a]);
  };
  return HG.forEach(o), DT.forEach(o), {
    forwardedProps: n,
    internalProps: r
  };
}, [e, t]), YG = /* @__PURE__ */ w.createContext(null);
function AT(e) {
  const {
    contextValue: t,
    localeText: n,
    children: r
  } = e;
  return /* @__PURE__ */ x.jsx(YG.Provider, {
    value: t,
    children: /* @__PURE__ */ x.jsx(ry, {
      localeText: n,
      children: r
    })
  });
}
const KG = (e) => {
  const t = pn(), n = hc();
  return ee({}, e, {
    disablePast: e.disablePast ?? !1,
    disableFuture: e.disableFuture ?? !1,
    format: e.format ?? t.formats.keyboardDate,
    minDate: eo(t, e.minDate, n.minDate),
    maxDate: eo(t, e.maxDate, n.maxDate)
  });
}, XG = (e) => {
  const t = KG(e), {
    forwardedProps: n,
    internalProps: r
  } = GG(t, "date");
  return zG({
    forwardedProps: n,
    internalProps: r,
    valueManager: Bo,
    fieldValueManager: yG,
    validator: mc,
    valueType: "date"
  });
};
function ZG(e) {
  return Fe("MuiPickersTextField", e);
}
Le("MuiPickersTextField", ["root", "focused", "disabled", "error", "required"]);
function QG(e) {
  return Fe("MuiPickersInputBase", e);
}
const as = Le("MuiPickersInputBase", ["root", "focused", "disabled", "error", "notchedOutline", "sectionContent", "sectionBefore", "sectionAfter", "adornedStart", "adornedEnd", "input"]);
function JG(e) {
  return Fe("MuiPickersSectionList", e);
}
const dl = Le("MuiPickersSectionList", ["root", "section", "sectionContent"]), eY = ["slots", "slotProps", "elements", "sectionListRef"], NT = ae("div", {
  name: "MuiPickersSectionList",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  direction: "ltr /*! @noflip */",
  outline: "none"
}), jT = ae("span", {
  name: "MuiPickersSectionList",
  slot: "Section",
  overridesResolver: (e, t) => t.section
})({}), FT = ae("span", {
  name: "MuiPickersSectionList",
  slot: "SectionSeparator",
  overridesResolver: (e, t) => t.sectionSeparator
})({
  whiteSpace: "pre"
}), LT = ae("span", {
  name: "MuiPickersSectionList",
  slot: "SectionContent",
  overridesResolver: (e, t) => t.sectionContent
})({
  outline: "none"
}), tY = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"],
    section: ["section"],
    sectionContent: ["sectionContent"]
  }, JG, t);
};
function BT(e) {
  const {
    slots: t,
    slotProps: n,
    element: r,
    classes: o
  } = e, a = (t == null ? void 0 : t.section) ?? jT, l = Lt({
    elementType: a,
    externalSlotProps: n == null ? void 0 : n.section,
    externalForwardedProps: r.container,
    className: o.section,
    ownerState: {}
  }), c = (t == null ? void 0 : t.sectionContent) ?? LT, d = Lt({
    elementType: c,
    externalSlotProps: n == null ? void 0 : n.sectionContent,
    externalForwardedProps: r.content,
    additionalProps: {
      suppressContentEditableWarning: !0
    },
    className: o.sectionContent,
    ownerState: {}
  }), p = (t == null ? void 0 : t.sectionSeparator) ?? FT, f = Lt({
    elementType: p,
    externalSlotProps: n == null ? void 0 : n.sectionSeparator,
    externalForwardedProps: r.before,
    ownerState: {
      position: "before"
    }
  }), m = Lt({
    elementType: p,
    externalSlotProps: n == null ? void 0 : n.sectionSeparator,
    externalForwardedProps: r.after,
    ownerState: {
      position: "after"
    }
  });
  return /* @__PURE__ */ x.jsxs(a, ee({}, l, {
    children: [/* @__PURE__ */ x.jsx(p, ee({}, f)), /* @__PURE__ */ x.jsx(c, ee({}, d)), /* @__PURE__ */ x.jsx(p, ee({}, m))]
  }));
}
process.env.NODE_ENV !== "production" && (BT.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: i.object.isRequired,
  element: i.shape({
    after: i.object.isRequired,
    before: i.object.isRequired,
    container: i.object.isRequired,
    content: i.object.isRequired
  }).isRequired,
  /**
   * The props used for each component slot.
   */
  slotProps: i.object,
  /**
   * Overridable component slots.
   */
  slots: i.object
});
const VT = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = dn({
    props: t,
    name: "MuiPickersSectionList"
  }), {
    slots: o,
    slotProps: a,
    elements: l,
    sectionListRef: c
  } = r, d = mt(r, eY), p = tY(r), f = w.useRef(null), m = It(n, f), g = (v) => {
    if (!f.current)
      throw new Error(`MUI X: Cannot call sectionListRef.${v} before the mount of the component.`);
    return f.current;
  };
  w.useImperativeHandle(c, () => ({
    getRoot() {
      return g("getRoot");
    },
    getSectionContainer(v) {
      return g("getSectionContainer").querySelector(`.${dl.section}[data-sectionindex="${v}"]`);
    },
    getSectionContent(v) {
      return g("getSectionContent").querySelector(`.${dl.section}[data-sectionindex="${v}"] .${dl.sectionContent}`);
    },
    getSectionIndexFromDOMElement(v) {
      const $ = g("getSectionIndexFromDOMElement");
      if (v == null || !$.contains(v))
        return null;
      let S = null;
      return v.classList.contains(dl.section) ? S = v : v.classList.contains(dl.sectionContent) && (S = v.parentElement), S == null ? null : Number(S.dataset.sectionindex);
    }
  }));
  const y = (o == null ? void 0 : o.root) ?? NT, b = Lt({
    elementType: y,
    externalSlotProps: a == null ? void 0 : a.root,
    externalForwardedProps: d,
    additionalProps: {
      ref: m,
      suppressContentEditableWarning: !0
    },
    className: p.root,
    ownerState: {}
  });
  return /* @__PURE__ */ x.jsx(y, ee({}, b, {
    children: b.contentEditable ? l.map(({
      content: v,
      before: $,
      after: S
    }) => `${$.children}${v.children}${S.children}`).join("") : /* @__PURE__ */ x.jsx(w.Fragment, {
      children: l.map((v, $) => /* @__PURE__ */ x.jsx(BT, {
        slots: o,
        slotProps: a,
        element: v,
        classes: p
      }, $))
    })
  }));
});
process.env.NODE_ENV !== "production" && (VT.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: i.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: i.arrayOf(i.shape({
    after: i.object.isRequired,
    before: i.object.isRequired,
    container: i.object.isRequired,
    content: i.object.isRequired
  })).isRequired,
  sectionListRef: i.oneOfType([i.func, i.shape({
    current: i.shape({
      getRoot: i.func.isRequired,
      getSectionContainer: i.func.isRequired,
      getSectionContent: i.func.isRequired,
      getSectionIndexFromDOMElement: i.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   */
  slotProps: i.object,
  /**
   * Overridable component slots.
   */
  slots: i.object
});
const nY = ["elements", "areAllSectionsEmpty", "defaultValue", "label", "value", "onChange", "id", "autoFocus", "endAdornment", "startAdornment", "renderSuffix", "slots", "slotProps", "contentEditable", "tabIndex", "onInput", "onPaste", "onKeyDown", "fullWidth", "name", "readOnly", "inputProps", "inputRef", "sectionListRef"], rY = (e) => Math.round(e * 1e5) / 1e5, xp = ae("div", {
  name: "MuiPickersInputBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ee({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  cursor: "text",
  padding: 0,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  letterSpacing: `${rY(0.15 / 16)}em`,
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
})), py = ae(NT, {
  name: "MuiPickersInputBase",
  slot: "SectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})(({
  theme: e
}) => ({
  padding: "4px 0 5px",
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit",
  lineHeight: "1.4375em",
  // 23px
  flexGrow: 1,
  outline: "none",
  display: "flex",
  flexWrap: "nowrap",
  overflow: "hidden",
  letterSpacing: "inherit",
  // Baseline behavior
  width: "182px",
  variants: [{
    props: {
      isRtl: !0
    },
    style: {
      textAlign: "right /*! @noflip */"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingTop: 1
    }
  }, {
    props: {
      adornedStart: !1,
      focused: !1,
      filled: !1
    },
    style: {
      color: "currentColor",
      opacity: 0
    }
  }, {
    // Can't use the object notation because label can be null or undefined
    props: ({
      adornedStart: t,
      focused: n,
      filled: r,
      label: o
    }) => !t && !n && !r && o == null,
    style: e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: e.palette.mode === "light" ? 0.42 : 0.5
    }
  }]
})), oY = ae(jT, {
  name: "MuiPickersInputBase",
  slot: "Section",
  overridesResolver: (e, t) => t.section
})(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit",
  letterSpacing: "inherit",
  lineHeight: "1.4375em",
  // 23px
  display: "inline-block",
  whiteSpace: "nowrap"
})), iY = ae(LT, {
  name: "MuiPickersInputBase",
  slot: "SectionContent",
  overridesResolver: (e, t) => t.content
})(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  lineHeight: "1.4375em",
  // 23px
  letterSpacing: "inherit",
  width: "fit-content",
  outline: "none"
})), aY = ae(FT, {
  name: "MuiPickersInputBase",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})(() => ({
  whiteSpace: "pre",
  letterSpacing: "inherit"
})), sY = ae("input", {
  name: "MuiPickersInputBase",
  slot: "Input",
  overridesResolver: (e, t) => t.hiddenInput
})(ee({}, k_)), lY = (e) => {
  const {
    focused: t,
    disabled: n,
    error: r,
    classes: o,
    fullWidth: a,
    readOnly: l,
    color: c,
    size: d,
    endAdornment: p,
    startAdornment: f
  } = e, m = {
    root: ["root", t && !n && "focused", n && "disabled", l && "readOnly", r && "error", a && "fullWidth", `color${Pe(c)}`, d === "small" && "inputSizeSmall", !!f && "adornedStart", !!p && "adornedEnd"],
    notchedOutline: ["notchedOutline"],
    input: ["input"],
    sectionsContainer: ["sectionsContainer"],
    sectionContent: ["sectionContent"],
    sectionBefore: ["sectionBefore"],
    sectionAfter: ["sectionAfter"]
  };
  return Be(m, QG, o);
}, wp = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = dn({
    props: t,
    name: "MuiPickersInputBase"
  }), {
    elements: o,
    areAllSectionsEmpty: a,
    value: l,
    onChange: c,
    id: d,
    endAdornment: p,
    startAdornment: f,
    renderSuffix: m,
    slots: g,
    slotProps: y,
    contentEditable: b,
    tabIndex: v,
    onInput: $,
    onPaste: S,
    onKeyDown: R,
    name: P,
    readOnly: T,
    inputProps: O,
    inputRef: k,
    sectionListRef: I
  } = r, D = mt(r, nY), j = w.useRef(null), E = It(n, j), M = It(O == null ? void 0 : O.ref, k), F = no(), B = cr();
  if (!B)
    throw new Error("MUI X: PickersInputBase should always be used inside a PickersTextField component");
  const V = (K) => {
    var Q;
    if (B.disabled) {
      K.stopPropagation();
      return;
    }
    (Q = B.onFocus) == null || Q.call(B, K);
  };
  w.useEffect(() => {
    B && B.setAdornedStart(!!f);
  }, [B, f]), w.useEffect(() => {
    B && (a ? B.onEmpty() : B.onFilled());
  }, [B, a]);
  const z = ee({}, r, B, {
    isRtl: F
  }), L = lY(z), G = (g == null ? void 0 : g.root) || xp, se = Lt({
    elementType: G,
    externalSlotProps: y == null ? void 0 : y.root,
    externalForwardedProps: D,
    additionalProps: {
      "aria-invalid": B.error,
      ref: E
    },
    className: L.root,
    ownerState: z
  }), ne = (g == null ? void 0 : g.input) || py;
  return /* @__PURE__ */ x.jsxs(G, ee({}, se, {
    children: [f, /* @__PURE__ */ x.jsx(VT, {
      sectionListRef: I,
      elements: o,
      contentEditable: b,
      tabIndex: v,
      className: L.sectionsContainer,
      onFocus: V,
      onBlur: B.onBlur,
      onInput: $,
      onPaste: S,
      onKeyDown: R,
      slots: {
        root: ne,
        section: oY,
        sectionContent: iY,
        sectionSeparator: aY
      },
      slotProps: {
        root: {
          ownerState: z
        },
        sectionContent: {
          className: as.sectionContent
        },
        sectionSeparator: ({
          position: K
        }) => ({
          className: K === "before" ? as.sectionBefore : as.sectionAfter
        })
      }
    }), p, m ? m(ee({}, B)) : null, /* @__PURE__ */ x.jsx(sY, ee({
      name: P,
      className: L.input,
      value: l,
      onChange: c,
      id: d,
      "aria-hidden": "true",
      tabIndex: -1,
      readOnly: T,
      required: B.required,
      disabled: B.disabled
    }, O, {
      ref: M
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (wp.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: i.bool.isRequired,
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: i.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: i.arrayOf(i.shape({
    after: i.object.isRequired,
    before: i.object.isRequired,
    container: i.object.isRequired,
    content: i.object.isRequired
  })).isRequired,
  endAdornment: i.node,
  fullWidth: i.bool,
  id: i.string,
  inputProps: i.object,
  inputRef: gn,
  label: i.node,
  margin: i.oneOf(["dense", "none", "normal"]),
  name: i.string,
  onChange: i.func.isRequired,
  onClick: i.func.isRequired,
  onInput: i.func.isRequired,
  onKeyDown: i.func.isRequired,
  onPaste: i.func.isRequired,
  ownerState: i.any,
  readOnly: i.bool,
  renderSuffix: i.func,
  sectionListRef: i.oneOfType([i.func, i.shape({
    current: i.shape({
      getRoot: i.func.isRequired,
      getSectionContainer: i.func.isRequired,
      getSectionContent: i.func.isRequired,
      getSectionIndexFromDOMElement: i.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: i.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: i.object,
  startAdornment: i.node,
  style: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  value: i.string.isRequired
});
function cY(e) {
  return Fe("MuiPickersOutlinedInput", e);
}
const po = ee({}, as, Le("MuiPickersOutlinedInput", ["root", "notchedOutline", "input"])), uY = ["children", "className", "label", "notched", "shrink"], dY = ae("fieldset", {
  name: "MuiPickersOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%",
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), n$ = ae("span")(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit"
})), pY = ae("legend")(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: {
      withLabel: !1
    },
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      withLabel: !0
    },
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: {
      withLabel: !0,
      notched: !0
    },
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
}));
function fY(e) {
  const {
    className: t,
    label: n
  } = e, r = mt(e, uY), o = n != null && n !== "", a = ee({}, e, {
    withLabel: o
  });
  return /* @__PURE__ */ x.jsx(dY, ee({
    "aria-hidden": !0,
    className: t
  }, r, {
    ownerState: a,
    children: /* @__PURE__ */ x.jsx(pY, {
      ownerState: a,
      children: o ? /* @__PURE__ */ x.jsx(n$, {
        children: n
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        /* @__PURE__ */ x.jsx(n$, {
          className: "notranslate",
          children: "​"
        })
      )
    })
  }));
}
const hY = ["label", "autoFocus", "ownerState", "notched"], mY = ae(xp, {
  name: "MuiPickersOutlinedInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    padding: "0 14px",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${po.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${po.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${po.focused} .${po.notchedOutline}`]: {
      borderStyle: "solid",
      borderWidth: 2
    },
    [`&.${po.disabled}`]: {
      [`& .${po.notchedOutline}`]: {
        borderColor: (e.vars || e).palette.action.disabled
      },
      "*": {
        color: (e.vars || e).palette.action.disabled
      }
    },
    [`&.${po.error} .${po.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    variants: Object.keys((e.vars ?? e).palette).filter((n) => {
      var r;
      return ((r = (e.vars ?? e).palette[n]) == null ? void 0 : r.main) ?? !1;
    }).map((n) => ({
      props: {
        color: n
      },
      style: {
        [`&.${po.focused}:not(.${po.error}) .${po.notchedOutline}`]: {
          // @ts-ignore
          borderColor: (e.vars || e).palette[n].main
        }
      }
    }))
  };
}), gY = ae(py, {
  name: "MuiPickersOutlinedInput",
  slot: "SectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})({
  padding: "16.5px 0",
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 0"
    }
  }]
}), yY = (e) => {
  const {
    classes: t
  } = e, r = Be({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, cY, t);
  return ee({}, t, r);
}, fy = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = dn({
    props: t,
    name: "MuiPickersOutlinedInput"
  }), {
    label: o,
    ownerState: a,
    notched: l
  } = r, c = mt(r, hY), d = cr(), p = ee({}, r, a, d, {
    color: (d == null ? void 0 : d.color) || "primary"
  }), f = yY(p);
  return /* @__PURE__ */ x.jsx(wp, ee({
    slots: {
      root: mY,
      input: gY
    },
    renderSuffix: (m) => /* @__PURE__ */ x.jsx(fY, {
      shrink: !!(l || m.adornedStart || m.focused || m.filled),
      notched: !!(l || m.adornedStart || m.focused || m.filled),
      className: f.notchedOutline,
      label: o != null && o !== "" && (d != null && d.required) ? /* @__PURE__ */ x.jsxs(w.Fragment, {
        children: [o, " ", "*"]
      }) : o,
      ownerState: p
    })
  }, c, {
    label: o,
    classes: f,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (fy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: i.bool.isRequired,
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: i.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: i.arrayOf(i.shape({
    after: i.object.isRequired,
    before: i.object.isRequired,
    container: i.object.isRequired,
    content: i.object.isRequired
  })).isRequired,
  endAdornment: i.node,
  fullWidth: i.bool,
  id: i.string,
  inputProps: i.object,
  inputRef: gn,
  label: i.node,
  margin: i.oneOf(["dense", "none", "normal"]),
  name: i.string,
  notched: i.bool,
  onChange: i.func.isRequired,
  onClick: i.func.isRequired,
  onInput: i.func.isRequired,
  onKeyDown: i.func.isRequired,
  onPaste: i.func.isRequired,
  ownerState: i.any,
  readOnly: i.bool,
  renderSuffix: i.func,
  sectionListRef: i.oneOfType([i.func, i.shape({
    current: i.shape({
      getRoot: i.func.isRequired,
      getSectionContainer: i.func.isRequired,
      getSectionContent: i.func.isRequired,
      getSectionIndexFromDOMElement: i.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: i.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: i.object,
  startAdornment: i.node,
  style: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  value: i.string.isRequired
});
fy.muiName = "Input";
function vY(e) {
  return Fe("MuiPickersFilledInput", e);
}
const sa = ee({}, as, Le("MuiPickersFilledInput", ["root", "underline", "input"])), bY = ["label", "autoFocus", "disableUnderline", "ownerState"], xY = ae(xp, {
  name: "MuiPickersFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => ku(e) && e !== "disableUnderline"
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", r = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", o = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", a = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : o,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
      }
    },
    [`&.${sa.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
    },
    [`&.${sa.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : a
    },
    variants: [...Object.keys((e.vars ?? e).palette).filter((l) => (e.vars ?? e).palette[l].main).map((l) => {
      var c;
      return {
        props: {
          color: l,
          disableUnderline: !1
        },
        style: {
          "&::after": {
            // @ts-ignore
            borderBottom: `2px solid ${(c = (e.vars || e).palette[l]) == null ? void 0 : c.main}`
          }
        }
      };
    }), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${sa.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${sa.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${sa.disabled}, .${sa.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${sa.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, {
      props: ({
        startAdornment: l
      }) => !!l,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        endAdornment: l
      }) => !!l,
      style: {
        paddingRight: 12
      }
    }]
  };
}), wY = ae(py, {
  name: "MuiPickersFilledInput",
  slot: "sectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      startAdornment: e
    }) => !!e,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      endAdornment: e
    }) => !!e,
    style: {
      paddingRight: 0
    }
  }, {
    props: {
      hiddenLabel: !0
    },
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: {
      hiddenLabel: !0,
      size: "small"
    },
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }]
}), $Y = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, o = Be({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, vY, t);
  return ee({}, t, o);
}, hy = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = dn({
    props: t,
    name: "MuiPickersFilledInput"
  }), {
    label: o,
    disableUnderline: a = !1,
    ownerState: l
  } = r, c = mt(r, bY), d = cr(), p = ee({}, r, l, d, {
    color: (d == null ? void 0 : d.color) || "primary"
  }), f = $Y(p);
  return /* @__PURE__ */ x.jsx(wp, ee({
    slots: {
      root: xY,
      input: wY
    },
    slotProps: {
      root: {
        disableUnderline: a
      }
    }
  }, c, {
    label: o,
    classes: f,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (hy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: i.bool.isRequired,
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: i.bool.isRequired,
  disableUnderline: i.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: i.arrayOf(i.shape({
    after: i.object.isRequired,
    before: i.object.isRequired,
    container: i.object.isRequired,
    content: i.object.isRequired
  })).isRequired,
  endAdornment: i.node,
  fullWidth: i.bool,
  hiddenLabel: i.bool,
  id: i.string,
  inputProps: i.object,
  inputRef: gn,
  label: i.node,
  margin: i.oneOf(["dense", "none", "normal"]),
  name: i.string,
  onChange: i.func.isRequired,
  onClick: i.func.isRequired,
  onInput: i.func.isRequired,
  onKeyDown: i.func.isRequired,
  onPaste: i.func.isRequired,
  ownerState: i.any,
  readOnly: i.bool,
  renderSuffix: i.func,
  sectionListRef: i.oneOfType([i.func, i.shape({
    current: i.shape({
      getRoot: i.func.isRequired,
      getSectionContainer: i.func.isRequired,
      getSectionContent: i.func.isRequired,
      getSectionIndexFromDOMElement: i.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: i.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: i.object,
  startAdornment: i.node,
  style: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  value: i.string.isRequired
});
hy.muiName = "Input";
function CY(e) {
  return Fe("MuiPickersFilledInput", e);
}
const pl = ee({}, as, Le("MuiPickersInput", ["root", "input"])), SY = ["label", "autoFocus", "disableUnderline", "ownerState"], TY = ae(xp, {
  name: "MuiPickersInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    "label + &": {
      marginTop: 16
    },
    variants: [...Object.keys((e.vars ?? e).palette).filter((r) => (e.vars ?? e).palette[r].main).map((r) => ({
      props: {
        color: r
      },
      style: {
        "&::after": {
          // @ts-ignore
          borderBottom: `2px solid ${(e.vars || e).palette[r].main}`
        }
      }
    })), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          background: "red",
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${pl.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${pl.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${pl.disabled}, .${pl.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${pl.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }]
  };
}), OY = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, o = Be({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, CY, t);
  return ee({}, t, o);
}, my = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = dn({
    props: t,
    name: "MuiPickersInput"
  }), {
    label: o,
    disableUnderline: a = !1,
    ownerState: l
  } = r, c = mt(r, SY), d = cr(), p = ee({}, r, l, d, {
    disableUnderline: a,
    color: (d == null ? void 0 : d.color) || "primary"
  }), f = OY(p);
  return /* @__PURE__ */ x.jsx(wp, ee({
    slots: {
      root: TY
    }
  }, c, {
    label: o,
    classes: f,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (my.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: i.bool.isRequired,
  className: i.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: i.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: i.bool.isRequired,
  disableUnderline: i.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: i.arrayOf(i.shape({
    after: i.object.isRequired,
    before: i.object.isRequired,
    container: i.object.isRequired,
    content: i.object.isRequired
  })).isRequired,
  endAdornment: i.node,
  fullWidth: i.bool,
  id: i.string,
  inputProps: i.object,
  inputRef: gn,
  label: i.node,
  margin: i.oneOf(["dense", "none", "normal"]),
  name: i.string,
  onChange: i.func.isRequired,
  onClick: i.func.isRequired,
  onInput: i.func.isRequired,
  onKeyDown: i.func.isRequired,
  onPaste: i.func.isRequired,
  ownerState: i.any,
  readOnly: i.bool,
  renderSuffix: i.func,
  sectionListRef: i.oneOfType([i.func, i.shape({
    current: i.shape({
      getRoot: i.func.isRequired,
      getSectionContainer: i.func.isRequired,
      getSectionContent: i.func.isRequired,
      getSectionIndexFromDOMElement: i.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: i.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: i.object,
  startAdornment: i.node,
  style: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  value: i.string.isRequired
});
my.muiName = "Input";
const PY = ["onFocus", "onBlur", "className", "color", "disabled", "error", "variant", "required", "InputProps", "inputProps", "inputRef", "sectionListRef", "elements", "areAllSectionsEmpty", "onClick", "onKeyDown", "onKeyUp", "onPaste", "onInput", "endAdornment", "startAdornment", "tabIndex", "contentEditable", "focused", "value", "onChange", "fullWidth", "id", "name", "helperText", "FormHelperTextProps", "label", "InputLabelProps"], EY = {
  standard: my,
  filled: hy,
  outlined: fy
}, RY = ae(Gn, {
  name: "MuiPickersTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), kY = (e) => {
  const {
    focused: t,
    disabled: n,
    classes: r,
    required: o
  } = e;
  return Be({
    root: ["root", t && !n && "focused", n && "disabled", o && "required"]
  }, ZG, r);
}, zT = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = dn({
    props: t,
    name: "MuiPickersTextField"
  }), {
    // Props used by FormControl
    onFocus: o,
    onBlur: a,
    className: l,
    color: c = "primary",
    disabled: d = !1,
    error: p = !1,
    variant: f = "outlined",
    required: m = !1,
    // Props used by PickersInput
    InputProps: g,
    inputProps: y,
    inputRef: b,
    sectionListRef: v,
    elements: $,
    areAllSectionsEmpty: S,
    onClick: R,
    onKeyDown: P,
    onKeyUp: T,
    onPaste: O,
    onInput: k,
    endAdornment: I,
    startAdornment: D,
    tabIndex: j,
    contentEditable: E,
    focused: M,
    value: F,
    onChange: B,
    fullWidth: V,
    id: z,
    name: L,
    // Props used by FormHelperText
    helperText: G,
    FormHelperTextProps: se,
    // Props used by InputLabel
    label: ne,
    InputLabelProps: K
  } = r, Q = mt(r, PY), ye = w.useRef(null), we = It(n, ye), fe = Mr(z), X = G && fe ? `${fe}-helper-text` : void 0, re = ne && fe ? `${fe}-label` : void 0, ie = ee({}, r, {
    color: c,
    disabled: d,
    error: p,
    focused: M,
    required: m,
    variant: f
  }), Y = kY(ie), Z = EY[f];
  return /* @__PURE__ */ x.jsxs(RY, ee({
    className: _e(Y.root, l),
    ref: we,
    focused: M,
    onFocus: o,
    onBlur: a,
    disabled: d,
    variant: f,
    error: p,
    color: c,
    fullWidth: V,
    required: m,
    ownerState: ie
  }, Q, {
    children: [/* @__PURE__ */ x.jsx(E0, ee({
      htmlFor: fe,
      id: re
    }, K, {
      children: ne
    })), /* @__PURE__ */ x.jsx(Z, ee({
      elements: $,
      areAllSectionsEmpty: S,
      onClick: R,
      onKeyDown: P,
      onKeyUp: T,
      onInput: k,
      onPaste: O,
      endAdornment: I,
      startAdornment: D,
      tabIndex: j,
      contentEditable: E,
      value: F,
      onChange: B,
      id: fe,
      fullWidth: V,
      inputProps: y,
      inputRef: b,
      sectionListRef: v,
      label: ne,
      name: L,
      role: "group",
      "aria-labelledby": re
    }, g)), G && /* @__PURE__ */ x.jsx(O0, ee({
      id: X
    }, se, {
      children: G
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (zT.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: i.bool.isRequired,
  className: i.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: i.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: i.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: i.bool.isRequired,
  disabled: i.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: i.arrayOf(i.shape({
    after: i.object.isRequired,
    before: i.object.isRequired,
    container: i.object.isRequired,
    content: i.object.isRequired
  })).isRequired,
  endAdornment: i.node,
  error: i.bool.isRequired,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: i.bool,
  FormHelperTextProps: i.object,
  fullWidth: i.bool,
  /**
   * The helper text content.
   */
  helperText: i.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: i.bool,
  id: i.string,
  InputLabelProps: i.object,
  inputProps: i.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: i.object,
  inputRef: gn,
  label: i.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: i.oneOf(["dense", "none", "normal"]),
  name: i.string,
  onBlur: i.func.isRequired,
  onChange: i.func.isRequired,
  onClick: i.func.isRequired,
  onFocus: i.func.isRequired,
  onInput: i.func.isRequired,
  onKeyDown: i.func.isRequired,
  onPaste: i.func.isRequired,
  readOnly: i.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: i.bool,
  sectionListRef: i.oneOfType([i.func, i.shape({
    current: i.shape({
      getRoot: i.func.isRequired,
      getSectionContainer: i.func.isRequired,
      getSectionContent: i.func.isRequired,
      getSectionIndexFromDOMElement: i.func.isRequired
    })
  })]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: i.oneOf(["medium", "small"]),
  startAdornment: i.node,
  style: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  value: i.string.isRequired,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: i.oneOf(["filled", "outlined", "standard"])
});
const _Y = ["enableAccessibleFieldDOMStructure"], DY = ["InputProps", "readOnly"], IY = ["onPaste", "onKeyDown", "inputMode", "readOnly", "InputProps", "inputProps", "inputRef"], MY = (e) => {
  let {
    enableAccessibleFieldDOMStructure: t
  } = e, n = mt(e, _Y);
  if (t) {
    const {
      InputProps: m,
      readOnly: g
    } = n, y = mt(n, DY);
    return ee({}, y, {
      InputProps: ee({}, m ?? {}, {
        readOnly: g
      })
    });
  }
  const {
    onPaste: r,
    onKeyDown: o,
    inputMode: a,
    readOnly: l,
    InputProps: c,
    inputProps: d,
    inputRef: p
  } = n, f = mt(n, IY);
  return ee({}, f, {
    InputProps: ee({}, c ?? {}, {
      readOnly: l
    }),
    inputProps: ee({}, d ?? {}, {
      inputMode: a,
      onPaste: r,
      onKeyDown: o,
      ref: p
    })
  });
}, AY = ["slots", "slotProps", "InputProps", "inputProps"], gy = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = dn({
    props: t,
    name: "MuiDateField"
  }), {
    slots: o,
    slotProps: a,
    InputProps: l,
    inputProps: c
  } = r, d = mt(r, AY), p = r, f = (o == null ? void 0 : o.textField) ?? (t.enableAccessibleFieldDOMStructure ? zT : di), m = Lt({
    elementType: f,
    externalSlotProps: a == null ? void 0 : a.textField,
    externalForwardedProps: d,
    additionalProps: {
      ref: n
    },
    ownerState: p
  });
  m.inputProps = ee({}, c, m.inputProps), m.InputProps = ee({}, l, m.InputProps);
  const g = XG(m), y = MY(g), b = UG(ee({}, y, {
    slots: o,
    slotProps: a
  }));
  return /* @__PURE__ */ x.jsx(f, ee({}, b));
});
process.env.NODE_ENV !== "production" && (gy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: i.bool,
  className: i.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: i.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: i.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: i.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: i.object,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: i.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: i.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: i.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: i.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: i.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: i.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: i.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: i.bool,
  /**
   * The helper text content.
   */
  helperText: i.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: i.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: i.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: i.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: i.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: i.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * The label content.
   */
  label: i.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: i.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: i.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: i.object,
  /**
   * Name attribute of the `input` element.
   */
  name: i.string,
  onBlur: i.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: i.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: i.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: i.func,
  onFocus: i.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: i.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: i.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: i.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: i.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: i.oneOfType([i.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), i.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: i.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: i.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: i.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: i.bool,
  /**
   * The size of the component.
   */
  size: i.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: i.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: i.object,
  style: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: i.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: i.oneOfType([i.func, i.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: i.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: i.oneOf(["filled", "outlined", "standard"])
});
const WT = ({
  shouldDisableDate: e,
  shouldDisableMonth: t,
  shouldDisableYear: n,
  minDate: r,
  maxDate: o,
  disableFuture: a,
  disablePast: l,
  timezone: c
}) => {
  const d = Pa();
  return w.useCallback((p) => mc({
    adapter: d,
    value: p,
    timezone: c,
    props: {
      shouldDisableDate: e,
      shouldDisableMonth: t,
      shouldDisableYear: n,
      minDate: r,
      maxDate: o,
      disableFuture: a,
      disablePast: l
    }
  }) !== null, [d, e, t, n, r, o, a, l, c]);
}, NY = (e, t, n) => (r, o) => {
  switch (o.type) {
    case "changeMonth":
      return ee({}, r, {
        slideDirection: o.direction,
        currentMonth: o.newMonth,
        isMonthSwitchingAnimating: !e
      });
    case "changeMonthTimezone": {
      const a = o.newTimezone;
      if (n.getTimezone(r.currentMonth) === a)
        return r;
      let l = n.setTimezone(r.currentMonth, a);
      return n.getMonth(l) !== n.getMonth(r.currentMonth) && (l = n.setMonth(l, n.getMonth(r.currentMonth))), ee({}, r, {
        currentMonth: l
      });
    }
    case "finishMonthSwitchingAnimation":
      return ee({}, r, {
        isMonthSwitchingAnimating: !1
      });
    case "changeFocusedDay": {
      if (r.focusedDay != null && o.focusedDay != null && n.isSameDay(o.focusedDay, r.focusedDay))
        return r;
      const a = o.focusedDay != null && !t && !n.isSameMonth(r.currentMonth, o.focusedDay);
      return ee({}, r, {
        focusedDay: o.focusedDay,
        isMonthSwitchingAnimating: a && !e && !o.withoutMonthSwitchingAnimation,
        currentMonth: a ? n.startOfMonth(o.focusedDay) : r.currentMonth,
        slideDirection: o.focusedDay != null && n.isAfterDay(o.focusedDay, r.currentMonth) ? "left" : "right"
      });
    }
    default:
      throw new Error("missing support");
  }
}, jY = (e) => {
  const {
    value: t,
    referenceDate: n,
    disableFuture: r,
    disablePast: o,
    disableSwitchToMonthOnDayFocus: a = !1,
    maxDate: l,
    minDate: c,
    onMonthChange: d,
    reduceAnimations: p,
    shouldDisableDate: f,
    timezone: m
  } = e, g = pn(), y = w.useRef(NY(!!p, a, g)).current, b = w.useMemo(
    () => Bo.getInitialReferenceValue({
      value: t,
      utils: g,
      timezone: m,
      props: e,
      referenceDate: n,
      granularity: Ro.day
    }),
    // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, m]
  ), [v, $] = w.useReducer(y, {
    isMonthSwitchingAnimating: !1,
    focusedDay: b,
    currentMonth: g.startOfMonth(b),
    slideDirection: "left"
  });
  w.useEffect(() => {
    $({
      type: "changeMonthTimezone",
      newTimezone: g.getTimezone(b)
    });
  }, [b, g]);
  const S = w.useCallback((k) => {
    $(ee({
      type: "changeMonth"
    }, k)), d && d(k.newMonth);
  }, [d]), R = w.useCallback((k) => {
    const I = k;
    g.isSameMonth(I, v.currentMonth) || S({
      newMonth: g.startOfMonth(I),
      direction: g.isAfterDay(I, v.currentMonth) ? "left" : "right"
    });
  }, [v.currentMonth, S, g]), P = WT({
    shouldDisableDate: f,
    minDate: c,
    maxDate: l,
    disableFuture: r,
    disablePast: o,
    timezone: m
  }), T = w.useCallback(() => {
    $({
      type: "finishMonthSwitchingAnimation"
    });
  }, []), O = ze((k, I) => {
    P(k) || $({
      type: "changeFocusedDay",
      focusedDay: k,
      withoutMonthSwitchingAnimation: I
    });
  });
  return {
    referenceDate: b,
    calendarState: v,
    changeMonth: R,
    changeFocusedDay: O,
    isDateDisabled: P,
    onMonthSwitchingAnimationEnd: T,
    handleChangeMonth: S
  };
}, FY = (e) => Fe("MuiPickersFadeTransitionGroup", e);
Le("MuiPickersFadeTransitionGroup", ["root"]);
const LY = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"]
  }, FY, t);
}, BY = ae(nc, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "block",
  position: "relative"
});
function qT(e) {
  const t = dn({
    props: e,
    name: "MuiPickersFadeTransitionGroup"
  }), {
    children: n,
    className: r,
    reduceAnimations: o,
    transKey: a
  } = t, l = LY(t), c = tr();
  return o ? n : /* @__PURE__ */ x.jsx(BY, {
    className: _e(l.root, r),
    children: /* @__PURE__ */ x.jsx(Vi, {
      appear: !1,
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: {
        appear: c.transitions.duration.enteringScreen,
        enter: c.transitions.duration.enteringScreen,
        exit: 0
      },
      children: n
    }, a)
  });
}
const VY = (e) => Fe("MuiPickersSlideTransition", e), qr = Le("MuiPickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]), zY = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"], WY = (e) => {
  const {
    classes: t,
    slideDirection: n
  } = e, r = {
    root: ["root"],
    exit: ["slideExit"],
    enterActive: ["slideEnterActive"],
    enter: [`slideEnter-${n}`],
    exitActive: [`slideExitActiveLeft-${n}`]
  };
  return Be(r, VY, t);
}, qY = ae(nc, {
  name: "MuiPickersSlideTransition",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`.${qr["slideEnter-left"]}`]: t["slideEnter-left"]
  }, {
    [`.${qr["slideEnter-right"]}`]: t["slideEnter-right"]
  }, {
    [`.${qr.slideEnterActive}`]: t.slideEnterActive
  }, {
    [`.${qr.slideExit}`]: t.slideExit
  }, {
    [`.${qr["slideExitActiveLeft-left"]}`]: t["slideExitActiveLeft-left"]
  }, {
    [`.${qr["slideExitActiveLeft-right"]}`]: t["slideExitActiveLeft-right"]
  }]
})(({
  theme: e
}) => {
  const t = e.transitions.create("transform", {
    duration: e.transitions.duration.complex,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${qr["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${qr["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${qr.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: t
    },
    [`& .${qr.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${qr["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: t,
      zIndex: 0
    },
    [`& .${qr["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: t,
      zIndex: 0
    }
  };
});
function UY(e) {
  const t = dn({
    props: e,
    name: "MuiPickersSlideTransition"
  }), {
    children: n,
    className: r,
    reduceAnimations: o,
    transKey: a
    // extracting `classes` from `other`
  } = t, l = mt(t, zY), c = WY(t), d = tr();
  if (o)
    return /* @__PURE__ */ x.jsx("div", {
      className: _e(c.root, r),
      children: n
    });
  const p = {
    exit: c.exit,
    enterActive: c.enterActive,
    enter: c.enter,
    exitActive: c.exitActive
  };
  return /* @__PURE__ */ x.jsx(qY, {
    className: _e(c.root, r),
    childFactory: (f) => /* @__PURE__ */ w.cloneElement(f, {
      classNames: p
    }),
    role: "presentation",
    children: /* @__PURE__ */ x.jsx(p0, ee({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: d.transitions.duration.complex,
      classNames: p
    }, l, {
      children: n
    }), a)
  });
}
const HY = (e) => Fe("MuiDayCalendar", e);
Le("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
const GY = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"], YY = ["ownerState"], KY = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"],
    header: ["header"],
    weekDayLabel: ["weekDayLabel"],
    loadingContainer: ["loadingContainer"],
    slideTransition: ["slideTransition"],
    monthContainer: ["monthContainer"],
    weekContainer: ["weekContainer"],
    weekNumberLabel: ["weekNumberLabel"],
    weekNumber: ["weekNumber"]
  }, HY, t);
}, UT = (Wl + yp * 2) * 6, XY = ae("div", {
  name: "MuiDayCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), ZY = ae("div", {
  name: "MuiDayCalendar",
  slot: "Header",
  overridesResolver: (e, t) => t.header
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), QY = ae(Qe, {
  name: "MuiDayCalendar",
  slot: "WeekDayLabel",
  overridesResolver: (e, t) => t.weekDayLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (e.vars || e).palette.text.secondary
})), JY = ae(Qe, {
  name: "MuiDayCalendar",
  slot: "WeekNumberLabel",
  overridesResolver: (e, t) => t.weekNumberLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: e.palette.text.disabled
})), eK = ae(Qe, {
  name: "MuiDayCalendar",
  slot: "WeekNumber",
  overridesResolver: (e, t) => t.weekNumber
})(({
  theme: e
}) => ee({}, e.typography.caption, {
  width: Wl,
  height: Wl,
  padding: 0,
  margin: `0 ${yp}px`,
  color: e.palette.text.disabled,
  fontSize: "0.75rem",
  alignItems: "center",
  justifyContent: "center",
  display: "inline-flex"
})), tK = ae("div", {
  name: "MuiDayCalendar",
  slot: "LoadingContainer",
  overridesResolver: (e, t) => t.loadingContainer
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: UT
}), nK = ae(UY, {
  name: "MuiDayCalendar",
  slot: "SlideTransition",
  overridesResolver: (e, t) => t.slideTransition
})({
  minHeight: UT
}), rK = ae("div", {
  name: "MuiDayCalendar",
  slot: "MonthContainer",
  overridesResolver: (e, t) => t.monthContainer
})({
  overflow: "hidden"
}), oK = ae("div", {
  name: "MuiDayCalendar",
  slot: "WeekContainer",
  overridesResolver: (e, t) => t.weekContainer
})({
  margin: `${yp}px 0`,
  display: "flex",
  justifyContent: "center"
});
function iK(e) {
  let {
    parentProps: t,
    day: n,
    focusableDay: r,
    selectedDays: o,
    isDateDisabled: a,
    currentMonthNumber: l,
    isViewFocused: c
  } = e, d = mt(e, GY);
  const {
    disabled: p,
    disableHighlightToday: f,
    isMonthSwitchingAnimating: m,
    showDaysOutsideCurrentMonth: g,
    slots: y,
    slotProps: b,
    timezone: v
  } = t, $ = pn(), S = gp(v), R = r !== null && $.isSameDay(n, r), P = o.some((F) => $.isSameDay(F, n)), T = $.isSameDay(n, S), O = (y == null ? void 0 : y.day) ?? OG, k = Lt({
    elementType: O,
    externalSlotProps: b == null ? void 0 : b.day,
    additionalProps: ee({
      disableHighlightToday: f,
      showDaysOutsideCurrentMonth: g,
      role: "gridcell",
      isAnimating: m,
      // it is used in date range dragging logic by accessing `dataset.timestamp`
      "data-timestamp": $.toJsDate(n).valueOf()
    }, d),
    ownerState: ee({}, t, {
      day: n,
      selected: P
    })
  }), I = mt(k, YY), D = w.useMemo(() => p || a(n), [p, a, n]), j = w.useMemo(() => $.getMonth(n) !== l, [$, n, l]), E = w.useMemo(() => {
    const F = $.startOfMonth($.setMonth(n, l));
    return g ? $.isSameDay(n, $.startOfWeek(F)) : $.isSameDay(n, F);
  }, [l, n, g, $]), M = w.useMemo(() => {
    const F = $.endOfMonth($.setMonth(n, l));
    return g ? $.isSameDay(n, $.endOfWeek(F)) : $.isSameDay(n, F);
  }, [l, n, g, $]);
  return /* @__PURE__ */ x.jsx(O, ee({}, I, {
    day: n,
    disabled: D,
    autoFocus: c && R,
    today: T,
    outsideCurrentMonth: j,
    isFirstVisibleCell: E,
    isLastVisibleCell: M,
    selected: P,
    tabIndex: R ? 0 : -1,
    "aria-selected": P,
    "aria-current": T ? "date" : void 0
  }));
}
function aK(e) {
  const t = dn({
    props: e,
    name: "MuiDayCalendar"
  }), n = pn(), {
    onFocusedDayChange: r,
    className: o,
    currentMonth: a,
    selectedDays: l,
    focusedDay: c,
    loading: d,
    onSelectedDaysChange: p,
    onMonthSwitchingAnimationEnd: f,
    readOnly: m,
    reduceAnimations: g,
    renderLoading: y = () => /* @__PURE__ */ x.jsx("span", {
      children: "..."
    }),
    slideDirection: b,
    TransitionProps: v,
    disablePast: $,
    disableFuture: S,
    minDate: R,
    maxDate: P,
    shouldDisableDate: T,
    shouldDisableMonth: O,
    shouldDisableYear: k,
    dayOfWeekFormatter: I = (be) => n.format(be, "weekdayShort").charAt(0).toUpperCase(),
    hasFocus: D,
    onFocusedViewChange: j,
    gridLabelId: E,
    displayWeekNumber: M,
    fixedWeekNumber: F,
    autoFocus: B,
    timezone: V
  } = t, z = gp(V), L = KY(t), G = no(), se = WT({
    shouldDisableDate: T,
    shouldDisableMonth: O,
    shouldDisableYear: k,
    minDate: R,
    maxDate: P,
    disablePast: $,
    disableFuture: S,
    timezone: V
  }), ne = bi(), [K, Q] = sr({
    name: "DayCalendar",
    state: "hasFocus",
    controlled: D,
    default: B ?? !1
  }), [ye, we] = w.useState(() => c || z), fe = ze((be) => {
    m || p(be);
  }), X = (be) => {
    se(be) || (r(be), we(be), j == null || j(!0), Q(!0));
  }, re = ze((be, de) => {
    switch (be.key) {
      case "ArrowUp":
        X(n.addDays(de, -7)), be.preventDefault();
        break;
      case "ArrowDown":
        X(n.addDays(de, 7)), be.preventDefault();
        break;
      case "ArrowLeft": {
        const Oe = n.addDays(de, G ? 1 : -1), Re = n.addMonths(de, G ? 1 : -1), We = Pl({
          utils: n,
          date: Oe,
          minDate: G ? Oe : n.startOfMonth(Re),
          maxDate: G ? n.endOfMonth(Re) : Oe,
          isDateDisabled: se,
          timezone: V
        });
        X(We || Oe), be.preventDefault();
        break;
      }
      case "ArrowRight": {
        const Oe = n.addDays(de, G ? -1 : 1), Re = n.addMonths(de, G ? -1 : 1), We = Pl({
          utils: n,
          date: Oe,
          minDate: G ? n.startOfMonth(Re) : Oe,
          maxDate: G ? Oe : n.endOfMonth(Re),
          isDateDisabled: se,
          timezone: V
        });
        X(We || Oe), be.preventDefault();
        break;
      }
      case "Home":
        X(n.startOfWeek(de)), be.preventDefault();
        break;
      case "End":
        X(n.endOfWeek(de)), be.preventDefault();
        break;
      case "PageUp":
        X(n.addMonths(de, 1)), be.preventDefault();
        break;
      case "PageDown":
        X(n.addMonths(de, -1)), be.preventDefault();
        break;
    }
  }), ie = ze((be, de) => X(de)), Y = ze((be, de) => {
    K && n.isSameDay(ye, de) && (j == null || j(!1));
  }), Z = n.getMonth(a), ue = n.getYear(a), ge = w.useMemo(() => l.filter((be) => !!be).map((be) => n.startOfDay(be)), [n, l]), W = `${ue}-${Z}`, J = w.useMemo(() => /* @__PURE__ */ w.createRef(), [W]), le = w.useMemo(() => {
    const be = n.startOfMonth(a), de = n.endOfMonth(a);
    return se(ye) || n.isAfterDay(ye, de) || n.isBeforeDay(ye, be) ? Pl({
      utils: n,
      date: ye,
      minDate: be,
      maxDate: de,
      disablePast: $,
      disableFuture: S,
      isDateDisabled: se,
      timezone: V
    }) : ye;
  }, [a, S, $, ye, se, n, V]), me = w.useMemo(() => {
    const be = n.getWeekArray(a);
    let de = n.addMonths(a, 1);
    for (; F && be.length < F; ) {
      const Oe = n.getWeekArray(de), Re = n.isSameDay(be[be.length - 1][0], Oe[0][0]);
      Oe.slice(Re ? 1 : 0).forEach((We) => {
        be.length < F && be.push(We);
      }), de = n.addMonths(de, 1);
    }
    return be;
  }, [a, F, n]);
  return /* @__PURE__ */ x.jsxs(XY, {
    role: "grid",
    "aria-labelledby": E,
    className: L.root,
    children: [/* @__PURE__ */ x.jsxs(ZY, {
      role: "row",
      className: L.header,
      children: [M && /* @__PURE__ */ x.jsx(JY, {
        variant: "caption",
        role: "columnheader",
        "aria-label": ne.calendarWeekNumberHeaderLabel,
        className: L.weekNumberLabel,
        children: ne.calendarWeekNumberHeaderText
      }), eG(n, z).map((be, de) => /* @__PURE__ */ x.jsx(QY, {
        variant: "caption",
        role: "columnheader",
        "aria-label": n.format(be, "weekday"),
        className: L.weekDayLabel,
        children: I(be)
      }, de.toString()))]
    }), d ? /* @__PURE__ */ x.jsx(tK, {
      className: L.loadingContainer,
      children: y()
    }) : /* @__PURE__ */ x.jsx(nK, ee({
      transKey: W,
      onExited: f,
      reduceAnimations: g,
      slideDirection: b,
      className: _e(o, L.slideTransition)
    }, v, {
      nodeRef: J,
      children: /* @__PURE__ */ x.jsx(rK, {
        ref: J,
        role: "rowgroup",
        className: L.monthContainer,
        children: me.map((be, de) => /* @__PURE__ */ x.jsxs(oK, {
          role: "row",
          className: L.weekContainer,
          "aria-rowindex": de + 1,
          children: [M && /* @__PURE__ */ x.jsx(eK, {
            className: L.weekNumber,
            role: "rowheader",
            "aria-label": ne.calendarWeekNumberAriaLabelText(n.getWeekNumber(be[0])),
            children: ne.calendarWeekNumberText(n.getWeekNumber(be[0]))
          }), be.map((Oe, Re) => /* @__PURE__ */ x.jsx(iK, {
            parentProps: t,
            day: Oe,
            selectedDays: ge,
            focusableDay: le,
            onKeyDown: re,
            onFocus: ie,
            onBlur: Y,
            onDaySelect: fe,
            isDateDisabled: se,
            currentMonthNumber: Z,
            isViewFocused: K,
            "aria-colindex": Re + 1
          }, Oe.toString()))]
        }, `week-${be[0]}`))
      })
    }))]
  });
}
function sK(e) {
  return Fe("MuiPickersMonth", e);
}
const xu = Le("MuiPickersMonth", ["root", "monthButton", "disabled", "selected"]), lK = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "aria-label", "monthsPerRow", "slots", "slotProps"], cK = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: r
  } = e;
  return Be({
    root: ["root"],
    monthButton: ["monthButton", t && "disabled", n && "selected"]
  }, sK, r);
}, uK = ae("div", {
  name: "MuiPickersMonth",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      monthsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
}), dK = ae("button", {
  name: "MuiPickersMonth",
  slot: "MonthButton",
  overridesResolver: (e, t) => [t.monthButton, {
    [`&.${xu.disabled}`]: t.disabled
  }, {
    [`&.${xu.selected}`]: t.selected
  }]
})(({
  theme: e
}) => ee({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : ht(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : ht(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${xu.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${xu.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), pK = /* @__PURE__ */ w.memo(function(t) {
  const n = dn({
    props: t,
    name: "MuiPickersMonth"
  }), {
    autoFocus: r,
    className: o,
    children: a,
    disabled: l,
    selected: c,
    value: d,
    tabIndex: p,
    onClick: f,
    onKeyDown: m,
    onFocus: g,
    onBlur: y,
    "aria-current": b,
    "aria-label": v,
    slots: $,
    slotProps: S
  } = n, R = mt(n, lK), P = w.useRef(null), T = cK(n);
  Nn(() => {
    var I;
    r && ((I = P.current) == null || I.focus());
  }, [r]);
  const O = ($ == null ? void 0 : $.monthButton) ?? dK, k = Lt({
    elementType: O,
    externalSlotProps: S == null ? void 0 : S.monthButton,
    additionalProps: {
      children: a,
      disabled: l,
      tabIndex: p,
      ref: P,
      type: "button",
      role: "radio",
      "aria-current": b,
      "aria-checked": c,
      "aria-label": v,
      onClick: (I) => f(I, d),
      onKeyDown: (I) => m(I, d),
      onFocus: (I) => g(I, d),
      onBlur: (I) => y(I, d)
    },
    ownerState: n,
    className: T.monthButton
  });
  return /* @__PURE__ */ x.jsx(uK, ee({
    className: _e(T.root, o),
    ownerState: n
  }, R, {
    children: /* @__PURE__ */ x.jsx(O, ee({}, k))
  }));
});
function fK(e) {
  return Fe("MuiMonthCalendar", e);
}
Le("MuiMonthCalendar", ["root"]);
const hK = ["className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "autoFocus", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId", "slots", "slotProps"], mK = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"]
  }, fK, t);
};
function gK(e, t) {
  const n = pn(), r = hc(), o = dn({
    props: e,
    name: t
  });
  return ee({
    disableFuture: !1,
    disablePast: !1
  }, o, {
    minDate: eo(n, o.minDate, r.minDate),
    maxDate: eo(n, o.maxDate, r.maxDate)
  });
}
const yK = ae("div", {
  name: "MuiMonthCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "stretch",
  padding: "0 4px",
  width: vp,
  // avoid padding increasing width over defined
  boxSizing: "border-box"
}), HT = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = gK(t, "MuiMonthCalendar"), {
    className: o,
    value: a,
    defaultValue: l,
    referenceDate: c,
    disabled: d,
    disableFuture: p,
    disablePast: f,
    maxDate: m,
    minDate: g,
    onChange: y,
    shouldDisableMonth: b,
    readOnly: v,
    autoFocus: $ = !1,
    onMonthFocus: S,
    hasFocus: R,
    onFocusedViewChange: P,
    monthsPerRow: T = 3,
    timezone: O,
    gridLabelId: k,
    slots: I,
    slotProps: D
  } = r, j = mt(r, hK), {
    value: E,
    handleValueChange: M,
    timezone: F
  } = ly({
    name: "MonthCalendar",
    timezone: O,
    value: a,
    defaultValue: l,
    referenceDate: c,
    onChange: y,
    valueManager: Bo
  }), B = gp(F), V = no(), z = pn(), L = w.useMemo(
    () => Bo.getInitialReferenceValue({
      value: E,
      utils: z,
      props: r,
      timezone: F,
      referenceDate: c,
      granularity: Ro.month
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), G = r, se = mK(G), ne = w.useMemo(() => z.getMonth(B), [z, B]), K = w.useMemo(() => E != null ? z.getMonth(E) : null, [E, z]), [Q, ye] = w.useState(() => K || z.getMonth(L)), [we, fe] = sr({
    name: "MonthCalendar",
    state: "hasFocus",
    controlled: R,
    default: $ ?? !1
  }), X = ze((W) => {
    fe(W), P && P(W);
  }), re = w.useCallback((W) => {
    const J = z.startOfMonth(f && z.isAfter(B, g) ? B : g), le = z.startOfMonth(p && z.isBefore(B, m) ? B : m), me = z.startOfMonth(W);
    return z.isBefore(me, J) || z.isAfter(me, le) ? !0 : b ? b(me) : !1;
  }, [p, f, m, g, B, b, z]), ie = ze((W, J) => {
    if (v)
      return;
    const le = z.setMonth(E ?? L, J);
    M(le);
  }), Y = ze((W) => {
    re(z.setMonth(E ?? L, W)) || (ye(W), X(!0), S && S(W));
  });
  w.useEffect(() => {
    ye((W) => K !== null && W !== K ? K : W);
  }, [K]);
  const Z = ze((W, J) => {
    switch (W.key) {
      case "ArrowUp":
        Y((12 + J - 3) % 12), W.preventDefault();
        break;
      case "ArrowDown":
        Y((12 + J + 3) % 12), W.preventDefault();
        break;
      case "ArrowLeft":
        Y((12 + J + (V ? 1 : -1)) % 12), W.preventDefault();
        break;
      case "ArrowRight":
        Y((12 + J + (V ? -1 : 1)) % 12), W.preventDefault();
        break;
    }
  }), ue = ze((W, J) => {
    Y(J);
  }), ge = ze((W, J) => {
    Q === J && X(!1);
  });
  return /* @__PURE__ */ x.jsx(yK, ee({
    ref: n,
    className: _e(se.root, o),
    ownerState: G,
    role: "radiogroup",
    "aria-labelledby": k
  }, j, {
    children: iy(z, E ?? L).map((W) => {
      const J = z.getMonth(W), le = z.format(W, "monthShort"), me = z.format(W, "month"), be = J === K, de = d || re(W);
      return /* @__PURE__ */ x.jsx(pK, {
        selected: be,
        value: J,
        onClick: ie,
        onKeyDown: Z,
        autoFocus: we && J === Q,
        disabled: de,
        tabIndex: J === Q && !de ? 0 : -1,
        onFocus: ue,
        onBlur: ge,
        "aria-current": ne === J ? "date" : void 0,
        "aria-label": me,
        monthsPerRow: T,
        slots: I,
        slotProps: D,
        children: le
      }, le);
    })
  }));
});
process.env.NODE_ENV !== "production" && (HT.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: i.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  className: i.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: i.object,
  /**
   * If `true` picker is disabled
   */
  disabled: i.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: i.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: i.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: i.bool,
  gridLabelId: i.string,
  hasFocus: i.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: i.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: i.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: i.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: i.func,
  onFocusedViewChange: i.func,
  onMonthFocus: i.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: i.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: i.object,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: i.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: i.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: i.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: i.object
});
function vK(e) {
  return Fe("MuiPickersYear", e);
}
const wu = Le("MuiPickersYear", ["root", "yearButton", "selected", "disabled"]), bK = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow", "slots", "slotProps"], xK = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: r
  } = e;
  return Be({
    root: ["root"],
    yearButton: ["yearButton", t && "disabled", n && "selected"]
  }, vK, r);
}, wK = ae("div", {
  name: "MuiPickersYear",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      yearsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
}), $K = ae("button", {
  name: "MuiPickersYear",
  slot: "YearButton",
  overridesResolver: (e, t) => [t.yearButton, {
    [`&.${wu.disabled}`]: t.disabled
  }, {
    [`&.${wu.selected}`]: t.selected
  }]
})(({
  theme: e
}) => ee({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "6px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.focusOpacity})` : ht(e.palette.action.active, e.palette.action.focusOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : ht(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${wu.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${wu.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), CK = /* @__PURE__ */ w.memo(function(t) {
  const n = dn({
    props: t,
    name: "MuiPickersYear"
  }), {
    autoFocus: r,
    className: o,
    children: a,
    disabled: l,
    selected: c,
    value: d,
    tabIndex: p,
    onClick: f,
    onKeyDown: m,
    onFocus: g,
    onBlur: y,
    "aria-current": b,
    slots: v,
    slotProps: $
  } = n, S = mt(n, bK), R = w.useRef(null), P = xK(n);
  Nn(() => {
    var k;
    r && ((k = R.current) == null || k.focus());
  }, [r]);
  const T = (v == null ? void 0 : v.yearButton) ?? $K, O = Lt({
    elementType: T,
    externalSlotProps: $ == null ? void 0 : $.yearButton,
    additionalProps: {
      children: a,
      disabled: l,
      tabIndex: p,
      ref: R,
      type: "button",
      role: "radio",
      "aria-current": b,
      "aria-checked": c,
      onClick: (k) => f(k, d),
      onKeyDown: (k) => m(k, d),
      onFocus: (k) => g(k, d),
      onBlur: (k) => y(k, d)
    },
    ownerState: n,
    className: P.yearButton
  });
  return /* @__PURE__ */ x.jsx(wK, ee({
    className: _e(P.root, o),
    ownerState: n
  }, S, {
    children: /* @__PURE__ */ x.jsx(T, ee({}, O))
  }));
});
function SK(e) {
  return Fe("MuiYearCalendar", e);
}
Le("MuiYearCalendar", ["root"]);
const TK = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsOrder", "yearsPerRow", "timezone", "gridLabelId", "slots", "slotProps"], OK = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"]
  }, SK, t);
};
function PK(e, t) {
  const n = pn(), r = hc(), o = dn({
    props: e,
    name: t
  });
  return ee({
    disablePast: !1,
    disableFuture: !1
  }, o, {
    yearsPerRow: o.yearsPerRow ?? 3,
    minDate: eo(n, o.minDate, r.minDate),
    maxDate: eo(n, o.maxDate, r.maxDate)
  });
}
const EK = ae("div", {
  name: "MuiYearCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  padding: "0 4px",
  width: vp,
  maxHeight: KH,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  position: "relative"
}), GT = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = PK(t, "MuiYearCalendar"), {
    autoFocus: o,
    className: a,
    value: l,
    defaultValue: c,
    referenceDate: d,
    disabled: p,
    disableFuture: f,
    disablePast: m,
    maxDate: g,
    minDate: y,
    onChange: b,
    readOnly: v,
    shouldDisableYear: $,
    onYearFocus: S,
    hasFocus: R,
    onFocusedViewChange: P,
    yearsOrder: T = "asc",
    yearsPerRow: O,
    timezone: k,
    gridLabelId: I,
    slots: D,
    slotProps: j
  } = r, E = mt(r, TK), {
    value: M,
    handleValueChange: F,
    timezone: B
  } = ly({
    name: "YearCalendar",
    timezone: k,
    value: l,
    defaultValue: c,
    referenceDate: d,
    onChange: b,
    valueManager: Bo
  }), V = gp(B), z = no(), L = pn(), G = w.useMemo(
    () => Bo.getInitialReferenceValue({
      value: M,
      utils: L,
      props: r,
      timezone: B,
      referenceDate: d,
      granularity: Ro.year
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), se = r, ne = OK(se), K = w.useMemo(() => L.getYear(V), [L, V]), Q = w.useMemo(() => M != null ? L.getYear(M) : null, [M, L]), [ye, we] = w.useState(() => Q || L.getYear(G)), [fe, X] = sr({
    name: "YearCalendar",
    state: "hasFocus",
    controlled: R,
    default: o ?? !1
  }), re = ze((Oe) => {
    X(Oe), P && P(Oe);
  }), ie = w.useCallback((Oe) => {
    if (m && L.isBeforeYear(Oe, V) || f && L.isAfterYear(Oe, V) || y && L.isBeforeYear(Oe, y) || g && L.isAfterYear(Oe, g))
      return !0;
    if (!$)
      return !1;
    const Re = L.startOfYear(Oe);
    return $(Re);
  }, [f, m, g, y, V, $, L]), Y = ze((Oe, Re) => {
    if (v)
      return;
    const We = L.setYear(M ?? G, Re);
    F(We);
  }), Z = ze((Oe) => {
    ie(L.setYear(M ?? G, Oe)) || (we(Oe), re(!0), S == null || S(Oe));
  });
  w.useEffect(() => {
    we((Oe) => Q !== null && Oe !== Q ? Q : Oe);
  }, [Q]);
  const ue = T !== "desc" ? O * 1 : O * -1, ge = z && T === "asc" || !z && T === "desc" ? -1 : 1, W = ze((Oe, Re) => {
    switch (Oe.key) {
      case "ArrowUp":
        Z(Re - ue), Oe.preventDefault();
        break;
      case "ArrowDown":
        Z(Re + ue), Oe.preventDefault();
        break;
      case "ArrowLeft":
        Z(Re - ge), Oe.preventDefault();
        break;
      case "ArrowRight":
        Z(Re + ge), Oe.preventDefault();
        break;
    }
  }), J = ze((Oe, Re) => {
    Z(Re);
  }), le = ze((Oe, Re) => {
    ye === Re && re(!1);
  }), me = w.useRef(null), be = It(n, me);
  w.useEffect(() => {
    if (o || me.current === null)
      return;
    const Oe = me.current.querySelector('[tabindex="0"]');
    if (!Oe)
      return;
    const Re = Oe.offsetHeight, We = Oe.offsetTop, Ye = me.current.clientHeight, Ie = me.current.scrollTop, kt = We + Re;
    Re > Ye || We < Ie || (me.current.scrollTop = kt - Ye / 2 - Re / 2);
  }, [o]);
  const de = L.getYearRange([y, g]);
  return T === "desc" && de.reverse(), /* @__PURE__ */ x.jsx(EK, ee({
    ref: be,
    className: _e(ne.root, a),
    ownerState: se,
    role: "radiogroup",
    "aria-labelledby": I
  }, E, {
    children: de.map((Oe) => {
      const Re = L.getYear(Oe), We = Re === Q, Ye = p || ie(Oe);
      return /* @__PURE__ */ x.jsx(CK, {
        selected: We,
        value: Re,
        onClick: Y,
        onKeyDown: W,
        autoFocus: fe && Re === ye,
        disabled: Ye,
        tabIndex: Re === ye && !Ye ? 0 : -1,
        onFocus: J,
        onBlur: le,
        "aria-current": K === Re ? "date" : void 0,
        yearsPerRow: O,
        slots: D,
        slotProps: j,
        children: L.format(Oe, "year")
      }, L.format(Oe, "year"));
    })
  }));
});
process.env.NODE_ENV !== "production" && (GT.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: i.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  className: i.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: i.object,
  /**
   * If `true` picker is disabled
   */
  disabled: i.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: i.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: i.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: i.bool,
  gridLabelId: i.string,
  hasFocus: i.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: i.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: i.object,
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: i.func,
  onFocusedViewChange: i.func,
  onYearFocus: i.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: i.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: i.object,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: i.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: i.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: i.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: i.object,
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: i.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: i.oneOf([3, 4])
});
const RK = (e) => Fe("MuiPickersCalendarHeader", e), kK = Le("MuiPickersCalendarHeader", ["root", "labelContainer", "label", "switchViewButton", "switchViewIcon"]), _K = ["slots", "slotProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "timezone", "format"], DK = ["ownerState"], IK = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"],
    labelContainer: ["labelContainer"],
    label: ["label"],
    switchViewButton: ["switchViewButton"],
    switchViewIcon: ["switchViewIcon"]
  }, RK, t);
}, MK = ae("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  alignItems: "center",
  marginTop: 12,
  marginBottom: 4,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 40,
  minHeight: 40
}), AK = ae("div", {
  name: "MuiPickersCalendarHeader",
  slot: "LabelContainer",
  overridesResolver: (e, t) => t.labelContainer
})(({
  theme: e
}) => ee({
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, e.typography.body1, {
  fontWeight: e.typography.fontWeightMedium
})), NK = ae("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})({
  marginRight: 6
}), jK = ae(Vo, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewButton",
  overridesResolver: (e, t) => t.switchViewButton
})({
  marginRight: "auto",
  variants: [{
    props: {
      view: "year"
    },
    style: {
      [`.${kK.switchViewIcon}`]: {
        transform: "rotate(180deg)"
      }
    }
  }]
}), FK = ae(kH, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewIcon",
  overridesResolver: (e, t) => t.switchViewIcon
})(({
  theme: e
}) => ({
  willChange: "transform",
  transition: e.transitions.create("transform"),
  transform: "rotate(0deg)"
})), YT = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = bi(), o = pn(), a = dn({
    props: t,
    name: "MuiPickersCalendarHeader"
  }), {
    slots: l,
    slotProps: c,
    currentMonth: d,
    disabled: p,
    disableFuture: f,
    disablePast: m,
    maxDate: g,
    minDate: y,
    onMonthChange: b,
    onViewChange: v,
    view: $,
    reduceAnimations: S,
    views: R,
    labelId: P,
    className: T,
    timezone: O,
    format: k = `${o.formats.month} ${o.formats.year}`
  } = a, I = mt(a, _K), D = a, j = IK(a), E = (l == null ? void 0 : l.switchViewButton) ?? jK, M = Lt({
    elementType: E,
    externalSlotProps: c == null ? void 0 : c.switchViewButton,
    additionalProps: {
      size: "small",
      "aria-label": r.calendarViewSwitchingButtonAriaLabel($)
    },
    ownerState: D,
    className: j.switchViewButton
  }), F = (l == null ? void 0 : l.switchViewIcon) ?? FK, B = Lt({
    elementType: F,
    externalSlotProps: c == null ? void 0 : c.switchViewIcon,
    ownerState: D,
    className: j.switchViewIcon
  }), V = mt(B, DK), z = () => b(o.addMonths(d, 1), "left"), L = () => b(o.addMonths(d, -1), "right"), G = GH(d, {
    disableFuture: f,
    maxDate: g,
    timezone: O
  }), se = YH(d, {
    disablePast: m,
    minDate: y,
    timezone: O
  }), ne = () => {
    if (!(R.length === 1 || !v || p))
      if (R.length === 2)
        v(R.find((Q) => Q !== $) || R[0]);
      else {
        const Q = R.indexOf($) !== 0 ? 0 : 1;
        v(R[Q]);
      }
  };
  if (R.length === 1 && R[0] === "year")
    return null;
  const K = o.formatByString(d, k);
  return /* @__PURE__ */ x.jsxs(MK, ee({}, I, {
    ownerState: D,
    className: _e(j.root, T),
    ref: n,
    children: [/* @__PURE__ */ x.jsxs(AK, {
      role: "presentation",
      onClick: ne,
      ownerState: D,
      "aria-live": "polite",
      className: j.labelContainer,
      children: [/* @__PURE__ */ x.jsx(qT, {
        reduceAnimations: S,
        transKey: K,
        children: /* @__PURE__ */ x.jsx(NK, {
          id: P,
          ownerState: D,
          className: j.label,
          children: K
        })
      }), R.length > 1 && !p && /* @__PURE__ */ x.jsx(E, ee({}, M, {
        children: /* @__PURE__ */ x.jsx(F, ee({}, V))
      }))]
    }), /* @__PURE__ */ x.jsx(Vi, {
      in: $ === "day",
      appear: !S,
      enter: !S,
      children: /* @__PURE__ */ x.jsx(zH, {
        slots: l,
        slotProps: c,
        onGoToPrevious: L,
        isPreviousDisabled: se,
        previousLabel: r.previousMonth,
        onGoToNext: z,
        isNextDisabled: G,
        nextLabel: r.nextMonth
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (YT.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  className: i.string,
  currentMonth: i.object.isRequired,
  disabled: i.bool,
  disableFuture: i.bool,
  disablePast: i.bool,
  /**
   * Format used to display the date.
   * @default `${adapter.formats.month} ${adapter.formats.year}`
   */
  format: i.string,
  /**
   * Id of the calendar text element.
   * It is used to establish an `aria-labelledby` relationship with the calendar `grid` element.
   */
  labelId: i.string,
  maxDate: i.object.isRequired,
  minDate: i.object.isRequired,
  onMonthChange: i.func.isRequired,
  onViewChange: i.func,
  reduceAnimations: i.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: i.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  timezone: i.string.isRequired,
  view: i.oneOf(["day", "month", "year"]).isRequired,
  views: i.arrayOf(i.oneOf(["day", "month", "year"]).isRequired).isRequired
});
const LK = "@media (prefers-reduced-motion: reduce)", ss = typeof navigator < "u" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i), r$ = ss && ss[1] ? parseInt(ss[1], 10) : null, o$ = ss && ss[2] ? parseInt(ss[2], 10) : null, BK = r$ && r$ < 10 || o$ && o$ < 13 || !1, KT = () => P0(LK, {
  defaultMatches: !1
}) || BK, VK = (e) => Fe("MuiDateCalendar", e);
Le("MuiDateCalendar", ["root", "viewTransitionContainer"]);
const zK = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsOrder", "yearsPerRow", "monthsPerRow", "timezone"], WK = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  }, VK, t);
};
function qK(e, t) {
  const n = pn(), r = hc(), o = KT(), a = dn({
    props: e,
    name: t
  });
  return ee({}, a, {
    loading: a.loading ?? !1,
    disablePast: a.disablePast ?? !1,
    disableFuture: a.disableFuture ?? !1,
    openTo: a.openTo ?? "day",
    views: a.views ?? ["year", "day"],
    reduceAnimations: a.reduceAnimations ?? o,
    renderLoading: a.renderLoading ?? (() => /* @__PURE__ */ x.jsx("span", {
      children: "..."
    })),
    minDate: eo(n, a.minDate, r.minDate),
    maxDate: eo(n, a.maxDate, r.maxDate)
  });
}
const UK = ae(XH, {
  name: "MuiDateCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column",
  height: oy
}), HK = ae(qT, {
  name: "MuiDateCalendar",
  slot: "ViewTransitionContainer",
  overridesResolver: (e, t) => t.viewTransitionContainer
})({}), XT = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = pn(), o = Mr(), a = qK(t, "MuiDateCalendar"), {
    autoFocus: l,
    onViewChange: c,
    value: d,
    defaultValue: p,
    referenceDate: f,
    disableFuture: m,
    disablePast: g,
    onChange: y,
    onYearChange: b,
    onMonthChange: v,
    reduceAnimations: $,
    shouldDisableDate: S,
    shouldDisableMonth: R,
    shouldDisableYear: P,
    view: T,
    views: O,
    openTo: k,
    className: I,
    disabled: D,
    readOnly: j,
    minDate: E,
    maxDate: M,
    disableHighlightToday: F,
    focusedView: B,
    onFocusedViewChange: V,
    showDaysOutsideCurrentMonth: z,
    fixedWeekNumber: L,
    dayOfWeekFormatter: G,
    slots: se,
    slotProps: ne,
    loading: K,
    renderLoading: Q,
    displayWeekNumber: ye,
    yearsOrder: we,
    yearsPerRow: fe,
    monthsPerRow: X,
    timezone: re
  } = a, ie = mt(a, zK), {
    value: Y,
    handleValueChange: Z,
    timezone: ue
  } = ly({
    name: "DateCalendar",
    timezone: re,
    value: d,
    defaultValue: p,
    referenceDate: f,
    onChange: y,
    valueManager: Bo
  }), {
    view: ge,
    setView: W,
    focusedView: J,
    setFocusedView: le,
    goToNextView: me,
    setValueAndGoToNextView: be
  } = $T({
    view: T,
    views: O,
    openTo: k,
    onChange: Z,
    onViewChange: c,
    autoFocus: l,
    focusedView: B,
    onFocusedViewChange: V
  }), {
    referenceDate: de,
    calendarState: Oe,
    changeFocusedDay: Re,
    changeMonth: We,
    handleChangeMonth: Ye,
    isDateDisabled: Ie,
    onMonthSwitchingAnimationEnd: kt
  } = jY({
    value: Y,
    referenceDate: f,
    reduceAnimations: $,
    onMonthChange: v,
    minDate: E,
    maxDate: M,
    shouldDisableDate: S,
    disablePast: g,
    disableFuture: m,
    timezone: ue
  }), Ee = D && Y || E, Ae = D && Y || M, pt = `${o}-grid-label`, Ue = J !== null, et = (se == null ? void 0 : se.calendarHeader) ?? YT, Je = Lt({
    elementType: et,
    externalSlotProps: ne == null ? void 0 : ne.calendarHeader,
    additionalProps: {
      views: O,
      view: ge,
      currentMonth: Oe.currentMonth,
      onViewChange: W,
      onMonthChange: (gt, Et) => Ye({
        newMonth: gt,
        direction: Et
      }),
      minDate: Ee,
      maxDate: Ae,
      disabled: D,
      disablePast: g,
      disableFuture: m,
      reduceAnimations: $,
      timezone: ue,
      labelId: pt
    },
    ownerState: a
  }), rt = ze((gt) => {
    const Et = r.startOfMonth(gt), xn = r.endOfMonth(gt), ln = Ie(gt) ? Pl({
      utils: r,
      date: gt,
      minDate: r.isBefore(E, Et) ? Et : E,
      maxDate: r.isAfter(M, xn) ? xn : M,
      disablePast: g,
      disableFuture: m,
      isDateDisabled: Ie,
      timezone: ue
    }) : gt;
    ln ? (be(ln, "finish"), v == null || v(Et)) : (me(), We(Et)), Re(ln, !0);
  }), je = ze((gt) => {
    const Et = r.startOfYear(gt), xn = r.endOfYear(gt), ln = Ie(gt) ? Pl({
      utils: r,
      date: gt,
      minDate: r.isBefore(E, Et) ? Et : E,
      maxDate: r.isAfter(M, xn) ? xn : M,
      disablePast: g,
      disableFuture: m,
      isDateDisabled: Ie,
      timezone: ue
    }) : gt;
    ln ? (be(ln, "finish"), b == null || b(ln)) : (me(), We(Et)), Re(ln, !0);
  }), $t = ze((gt) => Z(gt && pd(r, gt, Y ?? de), "finish", ge));
  w.useEffect(() => {
    Y != null && r.isValid(Y) && We(Y);
  }, [Y]);
  const Pt = a, Ft = WK(Pt), Jt = {
    disablePast: g,
    disableFuture: m,
    maxDate: M,
    minDate: E
  }, Me = {
    disableHighlightToday: F,
    readOnly: j,
    disabled: D,
    timezone: ue,
    gridLabelId: pt,
    slots: se,
    slotProps: ne
  }, it = w.useRef(ge);
  w.useEffect(() => {
    it.current !== ge && (J === it.current && le(ge, !0), it.current = ge);
  }, [J, le, ge]);
  const bt = w.useMemo(() => [Y], [Y]);
  return /* @__PURE__ */ x.jsxs(UK, ee({
    ref: n,
    className: _e(Ft.root, I),
    ownerState: Pt
  }, ie, {
    children: [/* @__PURE__ */ x.jsx(et, ee({}, Je, {
      slots: se,
      slotProps: ne
    })), /* @__PURE__ */ x.jsx(HK, {
      reduceAnimations: $,
      className: Ft.viewTransitionContainer,
      transKey: ge,
      ownerState: Pt,
      children: /* @__PURE__ */ x.jsxs("div", {
        children: [ge === "year" && /* @__PURE__ */ x.jsx(GT, ee({}, Jt, Me, {
          value: Y,
          onChange: je,
          shouldDisableYear: P,
          hasFocus: Ue,
          onFocusedViewChange: (gt) => le("year", gt),
          yearsOrder: we,
          yearsPerRow: fe,
          referenceDate: de
        })), ge === "month" && /* @__PURE__ */ x.jsx(HT, ee({}, Jt, Me, {
          hasFocus: Ue,
          className: I,
          value: Y,
          onChange: rt,
          shouldDisableMonth: R,
          onFocusedViewChange: (gt) => le("month", gt),
          monthsPerRow: X,
          referenceDate: de
        })), ge === "day" && /* @__PURE__ */ x.jsx(aK, ee({}, Oe, Jt, Me, {
          onMonthSwitchingAnimationEnd: kt,
          onFocusedDayChange: Re,
          reduceAnimations: $,
          selectedDays: bt,
          onSelectedDaysChange: $t,
          shouldDisableDate: S,
          shouldDisableMonth: R,
          shouldDisableYear: P,
          hasFocus: Ue,
          onFocusedViewChange: (gt) => le("day", gt),
          showDaysOutsideCurrentMonth: z,
          fixedWeekNumber: L,
          dayOfWeekFormatter: G,
          displayWeekNumber: ye,
          loading: K,
          renderLoading: Q
        }))]
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (XT.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: i.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  className: i.string,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: i.func,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: i.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: i.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: i.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: i.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: i.bool,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: i.number,
  /**
   * Controlled focused view.
   */
  focusedView: i.oneOf(["day", "month", "year"]),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: i.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: i.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: i.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: i.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: i.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: i.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: i.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: i.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: i.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: i.oneOf(["day", "month", "year"]),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: i.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: i.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: i.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: i.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: i.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: i.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: i.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: i.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: i.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: i.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: i.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: i.oneOf(["day", "month", "year"]),
  /**
   * Available views.
   */
  views: i.arrayOf(i.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: i.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: i.oneOf([3, 4])
});
function GK(e) {
  return Fe("MuiPickersToolbar", e);
}
Le("MuiPickersToolbar", ["root", "content"]);
const YK = ["children", "className", "toolbarTitle", "hidden", "titleId", "isLandscape", "classes", "landscapeDirection"], KK = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"],
    content: ["content"]
  }, GK, t);
}, XK = ae("div", {
  name: "MuiPickersToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: e.spacing(2, 3),
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      height: "auto",
      maxWidth: 160,
      padding: 16,
      justifyContent: "flex-start",
      flexWrap: "wrap"
    }
  }]
})), ZK = ae("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})({
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
  flex: 1,
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      justifyContent: "flex-start",
      alignItems: "flex-start",
      flexDirection: "column"
    }
  }, {
    props: {
      isLandscape: !0,
      landscapeDirection: "row"
    },
    style: {
      flexDirection: "row"
    }
  }]
}), QK = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = dn({
    props: t,
    name: "MuiPickersToolbar"
  }), {
    children: o,
    className: a,
    toolbarTitle: l,
    hidden: c,
    titleId: d
  } = r, p = mt(r, YK), f = r, m = KK(f);
  return c ? null : /* @__PURE__ */ x.jsxs(XK, ee({
    ref: n,
    className: _e(m.root, a),
    ownerState: f
  }, p, {
    children: [/* @__PURE__ */ x.jsx(Qe, {
      color: "text.secondary",
      variant: "overline",
      id: d,
      children: l
    }), /* @__PURE__ */ x.jsx(ZK, {
      className: m.content,
      ownerState: f,
      children: o
    })]
  }));
});
function JK(e) {
  return Fe("MuiDatePickerToolbar", e);
}
Le("MuiDatePickerToolbar", ["root", "title"]);
const eX = ["value", "isLandscape", "onChange", "toolbarFormat", "toolbarPlaceholder", "views", "className", "onViewChange", "view"], tX = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"],
    title: ["title"]
  }, JK, t);
}, nX = ae(QK, {
  name: "MuiDatePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), rX = ae(Qe, {
  name: "MuiDatePickerToolbar",
  slot: "Title",
  overridesResolver: (e, t) => t.title
})({
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      margin: "auto 16px auto auto"
    }
  }]
}), ZT = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = dn({
    props: t,
    name: "MuiDatePickerToolbar"
  }), {
    value: o,
    isLandscape: a,
    toolbarFormat: l,
    toolbarPlaceholder: c = "––",
    views: d,
    className: p
  } = r, f = mt(r, eX), m = pn(), g = bi(), y = tX(r), b = w.useMemo(() => {
    if (!o)
      return c;
    const $ = ay(m, {
      format: l,
      views: d
    }, !0);
    return m.formatByString(o, $);
  }, [o, l, c, m, d]), v = r;
  return /* @__PURE__ */ x.jsx(nX, ee({
    ref: n,
    toolbarTitle: g.datePickerToolbarTitle,
    isLandscape: a,
    className: _e(y.root, p)
  }, f, {
    children: /* @__PURE__ */ x.jsx(rX, {
      variant: "h4",
      align: a ? "left" : "center",
      ownerState: v,
      className: y.title,
      children: b
    })
  }));
});
process.env.NODE_ENV !== "production" && (ZT.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  className: i.string,
  disabled: i.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: i.bool,
  isLandscape: i.bool.isRequired,
  onChange: i.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: i.func.isRequired,
  readOnly: i.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  titleId: i.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: i.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: i.node,
  value: i.object,
  /**
   * Currently visible picker view.
   */
  view: i.oneOf(["day", "month", "year"]).isRequired,
  /**
   * Available views.
   */
  views: i.arrayOf(i.oneOf(["day", "month", "year"]).isRequired).isRequired
});
function QT(e, t) {
  const n = pn(), r = hc(), o = dn({
    props: e,
    name: t
  }), a = w.useMemo(() => {
    var l;
    return ((l = o.localeText) == null ? void 0 : l.toolbarTitle) == null ? o.localeText : ee({}, o.localeText, {
      datePickerToolbarTitle: o.localeText.toolbarTitle
    });
  }, [o.localeText]);
  return ee({}, o, {
    localeText: a
  }, WH({
    views: o.views,
    openTo: o.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    disableFuture: o.disableFuture ?? !1,
    disablePast: o.disablePast ?? !1,
    minDate: eo(n, o.minDate, r.minDate),
    maxDate: eo(n, o.maxDate, r.maxDate),
    slots: ee({
      toolbar: ZT
    }, o.slots)
  });
}
function oX(e) {
  return Fe("MuiPickersPopper", e);
}
Le("MuiPickersPopper", ["root", "paper"]);
const iX = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"], aX = (e) => {
  const {
    classes: t
  } = e;
  return Be({
    root: ["root"],
    paper: ["paper"]
  }, oX, t);
}, sX = ae(Es, {
  name: "MuiPickersPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), lX = ae(mi, {
  name: "MuiPickersPopper",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  outline: 0,
  transformOrigin: "top center",
  variants: [{
    props: ({
      placement: e
    }) => ["top", "top-start", "top-end"].includes(e),
    style: {
      transformOrigin: "bottom center"
    }
  }]
});
function cX(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function uX(e, t) {
  const n = w.useRef(!1), r = w.useRef(!1), o = w.useRef(null), a = w.useRef(!1);
  w.useEffect(() => {
    if (!e)
      return;
    function d() {
      a.current = !0;
    }
    return document.addEventListener("mousedown", d, !0), document.addEventListener("touchstart", d, !0), () => {
      document.removeEventListener("mousedown", d, !0), document.removeEventListener("touchstart", d, !0), a.current = !1;
    };
  }, [e]);
  const l = ze((d) => {
    if (!a.current)
      return;
    const p = r.current;
    r.current = !1;
    const f = er(o.current);
    if (!o.current || // is a TouchEvent?
    "clientX" in d && cX(d, f))
      return;
    if (n.current) {
      n.current = !1;
      return;
    }
    let m;
    d.composedPath ? m = d.composedPath().indexOf(o.current) > -1 : m = !f.documentElement.contains(d.target) || o.current.contains(d.target), !m && !p && t(d);
  }), c = () => {
    r.current = !0;
  };
  return w.useEffect(() => {
    if (e) {
      const d = er(o.current), p = () => {
        n.current = !0;
      };
      return d.addEventListener("touchstart", l), d.addEventListener("touchmove", p), () => {
        d.removeEventListener("touchstart", l), d.removeEventListener("touchmove", p);
      };
    }
  }, [e, l]), w.useEffect(() => {
    if (e) {
      const d = er(o.current);
      return d.addEventListener("click", l), () => {
        d.removeEventListener("click", l), r.current = !1;
      };
    }
  }, [e, l]), [o, c, c];
}
const dX = /* @__PURE__ */ w.forwardRef((e, t) => {
  const {
    PaperComponent: n,
    popperPlacement: r,
    ownerState: o,
    children: a,
    paperSlotProps: l,
    paperClasses: c,
    onPaperClick: d,
    onPaperTouchStart: p
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = e, f = mt(e, iX), m = ee({}, o, {
    placement: r
  }), g = Lt({
    elementType: n,
    externalSlotProps: l,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: t
    },
    className: c,
    ownerState: m
  });
  return /* @__PURE__ */ x.jsx(n, ee({}, f, g, {
    onClick: (y) => {
      var b;
      d(y), (b = g.onClick) == null || b.call(g, y);
    },
    onTouchStart: (y) => {
      var b;
      p(y), (b = g.onTouchStart) == null || b.call(g, y);
    },
    ownerState: m,
    children: a
  }));
});
function pX(e) {
  const t = dn({
    props: e,
    name: "MuiPickersPopper"
  }), {
    anchorEl: n,
    children: r,
    containerRef: o = null,
    shouldRestoreFocus: a,
    onBlur: l,
    onDismiss: c,
    open: d,
    role: p,
    placement: f,
    slots: m,
    slotProps: g,
    reduceAnimations: y
  } = t;
  w.useEffect(() => {
    function z(L) {
      d && L.key === "Escape" && c();
    }
    return document.addEventListener("keydown", z), () => {
      document.removeEventListener("keydown", z);
    };
  }, [c, d]);
  const b = w.useRef(null);
  w.useEffect(() => {
    p === "tooltip" || a && !a() || (d ? b.current = yr(document) : b.current && b.current instanceof HTMLElement && setTimeout(() => {
      b.current instanceof HTMLElement && b.current.focus();
    }));
  }, [d, p, a]);
  const [v, $, S] = uX(d, l ?? c), R = w.useRef(null), P = It(R, o), T = It(P, v), O = t, k = aX(O), I = KT(), D = y ?? I, j = (z) => {
    z.key === "Escape" && (z.stopPropagation(), c());
  }, E = (m == null ? void 0 : m.desktopTransition) ?? D ? Vi : vs, M = (m == null ? void 0 : m.desktopTrapFocus) ?? Fl, F = (m == null ? void 0 : m.desktopPaper) ?? lX, B = (m == null ? void 0 : m.popper) ?? sX, V = Lt({
    elementType: B,
    externalSlotProps: g == null ? void 0 : g.popper,
    additionalProps: {
      transition: !0,
      role: p,
      open: d,
      anchorEl: n,
      placement: f,
      onKeyDown: j
    },
    className: k.root,
    ownerState: t
  });
  return /* @__PURE__ */ x.jsx(B, ee({}, V, {
    children: ({
      TransitionProps: z,
      placement: L
    }) => /* @__PURE__ */ x.jsx(M, ee({
      open: d,
      disableAutoFocus: !0,
      disableRestoreFocus: !0,
      disableEnforceFocus: p === "tooltip",
      isEnabled: () => !0
    }, g == null ? void 0 : g.desktopTrapFocus, {
      children: /* @__PURE__ */ x.jsx(E, ee({}, z, g == null ? void 0 : g.desktopTransition, {
        children: /* @__PURE__ */ x.jsx(dX, {
          PaperComponent: F,
          ownerState: O,
          popperPlacement: L,
          ref: T,
          onPaperClick: $,
          onPaperTouchStart: S,
          paperClasses: k.paper,
          paperSlotProps: g == null ? void 0 : g.desktopPaper,
          children: r
        })
      }))
    }))
  }));
}
const i$ = /* @__PURE__ */ new Set();
function fX(e, t = "warning") {
  if (process.env.NODE_ENV === "production")
    return;
  const n = Array.isArray(e) ? e.join(`
`) : e;
  i$.has(n) || (i$.add(n), t === "error" ? console.error(n) : console.warn(n));
}
const hX = ({
  open: e,
  onOpen: t,
  onClose: n
}) => {
  const r = w.useRef(typeof e == "boolean").current, [o, a] = w.useState(!1);
  w.useEffect(() => {
    if (r) {
      if (typeof e != "boolean")
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      a(e);
    }
  }, [r, e]);
  const l = w.useCallback((c) => {
    r || a(c), c && t && t(), !c && n && n();
  }, [r, t, n]);
  return {
    isOpen: o,
    setIsOpen: l
  };
}, mX = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: r,
    isControlled: o
  } = e, a = !o && !r.hasBeenModifiedSinceMount;
  return t.name === "setValueFromField" ? !0 : t.name === "setValueFromAction" ? a && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(r.lastPublishedValue) : t.name === "setValueFromView" && t.selectionState !== "shallow" || t.name === "setValueFromShortcut" ? a ? !0 : n(r.lastPublishedValue) : !1;
}, gX = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: r,
    isControlled: o,
    closeOnSelect: a
  } = e, l = !o && !r.hasBeenModifiedSinceMount;
  return t.name === "setValueFromAction" ? l && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(r.lastCommittedValue) : t.name === "setValueFromView" && t.selectionState === "finish" && a ? l ? !0 : n(r.lastCommittedValue) : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" && n(r.lastCommittedValue) : !1;
}, yX = (e) => {
  const {
    action: t,
    closeOnSelect: n
  } = e;
  return t.name === "setValueFromAction" ? !0 : t.name === "setValueFromView" ? t.selectionState === "finish" && n : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" : !1;
}, vX = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: r,
  validator: o
}) => {
  const {
    onAccept: a,
    onChange: l,
    value: c,
    defaultValue: d,
    closeOnSelect: p = r === "desktop",
    timezone: f,
    referenceDate: m
  } = e, {
    current: g
  } = w.useRef(d), {
    current: y
  } = w.useRef(c !== void 0), [b, v] = w.useState(f);
  process.env.NODE_ENV !== "production" && (w.useEffect(() => {
    y !== (c !== void 0) && console.error([`MUI X: A component is changing the ${y ? "" : "un"}controlled value of a picker to be ${y ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled valuefor the lifetime of the component.", "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
  }, [c]), w.useEffect(() => {
    !y && g !== d && console.error(["MUI X: A component is changing the defaultValue of an uncontrolled picker after being initialized. To suppress this warning opt to use a controlled value."].join(`
`));
  }, [JSON.stringify(g)]));
  const $ = pn(), S = Pa(), {
    isOpen: R,
    setIsOpen: P
  } = hX(e), {
    timezone: T,
    value: O,
    handleValueChange: k
  } = sy({
    timezone: f,
    value: c,
    defaultValue: g,
    referenceDate: m,
    onChange: l,
    valueManager: t
  }), [I, D] = w.useState(() => {
    let Z;
    return O !== void 0 ? Z = O : g !== void 0 ? Z = g : Z = t.emptyValue, {
      draft: Z,
      lastPublishedValue: Z,
      lastCommittedValue: Z,
      lastControlledValue: c,
      hasBeenModifiedSinceMount: !1
    };
  }), j = t.getTimezone($, I.draft);
  b !== f && (v(f), f && j && f !== j && D((Z) => ee({}, Z, {
    draft: t.setTimezone($, f, Z.draft)
  })));
  const {
    getValidationErrorForNewValue: E
  } = MT({
    props: e,
    validator: o,
    timezone: T,
    value: I.draft,
    onError: e.onError
  }), M = ze((Z) => {
    const ue = {
      action: Z,
      dateState: I,
      hasChanged: (be) => !t.areValuesEqual($, Z.value, be),
      isControlled: y,
      closeOnSelect: p
    }, ge = mX(ue), W = gX(ue), J = yX(ue);
    D((be) => ee({}, be, {
      draft: Z.value,
      lastPublishedValue: ge ? Z.value : be.lastPublishedValue,
      lastCommittedValue: W ? Z.value : be.lastCommittedValue,
      hasBeenModifiedSinceMount: !0
    }));
    let le = null;
    const me = () => (le || (le = {
      validationError: Z.name === "setValueFromField" ? Z.context.validationError : E(Z.value)
    }, Z.name === "setValueFromShortcut" && (le.shortcut = Z.shortcut)), le);
    ge && k(Z.value, me()), W && a && a(Z.value, me()), J && P(!1);
  });
  if (I.lastControlledValue !== c) {
    const Z = t.areValuesEqual($, I.draft, O);
    D((ue) => ee({}, ue, {
      lastControlledValue: c
    }, Z ? {} : {
      lastCommittedValue: O,
      lastPublishedValue: O,
      draft: O,
      hasBeenModifiedSinceMount: !0
    }));
  }
  const F = ze(() => {
    M({
      value: t.emptyValue,
      name: "setValueFromAction",
      pickerAction: "clear"
    });
  }), B = ze(() => {
    M({
      value: I.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "accept"
    });
  }), V = ze(() => {
    M({
      value: I.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "dismiss"
    });
  }), z = ze(() => {
    M({
      value: I.lastCommittedValue,
      name: "setValueFromAction",
      pickerAction: "cancel"
    });
  }), L = ze(() => {
    M({
      value: t.getTodayValue($, T, n),
      name: "setValueFromAction",
      pickerAction: "today"
    });
  }), G = ze((Z) => {
    Z.preventDefault(), P(!0);
  }), se = ze((Z) => {
    Z == null || Z.preventDefault(), P(!1);
  }), ne = ze((Z, ue = "partial") => M({
    name: "setValueFromView",
    value: Z,
    selectionState: ue
  })), K = ze((Z, ue, ge) => M({
    name: "setValueFromShortcut",
    value: Z,
    changeImportance: ue,
    shortcut: ge
  })), Q = ze((Z, ue) => M({
    name: "setValueFromField",
    value: Z,
    context: ue
  })), ye = {
    onClear: F,
    onAccept: B,
    onDismiss: V,
    onCancel: z,
    onSetToday: L,
    onOpen: G,
    onClose: se
  }, we = {
    value: I.draft,
    onChange: Q
  }, fe = w.useMemo(() => t.cleanValue($, I.draft), [$, t, I.draft]), X = {
    value: fe,
    onChange: ne,
    onClose: se,
    open: R
  }, ie = ee({}, ye, {
    value: fe,
    onChange: ne,
    onSelectShortcut: K,
    isValid: (Z) => {
      const ue = o({
        adapter: S,
        value: Z,
        timezone: T,
        props: e
      });
      return !t.hasError(ue);
    }
  }), Y = w.useMemo(() => ({
    onOpen: G,
    onClose: se,
    open: R
  }), [R, se, G]);
  return {
    open: R,
    fieldProps: we,
    viewProps: X,
    layoutProps: ie,
    actions: ye,
    contextValue: Y
  };
}, bX = ["className", "sx"], xX = ({
  props: e,
  propsFromPickerValue: t,
  additionalViewProps: n,
  autoFocusView: r,
  rendererInterceptor: o,
  fieldRef: a
}) => {
  const {
    onChange: l,
    open: c,
    onClose: d
  } = t, {
    view: p,
    views: f,
    openTo: m,
    onViewChange: g,
    viewRenderers: y,
    timezone: b
  } = e, v = mt(e, bX), {
    view: $,
    setView: S,
    defaultView: R,
    focusedView: P,
    setFocusedView: T,
    setValueAndGoToNextView: O
  } = $T({
    view: p,
    views: f,
    openTo: m,
    onChange: l,
    onViewChange: g,
    autoFocus: r
  }), {
    hasUIView: k,
    viewModeLookup: I
  } = w.useMemo(() => f.reduce((V, z) => {
    let L;
    return y[z] != null ? L = "UI" : L = "field", V.viewModeLookup[z] = L, L === "UI" && (V.hasUIView = !0), V;
  }, {
    hasUIView: !1,
    viewModeLookup: {}
  }), [y, f]), D = w.useMemo(() => f.reduce((V, z) => y[z] != null && UH(z) ? V + 1 : V, 0), [y, f]), j = I[$], E = ze(() => j === "UI"), [M, F] = w.useState(j === "UI" ? $ : null);
  return M !== $ && I[$] === "UI" && F($), Nn(() => {
    j === "field" && c && (d(), setTimeout(() => {
      var V, z;
      (V = a == null ? void 0 : a.current) == null || V.setSelectedSections($), (z = a == null ? void 0 : a.current) == null || z.focusField($);
    }));
  }, [$]), Nn(() => {
    if (!c)
      return;
    let V = $;
    j === "field" && M != null && (V = M), V !== R && I[V] === "UI" && I[R] === "UI" && (V = R), V !== $ && S(V), T(V, !0);
  }, [c]), {
    hasUIView: k,
    shouldRestoreFocus: E,
    layoutProps: {
      views: f,
      view: M,
      onViewChange: S
    },
    renderCurrentView: () => {
      if (M == null)
        return null;
      const V = y[M];
      if (V == null)
        return null;
      const z = ee({}, v, n, t, {
        views: f,
        timezone: b,
        onChange: O,
        view: M,
        onViewChange: S,
        focusedView: P,
        onFocusedViewChange: T,
        showViewSwitcher: D > 1,
        timeViewsCount: D
      });
      return o ? o(y, M, z) : V(z);
    }
  };
};
function a$() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
}
const wX = (e, t) => {
  const [n, r] = w.useState(a$);
  return Nn(() => {
    const a = () => {
      r(a$());
    };
    return window.addEventListener("orientationchange", a), () => {
      window.removeEventListener("orientationchange", a);
    };
  }, []), vG(e, ["hours", "minutes", "seconds"]) ? !1 : (t || n) === "landscape";
}, $X = ({
  props: e,
  propsFromPickerValue: t,
  propsFromPickerViews: n,
  wrapperVariant: r
}) => {
  const {
    orientation: o
  } = e, a = wX(n.views, o), l = no();
  return {
    layoutProps: ee({}, n, t, {
      isLandscape: a,
      isRtl: l,
      wrapperVariant: r,
      disabled: e.disabled,
      readOnly: e.readOnly
    })
  };
};
function CX(e) {
  const {
    props: t,
    pickerValueResponse: n
  } = e;
  return w.useMemo(() => ({
    value: n.viewProps.value,
    open: n.open,
    disabled: t.disabled ?? !1,
    readOnly: t.readOnly ?? !1
  }), [n.viewProps.value, n.open, t.disabled, t.readOnly]);
}
const JT = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: r,
  additionalViewProps: o,
  validator: a,
  autoFocusView: l,
  rendererInterceptor: c,
  fieldRef: d
}) => {
  process.env.NODE_ENV !== "production" && e.renderInput != null && fX(["MUI X: The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]);
  const p = vX({
    props: e,
    valueManager: t,
    valueType: n,
    wrapperVariant: r,
    validator: a
  }), f = xX({
    props: e,
    additionalViewProps: o,
    autoFocusView: l,
    fieldRef: d,
    propsFromPickerValue: p.viewProps,
    rendererInterceptor: c
  }), m = $X({
    props: e,
    wrapperVariant: r,
    propsFromPickerValue: p.layoutProps,
    propsFromPickerViews: f.layoutProps
  }), g = CX({
    props: e,
    pickerValueResponse: p
  });
  return {
    // Picker value
    open: p.open,
    actions: p.actions,
    fieldProps: p.fieldProps,
    // Picker views
    renderCurrentView: f.renderCurrentView,
    hasUIView: f.hasUIView,
    shouldRestoreFocus: f.shouldRestoreFocus,
    // Picker layout
    layoutProps: m.layoutProps,
    // Picker context
    contextValue: p.contextValue,
    // Picker owner state
    ownerState: g
  };
};
function eO(e) {
  return Fe("MuiPickersLayout", e);
}
const la = Le("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "tabs", "shortcuts"]), SX = ["onAccept", "onClear", "onCancel", "onSetToday", "actions"];
function tO(e) {
  const {
    onAccept: t,
    onClear: n,
    onCancel: r,
    onSetToday: o,
    actions: a
  } = e, l = mt(e, SX), c = bi();
  if (a == null || a.length === 0)
    return null;
  const d = a == null ? void 0 : a.map((p) => {
    switch (p) {
      case "clear":
        return /* @__PURE__ */ x.jsx(Tn, {
          onClick: n,
          children: c.clearButtonLabel
        }, p);
      case "cancel":
        return /* @__PURE__ */ x.jsx(Tn, {
          onClick: r,
          children: c.cancelButtonLabel
        }, p);
      case "accept":
        return /* @__PURE__ */ x.jsx(Tn, {
          onClick: t,
          children: c.okButtonLabel
        }, p);
      case "today":
        return /* @__PURE__ */ x.jsx(Tn, {
          onClick: o,
          children: c.todayButtonLabel
        }, p);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ x.jsx(ii, ee({}, l, {
    children: d
  }));
}
process.env.NODE_ENV !== "production" && (tO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default `['cancel', 'accept']` for mobile and `[]` for desktop
   */
  actions: i.arrayOf(i.oneOf(["accept", "cancel", "clear", "today"]).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: i.bool,
  onAccept: i.func.isRequired,
  onCancel: i.func.isRequired,
  onClear: i.func.isRequired,
  onSetToday: i.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
const TX = ["items", "changeImportance", "isLandscape", "onChange", "isValid"], OX = ["getValue"];
function nO(e) {
  const {
    items: t,
    changeImportance: n = "accept",
    onChange: r,
    isValid: o
  } = e, a = mt(e, TX);
  if (t == null || t.length === 0)
    return null;
  const l = t.map((c) => {
    let {
      getValue: d
    } = c, p = mt(c, OX);
    const f = d({
      isValid: o
    });
    return ee({}, p, {
      label: p.label,
      onClick: () => {
        r(f, n, p);
      },
      disabled: !o(f)
    });
  });
  return /* @__PURE__ */ x.jsx(sc, ee({
    dense: !0,
    sx: [{
      maxHeight: oy,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(a.sx) ? a.sx : [a.sx]]
  }, a, {
    children: l.map((c) => /* @__PURE__ */ x.jsx(q3, {
      children: /* @__PURE__ */ x.jsx(Vd, ee({}, c))
    }, c.id ?? c.label))
  }));
}
process.env.NODE_ENV !== "production" && (nO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the picker.
   * @default "accept"
   */
  changeImportance: i.oneOf(["accept", "set"]),
  className: i.string,
  component: i.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: i.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: i.bool,
  isLandscape: i.bool.isRequired,
  isValid: i.func.isRequired,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default []
   */
  items: i.arrayOf(i.shape({
    getValue: i.func.isRequired,
    id: i.string,
    label: i.string.isRequired
  })),
  onChange: i.func.isRequired,
  style: i.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: i.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object])
});
function PX(e) {
  return e.view !== null;
}
const EX = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return Be({
    root: ["root", n && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  }, eO, t);
}, RX = (e) => {
  const {
    wrapperVariant: t,
    onAccept: n,
    onClear: r,
    onCancel: o,
    onSetToday: a,
    view: l,
    views: c,
    onViewChange: d,
    value: p,
    onChange: f,
    onSelectShortcut: m,
    isValid: g,
    isLandscape: y,
    disabled: b,
    readOnly: v,
    children: $,
    slots: S,
    slotProps: R
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = e, P = EX(e), T = (S == null ? void 0 : S.actionBar) ?? tO, O = Lt({
    elementType: T,
    externalSlotProps: R == null ? void 0 : R.actionBar,
    additionalProps: {
      onAccept: n,
      onClear: r,
      onCancel: o,
      onSetToday: a,
      actions: t === "desktop" ? [] : ["cancel", "accept"]
    },
    className: P.actionBar,
    ownerState: ee({}, e, {
      wrapperVariant: t
    })
  }), k = /* @__PURE__ */ x.jsx(T, ee({}, O)), I = S == null ? void 0 : S.toolbar, D = Lt({
    elementType: I,
    externalSlotProps: R == null ? void 0 : R.toolbar,
    additionalProps: {
      isLandscape: y,
      onChange: f,
      value: p,
      view: l,
      onViewChange: d,
      views: c,
      disabled: b,
      readOnly: v
    },
    className: P.toolbar,
    ownerState: ee({}, e, {
      wrapperVariant: t
    })
  }), j = PX(D) && I ? /* @__PURE__ */ x.jsx(I, ee({}, D)) : null, E = $, M = S == null ? void 0 : S.tabs, F = l && M ? /* @__PURE__ */ x.jsx(M, ee({
    view: l,
    onViewChange: d,
    className: P.tabs
  }, R == null ? void 0 : R.tabs)) : null, B = (S == null ? void 0 : S.shortcuts) ?? nO, V = Lt({
    elementType: B,
    externalSlotProps: R == null ? void 0 : R.shortcuts,
    additionalProps: {
      isValid: g,
      isLandscape: y,
      onChange: m
    },
    className: P.shortcuts,
    ownerState: {
      isValid: g,
      isLandscape: y,
      onChange: m,
      wrapperVariant: t
    }
  }), z = l && B ? /* @__PURE__ */ x.jsx(B, ee({}, V)) : null;
  return {
    toolbar: j,
    content: E,
    tabs: F,
    actionBar: k,
    shortcuts: z
  };
}, kX = (e) => {
  const {
    isLandscape: t,
    classes: n
  } = e;
  return Be({
    root: ["root", t && "landscape"],
    contentWrapper: ["contentWrapper"]
  }, eO, n);
}, _X = ae("div", {
  name: "MuiPickersLayout",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${la.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  },
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      [`& .${la.toolbar}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      },
      [`.${la.shortcuts}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      }
    }
  }, {
    props: {
      isLandscape: !0,
      isRtl: !0
    },
    style: {
      [`& .${la.toolbar}`]: {
        gridColumn: 3
      }
    }
  }, {
    props: {
      isLandscape: !1
    },
    style: {
      [`& .${la.toolbar}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      },
      [`& .${la.shortcuts}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      }
    }
  }, {
    props: {
      isLandscape: !1,
      isRtl: !0
    },
    style: {
      [`& .${la.shortcuts}`]: {
        gridColumn: 3
      }
    }
  }]
}), DX = ae("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper",
  overridesResolver: (e, t) => t.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
}), yy = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = dn({
    props: t,
    name: "MuiPickersLayout"
  }), {
    toolbar: o,
    content: a,
    tabs: l,
    actionBar: c,
    shortcuts: d
  } = RX(r), {
    sx: p,
    className: f,
    isLandscape: m,
    wrapperVariant: g
  } = r, y = kX(r);
  return /* @__PURE__ */ x.jsxs(_X, {
    ref: n,
    sx: p,
    className: _e(y.root, f),
    ownerState: r,
    children: [m ? d : o, m ? o : d, /* @__PURE__ */ x.jsx(DX, {
      className: y.contentWrapper,
      children: g === "desktop" ? /* @__PURE__ */ x.jsxs(w.Fragment, {
        children: [a, l]
      }) : /* @__PURE__ */ x.jsxs(w.Fragment, {
        children: [l, a]
      })
    }), c]
  });
});
process.env.NODE_ENV !== "production" && (yy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: i.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: i.object,
  className: i.string,
  disabled: i.bool,
  isLandscape: i.bool.isRequired,
  /**
   * `true` if the application is in right-to-left direction.
   */
  isRtl: i.bool.isRequired,
  isValid: i.func.isRequired,
  onAccept: i.func.isRequired,
  onCancel: i.func.isRequired,
  onChange: i.func.isRequired,
  onClear: i.func.isRequired,
  onClose: i.func.isRequired,
  onDismiss: i.func.isRequired,
  onOpen: i.func.isRequired,
  onSelectShortcut: i.func.isRequired,
  onSetToday: i.func.isRequired,
  onViewChange: i.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: i.oneOf(["landscape", "portrait"]),
  readOnly: i.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: i.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  value: i.any,
  view: i.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: i.arrayOf(i.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: i.oneOf(["desktop", "mobile"])
});
const IX = ["props", "getOpenDialogAriaText"], MX = ["ownerState"], AX = ["ownerState"], NX = (e) => {
  var me;
  let {
    props: t,
    getOpenDialogAriaText: n
  } = e, r = mt(e, IX);
  const {
    slots: o,
    slotProps: a,
    className: l,
    sx: c,
    format: d,
    formatDensity: p,
    enableAccessibleFieldDOMStructure: f,
    selectedSections: m,
    onSelectedSectionsChange: g,
    timezone: y,
    name: b,
    label: v,
    inputRef: $,
    readOnly: S,
    disabled: R,
    autoFocus: P,
    localeText: T,
    reduceAnimations: O
  } = t, k = w.useRef(null), I = w.useRef(null), D = Mr(), j = ((me = a == null ? void 0 : a.toolbar) == null ? void 0 : me.hidden) ?? !1, {
    open: E,
    actions: M,
    hasUIView: F,
    layoutProps: B,
    renderCurrentView: V,
    shouldRestoreFocus: z,
    fieldProps: L,
    contextValue: G,
    ownerState: se
  } = JT(ee({}, r, {
    props: t,
    fieldRef: I,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "desktop"
  })), ne = o.inputAdornment ?? Rs, K = Lt({
    elementType: ne,
    externalSlotProps: a == null ? void 0 : a.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: t
  }), Q = mt(K, MX), ye = o.openPickerButton ?? Vo, we = Lt({
    elementType: ye,
    externalSlotProps: a == null ? void 0 : a.openPickerButton,
    additionalProps: {
      disabled: R || S,
      onClick: E ? M.onClose : M.onOpen,
      "aria-label": n(L.value),
      edge: Q.position
    },
    ownerState: t
  }), fe = mt(we, AX), X = o.openPickerIcon, re = Lt({
    elementType: X,
    externalSlotProps: a == null ? void 0 : a.openPickerIcon,
    ownerState: se
  }), ie = o.field, Y = Lt({
    elementType: ie,
    externalSlotProps: a == null ? void 0 : a.field,
    additionalProps: ee({}, L, j && {
      id: D
    }, {
      readOnly: S,
      disabled: R,
      className: l,
      sx: c,
      format: d,
      formatDensity: p,
      enableAccessibleFieldDOMStructure: f,
      selectedSections: m,
      onSelectedSectionsChange: g,
      timezone: y,
      label: v,
      name: b,
      autoFocus: P && !t.open,
      focused: E ? !0 : void 0
    }, $ ? {
      inputRef: $
    } : {}),
    ownerState: t
  });
  F && (Y.InputProps = ee({}, Y.InputProps, {
    ref: k
  }, !t.disableOpenPicker && {
    [`${Q.position}Adornment`]: /* @__PURE__ */ x.jsx(ne, ee({}, Q, {
      children: /* @__PURE__ */ x.jsx(ye, ee({}, fe, {
        children: /* @__PURE__ */ x.jsx(X, ee({}, re))
      }))
    }))
  }));
  const Z = ee({
    textField: o.textField,
    clearIcon: o.clearIcon,
    clearButton: o.clearButton
  }, Y.slots), ue = o.layout ?? yy;
  let ge = D;
  j && (v ? ge = `${D}-label` : ge = void 0);
  const W = ee({}, a, {
    toolbar: ee({}, a == null ? void 0 : a.toolbar, {
      titleId: D
    }),
    popper: ee({
      "aria-labelledby": ge
    }, a == null ? void 0 : a.popper)
  }), J = It(I, Y.unstableFieldRef);
  return {
    renderPicker: () => /* @__PURE__ */ x.jsxs(AT, {
      contextValue: G,
      localeText: T,
      children: [/* @__PURE__ */ x.jsx(ie, ee({}, Y, {
        slots: Z,
        slotProps: W,
        unstableFieldRef: J
      })), /* @__PURE__ */ x.jsx(pX, ee({
        role: "dialog",
        placement: "bottom-start",
        anchorEl: k.current
      }, M, {
        open: E,
        slots: o,
        slotProps: W,
        shouldRestoreFocus: z,
        reduceAnimations: O,
        children: /* @__PURE__ */ x.jsx(ue, ee({}, B, W == null ? void 0 : W.layout, {
          slots: o,
          slotProps: W,
          children: V()
        }))
      }))]
    })
  };
}, ls = ({
  view: e,
  onViewChange: t,
  views: n,
  focusedView: r,
  onFocusedViewChange: o,
  value: a,
  defaultValue: l,
  referenceDate: c,
  onChange: d,
  className: p,
  classes: f,
  disableFuture: m,
  disablePast: g,
  minDate: y,
  maxDate: b,
  shouldDisableDate: v,
  shouldDisableMonth: $,
  shouldDisableYear: S,
  reduceAnimations: R,
  onMonthChange: P,
  monthsPerRow: T,
  onYearChange: O,
  yearsOrder: k,
  yearsPerRow: I,
  slots: D,
  slotProps: j,
  loading: E,
  renderLoading: M,
  disableHighlightToday: F,
  readOnly: B,
  disabled: V,
  showDaysOutsideCurrentMonth: z,
  dayOfWeekFormatter: L,
  sx: G,
  autoFocus: se,
  fixedWeekNumber: ne,
  displayWeekNumber: K,
  timezone: Q
}) => /* @__PURE__ */ x.jsx(XT, {
  view: e,
  onViewChange: t,
  views: n.filter(Gw),
  focusedView: r && Gw(r) ? r : null,
  onFocusedViewChange: o,
  value: a,
  defaultValue: l,
  referenceDate: c,
  onChange: d,
  className: p,
  classes: f,
  disableFuture: m,
  disablePast: g,
  minDate: y,
  maxDate: b,
  shouldDisableDate: v,
  shouldDisableMonth: $,
  shouldDisableYear: S,
  reduceAnimations: R,
  onMonthChange: P,
  monthsPerRow: T,
  onYearChange: O,
  yearsOrder: k,
  yearsPerRow: I,
  slots: D,
  slotProps: j,
  loading: E,
  renderLoading: M,
  disableHighlightToday: F,
  readOnly: B,
  disabled: V,
  showDaysOutsideCurrentMonth: z,
  dayOfWeekFormatter: L,
  sx: G,
  autoFocus: se,
  fixedWeekNumber: ne,
  displayWeekNumber: K,
  timezone: Q
}), rO = /* @__PURE__ */ w.forwardRef(function(t, n) {
  var p, f;
  const r = bi(), o = pn(), a = QT(t, "MuiDesktopDatePicker"), l = ee({
    day: ls,
    month: ls,
    year: ls
  }, a.viewRenderers), c = ee({}, a, {
    viewRenderers: l,
    format: ay(o, a, !1),
    yearsPerRow: a.yearsPerRow ?? 4,
    slots: ee({
      openPickerIcon: IH,
      field: gy
    }, a.slots),
    slotProps: ee({}, a.slotProps, {
      field: (m) => {
        var g;
        return ee({}, Ad((g = a.slotProps) == null ? void 0 : g.field, m), IT(a), {
          ref: n
        });
      },
      toolbar: ee({
        hidden: !0
      }, (p = a.slotProps) == null ? void 0 : p.toolbar)
    })
  }), {
    renderPicker: d
  } = NX({
    props: c,
    valueManager: Bo,
    valueType: "date",
    getOpenDialogAriaText: xT({
      utils: o,
      formatKey: "fullDate",
      contextTranslation: r.openDatePickerDialogue,
      propsTranslation: (f = c.localeText) == null ? void 0 : f.openDatePickerDialogue
    }),
    validator: mc
  });
  return d();
});
rO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: i.bool,
  className: i.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: i.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: i.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: i.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: i.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: i.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: i.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: i.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: i.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: i.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: i.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: i.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: i.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * The label content.
   */
  label: i.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: i.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: i.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: i.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: i.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: i.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: i.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: i.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: i.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: i.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: i.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: i.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: i.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: i.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: i.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: i.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: i.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: i.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: i.oneOf(["landscape", "portrait"]),
  readOnly: i.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: i.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: i.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: i.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: i.oneOfType([i.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), i.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: i.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: i.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: i.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: i.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: i.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: i.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: i.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: i.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: i.shape({
    day: i.func,
    month: i.func,
    year: i.func
  }),
  /**
   * Available views.
   */
  views: i.arrayOf(i.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: i.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: i.oneOf([3, 4])
};
const jX = ae(Sa)({
  [`& .${Tl.container}`]: {
    outline: 0
  },
  [`& .${Tl.paper}`]: {
    outline: 0,
    minWidth: vp
  }
}), FX = ae(Yd)({
  "&:first-of-type": {
    padding: 0
  }
});
function LX(e) {
  const {
    children: t,
    onDismiss: n,
    open: r,
    slots: o,
    slotProps: a
  } = e, l = (o == null ? void 0 : o.dialog) ?? jX, c = (o == null ? void 0 : o.mobileTransition) ?? Vi;
  return /* @__PURE__ */ x.jsx(l, ee({
    open: r,
    onClose: n
  }, a == null ? void 0 : a.dialog, {
    TransitionComponent: c,
    TransitionProps: a == null ? void 0 : a.mobileTransition,
    PaperComponent: o == null ? void 0 : o.mobilePaper,
    PaperProps: a == null ? void 0 : a.mobilePaper,
    children: /* @__PURE__ */ x.jsx(FX, {
      children: t
    })
  }));
}
const BX = ["props", "getOpenDialogAriaText"], VX = (e) => {
  var Q;
  let {
    props: t,
    getOpenDialogAriaText: n
  } = e, r = mt(e, BX);
  const {
    slots: o,
    slotProps: a,
    className: l,
    sx: c,
    format: d,
    formatDensity: p,
    enableAccessibleFieldDOMStructure: f,
    selectedSections: m,
    onSelectedSectionsChange: g,
    timezone: y,
    name: b,
    label: v,
    inputRef: $,
    readOnly: S,
    disabled: R,
    localeText: P
  } = t, T = w.useRef(null), O = Mr(), k = ((Q = a == null ? void 0 : a.toolbar) == null ? void 0 : Q.hidden) ?? !1, {
    open: I,
    actions: D,
    layoutProps: j,
    renderCurrentView: E,
    fieldProps: M,
    contextValue: F
  } = JT(ee({}, r, {
    props: t,
    fieldRef: T,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "mobile"
  })), B = o.field, V = Lt({
    elementType: B,
    externalSlotProps: a == null ? void 0 : a.field,
    additionalProps: ee({}, M, k && {
      id: O
    }, !(R || S) && {
      onClick: D.onOpen,
      onKeyDown: bG(D.onOpen)
    }, {
      readOnly: S ?? !0,
      disabled: R,
      className: l,
      sx: c,
      format: d,
      formatDensity: p,
      enableAccessibleFieldDOMStructure: f,
      selectedSections: m,
      onSelectedSectionsChange: g,
      timezone: y,
      label: v,
      name: b
    }, $ ? {
      inputRef: $
    } : {}),
    ownerState: t
  });
  V.inputProps = ee({}, V.inputProps, {
    "aria-label": n(M.value)
  });
  const z = ee({
    textField: o.textField
  }, V.slots), L = o.layout ?? yy;
  let G = O;
  k && (v ? G = `${O}-label` : G = void 0);
  const se = ee({}, a, {
    toolbar: ee({}, a == null ? void 0 : a.toolbar, {
      titleId: O
    }),
    mobilePaper: ee({
      "aria-labelledby": G
    }, a == null ? void 0 : a.mobilePaper)
  }), ne = It(T, V.unstableFieldRef);
  return {
    renderPicker: () => /* @__PURE__ */ x.jsxs(AT, {
      contextValue: F,
      localeText: P,
      children: [/* @__PURE__ */ x.jsx(B, ee({}, V, {
        slots: z,
        slotProps: se,
        unstableFieldRef: ne
      })), /* @__PURE__ */ x.jsx(LX, ee({}, D, {
        open: I,
        slots: o,
        slotProps: se,
        children: /* @__PURE__ */ x.jsx(L, ee({}, j, se == null ? void 0 : se.layout, {
          slots: o,
          slotProps: se,
          children: E()
        }))
      }))]
    })
  };
}, oO = /* @__PURE__ */ w.forwardRef(function(t, n) {
  var p, f;
  const r = bi(), o = pn(), a = QT(t, "MuiMobileDatePicker"), l = ee({
    day: ls,
    month: ls,
    year: ls
  }, a.viewRenderers), c = ee({}, a, {
    viewRenderers: l,
    format: ay(o, a, !1),
    slots: ee({
      field: gy
    }, a.slots),
    slotProps: ee({}, a.slotProps, {
      field: (m) => {
        var g;
        return ee({}, Ad((g = a.slotProps) == null ? void 0 : g.field, m), IT(a), {
          ref: n
        });
      },
      toolbar: ee({
        hidden: !1
      }, (p = a.slotProps) == null ? void 0 : p.toolbar)
    })
  }), {
    renderPicker: d
  } = VX({
    props: c,
    valueManager: Bo,
    valueType: "date",
    getOpenDialogAriaText: xT({
      utils: o,
      formatKey: "fullDate",
      contextTranslation: r.openDatePickerDialogue,
      propsTranslation: (f = c.localeText) == null ? void 0 : f.openDatePickerDialogue
    }),
    validator: mc
  });
  return d();
});
oO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: i.bool,
  className: i.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: i.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: i.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: i.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: i.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: i.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: i.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: i.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: i.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: i.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: i.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: i.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: i.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * The label content.
   */
  label: i.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: i.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: i.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: i.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: i.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: i.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: i.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: i.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: i.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: i.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: i.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: i.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: i.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: i.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: i.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: i.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: i.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: i.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: i.oneOf(["landscape", "portrait"]),
  readOnly: i.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: i.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: i.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: i.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: i.oneOfType([i.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), i.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: i.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: i.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: i.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: i.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: i.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: i.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: i.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: i.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: i.shape({
    day: i.func,
    month: i.func,
    year: i.func
  }),
  /**
   * Available views.
   */
  views: i.arrayOf(i.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: i.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: i.oneOf([3, 4])
};
const zX = ["desktopModeMediaQuery"], iO = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = dn({
    props: t,
    name: "MuiDatePicker"
  }), {
    desktopModeMediaQuery: o = xG
  } = r, a = mt(r, zX);
  return P0(o, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ x.jsx(rO, ee({
    ref: n
  }, a)) : /* @__PURE__ */ x.jsx(oO, ee({
    ref: n
  }, a));
});
process.env.NODE_ENV !== "production" && (iO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: i.bool,
  className: i.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: i.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: i.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: i.object,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: i.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: i.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: i.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: i.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: i.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: i.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: i.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: i.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: i.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: i.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: i.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * The label content.
   */
  label: i.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: i.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: i.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: i.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: i.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: i.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: i.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: i.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: i.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: i.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: i.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: i.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: i.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: i.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: i.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: i.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: i.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: i.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: i.oneOf(["landscape", "portrait"]),
  readOnly: i.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: i.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: i.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: i.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: i.oneOfType([i.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), i.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: i.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: i.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: i.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: i.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: i.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: i.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: i.oneOfType([i.arrayOf(i.oneOfType([i.func, i.object, i.bool])), i.func, i.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: i.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: i.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: i.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: i.shape({
    day: i.func,
    month: i.func,
    year: i.func
  }),
  /**
   * Available views.
   */
  views: i.arrayOf(i.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: i.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: i.oneOf([3, 4])
});
const WX = {
  // Year
  y: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yy: "year",
  yyy: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yyyy: "year",
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  L: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  LL: "month",
  LLL: {
    sectionType: "month",
    contentType: "letter"
  },
  LLLL: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  d: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  dd: "day",
  do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  E: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  i: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ii: "weekDay",
  iii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  iiii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // eslint-disable-next-line id-denylist
  e: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ee: "weekDay",
  eee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  c: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  cc: "weekDay",
  ccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  a: "meridiem",
  aa: "meridiem",
  aaa: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, qX = {
  year: "yyyy",
  month: "LLLL",
  monthShort: "MMM",
  dayOfMonth: "d",
  dayOfMonthFull: "do",
  weekday: "EEEE",
  weekdayShort: "EEEEEE",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "aa",
  minutes: "mm",
  seconds: "ss",
  fullDate: "PP",
  keyboardDate: "P",
  shortDate: "MMM d",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  fullTime: "p",
  fullTime12h: "hh:mm aa",
  fullTime24h: "HH:mm",
  keyboardDateTime: "P p",
  keyboardDateTime12h: "P hh:mm aa",
  keyboardDateTime24h: "P HH:mm"
};
class UX {
  constructor(t) {
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !1, this.lib = void 0, this.locale = void 0, this.formats = void 0, this.formatTokenMap = WX, this.escapedCharacters = {
      start: "'",
      end: "'"
    }, this.longFormatters = void 0, this.date = (l) => typeof l > "u" ? /* @__PURE__ */ new Date() : l === null ? null : new Date(l), this.getInvalidDate = () => /* @__PURE__ */ new Date("Invalid Date"), this.getTimezone = () => "default", this.setTimezone = (l) => l, this.toJsDate = (l) => l, this.getCurrentLocaleCode = () => this.locale.code, this.is12HourCycleInCurrentLocale = () => /a/.test(this.locale.formatLong.time({
      width: "short"
    })), this.expandFormat = (l) => {
      const c = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      return l.match(c).map((d) => {
        const p = d[0];
        if (p === "p" || p === "P") {
          const f = this.longFormatters[p];
          return f(d, this.locale.formatLong);
        }
        return d;
      }).join("");
    }, this.formatNumber = (l) => l, this.getDayOfWeek = (l) => l.getDay() + 1;
    const {
      locale: n,
      formats: r,
      longFormatters: o,
      lib: a
    } = t;
    this.locale = n, this.formats = ee({}, qX, r), this.longFormatters = o, this.lib = a || "date-fns";
  }
}
class HX extends UX {
  constructor({
    locale: t,
    formats: n
  } = {}) {
    if (process.env.NODE_ENV !== "production") {
      if (typeof zi != "function")
        throw new Error(["MUI: The `date-fns` package v2.x is not compatible with this adapter.", "Please, install v3.x or v4.x of the package or use the `AdapterDateFns` instead."].join(`
`));
      if (!zl)
        throw new Error("MUI: The minimum supported `date-fns` package version compatible with this adapter is `3.2.x`.");
    }
    super({
      locale: t ?? mp,
      formats: n,
      longFormatters: zl
    }), this.parse = (r, o) => r === "" ? null : hH(r, o, /* @__PURE__ */ new Date(), {
      locale: this.locale
    }), this.isValid = (r) => r == null ? !1 : cd(r), this.format = (r, o) => this.formatByString(r, this.formats[o]), this.formatByString = (r, o) => lU(r, o, {
      locale: this.locale
    }), this.isEqual = (r, o) => r === null && o === null ? !0 : r === null || o === null ? !1 : bU(r, o), this.isSameYear = (r, o) => vH(r, o), this.isSameMonth = (r, o) => yH(r, o), this.isSameDay = (r, o) => fq(r, o), this.isSameHour = (r, o) => gH(r, o), this.isAfter = (r, o) => om(r, o), this.isAfterYear = (r, o) => om(r, Aw(o)), this.isAfterDay = (r, o) => om(r, Mw(o)), this.isBefore = (r, o) => im(r, o), this.isBeforeYear = (r, o) => im(r, this.startOfYear(o)), this.isBeforeDay = (r, o) => im(r, this.startOfDay(o)), this.isWithinRange = (r, [o, a]) => bH(r, {
      start: o,
      end: a
    }), this.startOfYear = (r) => uT(r), this.startOfMonth = (r) => gq(r), this.startOfWeek = (r) => hi(r, {
      locale: this.locale
    }), this.startOfDay = (r) => xs(r), this.endOfYear = (r) => Aw(r), this.endOfMonth = (r) => mq(r), this.endOfWeek = (r) => yq(r, {
      locale: this.locale
    }), this.endOfDay = (r) => Mw(r), this.addYears = (r, o) => ld(r, o), this.addMonths = (r, o) => Vl(r, o), this.addWeeks = (r, o) => sd(r, o), this.addDays = (r, o) => zi(r, o), this.addHours = (r, o) => sq(r, o), this.addMinutes = (r, o) => dq(r, o), this.addSeconds = (r, o) => pq(r, o), this.getYear = (r) => vU(r), this.getMonth = (r) => gU(r), this.getDate = (r) => uU(r), this.getHours = (r) => pU(r), this.getMinutes = (r) => mU(r), this.getSeconds = (r) => yU(r), this.getMilliseconds = (r) => hU(r), this.setYear = (r, o) => OH(r, o), this.setMonth = (r, o) => xH(r, o), this.setDate = (r, o) => wH(r, o), this.setHours = (r, o) => $H(r, o), this.setMinutes = (r, o) => SH(r, o), this.setSeconds = (r, o) => TH(r, o), this.setMilliseconds = (r, o) => CH(r, o), this.getDaysInMonth = (r) => mT(r), this.getWeekArray = (r) => {
      const o = this.startOfWeek(this.startOfMonth(r)), a = this.endOfWeek(this.endOfMonth(r));
      let l = 0, c = o;
      const d = [];
      for (; this.isBefore(c, a); ) {
        const p = Math.floor(l / 7);
        d[p] = d[p] || [], d[p].push(c), c = this.addDays(c, 1), l += 1;
      }
      return d;
    }, this.getWeekNumber = (r) => ey(r, {
      locale: this.locale
    }), this.getYearRange = ([r, o]) => {
      const a = this.startOfYear(r), l = this.endOfYear(o), c = [];
      let d = a;
      for (; this.isBefore(d, l); )
        c.push(d), d = this.addYears(d, 1);
      return c;
    };
  }
}
const GX = ({
  disabled: e = !1,
  value: t,
  onChange: n,
  error: r,
  name: o,
  label: a,
  readOnly: l = !1,
  min: c,
  minPeriod: d,
  minDirection: p,
  max: f,
  maxPeriod: m,
  maxDirection: g,
  message: y,
  messageComparison: b,
  messageAmount: v,
  messagePeriod: $,
  messageIsAfter: S,
  displayDays: R = !0
}) => {
  const [P, T] = Kt(!1), [O, k] = Kt(null), I = () => {
    T(!P), k(y || null);
  }, D = (E, M) => {
    if (!(E === null || !cd(E))) {
      if (y && b && v && $ && S) {
        let F = /* @__PURE__ */ new Date();
        switch ($) {
          case "days":
            F = S ? zi(F, v) : Vw(F, v);
            break;
          case "weeks":
            F = S ? sd(F, v) : Ww(F, v);
            break;
          case "months":
            F = S ? Vl(F, v) : zw(F, v);
            break;
          case "years":
            F = S ? ld(F, v) : qw(F, v);
            break;
        }
        if (b === "lessthan" && E < F || b === "morethan" && E > F) {
          I();
          return;
        }
      }
      M(E);
    }
  }, j = (E, M, F) => {
    const B = xs(/* @__PURE__ */ new Date()), V = F === "after";
    switch (M) {
      case "days":
        return V ? zi(B, E) : Vw(B, E + 1);
      case "weeks":
        return V ? sd(B, E) : Ww(B, E + 1);
      case "months":
        return V ? Vl(B, E) : zw(B, E + 1);
      case "years":
        return V ? ld(B, E) : qw(B, E + 1);
    }
  };
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(Gn, { fullWidth: !0, size: "small", children: [
      /* @__PURE__ */ x.jsx(ur, { id: `${o}-label`, htmlFor: `${o}-input`, disabled: e, children: a }),
      /* @__PURE__ */ x.jsx(ry, { dateAdapter: HX, adapterLocale: mp, children: /* @__PURE__ */ x.jsx(
        iO,
        {
          "aria-labelledby": `${o}-label`,
          value: cd(t) ? t : null,
          disabled: e,
          readOnly: e || l,
          slotProps: {
            textField: {
              size: "small",
              error: !!r,
              inputProps: {
                "data-testid": `${o}-input`,
                "aria-labelledby": `${o}-label`,
                id: `${o}-input`
              }
            },
            field: { clearable: !0, onClear: () => n(void 0) },
            openPickerButton: {
              className: "openDatePickerIconButton"
            }
          },
          views: R ? ["day", "month", "year"] : ["month", "year"],
          onChange: (E) => D(E, n),
          minDate: c !== void 0 && d && p ? j(c, d, p) : void 0,
          maxDate: f !== void 0 && m && g ? j(f, m, g) : void 0
        }
      ) })
    ] }),
    r ? /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "error", children: r.message }) : /* @__PURE__ */ x.jsx(x.Fragment, {}),
    /* @__PURE__ */ x.jsxs(Sa, { open: P, onClose: I, children: [
      /* @__PURE__ */ x.jsx(wa, { variant: "h4", component: "h2", children: "Warning" }),
      /* @__PURE__ */ x.jsx(Yd, { children: /* @__PURE__ */ x.jsx(Qe, { children: O }) }),
      /* @__PURE__ */ x.jsx(ii, { children: /* @__PURE__ */ x.jsx(Tn, { onClick: I, children: "Close" }) })
    ] })
  ] });
};
function YX(e, t, n) {
  const r = e.includes(t) ? e.filter((o) => o !== t) : [...e, t];
  n(r);
}
const KX = ({
  label: e,
  disabled: t,
  value: n,
  onChange: r,
  error: o,
  name: a,
  readOnly: l,
  options: c,
  control: d,
  direction: p = "horizontal",
  itemWrapperProps: f = {}
}) => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
  /* @__PURE__ */ x.jsxs(Gn, { fullWidth: !0, size: "small", sx: { pointerEvents: l ? "none" : "auto" }, children: [
    /* @__PURE__ */ x.jsx(ur, { id: `${a}-label`, children: e }),
    /* @__PURE__ */ x.jsx(T0, { children: /* @__PURE__ */ x.jsxs(Qt, { direction: p === "horizontal" ? "row" : "column", flexWrap: "wrap", columnGap: 3, rowGap: 2, children: [
      c.map(({ value: m, label: g, textField: y }) => {
        const b = rT(m), { sx: v = {}, ...$ } = f;
        return /* @__PURE__ */ x.jsxs(Zr, { sx: { display: "flex", alignItems: "flex-start", ...v }, ...$, children: [
          /* @__PURE__ */ x.jsx(
            Xd,
            {
              control: /* @__PURE__ */ x.jsx(
                Gd,
                {
                  value: m,
                  disabled: t || l,
                  checked: n.includes(m),
                  onChange: () => YX(n, m, r)
                }
              ),
              label: g || m
            }
          ),
          y && /* @__PURE__ */ x.jsx(
            oT,
            {
              dependsOn: {
                disabled: !!(t || l),
                name: a,
                value: m
              },
              control: d,
              textField: y
            },
            `${a}-${b}-additional`
          )
        ] }, `${a}-checkbox-${b}`);
      }),
      /* @__PURE__ */ x.jsx(Zr, { flexGrow: "1" })
    ] }) })
  ] }),
  o && /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "error", children: o.message })
] });
var sm, s$;
function XX() {
  if (s$) return sm;
  s$ = 1;
  var e = ap();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return sm = t, sm;
}
var lm, l$;
function ZX() {
  if (l$) return lm;
  l$ = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return lm = e, lm;
}
var cm, c$;
function QX() {
  if (c$) return cm;
  c$ = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return cm = e, cm;
}
var um, u$;
function JX() {
  if (u$) return um;
  u$ = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return um = e, um;
}
var dm, d$;
function eZ() {
  if (d$) return dm;
  d$ = 1;
  var e = ap(), t = H0(), n = G0(), r = 200;
  function o(a, l) {
    var c = this.__data__;
    if (c instanceof e) {
      var d = c.__data__;
      if (!t || d.length < r - 1)
        return d.push([a, l]), this.size = ++c.size, this;
      c = this.__data__ = new n(d);
    }
    return c.set(a, l), this.size = c.size, this;
  }
  return dm = o, dm;
}
var pm, p$;
function tZ() {
  if (p$) return pm;
  p$ = 1;
  var e = ap(), t = XX(), n = ZX(), r = QX(), o = JX(), a = eZ();
  function l(c) {
    var d = this.__data__ = new e(c);
    this.size = d.size;
  }
  return l.prototype.clear = t, l.prototype.delete = n, l.prototype.get = r, l.prototype.has = o, l.prototype.set = a, pm = l, pm;
}
var fm, f$;
function nZ() {
  if (f$) return fm;
  f$ = 1;
  var e = "__lodash_hash_undefined__";
  function t(n) {
    return this.__data__.set(n, e), this;
  }
  return fm = t, fm;
}
var hm, h$;
function rZ() {
  if (h$) return hm;
  h$ = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return hm = e, hm;
}
var mm, m$;
function oZ() {
  if (m$) return mm;
  m$ = 1;
  var e = G0(), t = nZ(), n = rZ();
  function r(o) {
    var a = -1, l = o == null ? 0 : o.length;
    for (this.__data__ = new e(); ++a < l; )
      this.add(o[a]);
  }
  return r.prototype.add = r.prototype.push = t, r.prototype.has = n, mm = r, mm;
}
var gm, g$;
function iZ() {
  if (g$) return gm;
  g$ = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length; ++r < o; )
      if (n(t[r], r, t))
        return !0;
    return !1;
  }
  return gm = e, gm;
}
var ym, y$;
function aZ() {
  if (y$) return ym;
  y$ = 1;
  function e(t, n) {
    return t.has(n);
  }
  return ym = e, ym;
}
var vm, v$;
function aO() {
  if (v$) return vm;
  v$ = 1;
  var e = oZ(), t = iZ(), n = aZ(), r = 1, o = 2;
  function a(l, c, d, p, f, m) {
    var g = d & r, y = l.length, b = c.length;
    if (y != b && !(g && b > y))
      return !1;
    var v = m.get(l), $ = m.get(c);
    if (v && $)
      return v == c && $ == l;
    var S = -1, R = !0, P = d & o ? new e() : void 0;
    for (m.set(l, c), m.set(c, l); ++S < y; ) {
      var T = l[S], O = c[S];
      if (p)
        var k = g ? p(O, T, S, c, l, m) : p(T, O, S, l, c, m);
      if (k !== void 0) {
        if (k)
          continue;
        R = !1;
        break;
      }
      if (P) {
        if (!t(c, function(I, D) {
          if (!n(P, D) && (T === I || f(T, I, d, p, m)))
            return P.push(D);
        })) {
          R = !1;
          break;
        }
      } else if (!(T === O || f(T, O, d, p, m))) {
        R = !1;
        break;
      }
    }
    return m.delete(l), m.delete(c), R;
  }
  return vm = a, vm;
}
var bm, b$;
function sZ() {
  if (b$) return bm;
  b$ = 1;
  var e = vi(), t = e.Uint8Array;
  return bm = t, bm;
}
var xm, x$;
function lZ() {
  if (x$) return xm;
  x$ = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(o, a) {
      r[++n] = [a, o];
    }), r;
  }
  return xm = e, xm;
}
var wm, w$;
function cZ() {
  if (w$) return wm;
  w$ = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(o) {
      r[++n] = o;
    }), r;
  }
  return wm = e, wm;
}
var $m, $$;
function uZ() {
  if ($$) return $m;
  $$ = 1;
  var e = rp(), t = sZ(), n = RS(), r = aO(), o = lZ(), a = cZ(), l = 1, c = 2, d = "[object Boolean]", p = "[object Date]", f = "[object Error]", m = "[object Map]", g = "[object Number]", y = "[object RegExp]", b = "[object Set]", v = "[object String]", $ = "[object Symbol]", S = "[object ArrayBuffer]", R = "[object DataView]", P = e ? e.prototype : void 0, T = P ? P.valueOf : void 0;
  function O(k, I, D, j, E, M, F) {
    switch (D) {
      case R:
        if (k.byteLength != I.byteLength || k.byteOffset != I.byteOffset)
          return !1;
        k = k.buffer, I = I.buffer;
      case S:
        return !(k.byteLength != I.byteLength || !M(new t(k), new t(I)));
      case d:
      case p:
      case g:
        return n(+k, +I);
      case f:
        return k.name == I.name && k.message == I.message;
      case y:
      case v:
        return k == I + "";
      case m:
        var B = o;
      case b:
        var V = j & l;
        if (B || (B = a), k.size != I.size && !V)
          return !1;
        var z = F.get(k);
        if (z)
          return z == I;
        j |= c, F.set(k, I);
        var L = r(B(k), B(I), j, E, M, F);
        return F.delete(k), L;
      case $:
        if (T)
          return T.call(k) == T.call(I);
    }
    return !1;
  }
  return $m = O, $m;
}
var Cm, C$;
function dZ() {
  if (C$) return Cm;
  C$ = 1;
  function e(t, n) {
    for (var r = -1, o = n.length, a = t.length; ++r < o; )
      t[a + r] = n[r];
    return t;
  }
  return Cm = e, Cm;
}
var Sm, S$;
function pZ() {
  if (S$) return Sm;
  S$ = 1;
  var e = dZ(), t = _s();
  function n(r, o, a) {
    var l = o(r);
    return t(r) ? l : e(l, a(r));
  }
  return Sm = n, Sm;
}
var Tm, T$;
function fZ() {
  if (T$) return Tm;
  T$ = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, a = 0, l = []; ++r < o; ) {
      var c = t[r];
      n(c, r, t) && (l[a++] = c);
    }
    return l;
  }
  return Tm = e, Tm;
}
var Om, O$;
function hZ() {
  if (O$) return Om;
  O$ = 1;
  function e() {
    return [];
  }
  return Om = e, Om;
}
var Pm, P$;
function mZ() {
  if (P$) return Pm;
  P$ = 1;
  var e = fZ(), t = hZ(), n = Object.prototype, r = n.propertyIsEnumerable, o = Object.getOwnPropertySymbols, a = o ? function(l) {
    return l == null ? [] : (l = Object(l), e(o(l), function(c) {
      return r.call(l, c);
    }));
  } : t;
  return Pm = a, Pm;
}
var Em, E$;
function gZ() {
  if (E$) return Em;
  E$ = 1;
  function e(t, n) {
    for (var r = -1, o = Array(t); ++r < t; )
      o[r] = n(r);
    return o;
  }
  return Em = e, Em;
}
var Rm, R$;
function yZ() {
  if (R$) return Rm;
  R$ = 1;
  var e = dc(), t = pc(), n = "[object Arguments]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return Rm = r, Rm;
}
var km, k$;
function vZ() {
  if (k$) return km;
  k$ = 1;
  var e = yZ(), t = pc(), n = Object.prototype, r = n.hasOwnProperty, o = n.propertyIsEnumerable, a = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(l) {
    return t(l) && r.call(l, "callee") && !o.call(l, "callee");
  };
  return km = a, km;
}
var vl = { exports: {} }, _m, _$;
function bZ() {
  if (_$) return _m;
  _$ = 1;
  function e() {
    return !1;
  }
  return _m = e, _m;
}
vl.exports;
var D$;
function sO() {
  return D$ || (D$ = 1, function(e, t) {
    var n = vi(), r = bZ(), o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, l = a && a.exports === o, c = l ? n.Buffer : void 0, d = c ? c.isBuffer : void 0, p = d || r;
    e.exports = p;
  }(vl, vl.exports)), vl.exports;
}
var Dm, I$;
function xZ() {
  if (I$) return Dm;
  I$ = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, o) {
    var a = typeof r;
    return o = o ?? e, !!o && (a == "number" || a != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < o;
  }
  return Dm = n, Dm;
}
var Im, M$;
function lO() {
  if (M$) return Im;
  M$ = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return Im = t, Im;
}
var Mm, A$;
function wZ() {
  if (A$) return Mm;
  A$ = 1;
  var e = dc(), t = lO(), n = pc(), r = "[object Arguments]", o = "[object Array]", a = "[object Boolean]", l = "[object Date]", c = "[object Error]", d = "[object Function]", p = "[object Map]", f = "[object Number]", m = "[object Object]", g = "[object RegExp]", y = "[object Set]", b = "[object String]", v = "[object WeakMap]", $ = "[object ArrayBuffer]", S = "[object DataView]", R = "[object Float32Array]", P = "[object Float64Array]", T = "[object Int8Array]", O = "[object Int16Array]", k = "[object Int32Array]", I = "[object Uint8Array]", D = "[object Uint8ClampedArray]", j = "[object Uint16Array]", E = "[object Uint32Array]", M = {};
  M[R] = M[P] = M[T] = M[O] = M[k] = M[I] = M[D] = M[j] = M[E] = !0, M[r] = M[o] = M[$] = M[a] = M[S] = M[l] = M[c] = M[d] = M[p] = M[f] = M[m] = M[g] = M[y] = M[b] = M[v] = !1;
  function F(B) {
    return n(B) && t(B.length) && !!M[e(B)];
  }
  return Mm = F, Mm;
}
var Am, N$;
function $Z() {
  if (N$) return Am;
  N$ = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return Am = e, Am;
}
var bl = { exports: {} };
bl.exports;
var j$;
function CZ() {
  return j$ || (j$ = 1, function(e, t) {
    var n = TS(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, a = o && o.exports === r, l = a && n.process, c = function() {
      try {
        var d = o && o.require && o.require("util").types;
        return d || l && l.binding && l.binding("util");
      } catch {
      }
    }();
    e.exports = c;
  }(bl, bl.exports)), bl.exports;
}
var Nm, F$;
function cO() {
  if (F$) return Nm;
  F$ = 1;
  var e = wZ(), t = $Z(), n = CZ(), r = n && n.isTypedArray, o = r ? t(r) : e;
  return Nm = o, Nm;
}
var jm, L$;
function SZ() {
  if (L$) return jm;
  L$ = 1;
  var e = gZ(), t = vZ(), n = _s(), r = sO(), o = xZ(), a = cO(), l = Object.prototype, c = l.hasOwnProperty;
  function d(p, f) {
    var m = n(p), g = !m && t(p), y = !m && !g && r(p), b = !m && !g && !y && a(p), v = m || g || y || b, $ = v ? e(p.length, String) : [], S = $.length;
    for (var R in p)
      (f || c.call(p, R)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
      (R == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      y && (R == "offset" || R == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      b && (R == "buffer" || R == "byteLength" || R == "byteOffset") || // Skip index properties.
      o(R, S))) && $.push(R);
    return $;
  }
  return jm = d, jm;
}
var Fm, B$;
function TZ() {
  if (B$) return Fm;
  B$ = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, o = typeof r == "function" && r.prototype || e;
    return n === o;
  }
  return Fm = t, Fm;
}
var Lm, V$;
function OZ() {
  if (V$) return Lm;
  V$ = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return Lm = e, Lm;
}
var Bm, z$;
function PZ() {
  if (z$) return Bm;
  z$ = 1;
  var e = OZ(), t = e(Object.keys, Object);
  return Bm = t, Bm;
}
var Vm, W$;
function EZ() {
  if (W$) return Vm;
  W$ = 1;
  var e = TZ(), t = PZ(), n = Object.prototype, r = n.hasOwnProperty;
  function o(a) {
    if (!e(a))
      return t(a);
    var l = [];
    for (var c in Object(a))
      r.call(a, c) && c != "constructor" && l.push(c);
    return l;
  }
  return Vm = o, Vm;
}
var zm, q$;
function RZ() {
  if (q$) return zm;
  q$ = 1;
  var e = PS(), t = lO();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return zm = n, zm;
}
var Wm, U$;
function kZ() {
  if (U$) return Wm;
  U$ = 1;
  var e = SZ(), t = EZ(), n = RZ();
  function r(o) {
    return n(o) ? e(o) : t(o);
  }
  return Wm = r, Wm;
}
var qm, H$;
function _Z() {
  if (H$) return qm;
  H$ = 1;
  var e = pZ(), t = mZ(), n = kZ();
  function r(o) {
    return e(o, n, t);
  }
  return qm = r, qm;
}
var Um, G$;
function DZ() {
  if (G$) return Um;
  G$ = 1;
  var e = _Z(), t = 1, n = Object.prototype, r = n.hasOwnProperty;
  function o(a, l, c, d, p, f) {
    var m = c & t, g = e(a), y = g.length, b = e(l), v = b.length;
    if (y != v && !m)
      return !1;
    for (var $ = y; $--; ) {
      var S = g[$];
      if (!(m ? S in l : r.call(l, S)))
        return !1;
    }
    var R = f.get(a), P = f.get(l);
    if (R && P)
      return R == l && P == a;
    var T = !0;
    f.set(a, l), f.set(l, a);
    for (var O = m; ++$ < y; ) {
      S = g[$];
      var k = a[S], I = l[S];
      if (d)
        var D = m ? d(I, k, S, l, a, f) : d(k, I, S, a, l, f);
      if (!(D === void 0 ? k === I || p(k, I, c, d, f) : D)) {
        T = !1;
        break;
      }
      O || (O = S == "constructor");
    }
    if (T && !O) {
      var j = a.constructor, E = l.constructor;
      j != E && "constructor" in a && "constructor" in l && !(typeof j == "function" && j instanceof j && typeof E == "function" && E instanceof E) && (T = !1);
    }
    return f.delete(a), f.delete(l), T;
  }
  return Um = o, Um;
}
var Hm, Y$;
function IZ() {
  if (Y$) return Hm;
  Y$ = 1;
  var e = Ds(), t = vi(), n = e(t, "DataView");
  return Hm = n, Hm;
}
var Gm, K$;
function MZ() {
  if (K$) return Gm;
  K$ = 1;
  var e = Ds(), t = vi(), n = e(t, "Promise");
  return Gm = n, Gm;
}
var Ym, X$;
function AZ() {
  if (X$) return Ym;
  X$ = 1;
  var e = Ds(), t = vi(), n = e(t, "Set");
  return Ym = n, Ym;
}
var Km, Z$;
function NZ() {
  if (Z$) return Km;
  Z$ = 1;
  var e = Ds(), t = vi(), n = e(t, "WeakMap");
  return Km = n, Km;
}
var Xm, Q$;
function jZ() {
  if (Q$) return Xm;
  Q$ = 1;
  var e = IZ(), t = H0(), n = MZ(), r = AZ(), o = NZ(), a = dc(), l = ES(), c = "[object Map]", d = "[object Object]", p = "[object Promise]", f = "[object Set]", m = "[object WeakMap]", g = "[object DataView]", y = l(e), b = l(t), v = l(n), $ = l(r), S = l(o), R = a;
  return (e && R(new e(new ArrayBuffer(1))) != g || t && R(new t()) != c || n && R(n.resolve()) != p || r && R(new r()) != f || o && R(new o()) != m) && (R = function(P) {
    var T = a(P), O = T == d ? P.constructor : void 0, k = O ? l(O) : "";
    if (k)
      switch (k) {
        case y:
          return g;
        case b:
          return c;
        case v:
          return p;
        case $:
          return f;
        case S:
          return m;
      }
    return T;
  }), Xm = R, Xm;
}
var Zm, J$;
function FZ() {
  if (J$) return Zm;
  J$ = 1;
  var e = tZ(), t = aO(), n = uZ(), r = DZ(), o = jZ(), a = _s(), l = sO(), c = cO(), d = 1, p = "[object Arguments]", f = "[object Array]", m = "[object Object]", g = Object.prototype, y = g.hasOwnProperty;
  function b(v, $, S, R, P, T) {
    var O = a(v), k = a($), I = O ? f : o(v), D = k ? f : o($);
    I = I == p ? m : I, D = D == p ? m : D;
    var j = I == m, E = D == m, M = I == D;
    if (M && l(v)) {
      if (!l($))
        return !1;
      O = !0, j = !1;
    }
    if (M && !j)
      return T || (T = new e()), O || c(v) ? t(v, $, S, R, P, T) : n(v, $, I, S, R, P, T);
    if (!(S & d)) {
      var F = j && y.call(v, "__wrapped__"), B = E && y.call($, "__wrapped__");
      if (F || B) {
        var V = F ? v.value() : v, z = B ? $.value() : $;
        return T || (T = new e()), P(V, z, S, R, T);
      }
    }
    return M ? (T || (T = new e()), r(v, $, S, R, P, T)) : !1;
  }
  return Zm = b, Zm;
}
var Qm, eC;
function LZ() {
  if (eC) return Qm;
  eC = 1;
  var e = FZ(), t = pc();
  function n(r, o, a, l, c) {
    return r === o ? !0 : r == null || o == null || !t(r) && !t(o) ? r !== r && o !== o : e(r, o, a, l, n, c);
  }
  return Qm = n, Qm;
}
var Jm, tC;
function BZ() {
  if (tC) return Jm;
  tC = 1;
  var e = LZ();
  function t(n, r) {
    return e(n, r);
  }
  return Jm = t, Jm;
}
var VZ = BZ();
const uO = /* @__PURE__ */ Cs(VZ);
function Ea(e, t, n, r) {
  function o(a) {
    return a instanceof n ? a : new n(function(l) {
      l(a);
    });
  }
  return new (n || (n = Promise))(function(a, l) {
    function c(f) {
      try {
        p(r.next(f));
      } catch (m) {
        l(m);
      }
    }
    function d(f) {
      try {
        p(r.throw(f));
      } catch (m) {
        l(m);
      }
    }
    function p(f) {
      f.done ? a(f.value) : o(f.value).then(c, d);
    }
    p((r = r.apply(e, t || [])).next());
  });
}
const zZ = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function ws(e, t, n) {
  const r = WZ(e), { webkitRelativePath: o } = e, a = typeof t == "string" ? t : typeof o == "string" && o.length > 0 ? o : `./${e.name}`;
  return typeof r.path != "string" && nC(r, "path", a), nC(r, "relativePath", a), r;
}
function WZ(e) {
  const { name: t } = e;
  if (t && t.lastIndexOf(".") !== -1 && !e.type) {
    const r = t.split(".").pop().toLowerCase(), o = zZ.get(r);
    o && Object.defineProperty(e, "type", {
      value: o,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
function nC(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !1,
    configurable: !1,
    enumerable: !0
  });
}
const qZ = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function UZ(e) {
  return Ea(this, void 0, void 0, function* () {
    return fd(e) && HZ(e.dataTransfer) ? XZ(e.dataTransfer, e.type) : GZ(e) ? YZ(e) : Array.isArray(e) && e.every((t) => "getFile" in t && typeof t.getFile == "function") ? KZ(e) : [];
  });
}
function HZ(e) {
  return fd(e);
}
function GZ(e) {
  return fd(e) && fd(e.target);
}
function fd(e) {
  return typeof e == "object" && e !== null;
}
function YZ(e) {
  return Ng(e.target.files).map((t) => ws(t));
}
function KZ(e) {
  return Ea(this, void 0, void 0, function* () {
    return (yield Promise.all(e.map((n) => n.getFile()))).map((n) => ws(n));
  });
}
function XZ(e, t) {
  return Ea(this, void 0, void 0, function* () {
    if (e.items) {
      const n = Ng(e.items).filter((o) => o.kind === "file");
      if (t !== "drop")
        return n;
      const r = yield Promise.all(n.map(ZZ));
      return rC(dO(r));
    }
    return rC(Ng(e.files).map((n) => ws(n)));
  });
}
function rC(e) {
  return e.filter((t) => qZ.indexOf(t.name) === -1);
}
function Ng(e) {
  if (e === null)
    return [];
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    t.push(r);
  }
  return t;
}
function ZZ(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return oC(e);
  const t = e.webkitGetAsEntry();
  return t && t.isDirectory ? pO(t) : oC(e, t);
}
function dO(e) {
  return e.reduce((t, n) => [
    ...t,
    ...Array.isArray(n) ? dO(n) : [n]
  ], []);
}
function oC(e, t) {
  return Ea(this, void 0, void 0, function* () {
    var n;
    if (globalThis.isSecureContext && typeof e.getAsFileSystemHandle == "function") {
      const a = yield e.getAsFileSystemHandle();
      if (a === null)
        throw new Error(`${e} is not a File`);
      if (a !== void 0) {
        const l = yield a.getFile();
        return l.handle = a, ws(l);
      }
    }
    const r = e.getAsFile();
    if (!r)
      throw new Error(`${e} is not a File`);
    return ws(r, (n = t == null ? void 0 : t.fullPath) !== null && n !== void 0 ? n : void 0);
  });
}
function QZ(e) {
  return Ea(this, void 0, void 0, function* () {
    return e.isDirectory ? pO(e) : JZ(e);
  });
}
function pO(e) {
  const t = e.createReader();
  return new Promise((n, r) => {
    const o = [];
    function a() {
      t.readEntries((l) => Ea(this, void 0, void 0, function* () {
        if (l.length) {
          const c = Promise.all(l.map(QZ));
          o.push(c), a();
        } else
          try {
            const c = yield Promise.all(o);
            n(c);
          } catch (c) {
            r(c);
          }
      }), (l) => {
        r(l);
      });
    }
    a();
  });
}
function JZ(e) {
  return Ea(this, void 0, void 0, function* () {
    return new Promise((t, n) => {
      e.file((r) => {
        const o = ws(r, e.fullPath);
        t(o);
      }, (r) => {
        n(r);
      });
    });
  });
}
var $u = {}, iC;
function eQ() {
  return iC || (iC = 1, $u.__esModule = !0, $u.default = function(e, t) {
    if (e && t) {
      var n = Array.isArray(t) ? t : t.split(",");
      if (n.length === 0)
        return !0;
      var r = e.name || "", o = (e.type || "").toLowerCase(), a = o.replace(/\/.*$/, "");
      return n.some(function(l) {
        var c = l.trim().toLowerCase();
        return c.charAt(0) === "." ? r.toLowerCase().endsWith(c) : c.endsWith("/*") ? a === c.replace(/\/.*$/, "") : o === c;
      });
    }
    return !0;
  }), $u;
}
var tQ = eQ();
const eg = /* @__PURE__ */ Cs(tQ);
function aC(e) {
  return oQ(e) || rQ(e) || hO(e) || nQ();
}
function nQ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rQ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function oQ(e) {
  if (Array.isArray(e)) return jg(e);
}
function sC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function lC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sC(Object(n), !0).forEach(function(r) {
      fO(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function fO(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ql(e, t) {
  return sQ(e) || aQ(e, t) || hO(e, t) || iQ();
}
function iQ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hO(e, t) {
  if (e) {
    if (typeof e == "string") return jg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return jg(e, t);
  }
}
function jg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function aQ(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, a = !1, l, c;
    try {
      for (n = n.call(e); !(o = (l = n.next()).done) && (r.push(l.value), !(t && r.length === t)); o = !0)
        ;
    } catch (d) {
      a = !0, c = d;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (a) throw c;
      }
    }
    return r;
  }
}
function sQ(e) {
  if (Array.isArray(e)) return e;
}
var lQ = typeof eg == "function" ? eg : eg.default, cQ = "file-invalid-type", uQ = "file-too-large", dQ = "file-too-small", pQ = "too-many-files", fQ = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = t.split(","), r = n.length > 1 ? "one of ".concat(n.join(", ")) : n[0];
  return {
    code: cQ,
    message: "File type must be ".concat(r)
  };
}, cC = function(t) {
  return {
    code: uQ,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, uC = function(t) {
  return {
    code: dQ,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, hQ = {
  code: pQ,
  message: "Too many files"
};
function mO(e, t) {
  var n = e.type === "application/x-moz-file" || lQ(e, t);
  return [n, n ? null : fQ(t)];
}
function gO(e, t, n) {
  if (ha(e.size))
    if (ha(t) && ha(n)) {
      if (e.size > n) return [!1, cC(n)];
      if (e.size < t) return [!1, uC(t)];
    } else {
      if (ha(t) && e.size < t) return [!1, uC(t)];
      if (ha(n) && e.size > n) return [!1, cC(n)];
    }
  return [!0, null];
}
function ha(e) {
  return e != null;
}
function mQ(e) {
  var t = e.files, n = e.accept, r = e.minSize, o = e.maxSize, a = e.multiple, l = e.maxFiles, c = e.validator;
  return !a && t.length > 1 || a && l >= 1 && t.length > l ? !1 : t.every(function(d) {
    var p = mO(d, n), f = ql(p, 1), m = f[0], g = gO(d, r, o), y = ql(g, 1), b = y[0], v = c ? c(d) : null;
    return m && b && !v;
  });
}
function hd(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function Cu(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function dC(e) {
  e.preventDefault();
}
function gQ(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function yQ(e) {
  return e.indexOf("Edge/") !== -1;
}
function vQ() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return gQ(e) || yQ(e);
}
function To() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), l = 1; l < o; l++)
      a[l - 1] = arguments[l];
    return t.some(function(c) {
      return !hd(r) && c && c.apply(void 0, [r].concat(a)), hd(r);
    });
  };
}
function bQ() {
  return "showOpenFilePicker" in window;
}
function xQ(e) {
  if (ha(e)) {
    var t = Object.entries(e).filter(function(n) {
      var r = ql(n, 2), o = r[0], a = r[1], l = !0;
      return yO(o) || (console.warn('Skipped "'.concat(o, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), l = !1), (!Array.isArray(a) || !a.every(vO)) && (console.warn('Skipped "'.concat(o, '" because an invalid file extension was provided.')), l = !1), l;
    }).reduce(function(n, r) {
      var o = ql(r, 2), a = o[0], l = o[1];
      return lC(lC({}, n), {}, fO({}, a, l));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function wQ(e) {
  if (ha(e))
    return Object.entries(e).reduce(function(t, n) {
      var r = ql(n, 2), o = r[0], a = r[1];
      return [].concat(aC(t), [o], aC(a));
    }, []).filter(function(t) {
      return yO(t) || vO(t);
    }).join(",");
}
function $Q(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function CQ(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function yO(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || e === "application/*" || /\w+\/[-+.\w]+/g.test(e);
}
function vO(e) {
  return /^.*\.[\w]+$/.test(e);
}
var SQ = ["children"], TQ = ["open"], OQ = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], PQ = ["refKey", "onChange", "onClick"];
function EQ(e) {
  return _Q(e) || kQ(e) || bO(e) || RQ();
}
function RQ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kQ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function _Q(e) {
  if (Array.isArray(e)) return Fg(e);
}
function tg(e, t) {
  return MQ(e) || IQ(e, t) || bO(e, t) || DQ();
}
function DQ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bO(e, t) {
  if (e) {
    if (typeof e == "string") return Fg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Fg(e, t);
  }
}
function Fg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function IQ(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, a = !1, l, c;
    try {
      for (n = n.call(e); !(o = (l = n.next()).done) && (r.push(l.value), !(t && r.length === t)); o = !0)
        ;
    } catch (d) {
      a = !0, c = d;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (a) throw c;
      }
    }
    return r;
  }
}
function MQ(e) {
  if (Array.isArray(e)) return e;
}
function pC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pC(Object(n), !0).forEach(function(r) {
      Lg(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Lg(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function md(e, t) {
  if (e == null) return {};
  var n = AQ(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      r = a[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function AQ(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var vy = /* @__PURE__ */ Hl(function(e, t) {
  var n = e.children, r = md(e, SQ), o = by(r), a = o.open, l = md(o, TQ);
  return zg(t, function() {
    return {
      open: a
    };
  }, [a]), /* @__PURE__ */ Ne.createElement(Ak, null, n(vn(vn({}, l), {}, {
    open: a
  })));
});
vy.displayName = "Dropzone";
var xO = {
  disabled: !1,
  getFilesFromEvent: UZ,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
vy.defaultProps = xO;
vy.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: i.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: i.objectOf(i.arrayOf(i.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: i.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: i.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: i.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: i.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: i.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: i.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: i.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: i.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: i.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: i.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: i.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: i.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: i.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: i.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: i.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: i.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: i.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: i.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: i.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: i.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: i.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: i.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: i.func
};
var Bg = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function by() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = vn(vn({}, xO), e), n = t.accept, r = t.disabled, o = t.getFilesFromEvent, a = t.maxSize, l = t.minSize, c = t.multiple, d = t.maxFiles, p = t.onDragEnter, f = t.onDragLeave, m = t.onDragOver, g = t.onDrop, y = t.onDropAccepted, b = t.onDropRejected, v = t.onFileDialogCancel, $ = t.onFileDialogOpen, S = t.useFsAccessApi, R = t.autoFocus, P = t.preventDropOnDocument, T = t.noClick, O = t.noKeyboard, k = t.noDrag, I = t.noDragEventsBubbling, D = t.onError, j = t.validator, E = Ln(function() {
    return wQ(n);
  }, [n]), M = Ln(function() {
    return xQ(n);
  }, [n]), F = Ln(function() {
    return typeof $ == "function" ? $ : fC;
  }, [$]), B = Ln(function() {
    return typeof v == "function" ? v : fC;
  }, [v]), V = Yr(null), z = Yr(null), L = Vg(NQ, Bg), G = tg(L, 2), se = G[0], ne = G[1], K = se.isFocused, Q = se.isFileDialogActive, ye = Yr(typeof window < "u" && window.isSecureContext && S && bQ()), we = function() {
    !ye.current && Q && setTimeout(function() {
      if (z.current) {
        var Ae = z.current.files;
        Ae.length || (ne({
          type: "closeDialog"
        }), B());
      }
    }, 300);
  };
  nn(function() {
    return window.addEventListener("focus", we, !1), function() {
      window.removeEventListener("focus", we, !1);
    };
  }, [z, Q, B, ye]);
  var fe = Yr([]), X = function(Ae) {
    V.current && V.current.contains(Ae.target) || (Ae.preventDefault(), fe.current = []);
  };
  nn(function() {
    return P && (document.addEventListener("dragover", dC, !1), document.addEventListener("drop", X, !1)), function() {
      P && (document.removeEventListener("dragover", dC), document.removeEventListener("drop", X));
    };
  }, [V, P]), nn(function() {
    return !r && R && V.current && V.current.focus(), function() {
    };
  }, [V, R, r]);
  var re = At(function(Ee) {
    D ? D(Ee) : console.error(Ee);
  }, [D]), ie = At(function(Ee) {
    Ee.preventDefault(), Ee.persist(), We(Ee), fe.current = [].concat(EQ(fe.current), [Ee.target]), Cu(Ee) && Promise.resolve(o(Ee)).then(function(Ae) {
      if (!(hd(Ee) && !I)) {
        var pt = Ae.length, Ue = pt > 0 && mQ({
          files: Ae,
          accept: E,
          minSize: l,
          maxSize: a,
          multiple: c,
          maxFiles: d,
          validator: j
        }), et = pt > 0 && !Ue;
        ne({
          isDragAccept: Ue,
          isDragReject: et,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), p && p(Ee);
      }
    }).catch(function(Ae) {
      return re(Ae);
    });
  }, [o, p, re, I, E, l, a, c, d, j]), Y = At(function(Ee) {
    Ee.preventDefault(), Ee.persist(), We(Ee);
    var Ae = Cu(Ee);
    if (Ae && Ee.dataTransfer)
      try {
        Ee.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return Ae && m && m(Ee), !1;
  }, [m, I]), Z = At(function(Ee) {
    Ee.preventDefault(), Ee.persist(), We(Ee);
    var Ae = fe.current.filter(function(Ue) {
      return V.current && V.current.contains(Ue);
    }), pt = Ae.indexOf(Ee.target);
    pt !== -1 && Ae.splice(pt, 1), fe.current = Ae, !(Ae.length > 0) && (ne({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), Cu(Ee) && f && f(Ee));
  }, [V, f, I]), ue = At(function(Ee, Ae) {
    var pt = [], Ue = [];
    Ee.forEach(function(et) {
      var Je = mO(et, E), rt = tg(Je, 2), je = rt[0], $t = rt[1], Pt = gO(et, l, a), Ft = tg(Pt, 2), Jt = Ft[0], Me = Ft[1], it = j ? j(et) : null;
      if (je && Jt && !it)
        pt.push(et);
      else {
        var bt = [$t, Me];
        it && (bt = bt.concat(it)), Ue.push({
          file: et,
          errors: bt.filter(function(gt) {
            return gt;
          })
        });
      }
    }), (!c && pt.length > 1 || c && d >= 1 && pt.length > d) && (pt.forEach(function(et) {
      Ue.push({
        file: et,
        errors: [hQ]
      });
    }), pt.splice(0)), ne({
      acceptedFiles: pt,
      fileRejections: Ue,
      isDragReject: Ue.length > 0,
      type: "setFiles"
    }), g && g(pt, Ue, Ae), Ue.length > 0 && b && b(Ue, Ae), pt.length > 0 && y && y(pt, Ae);
  }, [ne, c, E, l, a, d, g, y, b, j]), ge = At(function(Ee) {
    Ee.preventDefault(), Ee.persist(), We(Ee), fe.current = [], Cu(Ee) && Promise.resolve(o(Ee)).then(function(Ae) {
      hd(Ee) && !I || ue(Ae, Ee);
    }).catch(function(Ae) {
      return re(Ae);
    }), ne({
      type: "reset"
    });
  }, [o, ue, re, I]), W = At(function() {
    if (ye.current) {
      ne({
        type: "openDialog"
      }), F();
      var Ee = {
        multiple: c,
        types: M
      };
      window.showOpenFilePicker(Ee).then(function(Ae) {
        return o(Ae);
      }).then(function(Ae) {
        ue(Ae, null), ne({
          type: "closeDialog"
        });
      }).catch(function(Ae) {
        $Q(Ae) ? (B(Ae), ne({
          type: "closeDialog"
        })) : CQ(Ae) ? (ye.current = !1, z.current ? (z.current.value = null, z.current.click()) : re(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : re(Ae);
      });
      return;
    }
    z.current && (ne({
      type: "openDialog"
    }), F(), z.current.value = null, z.current.click());
  }, [ne, F, B, S, ue, re, M, c]), J = At(function(Ee) {
    !V.current || !V.current.isEqualNode(Ee.target) || (Ee.key === " " || Ee.key === "Enter" || Ee.keyCode === 32 || Ee.keyCode === 13) && (Ee.preventDefault(), W());
  }, [V, W]), le = At(function() {
    ne({
      type: "focus"
    });
  }, []), me = At(function() {
    ne({
      type: "blur"
    });
  }, []), be = At(function() {
    T || (vQ() ? setTimeout(W, 0) : W());
  }, [T, W]), de = function(Ae) {
    return r ? null : Ae;
  }, Oe = function(Ae) {
    return O ? null : de(Ae);
  }, Re = function(Ae) {
    return k ? null : de(Ae);
  }, We = function(Ae) {
    I && Ae.stopPropagation();
  }, Ye = Ln(function() {
    return function() {
      var Ee = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ae = Ee.refKey, pt = Ae === void 0 ? "ref" : Ae, Ue = Ee.role, et = Ee.onKeyDown, Je = Ee.onFocus, rt = Ee.onBlur, je = Ee.onClick, $t = Ee.onDragEnter, Pt = Ee.onDragOver, Ft = Ee.onDragLeave, Jt = Ee.onDrop, Me = md(Ee, OQ);
      return vn(vn(Lg({
        onKeyDown: Oe(To(et, J)),
        onFocus: Oe(To(Je, le)),
        onBlur: Oe(To(rt, me)),
        onClick: de(To(je, be)),
        onDragEnter: Re(To($t, ie)),
        onDragOver: Re(To(Pt, Y)),
        onDragLeave: Re(To(Ft, Z)),
        onDrop: Re(To(Jt, ge)),
        role: typeof Ue == "string" && Ue !== "" ? Ue : "presentation"
      }, pt, V), !r && !O ? {
        tabIndex: 0
      } : {}), Me);
    };
  }, [V, J, le, me, be, ie, Y, Z, ge, O, k, r]), Ie = At(function(Ee) {
    Ee.stopPropagation();
  }, []), kt = Ln(function() {
    return function() {
      var Ee = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ae = Ee.refKey, pt = Ae === void 0 ? "ref" : Ae, Ue = Ee.onChange, et = Ee.onClick, Je = md(Ee, PQ), rt = Lg({
        accept: E,
        multiple: c,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: de(To(Ue, ge)),
        onClick: de(To(et, Ie)),
        tabIndex: -1
      }, pt, z);
      return vn(vn({}, rt), Je);
    };
  }, [z, n, c, ge, r]);
  return vn(vn({}, se), {}, {
    isFocused: K && !r,
    getRootProps: Ye,
    getInputProps: kt,
    rootRef: V,
    inputRef: z,
    open: de(W)
  });
}
function NQ(e, t) {
  switch (t.type) {
    case "focus":
      return vn(vn({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return vn(vn({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return vn(vn({}, Bg), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return vn(vn({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return vn(vn({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return vn(vn({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections,
        isDragReject: t.isDragReject
      });
    case "reset":
      return vn({}, Bg);
    default:
      return e;
  }
}
function fC() {
}
const wO = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
}), "UploadFile"), jQ = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), "Download"), FQ = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), "OpenInNew"), $O = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M16 9v10H8V9zm-1.5-6h-5l-1 1H5v2h14V4h-3.5zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2z"
}), "DeleteOutlined"), CO = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M9.29 16.29 5.7 12.7a.996.996 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0"
}), "CheckCircleRounded"), LQ = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zM6 20V4h7v5h5v11z"
}), "InsertDriveFileOutlined");
function SO(e, t = 0) {
  if (!+e) return "0 Bytes";
  const n = 1e3, r = t < 0 ? 0 : t, o = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], a = Math.floor(Math.log(e) / Math.log(n));
  return `${parseFloat((e / Math.pow(n, a)).toFixed(r))} ${o[a]}`;
}
const BQ = 512e3, ng = {
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "application/pdf": [".pdf"]
}, VQ = ({
  label: e,
  disabled: t,
  value: n,
  onChange: r,
  error: o,
  name: a,
  readOnly: l,
  allowMultiple: c = !1,
  uploadFile: d,
  getFile: p,
  deleteFile: f
}) => {
  const m = tr(), [g, y] = Kt(!1), [b, v] = Kt(!1), $ = Yr(null), S = Yr(null), R = Ln(() => {
    if (!ng) return "";
    const L = Object.values(ng).flat().map((se) => se.replace(".", "").toUpperCase()).sort();
    if (!L.length) return "";
    const G = L[L.length - 1];
    return L.length > 1 ? L.slice(0, -1).join(", ") + " or " + G : L[0];
  }, []), P = At(() => {
    v(!0);
  }, []), T = At(() => {
    v(!1);
  }, []), O = At(() => {
    y(!0), v(!1), f == null || f(n.id).then(() => {
      $.current = n.id;
      const L = { id: n == null ? void 0 : n.id, preview: "" };
      n.preview && URL.revokeObjectURL(n.preview), r(L), console.log(`[FileUploaderField]: deleteFile > done: ${n.id}`);
    }).catch((L) => {
      console.error(`[FileUploaderField]: deleteFile > error: ${n.id}`, L);
    }).finally(() => {
      y(!1);
    });
  }, [n, f, r]), k = At(
    (L) => {
      if (!(L != null && L.length)) return;
      y(!0);
      const G = L[0], se = URL.createObjectURL(G);
      d == null || d(G, se).then((ne) => {
        const K = {
          ...ne,
          filename: G.name,
          size: G.size,
          mime: G.type,
          preview: se
        };
        return r(K), console.log("[FileUploaderField]: uploadFile > done:", K), K;
      }).catch((ne) => {
        console.error(`[FileUploaderField]: uploadFile > error: ${G.name}`, ne), URL.revokeObjectURL(se);
      }).finally(() => y(!1));
    },
    [d, r]
  ), I = At(async () => {
    !(n != null && n.id) || n != null && n.preview || !p || (S.current = n, y(!0), p == null || p(n.id).then((L) => {
      if (L.preview)
        return r(L), console.log("[FileUploaderField]: downloadFile done:", L), L;
    }).catch((L) => {
      console.error("[FileUploaderField]: getFile > error:", L);
    }).finally(() => {
      y(!1);
    }));
  }, [p, r, n]);
  nn(() => {
    g || n != null && n.preview || (n == null ? void 0 : n.id) === $.current || uO(S.current, n) || I();
  }, [I, n]);
  const { getRootProps: D, getInputProps: j, isDragActive: E, isDragAccept: M, isDragReject: F } = by({
    multiple: c,
    accept: ng,
    disabled: t || l,
    maxSize: BQ,
    onDrop: k
  }), B = F ? m.palette.error.main : m.palette.primary.dark, V = F || o ? m.palette.error.main : M ? m.palette.primary.main : jd[400], z = M ? m.palette.success.light : F ? m.palette.error.light : "transparent";
  return /* @__PURE__ */ x.jsxs(Gn, { fullWidth: !0, children: [
    !!e && /* @__PURE__ */ x.jsx(
      ur,
      {
        sx: {
          mb: 2,
          fontWeight: 600,
          color: m.palette.text.primary,
          fontSize: m.typography.subtitle1.fontSize
        },
        id: `${a}-label`,
        children: e
      }
    ),
    /* @__PURE__ */ x.jsxs(Jn, { container: !0, rowSpacing: 1, columnSpacing: 3, children: [
      /* @__PURE__ */ x.jsxs(Jn, { size: { xs: 12, lg: 6 }, children: [
        /* @__PURE__ */ x.jsxs(
          Qt,
          {
            ...D(),
            minHeight: "152px",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: z,
            sx: { cursor: "pointer" },
            borderRadius: m.spacing(1),
            border: `1px dashed ${V}`,
            children: [
              /* @__PURE__ */ x.jsx("input", { ...j() }),
              /* @__PURE__ */ x.jsx(Qt, { alignItems: "center", justifyContent: "center", spacing: 1, children: g ? /* @__PURE__ */ x.jsx(Fo, { variant: "indeterminate" }) : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
                /* @__PURE__ */ x.jsx(Zr, { pt: 1, pb: 0.5, children: /* @__PURE__ */ x.jsx(wO, { sx: { color: B } }) }),
                !E && /* @__PURE__ */ x.jsxs(Zr, { children: [
                  /* @__PURE__ */ x.jsx(Qe, { display: "inline", color: "primary", sx: { textDecorationLine: "underline" }, children: "Click to upload" }),
                  /* @__PURE__ */ x.jsx(Qe, { display: "inline", children: " or drag and drop" })
                ] }),
                M && /* @__PURE__ */ x.jsx(Qe, { color: m.palette.primary.dark, fontWeight: "bold", children: "Drop file(s) here to upload" }),
                F && /* @__PURE__ */ x.jsx(Qe, { color: "error", children: "File type, size or count is not allowed" }),
                /* @__PURE__ */ x.jsxs(Zr, { pt: 0.5, children: [
                  R && /* @__PURE__ */ x.jsxs(Qe, { display: "inline", variant: "subtitle2", color: "secondary", children: [
                    R,
                    " "
                  ] }),
                  /* @__PURE__ */ x.jsx(Qe, { display: "inline", variant: "subtitle2", color: "secondary", children: "(max. 500kb)" })
                ] })
              ] }) })
            ]
          }
        ),
        o && /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "error", children: o.message })
      ] }),
      /* @__PURE__ */ x.jsx(Jn, { size: { xs: 12, lg: 6 }, children: !g && n && (n == null ? void 0 : n.preview) && /* @__PURE__ */ x.jsx(
        zQ,
        {
          size: n.size,
          name: n.filename,
          canRemove: !t && !l,
          preview: n.preview,
          onRemove: P
        },
        n.id
      ) })
    ] }),
    /* @__PURE__ */ x.jsxs(Sa, { open: b, onClose: T, children: [
      /* @__PURE__ */ x.jsx(wa, { variant: "h4", component: "h2", children: "Are you sure you want to remove this file?" }),
      /* @__PURE__ */ x.jsxs(ii, { children: [
        /* @__PURE__ */ x.jsx(Tn, { disabled: g, variant: "contained", color: "error", onClick: O, children: "Remove" }),
        /* @__PURE__ */ x.jsx(Tn, { disabled: g, variant: "outlined", color: "warning", onClick: T, children: "Keep" })
      ] })
    ] })
  ] });
}, zQ = ({ canRemove: e, name: t = "", onRemove: n, preview: r, size: o }) => {
  const a = tr(), [l, c] = Kt(!1), d = t.includes("pdf"), p = At(() => {
    n == null || n();
  }, [n]), f = At(() => c(!1), []), m = At(() => window.open(r, "_blank"), [r]);
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(
      Qt,
      {
        direction: "row",
        sx: { mb: 1, p: 2 },
        alignItems: "flex-start",
        justifyContent: "space-between",
        borderRadius: a.spacing(1),
        border: `1px solid ${a.palette.primary.main}`,
        children: [
          /* @__PURE__ */ x.jsxs(Qt, { width: "100%", direction: "row", spacing: 2, pb: 1, children: [
            /* @__PURE__ */ x.jsx(CS, { color: "primary", IconComponent: LQ }),
            /* @__PURE__ */ x.jsxs(Qt, { m: 1, maxWidth: "50%", children: [
              /* @__PURE__ */ x.jsx(
                Qe,
                {
                  sx: {
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis"
                  },
                  children: t
                }
              ),
              /* @__PURE__ */ x.jsxs(Qe, { variant: "subtitle2", color: "secondary", fontSize: "small", children: [
                "Uploaded - ",
                SO(o, 2)
              ] })
            ] })
          ] }),
          /* @__PURE__ */ x.jsx(CO, { color: "success" })
        ]
      }
    ),
    /* @__PURE__ */ x.jsxs(Qt, { direction: "row", spacing: 1, children: [
      d && /* @__PURE__ */ x.jsx(Fi, { title: "Preview in new tab", children: /* @__PURE__ */ x.jsx(Tn, { color: "primary", variant: "outlined", sx: { minWidth: "auto" }, "aria-label": `Open ${t} in new tab`, onClick: m, children: /* @__PURE__ */ x.jsx(FQ, {}) }) }),
      /* @__PURE__ */ x.jsx(Fi, { title: "Download file", children: /* @__PURE__ */ x.jsx(
        Tn,
        {
          component: "a",
          color: "primary",
          variant: "outlined",
          href: r,
          target: "_blank",
          download: t,
          rel: "noopener noreferrer",
          sx: { minWidth: "auto" },
          "aria-label": `Download ${t}`,
          children: /* @__PURE__ */ x.jsx(jQ, {})
        }
      ) }),
      e && /* @__PURE__ */ x.jsx(Fi, { title: "Remove file", children: /* @__PURE__ */ x.jsx(Tn, { variant: "outlined", "aria-label": "Remove file", onClick: p, color: "error", sx: { minWidth: "auto" }, children: /* @__PURE__ */ x.jsx($O, {}) }) })
    ] }),
    /* @__PURE__ */ x.jsxs(Sa, { open: l, onClose: f, maxWidth: "md", fullWidth: !0, children: [
      /* @__PURE__ */ x.jsx(wa, { children: t }),
      /* @__PURE__ */ x.jsx(ii, { children: /* @__PURE__ */ x.jsx(Vo, { onClick: f, color: "primary", children: "Close" }) })
    ] })
  ] });
}, gd = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  unit: "px"
}, Xa = (e, t, n) => Math.min(Math.max(e, t), n), WQ = (...e) => e.filter((t) => t && typeof t == "string").join(" "), hC = (e, t) => e === t || e.width === t.width && e.height === t.height && e.x === t.x && e.y === t.y && e.unit === t.unit;
function qQ(e, t, n, r) {
  const o = Oo(e, n, r);
  return e.width && (o.height = o.width / t), e.height && (o.width = o.height * t), o.y + o.height > r && (o.height = r - o.y, o.width = o.height * t), o.x + o.width > n && (o.width = n - o.x, o.height = o.width / t), e.unit === "%" ? Ai(o, n, r) : o;
}
function UQ(e, t, n) {
  const r = Oo(e, t, n);
  return r.x = (t - r.width) / 2, r.y = (n - r.height) / 2, e.unit === "%" ? Ai(r, t, n) : r;
}
function Ai(e, t, n) {
  return e.unit === "%" ? { ...gd, ...e, unit: "%" } : {
    unit: "%",
    x: e.x ? e.x / t * 100 : 0,
    y: e.y ? e.y / n * 100 : 0,
    width: e.width ? e.width / t * 100 : 0,
    height: e.height ? e.height / n * 100 : 0
  };
}
function Oo(e, t, n) {
  return e.unit ? e.unit === "px" ? { ...gd, ...e, unit: "px" } : {
    unit: "px",
    x: e.x ? e.x * t / 100 : 0,
    y: e.y ? e.y * n / 100 : 0,
    width: e.width ? e.width * t / 100 : 0,
    height: e.height ? e.height * n / 100 : 0
  } : { ...gd, ...e, unit: "px" };
}
function mC(e, t, n, r, o, a = 0, l = 0, c = r, d = o) {
  const p = { ...e };
  let f = Math.min(a, r), m = Math.min(l, o), g = Math.min(c, r), y = Math.min(d, o);
  t && (t > 1 ? (f = l ? l * t : f, m = f / t, g = c * t) : (m = a ? a / t : m, f = m * t, y = d / t)), p.y < 0 && (p.height = Math.max(p.height + p.y, m), p.y = 0), p.x < 0 && (p.width = Math.max(p.width + p.x, f), p.x = 0);
  const b = r - (p.x + p.width);
  b < 0 && (p.x = Math.min(p.x, r - f), p.width += b);
  const v = o - (p.y + p.height);
  if (v < 0 && (p.y = Math.min(p.y, o - m), p.height += v), p.width < f && ((n === "sw" || n == "nw") && (p.x -= f - p.width), p.width = f), p.height < m && ((n === "nw" || n == "ne") && (p.y -= m - p.height), p.height = m), p.width > g && ((n === "sw" || n == "nw") && (p.x -= g - p.width), p.width = g), p.height > y && ((n === "nw" || n == "ne") && (p.y -= y - p.height), p.height = y), t) {
    const $ = p.width / p.height;
    if ($ < t) {
      const S = Math.max(p.width / t, m);
      (n === "nw" || n == "ne") && (p.y -= S - p.height), p.height = S;
    } else if ($ > t) {
      const S = Math.max(p.height * t, f);
      (n === "sw" || n == "nw") && (p.x -= S - p.width), p.width = S;
    }
  }
  return p;
}
function HQ(e, t, n, r) {
  const o = { ...e };
  return t === "ArrowLeft" ? r === "nw" ? (o.x -= n, o.y -= n, o.width += n, o.height += n) : r === "w" ? (o.x -= n, o.width += n) : r === "sw" ? (o.x -= n, o.width += n, o.height += n) : r === "ne" ? (o.y += n, o.width -= n, o.height -= n) : r === "e" ? o.width -= n : r === "se" && (o.width -= n, o.height -= n) : t === "ArrowRight" && (r === "nw" ? (o.x += n, o.y += n, o.width -= n, o.height -= n) : r === "w" ? (o.x += n, o.width -= n) : r === "sw" ? (o.x += n, o.width -= n, o.height -= n) : r === "ne" ? (o.y -= n, o.width += n, o.height += n) : r === "e" ? o.width += n : r === "se" && (o.width += n, o.height += n)), t === "ArrowUp" ? r === "nw" ? (o.x -= n, o.y -= n, o.width += n, o.height += n) : r === "n" ? (o.y -= n, o.height += n) : r === "ne" ? (o.y -= n, o.width += n, o.height += n) : r === "sw" ? (o.x += n, o.width -= n, o.height -= n) : r === "s" ? o.height -= n : r === "se" && (o.width -= n, o.height -= n) : t === "ArrowDown" && (r === "nw" ? (o.x += n, o.y += n, o.width -= n, o.height -= n) : r === "n" ? (o.y += n, o.height -= n) : r === "ne" ? (o.y += n, o.width -= n, o.height -= n) : r === "sw" ? (o.x -= n, o.width += n, o.height += n) : r === "s" ? o.height += n : r === "se" && (o.width += n, o.height += n)), o;
}
const Za = { capture: !0, passive: !1 };
let GQ = 0;
const Mi = class fo extends Nk {
  constructor() {
    super(...arguments), this.docMoveBound = !1, this.mouseDownOnCrop = !1, this.dragStarted = !1, this.evData = {
      startClientX: 0,
      startClientY: 0,
      startCropX: 0,
      startCropY: 0,
      clientX: 0,
      clientY: 0,
      isResize: !0
    }, this.componentRef = qb(), this.mediaRef = qb(), this.initChangeCalled = !1, this.instanceId = `rc-${GQ++}`, this.state = {
      cropIsActive: !1,
      newCropIsBeingDrawn: !1
    }, this.onCropPointerDown = (t) => {
      const { crop: n, disabled: r } = this.props, o = this.getBox();
      if (!n)
        return;
      const a = Oo(n, o.width, o.height);
      if (r)
        return;
      t.cancelable && t.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({ preventScroll: !0 });
      const l = t.target.dataset.ord, c = !!l;
      let d = t.clientX, p = t.clientY, f = a.x, m = a.y;
      if (l) {
        const g = t.clientX - o.x, y = t.clientY - o.y;
        let b = 0, v = 0;
        l === "ne" || l == "e" ? (b = g - (a.x + a.width), v = y - a.y, f = a.x, m = a.y + a.height) : l === "se" || l === "s" ? (b = g - (a.x + a.width), v = y - (a.y + a.height), f = a.x, m = a.y) : l === "sw" || l == "w" ? (b = g - a.x, v = y - (a.y + a.height), f = a.x + a.width, m = a.y) : (l === "nw" || l == "n") && (b = g - a.x, v = y - a.y, f = a.x + a.width, m = a.y + a.height), d = f + o.x + b, p = m + o.y + v;
      }
      this.evData = {
        startClientX: d,
        startClientY: p,
        startCropX: f,
        startCropY: m,
        clientX: t.clientX,
        clientY: t.clientY,
        isResize: c,
        ord: l
      }, this.mouseDownOnCrop = !0, this.setState({ cropIsActive: !0 });
    }, this.onComponentPointerDown = (t) => {
      const { crop: n, disabled: r, locked: o, keepSelection: a, onChange: l } = this.props, c = this.getBox();
      if (r || o || a && n)
        return;
      t.cancelable && t.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({ preventScroll: !0 });
      const d = t.clientX - c.x, p = t.clientY - c.y, f = {
        unit: "px",
        x: d,
        y: p,
        width: 0,
        height: 0
      };
      this.evData = {
        startClientX: t.clientX,
        startClientY: t.clientY,
        startCropX: d,
        startCropY: p,
        clientX: t.clientX,
        clientY: t.clientY,
        isResize: !0
      }, this.mouseDownOnCrop = !0, l(Oo(f, c.width, c.height), Ai(f, c.width, c.height)), this.setState({ cropIsActive: !0, newCropIsBeingDrawn: !0 });
    }, this.onDocPointerMove = (t) => {
      const { crop: n, disabled: r, onChange: o, onDragStart: a } = this.props, l = this.getBox();
      if (r || !n || !this.mouseDownOnCrop)
        return;
      t.cancelable && t.preventDefault(), this.dragStarted || (this.dragStarted = !0, a && a(t));
      const { evData: c } = this;
      c.clientX = t.clientX, c.clientY = t.clientY;
      let d;
      c.isResize ? d = this.resizeCrop() : d = this.dragCrop(), hC(n, d) || o(
        Oo(d, l.width, l.height),
        Ai(d, l.width, l.height)
      );
    }, this.onComponentKeyDown = (t) => {
      const { crop: n, disabled: r, onChange: o, onComplete: a } = this.props;
      if (r)
        return;
      const l = t.key;
      let c = !1;
      if (!n)
        return;
      const d = this.getBox(), p = this.makePixelCrop(d), f = (navigator.platform.match("Mac") ? t.metaKey : t.ctrlKey) ? fo.nudgeStepLarge : t.shiftKey ? fo.nudgeStepMedium : fo.nudgeStep;
      if (l === "ArrowLeft" ? (p.x -= f, c = !0) : l === "ArrowRight" ? (p.x += f, c = !0) : l === "ArrowUp" ? (p.y -= f, c = !0) : l === "ArrowDown" && (p.y += f, c = !0), c) {
        t.cancelable && t.preventDefault(), p.x = Xa(p.x, 0, d.width - p.width), p.y = Xa(p.y, 0, d.height - p.height);
        const m = Oo(p, d.width, d.height), g = Ai(p, d.width, d.height);
        o(m, g), a && a(m, g);
      }
    }, this.onHandlerKeyDown = (t, n) => {
      const {
        aspect: r = 0,
        crop: o,
        disabled: a,
        minWidth: l = 0,
        minHeight: c = 0,
        maxWidth: d,
        maxHeight: p,
        onChange: f,
        onComplete: m
      } = this.props, g = this.getBox();
      if (a || !o)
        return;
      if (t.key === "ArrowUp" || t.key === "ArrowDown" || t.key === "ArrowLeft" || t.key === "ArrowRight")
        t.stopPropagation(), t.preventDefault();
      else
        return;
      const y = (navigator.platform.match("Mac") ? t.metaKey : t.ctrlKey) ? fo.nudgeStepLarge : t.shiftKey ? fo.nudgeStepMedium : fo.nudgeStep, b = Oo(o, g.width, g.height), v = HQ(b, t.key, y, n), $ = mC(
        v,
        r,
        n,
        g.width,
        g.height,
        l,
        c,
        d,
        p
      );
      if (!hC(o, $)) {
        const S = Ai($, g.width, g.height);
        f($, S), m && m($, S);
      }
    }, this.onDocPointerDone = (t) => {
      const { crop: n, disabled: r, onComplete: o, onDragEnd: a } = this.props, l = this.getBox();
      this.unbindDocMove(), !(r || !n) && this.mouseDownOnCrop && (this.mouseDownOnCrop = !1, this.dragStarted = !1, a && a(t), o && o(Oo(n, l.width, l.height), Ai(n, l.width, l.height)), this.setState({ cropIsActive: !1, newCropIsBeingDrawn: !1 }));
    }, this.onDragFocus = () => {
      var t;
      (t = this.componentRef.current) == null || t.scrollTo(0, 0);
    };
  }
  get document() {
    return document;
  }
  // We unfortunately get the bounding box every time as x+y changes
  // due to scrolling.
  getBox() {
    const t = this.mediaRef.current;
    if (!t)
      return { x: 0, y: 0, width: 0, height: 0 };
    const { x: n, y: r, width: o, height: a } = t.getBoundingClientRect();
    return { x: n, y: r, width: o, height: a };
  }
  componentDidUpdate(t) {
    const { crop: n, onComplete: r } = this.props;
    if (r && !t.crop && n) {
      const { width: o, height: a } = this.getBox();
      o && a && r(Oo(n, o, a), Ai(n, o, a));
    }
  }
  componentWillUnmount() {
    this.resizeObserver && this.resizeObserver.disconnect(), this.unbindDocMove();
  }
  bindDocMove() {
    this.docMoveBound || (this.document.addEventListener("pointermove", this.onDocPointerMove, Za), this.document.addEventListener("pointerup", this.onDocPointerDone, Za), this.document.addEventListener("pointercancel", this.onDocPointerDone, Za), this.docMoveBound = !0);
  }
  unbindDocMove() {
    this.docMoveBound && (this.document.removeEventListener("pointermove", this.onDocPointerMove, Za), this.document.removeEventListener("pointerup", this.onDocPointerDone, Za), this.document.removeEventListener("pointercancel", this.onDocPointerDone, Za), this.docMoveBound = !1);
  }
  getCropStyle() {
    const { crop: t } = this.props;
    if (t)
      return {
        top: `${t.y}${t.unit}`,
        left: `${t.x}${t.unit}`,
        width: `${t.width}${t.unit}`,
        height: `${t.height}${t.unit}`
      };
  }
  dragCrop() {
    const { evData: t } = this, n = this.getBox(), r = this.makePixelCrop(n), o = t.clientX - t.startClientX, a = t.clientY - t.startClientY;
    return r.x = Xa(t.startCropX + o, 0, n.width - r.width), r.y = Xa(t.startCropY + a, 0, n.height - r.height), r;
  }
  getPointRegion(t, n, r, o) {
    const { evData: a } = this, l = a.clientX - t.x, c = a.clientY - t.y;
    let d;
    o && n ? d = n === "nw" || n === "n" || n === "ne" : d = c < a.startCropY;
    let p;
    return r && n ? p = n === "nw" || n === "w" || n === "sw" : p = l < a.startCropX, p ? d ? "nw" : "sw" : d ? "ne" : "se";
  }
  resolveMinDimensions(t, n, r = 0, o = 0) {
    const a = Math.min(r, t.width), l = Math.min(o, t.height);
    return !n || !a && !l ? [a, l] : n > 1 ? a ? [a, a / n] : [l * n, l] : l ? [l * n, l] : [a, a / n];
  }
  resizeCrop() {
    const { evData: t } = this, { aspect: n = 0, maxWidth: r, maxHeight: o } = this.props, a = this.getBox(), [l, c] = this.resolveMinDimensions(a, n, this.props.minWidth, this.props.minHeight);
    let d = this.makePixelCrop(a);
    const p = this.getPointRegion(a, t.ord, l, c), f = t.ord || p;
    let m = t.clientX - t.startClientX, g = t.clientY - t.startClientY;
    (l && f === "nw" || f === "w" || f === "sw") && (m = Math.min(m, -l)), (c && f === "nw" || f === "n" || f === "ne") && (g = Math.min(g, -c));
    const y = {
      unit: "px",
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
    p === "ne" ? (y.x = t.startCropX, y.width = m, n ? (y.height = y.width / n, y.y = t.startCropY - y.height) : (y.height = Math.abs(g), y.y = t.startCropY - y.height)) : p === "se" ? (y.x = t.startCropX, y.y = t.startCropY, y.width = m, n ? y.height = y.width / n : y.height = g) : p === "sw" ? (y.x = t.startCropX + m, y.y = t.startCropY, y.width = Math.abs(m), n ? y.height = y.width / n : y.height = g) : p === "nw" && (y.x = t.startCropX + m, y.width = Math.abs(m), n ? (y.height = y.width / n, y.y = t.startCropY - y.height) : (y.height = Math.abs(g), y.y = t.startCropY + g));
    const b = mC(
      y,
      n,
      p,
      a.width,
      a.height,
      l,
      c,
      r,
      o
    );
    return n || fo.xyOrds.indexOf(f) > -1 ? d = b : fo.xOrds.indexOf(f) > -1 ? (d.x = b.x, d.width = b.width) : fo.yOrds.indexOf(f) > -1 && (d.y = b.y, d.height = b.height), d.x = Xa(d.x, 0, a.width - d.width), d.y = Xa(d.y, 0, a.height - d.height), d;
  }
  renderCropSelection() {
    const {
      ariaLabels: t = fo.defaultProps.ariaLabels,
      disabled: n,
      locked: r,
      renderSelectionAddon: o,
      ruleOfThirds: a,
      crop: l
    } = this.props, c = this.getCropStyle();
    if (l)
      return /* @__PURE__ */ Ne.createElement(
        "div",
        {
          style: c,
          className: "ReactCrop__crop-selection",
          onPointerDown: this.onCropPointerDown,
          "aria-label": t.cropArea,
          tabIndex: 0,
          onKeyDown: this.onComponentKeyDown,
          role: "group"
        },
        !n && !r && /* @__PURE__ */ Ne.createElement("div", { className: "ReactCrop__drag-elements", onFocus: this.onDragFocus }, /* @__PURE__ */ Ne.createElement("div", { className: "ReactCrop__drag-bar ord-n", "data-ord": "n" }), /* @__PURE__ */ Ne.createElement("div", { className: "ReactCrop__drag-bar ord-e", "data-ord": "e" }), /* @__PURE__ */ Ne.createElement("div", { className: "ReactCrop__drag-bar ord-s", "data-ord": "s" }), /* @__PURE__ */ Ne.createElement("div", { className: "ReactCrop__drag-bar ord-w", "data-ord": "w" }), /* @__PURE__ */ Ne.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-nw",
            "data-ord": "nw",
            tabIndex: 0,
            "aria-label": t.nwDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "nw"),
            role: "button"
          }
        ), /* @__PURE__ */ Ne.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-n",
            "data-ord": "n",
            tabIndex: 0,
            "aria-label": t.nDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "n"),
            role: "button"
          }
        ), /* @__PURE__ */ Ne.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-ne",
            "data-ord": "ne",
            tabIndex: 0,
            "aria-label": t.neDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "ne"),
            role: "button"
          }
        ), /* @__PURE__ */ Ne.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-e",
            "data-ord": "e",
            tabIndex: 0,
            "aria-label": t.eDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "e"),
            role: "button"
          }
        ), /* @__PURE__ */ Ne.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-se",
            "data-ord": "se",
            tabIndex: 0,
            "aria-label": t.seDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "se"),
            role: "button"
          }
        ), /* @__PURE__ */ Ne.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-s",
            "data-ord": "s",
            tabIndex: 0,
            "aria-label": t.sDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "s"),
            role: "button"
          }
        ), /* @__PURE__ */ Ne.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-sw",
            "data-ord": "sw",
            tabIndex: 0,
            "aria-label": t.swDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "sw"),
            role: "button"
          }
        ), /* @__PURE__ */ Ne.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-w",
            "data-ord": "w",
            tabIndex: 0,
            "aria-label": t.wDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "w"),
            role: "button"
          }
        )),
        o && /* @__PURE__ */ Ne.createElement("div", { className: "ReactCrop__selection-addon", onPointerDown: (d) => d.stopPropagation() }, o(this.state)),
        a && /* @__PURE__ */ Ne.createElement(Ne.Fragment, null, /* @__PURE__ */ Ne.createElement("div", { className: "ReactCrop__rule-of-thirds-hz" }), /* @__PURE__ */ Ne.createElement("div", { className: "ReactCrop__rule-of-thirds-vt" }))
      );
  }
  makePixelCrop(t) {
    const n = { ...gd, ...this.props.crop || {} };
    return Oo(n, t.width, t.height);
  }
  render() {
    const { aspect: t, children: n, circularCrop: r, className: o, crop: a, disabled: l, locked: c, style: d, ruleOfThirds: p } = this.props, { cropIsActive: f, newCropIsBeingDrawn: m } = this.state, g = a ? this.renderCropSelection() : null, y = WQ(
      "ReactCrop",
      o,
      f && "ReactCrop--active",
      l && "ReactCrop--disabled",
      c && "ReactCrop--locked",
      m && "ReactCrop--new-crop",
      a && t && "ReactCrop--fixed-aspect",
      a && r && "ReactCrop--circular-crop",
      a && p && "ReactCrop--rule-of-thirds",
      !this.dragStarted && a && !a.width && !a.height && "ReactCrop--invisible-crop",
      r && "ReactCrop--no-animate"
    );
    return /* @__PURE__ */ Ne.createElement("div", { ref: this.componentRef, className: y, style: d }, /* @__PURE__ */ Ne.createElement("div", { ref: this.mediaRef, className: "ReactCrop__child-wrapper", onPointerDown: this.onComponentPointerDown }, n), a ? /* @__PURE__ */ Ne.createElement("svg", { className: "ReactCrop__crop-mask", width: "100%", height: "100%" }, /* @__PURE__ */ Ne.createElement("defs", null, /* @__PURE__ */ Ne.createElement("mask", { id: `hole-${this.instanceId}` }, /* @__PURE__ */ Ne.createElement("rect", { width: "100%", height: "100%", fill: "white" }), r ? /* @__PURE__ */ Ne.createElement(
      "ellipse",
      {
        cx: `${a.x + a.width / 2}${a.unit}`,
        cy: `${a.y + a.height / 2}${a.unit}`,
        rx: `${a.width / 2}${a.unit}`,
        ry: `${a.height / 2}${a.unit}`,
        fill: "black"
      }
    ) : /* @__PURE__ */ Ne.createElement(
      "rect",
      {
        x: `${a.x}${a.unit}`,
        y: `${a.y}${a.unit}`,
        width: `${a.width}${a.unit}`,
        height: `${a.height}${a.unit}`,
        fill: "black"
      }
    ))), /* @__PURE__ */ Ne.createElement("rect", { fill: "black", fillOpacity: 0.5, width: "100%", height: "100%", mask: `url(#hole-${this.instanceId})` })) : void 0, g);
  }
};
Mi.xOrds = ["e", "w"], Mi.yOrds = ["n", "s"], Mi.xyOrds = ["nw", "ne", "se", "sw"], Mi.nudgeStep = 1, Mi.nudgeStepMedium = 10, Mi.nudgeStepLarge = 100, Mi.defaultProps = {
  ariaLabels: {
    cropArea: "Use the arrow keys to move the crop selection area",
    nwDragHandle: "Use the arrow keys to move the north west drag handle to change the crop selection area",
    nDragHandle: "Use the up and down arrow keys to move the north drag handle to change the crop selection area",
    neDragHandle: "Use the arrow keys to move the north east drag handle to change the crop selection area",
    eDragHandle: "Use the up and down arrow keys to move the east drag handle to change the crop selection area",
    seDragHandle: "Use the arrow keys to move the south east drag handle to change the crop selection area",
    sDragHandle: "Use the up and down arrow keys to move the south drag handle to change the crop selection area",
    swDragHandle: "Use the arrow keys to move the south west drag handle to change the crop selection area",
    wDragHandle: "Use the up and down arrow keys to move the west drag handle to change the crop selection area"
  }
};
let YQ = Mi;
const KQ = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7"
}), "VisibilityOutlined"), XQ = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z"
}), "Image"), ZQ = 10485760, QQ = ({
  label: e = "",
  disabled: t = !1,
  value: n,
  onChange: r,
  error: o,
  readOnly: a,
  aspectRatio: l,
  uploadFile: c,
  getFile: d,
  deleteFile: p
}) => {
  const f = tr(), [m, g] = Kt(!1), [y, b] = Kt(!1), [v, $] = Kt(""), [S, R] = Kt(""), [P, T] = Kt(), [O, k] = Kt(!1), [I, D] = Kt(!1), j = Yr(null), E = Yr(null), M = Yr(null), F = At(() => {
    g(!0), k(!1), p == null || p().then(() => {
      j.current = (n == null ? void 0 : n.id) ?? null;
      const re = { id: n == null ? void 0 : n.id, preview: "" };
      n != null && n.preview && URL.revokeObjectURL(n.preview), r(re), console.log("[PictureUploaderField]: deleteFile > done:", re);
    }).catch((re) => {
      console.error("[PictureUploaderField]: deleteFile > error:", re);
    }).finally(() => {
      g(!1);
    });
  }, [r, p, n]), B = At(async () => {
    !(n != null && n.id) || n != null && n.preview || !d || (E.current = n, g(!0), d == null || d(n == null ? void 0 : n.id).then((re) => {
      if (re.preview)
        return r(re), re;
    }).catch((re) => {
      console.error("[PictureUploaderField]: getFile > error:", re);
    }).finally(() => {
      g(!1);
    }));
  }, [d, r, n]), V = At(
    (re) => {
      const { width: ie, height: Y } = re.currentTarget;
      let Z;
      l ? Z = UQ(qQ({ unit: "%", width: 100 }, l, ie, Y), ie, Y) : Z = { x: 0, y: 0, width: ie, height: Y, unit: "px" }, T(Z);
    },
    [l]
  ), z = At(
    (re) => {
      re && re.length > 0 && (D(!0), $(re[0].name), S && URL.revokeObjectURL(S), R(URL.createObjectURL(re[0])));
    },
    [S]
  ), L = At(
    (re) => {
      g(!0);
      const ie = URL.createObjectURL(re);
      c == null || c(re, ie).then((Y) => {
        const Z = {
          id: Y == null ? void 0 : Y.id,
          filename: re.name,
          size: re.size,
          preview: ie
        };
        r(Z), R(ie), console.log("[PictureUploaderField]: uploadFile > done:", Z);
      }).catch((Y) => {
        console.error("[PictureUploaderField]: uploadFile > error:", Y), URL.revokeObjectURL(ie);
      }).finally(() => g(!1));
    },
    [r, c]
  ), G = At(() => {
    const re = M.current;
    if (!re || !P) {
      console.error("Crop elements not available");
      return;
    }
    const ie = document.createElement("canvas"), { x: Y, y: Z, width: ue, height: ge } = P, W = re.naturalWidth / re.width, J = re.naturalHeight / re.height;
    ie.width = ue * W, ie.height = ge * J;
    const le = ie.getContext("2d");
    le && (le.drawImage(re, Y * W, Z * J, ue * W, ge * J, 0, 0, ie.width, ie.height), ie.toBlob((me) => {
      if (me) {
        const be = new File([me], v, { type: "image/png" });
        L(be);
      }
    }, "image/png")), D(!1);
  }, [P, v, L]);
  nn(() => {
    m || n != null && n.preview || (n == null ? void 0 : n.id) === j.current || uO(E.current, n) || B().then(() => console.log("[PictureUploaderField]: downloadFile done"));
  }, [B, n]), nn(() => () => {
    S && URL.revokeObjectURL(S);
  }, [S]);
  const { getRootProps: se, getInputProps: ne, isDragActive: K, isDragAccept: Q, isDragReject: ye } = by({
    multiple: !1,
    accept: { "image/jpeg": [], "image/png": [] },
    disabled: t || a,
    maxSize: ZQ,
    onDrop: z
  }), we = ye ? f.palette.error.main : f.palette.primary.dark, fe = ye || o ? f.palette.error.main : Q ? f.palette.primary.main : jd[400], X = Q ? f.palette.success.light : ye ? f.palette.error.light : "transparent";
  return /* @__PURE__ */ x.jsxs(Gn, { fullWidth: !0, children: [
    !!e && /* @__PURE__ */ x.jsx(
      ur,
      {
        sx: {
          mb: 2,
          fontWeight: 600,
          color: f.palette.text.primary,
          fontSize: f.typography.subtitle1.fontSize
        },
        children: e
      }
    ),
    /* @__PURE__ */ x.jsxs(Jn, { container: !0, spacing: 3, children: [
      /* @__PURE__ */ x.jsxs(Jn, { size: { xs: 12, lg: 6 }, children: [
        /* @__PURE__ */ x.jsxs(
          Qt,
          {
            ...se(),
            minHeight: "152px",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: X,
            sx: { cursor: "pointer" },
            borderRadius: f.spacing(1),
            border: `1px dashed ${fe}`,
            children: [
              /* @__PURE__ */ x.jsx("input", { ...ne() }),
              /* @__PURE__ */ x.jsx(Qt, { alignItems: "center", justifyContent: "center", spacing: 1, children: m ? /* @__PURE__ */ x.jsx(Fo, { variant: "indeterminate" }) : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
                /* @__PURE__ */ x.jsx(Zr, { pt: 1, pb: 0.5, children: /* @__PURE__ */ x.jsx(wO, { sx: { color: we } }) }),
                !K && /* @__PURE__ */ x.jsxs(Zr, { children: [
                  /* @__PURE__ */ x.jsx(Qe, { display: "inline", color: "primary", sx: { textDecorationLine: "underline" }, children: "Click to upload" }),
                  /* @__PURE__ */ x.jsx(Qe, { display: "inline", children: " or drag and drop" })
                ] }),
                Q && /* @__PURE__ */ x.jsx(Qe, { color: f.palette.primary.dark, fontWeight: "bold", children: "Drop file(s) here to upload" }),
                ye && /* @__PURE__ */ x.jsx(Qe, { color: "error", children: "File type, size or count is not allowed" }),
                /* @__PURE__ */ x.jsxs(Zr, { pt: 0.5, children: [
                  /* @__PURE__ */ x.jsxs(Qe, { display: "inline", variant: "subtitle2", color: "secondary", children: [
                    "JPG, JPEG or PNG",
                    " "
                  ] }),
                  /* @__PURE__ */ x.jsx(Qe, { display: "inline", variant: "subtitle2", color: "secondary", children: "(max. 10MB)" })
                ] })
              ] }) })
            ]
          }
        ),
        o && /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "error", children: o.message })
      ] }),
      /* @__PURE__ */ x.jsx(Jn, { size: { xs: 12, lg: 6 }, children: !m && n && (n == null ? void 0 : n.preview) && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
        /* @__PURE__ */ x.jsxs(
          Qt,
          {
            direction: "row",
            sx: { mb: 1, p: 2 },
            alignItems: "flex-start",
            justifyContent: "space-between",
            borderRadius: f.spacing(1),
            border: `1px solid ${f.palette.primary.main}`,
            children: [
              /* @__PURE__ */ x.jsxs(Qt, { width: "100%", direction: "row", spacing: 2, pb: 1, children: [
                /* @__PURE__ */ x.jsx(CS, { color: "primary", IconComponent: XQ }),
                /* @__PURE__ */ x.jsxs(Qt, { m: 1, maxWidth: "50%", children: [
                  /* @__PURE__ */ x.jsx(
                    Qe,
                    {
                      "data-testid": n.filename,
                      sx: {
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                      },
                      children: n.filename
                    }
                  ),
                  /* @__PURE__ */ x.jsxs(Qe, { variant: "subtitle2", color: "secondary", fontSize: "small", children: [
                    "Uploaded - ",
                    SO(n.size, 2)
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ x.jsx(CO, { color: "success" })
            ]
          }
        ),
        /* @__PURE__ */ x.jsxs(Qt, { direction: "row", spacing: 1, children: [
          /* @__PURE__ */ x.jsx(Fi, { title: "View file", children: /* @__PURE__ */ x.jsx(
            Tn,
            {
              color: "primary",
              variant: "outlined",
              sx: { minWidth: "auto" },
              "aria-label": `View ${n.filename}`,
              onClick: () => b(!0),
              children: /* @__PURE__ */ x.jsx(KQ, {})
            }
          ) }),
          !t && !a && /* @__PURE__ */ x.jsx(Fi, { title: "Remove file", children: /* @__PURE__ */ x.jsx(
            Tn,
            {
              color: "error",
              variant: "outlined",
              sx: { minWidth: "auto" },
              "aria-label": `Remove ${n.filename}`,
              onClick: () => k(!0),
              children: /* @__PURE__ */ x.jsx($O, {})
            }
          ) })
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ x.jsxs(rg, { isOpen: O, onClose: () => k(!1), children: [
      /* @__PURE__ */ x.jsx(wa, { variant: "h4", component: "h2", children: "Are you sure you want to remove this file?" }),
      /* @__PURE__ */ x.jsxs(ii, { children: [
        /* @__PURE__ */ x.jsx(Tn, { disabled: m, variant: "contained", color: "error", onClick: F, children: "Remove" }),
        /* @__PURE__ */ x.jsx(Tn, { disabled: m, variant: "outlined", color: "warning", onClick: () => k(!1), children: "Keep" })
      ] })
    ] }),
    /* @__PURE__ */ x.jsxs(rg, { isOpen: y, onClose: () => b(!1), children: [
      /* @__PURE__ */ x.jsx("img", { src: (n == null ? void 0 : n.preview) || S, alt: "Preview", style: { maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" } }),
      /* @__PURE__ */ x.jsx(ii, { children: /* @__PURE__ */ x.jsx(Tn, { variant: "outlined", color: "secondary", onClick: () => b(!1), children: "Close" }) })
    ] }),
    /* @__PURE__ */ x.jsxs(rg, { onClose: () => D(!1), isOpen: I, children: [
      /* @__PURE__ */ x.jsx(wa, { variant: "h4", component: "h2", children: "Crop picture" }),
      /* @__PURE__ */ x.jsx(YQ, { crop: P, onChange: (re) => T(re), children: /* @__PURE__ */ x.jsx("img", { ref: M, src: S, alt: "Crop", onLoad: V }) }),
      /* @__PURE__ */ x.jsxs(ii, { children: [
        /* @__PURE__ */ x.jsx(Tn, { disabled: !P, loading: m, variant: "contained", color: "primary", onClick: G, children: "Confirm" }),
        /* @__PURE__ */ x.jsx(Tn, { variant: "outlined", color: "secondary", onClick: () => D(!1), children: "Cancel" })
      ] })
    ] })
  ] });
}, rg = ({ children: e, isOpen: t, onClose: n }) => /* @__PURE__ */ x.jsx(Sa, { open: t, onClose: n, sx: { zIndex: 1500 }, slotProps: { paper: { sx: { p: 2 } } }, children: e }), JQ = ({ label: e, disabled: t, value: n = [], onChange: r, error: o, name: a, readOnly: l = !1, groupedOptions: c }) => {
  const d = (g) => {
    const { children: y, key: b, group: v } = g, $ = m.length > parseInt(b) + y.length;
    return /* @__PURE__ */ x.jsxs("li", { children: [
      /* @__PURE__ */ x.jsx(Qe, { component: "p", variant: "caption", px: 2, py: 1, children: v }),
      /* @__PURE__ */ x.jsx(sc, { sx: { p: 0 }, children: y }),
      $ && /* @__PURE__ */ x.jsx(ys, { sx: { mx: 0, my: 1 } })
    ] }, b);
  }, p = (g) => {
    const y = n.slice();
    y.splice(g, 1), r(y);
  }, f = () => c.map(({ group: g, options: y }) => {
    const b = y.flatMap((v) => {
      const $ = n.findIndex((S) => v.value === S.value);
      return $ !== void 0 && $ !== -1 ? [{ ...n[$], index: $ }] : [];
    }).filter(Boolean);
    if (b.length !== 0)
      return /* @__PURE__ */ x.jsxs(Qt, { spacing: 2, children: [
        /* @__PURE__ */ x.jsx(Qe, { fontWeight: "bold", children: g }),
        /* @__PURE__ */ x.jsx(Qt, { direction: "row", spacing: 1, children: b.map((v) => /* @__PURE__ */ x.jsx(Vd, { label: v.label, sx: { width: "fit-content" }, onDelete: () => p(v.index) }, v.index)) })
      ] }, g);
  }), m = c.flatMap(
    (g) => g.options.map((y) => ({ group: g.group, label: y.label || y.value, value: y.value }))
  );
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(Gn, { fullWidth: !0, size: "small", children: [
      /* @__PURE__ */ x.jsx(ur, { id: `${a}-label`, children: e }),
      /* @__PURE__ */ x.jsxs(Qt, { spacing: 2, children: [
        /* @__PURE__ */ x.jsx(
          ac,
          {
            getOptionLabel: (g) => g.label,
            groupBy: (g) => g.group,
            getOptionDisabled: (g) => !!(n != null && n.find((y) => y.label === g.label)),
            renderGroup: d,
            multiple: !0,
            disableClearable: !0,
            disabled: t,
            "aria-labelledby": `${a}-label`,
            size: "small",
            options: m,
            value: n,
            renderTags: () => null,
            renderInput: (g) => /* @__PURE__ */ x.jsx(di, { ...g, error: !!o, "aria-invalid": !!o, placeholder: "Select option" }),
            onChange: (g, y) => r(y),
            readOnly: l,
            slotProps: { listbox: { sx: { p: 0 } } }
          }
        ),
        f()
      ] })
    ] }),
    o && /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "error", children: o.message })
  ] });
};
var Lu = { exports: {} }, eJ = Lu.exports, gC;
function tJ() {
  return gC || (gC = 1, function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(eJ, () => {
      return n = { 705: (o) => {
        o.exports = function(a, l) {
          const c = [];
          return l.length === 0 ? c.push({ text: a, highlight: !1 }) : l[0][0] > 0 && c.push({ text: a.slice(0, l[0][0]), highlight: !1 }), l.forEach((d, p) => {
            const f = d[0], m = d[1];
            c.push({ text: a.slice(f, m), highlight: !0 }), p === l.length - 1 ? m < a.length && c.push({ text: a.slice(m, a.length), highlight: !1 }) : m < l[p + 1][0] && c.push({ text: a.slice(m, l[p + 1][0]), highlight: !1 });
          }), c;
        };
      } }, r = {}, function o(a) {
        var l = r[a];
        if (l !== void 0) return l.exports;
        var c = r[a] = { exports: {} };
        return n[a](c, c.exports, o), c.exports;
      }(705);
      var n, r;
    });
  }(Lu)), Lu.exports;
}
var nJ = tJ();
const rJ = /* @__PURE__ */ Cs(nJ);
var og, yC;
function oJ() {
  return yC || (yC = 1, og = function e(t, n) {
    if (t === n) return !0;
    if (t && n && typeof t == "object" && typeof n == "object") {
      if (t.constructor !== n.constructor) return !1;
      var r, o, a;
      if (Array.isArray(t)) {
        if (r = t.length, r != n.length) return !1;
        for (o = r; o-- !== 0; )
          if (!e(t[o], n[o])) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
      if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
      if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
      if (a = Object.keys(t), r = a.length, r !== Object.keys(n).length) return !1;
      for (o = r; o-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(n, a[o])) return !1;
      for (o = r; o-- !== 0; ) {
        var l = a[o];
        if (!e(t[l], n[l])) return !1;
      }
      return !0;
    }
    return t !== t && n !== n;
  }), og;
}
var iJ = oJ();
const aJ = /* @__PURE__ */ Cs(iJ);
function Ao() {
  return Ao = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ao.apply(null, arguments);
}
function $s(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
function sJ(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function lJ(e) {
  var t = sJ(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
const oi = {
  NOT_LOADED: "NOT_LOADED",
  LOADING: "LOADING",
  LOADED: "LOADED",
  FAILED: "FAILED",
  AUTH_FAILURE: "AUTH_FAILURE"
}, cJ = "https://maps.googleapis.com/maps/api/js";
class Ul {
  /**
   * Loads the Maps JavaScript API with the specified parameters.
   * Since the Maps library can only be loaded once per page, this will
   * produce a warning when called multiple times with different
   * parameters.
   *
   * The returned promise resolves when loading completes
   * and rejects in case of an error or when the loading was aborted.
   */
  static async load(t, n) {
    var r;
    const o = t.libraries ? t.libraries.split(",") : [], a = this.serializeParams(t);
    this.listeners.push(n), (r = window.google) != null && (r = r.maps) != null && r.importLibrary ? (this.serializedApiParams || (this.loadingStatus = oi.LOADED), this.notifyLoadingStatusListeners()) : (this.serializedApiParams = a, this.initImportLibrary(t)), this.serializedApiParams && this.serializedApiParams !== a && console.warn("[google-maps-api-loader] The maps API has already been loaded with different parameters and will not be loaded again. Refresh the page for new values to have effect.");
    const l = ["maps", ...o];
    await Promise.all(l.map((c) => google.maps.importLibrary(c)));
  }
  /**
   * Serialize the parameters used to load the library for easier comparison.
   */
  static serializeParams(t) {
    return [t.v, t.key, t.language, t.region, t.authReferrerPolicy, t.solutionChannel].join("/");
  }
  /**
   * Creates the global `google.maps.importLibrary` function for bootstrapping.
   * This is essentially a formatted version of the dynamic loading script
   * from the official documentation with some minor adjustments.
   *
   * The created importLibrary function will load the Google Maps JavaScript API,
   * which will then replace the `google.maps.importLibrary` function with the full
   * implementation.
   *
   * @see https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
   */
  static initImportLibrary(t) {
    if (window.google || (window.google = {}), window.google.maps || (window.google.maps = {}), window.google.maps.importLibrary) {
      console.error("[google-maps-api-loader-internal]: initImportLibrary must only be called once");
      return;
    }
    let n = null;
    const r = () => n || (n = new Promise((o, a) => {
      var l;
      const c = document.createElement("script"), d = new URLSearchParams();
      for (const [p, f] of Object.entries(t)) {
        const m = p.replace(/[A-Z]/g, (g) => "_" + g[0].toLowerCase());
        d.set(m, String(f));
      }
      d.set("loading", "async"), d.set("callback", "__googleMapsCallback__"), c.async = !0, c.src = cJ + "?" + d.toString(), c.nonce = ((l = document.querySelector("script[nonce]")) == null ? void 0 : l.nonce) || "", c.onerror = () => {
        this.loadingStatus = oi.FAILED, this.notifyLoadingStatusListeners(), a(new Error("The Google Maps JavaScript API could not load."));
      }, window.__googleMapsCallback__ = () => {
        this.loadingStatus = oi.LOADED, this.notifyLoadingStatusListeners(), o();
      }, window.gm_authFailure = () => {
        this.loadingStatus = oi.AUTH_FAILURE, this.notifyLoadingStatusListeners();
      }, this.loadingStatus = oi.LOADING, this.notifyLoadingStatusListeners(), document.head.append(c);
    }), n);
    google.maps.importLibrary = (o) => r().then(() => google.maps.importLibrary(o));
  }
  /**
   * Calls all registered loadingStatusListeners after a status update.
   */
  static notifyLoadingStatusListeners() {
    for (const t of this.listeners)
      t(this.loadingStatus);
  }
}
Ul.loadingStatus = oi.NOT_LOADED;
Ul.serializedApiParams = void 0;
Ul.listeners = [];
const uJ = ["onLoad", "onError", "apiKey", "version", "libraries"], dJ = ["children"], pJ = "GMP_visgl_rgmlibrary_v1_default", gc = Ne.createContext(null);
function fJ() {
  const [e, t] = Kt({});
  return {
    mapInstances: e,
    addMapInstance: (a, l = "default") => {
      t((c) => Ao({}, c, {
        [l]: a
      }));
    },
    removeMapInstance: (a = "default") => {
      t((l) => $s(l, [a].map(lJ)));
    },
    clearMapInstances: () => {
      t({});
    }
  };
}
function hJ(e) {
  const {
    onLoad: t,
    onError: n,
    apiKey: r,
    version: o,
    libraries: a = []
  } = e, l = $s(e, uJ), [c, d] = Kt(Ul.loadingStatus), [p, f] = Vg((b, v) => b[v.name] ? b : Ao({}, b, {
    [v.name]: v.value
  }), {}), m = Ln(() => a == null ? void 0 : a.join(","), [a]), g = Ln(() => JSON.stringify(Ao({
    apiKey: r,
    version: o
  }, l)), [r, o, l]), y = At(async (b) => {
    var v;
    if (p[b])
      return p[b];
    if (!((v = google) != null && (v = v.maps) != null && v.importLibrary))
      throw new Error("[api-provider-internal] importLibrary was called before google.maps.importLibrary was defined.");
    const $ = await window.google.maps.importLibrary(b);
    return f({
      name: b,
      value: $
    }), $;
  }, [p]);
  return nn(
    () => {
      (async () => {
        try {
          const b = Ao({
            key: r
          }, l);
          o && (b.v = o), (m == null ? void 0 : m.length) > 0 && (b.libraries = m), (b.channel === void 0 || b.channel < 0 || b.channel > 999) && delete b.channel, b.solutionChannel === void 0 ? b.solutionChannel = pJ : b.solutionChannel === "" && delete b.solutionChannel, await Ul.load(b, (v) => d(v));
          for (const v of ["core", "maps", ...a])
            await y(v);
          t && t();
        } catch (b) {
          n ? n(b) : console.error("<ApiProvider> failed to load the Google Maps JavaScript API", b);
        }
      })();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, m, g]
  ), {
    status: c,
    loadedLibraries: p,
    importLibrary: y
  };
}
const mJ = (e) => {
  const {
    children: t
  } = e, n = $s(e, dJ), {
    mapInstances: r,
    addMapInstance: o,
    removeMapInstance: a,
    clearMapInstances: l
  } = fJ(), {
    status: c,
    loadedLibraries: d,
    importLibrary: p
  } = hJ(n), f = Ln(() => ({
    mapInstances: r,
    addMapInstance: o,
    removeMapInstance: a,
    clearMapInstances: l,
    status: c,
    loadedLibraries: d,
    importLibrary: p
  }), [r, o, a, l, c, d, p]);
  return /* @__PURE__ */ Ne.createElement(gc.Provider, {
    value: f
  }, t);
};
function gJ(e, t) {
  for (const n of xJ) {
    const r = t[n], o = TO[n];
    nn(() => {
      if (!e || !r) return;
      const a = google.maps.event.addListener(e, o, (l) => {
        r(yJ(o, e, l));
      });
      return () => a.remove();
    }, [e, o, r]);
  }
}
function yJ(e, t, n) {
  const r = {
    type: e,
    map: t,
    detail: {},
    stoppable: !1,
    stop: () => {
    }
  };
  if (vJ.includes(e)) {
    const a = r, l = t.getCenter(), c = t.getZoom(), d = t.getHeading() || 0, p = t.getTilt() || 0, f = t.getBounds();
    return (!l || !f || !Number.isFinite(c)) && console.warn("[createEvent] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new"), a.detail = {
      center: (l == null ? void 0 : l.toJSON()) || {
        lat: 0,
        lng: 0
      },
      zoom: c || 0,
      heading: d,
      tilt: p,
      bounds: (f == null ? void 0 : f.toJSON()) || {
        north: 90,
        east: 180,
        south: -90,
        west: -180
      }
    }, a;
  } else if (bJ.includes(e)) {
    var o;
    if (!n) throw new Error("[createEvent] mouse events must provide a srcEvent");
    const a = r;
    return a.domEvent = n.domEvent, a.stoppable = !0, a.stop = () => n.stop(), a.detail = {
      latLng: ((o = n.latLng) == null ? void 0 : o.toJSON()) || null,
      placeId: n.placeId
    }, a;
  }
  return r;
}
const TO = {
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onContextmenu: "contextmenu",
  onDblclick: "dblclick",
  onDrag: "drag",
  onDragend: "dragend",
  onDragstart: "dragstart",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onIsFractionalZoomEnabledChanged: "isfractionalzoomenabled_changed",
  onMapCapabilitiesChanged: "mapcapabilities_changed",
  onMapTypeIdChanged: "maptypeid_changed",
  onMousemove: "mousemove",
  onMouseout: "mouseout",
  onMouseover: "mouseover",
  onProjectionChanged: "projection_changed",
  onRenderingTypeChanged: "renderingtype_changed",
  onTilesLoaded: "tilesloaded",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed",
  // note: onCameraChanged is an alias for the bounds_changed event,
  // since that is going to be fired in every situation where the camera is
  // updated.
  onCameraChanged: "bounds_changed"
}, vJ = ["bounds_changed", "center_changed", "heading_changed", "tilt_changed", "zoom_changed"], bJ = ["click", "contextmenu", "dblclick", "mousemove", "mouseout", "mouseover"], xJ = Object.keys(TO);
function wJ(e, t) {
  const n = Yr(void 0);
  (!n.current || !aJ(t, n.current)) && (n.current = t), nn(e, n.current);
}
const $J = /* @__PURE__ */ new Set(["backgroundColor", "clickableIcons", "controlSize", "disableDefaultUI", "disableDoubleClickZoom", "draggable", "draggableCursor", "draggingCursor", "fullscreenControl", "fullscreenControlOptions", "gestureHandling", "headingInteractionEnabled", "isFractionalZoomEnabled", "keyboardShortcuts", "mapTypeControl", "mapTypeControlOptions", "mapTypeId", "maxZoom", "minZoom", "noClear", "panControl", "panControlOptions", "restriction", "rotateControl", "rotateControlOptions", "scaleControl", "scaleControlOptions", "scrollwheel", "streetView", "streetViewControl", "streetViewControlOptions", "styles", "tiltInteractionEnabled", "zoomControl", "zoomControlOptions"]);
function CJ(e, t) {
  const n = {}, r = Object.keys(t);
  for (const o of r)
    $J.has(o) && (n[o] = t[o]);
  wJ(() => {
    e && e.setOptions(n);
  }, [n]);
}
function OO() {
  var e;
  return ((e = cs(gc)) == null ? void 0 : e.status) || oi.NOT_LOADED;
}
function SJ(e, t) {
  const {
    viewport: n,
    viewState: r
  } = t, o = !!n;
  return Wg(() => {
    if (!e || !r) return;
    const {
      latitude: a,
      longitude: l,
      bearing: c,
      pitch: d,
      zoom: p
    } = r;
    e.moveCamera({
      center: {
        lat: a,
        lng: l
      },
      heading: c,
      tilt: d,
      zoom: p + 1
    });
  }, [e, r]), o;
}
function TJ(e) {
  return !e || typeof e != "object" || !("lat" in e && "lng" in e) ? !1 : Number.isFinite(e.lat) && Number.isFinite(e.lng);
}
function PO(e) {
  return TJ(e) ? e : e.toJSON();
}
function OJ(e, t, n) {
  const r = n.center ? PO(n.center) : null;
  let o = null, a = null;
  r && Number.isFinite(r.lat) && Number.isFinite(r.lng) && (o = r.lat, a = r.lng);
  const l = Number.isFinite(n.zoom) ? n.zoom : null, c = Number.isFinite(n.heading) ? n.heading : null, d = Number.isFinite(n.tilt) ? n.tilt : null;
  Wg(() => {
    if (!e) return;
    const p = {};
    let f = !1;
    o !== null && a !== null && (t.current.center.lat !== o || t.current.center.lng !== a) && (p.center = {
      lat: o,
      lng: a
    }, f = !0), l !== null && t.current.zoom !== l && (p.zoom = l, f = !0), c !== null && t.current.heading !== c && (p.heading = c, f = !0), d !== null && t.current.tilt !== d && (p.tilt = d, f = !0), f && e.moveCamera(p);
  });
}
const PJ = () => {
  const e = {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 999,
    display: "flex",
    flexFlow: "column nowrap",
    textAlign: "center",
    justifyContent: "center",
    fontSize: ".8rem",
    color: "rgba(0,0,0,0.6)",
    background: "#dddddd",
    padding: "1rem 1.5rem"
  };
  return /* @__PURE__ */ Ne.createElement("div", {
    style: e
  }, /* @__PURE__ */ Ne.createElement("h2", null, "Error: AuthFailure"), /* @__PURE__ */ Ne.createElement("p", null, "A problem with your API key prevents the map from rendering correctly. Please make sure the value of the ", /* @__PURE__ */ Ne.createElement("code", null, "APIProvider.apiKey"), " prop is correct. Check the error-message in the console for further details."));
};
function EJ() {
  const [e, t] = Kt(null), n = At((r) => t(r), [t]);
  return [e, n];
}
function xy() {
  return OO() === oi.LOADED;
}
function RJ() {
  const [, e] = Vg((t) => t + 1, 0);
  return e;
}
function kJ(e, t) {
  const n = e.getCenter(), r = e.getZoom(), o = e.getHeading() || 0, a = e.getTilt() || 0, l = e.getBounds();
  (!n || !l || !Number.isFinite(r)) && console.warn("[useTrackedCameraState] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new"), Object.assign(t.current, {
    center: (n == null ? void 0 : n.toJSON()) || {
      lat: 0,
      lng: 0
    },
    zoom: r || 0,
    heading: o,
    tilt: a
  });
}
function _J(e) {
  const t = RJ(), n = Yr({
    center: {
      lat: 0,
      lng: 0
    },
    heading: 0,
    tilt: 0,
    zoom: 0
  });
  return nn(() => {
    if (!e) return;
    const r = google.maps.event.addListener(e, "bounds_changed", () => {
      kJ(e, n), t();
    });
    return () => r.remove();
  }, [e, t]), n;
}
const DJ = ["id", "defaultBounds", "defaultCenter", "defaultZoom", "defaultHeading", "defaultTilt", "reuseMaps", "renderingType", "colorScheme"], IJ = ["padding"];
class Bu {
  static has(t) {
    return this.entries[t] && this.entries[t].length > 0;
  }
  static pop(t) {
    return this.entries[t] && this.entries[t].pop() || null;
  }
  static push(t, n) {
    this.entries[t] || (this.entries[t] = []), this.entries[t].push(n);
  }
}
Bu.entries = {};
function MJ(e, t) {
  const n = xy(), [r, o] = Kt(null), [a, l] = EJ(), c = _J(r), {
    id: d,
    defaultBounds: p,
    defaultCenter: f,
    defaultZoom: m,
    defaultHeading: g,
    defaultTilt: y,
    reuseMaps: b,
    renderingType: v,
    colorScheme: $
  } = e, S = $s(e, DJ), R = e.zoom !== void 0 || e.defaultZoom !== void 0, P = e.center !== void 0 || e.defaultCenter !== void 0;
  !p && (!R || !P) && console.warn("<Map> component is missing configuration. You have to provide zoom and center (via the `zoom`/`defaultZoom` and `center`/`defaultCenter` props) or specify the region to show using `defaultBounds`. See https://visgl.github.io/react-google-maps/docs/api-reference/components/map#required"), !S.center && f && (S.center = f), !S.zoom && Number.isFinite(m) && (S.zoom = m), !S.heading && Number.isFinite(g) && (S.heading = g), !S.tilt && Number.isFinite(y) && (S.tilt = y);
  for (const O of Object.keys(S)) S[O] === void 0 && delete S[O];
  const T = Yr(void 0);
  return nn(
    () => {
      if (!a || !n) return;
      const {
        addMapInstance: O,
        removeMapInstance: k
      } = t, {
        mapId: I
      } = e, D = `${I || "default"}:${v || "default"}:${$ || "LIGHT"}`;
      let j, E;
      if (b && Bu.has(D) ? (E = Bu.pop(D), j = E.getDiv(), a.appendChild(j), E.setOptions(S), setTimeout(() => E.setCenter(E.getCenter()), 0)) : (j = document.createElement("div"), j.style.height = "100%", a.appendChild(j), E = new google.maps.Map(j, Ao({}, S, v ? {
        renderingType: v
      } : {}, $ ? {
        colorScheme: $
      } : {}))), o(E), O(E, d), p) {
        const {
          padding: M
        } = p, F = $s(p, IJ);
        E.fitBounds(F, M);
      } else (!R || !P) && E.fitBounds({
        east: 180,
        west: -180,
        south: -90,
        north: 90
      });
      if (T.current) {
        const {
          mapId: M,
          cameraState: F
        } = T.current;
        M !== I && E.setOptions(F);
      }
      return () => {
        T.current = {
          mapId: I,
          // eslint-disable-next-line react-hooks/exhaustive-deps
          cameraState: c.current
        }, j.remove(), b ? Bu.push(D, E) : google.maps.event.clearInstanceListeners(E), o(null), k(d);
      };
    },
    // some dependencies are ignored in the list below:
    //  - defaultBounds and the default* camera props will only be used once, and
    //    changes should be ignored
    //  - mapOptions has special hooks that take care of updating the options
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      a,
      n,
      d,
      // these props can't be changed after initialization and require a new
      // instance to be created
      e.mapId,
      e.renderingType,
      e.colorScheme
    ]
  ), [r, l, c];
}
const EO = Ne.createContext(null), RO = (e) => {
  const {
    children: t,
    id: n,
    className: r,
    style: o
  } = e, a = cs(gc), l = OO();
  if (!a)
    throw new Error("<Map> can only be used inside an <ApiProvider> component.");
  const [c, d, p] = MJ(e, a);
  OJ(c, p, e), gJ(c, e), CJ(c, e);
  const f = SJ(c, e), m = !!e.controlled;
  nn(() => {
    if (c)
      return f && c.setOptions({
        disableDefaultUI: !0
      }), (f || m) && c.setOptions({
        gestureHandling: "none",
        keyboardShortcuts: !1
      }), () => {
        c.setOptions({
          gestureHandling: e.gestureHandling,
          keyboardShortcuts: e.keyboardShortcuts
        });
      };
  }, [c, f, m, e.gestureHandling, e.keyboardShortcuts]);
  const g = e.center ? PO(e.center) : null;
  let y = null, b = null;
  g && Number.isFinite(g.lat) && Number.isFinite(g.lng) && (y = g.lat, b = g.lng);
  const v = Ln(() => {
    var R, P, T, O, k;
    return {
      center: {
        lat: (R = y) != null ? R : 0,
        lng: (P = b) != null ? P : 0
      },
      zoom: (T = e.zoom) != null ? T : 0,
      heading: (O = e.heading) != null ? O : 0,
      tilt: (k = e.tilt) != null ? k : 0
    };
  }, [y, b, e.zoom, e.heading, e.tilt]);
  Wg(() => {
    if (!c || !m) return;
    c.moveCamera(v);
    const R = c.addListener("bounds_changed", () => {
      c.moveCamera(v);
    });
    return () => R.remove();
  }, [c, m, v]);
  const $ = Ln(() => Ao({
    width: "100%",
    height: "100%",
    position: "relative",
    // when using deckgl, the map should be sent to the back
    zIndex: f ? -1 : 0
  }, o), [o, f]), S = Ln(() => ({
    map: c
  }), [c]);
  return l === oi.AUTH_FAILURE ? /* @__PURE__ */ Ne.createElement("div", {
    style: Ao({
      position: "relative"
    }, r ? {} : $),
    className: r
  }, /* @__PURE__ */ Ne.createElement(PJ, null)) : /* @__PURE__ */ Ne.createElement("div", Ao({
    ref: d,
    "data-testid": "map",
    style: r ? void 0 : $,
    className: r
  }, n ? {
    id: n
  } : {}), c ? /* @__PURE__ */ Ne.createElement(EO.Provider, {
    value: S
  }, t) : null);
};
RO.deckGLViewProps = !0;
const vC = /* @__PURE__ */ new Set();
function AJ(...e) {
  const t = JSON.stringify(e);
  vC.has(t) || (vC.add(t), console.error(...e));
}
const wy = (e = null) => {
  const t = cs(gc), {
    map: n
  } = cs(EO) || {};
  if (t === null)
    return AJ("useMap(): failed to retrieve APIProviderContext. Make sure that the <APIProvider> component exists and that the component you are calling `useMap()` from is a sibling of the <APIProvider>."), null;
  const {
    mapInstances: r
  } = t;
  return e !== null ? r[e] || null : n || r.default || null;
};
function kO(e) {
  const t = xy(), n = cs(gc);
  return nn(() => {
    !t || !n || n.importLibrary(e);
  }, [t, n, e]), (n == null ? void 0 : n.loadedLibraries[e]) || null;
}
function Su(e, t, n) {
  nn(() => {
    if (!e || !t || !n) return;
    const r = google.maps.event.addListener(e, t, n);
    return () => r.remove();
  }, [e, t, n]);
}
function Tu(e, t, n) {
  nn(() => {
    e && (e[t] = n);
  }, [e, t, n]);
}
function bC(e, t, n) {
  nn(() => {
    if (!(!e || !t || !n))
      return e.addEventListener(t, n), () => e.removeEventListener(t, n);
  }, [e, t, n]);
}
function NJ(e) {
  return e.nodeType === Node.ELEMENT_NODE;
}
const jJ = Ne.createContext(null), FJ = {
  BOTTOM: ["50%", "100%"]
}, LJ = ({
  children: e,
  styles: t,
  className: n,
  anchorPoint: r
}) => {
  const [o, a] = r ?? FJ.BOTTOM, l = `translate(50%, 100%) translate(-${o}, -${a})`;
  return (
    // anchoring container
    /* @__PURE__ */ Ne.createElement("div", {
      style: {
        transform: l
      }
    }, /* @__PURE__ */ Ne.createElement("div", {
      className: n,
      style: t
    }, e))
  );
};
function BJ(e) {
  const [t, n] = Kt(null), [r, o] = Kt(null), a = wy(), l = kO("marker"), {
    children: c,
    onClick: d,
    className: p,
    onMouseEnter: f,
    onMouseLeave: m,
    onDrag: g,
    onDragStart: y,
    onDragEnd: b,
    collisionBehavior: v,
    clickable: $,
    draggable: S,
    position: R,
    title: P,
    zIndex: T
  } = e, O = xC.count(c);
  return nn(() => {
    if (!a || !l) return;
    const k = new l.AdvancedMarkerElement();
    k.map = a, n(k);
    let I = null;
    return O > 0 && (I = document.createElement("div"), I.isCustomMarker = !0, k.content = I, o(I)), () => {
      var D;
      k.map = null, (D = I) == null || D.remove(), n(null), o(null);
    };
  }, [a, l, O]), nn(() => {
    !t || !t.content || O > 0 || (t.content.className = p || "");
  }, [t, p, O]), Tu(t, "position", R), Tu(t, "title", P ?? ""), Tu(t, "zIndex", T), Tu(t, "collisionBehavior", v), nn(() => {
    t && (S !== void 0 ? t.gmpDraggable = S : g || y || b ? t.gmpDraggable = !0 : t.gmpDraggable = !1);
  }, [t, S, g, b, y]), nn(() => {
    if (!t) return;
    const k = $ !== void 0 || !!d || !!f || !!m;
    t.gmpClickable = k, k && t != null && t.content && NJ(t.content) && (t.content.style.pointerEvents = "none", t.content.firstElementChild && (t.content.firstElementChild.style.pointerEvents = "all"));
  }, [t, $, d, f, m]), Su(t, "click", d), Su(t, "drag", g), Su(t, "dragstart", y), Su(t, "dragend", b), bC(t == null ? void 0 : t.element, "mouseenter", f), bC(t == null ? void 0 : t.element, "mouseleave", m), [t, r];
}
Hl((e, t) => {
  const {
    children: n,
    style: r,
    className: o,
    anchorPoint: a
  } = e, [l, c] = BJ(e), d = Ln(() => l ? {
    marker: l
  } : null, [l]);
  return zg(t, () => l, [l]), c ? /* @__PURE__ */ Ne.createElement(jJ.Provider, {
    value: d
  }, Bk(/* @__PURE__ */ Ne.createElement(LJ, {
    anchorPoint: a,
    styles: r,
    className: o
  }, n), c)) : null;
});
const VJ = ["onClick", "onDrag", "onDragStart", "onDragEnd", "onMouseOver", "onMouseOut"];
function zJ(e) {
  const [t, n] = Kt(null), r = wy(), {
    onClick: o,
    onDrag: a,
    onDragStart: l,
    onDragEnd: c,
    onMouseOver: d,
    onMouseOut: p
  } = e, f = $s(e, VJ), {
    position: m,
    draggable: g
  } = f;
  return nn(() => {
    if (!r) {
      r === void 0 && console.error("<Marker> has to be inside a Map component.");
      return;
    }
    const y = new google.maps.Marker(f);
    return y.setMap(r), n(y), () => {
      y.setMap(null), n(null);
    };
  }, [r]), nn(() => {
    if (!t) return;
    const y = t, b = google.maps.event;
    return o && b.addListener(y, "click", o), a && b.addListener(y, "drag", a), l && b.addListener(y, "dragstart", l), c && b.addListener(y, "dragend", c), d && b.addListener(y, "mouseover", d), p && b.addListener(y, "mouseout", p), t.setDraggable(!!g), () => {
      b.clearInstanceListeners(y);
    };
  }, [t, g, o, a, l, c, d, p]), nn(() => {
    t && f && t.setOptions(f);
  }, [t, f]), nn(() => {
    g || !m || !t || t.setPosition(m);
  }, [g, m, t]), t;
}
Hl((e, t) => {
  const n = zJ(e);
  return zg(t, () => n, [n]), /* @__PURE__ */ Ne.createElement(Ne.Fragment, null);
});
const WJ = (e, t) => {
  const n = wy(), r = kO("places"), o = xy(), [a, l] = Kt(null), [c, d] = Kt(!1), [p, f] = Kt(), [m, g] = Kt(null), [y, b] = Kt(null), [v, $] = Kt([]);
  nn(() => {
    if (!(!r || !n || !o))
      return g(new r.AutocompleteService()), b(new r.PlacesService(n)), f(new r.AutocompleteSessionToken()), () => g(null);
  }, [n, r, o]);
  const S = At(
    async (T) => {
      const O = t ? { [SS.country]: "us" } : void 0;
      if (d(!0), !m || !T) {
        $([]);
        return;
      }
      try {
        const k = await m.getPlacePredictions({ input: T, sessionToken: p, componentRestrictions: O });
        $(a ? [a, ...k.predictions] : k.predictions);
      } catch (k) {
        console.error(k);
      } finally {
        d(!1);
      }
    },
    [m, p, a, t]
  ), R = At(
    (T) => {
      o0(S, 400)(T);
    },
    [S]
  );
  return { handleSuggestionClick: At(
    (T) => {
      if (!r || !T) return;
      const O = {
        placeId: T.place_id,
        fields: ["geometry", "name", "formatted_address", "address_components"],
        sessionToken: p
      }, k = (I) => {
        e(I, T), $([]), f(new r.AutocompleteSessionToken()), l(T);
      };
      y == null || y.getDetails(O, k);
    },
    [e, r, y, p, l]
  ), onInputChange: R, predictionResults: v, selectedSuggestion: a, loading: c };
}, qJ = jt(/* @__PURE__ */ x.jsx("path", {
  d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22zm1 14h-2v2h2zm0-6h-2v4h2z"
}), "WarningAmberOutlined"), UJ = [
  { name: "addressLine1", label: "Address Line 1", required: !0 },
  { name: "city", label: "City", required: !0 },
  { name: "postalCode", label: "Postal Code", required: !0 },
  { name: "addressLine2", label: "Address Line 2" },
  { name: "country", label: "Country", required: !0 },
  { name: "state", label: "State", required: !0 }
];
function HJ(e) {
  return /* @__PURE__ */ x.jsx(
    mi,
    {
      ...e,
      elevation: 5,
      sx: {
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        alignSelf: "stretch",
        border: "1px #AEAEAF",
        px: 2,
        py: 1,
        minWidth: "max-content",
        boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        "& .MuiAutocomplete-noOptions": {
          px: 2,
          py: 1
        }
      },
      children: e.children
    }
  );
}
const GJ = ({ option: e }) => {
  const t = e.structured_formatting.main_text_matched_substrings, n = rJ(
    e.structured_formatting.main_text,
    t.map((o) => [o.offset, o.offset + o.length])
  ), r = jk();
  return /* @__PURE__ */ x.jsxs(Jn, { sx: { wordWrap: "break-word" }, children: [
    n.map((o) => /* @__PURE__ */ x.jsx(
      Zr,
      {
        component: "span",
        sx: {
          fontWeight: o.highlight ? "fontWeightBold" : "fontWeightRegular"
        },
        children: o.text
      },
      `${r}${o.text}`
    )),
    e.structured_formatting.secondary_text ? /* @__PURE__ */ x.jsx(Qe, { variant: "body1", sx: { color: "text.secondary" }, children: e.structured_formatting.secondary_text }) : null
  ] });
}, YJ = ({ setManualMode: e, handlePlaceDetails: t, name: n, label: r, restrictToUS: o, error: a }) => {
  const { predictionResults: l, onInputChange: c, handleSuggestionClick: d, selectedSuggestion: p, loading: f } = WJ(
    t,
    o
  ), m = tr();
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx("div", { children: /* @__PURE__ */ x.jsx(RO, { zoom: null, center: null }) }),
    /* @__PURE__ */ x.jsx(
      ac,
      {
        fullWidth: !0,
        autoComplete: !0,
        includeInputInList: !0,
        filterSelectedOptions: !0,
        loading: f,
        popupIcon: null,
        clearIcon: null,
        getOptionLabel: (g) => typeof g == "string" ? g : g.description,
        slots: {
          paper: HJ
        },
        options: l,
        value: p,
        noOptionsText: /* @__PURE__ */ x.jsxs(Jn, { container: !0, direction: "row", display: "flex", alignItems: "flex-end", size: 12, children: [
          /* @__PURE__ */ x.jsxs(Qe, { variant: "caption", display: "flex", gap: 0.5, children: [
            "Sorry, we cannot find that address.",
            /* @__PURE__ */ x.jsx(jo, { sx: { textDecoration: "underline", textDecorationColor: m.palette.primary.main }, onClick: () => e(!0), children: /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "primary", children: "Please enter it manually" }) })
          ] }),
          /* @__PURE__ */ x.jsx(qJ, { sx: { marginLeft: "0.4rem" }, color: "warning", fontSize: "small" })
        ] }),
        onChange: (g, y) => {
          d(y);
        },
        onInputChange: (g, y) => {
          c(y);
        },
        renderInput: (g) => {
          var v;
          const { InputProps: y, inputProps: b } = g;
          return /* @__PURE__ */ x.jsx(Qt, { gap: 0.5, children: /* @__PURE__ */ x.jsx(
            hp,
            {
              value: ((v = b.value) == null ? void 0 : v.toString()) ?? "",
              slotProps: { input: y, htmlInput: b },
              label: r,
              name: n,
              error: a
            }
          ) });
        },
        renderOption: (g, y) => {
          const { key: b, ...v } = g;
          return /* @__PURE__ */ x.jsx("li", { ...v, children: /* @__PURE__ */ x.jsx(Jn, { container: !0, sx: { alignItems: "center" }, children: /* @__PURE__ */ x.jsx(GJ, { option: y }) }) }, b);
        }
      }
    )
  ] });
}, KJ = ({
  googleMapsAPIKey: e,
  name: t,
  value: n,
  onChange: r,
  disabled: o,
  label: a,
  readOnly: l,
  restrictToUS: c,
  error: d,
  addressInputs: p = UJ,
  validateAddress: f
}) => {
  const m = tr(), [g, y] = Kt(!1), b = g ? "Search for address instead" : "Can't find your address? Enter it manually", v = Ln(() => !Object.values(n || {}).some((T) => (T == null ? void 0 : T.trim().length) > 0), [n]), $ = f && c, S = (T, O) => {
    const k = n || {
      addressLine1: "",
      addressLine2: "",
      postalCode: "",
      city: "",
      state: "",
      country: "",
      addressValidationStatus: ""
    };
    k[T] = O, r(k);
  }, R = (T, O) => {
    var I, D, j, E, M, F, B, V, z, L;
    const k = {
      addressLine1: (O == null ? void 0 : O.structured_formatting.main_text) ?? "",
      addressLine2: ((D = (I = T == null ? void 0 : T.address_components) == null ? void 0 : I.find((G) => G.types.includes("sublocality") || G.types.includes("neighborhood"))) == null ? void 0 : D.long_name) ?? "",
      postalCode: ((E = (j = T == null ? void 0 : T.address_components) == null ? void 0 : j.find((G) => G.types.includes("postal_code"))) == null ? void 0 : E.long_name) ?? "",
      city: ((F = (M = T == null ? void 0 : T.address_components) == null ? void 0 : M.find((G) => G.types.includes("locality"))) == null ? void 0 : F.long_name) ?? "",
      state: ((V = (B = T == null ? void 0 : T.address_components) == null ? void 0 : B.find((G) => G.types.includes("administrative_area_level_1"))) == null ? void 0 : V.long_name) ?? "",
      country: ((L = (z = T == null ? void 0 : T.address_components) == null ? void 0 : z.find((G) => G.types.includes("country"))) == null ? void 0 : L.long_name) ?? "",
      addressValidationStatus: ""
    };
    r(k);
  }, P = () => {
    const { addressLine1: T, city: O, state: k } = n;
    S("addressValidationStatus", "loading"), f == null || f(T, O, k).then(() => S("addressValidationStatus", "success")).catch(() => S("addressValidationStatus", "failed"));
  };
  return nn(() => {
    (!v || l) && y(!0);
  }, [v, l]), nn(() => {
    d && y(!0);
  }, [d]), /* @__PURE__ */ x.jsxs(Jn, { container: !0, wrap: "wrap", spacing: { xs: 0, md: 4 }, children: [
    /* @__PURE__ */ x.jsx(Jn, { size: { xs: 12, md: 4 }, children: /* @__PURE__ */ x.jsx(mJ, { apiKey: e, children: /* @__PURE__ */ x.jsx(
      YJ,
      {
        label: a,
        name: t,
        setManualMode: y,
        handlePlaceDetails: R,
        restrictToUS: c,
        error: d == null ? void 0 : d.addressValidationStatus
      }
    ) }) }),
    /* @__PURE__ */ x.jsx(Jn, { size: { xs: 12, md: 8 }, container: !0, sx: { display: "flex", alignItems: "center" }, children: /* @__PURE__ */ x.jsx(
      jo,
      {
        onClick: () => y(!g),
        sx: { textDecoration: "underline", pb: "0.625rem", textDecorationColor: m.palette.primary.main },
        children: /* @__PURE__ */ x.jsx(Qe, { sx: {}, color: "primary", variant: "subtitle1", children: b })
      }
    ) }),
    g && p.map(({ name: T, label: O, required: k }) => {
      if (c && T === "country" || !c && T === "state") return;
      const I = d && k && !(n != null && n[T]) ? { type: "required", message: `${O} is required` } : void 0, D = n ? n[T] : "";
      return /* @__PURE__ */ x.jsx(Jn, { size: { xs: 12, md: 4 }, children: /* @__PURE__ */ x.jsx(Qt, { gap: 0.5, children: /* @__PURE__ */ x.jsx(
        hp,
        {
          name: `${t}-${T}`,
          label: O,
          disabled: o,
          value: D ?? "",
          onChange: (j) => S(T, j),
          error: I,
          readOnly: l
        }
      ) }) }, T);
    }),
    $ && /* @__PURE__ */ x.jsx(Jn, { size: 12, children: /* @__PURE__ */ x.jsxs(Qt, { direction: "row", gap: 1, children: [
      /* @__PURE__ */ x.jsx(
        Tn,
        {
          variant: "outlined",
          color: "primary",
          onClick: P,
          loading: n.addressValidationStatus === "loading",
          sx: { width: "fit-content" },
          children: "Validate Address With USPS"
        }
      ),
      n.addressValidationStatus === "" && /* @__PURE__ */ x.jsx(Du, { severity: "warning", variant: "outlined", sx: { mt: 0, flex: 1 }, children: "Address has not been verified by USPS" }),
      n.addressValidationStatus === "success" && /* @__PURE__ */ x.jsx(Du, { severity: "success", variant: "outlined", sx: { mt: 0, flex: 1 }, children: "Address has been verified by USPS." }),
      n.addressValidationStatus === "failed" && /* @__PURE__ */ x.jsx(Du, { severity: "error", variant: "outlined", sx: { mt: 0, flex: 1 }, children: "We could not verify that address with USPS. Please check the entered information and try again." })
    ] }) })
  ] });
}, XJ = ({
  label: e,
  disabled: t,
  value: n,
  onChange: r,
  error: o,
  name: a,
  readOnly: l,
  min: c = -1 / 0,
  max: d = 1 / 0,
  textSuffix: p,
  helperText: f
}) => {
  const m = p && /* @__PURE__ */ x.jsx(Rs, { position: "end", children: /* @__PURE__ */ x.jsx(Qe, { variant: "caption", children: p }) });
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(Gn, { fullWidth: !0, size: "small", children: [
      /* @__PURE__ */ x.jsx(ur, { id: `${a}-label`, children: e }),
      /* @__PURE__ */ x.jsx(
        di,
        {
          size: "small",
          type: "number",
          "aria-labelledby": `${a}-label`,
          value: n,
          error: !!o,
          slotProps: { htmlInput: { min: c, max: d, readOnly: l }, input: { endAdornment: m } },
          disabled: t,
          name: a,
          onChange: (g) => r(g.target.value),
          helperText: f
        }
      )
    ] }),
    o ? /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "error", children: o.message }) : /* @__PURE__ */ x.jsx(x.Fragment, {})
  ] });
}, ZJ = ({
  name: e,
  label: t,
  disabled: n = !1,
  value: r,
  onChange: o,
  options: a,
  error: l,
  readOnly: c = !1
}) => {
  const d = (p, f) => {
    const m = r || {};
    m[p] = f, o(m);
  };
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(Gn, { fullWidth: !0, size: "small", sx: { overflowX: "auto" }, children: [
      t && /* @__PURE__ */ x.jsx(ur, { id: `${e}-label`, disabled: n, children: t }),
      /* @__PURE__ */ x.jsxs(rS, { children: [
        /* @__PURE__ */ x.jsx(iS, { children: /* @__PURE__ */ x.jsxs($g, { children: [
          /* @__PURE__ */ x.jsx(da, {}),
          Array.from({ length: 10 }, (p, f) => /* @__PURE__ */ x.jsx(da, { sx: { textAlign: "center" }, children: f + 1 }, f + 1)),
          /* @__PURE__ */ x.jsx(da, {})
        ] }) }),
        /* @__PURE__ */ x.jsx(oS, { children: a.map(({ name: p, leftLabel: f, rightLabel: m }) => /* @__PURE__ */ x.jsxs($g, { children: [
          /* @__PURE__ */ x.jsx(da, { children: f }),
          Array.from({ length: 10 }, (g, y) => {
            const b = String(y + 1);
            return /* @__PURE__ */ x.jsx(da, { sx: { textAlign: "center" }, children: /* @__PURE__ */ x.jsx(
              M0,
              {
                name: p,
                value: b,
                checked: (r == null ? void 0 : r[p]) === b,
                onChange: () => d(p, b),
                disabled: n || c
              }
            ) }, y + 1);
          }),
          /* @__PURE__ */ x.jsx(da, { children: m })
        ] }, p)) })
      ] })
    ] }),
    l ? /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "error", children: l.message }) : /* @__PURE__ */ x.jsx("br", {})
  ] });
}, QJ = ({
  label: e,
  disabled: t,
  value: n = "",
  onChange: r,
  error: o,
  name: a,
  readOnly: l = !1,
  groupedOptions: c,
  disabledOptions: d = []
}) => {
  const p = (m) => {
    const { children: g, key: y, group: b } = m, v = f.length > parseInt(y) + g.length;
    return /* @__PURE__ */ x.jsxs("li", { children: [
      /* @__PURE__ */ x.jsx(Qe, { component: "p", variant: "caption", px: 2, py: 1, children: b }),
      /* @__PURE__ */ x.jsx(sc, { sx: { p: 0 }, children: g }),
      v && /* @__PURE__ */ x.jsx(ys, { sx: { mx: 0, my: 1 } })
    ] }, y);
  }, f = Ln(
    () => c.flatMap(
      (m) => m.options.map((g) => ({
        group: m.group,
        label: g.label || g.value,
        value: g.value
      }))
    ),
    [c]
  );
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(Gn, { fullWidth: !0, size: "small", children: [
      /* @__PURE__ */ x.jsx(ur, { id: `${a}-label`, children: e }),
      /* @__PURE__ */ x.jsx(Qt, { spacing: 2, children: /* @__PURE__ */ x.jsx(
        ac,
        {
          getOptionLabel: (m) => m.label,
          groupBy: (m) => m.group,
          getOptionDisabled: (m) => !!d.find((g) => g === m.label),
          renderGroup: p,
          disableClearable: !0,
          disabled: t,
          isOptionEqualToValue: (m, g) => m.value === g.value,
          "aria-labelledby": `${a}-label`,
          size: "small",
          options: f,
          value: f.find((m) => m.value === n) ?? { label: "", value: "", group: "" },
          renderTags: () => null,
          renderInput: (m) => /* @__PURE__ */ x.jsx(di, { ...m, error: !!o, "aria-invalid": !!o, placeholder: "Select option" }),
          onChange: (m, g) => r(g.value),
          readOnly: l,
          slotProps: { listbox: { sx: { p: 0 } } }
        }
      ) })
    ] }),
    o && /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "error", children: o.message })
  ] });
};
class JJ extends Fk {
  constructor(t) {
    super(t), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(t, n) {
    let r;
    xl(this.props.children) && (r = this.props.children.props), console.error("[ErrorBoundary component]", {
      error: t,
      info: n,
      props: r
    });
  }
  render() {
    return this.state.hasError ? this.props.fallback ?? null : this.props.children;
  }
}
const eee = ({ label: e, disabled: t, value: n, onChange: r, error: o, name: a, readOnly: l, options: c, loading: d = !1 }) => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
  /* @__PURE__ */ x.jsxs(Gn, { fullWidth: !0, size: "small", children: [
    /* @__PURE__ */ x.jsx(ur, { id: `${a}-label`, children: e }),
    /* @__PURE__ */ x.jsx(
      ac,
      {
        getOptionLabel: (p) => p.label || p.value,
        multiple: !1,
        disableClearable: !0,
        disablePortal: !0,
        disabled: t || d,
        "aria-labelledby": `${a}-label`,
        size: "small",
        options: c,
        value: c.find((p) => p.value === n) ?? { label: "", value: "" },
        isOptionEqualToValue: (p, f) => p.value === f.value,
        renderInput: (p) => d ? /* @__PURE__ */ x.jsx(x.Fragment, { children: /* @__PURE__ */ x.jsx(
          di,
          {
            ...p,
            error: !!o,
            "aria-invalid": !!o,
            placeholder: "Loading...",
            slotProps: { input: { startAdornment: /* @__PURE__ */ x.jsx(Fo, { size: "1em" }) } }
          }
        ) }) : /* @__PURE__ */ x.jsx(di, { ...p, error: !!o, "aria-invalid": !!o, placeholder: "Select option" }),
        onChange: (p, f) => r(f.value),
        readOnly: l
      }
    )
  ] }),
  o && /* @__PURE__ */ x.jsx(Qe, { variant: "caption", color: "error", children: o.message })
] }), tee = (e) => {
  const { label: t = "", name: n, control: r, type: o, rules: a, disabled: l = !1, readOnly: c } = e, {
    field: { value: d, onChange: p },
    formState: { errors: f }
  } = AS({ name: n, control: r, rules: a }), m = { name: n, label: t, disabled: l, readOnly: c, value: d, onChange: p, error: _B(f, n) };
  let g;
  switch (o) {
    case Qn.Text:
      g = /* @__PURE__ */ x.jsx(
        hp,
        {
          ...m,
          rows: e.rows,
          multiline: e.multiline,
          maxLength: e.maxLength,
          maxWords: e.maxWords,
          textSuffix: e.textSuffix,
          helperText: e.helperText,
          placeholder: e.placeholder
        }
      );
      break;
    case Qn.Date:
      g = /* @__PURE__ */ x.jsx(
        GX,
        {
          ...m,
          min: e.min,
          max: e.max,
          value: new Date(d),
          minPeriod: e.minPeriod,
          maxPeriod: e.maxPeriod,
          maxDirection: e.maxDirection,
          minDirection: e.minDirection,
          displayDays: e.displayDays
        }
      );
      break;
    case Qn.Radio:
      g = /* @__PURE__ */ x.jsx(
        oq,
        {
          ...m,
          options: e.options,
          direction: e.direction,
          control: r,
          itemWrapperProps: e.itemWrapperProps
        }
      );
      break;
    case Qn.Checkboxset:
      g = /* @__PURE__ */ x.jsx(
        KX,
        {
          ...m,
          options: e.options,
          direction: e.direction,
          control: r,
          itemWrapperProps: e.itemWrapperProps
        }
      );
      break;
    case Qn.Checkbox:
      g = /* @__PURE__ */ x.jsx($S, { ...m });
      break;
    case Qn.Dropdown:
      g = /* @__PURE__ */ x.jsx(
        wS,
        {
          ...m,
          options: e.options,
          placeholderValue: e.placeholderValue,
          loading: e.loading,
          onRenderValue: e.onRenderValue,
          multiple: e.multiple
        }
      );
      break;
    case Qn.TagsAutocomplete:
      g = /* @__PURE__ */ x.jsx(JQ, { ...m, groupedOptions: e.groupedOptions });
      break;
    case Qn.PictureUploader:
      g = /* @__PURE__ */ x.jsx(
        QQ,
        {
          ...m,
          readOnly: e.readOnly,
          aspectRatio: e.aspectRatio,
          uploadFile: e.uploadFile,
          getFile: e.getFile,
          deleteFile: e.deleteFile
        }
      );
      break;
    case Qn.FileUploader:
      g = /* @__PURE__ */ x.jsx(VQ, { ...m, readOnly: e.readOnly, uploadFile: e.uploadFile, getFile: e.getFile, deleteFile: e.deleteFile });
      break;
    case Qn.AddressAutocomplete:
      g = /* @__PURE__ */ x.jsx(
        KJ,
        {
          ...m,
          googleMapsAPIKey: e.googleMapsAPIKey,
          restrictToUS: e.restrictToUS,
          addressInputs: e.addressInputs,
          validateAddress: e.validateAddress
        }
      );
      break;
    case Qn.SelectionRangeTable:
      g = /* @__PURE__ */ x.jsx(ZJ, { ...m, options: e.options });
      break;
    case Qn.Number:
      g = /* @__PURE__ */ x.jsx(XJ, { ...m, min: e.min, max: e.max, textSuffix: e.textSuffix, helperText: e.helperText });
      break;
    case Qn.GroupedAutocomplete:
      g = /* @__PURE__ */ x.jsx(QJ, { ...m, groupedOptions: e.groupedOptions, disabledOptions: e.disabledOptions });
      break;
    case Qn.Phone:
      g = /* @__PURE__ */ x.jsx(JW, { ...m, placeholder: e.placeholder });
      break;
    case Qn.Autocomplete:
      g = /* @__PURE__ */ x.jsx(eee, { ...m, options: e.options, loading: e.loading });
      break;
    default:
      g = /* @__PURE__ */ x.jsx(x.Fragment, {});
  }
  return /* @__PURE__ */ x.jsx(x.Fragment, { children: g });
}, see = (e) => e.visible === !1 ? /* @__PURE__ */ x.jsx(x.Fragment, {}) : /* @__PURE__ */ x.jsx(w3, { theme: xS, children: /* @__PURE__ */ x.jsx(Qt, { gap: 0.5, children: /* @__PURE__ */ x.jsx(JJ, { children: /* @__PURE__ */ x.jsx(tee, { ...e }) }) }) }), lee = uc(wS), cee = uc(qL), uee = uc($S);
export {
  SS as API_FIELDS_CONTACT,
  HL as API_FIELDS_STUDENT_FAMILY,
  UL as CONTACT_CLASSIFICATION,
  uee as CheckboxField,
  cee as CustomModal,
  lee as DropdownField,
  see as FormField,
  Qn as FormFieldType,
  iee as FormProgressButton,
  CS as GradientIcon,
  aee as ProgressButton,
  hp as TextField
};
//# sourceMappingURL=index.js.map
